var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key3, value) => key3 in obj ? __defProp(obj, key3, { enumerable: true, configurable: true, writable: true, value }) : obj[key3] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key3 of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key3) && key3 !== except)
        __defProp(to, key3, { get: () => from[key3], enumerable: !(desc = __getOwnPropDesc(from, key3)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// node_modules/semver-lite/src/semver.js
var require_semver = __commonJS({
  "node_modules/semver-lite/src/semver.js"(exports, module) {
    var MAX_LENGTH = 256;
    var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;
    var NUMERIC_IDENTIFIER = "0|[1-9]\\d*";
    var BUILD_IDENTIFIER = `[0-9A-Za-z-]+`;
    var NON_NUMERIC_IDENTIFIER = "\\d*[a-zA-Z-][a-zA-Z0-9-]*";
    var MAIN_VERSION_IDENTIFIER = `(${NUMERIC_IDENTIFIER})\\.(${NUMERIC_IDENTIFIER})\\.(${NUMERIC_IDENTIFIER})`;
    var PRERELEASE_IDENTIFIER = `(?:${NUMERIC_IDENTIFIER}|${NON_NUMERIC_IDENTIFIER})`;
    var PRERELEASE = `(?:\\-(${PRERELEASE_IDENTIFIER}(?:\\.${PRERELEASE_IDENTIFIER})*))`;
    var BUILD = `(?:\\+(${BUILD_IDENTIFIER}(?:\\.${BUILD_IDENTIFIER})*))`;
    var FULL_VERSION_IDENTIFIER = `^v?${MAIN_VERSION_IDENTIFIER}${PRERELEASE}?${BUILD}?$`;
    var REGEX_MAIN_VERSION = new RegExp(MAIN_VERSION_IDENTIFIER);
    var REGEX_FULL_VERSION = new RegExp(FULL_VERSION_IDENTIFIER);
    var REGEX_NUMERIC = /^[0-9]+$/;
    var SemverVersion = class _SemverVersion {
      constructor(version) {
        if (version instanceof _SemverVersion) {
          return version;
        } else if (typeof version !== "string") {
          throw new TypeError("Invalid Version: " + version);
        }
        if (version.length > MAX_LENGTH) {
          throw new TypeError(`version is longer than ${MAX_LENGTH} characters`);
        }
        if (!(this instanceof _SemverVersion)) {
          return new _SemverVersion(version);
        }
        const matches = version.trim().match(REGEX_FULL_VERSION);
        this.rawVersion = version;
        this.major = +matches[1];
        this.minor = +matches[2];
        this.patch = +matches[3];
        this._isThrowVersionNumericError(this.major, "major");
        this._isThrowVersionNumericError(this.minor, "minor");
        this._isThrowVersionNumericError(this.patch, "patch");
        if (matches[4]) {
          this.prereleaseArray = matches[4].split(".").map(function(id) {
            if (REGEX_NUMERIC.test(id)) {
              var num = +id;
              if (num >= 0 && num < MAX_SAFE_INTEGER) {
                return num;
              }
            }
            return id;
          });
        } else {
          this.prereleaseArray = [];
        }
        this.prerelease = matches[4];
        this.build = matches[5];
        this.mainVersion = [
          this.major,
          this.minor,
          this.patch
        ].join(".");
        this.version = this.mainVersion + (this.prerelease ? `-${this.prerelease}` : "") + (this.build ? `+${this.build}` : "");
      }
      _isThrowVersionNumericError(versionNumber, versionName) {
        if (versionNumber > MAX_SAFE_INTEGER || this.major < 0) {
          throw new TypeError(`Invalid ${versionName} version`);
        }
      }
      _isNumeric(numeric) {
        return REGEX_NUMERIC.test(numeric);
      }
      _padNumber(num, fill) {
        const length = ("" + num).length;
        return Array(
          fill > length ? fill - length + 1 || 0 : 0
        ).join(0) + num;
      }
      static validate(version) {
        return REGEX_FULL_VERSION.test(version);
      }
      mainVersionToNumeric(digit) {
        const numericStr = [
          this._padNumber(this.major, digit),
          this._padNumber(this.minor, digit),
          this._padNumber(this.patch, digit)
        ].join("");
        return parseInt(numericStr);
      }
      compare(other, needCompareBuildVersion = false) {
        let otherSemver = other;
        if (!(other instanceof _SemverVersion)) {
          otherSemver = new _SemverVersion(other);
        }
        const result = this.compareMainVersion(otherSemver) || this.comparePreReleaseVersion(otherSemver);
        if (!result && needCompareBuildVersion) {
          return this.compareBuildVersion(otherSemver);
        } else {
          return result;
        }
      }
      // 比较数字
      compareNumeric(a, b) {
        return a > b ? 1 : a < b ? -1 : 0;
      }
      compareIdentifiers(a, b) {
        const aIsNumeric = this._isNumeric(a);
        const bIsNumeric = this._isNumeric(b);
        if (aIsNumeric && bIsNumeric) {
          a = +a;
          b = +b;
        }
        if (aIsNumeric && !bIsNumeric) {
          return -1;
        } else if (bIsNumeric && !aIsNumeric) {
          return 1;
        } else {
          return this.compareNumeric(a, b);
        }
      }
      compareMainVersion(otherSemver) {
        return this.compareNumeric(this.major, otherSemver.major) || this.compareNumeric(this.minor, otherSemver.minor) || this.compareNumeric(this.patch, otherSemver.patch);
      }
      comparePreReleaseVersion(otherSemver) {
        if (this.prereleaseArray.length && !otherSemver.prereleaseArray.length) {
          return -1;
        } else if (!this.prereleaseArray.length && otherSemver.prereleaseArray.length) {
          return 1;
        } else if (!this.prereleaseArray.length && !otherSemver.prereleaseArray.length) {
          return 0;
        }
        let i = 0;
        do {
          const a = this.prereleaseArray[i];
          const b = otherSemver.prereleaseArray[i];
          if (a === void 0 && b === void 0) {
            return 0;
          } else if (b === void 0) {
            return 1;
          } else if (a === void 0) {
            return -1;
          } else if (a === b) {
            continue;
          } else {
            return this.compareIdentifiers(a, b);
          }
        } while (++i);
      }
      compareBuildVersion(otherSemver) {
        if (this.build && !otherSemver.build) {
          return 1;
        } else if (!this.build && otherSemver.build) {
          return -1;
        } else {
          return this.compareIdentifiers(this.build, otherSemver.build);
        }
      }
    };
    module.exports = SemverVersion;
  }
});

// node_modules/semver-lite/src/index.js
var require_src = __commonJS({
  "node_modules/semver-lite/src/index.js"(exports, module) {
    var SemverVersion = require_semver();
    var semver2 = {
      version: "0.0.5",
      SemverVersion,
      validate(version) {
        return SemverVersion.validate(version);
      },
      compare(a, b, needCompareBuildVersion) {
        return new SemverVersion(a).compare(new SemverVersion(b), needCompareBuildVersion);
      },
      format(version) {
        return new SemverVersion(version).format();
      },
      instance(version) {
        return new SemverVersion(version);
      },
      compareMainVersion(a, b) {
        return new SemverVersion(a).compareMainVersion(new SemverVersion(b));
      },
      gt(a, b, needCompareBuildVersion) {
        const result = this.compare(a, b, needCompareBuildVersion);
        return result === 1;
      },
      gte(a, b, needCompareBuildVersion) {
        const result = this.compare(a, b, needCompareBuildVersion);
        return result === 1 || result === 0;
      },
      lt(a, b, needCompareBuildVersion) {
        const result = this.compare(a, b, needCompareBuildVersion);
        return result === -1;
      },
      lte(a, b, needCompareBuildVersion) {
        const result = this.compare(a, b, needCompareBuildVersion);
        return result === -1 || result === 0;
      },
      equal(a, b, needCompareBuildVersion) {
        const result = this.compare(a, b, needCompareBuildVersion);
        return result === 0;
      },
      equalMain(a, b) {
        return new SemverVersion(a).mainVersion === new SemverVersion(b).mainVersion;
      },
      // 主版本转成数字类型方便比较
      mainVersionToNumeric(version, digit = 6) {
        const semverVersion = new SemverVersion(version);
        return semverVersion.mainVersionToNumeric(digit);
      }
    };
    module.exports = semver2;
  }
});

// src/~assets/svg/icons/airplay.svg
var airplay_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m1 4c0-1.10457.89543-2 2-2h18c1.1046 0 2 .89543 2 2v11.5c0 1.1046-.8954 2-2 2h-2v-2h2v-11.5h-18v11.5h2v2h-2c-1.10457 0-2-.8954-2-2zm11 9.9999c.2968 0 .5782.1319.7682.3599l5 6c.2484.298.302.7129.1374 1.0643s-.5176.5758-.9056.5758h-10c-.38802 0-.74101-.2244-.90559-.5758s-.11103-.7663.13737-1.0643l5.00002-6c.19-.228.4714-.3599.7682-.3599zm-2.86496 6h5.72996l-2.865-3.4379z" fill-rule="evenodd"/></svg>';

// src/~assets/svg/icons/airplay-active.svg
var airplay_active_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m3 2c-1.10457 0-2 .89543-2 2v11.5c0 1.1046.89543 2 2 2h2v-2h-2v-11.5h18v11.5h-2v2h2c1.1046 0 2-.8954 2-2v-11.5c0-1.10457-.8954-2-2-2zm9.7682 12.3598c-.19-.228-.4714-.3599-.7682-.3599s-.5782.1319-.7682.3599l-5.00002 6c-.2484.298-.30195.7129-.13737 1.0643s.51757.5758.90559.5758h10c.388 0 .741-.2244.9056-.5758s.111-.7663-.1374-1.0643zm-.7682 2.2022 2.865 3.4379h-5.72996zm-7-3.062v-7.5h14v7.5h-5l-1.2929-1.2929c-.3905-.3905-1.0237-.3905-1.4142 0l-1.2929 1.2929z" fill-rule="evenodd"/></svg>';

// src/~assets/svg/icons/arrow-down.svg
var arrow_down_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m18.5 12.393-6.5 6.607-6.5-6.607 1.371-1.393 4.129 4.197v-10.197h2v10.197l4.129-4.197z"/></svg>';

// src/~assets/svg/icons/arrow-down-up.svg
var arrow_down_up_default = '<svg viewBox="0 0 24 28" xmlns="http://www.w3.org/2000/svg"><path d="m24 6.60691-6.5-6.60691-6.5 6.60691 1.3705 1.39309 4.1295-4.197v10.197h2v-10.197l4.1295 4.197z"/><path d="m.00000116 21.3931 6.49999884 6.6069 6.5-6.6069-1.3705-1.3931-4.1295 4.197v-10.197h-2v10.197l-4.12945-4.197z"/></svg>';

// src/~assets/svg/icons/arrow-left.svg
var arrow_left_default = '<svg viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg"><g transform="matrix(-1 0 0 1 19 6)"><path d="m0 7h12v-2h-12z"/><path d="m10.586 6-5.293 5.293 1.414 1.414 6.707-6.707-6.707-6.707-1.414 1.414z"/></g></svg>';

// src/~assets/svg/icons/arrow-right.svg
var arrow_right_default = '<svg viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg"><g transform="translate(6 6)"><path d="m0 7h12v-2h-12z"/><path d="m10.586 6-5.293 5.293 1.414 1.414 6.707-6.707-6.707-6.707-1.414 1.414z"/></g></svg>';

// src/~assets/svg/icons/arrow-up.svg
var arrow_up_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m5.5 11.607 6.5-6.607 6.5 6.607-1.371 1.393-4.129-4.197v10.197h-2v-10.197l-4.129 4.197z"/></svg>';

// src/~assets/svg/icons/bell.svg
var bell_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m14 19c0 1.1045695-.8954305 2-2 2s-2-.8954305-2-2zm-2-16.5c.7796961 0 1.4204487.59488808 1.4931334 1.35553999l.0068666.14446001-.0002575.18895995c2.5879715.66597461 4.5002575 3.01518816 4.5002575 5.81104005l-.0007914 4.825 1.6515828 1.4157434-.6507914 1.7592566h-14l-.65079137-1.7592566 1.65-1.4147434.00079137-4.826c0-2.79549326 1.9117955-5.14446276 4.4992617-5.81078369l.0007383-.18921631c0-.82842712.6715729-1.5 1.5-1.5zm0 3.5-.1512757.00278147c-2.07676362.07654179-3.74173528 1.73548434-3.84376794 3.79684349l-.00495639.20070304v5.999672h8.00000003v-6c0-2.14219539-1.6839685-3.89107888-3.8003597-3.99510469z"/></svg>';

// src/~assets/svg/icons/bell-active.svg
var bell_active_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m14 19c0 1.1045695-.8954305 2-2 2s-2-.8954305-2-2zm-2-16.5c.7796961 0 1.4204487.59488808 1.4931334 1.35553999l.0068666.14446001-.0002575.18895995c2.5879715.66597461 4.5002575 3.01518816 4.5002575 5.81104005l-.0007914 4.825 1.6515828 1.4157434-.6507914 1.7592566h-14l-.65079137-1.7592566 1.65-1.4147434.00079137-4.826c0-2.79549326 1.9117955-5.14446276 4.4992617-5.81078369l.0007383-.18921631c0-.82842712.6715729-1.5 1.5-1.5zm-7.07106781.42893219 1.41421356 1.41421356c-.74294448.74294448-1.33424364 1.62474759-1.73655018 2.59495067-.35442777.85473855-.55804712 1.76733761-.59892021 2.7079283l-.00767536.35397528h-2c0-1.32957376.2601343-2.62459983.75912968-3.82797785.4528715-1.09214562 1.09660661-2.09382427 1.89718187-2.95959549zm14.14213561 0c.9277873.92778731 1.666612 2.02959483 2.1698025 3.24308996.4490959 1.08304022.7047142 2.24031536.7513469 3.43019925l.0077828.3977786h-2c0-1.06551214-.2078643-2.10032271-.6065956-3.06190358-.3576058-.86240274-.8645391-1.65495859-1.4945697-2.34222881l-.2419805-.25272186z"/></svg>';

// src/~assets/svg/icons/bell-off.svg
var bell_off_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m14 19c0 1.1045695-.8954305 2-2 2s-2-.8954305-2-2zm-9.6-15.584 15.9986531 15.9982136.0133469-.0142136.0022136.0020627-1.4142136 1.4142136-2.817-2.8162763h-11.183l-.65079137-1.7592566 1.65-1.4147434.00079137-4.826c0-.65743814.10573879-1.29017966.30113763-1.88214584l-3.30113763-3.30157789zm3.603 6.404-.00300003.180328v5.999672h6.18300003zm3.997-7.32c.7796961 0 1.4204487.59488808 1.4931334 1.35553999l.0068666.14446001-.0002575.18895995c2.5879715.66597461 4.5002575 3.01518816 4.5002575 5.81104005l-.001 4.187-2-2 .001-2.187c0-2.14219539-1.6839685-3.89107888-3.8003597-3.99510469l-.1996403-.00489531-.1512757.00278147c-.5815197.02143266-1.1307521.16693659-1.6224237.41060532l-1.46506189-1.46504461c.52839646-.33947246 1.11353039-.59830735 1.73802299-.75912587l.0007383-.18921631c0-.82842712.6715729-1.5 1.5-1.5z"/></svg>';

// src/~assets/svg/icons/bell-on.svg
var bell_on_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m14 19c0 1.1045695-.8954305 2-2 2s-2-.8954305-2-2zm-2-16.5c.7796961 0 1.4204487.59488808 1.4931334 1.35553999l.0068666.14446001-.0002575.18895995c2.5879715.66597461 4.5002575 3.01518816 4.5002575 5.81104005l-.0007914 4.825 1.6515828 1.4157434-.6507914 1.7592566h-14l-.65079137-1.7592566 1.65-1.4147434.00079137-4.826c0-2.79549326 1.9117955-5.14446276 4.4992617-5.81078369l.0007383-.18921631c0-.82842712.6715729-1.5 1.5-1.5z"/></svg>';

// src/~assets/svg/icons/bundles.svg
var bundles_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m14.4628 18.7874c1.9771-1.5999 3.2413-4.0461 3.2413-6.7877 0-4.81977-3.9073-8.72699-8.72707-8.72699-4.8198 0-8.72703 3.90722-8.72703 8.72699 0 4.7395 3.77805 8.5966 8.48677 8.7238l-.00217.0033h14.5147v-1.9394h-3.2406c1.9771-1.5999 3.2413-4.0461 3.2413-6.7877 0-4.81977-3.9072-8.72699-8.7271-8.72699-.3854 0-.7649.02498-1.1372.07342 4.2825.55729 7.5899 4.21922 7.5899 8.65357 0 2.7416-1.2642 5.1878-3.2413 6.7877zm-5.46381-8.78747c1.10451 0 2.00001-.89542 2.00001-1.99997s-.8955-1.99996-2.00001-1.99996c-1.10455 0-1.99997.89541-1.99997 1.99996s.89542 1.99997 1.99997 1.99997zm-3.99903 3.99977c1.10455 0 1.99997-.8954 1.99997-2 0-1.1045-.89542-1.99994-1.99997-1.99994s-1.99996.89544-1.99996 1.99994c0 1.1046.89541 2 1.99996 2zm3.99903 4.0002c1.10451 0 2.00001-.8954 2.00001-1.9999 0-1.1046-.8955-2-2.00001-2-1.10455 0-1.99997.8954-1.99997 2 0 1.1045.89542 1.9999 1.99997 1.9999zm6.00191-6.0002c0 1.1046-.8954 2-2 2-1.1045 0-1.9999-.8954-1.9999-2 0-1.1045.8954-1.99994 1.9999-1.99994 1.1046 0 2 .89544 2 1.99994zm-5 .0003c0 .5523-.44767 1-.99994 1-.55228 0-.99998-.4477-.99998-1s.4477-1 .99998-1c.55227 0 .99994.4477.99994 1z" fill-rule="evenodd"/></svg>';

// src/~assets/svg/icons/caret-down.svg
var caret_down_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m5.707 7.293-1.414 1.414 7.707 7.707 7.707-7.707-1.414-1.414-6.293 6.293z"/></svg>';

// src/~assets/svg/icons/caret-up.svg
var caret_up_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m5.707 7.44-1.414 1.414 7.707 7.707 7.707-7.707-1.414-1.414-6.293 6.293z" transform="matrix(1 0 0 -1 0 24.001)"/></svg>';

// src/~assets/svg/icons/cart.svg
var cart_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m2.21922 2h-2.21922v-2h3 .78078l.18936.757464.81064 3.242536h17.21922 1.2808l-.3107 1.24254-2 7.99996-.1893.7575h-.7808-12.71922l.5 2h13.21922v2h-3-8-3-.78078l-.18936-.7575-1-4-2-7.99996zm7.78078 16c1.6569 0 3 1.3431 3 3s-1.3431 3-3 3c-1.65685 0-3-1.3431-3-3s1.34315-3 3-3zm8 0c1.6569 0 3 1.3431 3 3s-1.3431 3-3 3-3-1.3431-3-3 1.3431-3 3-3zm-11.21922-6h12.43842l1.5-6h-15.43842zm3.21922 8c-.55229 0-1 .4477-1 1s.44771 1 1 1c.5523 0 1-.4477 1-1s-.4477-1-1-1zm7 1c0-.5523.4477-1 1-1s1 .4477 1 1-.4477 1-1 1-1-.4477-1-1z" fill-rule="evenodd"/></svg>';

// src/~assets/svg/icons/cellular.svg
var cellular_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m19 7v-1h-2v1 11 1h2v-1zm-4 3v-1h-2v1 8 1h2v-1zm-4 2v1 5 1h-2v-1-5-1zm-4 4v-1h-2v1 2 1h2v-1z" fill-rule="evenodd"/></svg>';

// src/~assets/svg/icons/checkmark.svg
var checkmark_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m6.707 11.293-1.414 1.414 4.707 4.707 8.707-8.707-1.414-1.414-7.293 7.293z"/></svg>';

// src/~assets/svg/icons/chevron-left.svg
var chevron_left_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m15.41 7.41-1.41-1.41-6 6 6 6 1.41-1.41-4.58-4.59z"/><path d="m0 0h24v24h-24z" fill="none"/></svg>';

// src/~assets/svg/icons/chevron-right.svg
var chevron_right_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m10 6-1.41 1.41 4.58 4.59-4.58 4.59 1.41 1.41 6-6z"/><path d="m0 0h24v24h-24z" fill="none"/></svg>';

// src/~assets/svg/icons/chromecast.svg
var chromecast_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m0 15v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0-4v2c4.97 0 9 4.03 9 9h2c0-6.08-4.93-11-11-11zm20-7h-18c-1.1 0-2 .9-2 2v3h2v-3h18v14h-7v2h7c1.1 0 2-.9 2-2v-14c0-1.1-.9-2-2-2z" transform="translate(1 3)"/></svg>';

// src/~assets/svg/icons/chromecast-off.svg
var chromecast_off_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g transform="translate(1 3)"><path d="m0 15v3h3c0-1.66-1.34-3-3-3z"/><g opacity=".3" transform="translate(0 7)"><path d="m0 4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7z"/><path d="m0 0v2c4.97 0 9 4.03 9 9h2c0-6.08-4.93-11-11-11z"/></g><path d="m20 0h-18c-1.1 0-2 .9-2 2v3h2v-3h18v14h-7v2h7c1.1 0 2-.9 2-2v-14c0-1.1-.9-2-2-2z"/></g></svg>';

// src/~assets/svg/icons/close.svg
var close_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g transform="matrix(.7071 -.7071 .7071 .7071 -4.9706 12)"><path d="m11 3.5h2v17h-2z"/><path d="m3.5 11h17v2h-17z"/></g></svg>';

// src/~assets/svg/icons/coming.svg
var coming_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m6 2v2h-4v17h20v-17h-4v-2h-2v2h-8v-2zm10 4h-8v1h-2v-1h-2v3h16v-3h-2v1h-2zm-12 5v8h16v-8zm11 3h3v3h-3z" fill-rule="evenodd"/></svg>';

// src/~assets/svg/icons/discover.svg
var discover_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill-rule="nonzero"><path d="m18.3628932 7.05289321c-.3909586.39095862-1.0248278.39095861-1.4157864-.00000001-.3909586-.39095863-.3909586-1.0248278 0-1.41578643l.7071068-.70710678-3.5342136-3.53421355-12.72421356 12.72421356 3.53421354 3.5342135.70710678-.7071067c.39095863-.3909586 1.02482779-.3909586 1.41578641 0s.39095863 1.0248278.00000003 1.4157864l-.70710674.7071068 3.53421354 3.5342136 12.7242136-12.7242136-3.5342136-3.53421355zm1.4128932 2.82710679-9.8957864 9.8957864-.82644573-.8264457c.53311152-1.115604.33762901-2.4923709-.58644754-3.4164474-.92407654-.9240766-2.30084338-1.1195591-3.41644744-.5864476l-.82644573-.8264457 9.89578644-9.89578644.8264457.82644572c-.5331115 1.11560406-.337629 2.49237092.5864475 3.41644748.9240766.92407656 2.3008435 1.11955906 3.4164475.58644752z"/><path d="m9.883 7.047 7.07 7.07 1.414-1.414-7.07-7.07z"/></g></svg>';

// src/~assets/svg/icons/dots.svg
var dots_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m4 12c0 1.1046.89543 2 2 2s2-.8954 2-2-.89543-2-2-2-2 .8954-2 2zm12 0c0 1.1046.8954 2 2 2s2-.8954 2-2-.8954-2-2-2-2 .8954-2 2zm-4 2c-1.1046 0-2-.8954-2-2s.8954-2 2-2 2 .8954 2 2-.8954 2-2 2z" fill-rule="evenodd"/></svg>';

// src/~assets/svg/icons/download.svg
var download_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m11 3h2v12h-2z"/><path d="m12 16.4-6.7-6.7 1.4-1.4 5.3 5.3 5.3-5.3 1.4 1.4z"/><path d="m6 18h12v2h-12z"/></svg>';

// src/~assets/svg/icons/download-queue.svg
var download_queue_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m18.0769231 10v6.197l2.4471059-2.197 1.475971 1.3930873-5 4.6069127-5-4.6069127 1.475971-1.3930873 2.4471059 2.197v-6.197zm-7.0769231 5v2h-8v-2zm3-5v2h-11v-2zm5-5v2h-16v-2z"/></svg>';

// src/~assets/svg/icons/edit.svg
var edit_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m17.7071 2.29292-.7071-.7071-.7071.7071-13.00001 12.99998-.29289.2929v.4142 4 1h1 4 .41421l.2929-.2929 12.99999-12.99996.7071-.70711-.7071-.70711zm-2.2929 3.70711 1.5858-1.58579 2.5858 2.58579-1.5858 1.58578zm-1.4142 1.41421-9 8.99996v2.5858h2.58579l9.00001-9z" fill-rule="evenodd"/></svg>';

// src/~assets/svg/icons/exclude.svg
var exclude_default = '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 20C7.58172 20 4 16.4183 4 12C4 10.1513 4.62707 8.44908 5.6801 7.09441L16.9056 18.3199C15.5509 19.3729 13.8487 20 12 20ZM18.3198 16.9057C19.3729 15.551 20 13.8487 20 12C20 7.58172 16.4183 4 12 4C10.1513 4 8.449 4.6271 7.0943 5.68018L18.3198 16.9057Z" /></svg>\n';

// src/~assets/svg/icons/facebook.svg
var facebook_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">\n<path d="M9.34531 24V13.2656H5.75V9H9.34531V5.63906C9.34531 1.9875 11.5766 0 14.8344 0C16.3953 0 17.7359 0.117187 18.125 0.16875V3.98438H15.8656C14.0938 3.98438 13.7516 4.82812 13.7516 6.06094V9H17.75L17.2016 13.2656H13.7516V24"/>\n</svg>\n';

// src/~assets/svg/icons/filter.svg
var filter_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m4 8h16v-2h-16zm6 10h4v-2h-4zm7-5h-10v-1-1h10z"/></svg>';

// src/~assets/svg/icons/flag-dk.svg
var flag_dk_default = '<svg viewBox="0 0 640 480" xmlns="http://www.w3.org/2000/svg"><path d="m0 0h640.1v480h-640.1z" fill="#c60c30"/><g fill="#fff"><path d="m205.7 0h68.6v480h-68.6z"/><path d="m0 205.7h640.1v68.6h-640.1z"/></g></svg>';

// src/~assets/svg/icons/flag-fi.svg
var flag_fi_default = '<svg viewBox="0 0 640 480" xmlns="http://www.w3.org/2000/svg"><path d="m0 0h640v480h-640z" fill="#fff"/><g fill="#003580"><path d="m0 174.5h640v131h-640z"/><path d="m175.5 0h130.9v480h-131z"/></g></svg>';

// src/~assets/svg/icons/flag-no.svg
var flag_no_default = '<svg viewBox="0 0 640 480" xmlns="http://www.w3.org/2000/svg"><path d="m0 0h640v480h-640z" fill="#ef2b2d"/><path d="m180 0h120v480h-120z" fill="#fff"/><path d="m0 180h640v120h-640z" fill="#fff"/><g fill="#002868"><path d="m210 0h60v480h-60z"/><path d="m0 210h640v60h-640z"/></g></svg>';

// src/~assets/svg/icons/flag-se.svg
var flag_se_default = '<svg fill="none" viewBox="0 0 640 480" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><clipPath id="a"><path d="m0 0h640v480h-640z"/></clipPath><g clip-path="url(#a)" clip-rule="evenodd" fill-rule="evenodd"><path d="m-63.4521.283112h240.0001v191.997888h-240.0001zm0 287.695888h240.0001v192h-240.0001z" fill="#006aa7"/><g fill="#fecc00"><path d="m-63 192h289v96h-289z"/><path d="m175.56.0093689h96v479.9976311h-96z"/><path d="m216 192h485v96h-485z"/></g><path d="m271.477 288.007h431.998v192h-431.998zm0-287.723888h431.998v191.997888h-431.998z" fill="#006aa7"/></g></svg>';

// src/~assets/svg/icons/fullscreen.svg
var fullscreen_default = '<svg enable-background="new 0 0 24 24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m13 20h-9v-9h2v7h7z"/><path d="m20 13h-2v-7h-7v-2h9z"/></svg>';

// src/~assets/svg/icons/fullscreen-close.svg
var fullscreen_close_default = '<svg enable-background="new 0 0 24 24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m11 22h-2v-7h-7v-2h9z"/><path d="m22 11h-9v-9h2v7h7z"/></svg>';

// src/~assets/svg/icons/genres.svg
var genres_default = '<svg enable-background="new 0 0 24 24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m18.8 17c0-1.7-1.3-3-3-3s-3 1.3-3 3z"/><path d="m22.8 21h-14v-4.1c-.3 0-.7.1-1 .1-1.9 0-3.6-.7-4.9-2s-2.1-3.1-2.1-4.9v-7.1h14v4.1c.3 0 .7-.1 1-.1 3.9 0 7 3.1 7 7zm-12-2h10v-5c0-2.8-2.2-5-5-5-.6 0-1.1.1-1.7.3l-1.3.5v-4.8h-10v5c0 2.8 2.2 5 5 5 .6 0 1.1-.1 1.7-.3l1.3-.5z"/><path d="m4.8 10c0 1.7 1.3 3 3 3s3-1.3 3-3z"/><circle cx="17.8" cy="12" r="1"/><circle cx="13.8" cy="12" r="1"/><circle cx="9.8" cy="8" r="1"/><circle cx="5.8" cy="8" r="1"/></svg>';

// src/~assets/svg/icons/gift.svg
var gift_default = '<svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 24 24"><path fill-rule="evenodd" d="M7.5 3a1.5 1.5 0 0 0 0 3h3.2l-.5-1c-.6-1.2-1.5-2-2.7-2ZM4 4.5 4.3 6H1v7h2v10h18V13h2V6h-3.3a3.5 3.5 0 0 0-3.2-5c-2.3 0-3.7 1.7-4.4 3l-.1.1C11.1 2.6 9.7 1 7.4 1A3.5 3.5 0 0 0 4 4.5ZM13.3 6h3.2a1.5 1.5 0 0 0 0-3c-1.2 0-2 .8-2.7 2l-.5 1ZM13 8v3h8V8h-8ZM7.5 8H11v3H3V8h4.5ZM13 21h6v-8h-6v8Zm-2-8v8H5v-8h6Z" clip-rule="evenodd"/></svg>';

// src/~assets/svg/icons/grid.svg
var grid_default = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">\n    <path fill-rule="evenodd" d="M7.3 7.3H2.7v-4h4.6v4Zm6 5.4H8.7v-4h4.6v4ZM8.7 7.3h4.6v-4H8.7v4Zm-1.4 5.4H2.7v-4h4.6v4Z" clip-rule="evenodd"/>\n</svg>';

// src/~assets/svg/icons/guest.svg
var guest_default = '<svg enable-background="new 0 0 24 24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m3 9h18v2h-18z"/><path d="m7 21c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/><path d="m17 21c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/><path d="m15 17h-2c0-.6-.4-1-1-1s-1 .4-1 1h-2c0-1.7 1.3-3 3-3s3 1.3 3 3z"/><path d="m16.1 10.3-1.7-5-2.4.8-2.4-.8-1.7 5-1.8-.6 2.3-7 3.6 1.2 3.6-1.2 2.3 7z"/></svg>';

// src/~assets/svg/icons/help.svg
var help_default = '<svg enable-background="new 0 0 24 24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m13 16h-2v-5h1c1.7 0 3-1.3 3-3s-1.3-3-3-3-3 1.3-3 3h-2c0-2.8 2.2-5 5-5s5 2.2 5 5c0 2.4-1.7 4.4-4 4.9z"/><circle cx="12" cy="19" r="1.5"/></svg>';

// src/~assets/svg/icons/home.svg
var home_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m14 19v-7.11h-4v7.11h-7v-11.92064l9-6.300002 9 6.300002v11.92064zm5-10.87936-7-4.9-7 4.9v8.87936h3v-7.11001h8v7.11001h3z"/></svg>';

// src/~assets/svg/icons/info.svg
var info_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m12 2c5.5228475 0 10 4.4771525 10 10s-4.4771525 10-10 10-10-4.4771525-10-10 4.4771525-10 10-10zm0 2c-4.418278 0-8 3.581722-8 8s3.581722 8 8 8 8-3.581722 8-8-3.581722-8-8-8zm1 7v6h-2v-6zm-1-4c.8284271 0 1.5.67157288 1.5 1.5s-.6715729 1.5-1.5 1.5-1.5-.67157288-1.5-1.5.6715729-1.5 1.5-1.5z"/></svg>';

// src/~assets/svg/icons/instagram.svg
var instagram_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m12.0027 5.8467c-3.40527 0-6.15195 2.7473-6.15195 6.1533s2.74668 6.1533 6.15195 6.1533c3.4052 0 6.1519-2.7473 6.1519-6.1533s-2.7467-6.1533-6.1519-6.1533zm0 10.1537c-2.20058 0-3.99958-1.794-3.99958-4.0004s1.79365-4.00045 3.99958-4.00045c2.2059 0 3.9995 1.79405 3.9995 4.00045s-1.799 4.0004-3.9995 4.0004zm7.8385-10.4054c0 .79795-.6425 1.43524-1.435 1.43524-.7977 0-1.4349-.64265-1.4349-1.43524s.6425-1.43523 1.4349-1.43523c.7925 0 1.435.64264 1.435 1.43523zm4.0745 1.45666c-.091-1.92257-.5301-3.62558-1.9382-5.02868-1.4028-1.403098-3.1054-1.842237-5.0276-1.9386332-1.981-.1124623-7.91878-.1124623-9.89982 0-1.91678.0910412-3.6194.5301792-5.02755 1.9332832-1.408141 1.4031-1.841827 3.1061-1.938202 5.02867-.1124373 1.98148-.1124373 7.9206 0 9.902.091021 1.9226.530061 3.6256 1.938202 5.0287 1.40815 1.4031 3.10541 1.8423 5.02755 1.9387 1.98104.1124 7.91882.1124 9.89982 0 1.9222-.0911 3.6248-.5302 5.0276-1.9387 1.4028-1.4031 1.8418-3.1061 1.9382-5.0287.1124-1.9814.1124-7.91516 0-9.89664zm-2.5593 12.02274c-.4176 1.0497-1.2261 1.8583-2.2809 2.2814-1.5795.6266-5.3274.482-7.0728.482-1.7455 0-5.49874.1392-7.07286-.482-1.04942-.4177-1.85789-1.2264-2.28087-2.2814-.62644-1.5798-.48188-5.3286-.48188-7.0744s-.1392-5.49994.48188-7.07442c.41762-1.04965 1.2261-1.8583 2.28087-2.28138 1.57947-.62657 5.32736-.48198 7.07286-.48198 1.7454 0 5.4987-.13924 7.0728.48198 1.0494.41772 1.8579 1.22638 2.2809 2.28138.6264 1.57983.4819 5.32862.4819 7.07442s.1445 5.4999-.4819 7.0744z"/></svg>';

// src/~assets/svg/icons/kids.svg
var kids_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m11.998 3.00001c1.0208.00225 2.0269.17661 2.9806.51331.7818-1.26068 2.2257-2.01564 3.7646-1.87466 1.9208.17597 3.4424 1.69761 3.6184 3.61839.141 1.53874-.6138 2.98252-1.8743 3.76436 1.2636 3.57249.1527 7.60929-2.8637 10.02329-3.2874 2.6307-7.95931 2.6307-11.24668 0-3.01644-2.414-4.12734-6.4508-2.86372-10.02329-1.26046-.78184-2.01527-2.22562-1.8743-3.76436.17597-1.92078 1.69761-3.44242 3.6184-3.61839 1.53889-.14098 2.98279.61398 3.76458 1.87466.95375-.3367 1.95982-.51106 2.97612-.51331zm-3.04924 2.70873-1.07685.52535-.32429-1.15344c-.26103-.92842-1.14742-1.53833-2.10781-1.45035-.9604.08799-1.72122.84881-1.8092 1.8092-.08799.96039.52193 1.84679 1.45034 2.10781l1.15344.3243-.52534 1.07684c-1.43586 2.94315-.6393 6.48855 1.91754 8.53465 2.55681 2.0461 6.19061 2.0461 8.74741 0s3.3534-5.5915 1.9175-8.53465l-.5253-1.07684 1.1534-.3243c.9285-.26102 1.5384-1.14742 1.4504-2.10781s-.8488-1.72121-1.8092-1.8092c-.9604-.08798-1.8468.52193-2.1078 1.45035l-.3243 1.15344-1.0769-.52535c-.9506-.46376-1.9939-.70607-3.0515-.70875-1.0577.00268-2.10096.24499-3.05154.70875zm.05148 6.29126c.55229 0 .99996-.4477.99996-1s-.44767-1-.99996-1c-.55228 0-1 .4477-1 1s.44772 1 1 1zm6.99996-1c0 .5523-.4477 1-1 1-.5522 0-1-.4477-1-1s.4478-1 1-1c.5523 0 1 .4477 1 1zm-4 6c1.1046 0 2-.8954 2-2s-.8954-2-2-2c-1.1045 0-2 .8954-2 2s.8955 2 2 2z" fill-rule="evenodd"/></svg>';

// src/~assets/svg/icons/lightbulb.svg
var lightbulb_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g clip-rule="evenodd" fill-rule="evenodd"><path d="m15.605 4.47088c-1.9973-1.96117-5.2428-1.96117-7.24003 0-1.92958 1.89475-1.78253 4.8226.2471 6.81562.4192.4116.67339.9605.83849 1.4649.17002.5194.27584 1.0873.34395 1.6223.07304.5737.10665 1.1439.12212 1.6263h4.13617c.0155-.4824.0496-1.0526.1226-1.6263.0681-.535.1739-1.1029.344-1.6223.1651-.5044.4193-1.0533.8385-1.4649 2.1024-2.06454 2.1854-4.91229.2471-6.81562zm-8.64131-1.42704c2.77522-2.725121 7.26731-2.725121 10.04251 0 2.8341 2.78296 2.5526 6.92051-.2471 9.66966-.09.0884-.2177.2895-.339.6601-.1164.3556-.2015.7877-.2607 1.2527-.1184.93-.1193 1.8723-.1193 2.3737l-1 1h-6.11028l-1-1c0-.5014-.00091-1.4437-.1193-2.3737-.05918-.465-.14431-.8971-.26071-1.2527-.12132-.3706-.24902-.5717-.33902-.6601-2.70796-2.6591-3.08995-6.87812-.2471-9.66966z"/><path d="m14 22h-4v-2h4z"/><path d="m9.43742 6.01804c-.2672.30283-.43742.64798-.43742.98169h-1c0-.66629.32978-1.2378.68758-1.64331.35358-.40073.79895-.71258 1.15431-.83103l.31621.94868c-.1446.04822-.44926.23637-.72068.54397z"/></g></svg>';

// src/~assets/svg/icons/login.svg
var login_default = '<svg enable-background="new 0 0 24 24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m3 11h12v2h-12z"/><path d="m9.7 18.7-1.4-1.4 5.3-5.3-5.3-5.3 1.4-1.4 6.7 6.7z"/><path d="m18 6h2v12h-2z"/></svg>';

// src/~assets/svg/icons/logout.svg
var logout_default = '<svg enable-background="new 0 0 24 24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m8 11h12v2h-12z"/><path d="m14.7 18.7-1.4-1.4 5.3-5.3-5.3-5.3 1.4-1.4 6.7 6.7z"/><path d="m4 6h2v12h-2z"/></svg>';

// src/~assets/svg/icons/mail.svg
var mail_default = '<svg enable-background="new 0 0 24 24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m22 19h-20v-14h20zm-18-2h16v-10h-16z"/><path d="m12 14.3-9.6-7.5 1.2-1.6 8.4 6.5 8.4-6.5 1.2 1.6z"/></svg>';

// src/~assets/svg/icons/menu.svg
var menu_default = '<svg enable-background="new 0 0 24 24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m4 16h16v2h-16z"/><path d="m4 6h16v2h-16z"/><path d="m4 11h16v2h-16z"/></svg>';

// src/~assets/svg/icons/minus.svg
var minus_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m-1 2h18v-2h-18z" transform="translate(4 11)"/></svg>';

// src/~assets/svg/icons/mood.svg
var mood_default = '<svg enable-background="new 0 0 24 24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m11 8h-2c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5h-2c0-1.9 1.6-3.5 3.5-3.5s3.5 1.6 3.5 3.5z"/><path d="m20 8h-2c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5h-2c0-1.9 1.6-3.5 3.5-3.5s3.5 1.6 3.5 3.5z"/><path d="m12 20.5c-4.4 0-8-3.6-8-8v-1h16v1c0 4.4-3.6 8-8 8zm-5.9-7c.5 2.8 2.9 5 5.9 5s5.4-2.2 5.9-5z"/></svg>';

// src/~assets/svg/icons/movies.svg
var movies_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m22 12c0 3.2712-1.5707 6.1755-3.999 8h5.999v2h-12c-5.52285 0-10-4.4772-10-10 0-5.52285 4.47715-10 10-10 5.5228 0 10 4.47715 10 10zm-18 0c0 4.4183 3.58172 8 8 8 4.4183 0 8-3.5817 8-8 0-4.41828-3.5817-8-8-8-4.41828 0-8 3.58172-8 8zm8 6c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2zm-2-6c0 1.1046-.89543 2-2 2s-2-.8954-2-2 .89543-2 2-2 2 .8954 2 2zm6 2c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2zm-2-6c0 1.10457-.8954 2-2 2s-2-.89543-2-2 .8954-2 2-2 2 .89543 2 2zm-2 5c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1z"/></svg>';

// src/~assets/svg/icons/my-movies.svg
var my_movies_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m7.25874536 18.4442937c1.32685021.9778378 2.96656824 1.5557063 4.74125464 1.5557063 1.7698695 0 3.4055023-.5747359 4.7304436-1.5477529-.7035361-.819453-1.618078-1.4720491-2.7868752-2.0533459-.4326148-.2151593-.8811722-.4132446-1.4703211-.6553778-.0817705-.0336067-.2979203-.1214287-.4804006-.1954697-.1800699.0732463-.3977904.1619279-.4823891.1967769-.5911149.2434995-1.0402049.4421586-1.4736142.6579618-1.16391963.5795389-2.07573416 1.2287289-2.77809804 2.0415013zm-1.45211384-1.3801015c.87720045-.9940439 1.98257958-1.7764694 3.33876499-2.4517413.14656904-.0729796.29367262-.1437251.44512386-.2141364-.13226468-.0912928-.24983115-.1837632-.3548134-.2792365-1.18567991-.9230455-1.91311535-2.3146611-1.99570697-3.869078 0-2.62335256 2.12664744-4.75 4.75-4.75 2.6233526 0 4.75 2.12664744 4.7485412 4.8039945-.0811328 1.5004224-.8085683 2.892038-1.9393215 3.7690701-.1255675.1130887-.2607062.2193002-.4090502.3217504.151067.0701351.2978248.1406242.4440222.2133349 1.3622046.6774872 2.4715533 1.4643036 3.3507295 2.4663435 1.1342117-1.3807911 1.8150788-3.1481297 1.8150788-5.0744934 0-4.418278-3.581722-8-8-8s-8 3.581722-8 8c0 1.9215766.67748733 3.6849175 1.80663152 5.0641922zm12.19434338 2.9358078c-1.6714881 1.255821-3.7493253 2-6.0009749 2-5.5228475 0-10-4.4771525-10-10s4.4771525-10 10-10 10 4.4771525 10 10c0 3.2711979-1.5706862 6.1755424-3.9990251 8h5.9990251v2h-12l1-2zm-6.1581227-6.6773436c.0483356.0208318.0975269.0418051.1488835.0634762.0515549-.0218243.1009372-.042948.149435-.06392.6661241-.2880547 1.0756425-.5155553 1.3745363-.7812906.7287705-.567344 1.175884-1.4226915 1.224293-2.290922 0-1.51878306-1.2312169-2.75-2.75-2.75s-2.75 1.23121694-2.75145876 2.6960055c.04986778.922225.49698128 1.7775725 1.28067846 2.3909299.2442559.2199821.6546449.4473989 1.3236325.735721z"/></svg>';

// src/~assets/svg/icons/new.svg
var new_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m19 9.17070571c1.1651924.41183641 2 1.52307549 2 2.82929429s-.8348076 2.4174579-2 2.8292943v4.1707057l-1.4472136.8944272-9.78885438-4.8944272h-.76393202v4h-2v-4h-2v-6h4.76393202l9.78885438-4.89442719 1.4472136.89442719zm-12 1.82929429h-2v2h2zm2 2.381966 8 4v-10.76393201l-8 4.00000001z"/></svg>';

// src/~assets/svg/icons/pause.svg
var pause_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m10.5 4h-3v16h3zm6 0h-3v16h3z" fill-rule="evenodd"/></svg>';

// src/~assets/svg/icons/percent.svg
var percent_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m17 13c2.209139 0 4 1.790861 4 4s-1.790861 4-4 4-4-1.790861-4-4 1.790861-4 4-4zm2.0710678-9.48528137 1.4142136 1.41421356-15.55634921 15.55634921-1.41421356-1.4142136zm-2.0710678 11.48528137c-1.1045695 0-2 .8954305-2 2s.8954305 2 2 2 2-.8954305 2-2-.8954305-2-2-2zm-10-12c2.209139 0 4 1.790861 4 4s-1.790861 4-4 4-4-1.790861-4-4 1.790861-4 4-4zm0 2c-1.1045695 0-2 .8954305-2 2s.8954305 2 2 2 2-.8954305 2-2-.8954305-2-2-2z"/></svg>';

// src/~assets/svg/icons/phone.svg
var phone_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m15.4 20.9c-2.5 0-5.7-1.6-8.2-4.1-3.9-3.9-5.2-8.9-3-11.1l2.3-2.3h1.4l3.5 3.5v1.4l-1.8 1.8c.1 1.1.5 2.2 1.3 2.9.8.8 1.8 1.2 2.9 1.3l1.8-1.8h1.4l3.5 3.5v1.4l-2.3 2.3c-.6.8-1.6 1.2-2.8 1.2zm-8.2-15.4-1.6 1.6c-1.2 1.2-.2 5.1 3 8.3 2.1 2.1 4.8 3.5 6.8 3.5.5 0 1.1-.1 1.5-.5l1.6-1.6-2.1-2.1-1.4 1.4-.7.3c-1.8 0-3.5-.6-4.8-1.9-1.2-1.3-1.9-3-1.9-4.8l.3-.7 1.4-1.4z"/></svg>';

// src/~assets/svg/icons/pin.svg
var pin_default = '<svg viewBox="0 0 48 48"  xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15 6H33V8C33 9.14375 32.6621 10.4329 32.1859 11.4489C31.9452 11.9623 31.6201 12.5128 31.1934 12.9679C31.1365 13.0286 31.072 13.0937 31 13.1605V21.9363C35.0239 24.9426 36 29.7968 36 32V34H26V45H22V34H12V32C12 29.7968 12.9761 24.9426 17 21.9363V13.1605C16.928 13.0937 16.8635 13.0286 16.8066 12.9679C16.3799 12.5128 16.0548 11.9623 15.8141 11.4489C15.3379 10.4329 15 9.14375 15 8V6ZM27 10H21V24.1324L20.029 24.715C17.8449 26.0255 16.755 28.2273 16.2903 30H31.7097C31.245 28.2273 30.1551 26.0255 27.971 24.715L27 24.1324V10Z" /></svg>\n';

// src/~assets/svg/icons/place.svg
var place_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m19 10c0 2.4628991-1.2154584 4.995104-3.2191312 7.499695-.6841703.855213-1.4150272 1.6469745-2.1462904 2.3579249-.2565482.2494218-.495398.4714297-.7107501.6637084-.1317615.1176442-.2282471.200729-.2836439.246893h-1.2803688c-.0553968-.046164-.1518824-.1292488-.2836439-.246893-.2153521-.1922787-.4542019-.4142866-.7107501-.6637084-.73126325-.7109504-1.46212005-1.5027119-2.14629041-2.3579249-2.00367281-2.504591-3.21913119-5.0367959-3.21913119-7.499695 0-3.86599325 3.13400675-7 7-7 3.8659932 0 7 3.13400675 7 7zm-6.7595784 8.4236301c.6749868-.6562371 1.3503799-1.3879131 1.9787096-2.1733251 1.7463272-2.182909 2.7808688-4.3382041 2.7808688-6.250305 0-2.76142375-2.2385763-5-5-5-2.76142375 0-5 2.23857625-5 5 0 1.9121009 1.03454162 4.067396 2.78086881 6.250305.62832969.785412 1.30372279 1.517088 1.97870959 2.1733251.0823573.0800696.1625821.156927.2404216.2304624.0778395-.0735354.1580643-.1503928.2404216-.2304624zm-.2404216-6.4236301c-1.1045695 0-2-.8954305-2-2s.8954305-2 2-2 2 .8954305 2 2-.8954305 2-2 2z"/></svg>';

// src/~assets/svg/icons/play.svg
var play_default = '<svg enable-background="new 0 0 24 24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m6.5 20.7-1.5-.8v-15.8l1.5-.9 13 7.9v1.7zm.5-14.8v12.2l10.1-6.1z"/></svg>';

// src/~assets/svg/icons/play-next.svg
var play_next_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="M5 6.13V17.882l1.547.837 9-5.879v-1.675l-9-5.871zm2 1.847v8.056l6.17-4.031zm12-1.98h-2v12h2z" fill-rule="evenodd"/></svg>';

// src/~assets/svg/icons/plus.svg
var plus_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g transform="translate(3 3)"><path d="m0 10h18v-2h-18z"/><path d="m10 18v-18h-2v18z"/></g></svg>';

// src/~assets/svg/icons/profile.svg
var profile_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m11.8426304 12.0541524c-.2088622.0785363-.3641928.137639-.5173138.1971644-.3911991.1520775-.7201036.289014-1.0311542.43178-2.62884546 1.2065868-4.03815199 2.9536545-4.26232941 6.3169032h11.93633401c-.2241774-3.3632487-1.6334839-5.1103164-4.2623294-6.3169032-.3110506-.142766-.6399551-.2797025-1.0311542-.43178-.153121-.0595254-.3084516-.1186281-.5173138-.1971644-.0578382-.0216986-.1094991-.0410818-.1561957-.058609-.0490444.0175272-.1007053.0369104-.1585435.058609zm-2.59692343-1.4350744c-1.18567991-.92304552-1.91311535-2.31466115-1.99570697-3.869078 0-2.62335256 2.12664744-4.75 4.75-4.75 2.6233526 0 4.75 2.12664744 4.7485412 4.80399446-.0811328 1.50042239-.8085683 2.89203802-1.9407303 3.77033644-.1045113.0937672-.2122921.1810479-.3267467.2641224.0197297.0089587.0394114.0179437.0590537.0269591 3.5537746 1.6311107 5.4598821 4.2804057 5.4598821 9.1345876v1h-16v-1c0-4.8541819 1.90610749-7.5034769 5.45988209-9.1345876.0187651-.0086128.03756616-.0171978.0564106-.0257587-.09589725-.0705038-.18534551-.1435432-.27058572-.2205757zm4.28000003-1.57815599c.7287705-.56734397 1.175884-1.42269153 1.224293-2.29092201 0-1.51878306-1.2312169-2.75-2.75-2.75s-2.75 1.23121694-2.75145876 2.69600554c.04986778.92222494.49698128 1.7775725 1.27926966 2.38966352.2701508.24237827.6872362.45902188 1.4721328.76887457.7857495-.31049568 1.2086784-.53199964 1.5257633-.81362162z"/></svg>';

// src/~assets/svg/icons/question-mark.svg
var question_mark_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M17 8C17 10.419 15.2822 12.4367 13 12.9V16H11V11H12C13.6569 11 15 9.65685 15 8C15 6.34315 13.6569 5 12 5C10.3431 5 9 6.34315 9 8H7C7 5.23858 9.23858 3 12 3C14.7614 3 17 5.23858 17 8ZM12 20.5C12.8284 20.5 13.5 19.8284 13.5 19C13.5 18.1716 12.8284 17.5 12 17.5C11.1716 17.5 10.5 18.1716 10.5 19C10.5 19.8284 11.1716 20.5 12 20.5Z"/>\n</svg>\n';

// src/~assets/svg/icons/refresh.svg
var refresh_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m22 9v-8h-2v4.99993c-1.1396-1.51942-2.6957-2.69209-4.4945-3.36537-2.2864-.85579-4.8068-.84565-7.08624.02851-2.27941.87417-4.16032 2.55197-5.28815 4.71713-1.12782 2.16515-1.42466 4.6681-.83456 7.037.59011 2.3689 2.02639 4.4401 4.03811 5.8232s4.45984 1.9825 6.88304 1.6852c2.4231-.2973 4.6538-1.4707 6.2715-3.299 1.6178-1.8283 2.5108-4.1853 2.5108-6.6266h-2c0 1.953-.7144 3.8386-2.0086 5.3013-1.2942 1.4626-3.0788 2.4014-5.0173 2.6392s-3.897-.2417-5.50637-1.3482-2.7584-2.7634-3.23049-4.6585c-.47208-1.8952-.23461-3.8975.66765-5.62964.90227-1.73213 2.40699-3.07437 4.23052-3.7737 1.82349-.69933 3.83989-.70745 5.66899-.02281 1.3591.50871 2.5451 1.37378 3.4406 2.49235h-4.245v2z" fill-rule="evenodd"/></svg>';

// src/~assets/svg/icons/reset.svg
var reset_default = '<svg viewBox="0 0 24 25"  xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 9.5V1.5H4V6.49993C5.13959 4.98051 6.69571 3.80784 8.49448 3.13456C10.7809 2.27877 13.3013 2.28891 15.5807 3.16307C17.8602 4.03724 19.7411 5.71504 20.8689 7.8802C21.9967 10.0454 22.2936 12.5483 21.7034 14.9172C21.1133 17.2861 19.6771 19.3573 17.6653 20.7404C15.6536 22.1235 13.2055 22.7229 10.7823 22.4256C8.3592 22.1283 6.12852 20.9549 4.51077 19.1266C2.89303 17.2983 1.99998 14.9413 1.99998 12.5H3.99998C3.99998 14.453 4.71442 16.3386 6.00862 17.8013C7.30281 19.2639 9.08736 20.2027 11.0259 20.4405C12.9644 20.6783 14.9229 20.1988 16.5323 19.0923C18.1416 17.9858 19.2907 16.3289 19.7628 14.4338C20.2348 12.5386 19.9974 10.5363 19.0951 8.80416C18.1928 7.07203 16.6881 5.72979 14.8646 5.03046C13.0411 4.33113 11.0247 4.32301 9.19558 5.00765C7.83649 5.51636 6.65055 6.38143 5.75496 7.5H10V9.5H2Z" /></svg>\n';

// src/~assets/svg/icons/sad-mood.svg
var sad_mood_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m12 15c2.7574722 0 5.3498149.3456457 7.7747211 1.0384761l.961524.2747211-.5494423 1.9230479-.9615239-.2747212c-2.2417604-.6405029-4.6494177-.9615239-7.2252789-.9615239-2.57586116 0-4.98351847.321021-7.22527887.9615239l-.96152395.2747212-.54944226-1.9230479.96152395-.2747211c2.42490626-.6928304 5.01724895-1.0384761 7.77472113-1.0384761zm-1.5721929-8.84623685c.5002963 1.86713136-.60774241 3.78631071-2.47487377 4.28660705-1.86713136.5002963-3.78631071-.60774238-4.28660705-2.47487374l1.93185165-.51763809c.21441272.80019916 1.03691815 1.27507289 1.83711731 1.06066017.80019915-.21441271 1.27507289-1.03691815 1.06066017-1.8371173zm3.1443858 0 1.9318517.51763809c-.2144127.80019915.260461 1.62270459 1.0606602 1.8371173.8001991.21441272 1.6227046-.26046101 1.8371173-1.06066017l1.9318516.51763809c-.5002963 1.86713136-2.4194757 2.97517004-4.286607 2.47487374-1.8671314-.50029634-2.9751701-2.41947569-2.4748738-4.28660705z"/></svg>';

// src/~assets/svg/icons/search.svg
var search_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill-rule="nonzero"><path d="m10.0021356 16c3.3137085 0 6-2.6862915 6-6s-2.6862915-6-6-6c-3.31370848 0-5.99999998 2.6862915-5.99999998 6s2.6862915 6 5.99999998 6zm0-2c-2.20913898 0-3.99999998-1.790861-3.99999998-4s1.790861-4 3.99999998-4c2.209139 0 4 1.790861 4 4s-1.790861 4-4 4z"/><path d="m12.833 14.247 6.36 6.36 1.414-1.414-6.36-6.36z"/></g></svg>';

// src/~assets/svg/icons/series.svg
var series_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m9.17071 6h-6.17071-1v1 11 1h1 18 1v-1-11-1h-1-6.1707c-.0355-.10039-.0762-.19832-.1217-.29348l3.9995-3.99946-1.4143-1.414213-3.9994 3.999493c-.3917-.1874-.8303-.29234-1.2934-.29234s-.9018.10495-1.2934.29237l-3.99954-3.999523-1.41421 1.414213 3.99952 3.99952c-.04553.09514-.08619.19306-.12166.29342zm-.17071 2h-5v9h12v-9h-1zm9 0v2h2v-2zm0 4v5h2v-5z" fill-rule="evenodd"/></svg>';

// src/~assets/svg/icons/settings.svg
var settings_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m14.4004425 17.5005542-.3999261 2.9994458h-4.0010328l-.3999261-2.9994458c-.41365668-.1807742-.80299149-.4068427-1.16173508-.6719362l-2.79878015 1.15388-2.0005164-3.464996 2.39854407-1.8467704c-.02449345-.2202001-.03706994-.4439972-.03706994-.6707316s.01257649-.4505315.03706994-.6707316l-2.39854407-1.84677038 2.0005164-3.46499604 2.79878015 1.15388006c.35876652-.26511049.74812817-.49119099 1.1618144-.67197092l.39981637-2.99941112h4.00106321l.3999261 2.99944578c.4136834.18078586.8030419.40687196 1.1618047.6719877l2.7986953-1.15395784 2.0005468 3.46502238-2.3985589 1.84677328c.0244932.2201992.0370696.4439952.0370696.6707287 0 .226764-.0125798.4505898-.0370795.6708177l2.3985688 1.8466579-2.0005316 3.4650224-2.7987801-1.15388c-.3587436.2650935-.7480784.491162-1.1617351.6719362zm-2.4004425-2.5005542c1.6568542 0 3-1.3431458 3-3s-1.3431458-3-3-3-3 1.3431458-3 3 1.3431458 3 3 3z"/></svg>';

// src/~assets/svg/icons/share-android.svg
var share_android_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m15 7c0-1.65685 1.3431-3 3-3s3 1.34315 3 3-1.3431 3-3 3c-.8313 0-1.5837-.33814-2.127-.88437l-6.88795 2.58297c.00989.0991.01495.1997.01495.3014s-.00506.2023-.01495.3014l6.88795 2.583c.5433-.5463 1.2957-.8844 2.127-.8844 1.6569 0 3 1.3431 3 3s-1.3431 3-3 3-3-1.3431-3-3c0-.1017.0051-.2023.015-.3014l-6.888-2.583c-.54334.5463-1.29568.8844-2.127.8844-1.65685 0-3-1.3431-3-3s1.34315-3 3-3c.83132 0 1.58366.33814 2.127.88437l6.888-2.58298c-.0099-.09912-.015-.19966-.015-.30139zm3-1c-.5523 0-1 .44772-1 1s.4477 1 1 1 1-.44772 1-1-.4477-1-1-1zm-13 6c0-.5523.44772-1 1-1s1 .4477 1 1-.44772 1-1 1-1-.4477-1-1zm12 5c0-.5523.4477-1 1-1s1 .4477 1 1-.4477 1-1 1-1-.4477-1-1z" fill-rule="evenodd"/></svg>';

// src/~assets/svg/icons/share-ios.svg
var share_ios_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m12 .585815 4.4142 4.414215-1.4142 1.41421-2-2v3.58579h6v13.99997h-14v-13.99997h6v-3.58579l-2 2-1.41421-1.41421zm-1 9.414185h-4v10h10v-10h-4v6h-2z" fill-rule="evenodd"/></svg>';

// src/~assets/svg/icons/shield.svg
var shield_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m6 6.48333v8.25347c0 .8264.39213 1.6933 1.4168 2.6101.98311.8796 2.49088 1.7479 4.5832 2.5796 2.0923-.8317 3.6001-1.7 4.5832-2.5796 1.0247-.9168 1.4168-1.7837 1.4168-2.6101v-8.25347c-2.7837-1.02066-4.7601-1.48333-6-1.48333s-3.21627.46267-6 1.48333zm-1.35555-1.62852c3.14673-1.19701 5.62795-1.85481 7.35555-1.85481s4.2088.6578 7.3555 1.85481l.6445.24516v9.63683c0 1.5596-.7745 2.9296-2.0832 4.1005-1.295 1.1587-3.1715 2.181-5.5588 3.0964l-.358.1373-.358-.1373c-2.38734-.9154-4.26378-1.9377-5.55879-3.0964-1.30867-1.1709-2.08321-2.5409-2.08321-4.1005v-9.63683z" fill-rule="evenodd"/></svg>';

// src/~assets/svg/icons/skip-backward.svg
var skip_backward_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m10 8.19569862-8.45313421 5.52152168-1.54686579-.8372203v-11.75l1.54637907-.83753801 8.45362093 5.51483218v-4.67729417l1.5463791-.83753801 9 5.87126985.0004867 1.67475829-9 5.87873017-1.5468658-.8372203zm2-5.21935964v8.05604002l6.1705838-4.03057749zm-10 0v8.05604002l6.17058383-4.03057749z" transform="matrix(-1 0 0 1 22 5)"/></svg>';

// src/~assets/svg/icons/skip-backward-15.svg
var skip_backward_15_default = '<svg viewBox="0 0 24 26" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m13.879 2.20718-1.7932 1.79325c1.5125.013 3.0148.3691 4.3888 1.05661 2.2013 1.1014 3.919 2.97597 4.8244 5.26486.9054 2.2889.9347 4.8313.0825 7.1405s-2.5262 4.223-4.7014 5.3749c-2.1753 1.152-4.6989 1.4612-7.08797.8685-2.38902-.5926-4.47552-2.0456-5.86008-4.0807s-1.9699-4.5094-1.64397-6.9492c.32594-2.4398 1.54025-4.6736 3.41047-6.27391l1.3003 1.51962c-1.49618 1.28024-2.46763 3.06729-2.72838 5.01909-.26075 1.9519.20753 3.9313 1.31517 5.5594 1.10765 1.6281 2.77686 2.7904 4.68806 3.2646 1.9112.4741 3.9302.2268 5.6704-.6948s3.0793-2.4526 3.7611-4.3c.6818-1.8473.6583-3.8812-.066-5.7124-.7243-1.83107-2.0985-3.33073-3.8595-4.21185-1.1155-.55813-2.3365-.84324-3.5646-.84557l1.8639 1.86396-1.4142 1.41421-4.24265-4.24264 4.24265-4.242641zm-5.12119 15.79282h1.41109v-7.1191h-.1513l-2.94436 1.0546v1.1475l1.68457-.5225zm3.34569-7.1094-.4101 3.6133 1.123.2783.1367-.1269c.2084-.1758.4802-.2637.8155-.2637.3645 0 .6461.1074.8447.3223.1985.2148.2978.5241.2978.9277 0 .4199-.0862.7454-.2588.9766-.1725.2278-.4183.3418-.7373.3418-.2864 0-.5192-.0814-.6982-.2442-.1758-.166-.2783-.3971-.3076-.6933h-1.3965c.013.4036.1253.7633.3369 1.0791.2149.3157.5062.5615.874.7373.3679.1725.7666.2588 1.1963.2588.4916 0 .918-.0993 1.2793-.2979.3613-.2018.638-.4834.8301-.8447.1953-.3646.293-.7764.293-1.2354 0-.7552-.1921-1.3427-.5762-1.7627-.3841-.4199-.9147-.6299-1.5918-.6299-.3776 0-.7341.0896-1.0693.2686l.1757-1.5283h2.8272v-1.1768z" fill-rule="evenodd"/></svg>';

// src/~assets/svg/icons/skip-backward-30.svg
var skip_backward_30_default = '<svg viewBox="0 0 24 26" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m13.879 2.20718-1.7932 1.79325c1.5125.013 3.0148.3691 4.3888 1.05661 2.2013 1.1014 3.919 2.97597 4.8244 5.26486.9054 2.2889.9347 4.8313.0825 7.1405s-2.5262 4.223-4.7014 5.3749c-2.1753 1.152-4.6989 1.4612-7.08796.8685-2.38903-.5926-4.47553-2.0456-5.86009-4.0807s-1.9699-4.5094-1.64396-6.9492c.32593-2.4398 1.54024-4.6736 3.41046-6.27391l1.3003 1.51962c-1.49618 1.28024-2.46763 3.06729-2.72838 5.01909-.26075 1.9519.20753 3.9313 1.31517 5.5594 1.10765 1.6281 2.77686 2.7904 4.68806 3.2646 1.9112.4741 3.9302.2268 5.6704-.6948s3.0793-2.4526 3.7611-4.3c.6818-1.8473.6583-3.8812-.066-5.7124-.7243-1.83107-2.0985-3.33073-3.8595-4.21185-1.1155-.55813-2.3365-.84324-3.5646-.84557l1.8639 1.86396-1.4142 1.41421-4.24265-4.24264 4.24265-4.242641zm-4.95026 11.61312h-.75196v1.1035h.74707c.78125 0 1.17185.3548 1.17185 1.0645 0 .2929-.096.529-.28806.708-.1888.1758-.45084.2637-.78613.2637-.29297 0-.54036-.0847-.74219-.2539-.19856-.1693-.29785-.3874-.29785-.6543h-1.41113c0 .6152.22461 1.11.67383 1.4843.45247.3744 1.03353.5616 1.74316.5616.75846 0 1.36717-.1905 1.82617-.5713.4622-.3809.6934-.8871.6934-1.5186 0-.3906-.0993-.7292-.2979-1.0156-.1953-.2865-.4932-.5013-.8935-.6445.3222-.1465.5826-.3565.7812-.6299.1986-.2735.2979-.5729.2979-.8985 0-.6315-.2133-1.1263-.6397-1.4843-.4264-.3614-1.01562-.542-1.76757-.542-.43294 0-.83008.083-1.19141.249-.35807.166-.63802.3971-.83984.6934-.19857.2929-.29785.625-.29785.996h1.41113c0-.2376.09115-.4296.27344-.5761.18229-.1498.40853-.2246.67871-.2246.29948 0 .53385.0797.70313.2392.17252.1595.25878.3825.25878.669 0 .2962-.08626.5338-.25878.7129-.17253.179-.43783.2685-.7959.2685zm7.72946 3.4961c.4069-.5208.6104-1.2728.6104-2.2559v-1.3085c-.0098-.9538-.2197-1.6846-.6299-2.1924-.4102-.5111-1.0026-.7666-1.7773-.7666-.7748 0-1.3689.2571-1.7823.7715-.4101.5143-.6152 1.2679-.6152 2.2607v1.3086c.0098.9538.2197 1.6862.6299 2.1973.4101.511 1.0026.7666 1.7773.7666.7845 0 1.3802-.2605 1.7871-.7813zm-1.0449-4.9756c.1628.2669.2441.695.2441 1.2842v1.6895c-.0065.5566-.0862.97-.2392 1.2402s-.402.4053-.7471.4053c-.3483 0-.6022-.14-.7617-.42-.1562-.2832-.2344-.7145-.2344-1.2939v-1.7285c.0098-.5436.0928-.9424.2491-1.1963.1595-.2572.4052-.3858.7373-.3858.3418 0 .5924.1351.7519.4053z" fill-rule="evenodd"/></svg>';

// src/~assets/svg/icons/skip-forward.svg
var skip_forward_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m10 8.19569862-8.45313421 5.52152168-1.54686579-.8372203v-11.75l1.54637907-.83753801 8.45362093 5.51483218v-4.67729417l1.5463791-.83753801 9 5.87126985.0004867 1.67475829-9 5.87873017-1.5468658-.8372203zm2-5.21935964v8.05604002l6.1705838-4.03057749zm-10 0v8.05604002l6.17058383-4.03057749z" transform="translate(2 5)"/></svg>';

// src/~assets/svg/icons/skip-forward-15.svg
var skip_forward_15_default = '<svg viewBox="0 0 24 26" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m10.121 2.20718 1.7933 1.79325c-1.5126.013-3.01483.3691-4.38891 1.05661-2.20128 1.1014-3.91901 2.97597-4.82437 5.26486-.90536 2.2889-.93474 4.8313-.08251 7.1405s2.52619 4.223 4.70143 5.3749c2.17524 1.152 4.69896 1.4612 7.08796.8685 2.389-.5926 4.4755-2.0456 5.8601-4.0807 1.3845-2.0351 1.9699-4.5094 1.6439-6.9492-.3259-2.4398-1.5402-4.6736-3.4104-6.27391l-1.3003 1.51962c1.4962 1.28024 2.4676 3.06729 2.7284 5.01909.2607 1.9519-.2076 3.9313-1.3152 5.5594-1.1077 1.6281-2.7769 2.7904-4.6881 3.2646-1.9112.4741-3.93016.2268-5.67035-.6948s-3.07936-2.4526-3.76114-4.3c-.68179-1.8473-.65828-3.8812.066-5.7124.72429-1.83107 2.09848-3.33073 3.8595-4.21185 1.11548-.55813 2.33649-.84324 3.56469-.84557l-1.864 1.86396 1.4142 1.41421 4.2427-4.24264-4.2427-4.242641zm-1.36319 15.79282h1.41109v-7.1191h-.1513l-2.94436 1.0546v1.1475l1.68457-.5225zm3.34569-7.1094-.4101 3.6133 1.123.2783.1367-.1269c.2084-.1758.4802-.2637.8155-.2637.3645 0 .6461.1074.8447.3223.1985.2148.2978.5241.2978.9277 0 .4199-.0862.7454-.2588.9766-.1725.2278-.4183.3418-.7373.3418-.2864 0-.5192-.0814-.6982-.2442-.1758-.166-.2783-.3971-.3076-.6933h-1.3965c.013.4036.1253.7633.3369 1.0791.2149.3157.5062.5615.874.7373.3679.1725.7666.2588 1.1963.2588.4916 0 .918-.0993 1.2793-.2979.3613-.2018.638-.4834.8301-.8447.1953-.3646.293-.7764.293-1.2354 0-.7552-.1921-1.3427-.5762-1.7627-.3841-.4199-.9147-.6299-1.5918-.6299-.3776 0-.7341.0896-1.0693.2686l.1757-1.5283h2.8272v-1.1768z" fill-rule="evenodd"/></svg>';

// src/~assets/svg/icons/skip-forward-30.svg
var skip_forward_30_default = '<svg viewBox="0 0 24 26" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m10.121 2.20718 1.7933 1.79325c-1.5126.013-3.01483.3691-4.38891 1.05661-2.20128 1.1014-3.91901 2.97597-4.82437 5.26486-.90536 2.2889-.93474 4.8313-.08251 7.1405s2.52619 4.223 4.70143 5.3749c2.17524 1.152 4.69896 1.4612 7.08796.8685 2.389-.5926 4.4755-2.0456 5.8601-4.0807 1.3845-2.0351 1.9699-4.5094 1.6439-6.9492-.3259-2.4398-1.5402-4.6736-3.4104-6.27391l-1.3003 1.51962c1.4962 1.28024 2.4676 3.06729 2.7284 5.01909.2607 1.9519-.2076 3.9313-1.3152 5.5594-1.1077 1.6281-2.7769 2.7904-4.6881 3.2646-1.9112.4741-3.93016.2268-5.67035-.6948s-3.07936-2.4526-3.76114-4.3c-.68179-1.8473-.65828-3.8812.066-5.7124.72429-1.83107 2.09848-3.33073 3.8595-4.21185 1.11548-.55813 2.33649-.84324 3.56469-.84557l-1.864 1.86396 1.4142 1.41421 4.2427-4.24264-4.2427-4.242641zm-1.19229 11.61312h-.75195v1.1035h.74707c.78125 0 1.17187.3548 1.17187 1.0645 0 .2929-.09603.529-.28808.708-.18881.1758-.45085.2637-.78614.2637-.29296 0-.54036-.0847-.74218-.2539-.19857-.1693-.29785-.3874-.29785-.6543h-1.41114c0 .6152.22461 1.11.67383 1.4843.45247.3744 1.03353.5616 1.74316.5616.75847 0 1.3672-.1905 1.8262-.5713.4622-.3809.6933-.8871.6933-1.5186 0-.3906-.0992-.7292-.2978-1.0156-.1953-.2865-.4932-.5013-.8936-.6445.3223-.1465.5827-.3565.7813-.6299.1985-.2735.2978-.5729.2978-.8985 0-.6315-.2132-1.1263-.6396-1.4843-.4264-.3614-1.01564-.542-1.7676-.542-.43294 0-.83007.083-1.1914.249-.35807.166-.63802.3971-.83985.6934-.19856.2929-.29785.625-.29785.996h1.41114c0-.2376.09114-.4296.27343-.5761.18229-.1498.40853-.2246.67871-.2246.29948 0 .53386.0797.70313.2392.17253.1595.25879.3825.25879.669 0 .2962-.08626.5338-.25879.7129-.17253.179-.43783.2685-.7959.2685zm7.72949 3.4961c.4069-.5208.6104-1.2728.6104-2.2559v-1.3085c-.0098-.9538-.2198-1.6846-.6299-2.1924-.4102-.5111-1.0026-.7666-1.7774-.7666-.7747 0-1.3688.2571-1.7822.7715-.4102.5143-.6152 1.2679-.6152 2.2607v1.3086c.0097.9538.2197 1.6862.6299 2.1973.4101.511 1.0026.7666 1.7773.7666.7845 0 1.3802-.2605 1.7871-.7813zm-1.0449-4.9756c.1627.2669.2441.695.2441 1.2842v1.6895c-.0065.5566-.0862.97-.2392 1.2402s-.4021.4053-.7471.4053c-.3483 0-.6022-.14-.7617-.42-.1563-.2832-.2344-.7145-.2344-1.2939v-1.7285c.0098-.5436.0928-.9424.249-1.1963.1595-.2572.4053-.3858.7373-.3858.3418 0 .5925.1351.752.4053z" fill-rule="evenodd"/></svg>';

// src/~assets/svg/icons/social-apple.svg
var social_apple_default = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M14.7 3.4c-.6.8-1.6 1.4-2.5 1.4H12v-.4c0-1 .4-2 1-2.5A4 4 0 0 1 15.6.4v.4c0 1-.4 2-1 2.6Zm-4 15.7c-.5.1-.9.3-1.4.3-1.2 0-2-1-2.9-2.4-1-1.6-1.9-4-1.9-6.3C4.5 7 6.8 5 9.1 5c.7 0 1.3.3 1.9.5.4.2.8.4 1.1.4.3 0 .7-.2 1.1-.4.6-.2 1.4-.5 2.2-.5.5 0 2.4 0 3.6 1.9-.3.2-2 1.3-2 3.6 0 2.8 2.4 3.8 2.5 3.8 0 .3-.5 1.5-1.3 2.7-.8 1.2-1.6 2.4-2.8 2.4-.6 0-1-.2-1.4-.4-.5-.2-.9-.4-1.6-.4-.8 0-1.3.2-1.8.5Z" clip-rule="evenodd"/></svg>';

// src/~assets/svg/icons/social-facebook.svg
var social_facebook_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">\n<path clip-rule="evenodd" d="M16 5.988L14.3688 5.98913C13.0895 5.98913 12.8415 6.62025 12.8415 7.54612V9.58913H15.8928L15.4952 12.7898H12.8415V21H9.66025V12.7898H7V9.58913H9.66025V7.23C9.66025 4.49062 11.2709 3 13.6225 3C14.7489 3 15.7173 3.08663 16 3.126V5.988Z"/>\n</svg>\n';

// src/~assets/svg/icons/social-google.svg
var social_google_default = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="#EA4335" d="M12.5 6.56a4.9 4.9 0 0 1 3.45 1.35l2.57-2.57A9 9 0 0 0 4.46 7.95l3 2.33a5.37 5.37 0 0 1 5.04-3.72Z"/><path fill="#4285F4" d="M21.12 12.2c0-.58-.06-1.15-.14-1.7H12.5v3.38h4.85a4.18 4.18 0 0 1-1.79 2.7l2.9 2.25a8.82 8.82 0 0 0 2.66-6.62Z"/><path fill="#FBBC05" d="M7.45 13.72a5.47 5.47 0 0 1 0-3.44l-3-2.32a8.97 8.97 0 0 0 .01 8.08l2.99-2.32Z"/><path fill="#34A853" d="M12.5 21c2.43 0 4.47-.8 5.96-2.18l-2.9-2.25c-.8.54-1.84.86-3.06.86a5.38 5.38 0 0 1-5.05-3.71l-3 2.32A9 9 0 0 0 12.5 21Z"/></svg>';

// src/~assets/svg/icons/star.svg
var star_default = '<svg enable-background="new 0 0 24 24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m17.3 21.9-5.3-3.7-5.3 3.7-1.5-1.1 1.8-6.2-5.2-3.9.6-1.8 6.5-.1 2.1-6.1h1.9l2.1 6.1 6.5.1.6 1.8-5.1 3.9 1.9 6.2zm-5.9-5.8h1.1l3.5 2.5-1.2-4.1.4-1.1 3.4-2.6-4.3-.1-.9-.7-1.4-4-1.4 4-.9.7-4.3.1 3.4 2.6.4 1.1-1.2 4.1z"/></svg>';

// src/~assets/svg/icons/subtitles.svg
var subtitles_default = '<svg enable-background="new 0 0 24 24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m22 19h-20v-15h20zm-18-2h16v-11h-16z"/><circle cx="16.5" cy="13.5" r="1.5"/><circle cx="12" cy="13.5" r="1.5"/><circle cx="7.5" cy="13.5" r="1.5"/><path d="m15 18 6 2.5v-2.5z"/><path d="m22 22-12-5h12z"/></svg>';

// src/~assets/svg/icons/trash.svg
var trash_default = '<svg enable-background="new 0 0 24 24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m9.27924 2h.72076 4 .7208l.2279.68377.7721 2.31623h2.2792 2v2h-1.0644l-.9378 14.0665-.0622.9335h-.9356-10-.93555l-.06224-.9335-.93776-14.0665h-1.06445v-2h2 2.27924l.77208-2.31623zm1.10816 3h3.2252l-.3334-1h-2.5584zm-3.31851 2 .86666 13h8.12885l.8667-13h-1.9311-6z"/></svg>';

// src/~assets/svg/icons/trending.svg
var trending_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m5.19918574 16.2150278c1.41121385 2.2721249 3.92934185 3.7849722 6.80081426 3.7849722 4.418278 0 8-3.581722 8-8s-3.581722-8-8-8-8 3.581722-8 8c0 .785454.11319501 1.5444698.32416193 2.2616245l2.96873129-2.9687313 1.53915707.1524066 1.32337451 1.9850618 3.4303616-3.4303616h-2.5857864v-2h6v6h-2v-2.5857864l-4.2928932 4.2928932-1.53915709-.1524066-1.32337454-1.9850618zm6.80081426 5.7849722c-5.5228475 0-10-4.4771525-10-10s4.4771525-10 10-10 10 4.4771525 10 10-4.4771525 10-10 10z"/></svg>';

// src/~assets/svg/icons/twitter.svg
var twitter_default = '<svg  viewBox="0 0 24 25"  xmlns="http://www.w3.org/2000/svg"><g><path d="M18.8996 1.33301H22.5815L14.5398 10.5221L24 23.0279H16.5945L10.7901 15.4451L4.15645 23.0279H0.469361L9.0691 13.1974L0 1.33301H7.59322L12.8344 8.26391L18.8996 1.33301ZM17.6063 20.8271H19.6454L6.4824 3.41906H4.29205L17.6063 20.8271Z" /></g><defs><clipPath id="clip0_6650_84894"><rect transform="translate(0 0.333008)"/></clipPath></defs></svg>\n';

// src/~assets/svg/icons/unpin.svg
var unpin_default = '<svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M5.99023 9.64758L8.81866 6.81915L17 15.0005L21 19.0005L31.5941 29.5946L40.8138 38.8143L37.9854 41.6427L5.99023 9.64758Z" /><path fill-rule="evenodd" clip-rule="evenodd" d="M17 15.0005V21.9374C12.9761 24.9437 12 29.7979 12 32.0011V34.0011H22V45.0011H26V34.0011H36L31.5941 29.5946C31.6363 29.7322 31.6748 29.8678 31.7097 30.0011H16.2903C16.755 28.2284 17.8449 26.0266 20.029 24.7161L21 24.1335V19.0005L17 15.0005ZM15 7.34363L21 13.3436V10.0011H27V19.3436L35.0625 27.4062C34.3222 25.5015 33.0608 23.4771 31 21.9374V13.1616C31.072 13.0948 31.1365 13.0297 31.1934 12.969C31.6201 12.5139 31.9452 11.9634 32.1859 11.45C32.6621 10.434 33 9.14484 33 8.00109V6.00109H15V7.34363Z" /></svg>\n';

// src/~assets/svg/icons/visibility.svg
var visibility_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill-rule="evenodd"><path d="m2.08807849 12.4103647v-.8207294c1.95928039-4.3539564 5.31279875-6.5896353 9.91192151-6.5896353 4.5991228 0 7.9526411 2.2356789 9.9119215 6.5896353v.8207294c-1.9592804 4.3539564-5.3127987 6.5896353-9.9119215 6.5896353-4.59912276 0-7.95264112-2.2356789-9.91192151-6.5896353zm9.91192151 4.5896353c3.6554091 0 6.2430943-1.6318563 7.8952684-5-1.6521741-3.36814368-4.2398593-5-7.8952684-5-3.65540909 0-6.24309432 1.63185632-7.89526842 5 1.6521741 3.3681437 4.23985933 5 7.89526842 5z"/><path d="m12 16c2.209139 0 4-1.790861 4-4s-1.790861-4-4-4-4 1.790861-4 4 1.790861 4 4 4zm0-2c-1.1045695 0-2-.8954305-2-2s.8954305-2 2-2 2 .8954305 2 2-.8954305 2-2 2z"/></g></svg>';

// src/~assets/svg/icons/visibility-off.svg
var visibility_off_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill-rule="evenodd"><path d="m7.06279132 6.07835181 1.51453058 1.51453058c-1.91468634.7474524-3.39326282 2.20678649-4.47259032 4.40711761 1.6521741 3.3681437 4.23985933 5 7.89526842 5 1.8415494 0 3.4121085-.4141681 4.7285823-1.2558572l1.4405574 1.4405574c-1.7019907 1.204613-3.7654437 1.8152998-6.1691397 1.8152998-4.59912276 0-7.95264112-2.2356789-9.91192151-6.5896353v-.8207294c1.17088081-2.60195732 2.83969253-4.44740401 4.97471283-5.51128349zm2.07554956-.75287757c.89214072-.21656205 1.84655982-.32547424 2.86165912-.32547424 4.5991228 0 7.9526411 2.2356789 9.9119215 6.5896353v.8207294c-.6111861 1.3581914-1.3580445 2.510255-2.2360631 3.452627l-1.4144923-1.4144922c.621844-.6781817 1.1654737-1.4935549 1.6339023-2.4484995-1.6521741-3.36814368-4.2398593-5-7.8952684-5-.38922 0-.7663347.01850122-1.1315036.05562972zm.56836444 3.39679157 1.45935848 1.45935839c-.6881862.3161317-1.1660638 1.0114466-1.1660638 1.8183758 0 1.1045695.8954305 2 2 2 .8069292 0 1.5022441-.4778776 1.8183758-1.1660638l1.4593584 1.4593585c-.7233883 1.0320014-1.9217685 1.7067053-3.2777342 1.7067053-2.209139 0-4-1.790861-4-4 0-1.3559657.67470389-2.5543459 1.70670532-3.27773419zm2.11027398-.71815317c.0606648-.00273196.1216815-.00411264.1830207-.00411264 2.209139 0 4 1.790861 4 4 0 .0613392-.0013807.1223559-.0041126.1830207z"/><path d="m3 4.816 16 16 1.414-1.414-16-16z"/></g></svg>';

// src/~assets/svg/icons/volume.svg
var volume_default = '<svg enable-background="new 0 0 24 24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m12.3 21.7-6-6-.3-.7v-6l.3-.7 6-6 1.7.7v18zm-4.3-7.1 4 4v-13.2l-4 4z"/><path d="m8 16h-6v-8h6zm-4-2h2v-4h-2z"/><path d="m16 18v-2c2.2 0 4-1.8 4-4s-1.8-4-4-4v-2c3.3 0 6 2.7 6 6s-2.7 6-6 6z"/><path d="m16 10c1.1 0 2 .9 2 2s-.9 2-2 2"/></svg>';

// src/~assets/svg/icons/volume-off.svg
var volume_off_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m13 21-.7071.7071 1.7071-.7071zm0-18h1l-1.7071-.70711zm-10 6v-1h-1v1zm0 6h-1v1h1zm3.29289.7071 6.00001 6 1.4142-1.4142-5.99999-6zm7.70711 5.2929v-18h-2v18zm-1.7071-18.70711-6.00001 6 1.41422 1.41422 5.99999-6zm-6.2929 6.70711v6h2v-6zm-3 1h4v-2h-4zm4 4h-4v2h4zm-3 1v-6h-2v6zm11.2929-5.29289 6 5.99999 1.4142-1.4142-6-6.00001zm1.4142 5.99999 6-5.99999-1.4142-1.41422-6 6.00001z"/></svg>';

// src/~assets/svg/icons/wifi.svg
var wifi_default = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m2.45027 10.3285c5.38071-5.38071 14.10453-5.38071 19.48533 0l.7071.7071-1.4143 1.4142-.7071-.7071c-4.5996-4.59965-12.05715-4.59965-16.65682 0l-.7071.7071-1.41422-1.4142zm3.61426 3.614c3.38464-3.3846 8.87217-3.3846 12.25687 0l.7071.7071-1.4142 1.4143-.7071-.7072c-2.6036-2.6035-6.8249-2.6035-9.42846 0l-.7071.7072-1.41422-1.4143zm8.64267 3.6143c-1.3885-1.3886-3.6399-1.3886-5.02841 0l-.70711.7071 1.41422 1.4142.7071-.7071c.6075-.6075 1.5925-.6075 2.2 0l.7071.7071 1.4142-1.4142z" fill-rule="evenodd"/></svg>';

// src/~assets/svg/icons/youtube.svg
var youtube_default = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M22.9 6.5c-.3-1-1-1.8-2-2C19 4 12 4 12 4s-7.1 0-8.9.5c-1 .2-1.7 1-2 2C.6 8.3.6 12 .6 12s0 3.7.5 5.5c.3 1 1 1.8 2 2C5 20 12 20 12 20s7.1 0 8.9-.5c1-.2 1.7-1 2-2 .5-1.8.5-5.5.5-5.5s0-3.7-.5-5.5ZM9.7 15.4V8.6l6 3.4-6 3.4Z"/></svg>';

// src/~assets/svg/icons/dolby-vision.svg
var dolby_vision_default = '<svg  viewBox="0 0 24 10" xmlns="http://www.w3.org/2000/svg">\n<path d="M23.2286 1.43133L22.3085 3.50015L21.3883 1.43133H20.6167L21.9227 4.36662L21.8965 4.42334L21.8869 4.44387L21.6044 5.08261C21.6038 5.0841 21.6031 5.08579 21.6025 5.08748C21.5178 5.27712 21.2946 5.36325 21.1051 5.27881L21.0038 5.23352L20.8063 5.6767L20.7187 5.87332L20.7199 5.87374L20.9646 5.98316C21.4237 6.18782 21.9655 5.97956 22.1708 5.51924C22.1725 5.51543 23.8432 1.78224 24 1.43133H23.2286ZM19.9999 3.03898C19.9999 2.50458 19.5606 2.06563 19.0264 2.06563C18.5986 2.06563 18.2325 2.34352 18.1034 2.73167C18.0712 2.82818 18.053 2.93125 18.053 3.03898C18.053 3.14607 18.0712 3.24893 18.1034 3.34544C18.2316 3.73106 18.5946 4.01233 19.0264 4.01233C19.5606 4.01233 19.9999 3.5791 19.9999 3.03898ZM20.6408 3.04491C20.6408 3.93508 19.9168 4.65933 19.0264 4.65933C18.6833 4.65933 18.3652 4.55139 18.1034 4.3681V4.66017H17.3957V-0.00403589H18.1034V1.7215C18.3652 1.53843 18.6833 1.43028 19.0264 1.43028C19.9168 1.43028 20.6408 2.15452 20.6408 3.04491ZM16.0957 4.66017H16.802V-0.00403589H16.0957V4.66017ZM14.9979 3.03877C14.9979 2.50458 14.5586 2.06521 14.0244 2.06521C13.4902 2.06521 13.051 2.49865 13.051 3.03877C13.051 3.57296 13.4843 4.01212 14.0244 4.01212C14.5586 4.01212 14.9979 3.57888 14.9979 3.03877ZM15.6388 3.0447C15.6388 3.93487 14.9148 4.6589 14.0244 4.6589C13.134 4.6589 12.41 3.93487 12.41 3.0447C12.41 2.15431 13.134 1.43028 14.0244 1.43028C14.9148 1.43028 15.6388 2.15431 15.6388 3.0447ZM11.3452 2.32489C11.3452 1.43049 10.6161 0.701585 9.72186 0.701585H8.74555V3.9482H9.72186C10.6161 3.9482 11.3452 3.21909 11.3452 2.32489ZM12.0514 2.32489C12.0514 3.60936 11.0063 4.65467 9.72186 4.65467H8.0393V-0.00488281H9.72186C11.0063 -0.00488281 12.0514 1.04022 12.0514 2.32489ZM6.62827 -0.00467048H5.94085C4.65744 -0.00467048 3.61128 1.04149 3.61128 2.32489C3.61128 3.6083 4.65744 4.65467 5.94085 4.65467H6.62827V-0.00467048ZM0 4.65467H0.687208C1.97062 4.65467 3.01677 3.6083 3.01677 2.32489C3.01677 1.04149 1.97062 -0.00467048 0.687208 -0.00467048H0V4.65467ZM17.3087 10.0052H17.8837V7.50975H17.8926L19.4255 10.0052H20.1555V6.77513H19.5809V9.19316H19.5716L18.0708 6.77513H17.3087V10.0052ZM13.9084 7.95589C13.9571 7.82489 14.0261 7.71102 14.1152 7.61345C14.2043 7.5161 14.3107 7.43927 14.4345 7.38361C14.5584 7.32816 14.697 7.30022 14.85 7.30022C15.0032 7.30022 15.1425 7.32816 15.2676 7.38361C15.3929 7.43927 15.5002 7.5161 15.5893 7.61345C15.6782 7.71102 15.7472 7.82489 15.7958 7.95589C15.8445 8.08669 15.8689 8.2287 15.8689 8.38172C15.8689 8.54024 15.8445 8.68585 15.7958 8.81813C15.7472 8.9502 15.6775 9.06512 15.5869 9.16247C15.4966 9.26004 15.3888 9.33581 15.2636 9.38999C15.138 9.44438 15.0005 9.47147 14.85 9.47147C14.6997 9.47147 14.5626 9.44438 14.4388 9.38999C14.315 9.33581 14.2077 9.26004 14.1173 9.16247C14.0267 9.06512 13.9571 8.9502 13.9084 8.81813C13.8597 8.68585 13.8354 8.54024 13.8354 8.38172C13.8354 8.2287 13.8597 8.08669 13.9084 7.95589ZM13.324 9.0393C13.4064 9.23761 13.5207 9.40819 13.6669 9.55169C13.8132 9.69476 13.9867 9.8063 14.188 9.88587C14.389 9.96545 14.6083 10.0052 14.8458 10.0052C15.086 10.0052 15.3071 9.96545 15.5099 9.88587C15.7124 9.8063 15.8877 9.69476 16.0352 9.55169C16.1829 9.40819 16.2979 9.23761 16.3804 9.0393C16.4627 8.84099 16.504 8.62172 16.504 8.38151C16.504 8.13558 16.4627 7.91335 16.3804 7.71525C16.2979 7.51694 16.1829 7.34826 16.0352 7.20942C15.8877 7.07037 15.7124 6.96328 15.5099 6.88815C15.3071 6.8128 15.086 6.77513 14.8458 6.77513C14.6083 6.77513 14.389 6.8128 14.188 6.88815C13.9867 6.96328 13.8132 7.07037 13.6669 7.20942C13.5207 7.34826 13.4064 7.51694 13.324 7.71525C13.2415 7.91335 13.2002 8.13558 13.2002 8.38151C13.2002 8.62172 13.2415 8.84099 13.324 9.0393ZM11.8576 10.0052H12.4324V6.77534H11.8576V10.0052ZM10.9843 7.10487C10.8658 6.99524 10.7268 6.91291 10.5665 6.8581C10.4063 6.80328 10.2484 6.77598 10.0925 6.77598C9.95425 6.77598 9.81774 6.79397 9.68356 6.82995C9.54937 6.86593 9.42958 6.92095 9.3244 6.99439C9.219 7.06783 9.13392 7.16117 9.06894 7.27355C9.00418 7.38615 8.97159 7.52033 8.97159 7.6761C8.97159 7.82044 8.99466 7.94087 9.04079 8.03759C9.08714 8.13431 9.14683 8.21558 9.22048 8.28204C9.29413 8.34849 9.3771 8.40183 9.46937 8.44204C9.56165 8.48246 9.65393 8.51717 9.7462 8.54596C9.84166 8.5777 9.93245 8.60818 10.019 8.63696C10.1056 8.66575 10.1805 8.69961 10.2442 8.73855C10.3075 8.77771 10.3581 8.82363 10.3955 8.87718C10.433 8.93051 10.4518 8.9976 10.4518 9.07845C10.4518 9.16205 10.4353 9.23211 10.4021 9.28819C10.3689 9.34449 10.3257 9.39147 10.2721 9.42893C10.2188 9.4664 10.1589 9.49306 10.0925 9.50915C10.0262 9.52481 9.96123 9.53285 9.89795 9.53285C9.77668 9.53285 9.65329 9.50259 9.52779 9.44206C9.40228 9.38131 9.30196 9.2992 9.22704 9.19528L8.83762 9.55867C8.95868 9.70301 9.11445 9.81201 9.30493 9.88566C9.4954 9.95931 9.69012 9.99593 9.88927 9.99593C10.0391 9.99593 10.182 9.97582 10.3176 9.9354C10.4533 9.89497 10.5716 9.83444 10.6726 9.7536C10.7735 9.67275 10.8544 9.57116 10.9149 9.44841C10.9756 9.32586 11.0059 9.18216 11.0059 9.01792C11.0059 8.86765 10.9778 8.74236 10.9215 8.6412C10.8652 8.54024 10.793 8.45664 10.705 8.39019C10.6169 8.32373 10.5204 8.27061 10.415 8.23018C10.3096 8.18976 10.208 8.15357 10.1098 8.12182C10.0235 8.09579 9.94409 8.06997 9.87192 8.04394C9.79975 8.0179 9.73837 7.98764 9.688 7.95314C9.63742 7.91843 9.59763 7.87674 9.56906 7.82764C9.54006 7.77854 9.52567 7.71927 9.52567 7.65007C9.52567 7.57515 9.54218 7.51081 9.57541 7.45747C9.60863 7.40414 9.65118 7.36075 9.70303 7.32773C9.75488 7.29451 9.81266 7.26995 9.87615 7.25408C9.93965 7.23821 10.0031 7.23017 10.0666 7.23017C10.1733 7.23017 10.2793 7.25556 10.3847 7.30615C10.4899 7.35652 10.5716 7.41938 10.6294 7.4943L10.9843 7.10487ZM7.53198 10.0052H8.10681V6.77534H7.53198V10.0052ZM3.84451 6.77513H4.4877L5.37745 9.26152H5.39565L6.29429 6.77513H6.91462L5.61915 10.0052H5.12178L3.84451 6.77513Z" />\n</svg>';

// src/~assets/svg/icons/dolby-atmos.svg
var dolby_atmos_default = '<svg viewBox="0 0 24 10" xmlns="http://www.w3.org/2000/svg">\n<path d="M5.82563 8.77825L5.32826 7.46435L4.822 8.77825H5.82563ZM5.09566 6.78009H5.59303L6.98439 10.01H6.32744L6.02627 9.27096H4.62581L4.33373 10.01H3.69054L5.09566 6.78009Z"/>\n<path d="M7.90002 7.28184H6.91015V6.78003H9.46493V7.28184H8.47485V10.01H7.90002V7.28184Z"/>\n<path d="M10.182 6.78001H11.0806L11.9202 9.07489H11.9338L12.7643 6.78001H13.6674V10.0099H13.0972V7.41431H13.0881L12.1073 10.0099H11.7056L10.7386 7.41431H10.7293V10.0099H10.182V6.78001Z"/>\n<path d="M14.9884 8.38651C14.9884 8.54503 15.0127 8.69065 15.0614 8.82293C15.1101 8.95499 15.1797 9.06992 15.2703 9.16727C15.3607 9.26484 15.4678 9.34061 15.5918 9.39479C15.7156 9.44919 15.8527 9.47628 16.003 9.47628C16.1535 9.47628 16.2911 9.44919 16.4166 9.39479C16.5416 9.34061 16.6496 9.26484 16.74 9.16727C16.8305 9.06992 16.9 8.95499 16.9489 8.82293C16.9975 8.69065 17.0219 8.54503 17.0219 8.38651C17.0219 8.23349 16.9975 8.09148 16.9489 7.96068C16.9 7.82967 16.8312 7.7158 16.7421 7.61823C16.653 7.52088 16.5459 7.44426 16.4206 7.38839C16.2953 7.33294 16.1562 7.305 16.003 7.305C15.85 7.305 15.7114 7.33294 15.5875 7.38839C15.4637 7.44426 15.3573 7.52088 15.2682 7.61823C15.1791 7.7158 15.1101 7.82967 15.0614 7.96068C15.0127 8.09148 14.9884 8.23349 14.9884 8.38651ZM14.3532 8.3863C14.3532 8.14037 14.3945 7.91814 14.477 7.72004C14.5594 7.52172 14.6737 7.35304 14.8199 7.2142C14.9661 7.07515 15.1397 6.96806 15.341 6.89292C15.542 6.81758 15.7613 6.7799 15.9988 6.7799C16.239 6.7799 16.4602 6.81758 16.6629 6.89292C16.8655 6.96806 17.0405 7.07515 17.188 7.2142C17.3357 7.35304 17.4509 7.52172 17.5332 7.72004C17.6158 7.91814 17.657 8.14037 17.657 8.3863C17.657 8.62652 17.6158 8.84578 17.5332 9.0441C17.4509 9.24241 17.3357 9.413 17.188 9.55649C17.0405 9.69957 16.8655 9.8111 16.6629 9.89047C16.4602 9.97026 16.239 10.0101 15.9988 10.0101C15.7613 10.0101 15.542 9.97026 15.341 9.89047C15.1397 9.8111 14.9661 9.69957 14.8199 9.55649C14.6737 9.413 14.5594 9.24241 14.477 9.0441C14.3945 8.84578 14.3532 8.62652 14.3532 8.3863Z"/>\n<path d="M19.933 7.50342C19.8752 7.42849 19.7937 7.36563 19.6883 7.31505C19.5831 7.26468 19.4771 7.23949 19.3702 7.23949C19.3067 7.23949 19.2434 7.24732 19.1799 7.2632C19.1164 7.27907 19.0586 7.30362 19.0068 7.33685C18.9547 7.37008 18.9122 7.41325 18.879 7.46659C18.8459 7.52014 18.8292 7.58427 18.8292 7.65919C18.8292 7.7284 18.8436 7.78766 18.8726 7.83655C18.9014 7.88565 18.941 7.92756 18.9916 7.96227C19.0421 7.99698 19.1035 8.02724 19.1755 8.05306C19.2476 8.07909 19.327 8.10492 19.4136 8.13095C19.5116 8.16269 19.6134 8.19889 19.7188 8.2391C19.824 8.27952 19.9207 8.33307 20.0087 8.39932C20.0966 8.46577 20.1687 8.54937 20.2252 8.65033C20.2813 8.75149 20.3095 8.877 20.3095 9.02685C20.3095 9.19151 20.2792 9.335 20.2185 9.45755C20.1579 9.58009 20.0771 9.68189 19.9763 9.76274C19.8752 9.84359 19.7569 9.90412 19.6214 9.94455C19.4857 9.98476 19.3427 10.0051 19.1928 10.0051C18.9937 10.0051 18.799 9.96825 18.6085 9.8946C18.4182 9.82116 18.2622 9.71216 18.1412 9.56803L18.5308 9.20442C18.6057 9.30812 18.706 9.39046 18.8313 9.45099C18.9571 9.51173 19.0802 9.54199 19.2015 9.54199C19.265 9.54199 19.3298 9.53416 19.3962 9.51808C19.4627 9.50242 19.5224 9.47554 19.5759 9.43808C19.6292 9.40061 19.6726 9.35384 19.7057 9.29754C19.7389 9.24124 19.7554 9.17119 19.7554 9.08759C19.7554 9.00674 19.7366 8.93965 19.6993 8.88631C19.6616 8.83298 19.6113 8.78663 19.5478 8.74769C19.4843 8.70874 19.4091 8.67488 19.3228 8.6461C19.2362 8.6171 19.1452 8.58683 19.05 8.55509C18.9575 8.5263 18.8652 8.4918 18.7729 8.45138C18.6806 8.41096 18.5977 8.35762 18.524 8.29116C18.4506 8.22492 18.3907 8.14322 18.3446 8.0465C18.2984 7.94999 18.2751 7.82956 18.2751 7.68522C18.2751 7.52945 18.3077 7.39526 18.3727 7.28267C18.4377 7.17028 18.5228 7.07716 18.6279 7.00351C18.7333 6.92985 18.8531 6.87504 18.9873 6.83906C19.1215 6.80308 19.2578 6.78488 19.3962 6.78488C19.552 6.78488 19.7101 6.81239 19.8703 6.86721C20.0303 6.92202 20.1694 7.00435 20.2879 7.11378L19.933 7.50342Z"/>\n<path d="M0 0H0.687216C1.97085 0 3.01702 1.04617 3.01702 2.32959C3.01702 3.61323 1.97085 4.65918 0.687216 4.65918H0V0Z"/>\n<path d="M6.62832 4.65929H5.94111C4.65747 4.65929 3.6113 3.61312 3.6113 2.3297C3.6113 1.04606 4.65747 0.000105469 5.94111 0.000105469H6.62832V4.65929Z"/>\n<path d="M9.72193 3.95294H8.74561V0.706498H9.72193C10.6164 0.706498 11.3453 1.43541 11.3453 2.32961C11.3453 3.22403 10.6164 3.95294 9.72193 3.95294ZM9.72193 2.28449e-05H8.03913V4.65942H9.72193C11.0066 4.65942 12.0515 3.61431 12.0515 2.32961C12.0515 1.04513 11.0066 2.28449e-05 9.72193 2.28449e-05Z"/>\n<path d="M14.0244 4.01686C13.4843 4.01686 13.051 3.57769 13.051 3.0435C13.051 2.50338 13.4902 2.07014 14.0244 2.07014C14.5586 2.07014 14.9978 2.5093 14.9978 3.0435C14.9978 3.58362 14.5586 4.01686 14.0244 4.01686ZM14.0244 1.43498C13.134 1.43498 12.41 2.15903 12.41 3.04942C12.41 3.93961 13.134 4.66386 14.0244 4.66386C14.9146 4.66386 15.6388 3.93961 15.6388 3.04942C15.6388 2.15903 14.9146 1.43498 14.0244 1.43498Z"/>\n<path d="M16.0958 0.000803765H16.802V4.66507H16.0958V0.000803765Z"/>\n<path d="M19.0265 4.01707C18.5947 4.01707 18.2317 3.73579 18.1033 3.35017C18.0711 3.25366 18.0531 3.1508 18.0531 3.04371C18.0531 2.93598 18.0711 2.83291 18.1033 2.7364C18.2326 2.34845 18.5987 2.07035 19.0265 2.07035C19.5607 2.07035 19.9998 2.50951 19.9998 3.04371C19.9998 3.58383 19.5607 4.01707 19.0265 4.01707ZM19.0265 1.4352C18.6834 1.4352 18.3651 1.54314 18.1033 1.72621V0.000868311H17.3957V4.66492H18.1033V4.37306C18.3651 4.55613 18.6834 4.66407 19.0265 4.66407C19.9169 4.66407 20.6409 3.93982 20.6409 3.04963C20.6409 2.15924 19.9169 1.4352 19.0265 1.4352Z"/>\n<path d="M23.2285 1.43613L22.3085 3.50497L21.3883 1.43613H20.6168L21.9227 4.37145L21.8964 4.42838L21.8871 4.4487L21.6044 5.08724C21.6037 5.08893 21.6031 5.09062 21.6025 5.09211C21.5178 5.28195 21.2945 5.36788 21.1051 5.28343L21.0039 5.23835L20.7186 5.87816L20.7199 5.87858L20.9646 5.98779C21.4238 6.19267 21.9654 5.98441 22.1707 5.52408C22.1724 5.52027 23.8432 1.78704 24 1.43613H23.2285Z"/>\n</svg>\n';

// src/~assets/svg/icons.ts
var ICONS = {
  // Audio/Video Icons
  "dolby-vision": dolby_vision_default,
  "dolby-atmos": dolby_atmos_default,
  // App Icons
  "airplay-active": airplay_active_default,
  "arrow-down-up": arrow_down_up_default,
  "arrow-down": arrow_down_default,
  "arrow-left": arrow_left_default,
  "arrow-right": arrow_right_default,
  "arrow-up": arrow_up_default,
  "bell-active": bell_active_default,
  "bell-off": bell_off_default,
  "bell-on": bell_on_default,
  "caret-down": caret_down_default,
  "caret-up": caret_up_default,
  "chevron-left": chevron_left_default,
  "chevron-right": chevron_right_default,
  "chromecast-off": chromecast_off_default,
  "download-queue": download_queue_default,
  "flag-dk": flag_dk_default,
  "flag-fi": flag_fi_default,
  "flag-no": flag_no_default,
  "flag-se": flag_se_default,
  "fullscreen-close": fullscreen_close_default,
  "my-movies": my_movies_default,
  "question-mark": question_mark_default,
  "sad-mood": sad_mood_default,
  "share-android": share_android_default,
  "share-ios": share_ios_default,
  "skip-backward-15": skip_backward_15_default,
  "skip-backward-30": skip_backward_30_default,
  "skip-backward": skip_backward_default,
  "skip-forward-15": skip_forward_15_default,
  "skip-forward-30": skip_forward_30_default,
  "skip-forward": skip_forward_default,
  "visibility-off": visibility_off_default,
  "volume-off": volume_off_default,
  airplay: airplay_default,
  bell: bell_default,
  bundles: bundles_default,
  cart: cart_default,
  cellular: cellular_default,
  checkmark: checkmark_default,
  chromecast: chromecast_default,
  close: close_default,
  coming: coming_default,
  discover: discover_default,
  dots: dots_default,
  download: download_default,
  edit: edit_default,
  exclude: exclude_default,
  facebook: facebook_default,
  filter: filter_default,
  fullscreen: fullscreen_default,
  genres: genres_default,
  guest: guest_default,
  help: help_default,
  home: home_default,
  info: info_default,
  instagram: instagram_default,
  kids: kids_default,
  login: login_default,
  logout: logout_default,
  lightbulb: lightbulb_default,
  mail: mail_default,
  menu: menu_default,
  minus: minus_default,
  mood: mood_default,
  movies: movies_default,
  new: new_default,
  pause: pause_default,
  percent: percent_default,
  phone: phone_default,
  place: place_default,
  play: play_default,
  "play-next": play_next_default,
  plus: plus_default,
  profile: profile_default,
  refresh: refresh_default,
  search: search_default,
  series: series_default,
  settings: settings_default,
  shield: shield_default,
  star: star_default,
  subtitles: subtitles_default,
  trash: trash_default,
  trending: trending_default,
  twitter: twitter_default,
  visibility: visibility_default,
  volume: volume_default,
  wifi: wifi_default,
  gift: gift_default,
  grid: grid_default,
  youtube: youtube_default,
  reset: reset_default,
  ["social-apple"]: social_apple_default,
  ["social-google"]: social_google_default,
  ["social-facebook"]: social_facebook_default,
  pin: pin_default,
  unpin: unpin_default
};

// src/~graphql/queries/GQL_GET_MEDIA.ts
import { gql as gql4 } from "@apollo/client";

// src/~graphql/fragments/DISPLAYABLE_IN_COLLECTION_FRAGMENT.ts
import { gql as gql2 } from "@apollo/client";

// src/~graphql/fragments/TAGS_FRAGMENT.ts
import { gql } from "@apollo/client";
var TAGS_FRAGMENT_default = gql`
  fragment TagsFragment on Tag {
    __typename
    id
    name
    priority
    zones {
      __typename
      ... on TagZoneInterface {
        context
      }
      ... on TagZoneCard {
        groupCard: group
      }
      ... on TagZonePrimary {
        groupPrimary: group
      }
      ... on TagZoneDescription {
        groupDescription: group
      }
    }
    display {
      __typename
      ... on BasicDisplayTag {
        name
        slug
      }
      ... on TextDisplayTag {
        __typename
        text
        appearance
        target {
          __typename
          ... on ContentCollectionTargetSearch {
            params
          }
        }
      }
      ... on IconDisplayTag {
        icon
        appearance
        target {
          __typename
        }
      }
      ... on BookmarkDisplayTag {
        time
        duration

        percentage

        started
        completed
        appearance
      }
      ... on BoughtDisplayTag {
        appearance
      }
      ... on RentedDisplayTag {
        endDate
        appearance
      }
      ... on PriceReducedTagDisplay {
        previousPrice
        previousPriceFormatted
        newPrice
        newPriceFormatted
        rentalType
      }
      ... on ReleaseDateTagDisplay {
        daysUntilRelease
        releaseDate
        comingAtString
      }
      ... on AnytimeExclusiveDisplay {
        anytimeExclusive
      }
      ... on MediaUnavailableDisplay {
        isUnavailable
      }
      ... on PurchasableMediaDisplay {
        lowestPrice
        lowestPriceFormatted
      }
      ... on ItemIsCollectionDisplay {
        isCollection
      }
      ... on MediaIsPartOfCollectionDisplay {
        collections {
          ... on MetaCollectionBundle {
            slug
            display {
              title
            }
          }
        }
      }
    }
  }
`;

// src/~graphql/fragments/DISPLAYABLE_IN_COLLECTION_FRAGMENT.ts
var DISPLAYABLE_IN_COLLECTION_FRAGMENT_default = gql2`
  fragment DisplayableInCollectionFragment on DisplayableInCollection {
    __typename
    slug
    display {
      title
      originalTitle
      caption
    }
    tags(take: 20) {
      ...TagsFragment
    }
    displayableAsset {
      __typename
      ... on DisplayableInCollectionWithCover {
        id
        cover(size: $coverSize, preset: $coverPreset)
      }
      ... on DisplayableInCollectionWithPromo {
        promo
      }
    }

    ... on BaseMedia {
      id
    }
    ... on BaseMetaCollection {
      id
    }
    ... on Ticket {
      id
    }
    ... on Movie {
      id
    }
    ... on MetaCollectionBundle {
      id
    }
    ... on Episode {
      id
    }
    ... on Series {
      id
    }
    ... on Season {
      id
    }
  }
  ${TAGS_FRAGMENT_default}
`;

// src/~graphql/fragments/LINK_TARGET_FRAGMENT.ts
import { gql as gql3 } from "@apollo/client";
var LINK_TARGET_FRAGMENT = gql3`
  fragment LinkTargetFragment on DisplayableInCollection {
    linkTarget @client {
      __typename
      ... on InternalSite {
        url
      }
      ... on InternalRoute {
        target {
          __typename
          ... on DisplayableInCollection {
            slug
          }
          ... on PageReference {
            slug
          }
          ... on ListReference {
            slug
          }
          ... on ContentCollectionReference {
            slug
          }
        }
      }
    }
  }
`;

// src/~graphql/queries/GQL_GET_MEDIA.ts
var GQL_GET_MEDIA_default = gql4`
  query GetMediaQuery(
    $slug: ID!
    $locale: Locale!
    $seasonNo: Int
    $episodeNo: Int
    $avatarPreset: AvatarPreset
    $avatarSize: AvatarSize
    $recommendationTake: Int
    $mainMediaSize: MediaSize
    $mainMediaPreset: MediaPreset
    $episodeMediaSize: MediaSize
    $episodeMediaPreset: MediaPreset
    $coverSize: CoverSize
    $coverPreset: CoverPreset
  ) {
    response: media(slug: $slug, locale: $locale) @disableAuth {
      ...DisplayableInCollectionFragment
      ...LinkTargetFragment

      ... on BaseMedia {
        id
        slug
        alternativeSlugs {
          slug
          lang
        }
        comingAt
        comingAtString

        directors {
          id
          name
          avatar(preset: $avatarPreset, size: $avatarSize)
        }
        actors {
          id
          name
          avatar(preset: $avatarPreset, size: $avatarSize)
        }

        url
        genres

        mediaImages(size: $mainMediaSize, preset: $mainMediaPreset)
        subtitles {
          language
        }

        audio {
          tracks {
            language
            sound {
              channels
              format
            }
          }
        }

        tags(take: 20) {
          ...TagsFragment
        }

        similar(take: $recommendationTake) {
          ...DisplayableInCollectionFragment
          ...LinkTargetFragment
        }
        localization {
          __typename
          id
          locale
          items
        }
      }
      ... on Movie {
        isComing
        isPurchasable

        longSummary
        lowestPriceString
        duration
        durationString
        durationStringShort: durationString(format: "h _ mm _")
        durationStringLong: durationString(format: "h ___ mm ___")
        releaseYear
        ageLimit
        ageLimitString
        ageLimitStringLong: ageLimitString(format: long)
        productionCountries
        imdbId
        ratings {
          imdb
        }
        manifests {
          trailers {
            dash
            hls
            smooth
            default {
              dash
              hls
              smooth
            }
          }
        }
      }
      ... on Episode {
        id
        lowestPriceString
        duration
        seriesSlug
        releaseYear
        productionCountries
        imdbId
        isPurchasable
        episodeNo
        seasonNo
        longSummary
        abbreviation
      }
      ... on Series {
        id
        firstReleaseYear
        lastReleaseYear
        formattedReleaseRange
        imdbId
        episodeDuration
        episodeDurationStringShort: episodeDurationString(format: "h _ mm _")
        episodeDurationString
        episodeDurationStringLong: episodeDurationString(format: "h ___ mm ___")
        productionCountries
        ageLimit
        ageLimitString
        ageLimitStringLong: ageLimitString(format: long)
        genres
        longSummary
        firstEpisode {
          id
          slug

          seasonNo
          episodeNo

          isPurchasable
          comingAt
          abbreviation

          lowestPriceString
        }

        ratings {
          imdb
        }

        seasons(seasonNo: $seasonNo) {
          id
          slug
          lowestPriceString
          seasonNo
          isPurchasable
          comingAt
          abbreviation

          tags(take: 20) {
            ...TagsFragment
          }

          episodes(episodeNo: $episodeNo) {
            id
            ...DisplayableInCollectionFragment
            slug
            episodeNo
            duration
            longSummary
            abbreviation
            lowestPriceString
            isPurchasable
            audio {
              tracks {
                language
              }
            }
            subtitles {
              language
            }
            mediaImages(size: $episodeMediaSize, preset: $episodeMediaPreset)
          }
        }
      }
      ... on Season {
        id
        seriesSlug
        lowestPriceString
        longSummary
        seasonNo
        isPurchasable
        abbreviation

        firstEpisode {
          slug

          seasonNo
          episodeNo

          isPurchasable
          comingAt

          lowestPriceString
        }
      }
      __typename
    }
  }

  ${TAGS_FRAGMENT_default}
  ${DISPLAYABLE_IN_COLLECTION_FRAGMENT_default}
  ${LINK_TARGET_FRAGMENT}
`;

// src/~graphql/queries/GQL_GET_PRISMIC_PAGE.ts
import { gql as gql5 } from "@apollo/client";
var GQL_GET_PRISMIC_PAGE_default = gql5`
  query GetPrismicPageQuery($slug: ID!, $locale: Locale!) {
    response: page(slug: $slug, locale: $locale) {
      slug
      firstPublicationDate
      lastPublicationDate
      content
    }
  }
`;

// src/~graphql/queries/GQL_GET_BOOKMARKS.ts
import { gql as gql7 } from "@apollo/client";

// src/~graphql/fragments/BOOKMARK_FRAGMENT.ts
import { gql as gql6 } from "@apollo/client";
var BOOKMARK_FRAGMENT_default = gql6`
  fragment BookmarkParts on Bookmark {
    id
    time
    duration
    percentage
    procentage: percentage
    completed
    updatedAt
    started
    slug
    item: displayableItem {
      __typename
      ... on Playable {
        id
        slug
      }
      ...DisplayableInCollectionFragment
      ... on Episode {
        episodeNo
        seasonNo
        seriesSlug
      }
    }
  }
  ${DISPLAYABLE_IN_COLLECTION_FRAGMENT_default}
`;

// src/~graphql/queries/GQL_GET_BOOKMARKS.ts
var GQL_GET_BOOKMARKS_default = gql7`
  query BookmarksQuery(
    $locale: Locale!
    $coverSize: CoverSize
    $coverPreset: CoverPreset
  ) {
    response: bookmarks(locale: $locale) {
      ...BookmarkParts
    }
  }
  ${BOOKMARK_FRAGMENT_default}
`;

// src/~graphql/queries/GQL_GET_META_COLLECTION.ts
import { gql as gql9 } from "@apollo/client";

// src/~graphql/fragments/TRACKING_FRAGMENT.ts
import { gql as gql8 } from "@apollo/client";
var TRACKING_FRAGMENT_default = gql8`
  fragment TrackingFragment on DisplayableInCollection {
    __typename
    slug
    id
    display {
      originalTitle
    }
    ... on BaseMedia {
      genres
    }
  }
`;

// src/~graphql/queries/GQL_GET_META_COLLECTION.ts
var GQL_GET_META_COLLECTION = gql9`
  fragment GetMetaCollectionQueryFragment on DisplayableInCollection {
    ...DisplayableInCollectionFragment

    ... on Movie {
      releaseYear
      durationStringShort: durationString(format: "h _ mm _")
      ratings {
        imdb
      }
      genres
      ageLimitString
      longSummary @include(if: $includeItemLongSummaries)
    }
  }

  query GetMetaCollectionQuery(
    $slug: ID!
    $locale: Locale!
    $take: Int = 20
    $page: Int = 0
    $orderBy: ListOrderBy
    $coverSize: CoverSize
    $coverPreset: CoverPreset
    $mainMediaSize: MediaSize
    $mainMediaPreset: MediaPreset
    $avatarPreset: AvatarPreset
    $includeItemLongSummaries: Boolean = false
  ) {
    response: metacollection(
      slug: $slug
      locale: $locale
      take: $take
      page: $page
      orderBy: $orderBy
    ) @disableAuth {
      __typename
      ... on BaseMetaCollection {
        id
        slug
        page
        totalCount
        localization {
          id
          locale
          items
        }
        sortOptions {
          __typename
          active
          titleKey
          orderBy
          arrangement {
            reverse
            default
            active
          }
        }
        items: displayableItems {
          ...GetMetaCollectionQueryFragment
          ...LinkTargetFragment
        }
      }

      ... on MetaCollectionBundle {
        __typename
        id
        slug
        mediaImages(size: $mainMediaSize, preset: $mainMediaPreset)
        genres
        longSummary

        discount {
          amountString
          percentageString
        }

        tags(take: 20) {
          ...TagsFragment
        }

        directors {
          __typename
          id
          name
          avatar(preset: $avatarPreset)
        }
        actors {
          __typename
          id
          name
          avatar(preset: $avatarPreset)
        }

        ...DisplayableInCollectionFragment
        ...LinkTargetFragment
        ...TrackingFragment

        url
        isPurchasable
        lowestPriceString
        duration
        durationString
        durationStringShort: durationString(format: "h _ mm _")
        durationStringLong: durationString(format: "h ___ mm ___")
        firstReleaseYear
        lastReleaseYear
      }
    }
  }

  ${DISPLAYABLE_IN_COLLECTION_FRAGMENT_default}
  ${TRACKING_FRAGMENT_default}
  ${LINK_TARGET_FRAGMENT}
`;
var GQL_GET_META_COLLECTION_default = GQL_GET_META_COLLECTION;

// src/~graphql/queries/GQL_GET_META_COLLECTION_FOR_META.ts
import { gql as gql10 } from "@apollo/client";
var GQL_GET_META_COLLECTION_FOR_META_default = gql10`
  query GetMetaCollectionForMediaQuery(
    $slug: ID!
    $locale: Locale!
    $take: Int = 20
    $page: Int = 0
    $orderBy: ListOrderBy
  ) {
    response: media(slug: $slug, locale: $locale) @disableAuth {
      __typename
      ... on BaseMedia {
        slug
        id
        localization {
          id
          locale
          items
        }
        metacollections(take: $take, page: $page, orderBy: $orderBy) {
          __typename
          localization {
            id
            locale
            items
          }
          items {
            __typename
            ... on MetaCollectionCategory {
              images {
                promo
              }
            }
            ... on BaseMetaCollection {
              __typename
              id
              slug
            }
            ...LinkTargetFragment
          }
        }
      }
    }
  }
  ${LINK_TARGET_FRAGMENT}
`;

// src/~graphql/queries/GQL_GET_VOUCHER.ts
import { gql as gql11 } from "@apollo/client";
var GQL_GET_VOUCHER_default = gql11`
  query GetVoucherQuery(
    $locale: Locale!
    $code: String!
    $slug: String
    $productType: String
    $purchaseType: String
    $accessCode: String
    $userEmail: String
    $paymentMethod: String
  ) {
    response: voucher(
      locale: $locale
      code: $code
      productType: $productType
      purchaseType: $purchaseType
      accessCode: $accessCode
      slug: $slug
      userEmail: $userEmail
      paymentMethod: $paymentMethod
    ) {
      code
      name
      description
      percentageDiscount
      isMultipleUsed
      isPaymentDetailsRequired
    }
  }
`;

// src/~graphql/queries/GQL_GET_FAVORITES.ts
import { gql as gql13 } from "@apollo/client";

// src/~graphql/fragments/FAVORITES_FRAGMENT.ts
import { gql as gql12 } from "@apollo/client";
var FAVORITES_FRAGMENT_default = gql12`
  fragment FavoritesFragment on Favorite {
    id
    slug

    item: displayableItem {
      __typename

      ...DisplayableInCollectionFragment
      ...LinkTargetFragment
    }
  }

  ${DISPLAYABLE_IN_COLLECTION_FRAGMENT_default}
  ${LINK_TARGET_FRAGMENT}
`;

// src/~graphql/queries/GQL_GET_FAVORITES.ts
var GQL_GET_FAVORITES_default = gql13`
  query GetFavoritesQuery(
    $locale: Locale!
    $coverSize: CoverSize
    $coverPreset: CoverPreset
  ) {
    response: favorites(locale: $locale) {
      id
      ...FavoritesFragment
      item: displayableItem {
        __typename
        ...DisplayableInCollectionFragment
      }
    }
  }
  ${DISPLAYABLE_IN_COLLECTION_FRAGMENT_default}
  ${FAVORITES_FRAGMENT_default}
`;

// src/~graphql/queries/GQL_CREATE_PLAYBACK_TOKEN.ts
import { gql as gql16 } from "@apollo/client";

// src/~graphql/fragments/PLAYBACKTOKEN_FRAGMENT.ts
import { gql as gql14 } from "@apollo/client";
var PLAYBACKTOKEN_FRAGMENT_default = gql14`
  fragment PlaybacktokenParts on AccountPlaybackToken {
    id
    jwt
    expires
    thumbsUrl
    playbackId
    cdn

    widevine {
      licenseServer
      __typename
    }
    fairplay {
      licenseServer
      certificateUrl
      contentId
      __typename
    }
    manifest {
      # dash
      # hls

      # info {
      #   ...PlaybacktokenManifestInfoParts
      # }
      download {
        dash
        hls

        info {
          ...PlaybacktokenManifestInfoParts
        }
      }
      default {
        dash
        hls

        info {
          ...PlaybacktokenManifestInfoParts
        }
      }
      filtered(filters: $filters) {
        dash
      }
      __typename
    }
    playready {
      licenseServer
      __typename
    }
    __typename
  }

  fragment PlaybacktokenManifestInfoParts on ManifestInfo {
    name
  }
`;

// src/~graphql/fragments/MUX_TRACKING_FRAGMENT.ts
import { gql as gql15 } from "@apollo/client";
var MUX_TRACKING_FRAGMENT_default = gql15`
  fragment MuxTrackingFragment on Playable {
    __typename
    slug
    id
    ... on BaseMedia {
      display {
        originalTitle
      }
    }
    ... on Movie {
      duration
    }
    ... on Episode {
      seriesSlug
      duration
    }
  }
`;

// src/~graphql/queries/GQL_CREATE_PLAYBACK_TOKEN.ts
var GQL_CREATE_PLAYBACK_TOKEN_default = gql16`
  query PlaybackTokenQuery($slug: ID!, $filters: [ManifestFilter!]!) {
    response: playbacktoken(slug: $slug) {
      ...PlaybacktokenParts
      extra
      nextContent {
        ... on BaseMedia {
          id
          slug
          mediaImages
          originalTitle
          display {
            title
            caption
          }
        }
      }
      media {
        ...MuxTrackingFragment
        id
        slug
        introStart
        introEnd
        creditsStart
        ... on Episode {
          seriesSlug
        }
      }
    }
  }

  ${MUX_TRACKING_FRAGMENT_default}
  ${PLAYBACKTOKEN_FRAGMENT_default}
`;

// src/~graphql/queries/GQL_GET_ENTITLEMENTS.ts
import { gql as gql18 } from "@apollo/client";

// src/~graphql/fragments/ENTITLEMENT_FRAGMENT.ts
import { gql as gql17 } from "@apollo/client";
var ENTITLEMENT_FRAGMENT_default = gql17`
  fragment EntitlementParts on AccountEntitlement {
    id
    mediaId
    slug
    seriesSlug
    startDate
    endDate
    endIn
    isEst
    __typename
  }
`;

// src/~graphql/queries/GQL_GET_ENTITLEMENTS.ts
var GQL_GET_ENTITLEMENTS_default = gql18`
  query GetEntitlementsQuery(
    $locale: Locale!
    $coverSize: CoverSize
    $coverPreset: CoverPreset
  ) {
    response: entitlements(locale: $locale) {
      entitlements {
        ...EntitlementParts
      }

      items: displayableItems {
        ...DisplayableInCollectionFragment
        ...LinkTargetFragment
      }

      tickets {
        totalCount
        balance
        used
        displayableAsset {
          __typename
          ... on DisplayableInCollectionWithCover {
            id
            cover(size: $coverSize, preset: $coverPreset)
          }
          ... on DisplayableInCollectionWithPromo {
            promo
          }
        }
      }

      __typename
    }
  }

  ${ENTITLEMENT_FRAGMENT_default}
  ${LINK_TARGET_FRAGMENT}
  ${DISPLAYABLE_IN_COLLECTION_FRAGMENT_default}
`;

// src/~graphql/queries/GQL_GET_ACCOUNT_INFORMATION.ts
import { gql as gql21 } from "@apollo/client";

// src/~graphql/fragments/ACCOUNT_DETAILS_FRAGMENT.ts
import { gql as gql20 } from "@apollo/client";

// src/~graphql/fragments/DEVICEINFORMATION_FRAGMENT.ts
import { gql as gql19 } from "@apollo/client";
var DEVICEINFORMATION_FRAGMENT_default = gql19`
  fragment DeviceInformationParts on DeviceInformation {
    __typename
    id
    brand
    environment
    features {
      __typename
      feature
      enabled
      priority
      variant
      data
    }
    configs {
      __typename
      priority
      config
      value
    }
  }
`;

// src/~graphql/fragments/ACCOUNT_DETAILS_FRAGMENT.ts
var ACCOUNT_DETAILS_FRAGMENT_default = gql20`
  fragment AccountParts on Account {
    __typename

    id
    email
    mppId
    firstName
    lastName
    mobile
    address
    postalCode
    city
    country
    locale
    shortUserName
    countryOfResidence
    marketingConsent

    paymentMethods {
      __typename
      methodId
      processor
      method
      data
      logo
    }

    isNewUser

    deviceInformation {
      ...DeviceInformationParts
    }
  }
  ${DEVICEINFORMATION_FRAGMENT_default}
`;

// src/~graphql/queries/GQL_GET_ACCOUNT_INFORMATION.ts
var GQL_GET_ACCOUNT_INFORMATION_default = gql21`
  query AccountInformationQuery {
    response: account {
      ...AccountParts
    }
  }
  ${ACCOUNT_DETAILS_FRAGMENT_default}
`;

// src/~graphql/queries/GQL_GET_ACCOUNT_ORDERS.ts
import { gql as gql22 } from "@apollo/client";
var GQL_GET_ACCOUNT_ORDERS = gql22`
  query AccountOrdersQuery(
    $locale: Locale!
    $coverSize: CoverSize
    $coverPreset: CoverPreset
    $take: Int
    $page: Int
  ) {
    response: orders(locale: $locale, take: $take, page: $page) {
      description
      __typename
      orderId
      orderDate
      originalPrice
      discountAmount
      discountAmountString
      vatAmountString
      originalPriceString
      paidAmountString
      purchaseType
      purchaseTypeTitleKey
      purchaseTypeTitleData
      purchaseMethod
      purchaseMethodTitleKey
      purchaseMethodTitleData
      feeAmount
      feeAmountString
      orderDate
      currency
      pdfReceipt
      item {
        __typename
        ...DisplayableInCollectionFragment
      }
    }
  }
  ${DISPLAYABLE_IN_COLLECTION_FRAGMENT_default}
`;
var GQL_GET_ACCOUNT_ORDERS_default = GQL_GET_ACCOUNT_ORDERS;

// src/~graphql/queries/GQL_CONTENT_LIST_PAGINATE.ts
import { gql as gql23 } from "@apollo/client";
var GQL_LIST_PAGINATE = gql23`
  query ContentListPaginateQuery(
    $slug: ID!
    $locale: Locale!
    $orderBy: ListOrderBy
    $first: Int
    $after: String
    $coverSize: CoverSize
    $coverPreset: CoverPreset
  ) {
    response: contentList(locale: $locale, slug: $slug) @disableAuth {
      id
      slug
      title
      description
      hiddenTitle
      meta {
        __typename
        title
        description
      }
      image16x9
      image3x4
      image4x3
      items(first: $first, after: $after, orderBy: $orderBy) {
        totalCount
        sortOptions {
          __typename
          titleKey
          active
          orderBy
          arrangement {
            reverse
            default
            active
          }
        }

        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            ...DisplayableInCollectionFragment
            ...LinkTargetFragment
          }
        }
      }
    }
  }
  ${DISPLAYABLE_IN_COLLECTION_FRAGMENT_default}
  ${LINK_TARGET_FRAGMENT}
`;
var GQL_CONTENT_LIST_PAGINATE_default = GQL_LIST_PAGINATE;

// src/~graphql/queries/GQL_CONTENT_COLLECTION.ts
import { gql as gql24 } from "@apollo/client";
var GQL_CONTENT_COLLECTION = gql24`
  query ContentCollectionQuery(
    $slug: ID!
    $locale: Locale!
    $coverSize: CoverSize
    $coverPreset: CoverPreset
    $first: Int
    $after: String
  ) {
    contentcollection(slug: $slug, locale: $locale) @disableAuth {
      id
      name
      slug
      meta {
        title
        description
      }
      totalCount
      collection(first: $first, after: $after) {
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
        edges {
          node {
            __typename
            ... on ContentCollectionUserContent {
              contentType {
                __typename
              }
            }
            ... on ContentCollectionTakeover {
              text
              logo
              itemSlug
              item: displayableItem {
                __typename
                ... on Purchasable {
                  isPurchasable
                  lowestPriceString
                  slug
                  tags(take: 2) {
                    ...TagsFragment
                  }
                }
                ...TrackingFragment
                ...LinkTargetFragment
                ... on Series {
                  slug
                  firstEpisode {
                    ...TrackingFragment
                    slug
                    lowestPriceString
                    isPurchasable
                  }
                  tags(take: 2) {
                    ...TagsFragment
                  }
                }
              }
              image16x9
              image1x1
              preferredAccentTheme
              alignment
              header
              targetListSlug
              targetContentCollectionSlug
              targetPageSlug
              video16x9
              video1x1

              usps {
                __typename
                text
                image1x1
              }
            }

            ... on ContentCollectionCallToAction {
              text
              size
              alignment
              target {
                __typename
                ... on ContentCollectionTargetList {
                  item {
                    slug
                    title
                    totalCount
                  }
                }
                ... on ContentCollectionTargetPage {
                  item {
                    slug
                  }
                }
                ... on ContentCollectionTargetContentCollection {
                  item {
                    __typename
                    slug
                  }
                }

                ... on ContentCollectionTargetMedia {
                  action

                  item {
                    __typename
                    ... on BaseMedia {
                      slug
                    }
                    ... on MetaCollectionBundle {
                      slug
                    }
                  }
                }
              }
            }
            ... on ContentCollectionTitle {
              title
              description
              alignment
            }
            ... on ContentCollectionUsp {
              items {
                __typename
                icon
                title
                description
                iconColor
                image
              }
            }
            ... on ContentCollectionRecommendation {
              source
              title
              args
            }

            ... on ContentCollectionMyList {
              id
              title
            }
            ... on ContentCollectionContinueWatching {
              title
            }
            ... on ContentCollectionEntitlements {
              title
            }
            ... on ContentCollectionNotificationTeaser {
              title
            }
            ... on Spotlights {
              promos: items {
                ...ContentCollectionQueryPromoFragment
                ...LinkTargetFragment
              }
            }
            ... on Promos {
              promoSize: size
              promos: items {
                ...ContentCollectionQueryPromoFragment
                ...LinkTargetFragment
              }
            }
            ... on BaseList {
              __typename

              title
              orderBy
              slug
              items {
                ...DisplayableInCollectionFragment
                ...LinkTargetFragment
              }
            }
          }
        }
      }
    }
  }
  ${DISPLAYABLE_IN_COLLECTION_FRAGMENT_default}
  ${LINK_TARGET_FRAGMENT}
  ${TRACKING_FRAGMENT_default}

  fragment ContentCollectionQueryPromoFragment on Feature {
    ...DisplayableInCollectionFragment

    link {
      type
      url
    }
    animation {
      url
      type
    }
    target {
      __typename
      ... on BaseMedia {
        id
        slug
        mediaImages
      }
      ... on DisplayableInCollection {
        tags(take: 2) {
          ...TagsFragment
        }
        slug
      }
      ... on PageReference {
        slug
      }
      ... on ContentCollectionReference {
        contentCollectionSlug: slug
      }
      ... on ListReference {
        listSlug: slug
      }

      ... on ContentCollectionReference {
        contentCollectionSlug: slug
      }
    }
  }
`;
var GQL_CONTENT_COLLECTION_default = GQL_CONTENT_COLLECTION;

// src/~graphql/queries/GQL_GET_DEVICE_INFORMATION.ts
import { gql as gql25 } from "@apollo/client";
var GQL_GET_DEVICE_INFORMATION_default = gql25`
  query GetDeviceInformationQuery($device: DeviceType!) {
    response: deviceInfo(device: $device) @disableAuth {
      ...DeviceInformationParts
    }
  }
  ${DEVICEINFORMATION_FRAGMENT_default}
`;

// src/~graphql/queries/GQL_GET_SAVED_SEARCH.ts
import { gql as gql26 } from "@apollo/client";
var GQL_GET_SAVED_SEARCH_default = gql26`
  query GetSavedSearch($type: SavedSearchType!) {
    response: savedsearch(type: $type) {
      __typename
      ... on SingleTitleSavedSearch {
        id
        locale
        slug
      }
      ... on GenericSavedSearch {
        id
        locale
        algoliaFilter
        freeText
      }
      ... on TitlesInSeriesSavedSearch {
        id
        locale
        seriesSlug
      }
    }
  }
`;

// src/~graphql/queries/GQL_GET_SAVED_SEARCHES.ts
import { gql as gql27 } from "@apollo/client";
var GQL_GET_SAVED_SEARCHES_default = gql27`
  query GetSavedSearches($coverSize: CoverSize, $coverPreset: CoverPreset) {
    response: savedsearch(type: singletitle) {
      __typename
      ... on SingleTitleSavedSearch {
        id
        locale
        slug
        item {
          ...DisplayableInCollectionFragment
          ...LinkTargetFragment
        }
      }
    }
  }

  ${DISPLAYABLE_IN_COLLECTION_FRAGMENT_default}
  ${LINK_TARGET_FRAGMENT}
`;

// src/~graphql/queries/GQL_GET_LOCALIZATION.ts
import { gql as gql28 } from "@apollo/client";
var GQL_GET_LOCALIZATION_default = gql28`
  query LocalizationQuery(
    $locale: Locale!
    $brand: Brand!
    $fallbackLocale: Locale = en
    $deviceType: DeviceType
    $excludeNamespace: [String!]
    $pick: [String!]
  ) {
    response: localization(
      locale: $locale
      brand: $brand
      deviceType: $deviceType
      excludeNamespace: $excludeNamespace
      pick: $pick
    ) @disableAuth {
      id
      __typename
      locale
      items
    }
    fallback: localization(
      locale: $fallbackLocale
      brand: $brand
      deviceType: $deviceType
      excludeFrom: $locale
    ) @disableAuth {
      id
      locale
      items
    }
  }
`;

// src/~graphql/queries/GQL_GET_RECOMMENDATIONS.ts
import { gql as gql29 } from "@apollo/client";
var GQL_GET_RECOMMENDATIONS = gql29`
  query GetRecommendations(
    $locale: Locale
    $type: RecommendationsType
    $coverSize: CoverSize
    $coverPreset: CoverPreset
  ) {
    response: recommendations(locale: $locale, type: $type) {
      ...DisplayableInCollectionFragment
      ...LinkTargetFragment
    }
  }
  ${DISPLAYABLE_IN_COLLECTION_FRAGMENT_default}
  ${LINK_TARGET_FRAGMENT}
`;
var GQL_GET_RECOMMENDATIONS_default = GQL_GET_RECOMMENDATIONS;

// src/~graphql/queries/GQL_GET_MENU.ts
import { gql as gql30 } from "@apollo/client";
var GQL_GET_MENU_default = gql30`
  query GetMenuQuery($locale: Locale) {
    menu(locale: $locale) {
      items {
        target {
          route
          slug
        }
        icon
        text
      }
    }
  }
`;

// src/~graphql/queries/GQL_GET_TRANSACTION.ts
import { gql as gql32 } from "@apollo/client";

// src/~graphql/fragments/TRANSACTION_FRAGMENT.ts
import { gql as gql31 } from "@apollo/client";
var PAYMENT_METHODS_FRAGMENT = gql31`
  fragment PaymentMethodParts on PaymentMethodSelection {
    __typename
    processor
    method
    methodId
    selected
    selectable
    logo
    disabled
    data
    titleKey
    titleData
    descriptionKey
    descriptionData
    group {
      __typename
      id
      primaryMethodId
      titleKey
      titleData
      descriptionKey
      descriptionData
    }
  }
`;
var PURCHASE_TYPE_FRAGMENT = gql31`
  fragment PurchaseTypeParts on PurchaseTypeSelection {
    __typename
    id
    selected
    titleKey
    titleData
    descriptionKey
    descriptionData
    type
    price
    priceString
    originalPrice
    originalPriceString
    campaignPrice
    campaignPriceString
  }
`;
var AUDIO_LANGUAGE_FRAGMENT = gql31`
  fragment AudioLanguageParts on TransactionAudioLanguage {
    __typename
    id
    titleKey
    titleData
    selected
    language
  }
`;
var TRANSACTION_FRAGMENT_default = gql31`
  fragment TransactionParts on Transaction {
    __typename

    id
    status
    accessCode

    description

    voucherCode

    price
    priceString
    originalPrice
    originalPriceString

    createdAt
    updatedAt

    acquirerResponse {
      __typename
      code
      reason
      titleKey
      textKey
    }

    payment {
      adyen {
        clientKey
        environment
        locale
        countryCode
        channel
        currency
        minorAmount

        paymentMethodsResponse
        paymentsResponse
      }
      apple {
        productId
        paymentData
      }
      google {
        productId
        paymentData
      }
    }

    payUrl
    payQrUrl

    suggestedTicketsToBuy {
      id
      slug
      lowestPriceString(device: $device)
      numberOfTickets
    }

    selectedPurchaseType {
      ...PurchaseTypeParts
    }
    selectedAudioLanguage {
      ...AudioLanguageParts
    }
    selectedPaymentMethod {
      ...PaymentMethodParts
    }

    audioLanguages {
      ...AudioLanguageParts
    }
    purchaseTypes {
      ...PurchaseTypeParts
    }
    paymentMethods {
      ...PaymentMethodParts
    }

    item: purchasableItem {
      __typename
      ...TrackingFragment
      ... on Purchasable {
        slug
        cover
        originalTitle
        display {
          originalTitle
          title
          caption
        }
      }
    }

    receipt {
      __typename

      orderId
      currency
      paidAmount
      paidAmountString
      discountAmount
      discountAmountString
      vatAmount
      vatAmountString
      campaignPrice
      campaignPriceString
      feeAmount
      feeAmountString
      originalPrice
      originalPriceString
      orderCreatedAt
    }
  }
  ${PURCHASE_TYPE_FRAGMENT}
  ${AUDIO_LANGUAGE_FRAGMENT}
  ${PAYMENT_METHODS_FRAGMENT}
  ${TRACKING_FRAGMENT_default}
`;

// src/~graphql/queries/GQL_GET_TRANSACTION.ts
var GQL_GET_TRANSACTION_default = gql32`
  query GetTransactionQuery($id: ID!, $locale: Locale!, $device: DeviceInput!) {
    response: transaction(id: $id, locale: $locale) {
      ...TransactionParts
    }
  }
  ${TRANSACTION_FRAGMENT_default}
`;

// src/~graphql/queries/GQL_GET_NEXT_EPISODE.ts
import { gql as gql33 } from "@apollo/client";
var GQL_GET_NEXT_EPISODE_default = gql33`
  query GetNextEpisodeQuery(
    $locale: Locale
    $seriesSlug: ID!
    $coverSize: CoverSize
    $coverPreset: CoverPreset
  ) {
    response: nextEpisode(locale: $locale, seriesSlug: $seriesSlug) {
      id
      slug
      ...DisplayableInCollectionFragment

      mediaImages
      genres

      lowestPriceString
      duration
      seriesSlug
      releaseYear
      productionCountries
      imdbId
      isPurchasable
      episodeNo
      seasonNo
      longSummary
    }
  }

  ${DISPLAYABLE_IN_COLLECTION_FRAGMENT_default}
`;

// src/~graphql/queries/GQL_PUBLIC_FEED.ts
import { gql as gql34 } from "@apollo/client";
var GQL_PUBLIC_FEED_default = gql34`
  query PublicFeedQuery(
    $slug: ID!
    $locale: Locale!
    $orderBy: ListOrderBy
    $page: Int
    $take: Int
    $coverSize: CoverSize
    $coverPreset: CoverPreset
  ) {
    response: list(
      locale: $locale
      slug: $slug
      orderBy: $orderBy
      page: $page
      take: $take
    ) @disableAuth {
      title
      items {
        __typename
        ... on BaseMedia {
          display {
            title
          }
          slug
          cover(size: $coverSize, preset: $coverPreset)
        }
      }
    }
  }
`;

// src/~graphql/queries/GQL_GET_FOOTER.ts
import { gql as gql35 } from "@apollo/client";
var GQL_GET_FOOTER_default = gql35`
  query FooterQuery($locale: Locale!, $brand: Brand!) {
    response: footer(locale: $locale, brand: $brand) @disableAuth {
      copyright
      authority
      authorityLink
      commission
      commissionLink
      social {
        name
        icon
        link {
          url
        }
      }
      items {
        label
        link {
          link_type
          type
          uid
          target
          slug
          url
        }
      }
    }
  }
`;

// src/~graphql/queries/GQL_GET_REMOTE_AUTHENTICATION.ts
import { gql as gql37 } from "@apollo/client";

// src/~graphql/fragments/REMOTE_AUTHENTICATION_FRAGMENT.ts
import { gql as gql36 } from "@apollo/client";
var REMOTE_AUTHENTICATION_FRAGMENT_default = gql36`
  fragment RemoteAuthenticationParts on RemoteAuthentication {
    id
    accessCode
    url
    qrUrl
    status
    intent
    locale
    createdAt
    expiresAt
    initDevice {
      id
      type
      model
      manufacturer
      version
    }
    remoteDevice {
      id
      type
      model
      manufacturer
      version
    }
    token
  }
`;

// src/~graphql/queries/GQL_GET_REMOTE_AUTHENTICATION.ts
var GQL_GET_REMOTE_AUTHENTICATION_default = gql37`
  query GetRemoteAuthenticationQuery($accessCode: ID!, $locale: Locale!) {
    response: remoteAuthentication(accessCode: $accessCode, locale: $locale) {
      ...RemoteAuthenticationParts
    }
  }
  ${REMOTE_AUTHENTICATION_FRAGMENT_default}
`;

// src/~graphql/queries/GQL_PLAYABLE_METADATA.ts
import { gql as gql38 } from "@apollo/client";
var GQL_PLAYABLE_METADATA_default = gql38`
  query PlayableMetadataQuery($slug: ID!, $locale: Locale!) {
    response: media(slug: $slug, locale: $locale) {
      ... on Playable {
        id
        slug
        creditsStart
        introStart
        introEnd
      }
    }
  }
`;

// src/~graphql/queries/GQL_GET_APP_INFO.ts
import { gql as gql39 } from "@apollo/client";
var GQL_GET_APP_INFO_default = gql39`
  query AppInfoQuery($deviceType: [DeviceType!]) {
    response: apps(deviceType: $deviceType) {
      __typename
      id
      deviceType
      latestVersionReleaseDate
      latestVersion
      ... on WebApp {
        url
      }
      ... on NativeApp {
        appId
        storeUrl
      }
      ... on SmartTvApp {
        tvStoreUrl: storeUrl
      }
    }
  }
`;

// src/~graphql/queries/GQL_NEXT_ACTIONS.ts
import { gql as gql40 } from "@apollo/client";
var GQL_NEXT_ACTIONS_default = gql40`
  query GetNextActionsQuery(
    $slug: ID
    $locale: Locale!
    $take: Int = 3
    $context: NextActionContext!
  ) {
    nextActions(locale: $locale, slug: $slug, take: $take, context: $context) {
      items {
        item {
          __typename
          ... on NextActionProposePurchaseContent {
            content {
              __typename
              ... on BaseMedia {
                slug
              }
            }
          }
          ... on NextActionPlayContent {
            media {
              __typename
              slug
            }
          }
        }
      }
    }
  }
`;

// src/~graphql/queries/GQL_GET_PURCHASABLE.ts
import { gql as gql41 } from "@apollo/client";
var GQL_GET_PURCHASABLE_default = gql41`
  query GetPurchasableQuery(
    $locale: Locale!
    $slug: ID!
    $coverSize: CoverSize
    $coverPreset: CoverPreset
  ) {
    purchasable(slug: $slug, locale: $locale) {
      slug
      ...DisplayableInCollectionFragment
      ...LinkTargetFragment

      ... on BaseMedia {
        mediaImages

        subtitles {
          language
        }

        tags(take: 20) {
          ...TagsFragment
        }

        audio {
          tracks {
            language
            sound {
              channels
              format
            }
          }
        }
      }
      ... on Season {
        seriesSlug
        seasonNo
        firstEpisode {
          slug
        }
      }
      ... on Episode {
        seriesSlug
        seasonNo
      }

      ... on Ticket {
        mediaImages
      }

      ... on MetaCollectionBundle {
        mediaImages
        subtitles {
          language
        }
        audio {
          tracks {
            language
            sound {
              channels
              format
            }
          }
        }

        displayableItems {
          slug
          ...LinkTargetFragment
          ...DisplayableInCollectionFragment
          ... on Movie {
            releaseYear
            durationString(format: "h _ mm _")
            ratings {
              imdb
            }
            genres
            ageLimitString
          }
          ... on Series {
            ratings {
              imdb
            }
            ageLimitString
          }
        }
      }
    }
  }

  ${DISPLAYABLE_IN_COLLECTION_FRAGMENT_default}
  ${LINK_TARGET_FRAGMENT}
`;

// src/~graphql/queries/GQL_GET_TICKET.ts
import { gql as gql42 } from "@apollo/client";
var GQL_GET_TICKET_default = gql42`
  query GetTicketQuery(
    $locale: Locale!
    $slug: ID!
    $recommendationTake: Int
    $mainMediaSize: MediaSize
    $mainMediaPreset: MediaPreset
    $device: DeviceInput
    $coverSize: CoverSize
    $coverPreset: CoverPreset
  ) {
    ticket(slug: $slug, locale: $locale) {
      ...DisplayableInCollectionFragment
      ...LinkTargetFragment

      slug
      id
      originalTitle
      isPurchasable
      longSummary
      lowestPriceString(device: $device)
      mediaImages(size: $mainMediaSize, preset: $mainMediaPreset)
      url

      tags(take: 20) {
        ...TagsFragment
      }

      similar(take: $recommendationTake) {
        ...DisplayableInCollectionFragment
        ...LinkTargetFragment
      }

      localization {
        id
        locale
        items
      }
    }
  }
  ${DISPLAYABLE_IN_COLLECTION_FRAGMENT_default}
  ${LINK_TARGET_FRAGMENT}
`;

// src/~graphql/queries/GQL_GET_TICKETS.ts
import { gql as gql43 } from "@apollo/client";
var GQL_GET_TICKETS_default = gql43`
  query GetTicketsQuery(
    $locale: Locale!
    $coverSize: CoverSize
    $coverPreset: CoverPreset
    $first: Int
    $after: String
    $device: DeviceInput!
    $orderBy: ListOrderBy
  ) {
    tickets(
      locale: $locale
      first: $first
      after: $after
      orderBy: $orderBy
      device: $device
    ) {
      sortOptions {
        titleKey
        active
        orderBy
        arrangement {
          reverse
          default
          active
        }
      }
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          ...DisplayableInCollectionFragment
          ... on Ticket {
            numberOfTickets
            lowestPriceString(device: $device)
            numberOfTickets
            url
          }
        }
      }
    }
  }
  ${DISPLAYABLE_IN_COLLECTION_FRAGMENT_default}
`;

// src/~graphql/queries/GQL_GET_CUSTOMER_SUPPORT_ARTICLE.ts
import { gql as gql44 } from "@apollo/client";
var GQL_GET_CUSTOMER_SUPPORT_ARTICLE_default = gql44`
  query GetCustomerSupportArticleQuery($locale: Locale!, $slug: ID!) {
    response: supportArticle(locale: $locale, slug: $slug) {
      __typename
      id
      slug
      title
      updatedAt
      body
      tags {
        __typename
        id
        name
      }
      category {
        __typename
        id
        slug
        name
      }
    }
  }
`;

// src/~graphql/queries/GQL_GET_CUSTOMER_SUPPORT_CATEGORIES.ts
import { gql as gql45 } from "@apollo/client";
var GQL_GET_CUSTOMER_SUPPORT_CATEGORIES_default = gql45`
  query GetCustomerSupportCategoriesQuery($locale: Locale!) {
    response: supportCategories(locale: $locale) {
      __typename
      id
      slug
      name
      description
      icon
      articles {
        __typename
        title
        id
        slug
        category {
          __typename
          id
          slug
        }
      }
    }
  }
`;

// src/~graphql/queries/GQL_GET_SEARCH.ts
import { gql as gql46 } from "@apollo/client";
var GQL_GET_SEARCH_default = gql46`
  query SearchQuery($requests: [JSON!]!) {
    response: search(requests: $requests) @disableAuth {
      __typename
      results
    }
  }
`;

// src/~graphql/mutations/GQL_ACCOUNT_OAUTH.ts
import { gql as gql47 } from "@apollo/client";
var GQL_ACCOUNT_OAUTH_default = gql47`
  mutation RequestOAuthToken(
    $provider: AuthProvider!
    $returnUrl: String!
    $locale: Locale!
  ) {
    response: requestOAuthToken(
      provider: $provider
      returnUrl: $returnUrl
      locale: $locale
    ) @disableAuth {
      __typename
      url
      provider
    }
  }
`;

// src/~graphql/mutations/GQL_ACCOUNT_AUTHORIZATION.ts
import { gql as gql48 } from "@apollo/client";
var GQL_ACCOUNT_AUTHORIZATION_default = gql48`
  mutation CreateAuthToken($username: ID!, $password: String!) {
    response: createAuthToken(username: $username, password: $password)
      @disableAuth {
      accountId
      token
      refreshToken
      expires
    }
  }
`;

// src/~graphql/mutations/GQL_ACCOUNT_AUTHORIZATION_REFRESH.ts
import { gql as gql49 } from "@apollo/client";
var GQL_ACCOUNT_AUTHORIZATION_REFRESH_default = gql49`
  mutation RefreshAuthToken($refreshToken: String!) {
    response: refreshAuthToken(refreshToken: $refreshToken) {
      accountId
      token
      refreshToken
      expires
    }
  }
`;

// src/~graphql/mutations/GQL_ACCOUNT_AUTHORIZATION_ADDITIONAL.ts
import { gql as gql50 } from "@apollo/client";
var GQL_ACCOUNT_AUTHORIZATION_ADDITIONAL_default = gql50`
  mutation CreateAdditionalAuthToken {
    response: createAdditionalAuthToken {
      accountId
      token
      refreshToken
      expires
    }
  }
`;

// src/~graphql/mutations/GQL_ACCOUNT_AUTHORIZATION_LOGOUT_ALL.ts
import { gql as gql51 } from "@apollo/client";
var GQL_ACCOUNT_AUTHORIZATION_LOGOUT_ALL_default = gql51`
  mutation LogoutAll {
    response: logoutAll
  }
`;

// src/~graphql/mutations/GQL_CREATE_ACCOUNT.ts
import { gql as gql52 } from "@apollo/client";
var GQL_CREATE_ACCOUNT_default = gql52`
  mutation CreateAccount($input: AccountCreateInput!) {
    response: createAccount(input: $input) {
      ...AccountParts
    }
  }
  ${ACCOUNT_DETAILS_FRAGMENT_default}
`;

// src/~graphql/mutations/GQL_SEND_LOGS.ts
import { gql as gql53 } from "@apollo/client";
var GQL_SEND_LOGS = gql53`
  mutation GQL_SEND_LOGS($logs: [Log!]) {
    response: log(logs: $logs)
  }
`;
var GQL_SEND_LOGS_default = GQL_SEND_LOGS;

// src/~graphql/mutations/GQL_FORGOT_PASSWORD.ts
import { gql as gql54 } from "@apollo/client";
var GQL_FORGOT_PASSWORD_default = gql54`
  mutation ForgotPasswordMutation($username: ID!) {
    response: forgotPassword(username: $username)
  }
`;

// src/~graphql/mutations/GQL_RESET_PASSWORD.ts
import { gql as gql55 } from "@apollo/client";
var GQL_RESET_PASSWORD_default = gql55`
  mutation ResetPasswordMutation($token: String!, $newPassword: String!) {
    response: resetPassword(token: $token, newPassword: $newPassword)
  }
`;

// src/~graphql/mutations/GQL_UPDATE_BOOKMARK.ts
import { gql as gql56 } from "@apollo/client";
var GQL_UPDATE_BOOKMARK_default = gql56`
  mutation UpdateBookmarksMutation(
    $slug: ID!
    $value: String
    $seconds: Float
    $watched: Boolean
    $coverSize: CoverSize
    $coverPreset: CoverPreset
  ) {
    setBookmark(
      slug: $slug
      value: $value
      seconds: $seconds
      watched: $watched
    ) {
      ...BookmarkParts
    }
  }
  ${BOOKMARK_FRAGMENT_default}
`;

// src/~graphql/mutations/GQL_ADD_FAVORITE.ts
import { gql as gql57 } from "@apollo/client";
var GQL_ADD_FAVORITE_default = gql57`
  mutation AddFavoriteMutation(
    $slug: ID
    $locale: Locale
    $coverSize: CoverSize
    $coverPreset: CoverPreset
  ) {
    response: addFavorite(slug: $slug, locale: $locale) {
      id
      ...FavoritesFragment
    }
  }

  ${FAVORITES_FRAGMENT_default}
`;

// src/~graphql/mutations/GQL_REMOVE_FAVORITE.ts
import { gql as gql58 } from "@apollo/client";
var GQL_REMOVE_FAVORITE_default = gql58`
  mutation RemoveFavoriteMutation(
    $slug: ID
    $locale: Locale
    $coverSize: CoverSize
    $coverPreset: CoverPreset
  ) {
    response: removeFavorite(slug: $slug, locale: $locale) {
      id
      ...FavoritesFragment
      item: displayableItem {
        ...DisplayableInCollectionFragment
      }
    }
  }
  ${DISPLAYABLE_IN_COLLECTION_FRAGMENT_default}
  ${FAVORITES_FRAGMENT_default}
`;

// src/~graphql/mutations/GQL_DELETE_ACCOUNT.ts
import { gql as gql59 } from "@apollo/client";
var GQL_DELETE_ACCOUNT_default = gql59`
  mutation DeleteAccountMutation($input: AccountDeleteInput!) {
    response: deleteAccount(input: $input)
  }
`;

// src/~graphql/mutations/GQL_EXPORT_ACCOUNT.ts
import { gql as gql60 } from "@apollo/client";
var GQL_EXPORT_ACCOUNT_default = gql60`
  mutation ExportAccountMutation($input: AccountExportInput!) {
    response: exportAccount(input: $input)
  }
`;

// src/~graphql/mutations/GQL_UPDATE_ACCOUNT_EMAIL.ts
import { gql as gql61 } from "@apollo/client";
var GQL_UPDATE_ACCOUNT_EMAIL_default = gql61`
  mutation UpdateAccountEmailMutation($input: AccountUpdateEmailInput!) {
    response: updateAccountEmail(input: $input) {
      ...AccountParts
    }
  }
  ${ACCOUNT_DETAILS_FRAGMENT_default}
`;

// src/~graphql/mutations/GQL_UPDATE_ACCOUNT_INFORMATION.ts
import { gql as gql62 } from "@apollo/client";
var GQL_UPDATE_ACCOUNT_INFORMATION_default = gql62`
  mutation UpdateAccountInformationMutation($input: AccountUpdateInput!) {
    response: updateAccount(input: $input) {
      ...AccountParts
    }
  }
  ${ACCOUNT_DETAILS_FRAGMENT_default}
`;

// src/~graphql/mutations/GQL_UPDATE_ACCOUNT_PASSWORD.ts
import { gql as gql63 } from "@apollo/client";
var GQL_UPDATE_ACCOUNT_PASSWORD_default = gql63`
  mutation UpdateAccountPasswordMutation($input: AccountUpdatePasswordInput!) {
    response: updateAccountPassword(input: $input) {
      ...AccountParts
    }
  }
  ${ACCOUNT_DETAILS_FRAGMENT_default}
`;

// src/~graphql/mutations/GQL_DELETE_SAVED_SEARCH.ts
import { gql as gql64 } from "@apollo/client";
var GQL_DELETE_SAVED_SEARCH_default = gql64`
  mutation DeleteSavedSearch($id: ID!, $locale: Locale!) {
    response: deleteSavedSearch(id: $id, locale: $locale) {
      id
      locale
      __typename
    }
  }
`;

// src/~graphql/mutations/GQL_CREATE_SAVED_SEARCH.ts
import { gql as gql65 } from "@apollo/client";
var GQL_CREATE_SAVED_SEARCH_default = gql65`
  mutation CreateSavedSearch(
    $locale: Locale!
    $input: CreateSavedSearchInput!
    $type: SavedSearchType!
    $coverPreset: CoverPreset
    $coverSize: CoverSize
  ) {
    response: createSavedSearch(locale: $locale, type: $type, input: $input) {
      __typename
      ... on SingleTitleSavedSearch {
        id
        locale
        slug
        item {
          ...DisplayableInCollectionFragment
        }
      }
      ... on GenericSavedSearch {
        id
        locale
        algoliaFilter
        freeText
      }
      ... on TitlesInSeriesSavedSearch {
        id
        locale
        seriesSlug
      }
    }
  }

  ${DISPLAYABLE_IN_COLLECTION_FRAGMENT_default}
  ${LINK_TARGET_FRAGMENT}
`;

// src/~graphql/mutations/GQL_UPDATE_TRANSACTION.ts
import { gql as gql66 } from "@apollo/client";
var GQL_UPDATE_TRANSACTION_default = gql66`
  mutation UpdateTransactionMutation(
    $id: ID!
    $input: TransactionUpdateInput!
    $locale: Locale!
    $device: DeviceInput!
  ) {
    response: updateTransaction(id: $id, input: $input, locale: $locale) {
      ...TransactionParts
    }
  }
  ${TRANSACTION_FRAGMENT_default}
`;

// src/~graphql/mutations/GQL_CREATE_TRANSACTION.ts
import { gql as gql67 } from "@apollo/client";
var GQL_CREATE_TRANSACTION_default = gql67`
  mutation CreateTransactionMutation(
    $input: TransactionCreateInput!
    $locale: Locale!
    $device: DeviceInput!
  ) {
    response: createTransaction(input: $input, locale: $locale) {
      ...TransactionParts
    }
  }
  ${TRANSACTION_FRAGMENT_default}
`;

// src/~graphql/mutations/GQL_DELETE_PAYMENT_METHOD.ts
import { gql as gql68 } from "@apollo/client";
var GQL_DELETE_PAYMENT_METHOD_default = gql68`
  mutation DeletePaymentMethodMutation($id: ID!) {
    response: deletePaymentMethod(id: $id) {
      ...AccountParts
    }
  }
  ${ACCOUNT_DETAILS_FRAGMENT_default}
`;

// src/~graphql/mutations/GQL_UPDATE_PAYMENT_METHODS.ts
import { gql as gql69 } from "@apollo/client";
var GQL_UPDATE_PAYMENT_METHODS_default = gql69`
  mutation UpdateAccountPaymentMethods(
    $input: UpdateAccountPaymentMethodsInput!
  ) {
    response: updateAccountPaymentMethods(input: $input) {
      status
      payment
      account {
        ...AccountParts
      }
    }
  }
  ${ACCOUNT_DETAILS_FRAGMENT_default}
`;

// src/~graphql/mutations/GQL_INIT_UPDATE_ACCOUNT_PAYMENT_METHODS.ts
import { gql as gql70 } from "@apollo/client";
var GQL_INIT_UPDATE_ACCOUNT_PAYMENT_METHODS_default = gql70`
  mutation InitUpdateAccountPaymentMethods {
    response: initUpdateAccountPaymentMethods
  }
`;

// src/~graphql/mutations/GQL_VERIFY_UNKNOWN_RECEIPT.ts
import { gql as gql71 } from "@apollo/client";
var GQL_VERIFY_UNKNOWN_RECEIPT_default = gql71`
  mutation VerifyUnknownReceipt($input: UnknownReceiptInput!) {
    verifyUnknownInAppPurchaseReceipt(input: $input) {
      __typename
      message
      action {
        ... on RedirectAction {
          __typename
          url
        }
      }
    }
  }
`;

// src/~graphql/mutations/GQL_CREATE_VOUCHER_ORDER.ts
import { gql as gql72 } from "@apollo/client";
var GQL_CREATE_VOUCHER_ORDER_default = gql72`
  mutation CreateVoucherOrderMutation(
    $input: CreateVoucherOrderInput!
    $locale: Locale!
  ) {
    response: createVoucherOrder(input: $input, locale: $locale) {
      __typename
      ID
      status
      paymentLink
      paymentLinkExpireAt

      vouchersExpireAt

      tvodAmount
      tvodAmountString
      tvodAmountExclVat
      tvodAmountExclVatString

      tvodSumAmount
      tvodSumAmountString
      tvodSumAmountExclVat
      tvodSumAmountExclVatString

      estAmount
      estAmountString
      estAmountExclVat
      estAmountExclVatString

      estSumAmount
      estSumAmountString
      estSumAmountExclVat
      estSumAmountExclVatString

      receipt {
        __typename

        orderId
        currency

        paidAmount
        paidAmountString
        paidAmountExclVat
        paidAmountExclVatString

        discountAmount
        discountAmountString
        discountAmountExclVat
        discountAmountExclVatString

        originalPrice
        originalPriceString
        originalPriceExclVat
        originalPriceExclVatString

        feeAmount
        feeAmountString

        vatAmount
        vatAmountString

        campaignPrice
        campaignPriceString

        orderCreatedAt
      }

      tvodBulkPricingMaxPercentageDiscount
      tvodBulkPricing {
        __typename
        active
        rangeMin
        rangeMax
        discountPrice
        discountPriceString
        discountPriceExclVat
        discountPriceExclVatString
        discountPercentage
      }
    }
  }
`;

// src/~graphql/mutations/GQL_ADD_NOTIFICATION_TOKEN.ts
import { gql as gql73 } from "@apollo/client";
var GQL_ADD_NOTIFICATION_TOKEN_default = gql73`
  mutation AddNotificationTokenMutation($token: String!) {
    addNotificationToken(token: $token)
  }
`;

// src/~graphql/mutations/GQL_CREATE_REMOTE_AUTHENTICATION.ts
import { gql as gql74 } from "@apollo/client";
var GQL_CREATE_REMOTE_AUTHENTICATION_default = gql74`
  mutation CreateRemoteAuthenticationMutation(
    $locale: Locale!
    $input: RemoteAuthenticationCreateInput!
  ) {
    response: createRemoteAuthentication(locale: $locale, input: $input) {
      ...RemoteAuthenticationParts
    }
  }
  ${REMOTE_AUTHENTICATION_FRAGMENT_default}
`;

// src/~graphql/mutations/GQL_UPDATE_REMOTE_AUTHENTICATION.ts
import { gql as gql75 } from "@apollo/client";
var GQL_UPDATE_REMOTE_AUTHENTICATION_default = gql75`
  mutation UpdateRemoteAuthenticationMutation(
    $locale: Locale!
    $input: RemoteAuthenticationUpdateInput!
  ) {
    response: updateRemoteAuthentication(locale: $locale, input: $input) {
      ...RemoteAuthenticationParts
    }
  }
  ${REMOTE_AUTHENTICATION_FRAGMENT_default}
`;

// src/~graphql/subscriptions/GQL_UPDATED_TRANSACTION_SUBSCRIPTION.ts
import { gql as gql76 } from "@apollo/client";
var GQL_UPDATED_TRANSACTION_SUBSCRIPTION_default = gql76`
  subscription UpdatedTransactionSubscription(
    $accessCode: String!
    $locale: Locale!
    $device: DeviceInput!
  ) {
    response: transactionUpdated(accessCode: $accessCode, locale: $locale) {
      ...TransactionParts
    }
  }
  ${TRANSACTION_FRAGMENT_default}
`;

// src/~graphql/subscriptions/GQL_ENTITLEMENT_CREATED_SUBSCRIPTION.ts
import { gql as gql77 } from "@apollo/client";
var GQL_ENTITLEMENT_CREATED_SUBSCRIPTION_default = gql77`
  subscription EntitlementCreatedSubscription {
    response: entitlementCreated {
      mediaId
    }
  }
`;

// src/~graphql/subscriptions/GQL_UPDATED_REMOTE_AUTHENTICATION_SUBSCRIPTION.ts
import { gql as gql78 } from "@apollo/client";
var GQL_UPDATED_REMOTE_AUTHENTICATION_SUBSCRIPTION_default = gql78`
  subscription UpdatedRemoteAuthenticationSubscription(
    $accessCode: ID!
    $locale: Locale!
  ) {
    response: remoteAuthenticationUpdated(
      accessCode: $accessCode
      locale: $locale
    ) {
      ...RemoteAuthenticationParts
    }
  }
  ${REMOTE_AUTHENTICATION_FRAGMENT_default}
`;

// src/~graphql/subscriptions/GQL_ACCOUNT_EVENT_SUBSCRIPTION.ts
import { gql as gql79 } from "@apollo/client";
var GQL_ACCOUNT_EVENT_SUBSCRIPTION_default = gql79`
  subscription AccountEventSubscription($locale: Locale!) {
    response: accountEvent(locale: $locale) {
      id
      type
      action
      payload
    }
  }
`;

// src/~graphql/schema/localSchema.ts
import { gql as gql80 } from "@apollo/client";
var localSchema_default = gql80`
  directive @disableAuth on FIELD

  type InternalRoute {
    target: FeatureTarget!
  }

  type InternalSite {
    url: String!
  }

  union LinkTarget = InternalRoute | InternalSite

  extend interface DisplayableInCollection {
    linkTarget: LinkTarget
  }
`;

// src/~graphql/manualTypes.ts
var Currency = /* @__PURE__ */ ((Currency2) => {
  Currency2["DKK"] = "DKK";
  Currency2["EUR"] = "EUR";
  Currency2["NOK"] = "NOK";
  Currency2["SEK"] = "SEK";
  return Currency2;
})(Currency || {});

// src/~graphql/types.ts
var AccountEventAction = /* @__PURE__ */ ((AccountEventAction3) => {
  AccountEventAction3["REMOTE_AUTHENTICATION_STARTED"] = "REMOTE_AUTHENTICATION_STARTED";
  AccountEventAction3["TRANSACTION_STARTED"] = "TRANSACTION_STARTED";
  return AccountEventAction3;
})(AccountEventAction || {});
var AccountEventType = /* @__PURE__ */ ((AccountEventType2) => {
  AccountEventType2["BACKGROUND"] = "BACKGROUND";
  AccountEventType2["EVENT"] = "EVENT";
  AccountEventType2["PUSH"] = "PUSH";
  return AccountEventType2;
})(AccountEventType || {});
var AdyenChannel = /* @__PURE__ */ ((AdyenChannel2) => {
  AdyenChannel2["Android"] = "Android";
  AdyenChannel2["Web"] = "Web";
  AdyenChannel2["iOS"] = "iOS";
  return AdyenChannel2;
})(AdyenChannel || {});
var AdyenEnvironment = /* @__PURE__ */ ((AdyenEnvironment2) => {
  AdyenEnvironment2["live"] = "live";
  AdyenEnvironment2["test"] = "test";
  return AdyenEnvironment2;
})(AdyenEnvironment || {});
var AppEnvironment = /* @__PURE__ */ ((AppEnvironment2) => {
  AppEnvironment2["alpha"] = "alpha";
  AppEnvironment2["development"] = "development";
  AppEnvironment2["production"] = "production";
  AppEnvironment2["staging"] = "staging";
  return AppEnvironment2;
})(AppEnvironment || {});
var AuthProvider = /* @__PURE__ */ ((AuthProvider2) => {
  AuthProvider2["apple"] = "apple";
  AuthProvider2["facebook"] = "facebook";
  AuthProvider2["google"] = "google";
  return AuthProvider2;
})(AuthProvider || {});
var AvatarPreset = /* @__PURE__ */ ((AvatarPreset3) => {
  AvatarPreset3["circle"] = "circle";
  AvatarPreset3["default"] = "default";
  return AvatarPreset3;
})(AvatarPreset || {});
var AvatarSize = /* @__PURE__ */ ((AvatarSize3) => {
  AvatarSize3["default"] = "default";
  AvatarSize3["large"] = "large";
  AvatarSize3["master"] = "master";
  AvatarSize3["medium"] = "medium";
  AvatarSize3["small"] = "small";
  return AvatarSize3;
})(AvatarSize || {});
var Brand = /* @__PURE__ */ ((Brand3) => {
  Brand3["Blockbuster"] = "Blockbuster";
  Brand3["SFAnytime"] = "SFAnytime";
  return Brand3;
})(Brand || {});
var ConfigType = /* @__PURE__ */ ((ConfigType3) => {
  ConfigType3["ALGOLIASEARCH_API_KEY_SEARCH"] = "ALGOLIASEARCH_API_KEY_SEARCH";
  ConfigType3["ALGOLIASEARCH_APPLICATION_ID"] = "ALGOLIASEARCH_APPLICATION_ID";
  ConfigType3["ALGOLIASEARCH_INDEX"] = "ALGOLIASEARCH_INDEX";
  ConfigType3["AMPLITUDE_KEY"] = "AMPLITUDE_KEY";
  ConfigType3["APP_DEBUG"] = "APP_DEBUG";
  ConfigType3["APP_ENV"] = "APP_ENV";
  ConfigType3["CHATLIO_ID"] = "CHATLIO_ID";
  ConfigType3["CHECKOUT_URL"] = "CHECKOUT_URL";
  ConfigType3["CHROMECAST_ID"] = "CHROMECAST_ID";
  ConfigType3["FACEBOOK_PIXEL_ID"] = "FACEBOOK_PIXEL_ID";
  ConfigType3["FRMX_URL"] = "FRMX_URL";
  ConfigType3["GOOGLE_ANALYTICS_ID"] = "GOOGLE_ANALYTICS_ID";
  ConfigType3["GOOGLE_ANALYTICS_V4_ID"] = "GOOGLE_ANALYTICS_V4_ID";
  ConfigType3["GOOGLE_TAG_MANAGER_ID"] = "GOOGLE_TAG_MANAGER_ID";
  ConfigType3["MUX_KEY"] = "MUX_KEY";
  ConfigType3["SENTRY_AUTH_TOKEN"] = "SENTRY_AUTH_TOKEN";
  ConfigType3["SENTRY_DSN"] = "SENTRY_DSN";
  ConfigType3["SENTRY_ORG"] = "SENTRY_ORG";
  ConfigType3["SENTRY_PROJECT"] = "SENTRY_PROJECT";
  ConfigType3["WEBVIEW_CHECKOUT_URL"] = "WEBVIEW_CHECKOUT_URL";
  ConfigType3["WEBVIEW_TICKETS_URL"] = "WEBVIEW_TICKETS_URL";
  ConfigType3["WEB_URL_CHECKOUT_PATTERN"] = "WEB_URL_CHECKOUT_PATTERN";
  ConfigType3["WEB_URL_DOMAIN"] = "WEB_URL_DOMAIN";
  ConfigType3["WEB_URL_PROFILE_PATTERN"] = "WEB_URL_PROFILE_PATTERN";
  ConfigType3["WEB_URL_REMOTE"] = "WEB_URL_REMOTE";
  ConfigType3["WEB_URL_SUPPORT"] = "WEB_URL_SUPPORT";
  return ConfigType3;
})(ConfigType || {});
var ContentCollectionAlignment = /* @__PURE__ */ ((ContentCollectionAlignment2) => {
  ContentCollectionAlignment2["Bottom"] = "Bottom";
  ContentCollectionAlignment2["Center"] = "Center";
  ContentCollectionAlignment2["Left"] = "Left";
  ContentCollectionAlignment2["Right"] = "Right";
  ContentCollectionAlignment2["Top"] = "Top";
  return ContentCollectionAlignment2;
})(ContentCollectionAlignment || {});
var ContentCollectionSize = /* @__PURE__ */ ((ContentCollectionSize2) => {
  ContentCollectionSize2["base"] = "base";
  ContentCollectionSize2["lg"] = "lg";
  ContentCollectionSize2["sm"] = "sm";
  ContentCollectionSize2["xl"] = "xl";
  ContentCollectionSize2["xs"] = "xs";
  return ContentCollectionSize2;
})(ContentCollectionSize || {});
var ContentCollectionTargetMediaAction = /* @__PURE__ */ ((ContentCollectionTargetMediaAction2) => {
  ContentCollectionTargetMediaAction2["CDP"] = "CDP";
  ContentCollectionTargetMediaAction2["CHECKOUT"] = "CHECKOUT";
  return ContentCollectionTargetMediaAction2;
})(ContentCollectionTargetMediaAction || {});
var CountryOfResidence = /* @__PURE__ */ ((CountryOfResidence2) => {
  CountryOfResidence2["dk"] = "dk";
  CountryOfResidence2["fi"] = "fi";
  CountryOfResidence2["no"] = "no";
  CountryOfResidence2["se"] = "se";
  return CountryOfResidence2;
})(CountryOfResidence || {});
var CoverPreset = /* @__PURE__ */ ((CoverPreset6) => {
  CoverPreset6["blurFill"] = "blurFill";
  CoverPreset6["default"] = "default";
  CoverPreset6["lowQuality"] = "lowQuality";
  return CoverPreset6;
})(CoverPreset || {});
var CoverSize = /* @__PURE__ */ ((CoverSize6) => {
  CoverSize6["default"] = "default";
  CoverSize6["large"] = "large";
  CoverSize6["master"] = "master";
  CoverSize6["medium"] = "medium";
  CoverSize6["small"] = "small";
  CoverSize6["smarttv"] = "smarttv";
  return CoverSize6;
})(CoverSize || {});
var DeviceType = /* @__PURE__ */ ((DeviceType3) => {
  DeviceType3["Android"] = "Android";
  DeviceType3["AndroidTv"] = "AndroidTv";
  DeviceType3["Backend"] = "Backend";
  DeviceType3["ChromeCast"] = "ChromeCast";
  DeviceType3["SmartTv"] = "SmartTv";
  DeviceType3["UnknownType"] = "UnknownType";
  DeviceType3["Web"] = "Web";
  DeviceType3["iOS"] = "iOS";
  DeviceType3["tvOS"] = "tvOS";
  return DeviceType3;
})(DeviceType || {});
var DisplayTagAppearance = /* @__PURE__ */ ((DisplayTagAppearance2) => {
  DisplayTagAppearance2["CUSTOM"] = "CUSTOM";
  DisplayTagAppearance2["FILLED"] = "FILLED";
  DisplayTagAppearance2["FILLED_SCORE"] = "FILLED_SCORE";
  DisplayTagAppearance2["ICON"] = "ICON";
  DisplayTagAppearance2["OUTLINED"] = "OUTLINED";
  return DisplayTagAppearance2;
})(DisplayTagAppearance || {});
var FeatureToggle = /* @__PURE__ */ ((FeatureToggle3) => {
  FeatureToggle3["APPLE_PAY"] = "APPLE_PAY";
  FeatureToggle3["ASK_FOR_REVIEW"] = "ASK_FOR_REVIEW";
  FeatureToggle3["BUNDLES"] = "BUNDLES";
  FeatureToggle3["DISABLEEXTERNALLINKS"] = "DISABLEEXTERNALLINKS";
  FeatureToggle3["NATIVEPAYMENTONLY"] = "NATIVEPAYMENTONLY";
  FeatureToggle3["NOTIFICATION_TOPICS"] = "NOTIFICATION_TOPICS";
  FeatureToggle3["PAYMENT"] = "PAYMENT";
  FeatureToggle3["PERSONALIZATION"] = "PERSONALIZATION";
  FeatureToggle3["PREMB2C"] = "PREMB2C";
  FeatureToggle3["PROFILING"] = "PROFILING";
  FeatureToggle3["SEARCH"] = "SEARCH";
  FeatureToggle3["SOCIAL_LOGIN"] = "SOCIAL_LOGIN";
  FeatureToggle3["TICKETS"] = "TICKETS";
  return FeatureToggle3;
})(FeatureToggle || {});
var ListOrderBy = /* @__PURE__ */ ((ListOrderBy6) => {
  ListOrderBy6["AZ_ASC"] = "AZ_ASC";
  ListOrderBy6["AZ_DESC"] = "AZ_DESC";
  ListOrderBy6["COMING_ASC"] = "COMING_ASC";
  ListOrderBy6["COMING_DESC"] = "COMING_DESC";
  ListOrderBy6["DEFAULT"] = "DEFAULT";
  ListOrderBy6["DEFAULT_ASC"] = "DEFAULT_ASC";
  ListOrderBy6["DURATION_ASC"] = "DURATION_ASC";
  ListOrderBy6["DURATION_DESC"] = "DURATION_DESC";
  ListOrderBy6["EST_TOP"] = "EST_TOP";
  ListOrderBy6["EST_TOP_ASC"] = "EST_TOP_ASC";
  ListOrderBy6["FIRST_RELEASED_ASC"] = "FIRST_RELEASED_ASC";
  ListOrderBy6["FIRST_RELEASED_DESC"] = "FIRST_RELEASED_DESC";
  ListOrderBy6["IMDB_ASC"] = "IMDB_ASC";
  ListOrderBy6["IMDB_DESC"] = "IMDB_DESC";
  ListOrderBy6["NONE"] = "NONE";
  ListOrderBy6["PRICE_ASC"] = "PRICE_ASC";
  ListOrderBy6["PRICE_DESC"] = "PRICE_DESC";
  ListOrderBy6["PUBLISH_ASC"] = "PUBLISH_ASC";
  ListOrderBy6["PUBLISH_DESC"] = "PUBLISH_DESC";
  ListOrderBy6["TOP"] = "TOP";
  ListOrderBy6["TOP_ASC"] = "TOP_ASC";
  ListOrderBy6["TVOD_TOP"] = "TVOD_TOP";
  ListOrderBy6["TVOD_TOP_ASC"] = "TVOD_TOP_ASC";
  ListOrderBy6["YEAR_ASC"] = "YEAR_ASC";
  ListOrderBy6["YEAR_DESC"] = "YEAR_DESC";
  return ListOrderBy6;
})(ListOrderBy || {});
var ListOrderByArrangement = /* @__PURE__ */ ((ListOrderByArrangement2) => {
  ListOrderByArrangement2["ASC"] = "ASC";
  ListOrderByArrangement2["DESC"] = "DESC";
  ListOrderByArrangement2["UNKNOWN"] = "UNKNOWN";
  return ListOrderByArrangement2;
})(ListOrderByArrangement || {});
var Locale = /* @__PURE__ */ ((Locale10) => {
  Locale10["da"] = "da";
  Locale10["en"] = "en";
  Locale10["fi"] = "fi";
  Locale10["no"] = "no";
  Locale10["sv"] = "sv";
  return Locale10;
})(Locale || {});
var LogLevel = /* @__PURE__ */ ((LogLevel2) => {
  LogLevel2["alert"] = "alert";
  LogLevel2["crit"] = "crit";
  LogLevel2["debug"] = "debug";
  LogLevel2["emerg"] = "emerg";
  LogLevel2["error"] = "error";
  LogLevel2["info"] = "info";
  LogLevel2["notice"] = "notice";
  LogLevel2["warn"] = "warn";
  LogLevel2["warning"] = "warning";
  return LogLevel2;
})(LogLevel || {});
var ManifestFilter = /* @__PURE__ */ ((ManifestFilter4) => {
  ManifestFilter4["EXCLUDE_SUBTITLES"] = "EXCLUDE_SUBTITLES";
  ManifestFilter4["LOW_END_BITRATES"] = "LOW_END_BITRATES";
  ManifestFilter4["ONLY_AC3_AUDIO_IF_AVAILABLE"] = "ONLY_AC3_AUDIO_IF_AVAILABLE";
  ManifestFilter4["ONLY_STEREO_AUDIO"] = "ONLY_STEREO_AUDIO";
  return ManifestFilter4;
})(ManifestFilter || {});
var MediaPreset = /* @__PURE__ */ ((MediaPreset3) => {
  MediaPreset3["aspect16x9"] = "aspect16x9";
  MediaPreset3["default"] = "default";
  return MediaPreset3;
})(MediaPreset || {});
var MediaSize = /* @__PURE__ */ ((MediaSize3) => {
  MediaSize3["default"] = "default";
  MediaSize3["large"] = "large";
  MediaSize3["master"] = "master";
  MediaSize3["medium"] = "medium";
  MediaSize3["small"] = "small";
  return MediaSize3;
})(MediaSize || {});
var MenuRoute = /* @__PURE__ */ ((MenuRoute2) => {
  MenuRoute2["ContentCollection"] = "ContentCollection";
  MenuRoute2["List"] = "List";
  return MenuRoute2;
})(MenuRoute || {});
var NextActionContext = /* @__PURE__ */ ((NextActionContext2) => {
  NextActionContext2["FinishedWatchingFeature"] = "FinishedWatchingFeature";
  NextActionContext2["FinishedWatchingTrailer"] = "FinishedWatchingTrailer";
  return NextActionContext2;
})(NextActionContext || {});
var OrderStatus = /* @__PURE__ */ ((OrderStatus2) => {
  OrderStatus2["abandoned"] = "abandoned";
  OrderStatus2["awaitingConfirmation"] = "awaitingConfirmation";
  OrderStatus2["error"] = "error";
  OrderStatus2["initialized"] = "initialized";
  OrderStatus2["paid"] = "paid";
  OrderStatus2["pending"] = "pending";
  OrderStatus2["refunded"] = "refunded";
  OrderStatus2["rejected"] = "rejected";
  return OrderStatus2;
})(OrderStatus || {});
var PaymentProcessor = /* @__PURE__ */ ((PaymentProcessor3) => {
  PaymentProcessor3["adyen"] = "adyen";
  PaymentProcessor3["apple"] = "apple";
  PaymentProcessor3["creditDebitCard"] = "creditDebitCard";
  PaymentProcessor3["dibs"] = "dibs";
  PaymentProcessor3["google"] = "google";
  PaymentProcessor3["klarna"] = "klarna";
  PaymentProcessor3["mpp"] = "mpp";
  PaymentProcessor3["none"] = "none";
  PaymentProcessor3["remoteCheckout"] = "remoteCheckout";
  PaymentProcessor3["sf"] = "sf";
  return PaymentProcessor3;
})(PaymentProcessor || {});
var PromosSize = /* @__PURE__ */ ((PromosSize2) => {
  PromosSize2["base"] = "base";
  PromosSize2["lg"] = "lg";
  PromosSize2["sm"] = "sm";
  PromosSize2["xl"] = "xl";
  PromosSize2["xs"] = "xs";
  return PromosSize2;
})(PromosSize || {});
var PurchaseType = /* @__PURE__ */ ((PurchaseType2) => {
  PurchaseType2["est"] = "est";
  PurchaseType2["tvod"] = "tvod";
  return PurchaseType2;
})(PurchaseType || {});
var RecommendationsType = /* @__PURE__ */ ((RecommendationsType2) => {
  RecommendationsType2["default"] = "default";
  RecommendationsType2["infobaleen"] = "infobaleen";
  RecommendationsType2["vionlabsOrderHistory"] = "vionlabsOrderHistory";
  return RecommendationsType2;
})(RecommendationsType || {});
var RemoteAuthenticationIntent = /* @__PURE__ */ ((RemoteAuthenticationIntent2) => {
  RemoteAuthenticationIntent2["Checkout"] = "Checkout";
  RemoteAuthenticationIntent2["Login"] = "Login";
  return RemoteAuthenticationIntent2;
})(RemoteAuthenticationIntent || {});
var RemoteAuthenticationStatus = /* @__PURE__ */ ((RemoteAuthenticationStatus2) => {
  RemoteAuthenticationStatus2["AUTHENTICATED"] = "AUTHENTICATED";
  RemoteAuthenticationStatus2["COMPLETED"] = "COMPLETED";
  RemoteAuthenticationStatus2["CONNECTED"] = "CONNECTED";
  RemoteAuthenticationStatus2["CREATED"] = "CREATED";
  RemoteAuthenticationStatus2["ERROR"] = "ERROR";
  return RemoteAuthenticationStatus2;
})(RemoteAuthenticationStatus || {});
var RentalType = /* @__PURE__ */ ((RentalType2) => {
  RentalType2["est"] = "est";
  RentalType2["tvod"] = "tvod";
  return RentalType2;
})(RentalType || {});
var SavedSearchType = /* @__PURE__ */ ((SavedSearchType2) => {
  SavedSearchType2["generic"] = "generic";
  SavedSearchType2["singletitle"] = "singletitle";
  SavedSearchType2["titlesinseries"] = "titlesinseries";
  return SavedSearchType2;
})(SavedSearchType || {});
var TagZoneCardGroup = /* @__PURE__ */ ((TagZoneCardGroup2) => {
  TagZoneCardGroup2["BOTTOM"] = "BOTTOM";
  TagZoneCardGroup2["DEFAULT"] = "DEFAULT";
  return TagZoneCardGroup2;
})(TagZoneCardGroup || {});
var TagZoneContext = /* @__PURE__ */ ((TagZoneContext2) => {
  TagZoneContext2["CARD"] = "CARD";
  TagZoneContext2["DESCRIPTION"] = "DESCRIPTION";
  TagZoneContext2["PRIMARY"] = "PRIMARY";
  return TagZoneContext2;
})(TagZoneContext || {});
var TagZoneDescriptionGroup = /* @__PURE__ */ ((TagZoneDescriptionGroup2) => {
  TagZoneDescriptionGroup2["DEFAULT"] = "DEFAULT";
  return TagZoneDescriptionGroup2;
})(TagZoneDescriptionGroup || {});
var TagZonePrimaryGroup = /* @__PURE__ */ ((TagZonePrimaryGroup2) => {
  TagZonePrimaryGroup2["DEFAULT"] = "DEFAULT";
  TagZonePrimaryGroup2["OPTIONAL"] = "OPTIONAL";
  return TagZonePrimaryGroup2;
})(TagZonePrimaryGroup || {});

// src/~graphql/helpers.ts
var getProductionDomain = (brand) => {
  if (brand === "Blockbuster" /* Blockbuster */)
    return "https://blockbuster.dk";
  if (brand === "SFAnytime" /* SFAnytime */)
    return "https://sfanytime.com";
  throw new Error("Unsupported brand");
};

// src/~assets/svg/assets/logo-horizontal.svg
var logo_horizontal_default = '<svg viewBox="0 0 837 260" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><linearGradient id="a"><stop offset="0" stop-color="#ea1121"/><stop offset=".99" stop-color="#ea1121" stop-opacity="0"/></linearGradient><radialGradient id="b" cx="52.707" cy="-29.583" gradientUnits="userSpaceOnUse" r="109.734" xlink:href="#a"/><radialGradient id="c" cx="148.042" cy="281.222" gradientUnits="userSpaceOnUse" r=".321" xlink:href="#a"/><linearGradient id="d"><stop offset=".88" stop-color="#c11b1b"/><stop offset=".89" stop-color="#c11b1b" stop-opacity=".994"/><stop offset=".899" stop-color="#c11b1b" stop-opacity=".978"/><stop offset=".907" stop-color="#c11b1b" stop-opacity=".952"/><stop offset=".915" stop-color="#c11b1b" stop-opacity=".915"/><stop offset=".922" stop-color="#c11b1b" stop-opacity=".87"/><stop offset=".93" stop-color="#c11b1b" stop-opacity=".815"/><stop offset=".937" stop-color="#c11b1b" stop-opacity=".752"/><stop offset=".944" stop-color="#c11b1b" stop-opacity=".681"/><stop offset=".951" stop-color="#c11b1b" stop-opacity=".603"/><stop offset=".958" stop-color="#c11b1b" stop-opacity=".517"/><stop offset=".965" stop-color="#c11b1b" stop-opacity=".425"/><stop offset=".973" stop-color="#c11b1b" stop-opacity=".327"/><stop offset=".981" stop-color="#c11b1b" stop-opacity=".223"/><stop offset=".99" stop-color="#c11b1b" stop-opacity=".114"/><stop offset="1" stop-color="#c11b1b" stop-opacity="0"/></linearGradient><radialGradient id="e" cx="0" cy="0" gradientTransform="matrix(.43721661 54.10393344 -54.10393344 .43721661 34.718955 78.091345)" gradientUnits="userSpaceOnUse" r="1" xlink:href="#d"/><radialGradient id="f" cx="0" cy="0" gradientTransform="matrix(.34687988 42.92509845 -42.92509845 .34687988 187.756434 22.464166)" gradientUnits="userSpaceOnUse" r="1" xlink:href="#d"/><radialGradient id="g" cx="0" cy="0" gradientTransform="matrix(.42602 52.75258 -52.68508 .42547 74.474 29.848)" gradientUnits="userSpaceOnUse" r="1" xlink:href="#d"/><radialGradient id="h" cx="0" cy="0" gradientTransform="matrix(.39677227 49.09909686 -49.09909686 .39677227 221.500238 67.498575)" gradientUnits="userSpaceOnUse" r="1" xlink:href="#d"/><linearGradient id="i"><stop offset="0" stop-color="#ff3d00"/><stop offset=".99" stop-color="#ea1121" stop-opacity="0"/></linearGradient><radialGradient id="j" cx="175.26" cy="73.223" gradientUnits="userSpaceOnUse" r="17.193" xlink:href="#i"/><radialGradient id="k" cx="98.775" cy="181.843" gradientUnits="userSpaceOnUse" r="30.231" xlink:href="#i"/><radialGradient id="l" cx="0" cy="0" gradientTransform="matrix(-27.49998 -73 73 -27.49998 252 234.5)" gradientUnits="userSpaceOnUse" r="1"><stop offset="0" stop-color="#f63a02"/><stop offset=".04" stop-color="#f63a02" stop-opacity=".988"/><stop offset=".078" stop-color="#f63a02" stop-opacity=".972"/><stop offset=".116" stop-color="#f63a02" stop-opacity=".951"/><stop offset=".155" stop-color="#f63a02" stop-opacity=".926"/><stop offset=".196" stop-color="#f63a02" stop-opacity=".893"/><stop offset=".24" stop-color="#f63a02" stop-opacity=".854"/><stop offset=".29" stop-color="#f63a02" stop-opacity=".806"/><stop offset=".345" stop-color="#f63a02" stop-opacity=".748"/><stop offset=".407" stop-color="#f63a02" stop-opacity=".68"/><stop offset=".478" stop-color="#f63a02" stop-opacity=".601"/><stop offset=".559" stop-color="#f63a02" stop-opacity=".51"/><stop offset=".65" stop-color="#f53a02" stop-opacity=".405"/><stop offset=".753" stop-color="#f53a02" stop-opacity=".285"/><stop offset=".869" stop-color="#f53a02" stop-opacity=".151"/><stop offset="1" stop-color="#f53a02" stop-opacity="0"/></radialGradient><linearGradient id="m"><stop offset="0" stop-color="#ea1121"/><stop offset="1" stop-color="#ea1121" stop-opacity="0"/></linearGradient><linearGradient id="n" gradientUnits="userSpaceOnUse" x1="-49.829" x2="293.742" xlink:href="#m" y1="132.871" y2="106.582"/><linearGradient id="o" gradientUnits="userSpaceOnUse" x1="-38.825" x2="146.065" xlink:href="#m" y1="76.6" y2="135.171"/><linearGradient id="p" gradientUnits="userSpaceOnUse" x1="308.616" x2="126.847" xlink:href="#m" y1="124.048" y2="142.579"/><linearGradient id="q" gradientUnits="userSpaceOnUse" x1="40.81" x2="161.125" xlink:href="#i" y1="-18.933" y2="189.923"/><linearGradient id="r" gradientUnits="userSpaceOnUse" x1="77.542" x2="247.37" xlink:href="#i" y1="7.633" y2="121.386"/><linearGradient id="s" gradientUnits="userSpaceOnUse" x1="25.338" x2="119.669" xlink:href="#i" y1="134.573" y2="134.573"/><clipPath id="t"><path d="m115.63-49.662h144.252v144.252h-144.252z"/></clipPath><clipPath id="u"><path d="m-11.567-56.305h172.084v172.304h-172.084z"/></clipPath><clipPath id="v"><path d="m141.892-11.996h159.234v159.234h-159.234z"/></clipPath><clipPath id="w"><path d="m259.408 193.609h577v-128h-577z"/></clipPath><mask id="x" height="259" maskUnits="userSpaceOnUse" width="260" x="0" y="0"><path d="m88.77 252.566c1.783.597 3.593 1.168 5.412 1.685a128.552 128.552 0 0 0 24.524 4.548v-158.315s0-.044-.009-.089c0-.036-.009-.071-.018-.125-.009-.053-.027-.116-.045-.187 0-.027-.018-.054-.026-.09a2.688 2.688 0 0 0 -.161-.392c-.036-.08-.08-.16-.134-.25-.267-.454-.731-.954-1.498-1.355-.143-.062-2.301-1.123-2.301-4.789v-.017c0-.116.09-.402.268-.714-.375.669-.785 1.391-1.213 2.14-4.182 7.25-10.701 17.568-11.022 18.076-4.37 7.607-10.032 15.597-14.634 21.715-.285.383-.57.758-.847 1.124-.696.918-1.365 1.783-1.989 2.595l-.374.481a420.503 420.503 0 0 1 -2.587 3.282c-.187.232-.356.446-.526.651-.25.303-.472.588-.677.838-.072.08-.134.161-.197.241a68.43 68.43 0 0 1 -1.007 1.222 104.177 104.177 0 0 1 -10.817 12.422l-.027.027a119.9 119.9 0 0 1 -1.15 1.105c-2.899 2.738-4.932 4.308-5.351 4.62a56.173 56.173 0 0 1 -3.968 3.246c-.589.437-1.178.865-1.757 1.266-.259.178-.517.357-.767.526a62.74 62.74 0 0 1 -11.441 6.064c-.348.143-.696.277-1.035.41-2.586.99-4.78 1.641-6.34 2.034a49.04 49.04 0 0 1 -1.579.374c-.553.116-.9.179-.98.187-3.247.678-6.421 1.035-9.373 1.035-2.4 0-4.468-.232-6.225-.58a21.773 21.773 0 0 1 -1.257-.285c-.196-.054-.392-.098-.589-.152-.383-.107-.74-.214-1.088-.33-.17-.053-.338-.116-.499-.169a25.418 25.418 0 0 1 -.919-.348c-.142-.062-.285-.116-.419-.178-1.881-.83-2.871-1.623-3.067-1.793-.018-.009-.027-.017-.027-.026-1.605-1.231-2.943-2.72-4.049-4.334 12.672 38.845 43.153 69.611 81.784 82.613v-.009zm106.136-228.453c.473.286.919.598 1.329.954.035.027.241.206.517.553.08.098.161.214.25.34a7.975 7.975 0 0 1 1.043 2.22c.187.615.33 1.329.401 2.158.134 1.64-.044 3.71-.838 6.26-.018.063-1.953 6.501-9.747 13.974-.071.071-.678.704-1.213 1.471-.758 1.088-.99 1.944-.954 2.613.018.33.098.616.214.856a2.3 2.3 0 0 0 .401.58c.214.24.482.42.785.535.25.098.526.152.821.152 1.025 0 2.202-.633 3.727-1.998l7.883-6.251 17.827-14.135c.062-.044.107-.098.169-.142 15.356 14.17 27.288 32.014 34.422 52.15.509 1.49.963 2.827 1.623 4.94l-136.921.018c-.955 0-1.543.598-1.855 1.115.294-.526.571-1.025.811-1.48.081-.134 6.252-10.978 12.173-20.564l.481-.776c.259-.42.518-.83.776-1.24.116-.187.232-.374.348-.553.223-.356.455-.713.678-1.07.089-.134.178-.276.258-.41.625-.99 1.24-1.935 1.837-2.836.054-.08 2.845-3.941 6.493-8.472.347-.428.695-.865 1.052-1.302.098-.124.205-.25.303-.374.375-.455.758-.919 1.141-1.373.063-.08.134-.16.197-.241.446-.535.9-1.061 1.355-1.587.054-.063.107-.116.161-.179.428-.49.865-.98 1.302-1.462.053-.054.098-.107.151-.17.464-.508.919-1.008 1.374-1.489l.062-.063c1.471-1.551 2.907-2.933 4.209-4.004l.089-.08.036-.035s.838-.82 2.283-2.096c.036-.036.08-.071.116-.107.455-.401.963-.838 1.534-1.32.062-.053.133-.116.205-.17.776-.65 1.65-1.364 2.613-2.122.089-.071.178-.142.267-.205.473-.365.963-.749 1.472-1.132.437-.33.891-.67 1.355-1.017.767-.562 1.561-1.133 2.399-1.712l.508-.348c3.335-2.292 7.17-4.655 11.343-6.733 0 0 .027-.009.054-.027.018-.009.045-.017.071-.035.134-.063.375-.17.696-.303.178-.072.374-.152.597-.25.188-.072.384-.152.598-.232.267-.107.562-.214.874-.321 2.131-.767 5.199-1.685 8.418-2.033.223-.027.446-.045.669-.063.615-.053 1.239-.08 1.855-.08 2.006 0 3.763.303 5.279.892.285.107.553.232.82.357.277.133.544.276.794.437zm-194.27 107.949c.062 3.379.25 6.723.562 10.032l24.871-22.936.277-.214c.535-.33 1.06-.535 1.569-.625a3.34 3.34 0 0 1 .5-.044c.115 0 .222 0 .32.018.714.08 1.16.428 1.33.579.82.812.882 1.855.597 2.89-.018.08-.045.151-.072.232-.053.169-.116.33-.187.499a3.898 3.898 0 0 1 -.152.339c-.33.704-.758 1.355-1.132 1.864-13.323 17.148-16.016 23.899-16.043 23.97l-.062.143c-2.096 4.316-2.55 7.758-2.515 10.014 0 .161 0 .313.018.464.018.152.018.294.026.428a10.82 10.82 0 0 0 1.82 5.52 10.84 10.84 0 0 0 2.193 2.408c.214.169.428.339.651.49a10.7 10.7 0 0 0 2.961 1.436c1.703.624 4.049.999 5.779 1.142.58.044 1.088.071 1.48.062.223 0 .437 0 .66-.018.232 0 .455-.018.678-.026a40.36 40.36 0 0 0 1.676-.134 34.01 34.01 0 0 0 1.605-.214c.241-.036.455-.072.66-.107.045 0 .09-.018.125-.027.294-.054.535-.107.713-.143.223-.044.348-.08.348-.08 4.334-.981 8.338-3.514 11.014-5.547.151-.116.294-.223.437-.33.276-.223.543-.428.784-.633a46.065 46.065 0 0 0 1.668-1.445c.303-.276.464-.445.464-.445.4-.366.829-.785 1.266-1.249a46.947 46.947 0 0 0 2.417-2.809c.115-.152.24-.303.356-.455 1.73-2.193 3.55-4.771 5.288-7.348l.482-.722a216.263 216.263 0 0 0 2.319-3.558c.116-.179.223-.357.338-.527.215-.338.429-.668.634-.998.17-.268.338-.535.5-.794.097-.16.195-.321.293-.473.16-.258.313-.499.464-.749a261.808 261.808 0 0 0 2.64-4.351c.053-.09.098-.17.142-.25.473-.794.74-1.266.758-1.293 2.39-4.004 31.908-55.094 32.202-55.61 17.193-26.37 33.736-38.418 35.144-39.417.286-.24.571-.481.866-.722.115-.098.231-.187.338-.285.892-.74 1.784-1.454 2.667-2.15.151-.116.294-.231.446-.347a124.298 124.298 0 0 1 4.512-3.362c.196-.143.392-.277.58-.41a127.241 127.241 0 0 1 4.262-2.872c.232-.152.464-.294.696-.446.401-.259.802-.508 1.204-.758.241-.152.481-.303.731-.446.383-.232.758-.464 1.133-.686.249-.152.508-.304.758-.446.356-.214.713-.42 1.07-.625a151.768 151.768 0 0 1 3.54-1.962c.276-.142.544-.294.82-.427.295-.152.598-.313.883-.464.562-.286 1.115-.571 1.668-.838a130.369 130.369 0 0 1 2.434-1.168c.758-.357 1.49-.687 2.203-1.008a112.198 112.198 0 0 1 3.567-1.508 95.223 95.223 0 0 1 5.52-2.033c.241-.08.473-.16.696-.232.321-.098.615-.196.891-.276 1.302-.401 2.096-.598 2.248-.642a50.595 50.595 0 0 1 11.691-1.391c.82 0 1.56.018 2.202.053.223.01.437.027.634.036.49.036.918.071 1.266.107.294.027.535.062.713.08.054 0 .107.018.152.018-14.919-8.186-31.283-13.43-49.368-15.214a96.57 96.57 0 0 0 -4.022-.312c-.803-.053-1.614-.089-2.408-.133h-.08a141.583 141.583 0 0 0 -6.028-.152c-54.666 0-101.421 34.065-120.371 82.212a139.133 139.133 0 0 0 -2.426 6.706 116.708 116.708 0 0 0 -1.65 5.36c-.347 1.23-.677 2.47-.99 3.71-.427 1.685-.82 3.388-1.176 5.1-.259 1.24-.509 2.488-.732 3.746a210.52 210.52 0 0 0 -.535 3.21 131.42 131.42 0 0 0 -1.516 19.77c0 .197.018 1.677.027 2.23l.018.018zm240.58 63.895c.696-1.178 1.392-2.355 2.052-3.559.633-1.141 1.239-2.3 1.837-3.469a133.266 133.266 0 0 0 5.636-12.529c5.332-13.813 8.373-28.768 8.65-44.401v-.865c0-.401 0-.829.009-1.088v-.232c0-2.185-.09-4.628-.25-7.187-.063-1.026-.143-2.06-.223-3.104l-.134-1.578c-.383-4.209-.927-8.463-1.578-12.155a141.934 141.934 0 0 0 -.883-4.361c-.08-.33-.161-.659-.241-.972h-114.734v34.2h.089c.187 0 .446-.072.642-.134.08-.027.151-.054.205-.072 0 0 .018.001.027-.008 14.304-6.466 23.738-6.974 26.289-6.974h.794c11.878 0 29.018 7.535 29.74 7.856 16.194 6.929 22.142 8.017 22.142 8.017 6.368 1.579 11.335 1.409 11.62 1.409.375 0 .821-.026 1.302-.071h.089c1.276-.125 2.783-.366 4.031-.589.223-.044.437-.08.633-.115.232-.045.455-.09.66-.125.277-.054.517-.107.705-.143l.847-.232c.41-.116.749-.205 1.052-.276.143-.036.277-.063.41-.089.259-.054.491-.081.714-.081 1.114 0 1.765.687 2.006 1.32.509 1.48-.57 2.408-2.506 3.933l-.124.089-.018.018a24.51 24.51 0 0 1 -1.918 1.106c-.677.356-1.355.695-2.051.998-.9.393-1.819.741-2.737 1.053-5.066 1.685-10.238 2.122-14.206 2.122-2.149 0-3.808-.134-4.673-.214a20.155 20.155 0 0 0 -.669-.071c-7.348-.749-19.86-5.717-20.386-5.931-3.629-1.48-7.446-2.826-11.04-3.995a219.766 219.766 0 0 0 -5.19-1.623c-.704-.214-1.382-.41-2.042-.597s-1.293-.375-1.89-.544a85.344 85.344 0 0 0 -1.945-.535 643.96 643.96 0 0 0 -2.461-.66c-.312-.08-.597-.161-.865-.223-.615-.161-1.088-.276-1.409-.357-.285-.071-.455-.116-.472-.116a34.49 34.49 0 0 0 -7.598-.874c-10.907 0-17.916 5.681-19.771 7.384v113.504a128.288 128.288 0 0 0 44.482-12.172c.891-.429 1.774-.865 2.657-1.311a130.34 130.34 0 0 0 13.047-7.625c.633-.419 1.257-.847 1.881-1.275.945-.651 1.882-1.32 2.809-1.998.482-.348.954-.704 1.436-1.061a129.9 129.9 0 0 0 14.768-12.975 131.028 131.028 0 0 0 16.328-20.448c.847-1.311 1.659-2.64 2.452-3.978z" fill="#fff"/></mask><path d="m141.374 258.8c-3.487.276-7.535.419-11.343.419s-7.607-.08-11.335-.41c-23.605-2.06-102.999-62.343-111.711-88.838-2.925-8.9-4.851-18.254-5.788-27.867-.401-4.165.428-8.383.428-12.655 0-15.097 46.14-54.852 93.127-81.418 43.635-24.675 88.009-36.981 96.819-32.326 9.4 4.967 18.13 11.379 25.942 18.557 8.561 7.866 15.142 16.882 21.322 26.78 5.841 9.364 11.406 19.53 14.723 30.302.919 2.988 1.819 6.047 2.533 9.123.856 3.692 3.709 29.268-17.265 58.83-32.014 45.114-93.466 99.191-97.452 99.503z" fill="#fff"/><path d="m241.225 195.956a125.855 125.855 0 0 0 2.051-3.558c.633-1.141 1.24-2.301 1.837-3.469.99-1.926 1.926-3.87 2.827-5.85.99-2.194 1.935-4.423 2.809-6.679 5.333-13.814 8.374-28.769 8.65-44.401v-.865c0-.402 0-.83.009-1.088v-.232c0-2.185-.089-4.628-.249-7.188-.063-1.025-.143-2.06-.223-3.103l-.134-1.578c-.384-4.21-.928-8.463-1.579-12.155a138.42 138.42 0 0 0 -.882-4.361c-.081-.33-.161-.66-.241-.972h-114.735v34.199h.089c.188 0 .446-.071.642-.134.081-.026.152-.053.206-.071 0 0 .017 0 .026-.009 14.304-6.465 23.739-6.973 26.29-6.973h.793c11.879 0 29.018 7.535 29.741 7.856 16.194 6.929 22.142 8.017 22.142 8.017 6.367 1.578 11.335 1.409 11.62 1.409.374 0 .82-.027 1.302-.071h.089c1.275-.125 2.782-.366 4.031-.589.223-.044.437-.08.633-.116.232-.044.455-.089.66-.125.276-.053.517-.107.704-.142l.848-.232c.41-.116.749-.205 1.052-.277.143-.035.276-.062.41-.089.259-.053.491-.08.713-.08 1.115 0 1.766.687 2.007 1.32.508 1.48-.571 2.408-2.506 3.932l-.125.09-.018.017c-.624.402-1.266.767-1.917 1.106-.678.357-1.355.696-2.051.999-.901.392-1.819.74-2.738 1.052-5.065 1.686-10.237 2.123-14.206 2.123-2.149 0-3.807-.134-4.672-.214-.402-.045-.633-.072-.669-.072-7.348-.749-19.86-5.716-20.386-5.93-3.629-1.48-7.446-2.827-11.04-3.995a210.79 210.79 0 0 0 -7.232-2.221c-.66-.187-1.293-.374-1.891-.544a89.25 89.25 0 0 0 -1.944-.535c-.927-.249-1.757-.472-2.461-.659-.312-.081-.598-.161-.865-.223-.615-.161-1.088-.277-1.409-.357-.285-.071-.455-.116-.473-.116a34.416 34.416 0 0 0 -7.598-.874c-10.906 0-17.915 5.681-19.77 7.384v113.504a128.278 128.278 0 0 0 44.481-12.173c.892-.428 1.775-.865 2.658-1.311a130.204 130.204 0 0 0 17.737-10.897c.482-.348.954-.705 1.436-1.061a130.016 130.016 0 0 0 14.767-12.975 131.015 131.015 0 0 0 16.329-20.449 122.746 122.746 0 0 0 2.452-3.977zm-240.589-63.894c.062 3.379.25 6.723.562 10.032l24.871-22.936.277-.214c.535-.33 1.06-.535 1.569-.625a3.34 3.34 0 0 1 .5-.044c.115 0 .222 0 .32.018.714.08 1.16.428 1.33.579.82.812.882 1.855.597 2.89-.018.08-.045.151-.072.232-.053.169-.116.33-.187.499a3.898 3.898 0 0 1 -.152.339c-.33.704-.758 1.355-1.132 1.864-13.323 17.148-16.016 23.899-16.043 23.97l-.062.143c-2.096 4.316-2.55 7.758-2.515 10.014 0 .161 0 .313.018.464.018.152.018.294.026.428a10.82 10.82 0 0 0 1.82 5.52 10.84 10.84 0 0 0 2.193 2.408c.214.169.428.339.651.491.901.624 1.89 1.105 2.961 1.435 1.703.624 4.049.999 5.779 1.142.58.044 1.088.071 1.48.062.223 0 .437 0 .66-.018.232 0 .455-.018.678-.026a40.36 40.36 0 0 0 1.676-.134 34.01 34.01 0 0 0 1.605-.214c.241-.036.455-.072.66-.107.045 0 .09-.018.125-.027.294-.054.535-.107.713-.143.223-.044.348-.08.348-.08 4.334-.981 8.338-3.514 11.014-5.547.151-.116.294-.223.437-.33.276-.223.543-.428.784-.633a45.865 45.865 0 0 0 1.668-1.445c.303-.276.464-.445.464-.445.4-.366.829-.785 1.266-1.249a46.983 46.983 0 0 0 2.417-2.809c.115-.152.24-.303.356-.455 1.73-2.193 3.55-4.771 5.288-7.348l.482-.722a216.263 216.263 0 0 0 2.319-3.558c.116-.179.223-.357.338-.527.215-.338.429-.668.634-.998.17-.268.338-.535.499-.794.098-.16.196-.321.294-.473.16-.258.313-.499.464-.749a261.808 261.808 0 0 0 2.64-4.351c.053-.09.098-.17.142-.25.473-.794.74-1.266.758-1.293 2.39-4.004 31.908-55.094 32.202-55.61 17.193-26.37 33.735-38.418 35.144-39.417.286-.24.571-.481.866-.722.115-.098.231-.187.338-.285.892-.74 1.784-1.454 2.667-2.15.151-.116.294-.231.446-.347a124.298 124.298 0 0 1 4.512-3.362c.196-.143.392-.277.58-.41a127.241 127.241 0 0 1 4.262-2.872c.232-.152.464-.294.696-.446.401-.259.802-.508 1.204-.758.241-.152.481-.303.731-.446.383-.232.758-.464 1.133-.686.249-.152.508-.304.758-.446.356-.214.713-.42 1.07-.625a151.768 151.768 0 0 1 3.54-1.962c.276-.142.544-.294.82-.427.295-.152.598-.313.883-.464.562-.286 1.115-.571 1.668-.838a130.369 130.369 0 0 1 2.434-1.168c.758-.357 1.49-.687 2.203-1.008a112.198 112.198 0 0 1 3.567-1.508 95.223 95.223 0 0 1 5.52-2.033c.241-.08.473-.16.696-.232.321-.098.615-.196.891-.276 1.302-.401 2.096-.598 2.248-.642a50.595 50.595 0 0 1 11.691-1.391c.82 0 1.56.018 2.202.053.223.01.437.027.634.036.49.036.918.071 1.266.107.294.027.535.062.713.08.054 0 .107.018.152.018-14.919-8.186-31.283-13.43-49.368-15.214a96.57 96.57 0 0 0 -4.022-.312c-.803-.053-1.614-.089-2.408-.133h-.08a141.583 141.583 0 0 0 -6.028-.152c-54.666 0-101.421 34.065-120.371 82.212a139.098 139.098 0 0 0 -2.426 6.706 116.666 116.666 0 0 0 -1.65 5.36c-.347 1.23-.677 2.47-.99 3.71-.427 1.685-.82 3.388-1.176 5.1-.259 1.24-.509 2.488-.732 3.746a210.52 210.52 0 0 0 -.535 3.21 131.42 131.42 0 0 0 -1.516 19.77c0 .197.018 1.677.027 2.23l.018.018z" fill="#8d0025"/><path d="m.636 132.062c.062 3.379.25 6.723.562 10.032l24.871-22.936.277-.214c.535-.33 1.06-.535 1.569-.625a3.34 3.34 0 0 1 .5-.044c.115 0 .222 0 .32.018.714.08 1.16.428 1.33.579.82.812.882 1.855.597 2.89-.018.08-.045.151-.072.232-.053.169-.116.33-.187.499a3.898 3.898 0 0 1 -.152.339c-.33.704-.758 1.355-1.132 1.864-13.323 17.148-16.016 23.899-16.043 23.97l-.062.143c-2.096 4.316-2.55 7.758-2.515 10.014 0 .161 0 .313.018.464.018.152.018.294.026.428a10.82 10.82 0 0 0 1.82 5.52 10.84 10.84 0 0 0 2.193 2.408c.214.169.428.339.651.491.901.624 1.89 1.105 2.961 1.435 1.703.624 4.049.999 5.779 1.142.58.044 1.088.071 1.48.062.223 0 .437 0 .66-.018.232 0 .455-.018.678-.026a40.36 40.36 0 0 0 1.676-.134 34.01 34.01 0 0 0 1.605-.214c.241-.036.455-.072.66-.107.045 0 .09-.018.125-.027.294-.054.535-.107.713-.143.223-.044.348-.08.348-.08 4.334-.981 8.338-3.514 11.014-5.547.151-.116.294-.223.437-.33.276-.223.543-.428.784-.633a45.865 45.865 0 0 0 1.668-1.445c.303-.276.464-.445.464-.445.4-.366.829-.785 1.266-1.249a46.983 46.983 0 0 0 2.417-2.809c.115-.152.24-.303.356-.455 1.73-2.193 3.55-4.771 5.288-7.348l.482-.722a216.263 216.263 0 0 0 2.319-3.558c.116-.179.223-.357.338-.527.215-.338.429-.668.634-.998.17-.268.338-.535.499-.794.098-.16.196-.321.294-.473.16-.258.313-.499.464-.749a261.808 261.808 0 0 0 2.64-4.351c.053-.09.098-.17.142-.25.473-.794.74-1.266.758-1.293 2.39-4.004 31.908-55.094 32.202-55.61 17.193-26.37 33.735-38.418 35.144-39.417.286-.24.571-.481.866-.722.115-.098.231-.187.338-.285.892-.74 1.784-1.454 2.667-2.15.151-.116.294-.231.446-.347a124.298 124.298 0 0 1 4.512-3.362c.196-.143.392-.277.58-.41a127.241 127.241 0 0 1 4.262-2.872c.232-.152.464-.294.696-.446.401-.259.802-.508 1.204-.758.241-.152.481-.303.731-.446.383-.232.758-.464 1.133-.686.249-.152.508-.304.758-.446.356-.214.713-.42 1.07-.625a151.768 151.768 0 0 1 3.54-1.962c.276-.142.544-.294.82-.427.295-.152.598-.313.883-.464.562-.286 1.115-.571 1.668-.838a130.369 130.369 0 0 1 2.434-1.168c.758-.357 1.49-.687 2.203-1.008a112.198 112.198 0 0 1 3.567-1.508 95.223 95.223 0 0 1 5.52-2.033c.241-.08.473-.16.696-.232.321-.098.615-.196.891-.276 1.302-.401 2.096-.598 2.248-.642a50.595 50.595 0 0 1 11.691-1.391c.82 0 1.56.018 2.202.053.223.01.437.027.634.036.49.036.918.071 1.266.107.294.027.535.062.713.08.054 0 .107.018.152.018-14.919-8.186-31.283-13.43-49.368-15.214a96.57 96.57 0 0 0 -4.022-.312c-.803-.053-1.614-.089-2.408-.133h-.08a141.583 141.583 0 0 0 -6.028-.152c-54.666 0-101.421 34.065-120.371 82.212a139.098 139.098 0 0 0 -2.426 6.706 116.666 116.666 0 0 0 -1.65 5.36c-.347 1.23-.677 2.47-.99 3.71-.427 1.685-.82 3.388-1.176 5.1-.259 1.24-.509 2.488-.732 3.746a210.52 210.52 0 0 0 -.535 3.21 131.42 131.42 0 0 0 -1.516 19.77c0 .197.018 1.677.027 2.23l.018.018z" fill="url(#b)" opacity=".9"/><path d="m194.113 23.676a9.605 9.605 0 0 0 -.82-.356c-1.525-.59-3.282-.892-5.28-.892-.615 0-1.239.026-1.855.08-.223.018-.445.036-.668.062-3.22.348-6.287 1.267-8.419 2.034-.312.116-.606.223-.874.32-.214.08-.41.161-.597.233-.223.089-.428.169-.598.25-.321.133-.561.24-.695.302-.027.018-.054.027-.072.036a9.752 9.752 0 0 1 -.053.027c-4.173 2.078-8.008 4.45-11.343 6.733l-.509.347c-.829.58-1.632 1.15-2.398 1.713-.464.339-.919.677-1.356 1.016-.508.384-.999.767-1.471 1.133a5.312 5.312 0 0 1 -.268.205c-.963.758-1.837 1.471-2.613 2.122-.071.054-.133.116-.205.17-.571.481-1.079.918-1.534 1.32a1.53 1.53 0 0 0 -.116.107 65.89 65.89 0 0 0 -2.283 2.095l-.035.036-.089.08c-1.302 1.07-2.738 2.453-4.21 4.004a75.573 75.573 0 0 0 -1.435 1.552c-.054.053-.098.107-.152.17-.437.48-.865.971-1.302 1.462-.053.062-.107.116-.16.178-.455.526-.91 1.052-1.356 1.587-.071.08-.134.161-.196.241a153.503 153.503 0 0 0 -1.445 1.748c-.356.437-.713.874-1.052 1.302a219.247 219.247 0 0 0 -6.492 8.472c-.589.9-1.204 1.855-1.837 2.836-.089.133-.178.276-.259.41a79.05 79.05 0 0 1 -.677 1.07c-.116.187-.232.366-.348.553-.259.41-.517.82-.776 1.24l-.482.775c-5.921 9.587-12.092 20.43-12.172 20.564-.25.464-.517.963-.812 1.48.312-.516.91-1.114 1.855-1.114l136.922-.018a177.298 177.298 0 0 0 -1.623-4.94c-7.134-20.136-19.075-37.98-34.422-52.15-.054.044-.107.097-.17.142l-17.826 14.135-7.883 6.25c-1.525 1.365-2.702 1.998-3.728 1.998-.285 0-.562-.053-.82-.151a1.922 1.922 0 0 1 -.785-.535 2.447 2.447 0 0 1 -.401-.58 2.222 2.222 0 0 1 -.214-.856c-.036-.669.196-1.525.954-2.613.535-.767 1.15-1.4 1.213-1.471 7.803-7.473 9.729-13.912 9.747-13.974.793-2.55.972-4.61.838-6.26a10.175 10.175 0 0 0 -.401-2.159 7.74 7.74 0 0 0 -1.044-2.22c-.089-.125-.169-.24-.249-.339a3.715 3.715 0 0 0 -.518-.553 9.492 9.492 0 0 0 -1.328-.954 14.08 14.08 0 0 0 -.794-.437l-.009-.018zm-105.343 228.89c1.783.598 3.593 1.169 5.412 1.686 3.442.99 6.938 1.846 10.487 2.55 4.593.919 9.284 1.588 14.037 1.998v-158.315s0-.045-.009-.09c0-.035-.009-.071-.018-.124-.009-.054-.027-.116-.045-.188 0-.026-.017-.053-.026-.089a2.687 2.687 0 0 0 -.161-.392c-.036-.08-.08-.16-.134-.25-.267-.455-.731-.954-1.498-1.355-.142-.063-2.301-1.124-2.301-4.79v-.017c0-.116.09-.401.268-.713-.375.668-.785 1.39-1.213 2.14-4.182 7.25-10.701 17.568-11.022 18.076-4.37 7.607-10.032 15.597-14.634 21.714-.285.384-.57.758-.847 1.124-.696.919-1.365 1.784-1.989 2.595l-.374.482a418.45 418.45 0 0 1 -2.586 3.281c-.188.232-.357.446-.526.651-.25.303-.473.589-.678.839-.072.08-.134.16-.197.24-.624.767-.98 1.195-1.007 1.222a104.088 104.088 0 0 1 -10.817 12.422l-.027.027c-.392.384-.776.749-1.15 1.106-2.899 2.738-4.932 4.307-5.351 4.619a56.152 56.152 0 0 1 -3.968 3.246 67.457 67.457 0 0 1 -2.524 1.793 62.861 62.861 0 0 1 -11.441 6.064c-.348.142-.696.276-1.035.41-2.586.99-4.78 1.641-6.34 2.033-.633.161-1.168.286-1.579.375a17.5 17.5 0 0 1 -.98.187c-3.247.678-6.421 1.034-9.373 1.034-2.399 0-4.468-.231-6.225-.579a21.78 21.78 0 0 1 -1.257-.286c-.196-.053-.392-.098-.589-.151-.383-.107-.74-.214-1.088-.33-.169-.054-.338-.116-.499-.17a25.528 25.528 0 0 1 -.918-.347c-.143-.063-.286-.116-.42-.179-1.881-.829-2.871-1.623-3.067-1.792-.018-.009-.027-.018-.027-.027-1.605-1.231-2.943-2.72-4.049-4.334 12.672 38.845 43.153 69.611 81.784 82.613v-.009z" fill="#8d0025"/><g mask="url(#x)"><path d="m141.687 259.823 263.097-31.783-361.566-243.897-36.892 32.495z" fill="url(#n)" opacity=".6"/><path d="m-134.003 195.847 251.737 64.091 146.445-204.366-28.126-41.289z" fill="url(#o)" opacity=".9"/><path d="m-133.914 195.781 251.202 64.992 146.989-205.266-28.126-41.298z" fill="url(#p)" opacity=".9"/><path d="m-28.587 250.895 149.442 8.721 151.6-215.61-8.98-16.953-292.062 223.842z" fill="url(#c)" opacity=".9"/><path d="m102.869 223.877c74.61 0 135.093-60.484 135.093-135.094 0-74.61-60.483-135.094-135.093-135.094s-135.094 60.484-135.094 135.094 60.484 135.094 135.094 135.094z" fill="url(#q)" opacity=".8"/><path d="m-56.19-12.818h181.819v181.819h-181.819z" fill="url(#e)" opacity=".7"/><g clip-path="url(#t)" opacity=".7"><path d="m115.63-49.662h144.252v144.252h-144.252z" fill="url(#f)"/></g><g clip-path="url(#u)"><path d="m-14.051-58.791h177.051v177.278h-177.051z" fill="url(#g)"/></g><g clip-path="url(#v)"><path d="m139-15.002h165v165h-165z" fill="url(#h)"/></g><path d="m247.066 121.627-166.804-111.55.49-.741 166.814 111.551z" fill="url(#r)"/><path d="m118.893 218.782-93.555-167.99.785-.429 93.546 167.991z" fill="url(#s)"/><path d="m155.619 59.596-.494.742 39.789 26.486.494-.742z" fill="url(#j)"/><path d="m119.089 219.181-41.128-73.936.49-.749 41.128 73.945z" fill="url(#k)"/><circle cx="248" cy="218" fill="url(#l)" opacity=".9" r="70"/></g><g clip-path="url(#w)" fill="#fff"><path clip-rule="evenodd" d="m310.708 94.103c6.487-4.588 15.82-7.593 28.475-7.593 24.993 0 34.01 8.542 34.01 27.682v49.037c0 .951-.633 1.583-1.582 1.583h-17.559c-.949 0-1.581-.632-1.581-1.583v-5.061h-.159c-3.955 5.061-10.597 8.383-21.04 8.383-13.603 0-25.467-7.118-25.467-23.411 0-16.925 12.812-24.676 31.795-24.676h13.604c.635 0 .951-.317.951-.951v-2.846c0-7.118-3.482-10.44-15.663-10.44-7.751 0-13.445 2.214-17.083 4.902-.792.634-1.582.475-2.057-.316l-7.119-12.496c-.473-.949-.316-1.74.475-2.214zm27.209 55.839c9.491 0 14.238-3.48 14.238-10.598v-5.22c0-.632-.316-.951-.951-.951h-10.756c-9.333 0-13.604 2.691-13.604 8.701 0 5.379 3.796 8.068 11.073 8.068z" fill-rule="evenodd"/><path d="m431.119 86.508c-9.808 0-16.292 3.955-19.774 8.701h-.158v-5.378c0-.951-.632-1.583-1.58-1.583h-18.984c-.948 0-1.582.632-1.582 1.583v73.397c0 .951.634 1.583 1.582 1.583h18.984c.948 0 1.58-.632 1.58-1.583v-43.975c0-8.384 4.43-13.92 12.022-13.92 7.91 0 11.866 5.536 11.866 13.92v43.975c0 .951.632 1.583 1.58 1.583h18.984c.948 0 1.581-.632 1.581-1.583v-48.245c0-16.769-9.175-28.475-26.101-28.475m106.917 1.742h-19.615c-.949 0-1.581.631-1.898 1.582l-14.238 44.292h-.316l-15.344-44.292c-.316-.95-.948-1.583-1.897-1.583h-20.248c-.949 0-1.583.632-1.265 1.583l28.473 71.182-2.057 5.696c-1.898 5.695-4.903 7.91-10.44 7.91h-3.322c-.949 0-1.582.632-1.582 1.581v15.501c0 .951.633 1.583 1.582 1.583h5.378c13.764 0 20.565-5.061 27.05-21.988l31.006-81.465c.316-.95-.159-1.583-1.267-1.583m48.309-.002h-9.808c-.632 0-.949-.316-.949-.948v-20.564c0-.95-.633-1.582-1.581-1.582h-18.826c-.948 0-1.581.631-1.581 1.582v20.565c0 .632-.316.948-.949.948h-4.747c-.948 0-1.58.632-1.58 1.583v13.129c0 .948.632 1.581 1.58 1.581h4.747c.633 0 .949.318.949.95v34.8c0 17.56 6.643 25.468 24.36 25.468h8.385c.948 0 1.582-.632 1.582-1.58v-15.662c0-.949-.634-1.581-1.582-1.581h-3.797c-5.061 0-6.96-1.899-6.96-7.593v-33.853c0-.632.317-.95.949-.95h9.808c.948 0 1.582-.633 1.582-1.581v-13.13c0-.95-.634-1.582-1.582-1.582m35.227-23.093h-18.983c-.949 0-1.582.633-1.582 1.582v15.66c0 .95.633 1.582 1.582 1.582h18.983c.948 0 1.581-.633 1.581-1.582v-15.66c0-.95-.633-1.582-1.581-1.582m0 23.094h-18.983c-.949 0-1.582.632-1.582 1.583v73.397c0 .951.633 1.583 1.582 1.583h18.983c.948 0 1.581-.632 1.581-1.583v-73.397c0-.951-.633-1.583-1.581-1.583m104.448-1.74c-10.759 0-18.351 3.639-24.045 9.65h-.159c-4.429-6.327-11.231-9.65-20.564-9.65-9.808 0-16.292 3.955-19.773 8.701h-.159v-5.378c0-.951-.632-1.583-1.58-1.583h-18.984c-.948 0-1.581.632-1.581 1.583v73.397c0 .951.633 1.583 1.581 1.583h18.984c.948 0 1.58-.632 1.58-1.583v-43.975c0-8.384 4.431-13.92 12.023-13.92 7.909 0 11.865 5.536 11.865 13.92v43.975c0 .951.632 1.583 1.58 1.583h18.984c.948 0 1.581-.632 1.581-1.583v-43.975c0-8.384 4.271-13.92 11.864-13.92 7.91 0 12.023 5.536 12.023 13.92v43.975c0 .951.632 1.583 1.581 1.583h18.983c.949 0 1.581-.632 1.581-1.583v-48.245c0-16.927-9.332-28.475-27.365-28.475"/><g clip-rule="evenodd" fill-rule="evenodd"><path d="m835.088 133.173h-46.349c-.632 0-.948.318-.948.95.157 1.582.474 3.005.948 4.27 2.057 6.644 7.909 10.124 15.818 10.124 7.594 0 13.13-2.688 17.559-6.801.791-.633 1.583-.791 2.215 0l10.441 9.807c.791.633.791 1.581.157 2.216-7.276 7.75-18.506 12.812-32.586 12.812-17.402 0-29.422-8.068-33.852-21.83-1.582-4.746-2.688-10.282-2.688-18.192 0-8.066.948-13.604 2.53-18.349 4.43-13.761 16.608-21.672 32.903-21.672 16.925 0 28.632 8.067 33.061 21.513 1.582 5.063 2.531 10.599 2.531 23.571 0 .948-.633 1.581-1.74 1.581zm-33.693-29.738c-6.328 0-11.074 3.162-12.814 8.382-.474 1.583-.79 3.322-.79 5.695 0 .633.316.951.948.951h25.31c.632 0 .948-.318.948-.951 0-2.373-.316-4.112-.79-5.695-1.74-5.22-6.486-8.382-12.812-8.382z"/><path d="m538.036 88.25h-19.615c-.949 0-1.581.631-1.898 1.582l-14.238 44.292h-.316l-15.344-44.292c-.316-.95-.948-1.583-1.898-1.583h-20.247c-.949 0-1.583.632-1.265 1.583l28.473 71.182-2.057 5.696c-1.898 5.695-4.904 7.91-10.44 7.91h-3.322c-.949 0-1.582.632-1.582 1.581v15.501c0 .951.633 1.583 1.582 1.583h5.378c13.764 0 20.565-5.061 27.05-21.988l31.006-81.465c.315-.95-.159-1.583-1.267-1.583zm250.702 50.145c-.473-1.266-.79-2.688-.948-4.271 0-.632.316-.951.948-.951h46.35c1.107 0 1.74-.632 1.74-1.58 0-12.972-.95-18.508-2.531-23.57-4.429-13.447-16.136-21.513-33.061-21.513-16.295 0-28.474 7.909-32.903 21.671-1.583 4.746-2.531 10.283-2.531 18.35 0 7.909 1.107 13.445 2.688 18.192 4.431 13.762 16.451 21.828 33.852 21.828 14.08 0 25.311-5.06 32.587-12.811.633-.635.633-1.583-.157-2.216l-10.441-9.807c-.633-.79-1.425-.633-2.215 0-4.43 4.112-9.966 6.8-17.559 6.8-7.909 0-13.761-3.478-15.819-10.122zm0-19.931c-.631 0-.948-.318-.948-.951 0-2.373.317-4.112.791-5.695 1.74-5.22 6.487-8.382 12.814-8.382 6.326 0 11.071 3.162 12.811 8.382.475 1.583.791 3.322.791 5.695 0 .633-.316.951-.948.951zm-62.72-31.955c-10.757 0-18.349 3.638-24.044 9.65h-.158c-4.429-6.328-11.231-9.65-20.564-9.65-9.808 0-16.292 3.954-19.774 8.701h-.158v-5.378c0-.951-.632-1.583-1.58-1.583h-18.984c-.948 0-1.582.632-1.582 1.583v73.397c0 .951.634 1.583 1.582 1.583h18.984c.948 0 1.58-.632 1.58-1.583v-43.975c0-8.384 4.43-13.92 12.022-13.92 7.91 0 11.866 5.536 11.866 13.92v43.975c0 .951.632 1.583 1.58 1.583h18.984c.948 0 1.581-.632 1.581-1.583v-43.975c0-8.384 4.271-13.92 11.864-13.92 7.909 0 12.023 5.536 12.023 13.92v43.975c0 .951.632 1.583 1.581 1.583h18.983c.949 0 1.581-.632 1.581-1.583v-48.245c0-16.927-9.332-28.475-27.367-28.475zm-123.43 1.74h18.984c.948 0 1.58.632 1.58 1.583v73.397c0 .951-.632 1.583-1.58 1.583h-18.984c-.948 0-1.582-.632-1.582-1.583v-73.398c0-.95.634-1.582 1.582-1.582zm18.984-23.095h-18.984c-.948 0-1.582.633-1.582 1.583v15.66c0 .948.634 1.582 1.582 1.582h18.984c.948 0 1.58-.634 1.58-1.582v-15.66c0-.95-.632-1.583-1.58-1.583zm-45.035 23.096h9.808c.948 0 1.582.632 1.582 1.583v13.129c0 .948-.634 1.581-1.582 1.581h-9.808c-.632 0-.949.318-.949.95v33.852c0 5.694 1.899 7.593 6.96 7.593h3.797c.948 0 1.582.632 1.582 1.58v15.663c0 .948-.634 1.58-1.582 1.58h-8.385c-17.717 0-24.36-7.908-24.36-25.468v-34.8c0-.632-.316-.95-.95-.95h-4.745c-.949 0-1.581-.633-1.581-1.581v-13.13c0-.95.632-1.582 1.581-1.582h4.745c.634 0 .95-.316.95-.948v-20.565c0-.95.633-1.582 1.581-1.582h18.826c.947 0 1.581.632 1.581 1.582v20.564c0 .632.317.948.949.948zm-165.192 6.96c3.482-4.746 9.966-8.701 19.774-8.701 16.926 0 26.101 11.707 26.101 28.475v48.245c0 .951-.633 1.583-1.581 1.583h-18.984c-.948 0-1.58-.632-1.58-1.583v-43.975c0-8.384-3.956-13.92-11.866-13.92-7.592 0-12.022 5.536-12.022 13.92v43.975c0 .951-.632 1.583-1.58 1.583h-18.984c-.948 0-1.582-.632-1.582-1.583v-73.398c0-.95.634-1.582 1.582-1.582h18.984c.948 0 1.58.632 1.58 1.583v5.378zm-59.19 38.914c0-.632-.316-.951-.951-.951h-10.756c-9.333 0-13.604 2.691-13.604 8.701 0 5.379 3.796 8.068 11.073 8.068 9.491 0 14.238-3.48 14.238-10.598zm21.038 29.105v-49.037c0-19.14-9.017-27.682-34.01-27.682-12.655 0-21.988 3.005-28.475 7.593-.791.473-.948 1.265-.475 2.215l7.119 12.495c.475.791 1.265.95 2.057.316 3.638-2.688 9.332-4.902 17.083-4.902 12.181 0 15.663 3.322 15.663 10.44v2.846c0 .634-.316.951-.951.951h-13.604c-18.983 0-31.795 7.751-31.795 24.676 0 16.293 11.864 23.411 25.467 23.411 10.443 0 17.085-3.322 21.04-8.383h.159v5.061c0 .951.632 1.583 1.581 1.583h17.559c.949 0 1.582-.632 1.582-1.583z"/></g></g></svg>';

// src/~assets/svg/assets/logo-horizontal-bb.svg
var logo_horizontal_bb_default = '<svg viewBox="0 0 836 259" xmlns="http://www.w3.org/2000/svg"><path d="m819.803 71.394v-3.6869h2.058v3.6869zm-4.206 8.4718h4.206v-5.4126h2.058v5.4126h4.385v-4.4713c0-1.255-.895-2.0395-2.506-2.4317 1.521-.706 2.148-1.4904 2.148-2.9808v-2.4317c0-1.6473-1.253-2.5886-3.132-2.5886h-7.159zm4.832 3.2161c-7.338 0-11.991-4.2359-11.991-10.5897 0-6.5108 4.832-10.9036 11.991-10.9036 7.428 0 12.26 4.3928 12.26 10.9036 0 6.4323-4.832 10.5897-12.26 10.5897zm0 2.5886c9.128 0 15.571-5.3341 15.571-13.1783 0-8.0012-6.354-13.4922-15.571-13.4922-9.038 0-15.213 5.4126-15.213 13.4922 0 7.9227 6.175 13.1783 15.213 13.1783zm-54.677 43.5355v-24.003h13.691v24.003zm-25.415 64.794h25.146l.179-45.261h13.692v45.261h26.13v-38.672c0-8.158-5.458-13.649-15.034-16.865 9.307-4.785 13.871-9.414 13.871-19.768v-15.924c0-10.9035-7.785-17.728-20.224-17.728h-43.492zm-64.163 0h50.203v-20.16h-24.43v-25.101h19.418v-19.611h-19.866v-23.925h24.878v-20.16h-50.382zm-53.156 0h25.772v-88.797h15.84v-20.16h-57.541v20.16h15.839v88.797zm-66.043 0h22.194c12.438 0 20.224-6.825 20.224-17.728v-28.083c0-10.589-6.175-16.629-18.345-17.571l-19.419-1.49v-23.925h12.707v14.276h24.878v-16.708c0-10.9035-7.786-17.728-20.224-17.728h-22.194c-12.438 0-20.224 6.8245-20.224 17.728v28.867c0 10.59 6.175 16.473 18.345 17.414l19.419 1.491v23.297h-12.707v-13.649h-24.878v16.081c0 10.982 7.786 17.728 20.224 17.728zm-80.36 0h24.878c12.439 0 20.224-6.825 20.224-17.728l-.179-91.3074h-25.952v88.8754h-13.691v-88.797h-25.504v91.307c0 10.904 7.785 17.65 20.224 17.65zm-74.365-64.794v-24.003h13.692v24.003zm-24.788 64.794h44.475c12.439 0 20.225-6.825 20.225-17.728v-21.023c0-8.158-5.459-13.649-15.034-16.865 9.307-4.785 13.87-9.413 13.87-19.767v-15.846c0-10.9035-7.785-17.728-20.224-17.728h-43.223v108.957zm24.788-20.16v-25.101h13.692v25.101zm-164.39 20.16h22.998c12.439 0 20.225-6.825 20.225-17.728v-27.533h-24.878v25.101h-12.797v-68.637h12.708v21.022h24.877v-23.454c0-10.9035-7.785-17.728-20.224-17.728h-22.998c-12.439 0-20.225 6.8245-20.225 17.728v73.579c.09 10.904 7.875 17.65 20.314 17.65zm-74.633-20.16v-68.637h13.691v68.637zm-5.728 20.16h25.057c12.439 0 20.404-6.825 20.404-17.728v-73.501c0-10.9035-7.786-17.728-20.225-17.728h-25.236c-12.438 0-20.224 6.8245-20.224 17.728v73.579c0 10.904 7.786 17.65 20.224 17.65zm-77.9439 0h49.3979v-20.16h-23.804v-88.797h-25.5939zm-54.6773-64.794v-24.003h13.6917v24.003zm-24.8778 64.794h44.4757c12.4389 0 20.2244-6.825 20.2244-17.728v-21.023c0-8.158-5.4588-13.649-15.0341-16.865 9.3068-4.785 13.8707-9.413 13.8707-19.767v-15.846c0-10.9035-7.7855-17.728-20.2243-17.728h-43.3124zm24.8778-20.16v-25.101h13.6917v25.101zm270.6122 20.16h25.147v-48.635l19.15 48.635h27.652l-24.43-57.891 22.819-51.066h-25.772l-19.419 45.811v-45.811h-25.147z" fill="#ffe13f"/></svg>';

// src/~assets/assets.ts
var assetSizes = [16, 32, 64, 120, 128, 180, 256, 512, 1024];
var backgroundColors = [void 0, "backdrop"];
var aspectRatios = [void 0, "16x9", "1x1"];
var assetTypes = {
  logoVertical: { aliases: ["iosLaunchScreen"] },
  logoHorizontal: { aliases: ["tvOsIcon", "androidTvIcon"] },
  logoWithoutText: {
    aliases: [
      "favicon",
      "appIcon",
      "lgSmallIcon",
      "lgStore",
      "samsungIcon",
      "lgLargeIcon"
    ]
  },
  logoHorizontalOnBG: { aliases: ["openGraphImage"] },
  coverFallback: { aliases: [] },
  blank: { aliases: ["tvOsBackdrop"] },
  decorative1: { aliases: ["errorScreen"] },
  decorative2: { aliases: ["list16x9"] },
  ticketCover: { aliases: [] },
  appStore: { aliases: [] },
  googlePlay: { aliases: [] }
};
var common = {
  appStore: `APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg`,
  googlePlay: `APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg`,
  ticketCover: `APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png`,
  decorative1: `APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg`,
  blank: `APP/1x1_00000000.png`
};
var assets = {
  ["SFAnytime" /* SFAnytime */]: __spreadProps(__spreadValues({}, common), {
    logoHorizontal: `APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg`,
    logoVertical: `APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg`,
    logoWithoutText: `APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg`,
    logoHorizontalOnBG: `APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=360&h=1080&w=1920&fit=fill`,
    coverFallback: `APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=200&h=750&w=519&fit=fill&sat=-70`,
    decorative2: "APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png"
  }),
  ["Blockbuster" /* Blockbuster */]: __spreadProps(__spreadValues({}, common), {
    logoHorizontal: `APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg`,
    logoVertical: `APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg`,
    logoWithoutText: `APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg`,
    logoHorizontalOnBG: `APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=360&h=1080&w=1920&fit=fill`,
    coverFallback: `APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=200&h=750&w=519&fit=fill`,
    decorative2: "APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png"
  })
};
var svgAssets = {
  ["SFAnytime" /* SFAnytime */]: {
    logoHorizontal: logo_horizontal_default
  },
  ["Blockbuster" /* Blockbuster */]: {
    logoHorizontal: logo_horizontal_bb_default
  }
};

// src/~assets/types.ts
var keysUsedForCdnUrl = [
  "brand",
  "height",
  "backgroundColor",
  "aspectRatio"
];

// src/~assets/__generated__/cdn-asset-urls.json
var cdn_asset_urls_default = {
  "logoVertical@Blockbuster@16@@": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=16&fm=svg&bg=00000000&s=f6874115aa5b253189427f46ba770ed1",
  "logoVertical@Blockbuster@16@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=16&w=28&fm=svg&bg=00000000&fit=crop&s=47ea841c296c9cf5a97d4559284f215c",
  "logoVertical@Blockbuster@16@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=16&w=16&fm=svg&bg=00000000&fit=crop&s=8b79f28b881ce33692f9156df3fc4c61",
  "logoVertical@Blockbuster@16@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=16&fm=svg&bg=001B9F&s=2b559afcbca4acd04cb8b38ce10778a9",
  "logoVertical@Blockbuster@16@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=16&w=28&fm=svg&bg=001B9F&fit=crop&s=64f0bb35357aaf81b44f553c945bd600",
  "logoVertical@Blockbuster@16@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=16&w=16&fm=svg&bg=001B9F&fit=crop&s=532d5af93f66fa72db17e403fcf054ab",
  "logoVertical@Blockbuster@32@@": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=32&fm=svg&bg=00000000&s=93de4dd878d80b892b414e7943200e2d",
  "logoVertical@Blockbuster@32@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=32&w=57&fm=svg&bg=00000000&fit=crop&s=0b2a6297093e99b200573764bb2b0a6d",
  "logoVertical@Blockbuster@32@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=32&w=32&fm=svg&bg=00000000&fit=crop&s=c58b3b4eb7fc24dbfc6fe5021dbae42a",
  "logoVertical@Blockbuster@32@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=32&fm=svg&bg=001B9F&s=c429c1dc227e617d5996136accff4fa7",
  "logoVertical@Blockbuster@32@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=32&w=57&fm=svg&bg=001B9F&fit=crop&s=ed6d0cdfbcf0ec043bd7bc1f833af74e",
  "logoVertical@Blockbuster@32@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=32&w=32&fm=svg&bg=001B9F&fit=crop&s=028bd845f6672a6efb2372dcdff05c8c",
  "logoVertical@Blockbuster@64@@": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=64&fm=svg&bg=00000000&s=49f101fefcbd0a8ec259b2faa2bd4358",
  "logoVertical@Blockbuster@64@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=64&w=114&fm=svg&bg=00000000&fit=crop&s=fcee57e1eb56e8fbec196cd6b1071e4a",
  "logoVertical@Blockbuster@64@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=64&w=64&fm=svg&bg=00000000&fit=crop&s=53ee946ce552f65a05ae3ba88a494b16",
  "logoVertical@Blockbuster@64@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=64&fm=svg&bg=001B9F&s=b04a54dcd0b98b898cb1049503c29ea6",
  "logoVertical@Blockbuster@64@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=64&w=114&fm=svg&bg=001B9F&fit=crop&s=7c3409d29083d73651b0e6e76aa3c117",
  "logoVertical@Blockbuster@64@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=64&w=64&fm=svg&bg=001B9F&fit=crop&s=15b96a8fe173df08a4402341cd519c6e",
  "logoVertical@Blockbuster@120@@": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=120&fm=svg&bg=00000000&s=6aa777311860a2c9dbeab6bb3aeed6a7",
  "logoVertical@Blockbuster@120@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=120&w=213&fm=svg&bg=00000000&fit=crop&s=9c47838321498ec299ee23a0e7c25d42",
  "logoVertical@Blockbuster@120@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=120&w=120&fm=svg&bg=00000000&fit=crop&s=0132174754c4e80ddd9942274d2070e4",
  "logoVertical@Blockbuster@120@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=120&fm=svg&bg=001B9F&s=88f035c1d8271bb805111d755c76ce9e",
  "logoVertical@Blockbuster@120@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=120&w=213&fm=svg&bg=001B9F&fit=crop&s=23637cbc0815da21866ada4237882adb",
  "logoVertical@Blockbuster@120@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=120&w=120&fm=svg&bg=001B9F&fit=crop&s=ba02268a110a53cf503853387589b40e",
  "logoVertical@Blockbuster@128@@": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=128&fm=svg&bg=00000000&s=abfde7f9c8062af5f3968ae8c02c83a7",
  "logoVertical@Blockbuster@128@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=128&w=228&fm=svg&bg=00000000&fit=crop&s=d251639f62696563e75b2ffbe9d5d776",
  "logoVertical@Blockbuster@128@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=128&w=128&fm=svg&bg=00000000&fit=crop&s=22e2eb8e2f3d0aa8833fd66d10b0964c",
  "logoVertical@Blockbuster@128@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=128&fm=svg&bg=001B9F&s=a887ff475114d6371ebc7ff9d816a9e8",
  "logoVertical@Blockbuster@128@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=128&w=228&fm=svg&bg=001B9F&fit=crop&s=9383bec6aca8f5a968caa3e70a50c402",
  "logoVertical@Blockbuster@128@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=128&w=128&fm=svg&bg=001B9F&fit=crop&s=2be5c135f973893948912f9e47e4d3a5",
  "logoVertical@Blockbuster@180@@": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=180&fm=svg&bg=00000000&s=b9b77c2712b906280337f56dbf1496c5",
  "logoVertical@Blockbuster@180@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=180&w=320&fm=svg&bg=00000000&fit=crop&s=f758318c04930df8c5e99508f25490fc",
  "logoVertical@Blockbuster@180@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=180&w=180&fm=svg&bg=00000000&fit=crop&s=f015ff62027661948f683193bcc5b7dd",
  "logoVertical@Blockbuster@180@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=180&fm=svg&bg=001B9F&s=2eafd0e8d755b3514895bdd2c0613d5f",
  "logoVertical@Blockbuster@180@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=180&w=320&fm=svg&bg=001B9F&fit=crop&s=1ff188d3ad5f00c6b322b2c1458bad85",
  "logoVertical@Blockbuster@180@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=180&w=180&fm=svg&bg=001B9F&fit=crop&s=56aba3c6e1192e0117a6398934eb1658",
  "logoVertical@Blockbuster@256@@": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=256&fm=svg&bg=00000000&s=04a57cea3b5c6fc186bcc620f4a70747",
  "logoVertical@Blockbuster@256@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=256&w=455&fm=svg&bg=00000000&fit=crop&s=76a1b8d82423a64f692afeb605f498c5",
  "logoVertical@Blockbuster@256@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=256&w=256&fm=svg&bg=00000000&fit=crop&s=10886753934f89415f33ac7b9a852a34",
  "logoVertical@Blockbuster@256@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=256&fm=svg&bg=001B9F&s=6787bbaed31a980400a0974e3c741de6",
  "logoVertical@Blockbuster@256@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=256&w=455&fm=svg&bg=001B9F&fit=crop&s=5445e996f4f0fa99bed69849ec55ed6a",
  "logoVertical@Blockbuster@256@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=256&w=256&fm=svg&bg=001B9F&fit=crop&s=618e2e76e7bd2d533ccc744bf0c4cba9",
  "logoVertical@Blockbuster@512@@": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=512&fm=svg&bg=00000000&s=81592c1a3a91dea3a95a303275dc9318",
  "logoVertical@Blockbuster@512@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=512&w=910&fm=svg&bg=00000000&fit=crop&s=992313aa7f074575f9416f7ca9bb24ca",
  "logoVertical@Blockbuster@512@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=512&w=512&fm=svg&bg=00000000&fit=crop&s=2555d95cc483d59875dfafe979d88fea",
  "logoVertical@Blockbuster@512@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=512&fm=svg&bg=001B9F&s=c33b1333a1a7f6341ca8864382bcdae4",
  "logoVertical@Blockbuster@512@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=512&w=910&fm=svg&bg=001B9F&fit=crop&s=8a741da3512a637e19b6fea2a4ad0fd3",
  "logoVertical@Blockbuster@512@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=512&w=512&fm=svg&bg=001B9F&fit=crop&s=5ad0d631ec85254d2a2a7f867e0fd3e2",
  "logoVertical@Blockbuster@1024@@": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=1024&fm=svg&bg=00000000&s=e5c2698a791c8a81d75a930cd0b1b111",
  "logoVertical@Blockbuster@1024@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=1024&w=1820&fm=svg&bg=00000000&fit=crop&s=d8c57008d404ce407d4614230c8af065",
  "logoVertical@Blockbuster@1024@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=1024&w=1024&fm=svg&bg=00000000&fit=crop&s=92b2bbc8700c329c47b9216f5d4fbda8",
  "logoVertical@Blockbuster@1024@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=1024&fm=svg&bg=001B9F&s=25e145759707bffec3338997aa895ea4",
  "logoVertical@Blockbuster@1024@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=1024&w=1820&fm=svg&bg=001B9F&fit=crop&s=a94ae1791940d4545e0ae31a53671926",
  "logoVertical@Blockbuster@1024@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_BB_2d8968078caabb261f7709d16b1eb622.svg?h=1024&w=1024&fm=svg&bg=001B9F&fit=crop&s=96388313d5c95c4dc0e23966356d4a14",
  "logoHorizontal@Blockbuster@16@@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=16&fm=svg&bg=00000000&s=154b6598d292e21b56a778db495c829a",
  "logoHorizontal@Blockbuster@16@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=16&w=28&fm=svg&bg=00000000&fit=crop&s=e7a7d58ee6715990fa340ab7aa4b742d",
  "logoHorizontal@Blockbuster@16@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=16&w=16&fm=svg&bg=00000000&fit=crop&s=980befd6b85554f20017962fcf098773",
  "logoHorizontal@Blockbuster@16@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=16&fm=svg&bg=001B9F&s=9bc22207e3ab156de0e5f086aa8ef4ec",
  "logoHorizontal@Blockbuster@16@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=16&w=28&fm=svg&bg=001B9F&fit=crop&s=053cced12679fab7714a184b357cd44f",
  "logoHorizontal@Blockbuster@16@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=16&w=16&fm=svg&bg=001B9F&fit=crop&s=c1d2b2b4929ac350add6f9f30d7c770d",
  "logoHorizontal@Blockbuster@32@@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=32&fm=svg&bg=00000000&s=9cbc401d2771672d0e220c14f3f11564",
  "logoHorizontal@Blockbuster@32@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=32&w=57&fm=svg&bg=00000000&fit=crop&s=2b7ec825a00d3e24150e2a8bd9fc98aa",
  "logoHorizontal@Blockbuster@32@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=32&w=32&fm=svg&bg=00000000&fit=crop&s=68e845de9a4f684076e80db9cd604a7b",
  "logoHorizontal@Blockbuster@32@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=32&fm=svg&bg=001B9F&s=82a3158829564b575d7b20e37da032db",
  "logoHorizontal@Blockbuster@32@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=32&w=57&fm=svg&bg=001B9F&fit=crop&s=3eddf4e25c64829171bd10d0ea879574",
  "logoHorizontal@Blockbuster@32@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=32&w=32&fm=svg&bg=001B9F&fit=crop&s=96bbc36f8ddb513ec635d8478231a133",
  "logoHorizontal@Blockbuster@64@@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=64&fm=svg&bg=00000000&s=d61a472f47a66e52e9ebe9e0c7552cae",
  "logoHorizontal@Blockbuster@64@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=64&w=114&fm=svg&bg=00000000&fit=crop&s=73c97aaa791d36cc4573ee977980f61b",
  "logoHorizontal@Blockbuster@64@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=64&w=64&fm=svg&bg=00000000&fit=crop&s=0b6811b5ee55dc9f500c40cdec08173d",
  "logoHorizontal@Blockbuster@64@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=64&fm=svg&bg=001B9F&s=dfede926689aff59ac68a7620fbb0f2c",
  "logoHorizontal@Blockbuster@64@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=64&w=114&fm=svg&bg=001B9F&fit=crop&s=79eaa1c1811a7ba65557a7e1714500d4",
  "logoHorizontal@Blockbuster@64@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=64&w=64&fm=svg&bg=001B9F&fit=crop&s=0ec724d36d2aad8fee12712083310be9",
  "logoHorizontal@Blockbuster@120@@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=120&fm=svg&bg=00000000&s=43de4077a554b543053f7b8f91f9cadd",
  "logoHorizontal@Blockbuster@120@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=120&w=213&fm=svg&bg=00000000&fit=crop&s=15d9953363ca5ad23d56fb4f3494d76c",
  "logoHorizontal@Blockbuster@120@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=120&w=120&fm=svg&bg=00000000&fit=crop&s=38cf29e07934990e22021a63d4772bac",
  "logoHorizontal@Blockbuster@120@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=120&fm=svg&bg=001B9F&s=91075e496e8ad8f2a9e2b773cae18a04",
  "logoHorizontal@Blockbuster@120@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=120&w=213&fm=svg&bg=001B9F&fit=crop&s=4aaf40021b61e89e58bfb22efefb1ecf",
  "logoHorizontal@Blockbuster@120@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=120&w=120&fm=svg&bg=001B9F&fit=crop&s=e50b1978085108e9db03b69b05a750b2",
  "logoHorizontal@Blockbuster@128@@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=128&fm=svg&bg=00000000&s=a28d7ef1d8c3f9ad0200e59884481dd4",
  "logoHorizontal@Blockbuster@128@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=128&w=228&fm=svg&bg=00000000&fit=crop&s=222d836de700e8d66e9639f7f56426b7",
  "logoHorizontal@Blockbuster@128@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=128&w=128&fm=svg&bg=00000000&fit=crop&s=b136d86ce4c468dda444394628affb46",
  "logoHorizontal@Blockbuster@128@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=128&fm=svg&bg=001B9F&s=8dfefc1433f77884ed3a83c8dec30634",
  "logoHorizontal@Blockbuster@128@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=128&w=228&fm=svg&bg=001B9F&fit=crop&s=677a211256537c545fcd85b52920f36e",
  "logoHorizontal@Blockbuster@128@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=128&w=128&fm=svg&bg=001B9F&fit=crop&s=52063b3abfe6cc45fa271f8dcb3ccdc6",
  "logoHorizontal@Blockbuster@180@@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=180&fm=svg&bg=00000000&s=28989e7a49f03a9aa970eba4fe04890a",
  "logoHorizontal@Blockbuster@180@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=180&w=320&fm=svg&bg=00000000&fit=crop&s=0a09fd31f05bdd245f1a19b37a905ba5",
  "logoHorizontal@Blockbuster@180@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=180&w=180&fm=svg&bg=00000000&fit=crop&s=39139f27bfa30d6fb7960af71c61b48c",
  "logoHorizontal@Blockbuster@180@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=180&fm=svg&bg=001B9F&s=b0f49de6311e00e993a3daa9df2961c4",
  "logoHorizontal@Blockbuster@180@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=180&w=320&fm=svg&bg=001B9F&fit=crop&s=c244d65d8f60552b83f1f6920f07de93",
  "logoHorizontal@Blockbuster@180@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=180&w=180&fm=svg&bg=001B9F&fit=crop&s=0125315d211a5e7b43c58da7f60d8158",
  "logoHorizontal@Blockbuster@256@@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=256&fm=svg&bg=00000000&s=b9d0c95e1ecb762a01492b346c6d55bd",
  "logoHorizontal@Blockbuster@256@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=256&w=455&fm=svg&bg=00000000&fit=crop&s=df312ff5050a575cc9ff358fda76c38f",
  "logoHorizontal@Blockbuster@256@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=256&w=256&fm=svg&bg=00000000&fit=crop&s=1a1f73bb786e66de1e26771673d24239",
  "logoHorizontal@Blockbuster@256@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=256&fm=svg&bg=001B9F&s=ebf1eb3377309d0faa46b03b2b43108e",
  "logoHorizontal@Blockbuster@256@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=256&w=455&fm=svg&bg=001B9F&fit=crop&s=c6ebc8922a08c304b5735ba324603f52",
  "logoHorizontal@Blockbuster@256@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=256&w=256&fm=svg&bg=001B9F&fit=crop&s=bc34b5ac984b8ff200d5d85239a675e6",
  "logoHorizontal@Blockbuster@512@@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=512&fm=svg&bg=00000000&s=73b6930f1ec6ce7551cb710f92798f22",
  "logoHorizontal@Blockbuster@512@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=512&w=910&fm=svg&bg=00000000&fit=crop&s=d785824ac4931d847f8825008666839a",
  "logoHorizontal@Blockbuster@512@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=512&w=512&fm=svg&bg=00000000&fit=crop&s=75b18089f4c11c39340f152bc10fcc43",
  "logoHorizontal@Blockbuster@512@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=512&fm=svg&bg=001B9F&s=171c6c72e82f89de30d37b0a7e5b7af1",
  "logoHorizontal@Blockbuster@512@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=512&w=910&fm=svg&bg=001B9F&fit=crop&s=e5d2c3d05cb35e7461555b20f56b9f47",
  "logoHorizontal@Blockbuster@512@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=512&w=512&fm=svg&bg=001B9F&fit=crop&s=c95859a2b18ec6b1281de0f7586b9ae4",
  "logoHorizontal@Blockbuster@1024@@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=1024&fm=svg&bg=00000000&s=15bb4ac3d415150904d582edb36f08c4",
  "logoHorizontal@Blockbuster@1024@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=1024&w=1820&fm=svg&bg=00000000&fit=crop&s=986ea44f64df5fce79bd2302451d5fa5",
  "logoHorizontal@Blockbuster@1024@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=1024&w=1024&fm=svg&bg=00000000&fit=crop&s=98c63514a6828d1337672995018b5ae9",
  "logoHorizontal@Blockbuster@1024@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=1024&fm=svg&bg=001B9F&s=17aa6eb84e6eb16ab77230464d00f226",
  "logoHorizontal@Blockbuster@1024@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=1024&w=1820&fm=svg&bg=001B9F&fit=crop&s=bc14465d1f5a848df0f1cdef399fea94",
  "logoHorizontal@Blockbuster@1024@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?h=1024&w=1024&fm=svg&bg=001B9F&fit=crop&s=61f0b56481e9f80d97ceb60aed95fb61",
  "logoWithoutText@Blockbuster@16@@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=16&fm=svg&bg=00000000&s=e7cda710b8a7c2010514d4cf4d6da3cf",
  "logoWithoutText@Blockbuster@16@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=16&w=28&fm=svg&bg=00000000&fit=crop&s=ef97184706238188e57cfa56f1b03047",
  "logoWithoutText@Blockbuster@16@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=16&w=16&fm=svg&bg=00000000&fit=crop&s=f2b2ba22f2ca0d6d7eb9f823cae31ae7",
  "logoWithoutText@Blockbuster@16@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=16&fm=svg&bg=001B9F&s=a7edf3c346b2803e8f7f624bf9e13ac4",
  "logoWithoutText@Blockbuster@16@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=16&w=28&fm=svg&bg=001B9F&fit=crop&s=7eb363104211cf5bfdb9c382fbc33890",
  "logoWithoutText@Blockbuster@16@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=16&w=16&fm=svg&bg=001B9F&fit=crop&s=363eace0182f2a54fbf216bd43cd41c9",
  "logoWithoutText@Blockbuster@32@@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=32&fm=svg&bg=00000000&s=7282f7dec94ca593d515fd6a228f20f9",
  "logoWithoutText@Blockbuster@32@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=32&w=57&fm=svg&bg=00000000&fit=crop&s=61192802fac79a9da21ef8a2ad20f6ac",
  "logoWithoutText@Blockbuster@32@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=32&w=32&fm=svg&bg=00000000&fit=crop&s=05287d29678bb6209aa8bf3f0f31cbec",
  "logoWithoutText@Blockbuster@32@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=32&fm=svg&bg=001B9F&s=1da3ec6786da479dcc35b46848a6883f",
  "logoWithoutText@Blockbuster@32@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=32&w=57&fm=svg&bg=001B9F&fit=crop&s=74af9be95cc7d4321fb9ad6c4370ccec",
  "logoWithoutText@Blockbuster@32@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=32&w=32&fm=svg&bg=001B9F&fit=crop&s=cfd7b9fbfb69abea12205efb284814b2",
  "logoWithoutText@Blockbuster@64@@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=64&fm=svg&bg=00000000&s=2565253c9bd06a83dec6fe294fd57450",
  "logoWithoutText@Blockbuster@64@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=64&w=114&fm=svg&bg=00000000&fit=crop&s=a5604b6fbf4aa07bae3cfc3c8752b952",
  "logoWithoutText@Blockbuster@64@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=64&w=64&fm=svg&bg=00000000&fit=crop&s=9a977fa10e154495430f8dbb0aa326bc",
  "logoWithoutText@Blockbuster@64@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=64&fm=svg&bg=001B9F&s=8a5726469a2b809bb049fc743dfa4d49",
  "logoWithoutText@Blockbuster@64@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=64&w=114&fm=svg&bg=001B9F&fit=crop&s=a6ed2845b54d8e5dec181a7b7abe76a8",
  "logoWithoutText@Blockbuster@64@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=64&w=64&fm=svg&bg=001B9F&fit=crop&s=2ea2cbcc7f2348c553376701000f3a75",
  "logoWithoutText@Blockbuster@120@@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=120&fm=svg&bg=00000000&s=303f78aa17256a71549ddb8df48e3e0b",
  "logoWithoutText@Blockbuster@120@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=120&w=213&fm=svg&bg=00000000&fit=crop&s=79221fb6abeb5f028d9a71f72ac91d28",
  "logoWithoutText@Blockbuster@120@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=120&w=120&fm=svg&bg=00000000&fit=crop&s=6c708c51f883e2344d0c4e4c59d60c75",
  "logoWithoutText@Blockbuster@120@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=120&fm=svg&bg=001B9F&s=bb5d8ae31245a2757a97fc3938ea9d7c",
  "logoWithoutText@Blockbuster@120@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=120&w=213&fm=svg&bg=001B9F&fit=crop&s=9f3ba3fc7f76884b36fa50e0d6ec102f",
  "logoWithoutText@Blockbuster@120@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=120&w=120&fm=svg&bg=001B9F&fit=crop&s=14cc6b4e604a236c14fb51f92eee45c6",
  "logoWithoutText@Blockbuster@128@@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=128&fm=svg&bg=00000000&s=dacac0732d447b3024e191ee2fe9b32e",
  "logoWithoutText@Blockbuster@128@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=128&w=228&fm=svg&bg=00000000&fit=crop&s=9d18e9731babdcd25fd81f6f81b99900",
  "logoWithoutText@Blockbuster@128@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=128&w=128&fm=svg&bg=00000000&fit=crop&s=39f888834289b850317a5cc99d94ca6f",
  "logoWithoutText@Blockbuster@128@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=128&fm=svg&bg=001B9F&s=ed6f73f05778eb888139ea16b3ef2f94",
  "logoWithoutText@Blockbuster@128@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=128&w=228&fm=svg&bg=001B9F&fit=crop&s=12420f6c556bdfc270880a1b45abee40",
  "logoWithoutText@Blockbuster@128@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=128&w=128&fm=svg&bg=001B9F&fit=crop&s=987f6bb017ce73b061957c8bca281e14",
  "logoWithoutText@Blockbuster@180@@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=180&fm=svg&bg=00000000&s=29bea9b5b3eb6b6dd15ffe49f5957429",
  "logoWithoutText@Blockbuster@180@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=180&w=320&fm=svg&bg=00000000&fit=crop&s=19224b04a842362b71d0c800ccf61a75",
  "logoWithoutText@Blockbuster@180@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=180&w=180&fm=svg&bg=00000000&fit=crop&s=073073e1fdbf6aa814be15a81c0a416d",
  "logoWithoutText@Blockbuster@180@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=180&fm=svg&bg=001B9F&s=c14ee1d739f56c886b36cbd50bc27a45",
  "logoWithoutText@Blockbuster@180@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=180&w=320&fm=svg&bg=001B9F&fit=crop&s=ffda5affef3b8567346fad44902db419",
  "logoWithoutText@Blockbuster@180@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=180&w=180&fm=svg&bg=001B9F&fit=crop&s=6c6270be18caa65ac2a5c8b4d1e23df7",
  "logoWithoutText@Blockbuster@256@@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=256&fm=svg&bg=00000000&s=1d567e5a362833336f22a8732d9b605b",
  "logoWithoutText@Blockbuster@256@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=256&w=455&fm=svg&bg=00000000&fit=crop&s=93060274e3d9597cf24c40d6f41b25ee",
  "logoWithoutText@Blockbuster@256@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=256&w=256&fm=svg&bg=00000000&fit=crop&s=d58e0635243d720205194352b432d7e7",
  "logoWithoutText@Blockbuster@256@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=256&fm=svg&bg=001B9F&s=af95bde74bb2139cb045b73697dd2e8a",
  "logoWithoutText@Blockbuster@256@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=256&w=455&fm=svg&bg=001B9F&fit=crop&s=574ba168ada90af6fe223dfaaac2f7c4",
  "logoWithoutText@Blockbuster@256@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=256&w=256&fm=svg&bg=001B9F&fit=crop&s=1a9fcc2d4dbb1bc7b6f7324d1b4c040f",
  "logoWithoutText@Blockbuster@512@@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=512&fm=svg&bg=00000000&s=9f28cf9a48956feb608521369d7f120a",
  "logoWithoutText@Blockbuster@512@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=512&w=910&fm=svg&bg=00000000&fit=crop&s=293a1504b43889773e4e52d3c176193a",
  "logoWithoutText@Blockbuster@512@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=512&w=512&fm=svg&bg=00000000&fit=crop&s=74277fee47bf062b089205ed0fc49d45",
  "logoWithoutText@Blockbuster@512@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=512&fm=svg&bg=001B9F&s=6acf2879b612e6f2e0357cc2cfe35efd",
  "logoWithoutText@Blockbuster@512@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=512&w=910&fm=svg&bg=001B9F&fit=crop&s=c8e66de1091531c62c8f8242e32e80ae",
  "logoWithoutText@Blockbuster@512@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=512&w=512&fm=svg&bg=001B9F&fit=crop&s=8a926915b183242c73966b10a371fc2b",
  "logoWithoutText@Blockbuster@1024@@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=1024&fm=svg&bg=00000000&s=dd0af9f7ab5fe69782ab31e41760997f",
  "logoWithoutText@Blockbuster@1024@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=1024&w=1820&fm=svg&bg=00000000&fit=crop&s=4764674fa64f2eef4bbdcd0ee787ae65",
  "logoWithoutText@Blockbuster@1024@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=1024&w=1024&fm=svg&bg=00000000&fit=crop&s=cf4833a7b6ff07f21663b136c23e99f9",
  "logoWithoutText@Blockbuster@1024@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=1024&fm=svg&bg=001B9F&s=4dc3b807f21fd3544ecb52f0602859b4",
  "logoWithoutText@Blockbuster@1024@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=1024&w=1820&fm=svg&bg=001B9F&fit=crop&s=b23688a8ae1b0fe2f2551954f791bf96",
  "logoWithoutText@Blockbuster@1024@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?h=1024&w=1024&fm=svg&bg=001B9F&fit=crop&s=dbcf0ff6f442adb80e8f066a839ebf4f",
  "logoHorizontalOnBG@Blockbuster@16@@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=5&h=16&w=28&fit=fill&fm=svg&s=227069b141291240e38e2d86c7b3465d",
  "logoHorizontalOnBG@Blockbuster@16@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=5&h=16&w=28&fit=fill&fm=svg&s=227069b141291240e38e2d86c7b3465d",
  "logoHorizontalOnBG@Blockbuster@16@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=5&h=16&w=16&fit=fill&fm=svg&s=12e7a6b294b18b2b0fc4cb5d32b14887",
  "logoHorizontalOnBG@Blockbuster@16@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=5&h=16&w=28&fit=fill&fm=svg&s=227069b141291240e38e2d86c7b3465d",
  "logoHorizontalOnBG@Blockbuster@16@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=5&h=16&w=28&fit=fill&fm=svg&s=227069b141291240e38e2d86c7b3465d",
  "logoHorizontalOnBG@Blockbuster@16@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=5&h=16&w=16&fit=fill&fm=svg&s=12e7a6b294b18b2b0fc4cb5d32b14887",
  "logoHorizontalOnBG@Blockbuster@32@@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=11&h=32&w=57&fit=fill&fm=svg&s=eee9372e9b1126cb4e6a84f31c2380a9",
  "logoHorizontalOnBG@Blockbuster@32@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=11&h=32&w=57&fit=fill&fm=svg&s=eee9372e9b1126cb4e6a84f31c2380a9",
  "logoHorizontalOnBG@Blockbuster@32@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=11&h=32&w=32&fit=fill&fm=svg&s=11c3f3a72334ac6c7be5d712c3c1c059",
  "logoHorizontalOnBG@Blockbuster@32@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=11&h=32&w=57&fit=fill&fm=svg&s=eee9372e9b1126cb4e6a84f31c2380a9",
  "logoHorizontalOnBG@Blockbuster@32@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=11&h=32&w=57&fit=fill&fm=svg&s=eee9372e9b1126cb4e6a84f31c2380a9",
  "logoHorizontalOnBG@Blockbuster@32@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=11&h=32&w=32&fit=fill&fm=svg&s=11c3f3a72334ac6c7be5d712c3c1c059",
  "logoHorizontalOnBG@Blockbuster@64@@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=21&h=64&w=114&fit=fill&fm=svg&s=471b0fe7c9a2ea083e557478040f62fe",
  "logoHorizontalOnBG@Blockbuster@64@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=21&h=64&w=114&fit=fill&fm=svg&s=471b0fe7c9a2ea083e557478040f62fe",
  "logoHorizontalOnBG@Blockbuster@64@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=21&h=64&w=64&fit=fill&fm=svg&s=2c34bd6ec267b7da9d96ec0b06742c2e",
  "logoHorizontalOnBG@Blockbuster@64@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=21&h=64&w=114&fit=fill&fm=svg&s=471b0fe7c9a2ea083e557478040f62fe",
  "logoHorizontalOnBG@Blockbuster@64@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=21&h=64&w=114&fit=fill&fm=svg&s=471b0fe7c9a2ea083e557478040f62fe",
  "logoHorizontalOnBG@Blockbuster@64@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=21&h=64&w=64&fit=fill&fm=svg&s=2c34bd6ec267b7da9d96ec0b06742c2e",
  "logoHorizontalOnBG@Blockbuster@120@@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=40&h=120&w=213&fit=fill&fm=svg&s=3547a268b4b7a65b3fd82d076fa6b63d",
  "logoHorizontalOnBG@Blockbuster@120@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=40&h=120&w=213&fit=fill&fm=svg&s=3547a268b4b7a65b3fd82d076fa6b63d",
  "logoHorizontalOnBG@Blockbuster@120@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=40&h=120&w=120&fit=fill&fm=svg&s=1ae996096b58b3721ba536e754e9f29d",
  "logoHorizontalOnBG@Blockbuster@120@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=40&h=120&w=213&fit=fill&fm=svg&s=3547a268b4b7a65b3fd82d076fa6b63d",
  "logoHorizontalOnBG@Blockbuster@120@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=40&h=120&w=213&fit=fill&fm=svg&s=3547a268b4b7a65b3fd82d076fa6b63d",
  "logoHorizontalOnBG@Blockbuster@120@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=40&h=120&w=120&fit=fill&fm=svg&s=1ae996096b58b3721ba536e754e9f29d",
  "logoHorizontalOnBG@Blockbuster@128@@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=43&h=128&w=228&fit=fill&fm=svg&s=c08513dcadfa2cbe97276daf8cddec93",
  "logoHorizontalOnBG@Blockbuster@128@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=43&h=128&w=228&fit=fill&fm=svg&s=c08513dcadfa2cbe97276daf8cddec93",
  "logoHorizontalOnBG@Blockbuster@128@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=43&h=128&w=128&fit=fill&fm=svg&s=053b0d00844de7efb51d4a96916f30e7",
  "logoHorizontalOnBG@Blockbuster@128@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=43&h=128&w=228&fit=fill&fm=svg&s=c08513dcadfa2cbe97276daf8cddec93",
  "logoHorizontalOnBG@Blockbuster@128@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=43&h=128&w=228&fit=fill&fm=svg&s=c08513dcadfa2cbe97276daf8cddec93",
  "logoHorizontalOnBG@Blockbuster@128@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=43&h=128&w=128&fit=fill&fm=svg&s=053b0d00844de7efb51d4a96916f30e7",
  "logoHorizontalOnBG@Blockbuster@180@@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=60&h=180&w=320&fit=fill&fm=svg&s=cee8b031d2edd8910e9ae2b33fe7663f",
  "logoHorizontalOnBG@Blockbuster@180@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=60&h=180&w=320&fit=fill&fm=svg&s=cee8b031d2edd8910e9ae2b33fe7663f",
  "logoHorizontalOnBG@Blockbuster@180@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=60&h=180&w=180&fit=fill&fm=svg&s=ff5a418ec196e25634a18cfbec27617f",
  "logoHorizontalOnBG@Blockbuster@180@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=60&h=180&w=320&fit=fill&fm=svg&s=cee8b031d2edd8910e9ae2b33fe7663f",
  "logoHorizontalOnBG@Blockbuster@180@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=60&h=180&w=320&fit=fill&fm=svg&s=cee8b031d2edd8910e9ae2b33fe7663f",
  "logoHorizontalOnBG@Blockbuster@180@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=60&h=180&w=180&fit=fill&fm=svg&s=ff5a418ec196e25634a18cfbec27617f",
  "logoHorizontalOnBG@Blockbuster@256@@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=85&h=256&w=455&fit=fill&fm=svg&s=3a141aaab2460223dcf2df0410c8b92b",
  "logoHorizontalOnBG@Blockbuster@256@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=85&h=256&w=455&fit=fill&fm=svg&s=3a141aaab2460223dcf2df0410c8b92b",
  "logoHorizontalOnBG@Blockbuster@256@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=85&h=256&w=256&fit=fill&fm=svg&s=83288f05ca3f5797bab8dea4b3bdcc0a",
  "logoHorizontalOnBG@Blockbuster@256@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=85&h=256&w=455&fit=fill&fm=svg&s=3a141aaab2460223dcf2df0410c8b92b",
  "logoHorizontalOnBG@Blockbuster@256@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=85&h=256&w=455&fit=fill&fm=svg&s=3a141aaab2460223dcf2df0410c8b92b",
  "logoHorizontalOnBG@Blockbuster@256@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=85&h=256&w=256&fit=fill&fm=svg&s=83288f05ca3f5797bab8dea4b3bdcc0a",
  "logoHorizontalOnBG@Blockbuster@512@@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=171&h=512&w=910&fit=fill&fm=svg&s=53a988d7ad6ad9b719b26c6432112b23",
  "logoHorizontalOnBG@Blockbuster@512@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=171&h=512&w=910&fit=fill&fm=svg&s=53a988d7ad6ad9b719b26c6432112b23",
  "logoHorizontalOnBG@Blockbuster@512@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=171&h=512&w=512&fit=fill&fm=svg&s=ff2b33cc29b232aaabe7b573833df555",
  "logoHorizontalOnBG@Blockbuster@512@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=171&h=512&w=910&fit=fill&fm=svg&s=53a988d7ad6ad9b719b26c6432112b23",
  "logoHorizontalOnBG@Blockbuster@512@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=171&h=512&w=910&fit=fill&fm=svg&s=53a988d7ad6ad9b719b26c6432112b23",
  "logoHorizontalOnBG@Blockbuster@512@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=171&h=512&w=512&fit=fill&fm=svg&s=ff2b33cc29b232aaabe7b573833df555",
  "logoHorizontalOnBG@Blockbuster@1024@@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=341&h=1024&w=1820&fit=fill&fm=svg&s=39e771a096091700ba75527b1e6265f3",
  "logoHorizontalOnBG@Blockbuster@1024@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=341&h=1024&w=1820&fit=fill&fm=svg&s=39e771a096091700ba75527b1e6265f3",
  "logoHorizontalOnBG@Blockbuster@1024@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=341&h=1024&w=1024&fit=fill&fm=svg&s=df6c175d6f52acca6dadd04429da17ea",
  "logoHorizontalOnBG@Blockbuster@1024@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=341&h=1024&w=1820&fit=fill&fm=svg&s=39e771a096091700ba75527b1e6265f3",
  "logoHorizontalOnBG@Blockbuster@1024@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=341&h=1024&w=1820&fit=fill&fm=svg&s=39e771a096091700ba75527b1e6265f3",
  "logoHorizontalOnBG@Blockbuster@1024@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_BB_85296c9e8f55c4b6cf8e02505ca8ee60.svg?bg=001B9F&fill-color=001B9F&pad=341&h=1024&w=1024&fit=fill&fm=svg&s=df6c175d6f52acca6dadd04429da17ea",
  "coverFallback@Blockbuster@16@@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=4&h=16&w=11&fit=fill&fm=svg&s=46f28f0104ce49209ea7b285b67fc049",
  "coverFallback@Blockbuster@16@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=4&h=16&w=28&fit=fill&fm=svg&s=5b0f673e56ccca4075601e11f0704b3e",
  "coverFallback@Blockbuster@16@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=4&h=16&w=16&fit=fill&fm=svg&s=f50d92a3211ed64b117e7269032636b0",
  "coverFallback@Blockbuster@16@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=4&h=16&w=11&fit=fill&fm=svg&s=46f28f0104ce49209ea7b285b67fc049",
  "coverFallback@Blockbuster@16@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=4&h=16&w=28&fit=fill&fm=svg&s=5b0f673e56ccca4075601e11f0704b3e",
  "coverFallback@Blockbuster@16@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=4&h=16&w=16&fit=fill&fm=svg&s=f50d92a3211ed64b117e7269032636b0",
  "coverFallback@Blockbuster@32@@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=9&h=32&w=22&fit=fill&fm=svg&s=5e7b3506eb059a115c475df30484a4df",
  "coverFallback@Blockbuster@32@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=9&h=32&w=57&fit=fill&fm=svg&s=aec2895d797b8dd111b260067964d9ef",
  "coverFallback@Blockbuster@32@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=9&h=32&w=32&fit=fill&fm=svg&s=ea78a5591c9574e018daa80c4925a305",
  "coverFallback@Blockbuster@32@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=9&h=32&w=22&fit=fill&fm=svg&s=5e7b3506eb059a115c475df30484a4df",
  "coverFallback@Blockbuster@32@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=9&h=32&w=57&fit=fill&fm=svg&s=aec2895d797b8dd111b260067964d9ef",
  "coverFallback@Blockbuster@32@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=9&h=32&w=32&fit=fill&fm=svg&s=ea78a5591c9574e018daa80c4925a305",
  "coverFallback@Blockbuster@64@@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=17&h=64&w=44&fit=fill&fm=svg&s=31b68e81ebdfe55cedea67d248cf730b",
  "coverFallback@Blockbuster@64@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=17&h=64&w=114&fit=fill&fm=svg&s=dc9d15c2764a912b187c266c3613f8d4",
  "coverFallback@Blockbuster@64@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=17&h=64&w=64&fit=fill&fm=svg&s=6bb3fbade4bae1fc4781e9b9e9494e9f",
  "coverFallback@Blockbuster@64@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=17&h=64&w=44&fit=fill&fm=svg&s=31b68e81ebdfe55cedea67d248cf730b",
  "coverFallback@Blockbuster@64@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=17&h=64&w=114&fit=fill&fm=svg&s=dc9d15c2764a912b187c266c3613f8d4",
  "coverFallback@Blockbuster@64@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=17&h=64&w=64&fit=fill&fm=svg&s=6bb3fbade4bae1fc4781e9b9e9494e9f",
  "coverFallback@Blockbuster@120@@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=32&h=120&w=83&fit=fill&fm=svg&s=1be25a35521432d389667db877c5bcb5",
  "coverFallback@Blockbuster@120@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=32&h=120&w=213&fit=fill&fm=svg&s=6a6d97928f498cfea2d80d978784d0d5",
  "coverFallback@Blockbuster@120@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=32&h=120&w=120&fit=fill&fm=svg&s=c4bb0f77acbce6779d9855d906cc3d66",
  "coverFallback@Blockbuster@120@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=32&h=120&w=83&fit=fill&fm=svg&s=1be25a35521432d389667db877c5bcb5",
  "coverFallback@Blockbuster@120@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=32&h=120&w=213&fit=fill&fm=svg&s=6a6d97928f498cfea2d80d978784d0d5",
  "coverFallback@Blockbuster@120@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=32&h=120&w=120&fit=fill&fm=svg&s=c4bb0f77acbce6779d9855d906cc3d66",
  "coverFallback@Blockbuster@128@@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=34&h=128&w=89&fit=fill&fm=svg&s=294a830fe710ff83c3df096728cc5fb1",
  "coverFallback@Blockbuster@128@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=34&h=128&w=228&fit=fill&fm=svg&s=89770fd12a95b1870bd76edd8404454c",
  "coverFallback@Blockbuster@128@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=34&h=128&w=128&fit=fill&fm=svg&s=8690fc103bb301c32aa98e7a14f79c4f",
  "coverFallback@Blockbuster@128@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=34&h=128&w=89&fit=fill&fm=svg&s=294a830fe710ff83c3df096728cc5fb1",
  "coverFallback@Blockbuster@128@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=34&h=128&w=228&fit=fill&fm=svg&s=89770fd12a95b1870bd76edd8404454c",
  "coverFallback@Blockbuster@128@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=34&h=128&w=128&fit=fill&fm=svg&s=8690fc103bb301c32aa98e7a14f79c4f",
  "coverFallback@Blockbuster@180@@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=48&h=180&w=125&fit=fill&fm=svg&s=37bc50766b7e2fcbbde6193aa42d35f1",
  "coverFallback@Blockbuster@180@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=48&h=180&w=320&fit=fill&fm=svg&s=4955aa89c3c8605df8693bf62dcd33b3",
  "coverFallback@Blockbuster@180@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=48&h=180&w=180&fit=fill&fm=svg&s=1ccb4cd88e5821dc61a9ab3e35da7667",
  "coverFallback@Blockbuster@180@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=48&h=180&w=125&fit=fill&fm=svg&s=37bc50766b7e2fcbbde6193aa42d35f1",
  "coverFallback@Blockbuster@180@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=48&h=180&w=320&fit=fill&fm=svg&s=4955aa89c3c8605df8693bf62dcd33b3",
  "coverFallback@Blockbuster@180@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=48&h=180&w=180&fit=fill&fm=svg&s=1ccb4cd88e5821dc61a9ab3e35da7667",
  "coverFallback@Blockbuster@256@@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=68&h=256&w=177&fit=fill&fm=svg&s=0b6a1194174b0560474eef27f747b83a",
  "coverFallback@Blockbuster@256@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=68&h=256&w=455&fit=fill&fm=svg&s=784cc54d6da82867926f7b68ae8be052",
  "coverFallback@Blockbuster@256@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=68&h=256&w=256&fit=fill&fm=svg&s=75c21358c68fa134daef82050b079a5a",
  "coverFallback@Blockbuster@256@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=68&h=256&w=177&fit=fill&fm=svg&s=0b6a1194174b0560474eef27f747b83a",
  "coverFallback@Blockbuster@256@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=68&h=256&w=455&fit=fill&fm=svg&s=784cc54d6da82867926f7b68ae8be052",
  "coverFallback@Blockbuster@256@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=68&h=256&w=256&fit=fill&fm=svg&s=75c21358c68fa134daef82050b079a5a",
  "coverFallback@Blockbuster@512@@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=137&h=512&w=354&fit=fill&fm=svg&s=0c82bad0fb83eb62f1d4be7aecb91e70",
  "coverFallback@Blockbuster@512@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=137&h=512&w=910&fit=fill&fm=svg&s=01ec934f5e0a714a76be4b3b01e25b51",
  "coverFallback@Blockbuster@512@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=137&h=512&w=512&fit=fill&fm=svg&s=814909d61f325c58f5610603da573804",
  "coverFallback@Blockbuster@512@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=137&h=512&w=354&fit=fill&fm=svg&s=0c82bad0fb83eb62f1d4be7aecb91e70",
  "coverFallback@Blockbuster@512@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=137&h=512&w=910&fit=fill&fm=svg&s=01ec934f5e0a714a76be4b3b01e25b51",
  "coverFallback@Blockbuster@512@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=137&h=512&w=512&fit=fill&fm=svg&s=814909d61f325c58f5610603da573804",
  "coverFallback@Blockbuster@1024@@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=273&h=1024&w=709&fit=fill&fm=svg&s=63d4e26b2f0d9540a660ef91d5d8cf55",
  "coverFallback@Blockbuster@1024@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=273&h=1024&w=1820&fit=fill&fm=svg&s=f8adff2ef0557fe44303eaec7dfae596",
  "coverFallback@Blockbuster@1024@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=273&h=1024&w=1024&fit=fill&fm=svg&s=c24ef929a90eab780a1b8aa307fba4c2",
  "coverFallback@Blockbuster@1024@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=273&h=1024&w=709&fit=fill&fm=svg&s=63d4e26b2f0d9540a660ef91d5d8cf55",
  "coverFallback@Blockbuster@1024@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=273&h=1024&w=1820&fit=fill&fm=svg&s=f8adff2ef0557fe44303eaec7dfae596",
  "coverFallback@Blockbuster@1024@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_BB_cfb0bf641398cd0ce1db61cc5301bf0d.svg?bg=001B9F&fill-color=001B9F&pad=273&h=1024&w=1024&fit=fill&fm=svg&s=c24ef929a90eab780a1b8aa307fba4c2",
  "blank@Blockbuster@16@@": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=16&fm=png&bg=00000000&s=a68f90b17f2fc3514e5483bd609eaa20",
  "blank@Blockbuster@16@@16x9": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=16&w=28&fm=png&bg=00000000&fit=crop&s=08f848ae5627d9043fef70bd2e4ac55b",
  "blank@Blockbuster@16@@1x1": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=16&w=16&fm=png&bg=00000000&fit=crop&s=1b1eeaff4aa604fb5c2ef4bf4775d88e",
  "blank@Blockbuster@16@backdrop@": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=16&fm=png&bg=001B9F&s=fca9517a3f8abbe7252fad0b92363f63",
  "blank@Blockbuster@16@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=16&w=28&fm=png&bg=001B9F&fit=crop&s=0c469d13fa79b51a9b3992f1a11a4ffb",
  "blank@Blockbuster@16@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=16&w=16&fm=png&bg=001B9F&fit=crop&s=0be81a65c9e9f2f79220f484d05598de",
  "blank@Blockbuster@32@@": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=32&fm=png&bg=00000000&s=121501174d3da2634c914c2f8050e6e2",
  "blank@Blockbuster@32@@16x9": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=32&w=57&fm=png&bg=00000000&fit=crop&s=944ac0056646f333328c7a48c0f2ccc2",
  "blank@Blockbuster@32@@1x1": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=32&w=32&fm=png&bg=00000000&fit=crop&s=d0ab8ced66e0da8220138d28694da246",
  "blank@Blockbuster@32@backdrop@": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=32&fm=png&bg=001B9F&s=17e0c1729ef51cb46d5ba59d22105f1d",
  "blank@Blockbuster@32@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=32&w=57&fm=png&bg=001B9F&fit=crop&s=3b06342db23546ae7196945ccc41c5af",
  "blank@Blockbuster@32@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=32&w=32&fm=png&bg=001B9F&fit=crop&s=b069b121052b5fb35909160331bb246c",
  "blank@Blockbuster@64@@": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=64&fm=png&bg=00000000&s=ddfc63735a6bd8d6756d5c67eb15baf3",
  "blank@Blockbuster@64@@16x9": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=64&w=114&fm=png&bg=00000000&fit=crop&s=52d5905c3a3517936de78f78f0f3c466",
  "blank@Blockbuster@64@@1x1": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=64&w=64&fm=png&bg=00000000&fit=crop&s=134e9cd0bf7568b01d35ff1218934115",
  "blank@Blockbuster@64@backdrop@": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=64&fm=png&bg=001B9F&s=c258911619b9dd80f25c98e13e405077",
  "blank@Blockbuster@64@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=64&w=114&fm=png&bg=001B9F&fit=crop&s=1203fa9546802c06f7abc7a00b6380dc",
  "blank@Blockbuster@64@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=64&w=64&fm=png&bg=001B9F&fit=crop&s=f330aae3c1268e1b8be7cd39218559f1",
  "blank@Blockbuster@120@@": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=120&fm=png&bg=00000000&s=61e83e767fab191efcb9fc8c92056eaf",
  "blank@Blockbuster@120@@16x9": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=120&w=213&fm=png&bg=00000000&fit=crop&s=b6e0c1a56ceb78b69141e77f7ecf2e85",
  "blank@Blockbuster@120@@1x1": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=120&w=120&fm=png&bg=00000000&fit=crop&s=1f11bab724e9157902821caa7074dd8b",
  "blank@Blockbuster@120@backdrop@": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=120&fm=png&bg=001B9F&s=0d89eac2054306bca573b350804fb5ec",
  "blank@Blockbuster@120@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=120&w=213&fm=png&bg=001B9F&fit=crop&s=049ac1ce5b90c250f69856846fcae5d4",
  "blank@Blockbuster@120@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=120&w=120&fm=png&bg=001B9F&fit=crop&s=854fe95b6eb1fd90033c6da75f299fa1",
  "blank@Blockbuster@128@@": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=128&fm=png&bg=00000000&s=eae7aac61230df83a8ac60af8870b5cb",
  "blank@Blockbuster@128@@16x9": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=128&w=228&fm=png&bg=00000000&fit=crop&s=f9e28d8f3a8fbc1c58e96a013a00aa6d",
  "blank@Blockbuster@128@@1x1": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=128&w=128&fm=png&bg=00000000&fit=crop&s=3ce31c697b31f70a25e9ba8edd71e459",
  "blank@Blockbuster@128@backdrop@": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=128&fm=png&bg=001B9F&s=0f0ca760c22f3b51dbef5e9967e14a9f",
  "blank@Blockbuster@128@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=128&w=228&fm=png&bg=001B9F&fit=crop&s=b696ea25628f75e17f93a73fbb66bb1a",
  "blank@Blockbuster@128@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=128&w=128&fm=png&bg=001B9F&fit=crop&s=063df3a64578daaf527ed65dcb545de9",
  "blank@Blockbuster@180@@": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=180&fm=png&bg=00000000&s=a71cb3c5b73e817631b0f00c3befcdad",
  "blank@Blockbuster@180@@16x9": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=180&w=320&fm=png&bg=00000000&fit=crop&s=ae7e88fe15a7a10c955be039b059d01a",
  "blank@Blockbuster@180@@1x1": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=180&w=180&fm=png&bg=00000000&fit=crop&s=a2b80d66f8a870d5b4ad88f69bc1bc09",
  "blank@Blockbuster@180@backdrop@": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=180&fm=png&bg=001B9F&s=99013acb5d0680b3b4bb9095017dad75",
  "blank@Blockbuster@180@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=180&w=320&fm=png&bg=001B9F&fit=crop&s=82b44b8baf82380b483ef7a7483495b1",
  "blank@Blockbuster@180@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=180&w=180&fm=png&bg=001B9F&fit=crop&s=f00d30f1ca334470eb9e17302310752f",
  "blank@Blockbuster@256@@": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=256&fm=png&bg=00000000&s=e4fe91fa0cc62e05a4fb792a3d66864d",
  "blank@Blockbuster@256@@16x9": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=256&w=455&fm=png&bg=00000000&fit=crop&s=1deabbaa92c17b752e1072ed4132fd3a",
  "blank@Blockbuster@256@@1x1": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=256&w=256&fm=png&bg=00000000&fit=crop&s=bde12a3e9e524f2e44613911b7179a57",
  "blank@Blockbuster@256@backdrop@": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=256&fm=png&bg=001B9F&s=579dd41eea73b6163952d4501f625f2e",
  "blank@Blockbuster@256@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=256&w=455&fm=png&bg=001B9F&fit=crop&s=8b153cccd38a5a78af283acb4bdd8d5a",
  "blank@Blockbuster@256@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=256&w=256&fm=png&bg=001B9F&fit=crop&s=cdb4e5f93c625aad29a32835894fdc30",
  "blank@Blockbuster@512@@": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=512&fm=png&bg=00000000&s=0e826e5cf2db62d51373986da13c975d",
  "blank@Blockbuster@512@@16x9": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=512&w=910&fm=png&bg=00000000&fit=crop&s=8f93c1ef8181ed9a730015d1a1d9430b",
  "blank@Blockbuster@512@@1x1": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=512&w=512&fm=png&bg=00000000&fit=crop&s=1b2161bda1e32a381d89eb54190b10a5",
  "blank@Blockbuster@512@backdrop@": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=512&fm=png&bg=001B9F&s=94d87724b252d1841eaa281b435163ac",
  "blank@Blockbuster@512@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=512&w=910&fm=png&bg=001B9F&fit=crop&s=00a95473a1cfe152a891639158f4a036",
  "blank@Blockbuster@512@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=512&w=512&fm=png&bg=001B9F&fit=crop&s=4234c3302e20b9791379075bb7586dee",
  "blank@Blockbuster@1024@@": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=1024&fm=png&bg=00000000&s=e82e5251868898cde47edfebf1466204",
  "blank@Blockbuster@1024@@16x9": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=1024&w=1820&fm=png&bg=00000000&fit=crop&s=50548c1b934d8e7379a84a221e29f4b7",
  "blank@Blockbuster@1024@@1x1": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=1024&w=1024&fm=png&bg=00000000&fit=crop&s=8d8be5132853a1f80088635c650a3124",
  "blank@Blockbuster@1024@backdrop@": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=1024&fm=png&bg=001B9F&s=bfa272bdc802aaf2ec74e42a9560b4b8",
  "blank@Blockbuster@1024@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=1024&w=1820&fm=png&bg=001B9F&fit=crop&s=ae20e961910aad3d43f505c7adb3d78c",
  "blank@Blockbuster@1024@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=1024&w=1024&fm=png&bg=001B9F&fit=crop&s=edc0faab8ca56ae3ac5ae8d00f6262d7",
  "decorative1@Blockbuster@16@@": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=16&fm=jpg&bg=00000000&s=8187071152ecea09ec327335db378103",
  "decorative1@Blockbuster@16@@16x9": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=16&w=28&fm=jpg&bg=00000000&fit=crop&s=3df2b89e3c98a56d51cf55fdcdcfd7ad",
  "decorative1@Blockbuster@16@@1x1": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=16&w=16&fm=jpg&bg=00000000&fit=crop&s=e90d84aed69f6b70944a8a842f379d64",
  "decorative1@Blockbuster@16@backdrop@": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=16&fm=jpg&bg=001B9F&s=3bc1960dee3278802ea5700587aff220",
  "decorative1@Blockbuster@16@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=16&w=28&fm=jpg&bg=001B9F&fit=crop&s=47045c187ac58f83be2df46048743db8",
  "decorative1@Blockbuster@16@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=16&w=16&fm=jpg&bg=001B9F&fit=crop&s=4a23a3386eb09fd5d0ea67ea77379258",
  "decorative1@Blockbuster@32@@": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=32&fm=jpg&bg=00000000&s=c70af01c522fc3dd173c299ab68006bc",
  "decorative1@Blockbuster@32@@16x9": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=32&w=57&fm=jpg&bg=00000000&fit=crop&s=992d8112fdd24d86977807b8d27cad66",
  "decorative1@Blockbuster@32@@1x1": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=32&w=32&fm=jpg&bg=00000000&fit=crop&s=46b85459dca7a6bf4c5ab73da9b9e2bc",
  "decorative1@Blockbuster@32@backdrop@": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=32&fm=jpg&bg=001B9F&s=f800a339b16d0a79481b8ed9f9195339",
  "decorative1@Blockbuster@32@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=32&w=57&fm=jpg&bg=001B9F&fit=crop&s=384edc5252270a7d4864f21b1a1078dc",
  "decorative1@Blockbuster@32@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=32&w=32&fm=jpg&bg=001B9F&fit=crop&s=5345d34141341f013801a0a82f8c01d3",
  "decorative1@Blockbuster@64@@": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=64&fm=jpg&bg=00000000&s=6d7a723564bbdef55729162eae169bf1",
  "decorative1@Blockbuster@64@@16x9": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=64&w=114&fm=jpg&bg=00000000&fit=crop&s=8d11e708dc7e428aa69166f6e8e86d1e",
  "decorative1@Blockbuster@64@@1x1": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=64&w=64&fm=jpg&bg=00000000&fit=crop&s=ad51254b22245d87ac5f7cac6cb9e2dd",
  "decorative1@Blockbuster@64@backdrop@": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=64&fm=jpg&bg=001B9F&s=fa56e7744fa490261cd4a1711b694bed",
  "decorative1@Blockbuster@64@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=64&w=114&fm=jpg&bg=001B9F&fit=crop&s=82242ad2833215d387663581a78f620f",
  "decorative1@Blockbuster@64@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=64&w=64&fm=jpg&bg=001B9F&fit=crop&s=1b015c3dfc911011845c72c29f3ae4d5",
  "decorative1@Blockbuster@120@@": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=120&fm=jpg&bg=00000000&s=25b1d82fe61cf7e89dfe01f67c7e32b9",
  "decorative1@Blockbuster@120@@16x9": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=120&w=213&fm=jpg&bg=00000000&fit=crop&s=cd6f88fc7cdefacf03f3a673e808696c",
  "decorative1@Blockbuster@120@@1x1": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=120&w=120&fm=jpg&bg=00000000&fit=crop&s=62262b7d5a13c119b1a87ad90ad437a9",
  "decorative1@Blockbuster@120@backdrop@": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=120&fm=jpg&bg=001B9F&s=4d286d7cd642cad971d62c52f9bb159f",
  "decorative1@Blockbuster@120@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=120&w=213&fm=jpg&bg=001B9F&fit=crop&s=f7f86f647e308446c4b76a879a810fe0",
  "decorative1@Blockbuster@120@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=120&w=120&fm=jpg&bg=001B9F&fit=crop&s=2d51620c907af4b40065f8b353064c4f",
  "decorative1@Blockbuster@128@@": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=128&fm=jpg&bg=00000000&s=17da56c654b69731e93829b4afa38740",
  "decorative1@Blockbuster@128@@16x9": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=128&w=228&fm=jpg&bg=00000000&fit=crop&s=5bd4d80f5ace8a5a48b4b2a31dd3fa36",
  "decorative1@Blockbuster@128@@1x1": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=128&w=128&fm=jpg&bg=00000000&fit=crop&s=d7c855049161a5926fab016e64f22af1",
  "decorative1@Blockbuster@128@backdrop@": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=128&fm=jpg&bg=001B9F&s=111f8fc9ba3de604b668ddca3248df00",
  "decorative1@Blockbuster@128@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=128&w=228&fm=jpg&bg=001B9F&fit=crop&s=1d0c332532b51b0c42384aef0eed2464",
  "decorative1@Blockbuster@128@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=128&w=128&fm=jpg&bg=001B9F&fit=crop&s=c7217f257f832216ac0c3545ea97a925",
  "decorative1@Blockbuster@180@@": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=180&fm=jpg&bg=00000000&s=8f51f6c5f774c98f8c57b99cd9ffaf22",
  "decorative1@Blockbuster@180@@16x9": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=180&w=320&fm=jpg&bg=00000000&fit=crop&s=c1e92bda75904c063835cb926725c312",
  "decorative1@Blockbuster@180@@1x1": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=180&w=180&fm=jpg&bg=00000000&fit=crop&s=fc3a2662eb0930359c35fe6439b5ba73",
  "decorative1@Blockbuster@180@backdrop@": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=180&fm=jpg&bg=001B9F&s=4dc965d70f78133dc2c7713f2aabad11",
  "decorative1@Blockbuster@180@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=180&w=320&fm=jpg&bg=001B9F&fit=crop&s=5111f3e78086cbbe548f66b4e465fdff",
  "decorative1@Blockbuster@180@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=180&w=180&fm=jpg&bg=001B9F&fit=crop&s=c10184da4cc56dc2f9337991394a0788",
  "decorative1@Blockbuster@256@@": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=256&fm=jpg&bg=00000000&s=648375a4b7271f0ea55562d234f7d18e",
  "decorative1@Blockbuster@256@@16x9": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=256&w=455&fm=jpg&bg=00000000&fit=crop&s=9b99e5b731d8e35361e1bc22f7bad691",
  "decorative1@Blockbuster@256@@1x1": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=256&w=256&fm=jpg&bg=00000000&fit=crop&s=23592626ec5e79df44bfd82fe8c03113",
  "decorative1@Blockbuster@256@backdrop@": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=256&fm=jpg&bg=001B9F&s=42ce6202891885bd3301134f5dd191e1",
  "decorative1@Blockbuster@256@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=256&w=455&fm=jpg&bg=001B9F&fit=crop&s=6706f39fef0a35fc93eb619181dac1d3",
  "decorative1@Blockbuster@256@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=256&w=256&fm=jpg&bg=001B9F&fit=crop&s=69f89500b594f0dbecdfee71ec71e6ea",
  "decorative1@Blockbuster@512@@": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=512&fm=jpg&bg=00000000&s=8c811100fdb28fa78400780695a59202",
  "decorative1@Blockbuster@512@@16x9": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=512&w=910&fm=jpg&bg=00000000&fit=crop&s=8eb5171564cbed0742bbc74020203bf0",
  "decorative1@Blockbuster@512@@1x1": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=512&w=512&fm=jpg&bg=00000000&fit=crop&s=1b50be561e9924a8878dfddc7f611959",
  "decorative1@Blockbuster@512@backdrop@": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=512&fm=jpg&bg=001B9F&s=c486749674b375d89ba27ae28264c318",
  "decorative1@Blockbuster@512@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=512&w=910&fm=jpg&bg=001B9F&fit=crop&s=4b639a38bd2b0ff73db1a4baa3c8ee02",
  "decorative1@Blockbuster@512@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=512&w=512&fm=jpg&bg=001B9F&fit=crop&s=38857031576a666f192809cb95ec1f1e",
  "decorative1@Blockbuster@1024@@": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=1024&fm=jpg&bg=00000000&s=3758a890a25997fd14e4777290aae7e5",
  "decorative1@Blockbuster@1024@@16x9": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=1024&w=1820&fm=jpg&bg=00000000&fit=crop&s=c9e14eec5ef136e9d3a8bcd76102a1ad",
  "decorative1@Blockbuster@1024@@1x1": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=1024&w=1024&fm=jpg&bg=00000000&fit=crop&s=43799b4b76af9b5827c78f11c800e377",
  "decorative1@Blockbuster@1024@backdrop@": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=1024&fm=jpg&bg=001B9F&s=2d23f63c79e8e7901ed59d0c0cfd2979",
  "decorative1@Blockbuster@1024@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=1024&w=1820&fm=jpg&bg=001B9F&fit=crop&s=c1f6078b6f683249d306f7fac0de0255",
  "decorative1@Blockbuster@1024@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=1024&w=1024&fm=jpg&bg=001B9F&fit=crop&s=0a5d9ff56a90739204facc72127b3114",
  "decorative2@Blockbuster@16@@": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=16&fm=png&bg=00000000&s=d31dbd0c5315b6942b9f3d8d60ca878d",
  "decorative2@Blockbuster@16@@16x9": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=16&w=28&fm=png&bg=00000000&fit=crop&s=05c4015656d57d9c6c9f5353df9091ed",
  "decorative2@Blockbuster@16@@1x1": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=16&w=16&fm=png&bg=00000000&fit=crop&s=761ef99aba3d743e8e9992092f4352f3",
  "decorative2@Blockbuster@16@backdrop@": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=16&fm=png&bg=001B9F&s=15c37023e0010b92dd820ff67e67d376",
  "decorative2@Blockbuster@16@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=16&w=28&fm=png&bg=001B9F&fit=crop&s=ca186c43db409922b572d732b438c339",
  "decorative2@Blockbuster@16@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=16&w=16&fm=png&bg=001B9F&fit=crop&s=f508577643b49bf93bd5a85541cb35a6",
  "decorative2@Blockbuster@32@@": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=32&fm=png&bg=00000000&s=42f13177d81400b7a9bf5599b0fb60dd",
  "decorative2@Blockbuster@32@@16x9": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=32&w=57&fm=png&bg=00000000&fit=crop&s=c88f435d1f770b1a3957fb3a387b7288",
  "decorative2@Blockbuster@32@@1x1": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=32&w=32&fm=png&bg=00000000&fit=crop&s=be3df63c345fed5a0fd83c9fc8288fc4",
  "decorative2@Blockbuster@32@backdrop@": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=32&fm=png&bg=001B9F&s=4a26417081f7520dc2e73214dc3d748a",
  "decorative2@Blockbuster@32@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=32&w=57&fm=png&bg=001B9F&fit=crop&s=d06faa01932413a8766e3b9de14f9c53",
  "decorative2@Blockbuster@32@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=32&w=32&fm=png&bg=001B9F&fit=crop&s=14dbba4f982693bd2f73c4a3877f2a62",
  "decorative2@Blockbuster@64@@": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=64&fm=png&bg=00000000&s=92e3322065092022b248546a09378685",
  "decorative2@Blockbuster@64@@16x9": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=64&w=114&fm=png&bg=00000000&fit=crop&s=9b72020c77a5b68c4d267e42553ea44f",
  "decorative2@Blockbuster@64@@1x1": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=64&w=64&fm=png&bg=00000000&fit=crop&s=6b0e47d761dd6f7d2791fb9849321ccb",
  "decorative2@Blockbuster@64@backdrop@": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=64&fm=png&bg=001B9F&s=41150f0d1856c4f0f496db61d7673b48",
  "decorative2@Blockbuster@64@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=64&w=114&fm=png&bg=001B9F&fit=crop&s=e8f3399141ec0bf737deea6382f87920",
  "decorative2@Blockbuster@64@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=64&w=64&fm=png&bg=001B9F&fit=crop&s=698e7d9cb246b7441bac556615f3c23c",
  "decorative2@Blockbuster@120@@": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=120&fm=png&bg=00000000&s=38129cdecd13dc2c6b26864a6e0f39bd",
  "decorative2@Blockbuster@120@@16x9": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=120&w=213&fm=png&bg=00000000&fit=crop&s=87409a2b9ad79a50663c6e9fc6e01fcf",
  "decorative2@Blockbuster@120@@1x1": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=120&w=120&fm=png&bg=00000000&fit=crop&s=ad0e409884542ad4d9a5751278d7f420",
  "decorative2@Blockbuster@120@backdrop@": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=120&fm=png&bg=001B9F&s=a80940360a6cbd9f1f0a1c70a66a4020",
  "decorative2@Blockbuster@120@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=120&w=213&fm=png&bg=001B9F&fit=crop&s=2874ee8ec1a3bc8b336ac1d6e2f092ff",
  "decorative2@Blockbuster@120@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=120&w=120&fm=png&bg=001B9F&fit=crop&s=614de68d1e1e58fabf1a42fc735fed13",
  "decorative2@Blockbuster@128@@": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=128&fm=png&bg=00000000&s=8469a108300dc44d254a7dbdaf51b8c0",
  "decorative2@Blockbuster@128@@16x9": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=128&w=228&fm=png&bg=00000000&fit=crop&s=c4a2adc3fecdb748492f2539d3809cf7",
  "decorative2@Blockbuster@128@@1x1": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=128&w=128&fm=png&bg=00000000&fit=crop&s=38df2f985b323edabc62b69696540650",
  "decorative2@Blockbuster@128@backdrop@": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=128&fm=png&bg=001B9F&s=d4e236c447f8a6e13502269f14decd07",
  "decorative2@Blockbuster@128@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=128&w=228&fm=png&bg=001B9F&fit=crop&s=611606cb3b003c36bdc4d51e62d8bfd4",
  "decorative2@Blockbuster@128@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=128&w=128&fm=png&bg=001B9F&fit=crop&s=cc2baf3104b914210cf1956e47c39551",
  "decorative2@Blockbuster@180@@": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=180&fm=png&bg=00000000&s=7e02b14e7255b1d3b684bc1af062c4a7",
  "decorative2@Blockbuster@180@@16x9": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=180&w=320&fm=png&bg=00000000&fit=crop&s=4af263f0d05a914666bb8ef63ea54c60",
  "decorative2@Blockbuster@180@@1x1": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=180&w=180&fm=png&bg=00000000&fit=crop&s=9e686e40b58af3687bdc1b8b48f13b77",
  "decorative2@Blockbuster@180@backdrop@": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=180&fm=png&bg=001B9F&s=99c273e894956c296ab4ca22318b5540",
  "decorative2@Blockbuster@180@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=180&w=320&fm=png&bg=001B9F&fit=crop&s=ee49bf0c70359d70fc093d46bf4cdfa1",
  "decorative2@Blockbuster@180@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=180&w=180&fm=png&bg=001B9F&fit=crop&s=0176f27d938d58375d26149db6e8553e",
  "decorative2@Blockbuster@256@@": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=256&fm=png&bg=00000000&s=fb1c2bf600aa954b14e687fbfbca611f",
  "decorative2@Blockbuster@256@@16x9": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=256&w=455&fm=png&bg=00000000&fit=crop&s=7c14ff710e08afefe557eb36ba4cc88c",
  "decorative2@Blockbuster@256@@1x1": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=256&w=256&fm=png&bg=00000000&fit=crop&s=a7a41e41c13b923064de252333c38b6a",
  "decorative2@Blockbuster@256@backdrop@": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=256&fm=png&bg=001B9F&s=704de852f62b04afb0a2642cb95502fd",
  "decorative2@Blockbuster@256@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=256&w=455&fm=png&bg=001B9F&fit=crop&s=385174236d914b054b4a6e98a74b09f7",
  "decorative2@Blockbuster@256@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=256&w=256&fm=png&bg=001B9F&fit=crop&s=4adc30d0dcc4b455f1bf28499042da80",
  "decorative2@Blockbuster@512@@": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=512&fm=png&bg=00000000&s=6a9b933fda30ef4787ee46f2bc5876d3",
  "decorative2@Blockbuster@512@@16x9": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=512&w=910&fm=png&bg=00000000&fit=crop&s=146c96d339470ca4879dbb6961850d30",
  "decorative2@Blockbuster@512@@1x1": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=512&w=512&fm=png&bg=00000000&fit=crop&s=121f64fb88d9849b1ef969bc3dbfa61d",
  "decorative2@Blockbuster@512@backdrop@": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=512&fm=png&bg=001B9F&s=817981899c6b04389f79eed7b7849152",
  "decorative2@Blockbuster@512@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=512&w=910&fm=png&bg=001B9F&fit=crop&s=17945f1025bb2cd65ecba2c80175bbbd",
  "decorative2@Blockbuster@512@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=512&w=512&fm=png&bg=001B9F&fit=crop&s=77d35e614f05724d6b48688b451b0450",
  "decorative2@Blockbuster@1024@@": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=1024&fm=png&bg=00000000&s=8bcff345cbb32a08543400501f1dd4f1",
  "decorative2@Blockbuster@1024@@16x9": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=1024&w=1820&fm=png&bg=00000000&fit=crop&s=b0a53f737fffe0b54ecc6675f4aaad68",
  "decorative2@Blockbuster@1024@@1x1": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=1024&w=1024&fm=png&bg=00000000&fit=crop&s=fe0d7566808de1c79a0c122064d35a4c",
  "decorative2@Blockbuster@1024@backdrop@": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=1024&fm=png&bg=001B9F&s=83bb0bc9862cb704e66eca2f1d4ce919",
  "decorative2@Blockbuster@1024@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=1024&w=1820&fm=png&bg=001B9F&fit=crop&s=237bee50511f845fefdb9dd2bcfaafef",
  "decorative2@Blockbuster@1024@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LIST_16x9_BB_03ec8e21d7287b7e42ffd932fa884404.png?h=1024&w=1024&fm=png&bg=001B9F&fit=crop&s=c1c0b72dcf73d7142a8999ca97c25edd",
  "ticketCover@Blockbuster@16@@": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=16&fm=png&bg=00000000&s=4503da4fb248295db5f4530ca632c39f",
  "ticketCover@Blockbuster@16@@16x9": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=16&w=28&fm=png&bg=00000000&fit=crop&s=ef150b4e23d4bbb2bf8bae2044648e7f",
  "ticketCover@Blockbuster@16@@1x1": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=16&w=16&fm=png&bg=00000000&fit=crop&s=74b9fa3553e8838fd48a9c1a86181f7f",
  "ticketCover@Blockbuster@16@backdrop@": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=16&fm=png&bg=001B9F&s=9542f481ca0aabaa7c9c9d81a1381842",
  "ticketCover@Blockbuster@16@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=16&w=28&fm=png&bg=001B9F&fit=crop&s=850c0c09e072e9aebed388c780806b29",
  "ticketCover@Blockbuster@16@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=16&w=16&fm=png&bg=001B9F&fit=crop&s=5a286a3ea187678df0da0b033cfdf735",
  "ticketCover@Blockbuster@32@@": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=32&fm=png&bg=00000000&s=0221f4009351edac870c40b8614c4155",
  "ticketCover@Blockbuster@32@@16x9": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=32&w=57&fm=png&bg=00000000&fit=crop&s=a46bb469f34370f21a2502a31f6fd7c4",
  "ticketCover@Blockbuster@32@@1x1": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=32&w=32&fm=png&bg=00000000&fit=crop&s=72835c9cfb1233825524c4f16a58c30f",
  "ticketCover@Blockbuster@32@backdrop@": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=32&fm=png&bg=001B9F&s=c627aa7cdab524d81003985f15d53147",
  "ticketCover@Blockbuster@32@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=32&w=57&fm=png&bg=001B9F&fit=crop&s=a144a25720b24e745cb7a2913026e498",
  "ticketCover@Blockbuster@32@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=32&w=32&fm=png&bg=001B9F&fit=crop&s=2e3f66b48774d3c47550905ab7a934bc",
  "ticketCover@Blockbuster@64@@": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=64&fm=png&bg=00000000&s=e2b4dfcf2bd877bc6c75e550f5036b6f",
  "ticketCover@Blockbuster@64@@16x9": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=64&w=114&fm=png&bg=00000000&fit=crop&s=a7310e390539d1dc2368e7ca331d387d",
  "ticketCover@Blockbuster@64@@1x1": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=64&w=64&fm=png&bg=00000000&fit=crop&s=60b23bebc03c6c276eb52ae6025a22f2",
  "ticketCover@Blockbuster@64@backdrop@": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=64&fm=png&bg=001B9F&s=50c8cde7fb20ed520e2cc30acc069726",
  "ticketCover@Blockbuster@64@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=64&w=114&fm=png&bg=001B9F&fit=crop&s=5ca9d4266c25f74c8434d1f5fc8ef9f1",
  "ticketCover@Blockbuster@64@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=64&w=64&fm=png&bg=001B9F&fit=crop&s=6e5311c45c2727dbd4a4ac6b7a02d0e3",
  "ticketCover@Blockbuster@120@@": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=120&fm=png&bg=00000000&s=31b2d86b9a739f6bc9777afdd459cfe6",
  "ticketCover@Blockbuster@120@@16x9": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=120&w=213&fm=png&bg=00000000&fit=crop&s=362ca864b67243f241788b1f8ca37fde",
  "ticketCover@Blockbuster@120@@1x1": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=120&w=120&fm=png&bg=00000000&fit=crop&s=327fa8b19f3f9a20d3dd8a803e777d59",
  "ticketCover@Blockbuster@120@backdrop@": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=120&fm=png&bg=001B9F&s=0fbb3ddc175ab2dc1642d7dfe87eb18e",
  "ticketCover@Blockbuster@120@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=120&w=213&fm=png&bg=001B9F&fit=crop&s=54fbef7b8db14f71adf3ab219301ffba",
  "ticketCover@Blockbuster@120@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=120&w=120&fm=png&bg=001B9F&fit=crop&s=f23993db5fc274feea0ffae4b4d6292c",
  "ticketCover@Blockbuster@128@@": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=128&fm=png&bg=00000000&s=d6bd5a237e8d2f5b72ef18f3a1087ec1",
  "ticketCover@Blockbuster@128@@16x9": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=128&w=228&fm=png&bg=00000000&fit=crop&s=d14150920d7ba630963a3ccec0477687",
  "ticketCover@Blockbuster@128@@1x1": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=128&w=128&fm=png&bg=00000000&fit=crop&s=83e1d9a5dd616f63f2d8b12bb02a0f37",
  "ticketCover@Blockbuster@128@backdrop@": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=128&fm=png&bg=001B9F&s=e27b8fad1052d2ca2e9e22ec68c31ec0",
  "ticketCover@Blockbuster@128@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=128&w=228&fm=png&bg=001B9F&fit=crop&s=59305c4332b9bf5adc8b5e6de7e42d50",
  "ticketCover@Blockbuster@128@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=128&w=128&fm=png&bg=001B9F&fit=crop&s=6f911363ed618014d3d624da8a2f79e9",
  "ticketCover@Blockbuster@180@@": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=180&fm=png&bg=00000000&s=593af29a00eef9a05e2d6ba1c28729fc",
  "ticketCover@Blockbuster@180@@16x9": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=180&w=320&fm=png&bg=00000000&fit=crop&s=0d7975e3450564852b6cbebb40a14d9f",
  "ticketCover@Blockbuster@180@@1x1": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=180&w=180&fm=png&bg=00000000&fit=crop&s=ef1e446819384816365c257bd86a4723",
  "ticketCover@Blockbuster@180@backdrop@": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=180&fm=png&bg=001B9F&s=f387ed460581e9f1592aa4e3f80c084a",
  "ticketCover@Blockbuster@180@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=180&w=320&fm=png&bg=001B9F&fit=crop&s=70f26593dece8ac2661147ead505e116",
  "ticketCover@Blockbuster@180@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=180&w=180&fm=png&bg=001B9F&fit=crop&s=3b2d0a974e6de56b8061e4805c6b99aa",
  "ticketCover@Blockbuster@256@@": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=256&fm=png&bg=00000000&s=50b84af3c099b4d8aba5531385098da7",
  "ticketCover@Blockbuster@256@@16x9": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=256&w=455&fm=png&bg=00000000&fit=crop&s=c910689765b8ea4bbe248ff0a1436390",
  "ticketCover@Blockbuster@256@@1x1": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=256&w=256&fm=png&bg=00000000&fit=crop&s=c3c1bd104476316108016f1832e0a252",
  "ticketCover@Blockbuster@256@backdrop@": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=256&fm=png&bg=001B9F&s=e86e9e4ab50cc8319e4020c712a6abe6",
  "ticketCover@Blockbuster@256@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=256&w=455&fm=png&bg=001B9F&fit=crop&s=ad2a7c91ebb971b04f0b268f9824aac1",
  "ticketCover@Blockbuster@256@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=256&w=256&fm=png&bg=001B9F&fit=crop&s=b94bcdececbdadadcc808a95b7276506",
  "ticketCover@Blockbuster@512@@": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=512&fm=png&bg=00000000&s=99917338a168ef970dff08567fc119bb",
  "ticketCover@Blockbuster@512@@16x9": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=512&w=910&fm=png&bg=00000000&fit=crop&s=0059a4b6faf485f94b8f146a2d250317",
  "ticketCover@Blockbuster@512@@1x1": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=512&w=512&fm=png&bg=00000000&fit=crop&s=9e24876ef6fcede7a444d9435f8ec50f",
  "ticketCover@Blockbuster@512@backdrop@": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=512&fm=png&bg=001B9F&s=0a375267065a6c5698b994ea0c3b393f",
  "ticketCover@Blockbuster@512@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=512&w=910&fm=png&bg=001B9F&fit=crop&s=bb4d65596dd2ab70c18eebe8ee37d114",
  "ticketCover@Blockbuster@512@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=512&w=512&fm=png&bg=001B9F&fit=crop&s=dd67f86e5912bdf4efc0001bf0a2e069",
  "ticketCover@Blockbuster@1024@@": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=1024&fm=png&bg=00000000&s=2e288dfefbea4969c07c88288db27af2",
  "ticketCover@Blockbuster@1024@@16x9": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=1024&w=1820&fm=png&bg=00000000&fit=crop&s=b8b8733c43c89fcaeac3b3b34df0d724",
  "ticketCover@Blockbuster@1024@@1x1": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=1024&w=1024&fm=png&bg=00000000&fit=crop&s=eb4b7c9698dbe2495758e4634f4ea7e2",
  "ticketCover@Blockbuster@1024@backdrop@": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=1024&fm=png&bg=001B9F&s=8fd01849b90de7f0d0cab34b9ad87c97",
  "ticketCover@Blockbuster@1024@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=1024&w=1820&fm=png&bg=001B9F&fit=crop&s=65501b77375f113f8d055355ce0f4493",
  "ticketCover@Blockbuster@1024@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=1024&w=1024&fm=png&bg=001B9F&fit=crop&s=bdd42ef8743ace2d1091205a68f12343",
  "appStore@Blockbuster@16@@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=16&fm=svg&bg=00000000&s=a07391f6b0793809298d79c17beae9c8",
  "appStore@Blockbuster@16@@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=16&w=28&fm=svg&bg=00000000&fit=crop&s=a0f29381fbb5c186c59e21aa0d89da9a",
  "appStore@Blockbuster@16@@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=16&w=16&fm=svg&bg=00000000&fit=crop&s=b2b7ea6a728dfc2f098fb02cf8b252a3",
  "appStore@Blockbuster@16@backdrop@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=16&fm=svg&bg=001B9F&s=ceba2e838fd69a1d06c739c315ef8eae",
  "appStore@Blockbuster@16@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=16&w=28&fm=svg&bg=001B9F&fit=crop&s=f0e698bbeeb99bc8db0dc3c7d81ef3cf",
  "appStore@Blockbuster@16@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=16&w=16&fm=svg&bg=001B9F&fit=crop&s=64ee66c9c41de71cb0a0738bb1cef68d",
  "appStore@Blockbuster@32@@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=32&fm=svg&bg=00000000&s=8c2ea711c84e7852fe874b700c31cd57",
  "appStore@Blockbuster@32@@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=32&w=57&fm=svg&bg=00000000&fit=crop&s=ee62672cb384262e107eaae3e00f5224",
  "appStore@Blockbuster@32@@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=32&w=32&fm=svg&bg=00000000&fit=crop&s=2746e03c5d3a901f87460b80abeb1a96",
  "appStore@Blockbuster@32@backdrop@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=32&fm=svg&bg=001B9F&s=f712a5a98453a41b623f3f3ca767f0fd",
  "appStore@Blockbuster@32@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=32&w=57&fm=svg&bg=001B9F&fit=crop&s=edaf1e05c1b5e077d3e8b320f7a71750",
  "appStore@Blockbuster@32@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=32&w=32&fm=svg&bg=001B9F&fit=crop&s=37fa8172a80b7c80bf3907addf9635f2",
  "appStore@Blockbuster@64@@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=64&fm=svg&bg=00000000&s=cdd69aee556036a04a55a9cf6c09e997",
  "appStore@Blockbuster@64@@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=64&w=114&fm=svg&bg=00000000&fit=crop&s=f8ab946b1c9e919a07c439d0219d6252",
  "appStore@Blockbuster@64@@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=64&w=64&fm=svg&bg=00000000&fit=crop&s=ae75615e751c3900ed3d57196d425527",
  "appStore@Blockbuster@64@backdrop@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=64&fm=svg&bg=001B9F&s=447ff0f6bdae8b7e1fcc1735ca64f887",
  "appStore@Blockbuster@64@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=64&w=114&fm=svg&bg=001B9F&fit=crop&s=bc32b8c46b8d8a719c98712694c11262",
  "appStore@Blockbuster@64@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=64&w=64&fm=svg&bg=001B9F&fit=crop&s=95eae1dc24e840c3a13c0dc5cf48d4ac",
  "appStore@Blockbuster@120@@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=120&fm=svg&bg=00000000&s=03e4e99e3534208dee2f3fe13005df94",
  "appStore@Blockbuster@120@@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=120&w=213&fm=svg&bg=00000000&fit=crop&s=1349eacb901d2ef9e27747487b9fe328",
  "appStore@Blockbuster@120@@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=120&w=120&fm=svg&bg=00000000&fit=crop&s=e269f5dd5af291c5cdfe2e9cc88dec26",
  "appStore@Blockbuster@120@backdrop@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=120&fm=svg&bg=001B9F&s=ac295f8e8c076ee4750630a68333ec5f",
  "appStore@Blockbuster@120@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=120&w=213&fm=svg&bg=001B9F&fit=crop&s=0defbd194bf0f8e649ea5a1a18721355",
  "appStore@Blockbuster@120@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=120&w=120&fm=svg&bg=001B9F&fit=crop&s=72fb83007aa41a179c073bab1a61a72e",
  "appStore@Blockbuster@128@@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=128&fm=svg&bg=00000000&s=5821456cc03f818b5a055d596ddc6e99",
  "appStore@Blockbuster@128@@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=128&w=228&fm=svg&bg=00000000&fit=crop&s=0cb1af7886ea139fd4926872b3ca1ca9",
  "appStore@Blockbuster@128@@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=128&w=128&fm=svg&bg=00000000&fit=crop&s=61e0c6047d25b783160df7ad28212810",
  "appStore@Blockbuster@128@backdrop@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=128&fm=svg&bg=001B9F&s=2e2d9890cea5d1a63c2e5dd21e37c162",
  "appStore@Blockbuster@128@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=128&w=228&fm=svg&bg=001B9F&fit=crop&s=b5095b4bb4b42d1f55e781dd7d8ff29c",
  "appStore@Blockbuster@128@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=128&w=128&fm=svg&bg=001B9F&fit=crop&s=154a7e9ef7689e6f94baaf9356935091",
  "appStore@Blockbuster@180@@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=180&fm=svg&bg=00000000&s=2fc51b47580194192f960386ddccde78",
  "appStore@Blockbuster@180@@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=180&w=320&fm=svg&bg=00000000&fit=crop&s=4b58a8768348d14f7d73cb55cef0c880",
  "appStore@Blockbuster@180@@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=180&w=180&fm=svg&bg=00000000&fit=crop&s=ed68c046da358fbc7031c26c2f9b9f5d",
  "appStore@Blockbuster@180@backdrop@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=180&fm=svg&bg=001B9F&s=c689bfc6cdaa7e49aaaf152f5aa546bc",
  "appStore@Blockbuster@180@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=180&w=320&fm=svg&bg=001B9F&fit=crop&s=4b93a8e275e46677a1f3ce02e2fcf02c",
  "appStore@Blockbuster@180@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=180&w=180&fm=svg&bg=001B9F&fit=crop&s=bf0856d8f362096674be667af9b47614",
  "appStore@Blockbuster@256@@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=256&fm=svg&bg=00000000&s=41d7a82da5e9c2c7d4c2b77d873646c8",
  "appStore@Blockbuster@256@@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=256&w=455&fm=svg&bg=00000000&fit=crop&s=7ce7101fb061aa7467b7fe4be7454f3c",
  "appStore@Blockbuster@256@@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=256&w=256&fm=svg&bg=00000000&fit=crop&s=244b480050ea61d11459a1d7fd0ac6be",
  "appStore@Blockbuster@256@backdrop@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=256&fm=svg&bg=001B9F&s=13517b157a48b04392e153475631c980",
  "appStore@Blockbuster@256@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=256&w=455&fm=svg&bg=001B9F&fit=crop&s=e309be05cfc60c779ffc3a61a9ad0785",
  "appStore@Blockbuster@256@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=256&w=256&fm=svg&bg=001B9F&fit=crop&s=132e4415714a241465c84cae54dbf2a0",
  "appStore@Blockbuster@512@@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=512&fm=svg&bg=00000000&s=415cfa68e82edee690f0c4203e73fd9e",
  "appStore@Blockbuster@512@@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=512&w=910&fm=svg&bg=00000000&fit=crop&s=cb77d112826f42ffc14acb360910cf31",
  "appStore@Blockbuster@512@@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=512&w=512&fm=svg&bg=00000000&fit=crop&s=27858e8fbecad6c56de19ae89b2d7705",
  "appStore@Blockbuster@512@backdrop@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=512&fm=svg&bg=001B9F&s=e233c8a269c88c4cacd2e7468de018ec",
  "appStore@Blockbuster@512@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=512&w=910&fm=svg&bg=001B9F&fit=crop&s=992417766018a9d61a6a69a6adb9109c",
  "appStore@Blockbuster@512@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=512&w=512&fm=svg&bg=001B9F&fit=crop&s=b541f65cfa120f3f3bb176213a23f9e4",
  "appStore@Blockbuster@1024@@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=1024&fm=svg&bg=00000000&s=4c32f2d3a418238df9ffe550e6594f49",
  "appStore@Blockbuster@1024@@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=1024&w=1820&fm=svg&bg=00000000&fit=crop&s=6095621822c5f293e079c0b714c2cd6f",
  "appStore@Blockbuster@1024@@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=1024&w=1024&fm=svg&bg=00000000&fit=crop&s=b5ab6b1913f965ccec4e7c7c6fb76584",
  "appStore@Blockbuster@1024@backdrop@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=1024&fm=svg&bg=001B9F&s=6134a5b777c87c9dcaff22af710ecd59",
  "appStore@Blockbuster@1024@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=1024&w=1820&fm=svg&bg=001B9F&fit=crop&s=139990a784c3fd9629dc2a9ecbb43ce3",
  "appStore@Blockbuster@1024@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=1024&w=1024&fm=svg&bg=001B9F&fit=crop&s=22ff136bf45bbcda00654b2d5ab5cbc9",
  "googlePlay@Blockbuster@16@@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=16&fm=svg&bg=00000000&s=762b23585ef713f6f5bfb9b74fd8fd02",
  "googlePlay@Blockbuster@16@@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=16&w=28&fm=svg&bg=00000000&fit=crop&s=31bd115956b70d3aea311c6f34e800cd",
  "googlePlay@Blockbuster@16@@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=16&w=16&fm=svg&bg=00000000&fit=crop&s=a28147c88fb2c6717cf074b699b5f312",
  "googlePlay@Blockbuster@16@backdrop@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=16&fm=svg&bg=001B9F&s=fc551cdcfe0a79b0b3f53dd29ff02a10",
  "googlePlay@Blockbuster@16@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=16&w=28&fm=svg&bg=001B9F&fit=crop&s=a3971b1b62fb81660a164278ea687796",
  "googlePlay@Blockbuster@16@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=16&w=16&fm=svg&bg=001B9F&fit=crop&s=a81101399fa121f4571820339ee8086f",
  "googlePlay@Blockbuster@32@@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=32&fm=svg&bg=00000000&s=77de33df5b54fcbbe1cd2fbc4a2c6e96",
  "googlePlay@Blockbuster@32@@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=32&w=57&fm=svg&bg=00000000&fit=crop&s=76d660bdca3b176823d050d786a59efb",
  "googlePlay@Blockbuster@32@@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=32&w=32&fm=svg&bg=00000000&fit=crop&s=390e8ed78f6ada9d6374b7d39f8595a5",
  "googlePlay@Blockbuster@32@backdrop@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=32&fm=svg&bg=001B9F&s=9439f3e09a3324cbfef7f9c72a8ad4c5",
  "googlePlay@Blockbuster@32@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=32&w=57&fm=svg&bg=001B9F&fit=crop&s=599764f212692e65ad5b48c700e56cef",
  "googlePlay@Blockbuster@32@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=32&w=32&fm=svg&bg=001B9F&fit=crop&s=91251db766256ea45501b0de7c9f1760",
  "googlePlay@Blockbuster@64@@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=64&fm=svg&bg=00000000&s=b1f1ce5ee0b9bf173e10e5a85025fbe9",
  "googlePlay@Blockbuster@64@@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=64&w=114&fm=svg&bg=00000000&fit=crop&s=ca8ec229e543d2f2c37f22c4d3d0e835",
  "googlePlay@Blockbuster@64@@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=64&w=64&fm=svg&bg=00000000&fit=crop&s=e66a24d1355af635bbbb8a049bbb99bd",
  "googlePlay@Blockbuster@64@backdrop@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=64&fm=svg&bg=001B9F&s=3b27351b162b858b36cea77e467f5041",
  "googlePlay@Blockbuster@64@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=64&w=114&fm=svg&bg=001B9F&fit=crop&s=31b34796588eb9cac7ad4c5b159adbd0",
  "googlePlay@Blockbuster@64@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=64&w=64&fm=svg&bg=001B9F&fit=crop&s=6fdd3f65f0485591b0cb008421405e35",
  "googlePlay@Blockbuster@120@@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=120&fm=svg&bg=00000000&s=b2be1c89e7bdfced045e1af621b6a7c5",
  "googlePlay@Blockbuster@120@@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=120&w=213&fm=svg&bg=00000000&fit=crop&s=44c210fc627dd11d57b3ab7a6b2190d1",
  "googlePlay@Blockbuster@120@@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=120&w=120&fm=svg&bg=00000000&fit=crop&s=365dd69714063a0baf70d05d003d5a7c",
  "googlePlay@Blockbuster@120@backdrop@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=120&fm=svg&bg=001B9F&s=01fab919150f6bbdfd0158365b4f9408",
  "googlePlay@Blockbuster@120@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=120&w=213&fm=svg&bg=001B9F&fit=crop&s=f942ec6eccc295c37cb87214b9ebc58e",
  "googlePlay@Blockbuster@120@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=120&w=120&fm=svg&bg=001B9F&fit=crop&s=cb661ef62a142e110154dabadf2bf192",
  "googlePlay@Blockbuster@128@@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=128&fm=svg&bg=00000000&s=ab81ded67fb210a5f00573c166f5cebc",
  "googlePlay@Blockbuster@128@@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=128&w=228&fm=svg&bg=00000000&fit=crop&s=4fcd0abbd9d147b62935757dbefb0b19",
  "googlePlay@Blockbuster@128@@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=128&w=128&fm=svg&bg=00000000&fit=crop&s=84fa6a2655f1ff0aa4c30ee5fe5316b4",
  "googlePlay@Blockbuster@128@backdrop@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=128&fm=svg&bg=001B9F&s=b7e1a5d739f712907e50ff2602affa0f",
  "googlePlay@Blockbuster@128@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=128&w=228&fm=svg&bg=001B9F&fit=crop&s=e8b5d6cd995d7a1792360b114371f335",
  "googlePlay@Blockbuster@128@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=128&w=128&fm=svg&bg=001B9F&fit=crop&s=32bbb188148550bcf07045a04cc8aefb",
  "googlePlay@Blockbuster@180@@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=180&fm=svg&bg=00000000&s=174960195252bacaa36bf9cadd4c7cc5",
  "googlePlay@Blockbuster@180@@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=180&w=320&fm=svg&bg=00000000&fit=crop&s=fca789dae0c40396ff769bfb7eddfd3e",
  "googlePlay@Blockbuster@180@@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=180&w=180&fm=svg&bg=00000000&fit=crop&s=39e831164b6c4ab3f23e6ec0734a1a83",
  "googlePlay@Blockbuster@180@backdrop@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=180&fm=svg&bg=001B9F&s=d99cf50550e5e2644de6882d801dbc85",
  "googlePlay@Blockbuster@180@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=180&w=320&fm=svg&bg=001B9F&fit=crop&s=dc87a7802a841bf14f0c68ecd89c5073",
  "googlePlay@Blockbuster@180@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=180&w=180&fm=svg&bg=001B9F&fit=crop&s=ee7ba592af2968ddf4393c91da1ac3c5",
  "googlePlay@Blockbuster@256@@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=256&fm=svg&bg=00000000&s=cd7e210ecb85c193a2ecb1bd0f300c78",
  "googlePlay@Blockbuster@256@@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=256&w=455&fm=svg&bg=00000000&fit=crop&s=a36819c1b9792d209292c070d7bf9e88",
  "googlePlay@Blockbuster@256@@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=256&w=256&fm=svg&bg=00000000&fit=crop&s=86cc9719d809a9df94b78a870523141e",
  "googlePlay@Blockbuster@256@backdrop@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=256&fm=svg&bg=001B9F&s=3aded169a3815cabadf4aa160cd3ac8f",
  "googlePlay@Blockbuster@256@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=256&w=455&fm=svg&bg=001B9F&fit=crop&s=b9f1ae61114126590b66907ffb5edac5",
  "googlePlay@Blockbuster@256@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=256&w=256&fm=svg&bg=001B9F&fit=crop&s=fa45f68abbd1b35b2cef9248f9fe73e7",
  "googlePlay@Blockbuster@512@@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=512&fm=svg&bg=00000000&s=605b92b8aadd0a5a51a7e49a2893531a",
  "googlePlay@Blockbuster@512@@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=512&w=910&fm=svg&bg=00000000&fit=crop&s=ddb9073381ca872d356fba033a1e6845",
  "googlePlay@Blockbuster@512@@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=512&w=512&fm=svg&bg=00000000&fit=crop&s=f8511fc9e1acdd31275bd6ccbdc552e7",
  "googlePlay@Blockbuster@512@backdrop@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=512&fm=svg&bg=001B9F&s=84bfc34de49d12c00c837ff89e6207e0",
  "googlePlay@Blockbuster@512@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=512&w=910&fm=svg&bg=001B9F&fit=crop&s=8712a8fce7c493ff313a680dceddd2a0",
  "googlePlay@Blockbuster@512@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=512&w=512&fm=svg&bg=001B9F&fit=crop&s=a7470b7ed6075bbae633cf01cc8a2c89",
  "googlePlay@Blockbuster@1024@@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=1024&fm=svg&bg=00000000&s=564bc39eebc25b7b6f8f9dc6c5f5cadf",
  "googlePlay@Blockbuster@1024@@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=1024&w=1820&fm=svg&bg=00000000&fit=crop&s=258389b45d1cf13c275550720fe83894",
  "googlePlay@Blockbuster@1024@@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=1024&w=1024&fm=svg&bg=00000000&fit=crop&s=88f121c575da6805fec573c55e826c27",
  "googlePlay@Blockbuster@1024@backdrop@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=1024&fm=svg&bg=001B9F&s=5265af8cb09b6be8b09e7e946581965e",
  "googlePlay@Blockbuster@1024@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=1024&w=1820&fm=svg&bg=001B9F&fit=crop&s=24c60ba562827de3d61c5aab4dd16dd0",
  "googlePlay@Blockbuster@1024@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=1024&w=1024&fm=svg&bg=001B9F&fit=crop&s=29e1147a749942098815743eeced2300",
  "logoVertical@SFAnytime@16@@": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=16&fm=svg&bg=00000000&s=4febdbd7ee3b1a1b2ec769101f4567f7",
  "logoVertical@SFAnytime@16@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=16&w=28&fm=svg&bg=00000000&fit=crop&s=eddeb325bfb124ee4d50f410876bfab0",
  "logoVertical@SFAnytime@16@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=16&w=16&fm=svg&bg=00000000&fit=crop&s=e8b3a80322be13da2ee53f34f709fc45",
  "logoVertical@SFAnytime@16@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=16&fm=svg&bg=171717&s=97bed7ca8703906841e8aeaff26d117f",
  "logoVertical@SFAnytime@16@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=16&w=28&fm=svg&bg=171717&fit=crop&s=ea861169972c43e4e819968c95d91660",
  "logoVertical@SFAnytime@16@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=16&w=16&fm=svg&bg=171717&fit=crop&s=4a7acda39d65273d35d08b08b7e5fa78",
  "logoVertical@SFAnytime@32@@": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=32&fm=svg&bg=00000000&s=6dfc44771538a08e90ced4889241d76b",
  "logoVertical@SFAnytime@32@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=32&w=57&fm=svg&bg=00000000&fit=crop&s=18f727e460fb6d63ea53bbc5a881cc36",
  "logoVertical@SFAnytime@32@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=32&w=32&fm=svg&bg=00000000&fit=crop&s=ba9b055008e83bc7ca3079d81de568a6",
  "logoVertical@SFAnytime@32@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=32&fm=svg&bg=171717&s=2351c9effd42ccdb142bf7796bb1d132",
  "logoVertical@SFAnytime@32@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=32&w=57&fm=svg&bg=171717&fit=crop&s=fd70c8b4e27c7ef2455cf2681f4861f2",
  "logoVertical@SFAnytime@32@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=32&w=32&fm=svg&bg=171717&fit=crop&s=f54850056a1623e34eb4cda1c9749e63",
  "logoVertical@SFAnytime@64@@": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=64&fm=svg&bg=00000000&s=dd54d0a60dd72474572daddd8f9ade20",
  "logoVertical@SFAnytime@64@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=64&w=114&fm=svg&bg=00000000&fit=crop&s=625ac5fe82037f81df71c0f30274f99f",
  "logoVertical@SFAnytime@64@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=64&w=64&fm=svg&bg=00000000&fit=crop&s=7fa6258f339d20449f749ea6cad6ed56",
  "logoVertical@SFAnytime@64@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=64&fm=svg&bg=171717&s=6dd6ce5d87bb67abb7c946132d91cee7",
  "logoVertical@SFAnytime@64@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=64&w=114&fm=svg&bg=171717&fit=crop&s=a2523950eae3c45e2a0686f6585745e6",
  "logoVertical@SFAnytime@64@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=64&w=64&fm=svg&bg=171717&fit=crop&s=aed4e0dd6b078305ada09eb51e76e79e",
  "logoVertical@SFAnytime@120@@": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=120&fm=svg&bg=00000000&s=65efa371fde4a2bee4732b6bf5fe377d",
  "logoVertical@SFAnytime@120@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=120&w=213&fm=svg&bg=00000000&fit=crop&s=98caa7bc5e0e4460e326554be646b622",
  "logoVertical@SFAnytime@120@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=120&w=120&fm=svg&bg=00000000&fit=crop&s=0f405936f3f8e28cdc7157581d81713f",
  "logoVertical@SFAnytime@120@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=120&fm=svg&bg=171717&s=5bcd7af4853a06d734f9ee14952f10ae",
  "logoVertical@SFAnytime@120@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=120&w=213&fm=svg&bg=171717&fit=crop&s=28e7c936a6747cd49bde0a11f7be1790",
  "logoVertical@SFAnytime@120@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=120&w=120&fm=svg&bg=171717&fit=crop&s=1f194ce3b6c748de2fed0cc9af2ca11a",
  "logoVertical@SFAnytime@128@@": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=128&fm=svg&bg=00000000&s=f52a1a3a8b437cd81320ad00329be745",
  "logoVertical@SFAnytime@128@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=128&w=228&fm=svg&bg=00000000&fit=crop&s=02baa72a290d900a43b2aa92878bce4d",
  "logoVertical@SFAnytime@128@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=128&w=128&fm=svg&bg=00000000&fit=crop&s=9a728b07fb806459372837336159b671",
  "logoVertical@SFAnytime@128@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=128&fm=svg&bg=171717&s=7e08f5ab016bfb3cdb4f7486788272c6",
  "logoVertical@SFAnytime@128@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=128&w=228&fm=svg&bg=171717&fit=crop&s=19a4230df8418a87dae2798fbcefed0f",
  "logoVertical@SFAnytime@128@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=128&w=128&fm=svg&bg=171717&fit=crop&s=06ac8c85fdf6ecd1f6db560f83d429df",
  "logoVertical@SFAnytime@180@@": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=180&fm=svg&bg=00000000&s=68f85a0e7467c88ac5542eeea625abc7",
  "logoVertical@SFAnytime@180@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=180&w=320&fm=svg&bg=00000000&fit=crop&s=3ad106c5a198824b7e6c58a1070a3537",
  "logoVertical@SFAnytime@180@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=180&w=180&fm=svg&bg=00000000&fit=crop&s=a4e7788089c48d5e36c6c4f7304192f7",
  "logoVertical@SFAnytime@180@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=180&fm=svg&bg=171717&s=060268b562c5d1cd30dc574b37b77620",
  "logoVertical@SFAnytime@180@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=180&w=320&fm=svg&bg=171717&fit=crop&s=289a1a712a986125b7960733770c6d62",
  "logoVertical@SFAnytime@180@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=180&w=180&fm=svg&bg=171717&fit=crop&s=045b5f6a2762047e4af1992e91a9906b",
  "logoVertical@SFAnytime@256@@": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=256&fm=svg&bg=00000000&s=18b9d0ac259cf1a0e996132cff9b7256",
  "logoVertical@SFAnytime@256@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=256&w=455&fm=svg&bg=00000000&fit=crop&s=c73e57dd4e9b75c30d2cddd20d1519cd",
  "logoVertical@SFAnytime@256@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=256&w=256&fm=svg&bg=00000000&fit=crop&s=796dd67ec6ce7075125c451e6eb1afba",
  "logoVertical@SFAnytime@256@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=256&fm=svg&bg=171717&s=481d493705f4c774839ac4d0f153ea9f",
  "logoVertical@SFAnytime@256@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=256&w=455&fm=svg&bg=171717&fit=crop&s=9d0e22dbad6b7acd27af305a2c43e260",
  "logoVertical@SFAnytime@256@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=256&w=256&fm=svg&bg=171717&fit=crop&s=b7b297e7661214bf955218ec94a159a0",
  "logoVertical@SFAnytime@512@@": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=512&fm=svg&bg=00000000&s=5e8e9b6c4da558321fb83a3e3d5f7f54",
  "logoVertical@SFAnytime@512@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=512&w=910&fm=svg&bg=00000000&fit=crop&s=583137084c2ba3ac803db2d873a4268a",
  "logoVertical@SFAnytime@512@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=512&w=512&fm=svg&bg=00000000&fit=crop&s=1b500692bdf0803a7bfe10fca1263254",
  "logoVertical@SFAnytime@512@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=512&fm=svg&bg=171717&s=9ce86c97b8df28327092d43bc4645be7",
  "logoVertical@SFAnytime@512@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=512&w=910&fm=svg&bg=171717&fit=crop&s=b440be6274d1ce9c38d852dcbdb5890f",
  "logoVertical@SFAnytime@512@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=512&w=512&fm=svg&bg=171717&fit=crop&s=be29dedfd05b2f0cdeecf81c82c25b38",
  "logoVertical@SFAnytime@1024@@": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=1024&fm=svg&bg=00000000&s=b31e52da8bea7587a20569160183a383",
  "logoVertical@SFAnytime@1024@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=1024&w=1820&fm=svg&bg=00000000&fit=crop&s=5dc1893e45a01d4c7fc7fc5a7071d567",
  "logoVertical@SFAnytime@1024@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=1024&w=1024&fm=svg&bg=00000000&fit=crop&s=bbfaa1f0f18ef7c3547b14a264b14fe6",
  "logoVertical@SFAnytime@1024@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=1024&fm=svg&bg=171717&s=af1187b1fecc51b6b644a809a6678bea",
  "logoVertical@SFAnytime@1024@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=1024&w=1820&fm=svg&bg=171717&fit=crop&s=76dcce5cbf7b22b90ec74be7b28694b8",
  "logoVertical@SFAnytime@1024@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_VERTI_SF_3daff45fa48767ceabe26cd775284e1b.svg?h=1024&w=1024&fm=svg&bg=171717&fit=crop&s=0be826fb55e1839d2a9a1f53efd3eaa0",
  "logoHorizontal@SFAnytime@16@@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=16&fm=svg&bg=00000000&s=4e33a6f929323469a9e1fe9c5b6fbe65",
  "logoHorizontal@SFAnytime@16@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=16&w=28&fm=svg&bg=00000000&fit=crop&s=764542780e675d43f8845a8a20a22a40",
  "logoHorizontal@SFAnytime@16@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=16&w=16&fm=svg&bg=00000000&fit=crop&s=749a95831e0bc99ae394440fe5338fbf",
  "logoHorizontal@SFAnytime@16@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=16&fm=svg&bg=171717&s=10246e09c8cbc68e5e92342940bae8ca",
  "logoHorizontal@SFAnytime@16@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=16&w=28&fm=svg&bg=171717&fit=crop&s=0a1b9e7b30a6ac673e83471e23e5ca79",
  "logoHorizontal@SFAnytime@16@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=16&w=16&fm=svg&bg=171717&fit=crop&s=adc8132734afb8d2e5c6068fa317006d",
  "logoHorizontal@SFAnytime@32@@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=32&fm=svg&bg=00000000&s=feeff266aa7ee4332bfa7277b01a669d",
  "logoHorizontal@SFAnytime@32@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=32&w=57&fm=svg&bg=00000000&fit=crop&s=303b75853b6411e65f56d6e99fa129a4",
  "logoHorizontal@SFAnytime@32@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=32&w=32&fm=svg&bg=00000000&fit=crop&s=33198d0b0bc900fe533b38c908ce79fb",
  "logoHorizontal@SFAnytime@32@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=32&fm=svg&bg=171717&s=3971623c275eb27f52b3e15f6d883ec7",
  "logoHorizontal@SFAnytime@32@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=32&w=57&fm=svg&bg=171717&fit=crop&s=a409009dbe5c5cfa25a47f98f0e93b60",
  "logoHorizontal@SFAnytime@32@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=32&w=32&fm=svg&bg=171717&fit=crop&s=3a41b657adb8e9b42cd6cabaae915d36",
  "logoHorizontal@SFAnytime@64@@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=64&fm=svg&bg=00000000&s=70326f51a02d77ce230fe3c9ab261eb7",
  "logoHorizontal@SFAnytime@64@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=64&w=114&fm=svg&bg=00000000&fit=crop&s=365f22ee69474174be926e9871a75e9a",
  "logoHorizontal@SFAnytime@64@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=64&w=64&fm=svg&bg=00000000&fit=crop&s=1c0fb7bc1f67dd6fab7ebb190a7fd39e",
  "logoHorizontal@SFAnytime@64@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=64&fm=svg&bg=171717&s=76067bf374e866378102775dc6cea0e5",
  "logoHorizontal@SFAnytime@64@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=64&w=114&fm=svg&bg=171717&fit=crop&s=7e9e8e6de265dff7d298537dd19789cb",
  "logoHorizontal@SFAnytime@64@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=64&w=64&fm=svg&bg=171717&fit=crop&s=6ea496706a5d87e76a969d7055daee75",
  "logoHorizontal@SFAnytime@120@@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=120&fm=svg&bg=00000000&s=e719a857def089992a50eea30d12d894",
  "logoHorizontal@SFAnytime@120@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=120&w=213&fm=svg&bg=00000000&fit=crop&s=8ca57b8149bdbdc541da69eca2485f61",
  "logoHorizontal@SFAnytime@120@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=120&w=120&fm=svg&bg=00000000&fit=crop&s=2ecff861638a623d7ab11784e3b386a9",
  "logoHorizontal@SFAnytime@120@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=120&fm=svg&bg=171717&s=e0c7960888f7bc3c9aab389edc1337f1",
  "logoHorizontal@SFAnytime@120@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=120&w=213&fm=svg&bg=171717&fit=crop&s=a0cd7c8d1d816084b2954acc9a26b4f6",
  "logoHorizontal@SFAnytime@120@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=120&w=120&fm=svg&bg=171717&fit=crop&s=3bc2635ef59d818552c7129bed1d312e",
  "logoHorizontal@SFAnytime@128@@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=128&fm=svg&bg=00000000&s=76fe7b9fb91fc9c9f2bfe4e4163a66a9",
  "logoHorizontal@SFAnytime@128@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=128&w=228&fm=svg&bg=00000000&fit=crop&s=f3d6e0c613915ea1db97d715618a3156",
  "logoHorizontal@SFAnytime@128@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=128&w=128&fm=svg&bg=00000000&fit=crop&s=5a64063d1d630a7d390563bd21f3fb81",
  "logoHorizontal@SFAnytime@128@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=128&fm=svg&bg=171717&s=3a3589161c1b2aaf02fdbb7af4f09bef",
  "logoHorizontal@SFAnytime@128@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=128&w=228&fm=svg&bg=171717&fit=crop&s=270b993da8c5eccba6eaabaac9842b22",
  "logoHorizontal@SFAnytime@128@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=128&w=128&fm=svg&bg=171717&fit=crop&s=627903625a6239f1844a7e11b0adf9d8",
  "logoHorizontal@SFAnytime@180@@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=180&fm=svg&bg=00000000&s=ebf05c68ad016e2a166995ec87567792",
  "logoHorizontal@SFAnytime@180@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=180&w=320&fm=svg&bg=00000000&fit=crop&s=3aab0fff30c3253f01f65c33c0289f43",
  "logoHorizontal@SFAnytime@180@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=180&w=180&fm=svg&bg=00000000&fit=crop&s=977fa7496912b4ba6cc06a7bad27b2bc",
  "logoHorizontal@SFAnytime@180@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=180&fm=svg&bg=171717&s=6be29bfe1f59c7fecef5159c06947756",
  "logoHorizontal@SFAnytime@180@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=180&w=320&fm=svg&bg=171717&fit=crop&s=587f946138442b8c11745186dfaf7f8a",
  "logoHorizontal@SFAnytime@180@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=180&w=180&fm=svg&bg=171717&fit=crop&s=4a5db73146302bb99935107b743078ed",
  "logoHorizontal@SFAnytime@256@@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=256&fm=svg&bg=00000000&s=d41fce969f52bc95c3a2a15a023d2bfa",
  "logoHorizontal@SFAnytime@256@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=256&w=455&fm=svg&bg=00000000&fit=crop&s=6d777ca3a9bbf59f81aa51a4a10faaa3",
  "logoHorizontal@SFAnytime@256@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=256&w=256&fm=svg&bg=00000000&fit=crop&s=c2bfab01b490b809bf0c35a4dfc80b80",
  "logoHorizontal@SFAnytime@256@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=256&fm=svg&bg=171717&s=ad909585ce5f720d5abe5fe8fc59e834",
  "logoHorizontal@SFAnytime@256@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=256&w=455&fm=svg&bg=171717&fit=crop&s=7b0ccea1e7b904b392d3388237c5cbd3",
  "logoHorizontal@SFAnytime@256@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=256&w=256&fm=svg&bg=171717&fit=crop&s=428bc7d1f9a7f73d8229226232e5699f",
  "logoHorizontal@SFAnytime@512@@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=512&fm=svg&bg=00000000&s=189c76fd91b828f415864138beedb631",
  "logoHorizontal@SFAnytime@512@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=512&w=910&fm=svg&bg=00000000&fit=crop&s=f2771bf295ee0c406b499f4608457833",
  "logoHorizontal@SFAnytime@512@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=512&w=512&fm=svg&bg=00000000&fit=crop&s=6cc5b0141881e98669e35ccb9a47c3c0",
  "logoHorizontal@SFAnytime@512@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=512&fm=svg&bg=171717&s=ad5ef3e90f4ad3329b7dd766fba34146",
  "logoHorizontal@SFAnytime@512@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=512&w=910&fm=svg&bg=171717&fit=crop&s=5067c5fedf6f66a049fed46a7c5b94fc",
  "logoHorizontal@SFAnytime@512@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=512&w=512&fm=svg&bg=171717&fit=crop&s=74d7f8016d1c5aee83c39c1f0558b3b3",
  "logoHorizontal@SFAnytime@1024@@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=1024&fm=svg&bg=00000000&s=920677d070191b493459e6ce4a5af498",
  "logoHorizontal@SFAnytime@1024@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=1024&w=1820&fm=svg&bg=00000000&fit=crop&s=a13c0e45728166224a3b3742a0a85c10",
  "logoHorizontal@SFAnytime@1024@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=1024&w=1024&fm=svg&bg=00000000&fit=crop&s=2cec8f423b58ca090173c27e6cf83312",
  "logoHorizontal@SFAnytime@1024@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=1024&fm=svg&bg=171717&s=a709ce911e5fa8a61758b1712804f2e1",
  "logoHorizontal@SFAnytime@1024@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=1024&w=1820&fm=svg&bg=171717&fit=crop&s=e1ff6da8d4653b4c70fc34d7ee03c3e5",
  "logoHorizontal@SFAnytime@1024@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?h=1024&w=1024&fm=svg&bg=171717&fit=crop&s=4e5754d627606ace6b523ba8e33fbd97",
  "logoWithoutText@SFAnytime@16@@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=16&fm=svg&bg=00000000&s=6a8ca3dfe3db254a26a1053ba082af0b",
  "logoWithoutText@SFAnytime@16@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=16&w=28&fm=svg&bg=00000000&fit=crop&s=7c1aaeade6e93c45d1c1ab278b6bfd7c",
  "logoWithoutText@SFAnytime@16@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=16&w=16&fm=svg&bg=00000000&fit=crop&s=c7d6552bac609b46f2e91b0d7dfbf9f7",
  "logoWithoutText@SFAnytime@16@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=16&fm=svg&bg=171717&s=cd7d957d0458c45f9208c65eb245ceed",
  "logoWithoutText@SFAnytime@16@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=16&w=28&fm=svg&bg=171717&fit=crop&s=34408cbc548e06ee62dda4b113f31e0b",
  "logoWithoutText@SFAnytime@16@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=16&w=16&fm=svg&bg=171717&fit=crop&s=0856d7701bdeb47b64767c58bbb29e48",
  "logoWithoutText@SFAnytime@32@@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=32&fm=svg&bg=00000000&s=38f48045c92529abfe339129b54948a2",
  "logoWithoutText@SFAnytime@32@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=32&w=57&fm=svg&bg=00000000&fit=crop&s=6f29dedebe66cd475db4a64457aaa520",
  "logoWithoutText@SFAnytime@32@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=32&w=32&fm=svg&bg=00000000&fit=crop&s=062c4ec2d1f6ff32aa20ba18b4ba5b38",
  "logoWithoutText@SFAnytime@32@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=32&fm=svg&bg=171717&s=af820766c65cceff4f80bb9103da06f5",
  "logoWithoutText@SFAnytime@32@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=32&w=57&fm=svg&bg=171717&fit=crop&s=d1bff7551b114b98ee413129ce81b349",
  "logoWithoutText@SFAnytime@32@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=32&w=32&fm=svg&bg=171717&fit=crop&s=9af5c0631a93772e5795697aec62d87e",
  "logoWithoutText@SFAnytime@64@@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=64&fm=svg&bg=00000000&s=4f91d0a347525479754811a1c876191d",
  "logoWithoutText@SFAnytime@64@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=64&w=114&fm=svg&bg=00000000&fit=crop&s=f3961ad362ae4da5e192b877caf16e9d",
  "logoWithoutText@SFAnytime@64@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=64&w=64&fm=svg&bg=00000000&fit=crop&s=485bda98a04964f0c829510b2e2de0c0",
  "logoWithoutText@SFAnytime@64@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=64&fm=svg&bg=171717&s=f8e8ceba3e6c3cee984633381b9ca5d9",
  "logoWithoutText@SFAnytime@64@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=64&w=114&fm=svg&bg=171717&fit=crop&s=bf6e4344a76c81146d414934a9d20eed",
  "logoWithoutText@SFAnytime@64@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=64&w=64&fm=svg&bg=171717&fit=crop&s=8d3a67a2c9a9535092e411d1160a4b1b",
  "logoWithoutText@SFAnytime@120@@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=120&fm=svg&bg=00000000&s=5ae597583771c4d704659b4ca5f6f131",
  "logoWithoutText@SFAnytime@120@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=120&w=213&fm=svg&bg=00000000&fit=crop&s=44f7a571fa9d398e9b7931c96ceed623",
  "logoWithoutText@SFAnytime@120@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=120&w=120&fm=svg&bg=00000000&fit=crop&s=f48e36678b34416063d53ed9375552e2",
  "logoWithoutText@SFAnytime@120@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=120&fm=svg&bg=171717&s=9244d31a1764653aeb6e7cf40ffbe3b4",
  "logoWithoutText@SFAnytime@120@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=120&w=213&fm=svg&bg=171717&fit=crop&s=b645e4735f04c9a93359b3f7e34fef0c",
  "logoWithoutText@SFAnytime@120@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=120&w=120&fm=svg&bg=171717&fit=crop&s=5727fdb3583cafa9b01bf1be7c5fe789",
  "logoWithoutText@SFAnytime@128@@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=128&fm=svg&bg=00000000&s=abfcd36d786730c430b0112c6fa54df9",
  "logoWithoutText@SFAnytime@128@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=128&w=228&fm=svg&bg=00000000&fit=crop&s=721da9e1754f5c45e93f5432a2d08317",
  "logoWithoutText@SFAnytime@128@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=128&w=128&fm=svg&bg=00000000&fit=crop&s=3074c6f6cdaa97258043efae6651e59c",
  "logoWithoutText@SFAnytime@128@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=128&fm=svg&bg=171717&s=e56f8c0bcf0808590e9c7499d60dec33",
  "logoWithoutText@SFAnytime@128@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=128&w=228&fm=svg&bg=171717&fit=crop&s=282b2587253d4aa9807010d930b70368",
  "logoWithoutText@SFAnytime@128@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=128&w=128&fm=svg&bg=171717&fit=crop&s=8245857215dfc7a5ce34c167dae2880d",
  "logoWithoutText@SFAnytime@180@@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=180&fm=svg&bg=00000000&s=6bce87666863cc1d0da15010077aead8",
  "logoWithoutText@SFAnytime@180@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=180&w=320&fm=svg&bg=00000000&fit=crop&s=641f185aca9117476f586d4f61fe5066",
  "logoWithoutText@SFAnytime@180@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=180&w=180&fm=svg&bg=00000000&fit=crop&s=0ba0d946027c15fcb940082904d297b7",
  "logoWithoutText@SFAnytime@180@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=180&fm=svg&bg=171717&s=f737c04c0569147a59a88ba258077ac1",
  "logoWithoutText@SFAnytime@180@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=180&w=320&fm=svg&bg=171717&fit=crop&s=a0627fe0e09ffe7a1d61fde8e24ea3c7",
  "logoWithoutText@SFAnytime@180@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=180&w=180&fm=svg&bg=171717&fit=crop&s=1cbd2865c2e2d71bacff4b9d61f001ab",
  "logoWithoutText@SFAnytime@256@@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=256&fm=svg&bg=00000000&s=07fc7242d8155788a2f5998b023d327e",
  "logoWithoutText@SFAnytime@256@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=256&w=455&fm=svg&bg=00000000&fit=crop&s=deb7f9f9b7b12df888f4d14633468342",
  "logoWithoutText@SFAnytime@256@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=256&w=256&fm=svg&bg=00000000&fit=crop&s=86acccb895698806bf7e5a26920a0b8a",
  "logoWithoutText@SFAnytime@256@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=256&fm=svg&bg=171717&s=bbd5b91ed31699c125aa12ecd7fdd47d",
  "logoWithoutText@SFAnytime@256@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=256&w=455&fm=svg&bg=171717&fit=crop&s=03ef5eea8100e4a0fa10716561db2acd",
  "logoWithoutText@SFAnytime@256@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=256&w=256&fm=svg&bg=171717&fit=crop&s=180e3d309c5ef022ebdcea0709eea9c7",
  "logoWithoutText@SFAnytime@512@@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=512&fm=svg&bg=00000000&s=4b12b1187d05d2071b5adfd18b81a52e",
  "logoWithoutText@SFAnytime@512@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=512&w=910&fm=svg&bg=00000000&fit=crop&s=49724a3d9ce66a9f33f3f5ec9527b45b",
  "logoWithoutText@SFAnytime@512@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=512&w=512&fm=svg&bg=00000000&fit=crop&s=45fceb5d8e639ac0809a3686717fd175",
  "logoWithoutText@SFAnytime@512@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=512&fm=svg&bg=171717&s=172d8fb258f788258db5bdc0b8738bae",
  "logoWithoutText@SFAnytime@512@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=512&w=910&fm=svg&bg=171717&fit=crop&s=e72477b5e0443e612963095fa937a17f",
  "logoWithoutText@SFAnytime@512@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=512&w=512&fm=svg&bg=171717&fit=crop&s=2bd2c9be862ac254313c8b3bfddc8541",
  "logoWithoutText@SFAnytime@1024@@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=1024&fm=svg&bg=00000000&s=33474f84dc8a39ca76688fff6d2b3ebe",
  "logoWithoutText@SFAnytime@1024@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=1024&w=1820&fm=svg&bg=00000000&fit=crop&s=b14230cdb2967b81b84975a835d91421",
  "logoWithoutText@SFAnytime@1024@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=1024&w=1024&fm=svg&bg=00000000&fit=crop&s=877a98895717f60f6d246845feef5f3d",
  "logoWithoutText@SFAnytime@1024@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=1024&fm=svg&bg=171717&s=2d58c79c1b266e10fa00b18c850d7e3b",
  "logoWithoutText@SFAnytime@1024@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=1024&w=1820&fm=svg&bg=171717&fit=crop&s=3dc3f6ac047975f9fcf16912a34bbdad",
  "logoWithoutText@SFAnytime@1024@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?h=1024&w=1024&fm=svg&bg=171717&fit=crop&s=f6ea36d9aff47eccff3be73d56059915",
  "logoHorizontalOnBG@SFAnytime@16@@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=5&h=16&w=28&fit=fill&fm=svg&s=d89f5511012348b8a3db8aae20bab699",
  "logoHorizontalOnBG@SFAnytime@16@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=5&h=16&w=28&fit=fill&fm=svg&s=d89f5511012348b8a3db8aae20bab699",
  "logoHorizontalOnBG@SFAnytime@16@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=5&h=16&w=16&fit=fill&fm=svg&s=d18dc97fc2f06db69a70dfcf9b6c05d8",
  "logoHorizontalOnBG@SFAnytime@16@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=5&h=16&w=28&fit=fill&fm=svg&s=d89f5511012348b8a3db8aae20bab699",
  "logoHorizontalOnBG@SFAnytime@16@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=5&h=16&w=28&fit=fill&fm=svg&s=d89f5511012348b8a3db8aae20bab699",
  "logoHorizontalOnBG@SFAnytime@16@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=5&h=16&w=16&fit=fill&fm=svg&s=d18dc97fc2f06db69a70dfcf9b6c05d8",
  "logoHorizontalOnBG@SFAnytime@32@@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=11&h=32&w=57&fit=fill&fm=svg&s=069cbecb63bb55611626813c1e56b648",
  "logoHorizontalOnBG@SFAnytime@32@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=11&h=32&w=57&fit=fill&fm=svg&s=069cbecb63bb55611626813c1e56b648",
  "logoHorizontalOnBG@SFAnytime@32@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=11&h=32&w=32&fit=fill&fm=svg&s=c22a9b2361c538f14b300b3984f83b48",
  "logoHorizontalOnBG@SFAnytime@32@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=11&h=32&w=57&fit=fill&fm=svg&s=069cbecb63bb55611626813c1e56b648",
  "logoHorizontalOnBG@SFAnytime@32@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=11&h=32&w=57&fit=fill&fm=svg&s=069cbecb63bb55611626813c1e56b648",
  "logoHorizontalOnBG@SFAnytime@32@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=11&h=32&w=32&fit=fill&fm=svg&s=c22a9b2361c538f14b300b3984f83b48",
  "logoHorizontalOnBG@SFAnytime@64@@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=21&h=64&w=114&fit=fill&fm=svg&s=f619bf50a38e294a4224a41f975a0906",
  "logoHorizontalOnBG@SFAnytime@64@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=21&h=64&w=114&fit=fill&fm=svg&s=f619bf50a38e294a4224a41f975a0906",
  "logoHorizontalOnBG@SFAnytime@64@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=21&h=64&w=64&fit=fill&fm=svg&s=fc53f13460dd628c9585609b58e46ad0",
  "logoHorizontalOnBG@SFAnytime@64@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=21&h=64&w=114&fit=fill&fm=svg&s=f619bf50a38e294a4224a41f975a0906",
  "logoHorizontalOnBG@SFAnytime@64@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=21&h=64&w=114&fit=fill&fm=svg&s=f619bf50a38e294a4224a41f975a0906",
  "logoHorizontalOnBG@SFAnytime@64@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=21&h=64&w=64&fit=fill&fm=svg&s=fc53f13460dd628c9585609b58e46ad0",
  "logoHorizontalOnBG@SFAnytime@120@@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=40&h=120&w=213&fit=fill&fm=svg&s=cef67eaefc5bf4a5880297c571b6affe",
  "logoHorizontalOnBG@SFAnytime@120@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=40&h=120&w=213&fit=fill&fm=svg&s=cef67eaefc5bf4a5880297c571b6affe",
  "logoHorizontalOnBG@SFAnytime@120@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=40&h=120&w=120&fit=fill&fm=svg&s=dceff208654d39ec5462e97a0ed256c3",
  "logoHorizontalOnBG@SFAnytime@120@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=40&h=120&w=213&fit=fill&fm=svg&s=cef67eaefc5bf4a5880297c571b6affe",
  "logoHorizontalOnBG@SFAnytime@120@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=40&h=120&w=213&fit=fill&fm=svg&s=cef67eaefc5bf4a5880297c571b6affe",
  "logoHorizontalOnBG@SFAnytime@120@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=40&h=120&w=120&fit=fill&fm=svg&s=dceff208654d39ec5462e97a0ed256c3",
  "logoHorizontalOnBG@SFAnytime@128@@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=43&h=128&w=228&fit=fill&fm=svg&s=998c4eab18aa4b2e6c3b3e77f2cde06d",
  "logoHorizontalOnBG@SFAnytime@128@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=43&h=128&w=228&fit=fill&fm=svg&s=998c4eab18aa4b2e6c3b3e77f2cde06d",
  "logoHorizontalOnBG@SFAnytime@128@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=43&h=128&w=128&fit=fill&fm=svg&s=a0160e42ab921cac57ff50374ab57041",
  "logoHorizontalOnBG@SFAnytime@128@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=43&h=128&w=228&fit=fill&fm=svg&s=998c4eab18aa4b2e6c3b3e77f2cde06d",
  "logoHorizontalOnBG@SFAnytime@128@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=43&h=128&w=228&fit=fill&fm=svg&s=998c4eab18aa4b2e6c3b3e77f2cde06d",
  "logoHorizontalOnBG@SFAnytime@128@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=43&h=128&w=128&fit=fill&fm=svg&s=a0160e42ab921cac57ff50374ab57041",
  "logoHorizontalOnBG@SFAnytime@180@@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=60&h=180&w=320&fit=fill&fm=svg&s=61ecb9f61e3944b0109b72c351b7450a",
  "logoHorizontalOnBG@SFAnytime@180@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=60&h=180&w=320&fit=fill&fm=svg&s=61ecb9f61e3944b0109b72c351b7450a",
  "logoHorizontalOnBG@SFAnytime@180@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=60&h=180&w=180&fit=fill&fm=svg&s=d11267a8f1b6f87fb6f45ec1fc425962",
  "logoHorizontalOnBG@SFAnytime@180@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=60&h=180&w=320&fit=fill&fm=svg&s=61ecb9f61e3944b0109b72c351b7450a",
  "logoHorizontalOnBG@SFAnytime@180@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=60&h=180&w=320&fit=fill&fm=svg&s=61ecb9f61e3944b0109b72c351b7450a",
  "logoHorizontalOnBG@SFAnytime@180@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=60&h=180&w=180&fit=fill&fm=svg&s=d11267a8f1b6f87fb6f45ec1fc425962",
  "logoHorizontalOnBG@SFAnytime@256@@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=85&h=256&w=455&fit=fill&fm=svg&s=9ecb8879ab4a0406fadf2733e2f78390",
  "logoHorizontalOnBG@SFAnytime@256@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=85&h=256&w=455&fit=fill&fm=svg&s=9ecb8879ab4a0406fadf2733e2f78390",
  "logoHorizontalOnBG@SFAnytime@256@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=85&h=256&w=256&fit=fill&fm=svg&s=d76895bfc5379f3535e14c14d999951a",
  "logoHorizontalOnBG@SFAnytime@256@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=85&h=256&w=455&fit=fill&fm=svg&s=9ecb8879ab4a0406fadf2733e2f78390",
  "logoHorizontalOnBG@SFAnytime@256@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=85&h=256&w=455&fit=fill&fm=svg&s=9ecb8879ab4a0406fadf2733e2f78390",
  "logoHorizontalOnBG@SFAnytime@256@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=85&h=256&w=256&fit=fill&fm=svg&s=d76895bfc5379f3535e14c14d999951a",
  "logoHorizontalOnBG@SFAnytime@512@@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=171&h=512&w=910&fit=fill&fm=svg&s=302e546fa8511684046dc2cbe68a39ef",
  "logoHorizontalOnBG@SFAnytime@512@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=171&h=512&w=910&fit=fill&fm=svg&s=302e546fa8511684046dc2cbe68a39ef",
  "logoHorizontalOnBG@SFAnytime@512@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=171&h=512&w=512&fit=fill&fm=svg&s=939e4067403143474fde204e74c0dd30",
  "logoHorizontalOnBG@SFAnytime@512@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=171&h=512&w=910&fit=fill&fm=svg&s=302e546fa8511684046dc2cbe68a39ef",
  "logoHorizontalOnBG@SFAnytime@512@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=171&h=512&w=910&fit=fill&fm=svg&s=302e546fa8511684046dc2cbe68a39ef",
  "logoHorizontalOnBG@SFAnytime@512@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=171&h=512&w=512&fit=fill&fm=svg&s=939e4067403143474fde204e74c0dd30",
  "logoHorizontalOnBG@SFAnytime@1024@@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=341&h=1024&w=1820&fit=fill&fm=svg&s=8e5a8a9fa2016ce4d7efb8ffcbdc82fc",
  "logoHorizontalOnBG@SFAnytime@1024@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=341&h=1024&w=1820&fit=fill&fm=svg&s=8e5a8a9fa2016ce4d7efb8ffcbdc82fc",
  "logoHorizontalOnBG@SFAnytime@1024@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=341&h=1024&w=1024&fit=fill&fm=svg&s=2780f4e2630ac05e4c82901aa8799df9",
  "logoHorizontalOnBG@SFAnytime@1024@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=341&h=1024&w=1820&fit=fill&fm=svg&s=8e5a8a9fa2016ce4d7efb8ffcbdc82fc",
  "logoHorizontalOnBG@SFAnytime@1024@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=341&h=1024&w=1820&fit=fill&fm=svg&s=8e5a8a9fa2016ce4d7efb8ffcbdc82fc",
  "logoHorizontalOnBG@SFAnytime@1024@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_HORIZ_SF_587bf34c3e68af3b0577acbddac02d77.svg?bg=141414&fill-color=141414&pad=341&h=1024&w=1024&fit=fill&fm=svg&s=2780f4e2630ac05e4c82901aa8799df9",
  "coverFallback@SFAnytime@16@@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=4&h=16&w=11&fit=fill&sat=-70&fm=svg&s=0c4c288996f405038354e90205232bac",
  "coverFallback@SFAnytime@16@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=4&h=16&w=28&fit=fill&sat=-70&fm=svg&s=11d2d0028122e2c805761e3a15177857",
  "coverFallback@SFAnytime@16@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=4&h=16&w=16&fit=fill&sat=-70&fm=svg&s=39fcc7affb9a13a343456935d33eebd1",
  "coverFallback@SFAnytime@16@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=4&h=16&w=11&fit=fill&sat=-70&fm=svg&s=0c4c288996f405038354e90205232bac",
  "coverFallback@SFAnytime@16@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=4&h=16&w=28&fit=fill&sat=-70&fm=svg&s=11d2d0028122e2c805761e3a15177857",
  "coverFallback@SFAnytime@16@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=4&h=16&w=16&fit=fill&sat=-70&fm=svg&s=39fcc7affb9a13a343456935d33eebd1",
  "coverFallback@SFAnytime@32@@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=9&h=32&w=22&fit=fill&sat=-70&fm=svg&s=5032e492bd22e1c38c37aa51886110a0",
  "coverFallback@SFAnytime@32@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=9&h=32&w=57&fit=fill&sat=-70&fm=svg&s=897c11fdc2e7694839233ad8d6c92793",
  "coverFallback@SFAnytime@32@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=9&h=32&w=32&fit=fill&sat=-70&fm=svg&s=e921c334b15c2514dee60f4c9ec3ddf0",
  "coverFallback@SFAnytime@32@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=9&h=32&w=22&fit=fill&sat=-70&fm=svg&s=5032e492bd22e1c38c37aa51886110a0",
  "coverFallback@SFAnytime@32@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=9&h=32&w=57&fit=fill&sat=-70&fm=svg&s=897c11fdc2e7694839233ad8d6c92793",
  "coverFallback@SFAnytime@32@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=9&h=32&w=32&fit=fill&sat=-70&fm=svg&s=e921c334b15c2514dee60f4c9ec3ddf0",
  "coverFallback@SFAnytime@64@@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=17&h=64&w=44&fit=fill&sat=-70&fm=svg&s=5a09f1eb20322263ada305d1bc15d358",
  "coverFallback@SFAnytime@64@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=17&h=64&w=114&fit=fill&sat=-70&fm=svg&s=c1e0bcb1540264340db0760f36cfa41d",
  "coverFallback@SFAnytime@64@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=17&h=64&w=64&fit=fill&sat=-70&fm=svg&s=3bf371033d90377a0b0a1ad796615399",
  "coverFallback@SFAnytime@64@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=17&h=64&w=44&fit=fill&sat=-70&fm=svg&s=5a09f1eb20322263ada305d1bc15d358",
  "coverFallback@SFAnytime@64@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=17&h=64&w=114&fit=fill&sat=-70&fm=svg&s=c1e0bcb1540264340db0760f36cfa41d",
  "coverFallback@SFAnytime@64@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=17&h=64&w=64&fit=fill&sat=-70&fm=svg&s=3bf371033d90377a0b0a1ad796615399",
  "coverFallback@SFAnytime@120@@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=32&h=120&w=83&fit=fill&sat=-70&fm=svg&s=d9cd054fe2bf7d0d5d1a6b4ad319743c",
  "coverFallback@SFAnytime@120@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=32&h=120&w=213&fit=fill&sat=-70&fm=svg&s=700a122570584dc385d0c09922c99cde",
  "coverFallback@SFAnytime@120@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=32&h=120&w=120&fit=fill&sat=-70&fm=svg&s=bfbeedced58009c37fb70f98918d3e53",
  "coverFallback@SFAnytime@120@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=32&h=120&w=83&fit=fill&sat=-70&fm=svg&s=d9cd054fe2bf7d0d5d1a6b4ad319743c",
  "coverFallback@SFAnytime@120@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=32&h=120&w=213&fit=fill&sat=-70&fm=svg&s=700a122570584dc385d0c09922c99cde",
  "coverFallback@SFAnytime@120@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=32&h=120&w=120&fit=fill&sat=-70&fm=svg&s=bfbeedced58009c37fb70f98918d3e53",
  "coverFallback@SFAnytime@128@@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=34&h=128&w=89&fit=fill&sat=-70&fm=svg&s=b3e2616e56eda98237fbaaa0131ceab1",
  "coverFallback@SFAnytime@128@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=34&h=128&w=228&fit=fill&sat=-70&fm=svg&s=1bdb1059f9dbb8a5ed85c4b719442fa2",
  "coverFallback@SFAnytime@128@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=34&h=128&w=128&fit=fill&sat=-70&fm=svg&s=7acc300331816b2b27189ec731fabddd",
  "coverFallback@SFAnytime@128@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=34&h=128&w=89&fit=fill&sat=-70&fm=svg&s=b3e2616e56eda98237fbaaa0131ceab1",
  "coverFallback@SFAnytime@128@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=34&h=128&w=228&fit=fill&sat=-70&fm=svg&s=1bdb1059f9dbb8a5ed85c4b719442fa2",
  "coverFallback@SFAnytime@128@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=34&h=128&w=128&fit=fill&sat=-70&fm=svg&s=7acc300331816b2b27189ec731fabddd",
  "coverFallback@SFAnytime@180@@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=48&h=180&w=125&fit=fill&sat=-70&fm=svg&s=778387ebc98df29cdc9a4b157b493920",
  "coverFallback@SFAnytime@180@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=48&h=180&w=320&fit=fill&sat=-70&fm=svg&s=3548096b37afb95f50bb7d2a8db348b7",
  "coverFallback@SFAnytime@180@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=48&h=180&w=180&fit=fill&sat=-70&fm=svg&s=dff60c75f57a1c9e95e24990279a3d13",
  "coverFallback@SFAnytime@180@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=48&h=180&w=125&fit=fill&sat=-70&fm=svg&s=778387ebc98df29cdc9a4b157b493920",
  "coverFallback@SFAnytime@180@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=48&h=180&w=320&fit=fill&sat=-70&fm=svg&s=3548096b37afb95f50bb7d2a8db348b7",
  "coverFallback@SFAnytime@180@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=48&h=180&w=180&fit=fill&sat=-70&fm=svg&s=dff60c75f57a1c9e95e24990279a3d13",
  "coverFallback@SFAnytime@256@@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=68&h=256&w=177&fit=fill&sat=-70&fm=svg&s=68cb2041320217a39463e769c4b9ea7e",
  "coverFallback@SFAnytime@256@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=68&h=256&w=455&fit=fill&sat=-70&fm=svg&s=1ea4a4d29824290739bfa2ac980f05ab",
  "coverFallback@SFAnytime@256@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=68&h=256&w=256&fit=fill&sat=-70&fm=svg&s=51dd4cabe0a6adfce4d498fcefc60d9f",
  "coverFallback@SFAnytime@256@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=68&h=256&w=177&fit=fill&sat=-70&fm=svg&s=68cb2041320217a39463e769c4b9ea7e",
  "coverFallback@SFAnytime@256@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=68&h=256&w=455&fit=fill&sat=-70&fm=svg&s=1ea4a4d29824290739bfa2ac980f05ab",
  "coverFallback@SFAnytime@256@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=68&h=256&w=256&fit=fill&sat=-70&fm=svg&s=51dd4cabe0a6adfce4d498fcefc60d9f",
  "coverFallback@SFAnytime@512@@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=137&h=512&w=354&fit=fill&sat=-70&fm=svg&s=5eec81fb9be41e054e4162f62d2c4a12",
  "coverFallback@SFAnytime@512@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=137&h=512&w=910&fit=fill&sat=-70&fm=svg&s=f5f2cce19be6a66edf4748a67a777960",
  "coverFallback@SFAnytime@512@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=137&h=512&w=512&fit=fill&sat=-70&fm=svg&s=dbbe725137568abee43ac679d6a34d8c",
  "coverFallback@SFAnytime@512@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=137&h=512&w=354&fit=fill&sat=-70&fm=svg&s=5eec81fb9be41e054e4162f62d2c4a12",
  "coverFallback@SFAnytime@512@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=137&h=512&w=910&fit=fill&sat=-70&fm=svg&s=f5f2cce19be6a66edf4748a67a777960",
  "coverFallback@SFAnytime@512@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=137&h=512&w=512&fit=fill&sat=-70&fm=svg&s=dbbe725137568abee43ac679d6a34d8c",
  "coverFallback@SFAnytime@1024@@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=273&h=1024&w=709&fit=fill&sat=-70&fm=svg&s=0319d380c8c1e3f43b862f539039c40f",
  "coverFallback@SFAnytime@1024@@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=273&h=1024&w=1820&fit=fill&sat=-70&fm=svg&s=acb2e82919207b44cbec3b382c336c1a",
  "coverFallback@SFAnytime@1024@@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=273&h=1024&w=1024&fit=fill&sat=-70&fm=svg&s=c439fbc4890712c7b3064c27c0b745ca",
  "coverFallback@SFAnytime@1024@backdrop@": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=273&h=1024&w=709&fit=fill&sat=-70&fm=svg&s=0319d380c8c1e3f43b862f539039c40f",
  "coverFallback@SFAnytime@1024@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=273&h=1024&w=1820&fit=fill&sat=-70&fm=svg&s=acb2e82919207b44cbec3b382c336c1a",
  "coverFallback@SFAnytime@1024@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LOGO_CLEAN_SF_f2a68803df1fe529d0157443f735e9e7.svg?bg=141414&fill-color=141414&pad=273&h=1024&w=1024&fit=fill&sat=-70&fm=svg&s=c439fbc4890712c7b3064c27c0b745ca",
  "blank@SFAnytime@16@@": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=16&fm=png&bg=00000000&s=a68f90b17f2fc3514e5483bd609eaa20",
  "blank@SFAnytime@16@@16x9": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=16&w=28&fm=png&bg=00000000&fit=crop&s=08f848ae5627d9043fef70bd2e4ac55b",
  "blank@SFAnytime@16@@1x1": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=16&w=16&fm=png&bg=00000000&fit=crop&s=1b1eeaff4aa604fb5c2ef4bf4775d88e",
  "blank@SFAnytime@16@backdrop@": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=16&fm=png&bg=171717&s=db5d59d9855c13ab93de0e5a929487fd",
  "blank@SFAnytime@16@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=16&w=28&fm=png&bg=171717&fit=crop&s=8c783aa8b7093dbee90676977b976cae",
  "blank@SFAnytime@16@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=16&w=16&fm=png&bg=171717&fit=crop&s=e035b572172a245444b4b4ad44bee74d",
  "blank@SFAnytime@32@@": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=32&fm=png&bg=00000000&s=121501174d3da2634c914c2f8050e6e2",
  "blank@SFAnytime@32@@16x9": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=32&w=57&fm=png&bg=00000000&fit=crop&s=944ac0056646f333328c7a48c0f2ccc2",
  "blank@SFAnytime@32@@1x1": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=32&w=32&fm=png&bg=00000000&fit=crop&s=d0ab8ced66e0da8220138d28694da246",
  "blank@SFAnytime@32@backdrop@": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=32&fm=png&bg=171717&s=2510781b4c734e2d40044f71cd0846f4",
  "blank@SFAnytime@32@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=32&w=57&fm=png&bg=171717&fit=crop&s=96bde988684130201955338e5b05a657",
  "blank@SFAnytime@32@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=32&w=32&fm=png&bg=171717&fit=crop&s=e948be5b29da31edcae9877bec56ac6d",
  "blank@SFAnytime@64@@": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=64&fm=png&bg=00000000&s=ddfc63735a6bd8d6756d5c67eb15baf3",
  "blank@SFAnytime@64@@16x9": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=64&w=114&fm=png&bg=00000000&fit=crop&s=52d5905c3a3517936de78f78f0f3c466",
  "blank@SFAnytime@64@@1x1": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=64&w=64&fm=png&bg=00000000&fit=crop&s=134e9cd0bf7568b01d35ff1218934115",
  "blank@SFAnytime@64@backdrop@": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=64&fm=png&bg=171717&s=30f6e2080a62c7c89333d3699db9d05d",
  "blank@SFAnytime@64@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=64&w=114&fm=png&bg=171717&fit=crop&s=211f7e86e8a67f66e3d5ca18bc1cb5ef",
  "blank@SFAnytime@64@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=64&w=64&fm=png&bg=171717&fit=crop&s=574b110f79f1fa13be3c4db4228a3696",
  "blank@SFAnytime@120@@": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=120&fm=png&bg=00000000&s=61e83e767fab191efcb9fc8c92056eaf",
  "blank@SFAnytime@120@@16x9": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=120&w=213&fm=png&bg=00000000&fit=crop&s=b6e0c1a56ceb78b69141e77f7ecf2e85",
  "blank@SFAnytime@120@@1x1": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=120&w=120&fm=png&bg=00000000&fit=crop&s=1f11bab724e9157902821caa7074dd8b",
  "blank@SFAnytime@120@backdrop@": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=120&fm=png&bg=171717&s=650384222908ef876885c47df4ffd01e",
  "blank@SFAnytime@120@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=120&w=213&fm=png&bg=171717&fit=crop&s=b36af77672ea7974026ae75d562cddc3",
  "blank@SFAnytime@120@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=120&w=120&fm=png&bg=171717&fit=crop&s=2c705b45291d95948c92240de7aa3382",
  "blank@SFAnytime@128@@": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=128&fm=png&bg=00000000&s=eae7aac61230df83a8ac60af8870b5cb",
  "blank@SFAnytime@128@@16x9": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=128&w=228&fm=png&bg=00000000&fit=crop&s=f9e28d8f3a8fbc1c58e96a013a00aa6d",
  "blank@SFAnytime@128@@1x1": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=128&w=128&fm=png&bg=00000000&fit=crop&s=3ce31c697b31f70a25e9ba8edd71e459",
  "blank@SFAnytime@128@backdrop@": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=128&fm=png&bg=171717&s=8daae8877c21f7650684c4a3887e1c7c",
  "blank@SFAnytime@128@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=128&w=228&fm=png&bg=171717&fit=crop&s=7fa80a4a96adb144e2d76e16307a1f2d",
  "blank@SFAnytime@128@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=128&w=128&fm=png&bg=171717&fit=crop&s=8b341f83403a1baa8afeae833e7b2cbd",
  "blank@SFAnytime@180@@": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=180&fm=png&bg=00000000&s=a71cb3c5b73e817631b0f00c3befcdad",
  "blank@SFAnytime@180@@16x9": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=180&w=320&fm=png&bg=00000000&fit=crop&s=ae7e88fe15a7a10c955be039b059d01a",
  "blank@SFAnytime@180@@1x1": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=180&w=180&fm=png&bg=00000000&fit=crop&s=a2b80d66f8a870d5b4ad88f69bc1bc09",
  "blank@SFAnytime@180@backdrop@": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=180&fm=png&bg=171717&s=3ac1cb312096e2dc6313388a2f9bd221",
  "blank@SFAnytime@180@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=180&w=320&fm=png&bg=171717&fit=crop&s=a7950174b40e713f019735a49d4d9472",
  "blank@SFAnytime@180@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=180&w=180&fm=png&bg=171717&fit=crop&s=9d57ebc3ec5a201c5a1ec191e7f284f8",
  "blank@SFAnytime@256@@": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=256&fm=png&bg=00000000&s=e4fe91fa0cc62e05a4fb792a3d66864d",
  "blank@SFAnytime@256@@16x9": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=256&w=455&fm=png&bg=00000000&fit=crop&s=1deabbaa92c17b752e1072ed4132fd3a",
  "blank@SFAnytime@256@@1x1": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=256&w=256&fm=png&bg=00000000&fit=crop&s=bde12a3e9e524f2e44613911b7179a57",
  "blank@SFAnytime@256@backdrop@": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=256&fm=png&bg=171717&s=c5134d8c6c2e6af3a50228e07de5d3ef",
  "blank@SFAnytime@256@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=256&w=455&fm=png&bg=171717&fit=crop&s=c49026b9ca029ed938a9de8a240c45c0",
  "blank@SFAnytime@256@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=256&w=256&fm=png&bg=171717&fit=crop&s=db07978bd033dbfa53aad4ffd4d0ec91",
  "blank@SFAnytime@512@@": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=512&fm=png&bg=00000000&s=0e826e5cf2db62d51373986da13c975d",
  "blank@SFAnytime@512@@16x9": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=512&w=910&fm=png&bg=00000000&fit=crop&s=8f93c1ef8181ed9a730015d1a1d9430b",
  "blank@SFAnytime@512@@1x1": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=512&w=512&fm=png&bg=00000000&fit=crop&s=1b2161bda1e32a381d89eb54190b10a5",
  "blank@SFAnytime@512@backdrop@": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=512&fm=png&bg=171717&s=ff9052cdadb3c3a678f256dfb9bf01ed",
  "blank@SFAnytime@512@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=512&w=910&fm=png&bg=171717&fit=crop&s=a30955ad308c77ffaa64c997b130f698",
  "blank@SFAnytime@512@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=512&w=512&fm=png&bg=171717&fit=crop&s=37db4e8ae67121dd61f9a382f4cb8100",
  "blank@SFAnytime@1024@@": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=1024&fm=png&bg=00000000&s=e82e5251868898cde47edfebf1466204",
  "blank@SFAnytime@1024@@16x9": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=1024&w=1820&fm=png&bg=00000000&fit=crop&s=50548c1b934d8e7379a84a221e29f4b7",
  "blank@SFAnytime@1024@@1x1": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=1024&w=1024&fm=png&bg=00000000&fit=crop&s=8d8be5132853a1f80088635c650a3124",
  "blank@SFAnytime@1024@backdrop@": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=1024&fm=png&bg=171717&s=82075f0e08100e509796990709c9c7cf",
  "blank@SFAnytime@1024@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=1024&w=1820&fm=png&bg=171717&fit=crop&s=547be2e8d24567506385436bfc880e31",
  "blank@SFAnytime@1024@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/1x1_00000000.png?h=1024&w=1024&fm=png&bg=171717&fit=crop&s=fad36bbf95c27aa8d2fd2e0b7986cd70",
  "decorative1@SFAnytime@16@@": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=16&fm=jpg&bg=00000000&s=8187071152ecea09ec327335db378103",
  "decorative1@SFAnytime@16@@16x9": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=16&w=28&fm=jpg&bg=00000000&fit=crop&s=3df2b89e3c98a56d51cf55fdcdcfd7ad",
  "decorative1@SFAnytime@16@@1x1": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=16&w=16&fm=jpg&bg=00000000&fit=crop&s=e90d84aed69f6b70944a8a842f379d64",
  "decorative1@SFAnytime@16@backdrop@": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=16&fm=jpg&bg=171717&s=34dcd082e04f2c4aa555b1165ea84641",
  "decorative1@SFAnytime@16@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=16&w=28&fm=jpg&bg=171717&fit=crop&s=6e6fd6caa49a7dfb48ffb4b3031b086c",
  "decorative1@SFAnytime@16@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=16&w=16&fm=jpg&bg=171717&fit=crop&s=9958de573ca514ea486942e72ef54fcc",
  "decorative1@SFAnytime@32@@": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=32&fm=jpg&bg=00000000&s=c70af01c522fc3dd173c299ab68006bc",
  "decorative1@SFAnytime@32@@16x9": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=32&w=57&fm=jpg&bg=00000000&fit=crop&s=992d8112fdd24d86977807b8d27cad66",
  "decorative1@SFAnytime@32@@1x1": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=32&w=32&fm=jpg&bg=00000000&fit=crop&s=46b85459dca7a6bf4c5ab73da9b9e2bc",
  "decorative1@SFAnytime@32@backdrop@": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=32&fm=jpg&bg=171717&s=ba4160164759bf59a65b3a14b077bdc1",
  "decorative1@SFAnytime@32@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=32&w=57&fm=jpg&bg=171717&fit=crop&s=700261bfa1d7ba475cfcbe97be741d95",
  "decorative1@SFAnytime@32@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=32&w=32&fm=jpg&bg=171717&fit=crop&s=39cadee1b36f3018e59c17cba80332a6",
  "decorative1@SFAnytime@64@@": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=64&fm=jpg&bg=00000000&s=6d7a723564bbdef55729162eae169bf1",
  "decorative1@SFAnytime@64@@16x9": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=64&w=114&fm=jpg&bg=00000000&fit=crop&s=8d11e708dc7e428aa69166f6e8e86d1e",
  "decorative1@SFAnytime@64@@1x1": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=64&w=64&fm=jpg&bg=00000000&fit=crop&s=ad51254b22245d87ac5f7cac6cb9e2dd",
  "decorative1@SFAnytime@64@backdrop@": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=64&fm=jpg&bg=171717&s=1b24b9feaa1b45e165b5b099f5658e03",
  "decorative1@SFAnytime@64@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=64&w=114&fm=jpg&bg=171717&fit=crop&s=93fe9d61c997c279d4f93c8a952ba8f9",
  "decorative1@SFAnytime@64@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=64&w=64&fm=jpg&bg=171717&fit=crop&s=771b0919ae0a3155ba3902844b5c2890",
  "decorative1@SFAnytime@120@@": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=120&fm=jpg&bg=00000000&s=25b1d82fe61cf7e89dfe01f67c7e32b9",
  "decorative1@SFAnytime@120@@16x9": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=120&w=213&fm=jpg&bg=00000000&fit=crop&s=cd6f88fc7cdefacf03f3a673e808696c",
  "decorative1@SFAnytime@120@@1x1": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=120&w=120&fm=jpg&bg=00000000&fit=crop&s=62262b7d5a13c119b1a87ad90ad437a9",
  "decorative1@SFAnytime@120@backdrop@": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=120&fm=jpg&bg=171717&s=0b97d90bf51eb60fa88bd4e41fb16bdc",
  "decorative1@SFAnytime@120@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=120&w=213&fm=jpg&bg=171717&fit=crop&s=447531e0c57777016250a2e4c87e56e3",
  "decorative1@SFAnytime@120@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=120&w=120&fm=jpg&bg=171717&fit=crop&s=d2257b9777b905c4c10b8fcb6e415f67",
  "decorative1@SFAnytime@128@@": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=128&fm=jpg&bg=00000000&s=17da56c654b69731e93829b4afa38740",
  "decorative1@SFAnytime@128@@16x9": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=128&w=228&fm=jpg&bg=00000000&fit=crop&s=5bd4d80f5ace8a5a48b4b2a31dd3fa36",
  "decorative1@SFAnytime@128@@1x1": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=128&w=128&fm=jpg&bg=00000000&fit=crop&s=d7c855049161a5926fab016e64f22af1",
  "decorative1@SFAnytime@128@backdrop@": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=128&fm=jpg&bg=171717&s=c2bdf92fb12f03536f8297c36da7578e",
  "decorative1@SFAnytime@128@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=128&w=228&fm=jpg&bg=171717&fit=crop&s=6ac0575e68d0befabd464454842446de",
  "decorative1@SFAnytime@128@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=128&w=128&fm=jpg&bg=171717&fit=crop&s=c2522b70ae0e5a38a0c783dcb3b24ed4",
  "decorative1@SFAnytime@180@@": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=180&fm=jpg&bg=00000000&s=8f51f6c5f774c98f8c57b99cd9ffaf22",
  "decorative1@SFAnytime@180@@16x9": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=180&w=320&fm=jpg&bg=00000000&fit=crop&s=c1e92bda75904c063835cb926725c312",
  "decorative1@SFAnytime@180@@1x1": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=180&w=180&fm=jpg&bg=00000000&fit=crop&s=fc3a2662eb0930359c35fe6439b5ba73",
  "decorative1@SFAnytime@180@backdrop@": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=180&fm=jpg&bg=171717&s=f648a6b106405a2e8cc53f40fd5bfd49",
  "decorative1@SFAnytime@180@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=180&w=320&fm=jpg&bg=171717&fit=crop&s=d68a227874104ca456dabb43021a8c07",
  "decorative1@SFAnytime@180@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=180&w=180&fm=jpg&bg=171717&fit=crop&s=0f61fcdfd8b844498e3df2d184b1f8b1",
  "decorative1@SFAnytime@256@@": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=256&fm=jpg&bg=00000000&s=648375a4b7271f0ea55562d234f7d18e",
  "decorative1@SFAnytime@256@@16x9": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=256&w=455&fm=jpg&bg=00000000&fit=crop&s=9b99e5b731d8e35361e1bc22f7bad691",
  "decorative1@SFAnytime@256@@1x1": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=256&w=256&fm=jpg&bg=00000000&fit=crop&s=23592626ec5e79df44bfd82fe8c03113",
  "decorative1@SFAnytime@256@backdrop@": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=256&fm=jpg&bg=171717&s=4f86b2dedb33f97e57c1d70c5b0eb4fc",
  "decorative1@SFAnytime@256@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=256&w=455&fm=jpg&bg=171717&fit=crop&s=14a5f33bdb87ec754c56f7cf1ea106ae",
  "decorative1@SFAnytime@256@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=256&w=256&fm=jpg&bg=171717&fit=crop&s=3689ca040eb44983fa297b4fda0148e4",
  "decorative1@SFAnytime@512@@": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=512&fm=jpg&bg=00000000&s=8c811100fdb28fa78400780695a59202",
  "decorative1@SFAnytime@512@@16x9": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=512&w=910&fm=jpg&bg=00000000&fit=crop&s=8eb5171564cbed0742bbc74020203bf0",
  "decorative1@SFAnytime@512@@1x1": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=512&w=512&fm=jpg&bg=00000000&fit=crop&s=1b50be561e9924a8878dfddc7f611959",
  "decorative1@SFAnytime@512@backdrop@": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=512&fm=jpg&bg=171717&s=4187d9594c4383659a0e6d520f3f1426",
  "decorative1@SFAnytime@512@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=512&w=910&fm=jpg&bg=171717&fit=crop&s=daa7ce39df3247a4058db54ee65265b0",
  "decorative1@SFAnytime@512@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=512&w=512&fm=jpg&bg=171717&fit=crop&s=afa2a78ea41aa479815bd9ea7fee303e",
  "decorative1@SFAnytime@1024@@": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=1024&fm=jpg&bg=00000000&s=3758a890a25997fd14e4777290aae7e5",
  "decorative1@SFAnytime@1024@@16x9": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=1024&w=1820&fm=jpg&bg=00000000&fit=crop&s=c9e14eec5ef136e9d3a8bcd76102a1ad",
  "decorative1@SFAnytime@1024@@1x1": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=1024&w=1024&fm=jpg&bg=00000000&fit=crop&s=43799b4b76af9b5827c78f11c800e377",
  "decorative1@SFAnytime@1024@backdrop@": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=1024&fm=jpg&bg=171717&s=8abac50ee8e04f1f56dcc618d77bc85a",
  "decorative1@SFAnytime@1024@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=1024&w=1820&fm=jpg&bg=171717&fit=crop&s=185d1dd3aaae8d7e2d8792ad4bcecc60",
  "decorative1@SFAnytime@1024@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/ERROR_BG_93fe5544f72ac460ef06c95acb4d302cb1fd8eb7ce677e87470eddf8509b7a61.jpg?h=1024&w=1024&fm=jpg&bg=171717&fit=crop&s=3ca0a7aebed286c1f6de1fd3c92cda6d",
  "decorative2@SFAnytime@16@@": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=16&fm=png&bg=00000000&s=f92c574a77caf8f3760cff7067516ed0",
  "decorative2@SFAnytime@16@@16x9": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=16&w=28&fm=png&bg=00000000&fit=crop&s=91ad9bf1d1888c4bf37d3ec6d3ece2e4",
  "decorative2@SFAnytime@16@@1x1": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=16&w=16&fm=png&bg=00000000&fit=crop&s=c32eb0f201697b88c5737231f8d5b687",
  "decorative2@SFAnytime@16@backdrop@": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=16&fm=png&bg=171717&s=30e5ab59e07813092fc52a265599ad86",
  "decorative2@SFAnytime@16@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=16&w=28&fm=png&bg=171717&fit=crop&s=62b5ff595cf355ed47c2967eb72a4e6f",
  "decorative2@SFAnytime@16@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=16&w=16&fm=png&bg=171717&fit=crop&s=d96c1c9c67416fd2ce22a69a450ec1a3",
  "decorative2@SFAnytime@32@@": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=32&fm=png&bg=00000000&s=d76fef5e3d365303043bd130f83b4c40",
  "decorative2@SFAnytime@32@@16x9": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=32&w=57&fm=png&bg=00000000&fit=crop&s=82acb6bf5ec4a8dcf3800bd2d13bf6c4",
  "decorative2@SFAnytime@32@@1x1": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=32&w=32&fm=png&bg=00000000&fit=crop&s=375077c4c77fccbc8c5f47b4a042c938",
  "decorative2@SFAnytime@32@backdrop@": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=32&fm=png&bg=171717&s=4ba1608e6a66366f854423ae4a51a481",
  "decorative2@SFAnytime@32@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=32&w=57&fm=png&bg=171717&fit=crop&s=cf7d5ef381f4b5e43d52d448ae5201a2",
  "decorative2@SFAnytime@32@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=32&w=32&fm=png&bg=171717&fit=crop&s=dcccf6add22bf2085eaa2dc88f6c51d9",
  "decorative2@SFAnytime@64@@": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=64&fm=png&bg=00000000&s=11242016da5c41a71e3f8f563d1f2e58",
  "decorative2@SFAnytime@64@@16x9": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=64&w=114&fm=png&bg=00000000&fit=crop&s=b85b40451e71405a35c95bd418f68fcc",
  "decorative2@SFAnytime@64@@1x1": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=64&w=64&fm=png&bg=00000000&fit=crop&s=a2215b7e4ca2b41763b486a2f27f6fcc",
  "decorative2@SFAnytime@64@backdrop@": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=64&fm=png&bg=171717&s=ce670a10ac9172d9a254b8dbbac85590",
  "decorative2@SFAnytime@64@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=64&w=114&fm=png&bg=171717&fit=crop&s=6aedb4cc64709f7751259c54f0c42a63",
  "decorative2@SFAnytime@64@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=64&w=64&fm=png&bg=171717&fit=crop&s=83763700716b5ba1679e5cb6f85a3c9a",
  "decorative2@SFAnytime@120@@": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=120&fm=png&bg=00000000&s=fb32b09dab9688395a9fcfe3e0ee7fbc",
  "decorative2@SFAnytime@120@@16x9": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=120&w=213&fm=png&bg=00000000&fit=crop&s=5b28eccfa1cf4aebd9b2fb098511d100",
  "decorative2@SFAnytime@120@@1x1": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=120&w=120&fm=png&bg=00000000&fit=crop&s=5b50fef2c86406e1cc09b0a220c4c502",
  "decorative2@SFAnytime@120@backdrop@": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=120&fm=png&bg=171717&s=d69d960be0e8eec70c71aeac51e77f2b",
  "decorative2@SFAnytime@120@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=120&w=213&fm=png&bg=171717&fit=crop&s=7de4ddb46dd984e1e7d85842271ad98c",
  "decorative2@SFAnytime@120@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=120&w=120&fm=png&bg=171717&fit=crop&s=1589982189ef5efb56fbdf7b48a3f665",
  "decorative2@SFAnytime@128@@": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=128&fm=png&bg=00000000&s=8fc4bfd4534481797f222343194e8e3c",
  "decorative2@SFAnytime@128@@16x9": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=128&w=228&fm=png&bg=00000000&fit=crop&s=832bd02be7f3322f55a398205a8c285f",
  "decorative2@SFAnytime@128@@1x1": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=128&w=128&fm=png&bg=00000000&fit=crop&s=a1b797606cd815ffed5f9f575dff0f6d",
  "decorative2@SFAnytime@128@backdrop@": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=128&fm=png&bg=171717&s=3efff5b789dbf634b768472087be4f8d",
  "decorative2@SFAnytime@128@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=128&w=228&fm=png&bg=171717&fit=crop&s=713db5df18a96c0c6b98dee15e22fc30",
  "decorative2@SFAnytime@128@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=128&w=128&fm=png&bg=171717&fit=crop&s=c16fb8951094731f02b0b82af1be9207",
  "decorative2@SFAnytime@180@@": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=180&fm=png&bg=00000000&s=f9951e7e3455af555eccd6f5297a407f",
  "decorative2@SFAnytime@180@@16x9": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=180&w=320&fm=png&bg=00000000&fit=crop&s=64eff9a0a3f9ae9ee406099d63cc6e49",
  "decorative2@SFAnytime@180@@1x1": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=180&w=180&fm=png&bg=00000000&fit=crop&s=d23b247f927ad3f979eca1a89451f1de",
  "decorative2@SFAnytime@180@backdrop@": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=180&fm=png&bg=171717&s=89b7de99589dc777b7d52d7f9453f28a",
  "decorative2@SFAnytime@180@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=180&w=320&fm=png&bg=171717&fit=crop&s=c30cb6be0ecc73ab5406a63a056149ee",
  "decorative2@SFAnytime@180@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=180&w=180&fm=png&bg=171717&fit=crop&s=02c6247cf2d9718108a6cc096d97721c",
  "decorative2@SFAnytime@256@@": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=256&fm=png&bg=00000000&s=9eb7c650eecd6c4395a92d9382d0c28b",
  "decorative2@SFAnytime@256@@16x9": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=256&w=455&fm=png&bg=00000000&fit=crop&s=396ee2c67be5f79e4ed58928ff90748e",
  "decorative2@SFAnytime@256@@1x1": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=256&w=256&fm=png&bg=00000000&fit=crop&s=f86f84e85223ff8bd6b0034fe5e55406",
  "decorative2@SFAnytime@256@backdrop@": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=256&fm=png&bg=171717&s=a65d3b7e5bbd8308a59c80069a21c189",
  "decorative2@SFAnytime@256@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=256&w=455&fm=png&bg=171717&fit=crop&s=32b84312bc88bf56dcea1e6817b83ee7",
  "decorative2@SFAnytime@256@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=256&w=256&fm=png&bg=171717&fit=crop&s=eeec1184779a6dc624d95a8ad86c3a4b",
  "decorative2@SFAnytime@512@@": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=512&fm=png&bg=00000000&s=eb1c7c6856370d8aa404d40a1afef49c",
  "decorative2@SFAnytime@512@@16x9": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=512&w=910&fm=png&bg=00000000&fit=crop&s=2731e46dbc8de87194565d31952711ba",
  "decorative2@SFAnytime@512@@1x1": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=512&w=512&fm=png&bg=00000000&fit=crop&s=bb5b2f54e0f88fe6a65b56fc160ca187",
  "decorative2@SFAnytime@512@backdrop@": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=512&fm=png&bg=171717&s=d1851e7aafa654c9096936d33a7e1134",
  "decorative2@SFAnytime@512@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=512&w=910&fm=png&bg=171717&fit=crop&s=62d439bf892908cdb1854e65c66c76b7",
  "decorative2@SFAnytime@512@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=512&w=512&fm=png&bg=171717&fit=crop&s=d56d8227bb20f2ff7006c06086079931",
  "decorative2@SFAnytime@1024@@": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=1024&fm=png&bg=00000000&s=283b7168843156459d0e38112a659018",
  "decorative2@SFAnytime@1024@@16x9": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=1024&w=1820&fm=png&bg=00000000&fit=crop&s=0d395a507ee9ea05cd57ae377912db36",
  "decorative2@SFAnytime@1024@@1x1": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=1024&w=1024&fm=png&bg=00000000&fit=crop&s=8bafe7dc53392a1946cd7bf9232db47c",
  "decorative2@SFAnytime@1024@backdrop@": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=1024&fm=png&bg=171717&s=6490089d714c67cb2348f61a5a80a9c3",
  "decorative2@SFAnytime@1024@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=1024&w=1820&fm=png&bg=171717&fit=crop&s=589402f39519ae483538ec47e5e23520",
  "decorative2@SFAnytime@1024@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/LIST_16x9_SF_f21f33c0137de7089da010bac1402d99.png?h=1024&w=1024&fm=png&bg=171717&fit=crop&s=4059be0780b84084e6b2fd562fbe498e",
  "ticketCover@SFAnytime@16@@": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=16&fm=png&bg=00000000&s=4503da4fb248295db5f4530ca632c39f",
  "ticketCover@SFAnytime@16@@16x9": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=16&w=28&fm=png&bg=00000000&fit=crop&s=ef150b4e23d4bbb2bf8bae2044648e7f",
  "ticketCover@SFAnytime@16@@1x1": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=16&w=16&fm=png&bg=00000000&fit=crop&s=74b9fa3553e8838fd48a9c1a86181f7f",
  "ticketCover@SFAnytime@16@backdrop@": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=16&fm=png&bg=171717&s=76c89792563418ba1474a02d4f89c9d2",
  "ticketCover@SFAnytime@16@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=16&w=28&fm=png&bg=171717&fit=crop&s=134e490b551bb0e1d304dffdb8f151be",
  "ticketCover@SFAnytime@16@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=16&w=16&fm=png&bg=171717&fit=crop&s=63006da4f7174057033460ec718778f3",
  "ticketCover@SFAnytime@32@@": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=32&fm=png&bg=00000000&s=0221f4009351edac870c40b8614c4155",
  "ticketCover@SFAnytime@32@@16x9": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=32&w=57&fm=png&bg=00000000&fit=crop&s=a46bb469f34370f21a2502a31f6fd7c4",
  "ticketCover@SFAnytime@32@@1x1": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=32&w=32&fm=png&bg=00000000&fit=crop&s=72835c9cfb1233825524c4f16a58c30f",
  "ticketCover@SFAnytime@32@backdrop@": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=32&fm=png&bg=171717&s=bde601206b93a5f21ada9c1d0d00d413",
  "ticketCover@SFAnytime@32@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=32&w=57&fm=png&bg=171717&fit=crop&s=8b810966fa0aa70cbff998f130aec8a9",
  "ticketCover@SFAnytime@32@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=32&w=32&fm=png&bg=171717&fit=crop&s=3d60566a6950568db7687924e613ab5b",
  "ticketCover@SFAnytime@64@@": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=64&fm=png&bg=00000000&s=e2b4dfcf2bd877bc6c75e550f5036b6f",
  "ticketCover@SFAnytime@64@@16x9": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=64&w=114&fm=png&bg=00000000&fit=crop&s=a7310e390539d1dc2368e7ca331d387d",
  "ticketCover@SFAnytime@64@@1x1": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=64&w=64&fm=png&bg=00000000&fit=crop&s=60b23bebc03c6c276eb52ae6025a22f2",
  "ticketCover@SFAnytime@64@backdrop@": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=64&fm=png&bg=171717&s=56a1dc26b43250212dc3af02b8b959e1",
  "ticketCover@SFAnytime@64@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=64&w=114&fm=png&bg=171717&fit=crop&s=5ef4876111680612c034dc4572779d07",
  "ticketCover@SFAnytime@64@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=64&w=64&fm=png&bg=171717&fit=crop&s=4b7e30fe545f9c7d09084c3484ac8381",
  "ticketCover@SFAnytime@120@@": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=120&fm=png&bg=00000000&s=31b2d86b9a739f6bc9777afdd459cfe6",
  "ticketCover@SFAnytime@120@@16x9": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=120&w=213&fm=png&bg=00000000&fit=crop&s=362ca864b67243f241788b1f8ca37fde",
  "ticketCover@SFAnytime@120@@1x1": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=120&w=120&fm=png&bg=00000000&fit=crop&s=327fa8b19f3f9a20d3dd8a803e777d59",
  "ticketCover@SFAnytime@120@backdrop@": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=120&fm=png&bg=171717&s=e8c31106fab82f6b19d9de7d451eb817",
  "ticketCover@SFAnytime@120@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=120&w=213&fm=png&bg=171717&fit=crop&s=56f4a850073dae221b17d8c1d4cddda8",
  "ticketCover@SFAnytime@120@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=120&w=120&fm=png&bg=171717&fit=crop&s=f0c8262bfe05ab3db3a40a6a8698767b",
  "ticketCover@SFAnytime@128@@": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=128&fm=png&bg=00000000&s=d6bd5a237e8d2f5b72ef18f3a1087ec1",
  "ticketCover@SFAnytime@128@@16x9": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=128&w=228&fm=png&bg=00000000&fit=crop&s=d14150920d7ba630963a3ccec0477687",
  "ticketCover@SFAnytime@128@@1x1": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=128&w=128&fm=png&bg=00000000&fit=crop&s=83e1d9a5dd616f63f2d8b12bb02a0f37",
  "ticketCover@SFAnytime@128@backdrop@": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=128&fm=png&bg=171717&s=796a8a1b3dd2b31d696061e98972104e",
  "ticketCover@SFAnytime@128@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=128&w=228&fm=png&bg=171717&fit=crop&s=70315efa35f9f6dfd7cce82f1eb5aaf4",
  "ticketCover@SFAnytime@128@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=128&w=128&fm=png&bg=171717&fit=crop&s=884172f0c37e447ff26eb75ed82d0e79",
  "ticketCover@SFAnytime@180@@": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=180&fm=png&bg=00000000&s=593af29a00eef9a05e2d6ba1c28729fc",
  "ticketCover@SFAnytime@180@@16x9": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=180&w=320&fm=png&bg=00000000&fit=crop&s=0d7975e3450564852b6cbebb40a14d9f",
  "ticketCover@SFAnytime@180@@1x1": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=180&w=180&fm=png&bg=00000000&fit=crop&s=ef1e446819384816365c257bd86a4723",
  "ticketCover@SFAnytime@180@backdrop@": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=180&fm=png&bg=171717&s=b635b5d5659bd9520ce65543045a8547",
  "ticketCover@SFAnytime@180@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=180&w=320&fm=png&bg=171717&fit=crop&s=3d4a9c9e2ebcddd8d2fe18d189c43099",
  "ticketCover@SFAnytime@180@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=180&w=180&fm=png&bg=171717&fit=crop&s=6791cecce1b5dc0f4de370449d163cd6",
  "ticketCover@SFAnytime@256@@": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=256&fm=png&bg=00000000&s=50b84af3c099b4d8aba5531385098da7",
  "ticketCover@SFAnytime@256@@16x9": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=256&w=455&fm=png&bg=00000000&fit=crop&s=c910689765b8ea4bbe248ff0a1436390",
  "ticketCover@SFAnytime@256@@1x1": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=256&w=256&fm=png&bg=00000000&fit=crop&s=c3c1bd104476316108016f1832e0a252",
  "ticketCover@SFAnytime@256@backdrop@": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=256&fm=png&bg=171717&s=0de5b8a6a15e5d3e0d9589fbf6e8deed",
  "ticketCover@SFAnytime@256@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=256&w=455&fm=png&bg=171717&fit=crop&s=c73e3ab927a8fa1c81baa6690233a467",
  "ticketCover@SFAnytime@256@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=256&w=256&fm=png&bg=171717&fit=crop&s=c0af0863f3f4d3bdf2cc260d33c8de4b",
  "ticketCover@SFAnytime@512@@": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=512&fm=png&bg=00000000&s=99917338a168ef970dff08567fc119bb",
  "ticketCover@SFAnytime@512@@16x9": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=512&w=910&fm=png&bg=00000000&fit=crop&s=0059a4b6faf485f94b8f146a2d250317",
  "ticketCover@SFAnytime@512@@1x1": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=512&w=512&fm=png&bg=00000000&fit=crop&s=9e24876ef6fcede7a444d9435f8ec50f",
  "ticketCover@SFAnytime@512@backdrop@": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=512&fm=png&bg=171717&s=705c6e6113f2e2a7edd1bebcba7a3f0f",
  "ticketCover@SFAnytime@512@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=512&w=910&fm=png&bg=171717&fit=crop&s=3df1790eb327aafdcd565aa5f04d0677",
  "ticketCover@SFAnytime@512@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=512&w=512&fm=png&bg=171717&fit=crop&s=7e1807589fb1ce38b0439be5eb22d45f",
  "ticketCover@SFAnytime@1024@@": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=1024&fm=png&bg=00000000&s=2e288dfefbea4969c07c88288db27af2",
  "ticketCover@SFAnytime@1024@@16x9": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=1024&w=1820&fm=png&bg=00000000&fit=crop&s=b8b8733c43c89fcaeac3b3b34df0d724",
  "ticketCover@SFAnytime@1024@@1x1": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=1024&w=1024&fm=png&bg=00000000&fit=crop&s=eb4b7c9698dbe2495758e4634f4ea7e2",
  "ticketCover@SFAnytime@1024@backdrop@": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=1024&fm=png&bg=171717&s=b4250dbbcd94757e9e965b1511b477b6",
  "ticketCover@SFAnytime@1024@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=1024&w=1820&fm=png&bg=171717&fit=crop&s=bc1e4445f157ad4c8e7848b17085b1c3",
  "ticketCover@SFAnytime@1024@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/TICKET_COVER_bebeb1e802a23a6c651bb46d497801a4.png?h=1024&w=1024&fm=png&bg=171717&fit=crop&s=19e3a0cfb62d7ee419fca37d57fd6215",
  "appStore@SFAnytime@16@@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=16&fm=svg&bg=00000000&s=a07391f6b0793809298d79c17beae9c8",
  "appStore@SFAnytime@16@@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=16&w=28&fm=svg&bg=00000000&fit=crop&s=a0f29381fbb5c186c59e21aa0d89da9a",
  "appStore@SFAnytime@16@@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=16&w=16&fm=svg&bg=00000000&fit=crop&s=b2b7ea6a728dfc2f098fb02cf8b252a3",
  "appStore@SFAnytime@16@backdrop@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=16&fm=svg&bg=171717&s=8338d9c526465c8257c8b42d46b65586",
  "appStore@SFAnytime@16@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=16&w=28&fm=svg&bg=171717&fit=crop&s=62127087fc77f7154f5c01e1f57fb518",
  "appStore@SFAnytime@16@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=16&w=16&fm=svg&bg=171717&fit=crop&s=3fcd278e2f58eaf1a4eeceaad0d0ae2c",
  "appStore@SFAnytime@32@@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=32&fm=svg&bg=00000000&s=8c2ea711c84e7852fe874b700c31cd57",
  "appStore@SFAnytime@32@@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=32&w=57&fm=svg&bg=00000000&fit=crop&s=ee62672cb384262e107eaae3e00f5224",
  "appStore@SFAnytime@32@@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=32&w=32&fm=svg&bg=00000000&fit=crop&s=2746e03c5d3a901f87460b80abeb1a96",
  "appStore@SFAnytime@32@backdrop@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=32&fm=svg&bg=171717&s=a5952e39245322b125a4ddd65f4b6f7f",
  "appStore@SFAnytime@32@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=32&w=57&fm=svg&bg=171717&fit=crop&s=15d410a1b2b5956f82c6caa687989898",
  "appStore@SFAnytime@32@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=32&w=32&fm=svg&bg=171717&fit=crop&s=1977fff336e2cd976768b8e42c431527",
  "appStore@SFAnytime@64@@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=64&fm=svg&bg=00000000&s=cdd69aee556036a04a55a9cf6c09e997",
  "appStore@SFAnytime@64@@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=64&w=114&fm=svg&bg=00000000&fit=crop&s=f8ab946b1c9e919a07c439d0219d6252",
  "appStore@SFAnytime@64@@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=64&w=64&fm=svg&bg=00000000&fit=crop&s=ae75615e751c3900ed3d57196d425527",
  "appStore@SFAnytime@64@backdrop@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=64&fm=svg&bg=171717&s=b67fcfafdaf645c78210ab04120f9c25",
  "appStore@SFAnytime@64@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=64&w=114&fm=svg&bg=171717&fit=crop&s=678bfa9cf03e2b9c6e8daf59a836bac8",
  "appStore@SFAnytime@64@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=64&w=64&fm=svg&bg=171717&fit=crop&s=c8f4578775c631891b8d933a0a7d7fb5",
  "appStore@SFAnytime@120@@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=120&fm=svg&bg=00000000&s=03e4e99e3534208dee2f3fe13005df94",
  "appStore@SFAnytime@120@@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=120&w=213&fm=svg&bg=00000000&fit=crop&s=1349eacb901d2ef9e27747487b9fe328",
  "appStore@SFAnytime@120@@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=120&w=120&fm=svg&bg=00000000&fit=crop&s=e269f5dd5af291c5cdfe2e9cc88dec26",
  "appStore@SFAnytime@120@backdrop@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=120&fm=svg&bg=171717&s=170b023969378749104de3df24e2c2df",
  "appStore@SFAnytime@120@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=120&w=213&fm=svg&bg=171717&fit=crop&s=5e1ffe1e4b8e6b3b6c14d2adea3ba4c0",
  "appStore@SFAnytime@120@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=120&w=120&fm=svg&bg=171717&fit=crop&s=916f55253b77faef24cd6fae3d9637b2",
  "appStore@SFAnytime@128@@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=128&fm=svg&bg=00000000&s=5821456cc03f818b5a055d596ddc6e99",
  "appStore@SFAnytime@128@@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=128&w=228&fm=svg&bg=00000000&fit=crop&s=0cb1af7886ea139fd4926872b3ca1ca9",
  "appStore@SFAnytime@128@@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=128&w=128&fm=svg&bg=00000000&fit=crop&s=61e0c6047d25b783160df7ad28212810",
  "appStore@SFAnytime@128@backdrop@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=128&fm=svg&bg=171717&s=0e6da925834a2291febdf3ea858730a8",
  "appStore@SFAnytime@128@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=128&w=228&fm=svg&bg=171717&fit=crop&s=f0d06755ec404942a2b40935ff45743e",
  "appStore@SFAnytime@128@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=128&w=128&fm=svg&bg=171717&fit=crop&s=f936500f51856894bbc045db885bc14d",
  "appStore@SFAnytime@180@@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=180&fm=svg&bg=00000000&s=2fc51b47580194192f960386ddccde78",
  "appStore@SFAnytime@180@@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=180&w=320&fm=svg&bg=00000000&fit=crop&s=4b58a8768348d14f7d73cb55cef0c880",
  "appStore@SFAnytime@180@@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=180&w=180&fm=svg&bg=00000000&fit=crop&s=ed68c046da358fbc7031c26c2f9b9f5d",
  "appStore@SFAnytime@180@backdrop@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=180&fm=svg&bg=171717&s=093606c7aabb77c8654565937388e6cc",
  "appStore@SFAnytime@180@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=180&w=320&fm=svg&bg=171717&fit=crop&s=d87c998cad6d528d7634220fb6389277",
  "appStore@SFAnytime@180@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=180&w=180&fm=svg&bg=171717&fit=crop&s=b152e73a485898c86d4262f6d62e45df",
  "appStore@SFAnytime@256@@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=256&fm=svg&bg=00000000&s=41d7a82da5e9c2c7d4c2b77d873646c8",
  "appStore@SFAnytime@256@@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=256&w=455&fm=svg&bg=00000000&fit=crop&s=7ce7101fb061aa7467b7fe4be7454f3c",
  "appStore@SFAnytime@256@@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=256&w=256&fm=svg&bg=00000000&fit=crop&s=244b480050ea61d11459a1d7fd0ac6be",
  "appStore@SFAnytime@256@backdrop@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=256&fm=svg&bg=171717&s=597b50660cb4b863e9d14e8509dafa81",
  "appStore@SFAnytime@256@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=256&w=455&fm=svg&bg=171717&fit=crop&s=c4314499580f9d6d73d84752214224ed",
  "appStore@SFAnytime@256@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=256&w=256&fm=svg&bg=171717&fit=crop&s=e9d6e44126b1e2f6ea043901b3be0b4d",
  "appStore@SFAnytime@512@@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=512&fm=svg&bg=00000000&s=415cfa68e82edee690f0c4203e73fd9e",
  "appStore@SFAnytime@512@@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=512&w=910&fm=svg&bg=00000000&fit=crop&s=cb77d112826f42ffc14acb360910cf31",
  "appStore@SFAnytime@512@@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=512&w=512&fm=svg&bg=00000000&fit=crop&s=27858e8fbecad6c56de19ae89b2d7705",
  "appStore@SFAnytime@512@backdrop@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=512&fm=svg&bg=171717&s=76054816dbf8ecb201727cc8c2816e1b",
  "appStore@SFAnytime@512@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=512&w=910&fm=svg&bg=171717&fit=crop&s=636fc504b9c8a901e2a1501113a79834",
  "appStore@SFAnytime@512@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=512&w=512&fm=svg&bg=171717&fit=crop&s=0e7ccf40449166542a700ac8614acac7",
  "appStore@SFAnytime@1024@@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=1024&fm=svg&bg=00000000&s=4c32f2d3a418238df9ffe550e6594f49",
  "appStore@SFAnytime@1024@@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=1024&w=1820&fm=svg&bg=00000000&fit=crop&s=6095621822c5f293e079c0b714c2cd6f",
  "appStore@SFAnytime@1024@@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=1024&w=1024&fm=svg&bg=00000000&fit=crop&s=b5ab6b1913f965ccec4e7c7c6fb76584",
  "appStore@SFAnytime@1024@backdrop@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=1024&fm=svg&bg=171717&s=2a0f75f64fe93f446589957454a28c9a",
  "appStore@SFAnytime@1024@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=1024&w=1820&fm=svg&bg=171717&fit=crop&s=a4b7e6a363c23876f4e28836b5e3b4ef",
  "appStore@SFAnytime@1024@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_APPLE_EN_6ad869e89594529934e4e936dc966302656e7e74fbbd653012e47d1e61fc607b.svg?h=1024&w=1024&fm=svg&bg=171717&fit=crop&s=cbb2c2cf2079b2d00cdb63cae07e7598",
  "googlePlay@SFAnytime@16@@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=16&fm=svg&bg=00000000&s=762b23585ef713f6f5bfb9b74fd8fd02",
  "googlePlay@SFAnytime@16@@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=16&w=28&fm=svg&bg=00000000&fit=crop&s=31bd115956b70d3aea311c6f34e800cd",
  "googlePlay@SFAnytime@16@@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=16&w=16&fm=svg&bg=00000000&fit=crop&s=a28147c88fb2c6717cf074b699b5f312",
  "googlePlay@SFAnytime@16@backdrop@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=16&fm=svg&bg=171717&s=d91f05a03a563e672b7418c4d1e96592",
  "googlePlay@SFAnytime@16@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=16&w=28&fm=svg&bg=171717&fit=crop&s=201cb7019c3a88f646eab54b1b82f055",
  "googlePlay@SFAnytime@16@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=16&w=16&fm=svg&bg=171717&fit=crop&s=059821e7d9f14a7bbe604a141d938ace",
  "googlePlay@SFAnytime@32@@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=32&fm=svg&bg=00000000&s=77de33df5b54fcbbe1cd2fbc4a2c6e96",
  "googlePlay@SFAnytime@32@@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=32&w=57&fm=svg&bg=00000000&fit=crop&s=76d660bdca3b176823d050d786a59efb",
  "googlePlay@SFAnytime@32@@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=32&w=32&fm=svg&bg=00000000&fit=crop&s=390e8ed78f6ada9d6374b7d39f8595a5",
  "googlePlay@SFAnytime@32@backdrop@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=32&fm=svg&bg=171717&s=0625d5224a5f6594e027280e1c96331b",
  "googlePlay@SFAnytime@32@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=32&w=57&fm=svg&bg=171717&fit=crop&s=d106aaea08f5154ae6b0daba2dc998fb",
  "googlePlay@SFAnytime@32@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=32&w=32&fm=svg&bg=171717&fit=crop&s=3ed70aa615b28a5b544988be25cd87b4",
  "googlePlay@SFAnytime@64@@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=64&fm=svg&bg=00000000&s=b1f1ce5ee0b9bf173e10e5a85025fbe9",
  "googlePlay@SFAnytime@64@@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=64&w=114&fm=svg&bg=00000000&fit=crop&s=ca8ec229e543d2f2c37f22c4d3d0e835",
  "googlePlay@SFAnytime@64@@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=64&w=64&fm=svg&bg=00000000&fit=crop&s=e66a24d1355af635bbbb8a049bbb99bd",
  "googlePlay@SFAnytime@64@backdrop@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=64&fm=svg&bg=171717&s=ddceb312a7d990893b9d34a99b85e13d",
  "googlePlay@SFAnytime@64@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=64&w=114&fm=svg&bg=171717&fit=crop&s=1e06027bf2907a2a658ed9a7b8df5d78",
  "googlePlay@SFAnytime@64@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=64&w=64&fm=svg&bg=171717&fit=crop&s=798163b70fd1c664db6dc2a006de8df5",
  "googlePlay@SFAnytime@120@@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=120&fm=svg&bg=00000000&s=b2be1c89e7bdfced045e1af621b6a7c5",
  "googlePlay@SFAnytime@120@@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=120&w=213&fm=svg&bg=00000000&fit=crop&s=44c210fc627dd11d57b3ab7a6b2190d1",
  "googlePlay@SFAnytime@120@@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=120&w=120&fm=svg&bg=00000000&fit=crop&s=365dd69714063a0baf70d05d003d5a7c",
  "googlePlay@SFAnytime@120@backdrop@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=120&fm=svg&bg=171717&s=1c910d5a9fb5120675cc82a0705d5238",
  "googlePlay@SFAnytime@120@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=120&w=213&fm=svg&bg=171717&fit=crop&s=74f103220437d7238acac51a6a3823b3",
  "googlePlay@SFAnytime@120@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=120&w=120&fm=svg&bg=171717&fit=crop&s=ce2a9162396521051efd072a586f407a",
  "googlePlay@SFAnytime@128@@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=128&fm=svg&bg=00000000&s=ab81ded67fb210a5f00573c166f5cebc",
  "googlePlay@SFAnytime@128@@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=128&w=228&fm=svg&bg=00000000&fit=crop&s=4fcd0abbd9d147b62935757dbefb0b19",
  "googlePlay@SFAnytime@128@@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=128&w=128&fm=svg&bg=00000000&fit=crop&s=84fa6a2655f1ff0aa4c30ee5fe5316b4",
  "googlePlay@SFAnytime@128@backdrop@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=128&fm=svg&bg=171717&s=b51a6081b99c1a6e6df5409d697f29b1",
  "googlePlay@SFAnytime@128@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=128&w=228&fm=svg&bg=171717&fit=crop&s=47558f9745c27baf499eb636c1b0b424",
  "googlePlay@SFAnytime@128@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=128&w=128&fm=svg&bg=171717&fit=crop&s=7866b537a1f02e5418842a6d3f7f559e",
  "googlePlay@SFAnytime@180@@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=180&fm=svg&bg=00000000&s=174960195252bacaa36bf9cadd4c7cc5",
  "googlePlay@SFAnytime@180@@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=180&w=320&fm=svg&bg=00000000&fit=crop&s=fca789dae0c40396ff769bfb7eddfd3e",
  "googlePlay@SFAnytime@180@@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=180&w=180&fm=svg&bg=00000000&fit=crop&s=39e831164b6c4ab3f23e6ec0734a1a83",
  "googlePlay@SFAnytime@180@backdrop@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=180&fm=svg&bg=171717&s=255a62cb39c81a9631ba619e776ca1dd",
  "googlePlay@SFAnytime@180@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=180&w=320&fm=svg&bg=171717&fit=crop&s=53acb8f56e7638dbbfa58f89697edc82",
  "googlePlay@SFAnytime@180@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=180&w=180&fm=svg&bg=171717&fit=crop&s=eb8e1c172c5417b1b68bc0f9f7da135e",
  "googlePlay@SFAnytime@256@@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=256&fm=svg&bg=00000000&s=cd7e210ecb85c193a2ecb1bd0f300c78",
  "googlePlay@SFAnytime@256@@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=256&w=455&fm=svg&bg=00000000&fit=crop&s=a36819c1b9792d209292c070d7bf9e88",
  "googlePlay@SFAnytime@256@@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=256&w=256&fm=svg&bg=00000000&fit=crop&s=86cc9719d809a9df94b78a870523141e",
  "googlePlay@SFAnytime@256@backdrop@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=256&fm=svg&bg=171717&s=72bf1c165d2c48c6779d40464c036c28",
  "googlePlay@SFAnytime@256@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=256&w=455&fm=svg&bg=171717&fit=crop&s=8c867ac19f46316d00c2d2a729c38ddf",
  "googlePlay@SFAnytime@256@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=256&w=256&fm=svg&bg=171717&fit=crop&s=e01e1089b38018037a2676a864ecab4b",
  "googlePlay@SFAnytime@512@@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=512&fm=svg&bg=00000000&s=605b92b8aadd0a5a51a7e49a2893531a",
  "googlePlay@SFAnytime@512@@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=512&w=910&fm=svg&bg=00000000&fit=crop&s=ddb9073381ca872d356fba033a1e6845",
  "googlePlay@SFAnytime@512@@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=512&w=512&fm=svg&bg=00000000&fit=crop&s=f8511fc9e1acdd31275bd6ccbdc552e7",
  "googlePlay@SFAnytime@512@backdrop@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=512&fm=svg&bg=171717&s=842a4df438c44660709230b51efedca4",
  "googlePlay@SFAnytime@512@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=512&w=910&fm=svg&bg=171717&fit=crop&s=0c9651b4edc329261e1a54b462f7e8c4",
  "googlePlay@SFAnytime@512@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=512&w=512&fm=svg&bg=171717&fit=crop&s=ae71e45f7c4906dc81bca2578749703b",
  "googlePlay@SFAnytime@1024@@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=1024&fm=svg&bg=00000000&s=564bc39eebc25b7b6f8f9dc6c5f5cadf",
  "googlePlay@SFAnytime@1024@@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=1024&w=1820&fm=svg&bg=00000000&fit=crop&s=258389b45d1cf13c275550720fe83894",
  "googlePlay@SFAnytime@1024@@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=1024&w=1024&fm=svg&bg=00000000&fit=crop&s=88f121c575da6805fec573c55e826c27",
  "googlePlay@SFAnytime@1024@backdrop@": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=1024&fm=svg&bg=171717&s=093b37ef6f313f9099e6674e1b6523ea",
  "googlePlay@SFAnytime@1024@backdrop@16x9": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=1024&w=1820&fm=svg&bg=171717&fit=crop&s=3ece7d9e233116d026080ece0b169180",
  "googlePlay@SFAnytime@1024@backdrop@1x1": "https://img-cdn.sfanytime.com/APP/STORE_BADGE_GOOGLE_EN_07c85592067cd02ad4447f667ee84af3bce6a2a727369c11bc2f6785c51c6c08.svg?h=1024&w=1024&fm=svg&bg=171717&fit=crop&s=a129a46130c480811b334580859712da"
};

// src/~assets/helpers.ts
var cdnAssetUrls = cdn_asset_urls_default;
var assetKeys = Object.keys(assetTypes);
var aliases = Object.values(assetTypes).map((a) => a.aliases).flat();
var getCdnJsonKey = (asset) => {
  const _a = asset, { name } = _a, options = __objRest(_a, ["name"]);
  const assetKey = getAssetKey(name);
  const optionKeys = keysUsedForCdnUrl.map((key3) => options[key3]);
  return [assetKey, ...optionKeys].join("@");
};
var getCdnAsset = (asset) => {
  const cdnJsonKey = getCdnJsonKey(asset);
  const cdnAsset = cdnAssetUrls[cdnJsonKey];
  if (!cdnAsset) {
    throw Error(
      `No cached asset found for ${cdnJsonKey}. Make sure all assets are generated and you are using a supported size.`
    );
  }
  return cdnAsset;
};
var aliasMap = (() => {
  const map = {};
  for (const assetKey of assetKeys) {
    for (const alias of assetTypes[assetKey].aliases) {
      map[alias] = assetKey;
    }
  }
  return map;
})();
var getAssetKey = (name) => isAlias(name) ? aliasMap[name] : name;
var getAssetSrc = ({ brand, name }) => {
  const assetKey = getAssetKey(name);
  return assets[brand][assetKey];
};
var isAlias = (name) => {
  return aliases.includes(name);
};

// src/~client/cache/cacheUtils.ts
import base64 from "base-64";
import merge2 from "lodash/merge";
import uniqBy from "lodash/uniqBy";

// src/~utils/entitlementUtils/entitlementUtils.ts
var isRented = ({ slug: slug3, entitlements: entitlements2 }) => {
  const entitlement = entitlements2.find((e) => e.slug === slug3);
  if (entitlement) {
    return !entitlement.isEst;
  }
  return false;
};
var isBought = ({ slug: slug3, entitlements: entitlements2 }) => {
  const entitlement = entitlements2.find((e) => e.slug === slug3);
  if (entitlement) {
    return entitlement.isEst;
  }
  return false;
};

// src/~utils/graphqlUtils/graphqlUtils.ts
var extractErrorMessage = (error) => error.message;

// src/~utils/logger/ShakaLogger/shakaTypes.ts
var Severity = /* @__PURE__ */ ((Severity2) => {
  Severity2[Severity2["RECOVERABLE"] = 1] = "RECOVERABLE";
  Severity2[Severity2["CRITICAL"] = 2] = "CRITICAL";
  return Severity2;
})(Severity || {});
var ShakaEVENT = /* @__PURE__ */ ((ShakaEVENT2) => {
  ShakaEVENT2["ERROR"] = "error";
  ShakaEVENT2["ERROR_MESSAGE"] = "emsg";
  ShakaEVENT2["DRM_SESSION_UPDATE"] = "drmsessionupdate";
  ShakaEVENT2["TIMELINE_REGION_ADDED"] = "timelineregionadded";
  ShakaEVENT2["TIMELINE_REGION_ENTER"] = "timelineregionenter";
  ShakaEVENT2["TIMELINE_REGION_EXIT"] = "timelineregionexit";
  ShakaEVENT2["BUFFERING"] = "buffering";
  ShakaEVENT2["LOADING"] = "loading";
  ShakaEVENT2["UNLOADING"] = "unloading";
  ShakaEVENT2["TEXTTRACK_VISIBILITY"] = "texttrackvisibility";
  ShakaEVENT2["TRACKS_CHANGED"] = "trackschanged";
  ShakaEVENT2["ADOPTATION"] = "adaptation";
  ShakaEVENT2["EXPIRATION_UPDATED"] = "expirationupdated";
  ShakaEVENT2["LARGE_GAP"] = "largegap";
  ShakaEVENT2["STREAMING"] = "streaming";
  return ShakaEVENT2;
})(ShakaEVENT || {});
var ShakaRequestType = /* @__PURE__ */ ((ShakaRequestType2) => {
  ShakaRequestType2["MANIFEST"] = "shaka-manifest";
  ShakaRequestType2["SEGMENT"] = "shaka-segment";
  ShakaRequestType2["LICENSE"] = "shaka-license";
  ShakaRequestType2["APP"] = "shaka-app";
  ShakaRequestType2["UNKNOWN"] = "shaka-unknown";
  return ShakaRequestType2;
})(ShakaRequestType || {});
var ShakaErrorSeverity = /* @__PURE__ */ ((ShakaErrorSeverity3) => {
  ShakaErrorSeverity3[ShakaErrorSeverity3["RECOVERABLE"] = 1] = "RECOVERABLE";
  ShakaErrorSeverity3[ShakaErrorSeverity3["CRITICAL"] = 2] = "CRITICAL";
  return ShakaErrorSeverity3;
})(ShakaErrorSeverity || {});
var ShakaErrorTypes = /* @__PURE__ */ ((ShakaErrorTypes2) => {
  ShakaErrorTypes2[ShakaErrorTypes2["NETWORK"] = 1] = "NETWORK";
  ShakaErrorTypes2[ShakaErrorTypes2["TEXT"] = 2] = "TEXT";
  ShakaErrorTypes2[ShakaErrorTypes2["MEDIA"] = 3] = "MEDIA";
  ShakaErrorTypes2[ShakaErrorTypes2["MANIFEST"] = 4] = "MANIFEST";
  ShakaErrorTypes2[ShakaErrorTypes2["STREAMING"] = 5] = "STREAMING";
  ShakaErrorTypes2[ShakaErrorTypes2["DRM"] = 6] = "DRM";
  ShakaErrorTypes2[ShakaErrorTypes2["PLAYER"] = 7] = "PLAYER";
  ShakaErrorTypes2[ShakaErrorTypes2["CAST"] = 8] = "CAST";
  ShakaErrorTypes2[ShakaErrorTypes2["STORAGE"] = 9] = "STORAGE";
  return ShakaErrorTypes2;
})(ShakaErrorTypes || {});
var ShakaErrorCodes = /* @__PURE__ */ ((ShakaErrorCodes2) => {
  ShakaErrorCodes2[ShakaErrorCodes2["UNSUPPORTED_SCHEME"] = 1e3] = "UNSUPPORTED_SCHEME";
  ShakaErrorCodes2[ShakaErrorCodes2["BAD_HTTP_STATUS"] = 1001] = "BAD_HTTP_STATUS";
  ShakaErrorCodes2[ShakaErrorCodes2["HTTP_ERROR"] = 1002] = "HTTP_ERROR";
  ShakaErrorCodes2[ShakaErrorCodes2["TIMEOUT"] = 1003] = "TIMEOUT";
  ShakaErrorCodes2[ShakaErrorCodes2["MALFORMED_DATA_URI"] = 1004] = "MALFORMED_DATA_URI";
  ShakaErrorCodes2[ShakaErrorCodes2["UNKNOWN_DATA_URI_ENCODING"] = 1005] = "UNKNOWN_DATA_URI_ENCODING";
  ShakaErrorCodes2[ShakaErrorCodes2["REQUEST_FILTER_ERROR"] = 1006] = "REQUEST_FILTER_ERROR";
  ShakaErrorCodes2[ShakaErrorCodes2["RESPONSE_FILTER_ERROR"] = 1007] = "RESPONSE_FILTER_ERROR";
  ShakaErrorCodes2[ShakaErrorCodes2["MALFORMED_TEST_URI"] = 1008] = "MALFORMED_TEST_URI";
  ShakaErrorCodes2[ShakaErrorCodes2["UNEXPECTED_TEST_REQUEST"] = 1009] = "UNEXPECTED_TEST_REQUEST";
  ShakaErrorCodes2[ShakaErrorCodes2["INVALID_TEXT_HEADER"] = 2e3] = "INVALID_TEXT_HEADER";
  ShakaErrorCodes2[ShakaErrorCodes2["INVALID_TEXT_CUE"] = 2001] = "INVALID_TEXT_CUE";
  ShakaErrorCodes2[ShakaErrorCodes2["UNABLE_TO_DETECT_ENCODING"] = 2003] = "UNABLE_TO_DETECT_ENCODING";
  ShakaErrorCodes2[ShakaErrorCodes2["BAD_ENCODING"] = 2004] = "BAD_ENCODING";
  ShakaErrorCodes2[ShakaErrorCodes2["INVALID_XML"] = 2005] = "INVALID_XML";
  ShakaErrorCodes2[ShakaErrorCodes2["INVALID_MP4_TTML"] = 2007] = "INVALID_MP4_TTML";
  ShakaErrorCodes2[ShakaErrorCodes2["INVALID_MP4_VTT"] = 2008] = "INVALID_MP4_VTT";
  ShakaErrorCodes2[ShakaErrorCodes2["UNABLE_TO_EXTRACT_CUE_START_TIME"] = 2009] = "UNABLE_TO_EXTRACT_CUE_START_TIME";
  ShakaErrorCodes2[ShakaErrorCodes2["BUFFER_READ_OUT_OF_BOUNDS"] = 3e3] = "BUFFER_READ_OUT_OF_BOUNDS";
  ShakaErrorCodes2[ShakaErrorCodes2["JS_INTEGER_OVERFLOW"] = 3001] = "JS_INTEGER_OVERFLOW";
  ShakaErrorCodes2[ShakaErrorCodes2["EBML_OVERFLOW"] = 3002] = "EBML_OVERFLOW";
  ShakaErrorCodes2[ShakaErrorCodes2["EBML_BAD_FLOATING_POINT_SIZE"] = 3003] = "EBML_BAD_FLOATING_POINT_SIZE";
  ShakaErrorCodes2[ShakaErrorCodes2["MP4_SIDX_WRONG_BOX_TYPE"] = 3004] = "MP4_SIDX_WRONG_BOX_TYPE";
  ShakaErrorCodes2[ShakaErrorCodes2["MP4_SIDX_INVALID_TIMESCALE"] = 3005] = "MP4_SIDX_INVALID_TIMESCALE";
  ShakaErrorCodes2[ShakaErrorCodes2["MP4_SIDX_TYPE_NOT_SUPPORTED"] = 3006] = "MP4_SIDX_TYPE_NOT_SUPPORTED";
  ShakaErrorCodes2[ShakaErrorCodes2["WEBM_CUES_ELEMENT_MISSING"] = 3007] = "WEBM_CUES_ELEMENT_MISSING";
  ShakaErrorCodes2[ShakaErrorCodes2["WEBM_EBML_HEADER_ELEMENT_MISSING"] = 3008] = "WEBM_EBML_HEADER_ELEMENT_MISSING";
  ShakaErrorCodes2[ShakaErrorCodes2["WEBM_SEGMENT_ELEMENT_MISSING"] = 3009] = "WEBM_SEGMENT_ELEMENT_MISSING";
  ShakaErrorCodes2[ShakaErrorCodes2["WEBM_INFO_ELEMENT_MISSING"] = 3010] = "WEBM_INFO_ELEMENT_MISSING";
  ShakaErrorCodes2[ShakaErrorCodes2["WEBM_DURATION_ELEMENT_MISSING"] = 3011] = "WEBM_DURATION_ELEMENT_MISSING";
  ShakaErrorCodes2[ShakaErrorCodes2["WEBM_CUE_TRACK_POSITIONS_ELEMENT_MISSING"] = 3012] = "WEBM_CUE_TRACK_POSITIONS_ELEMENT_MISSING";
  ShakaErrorCodes2[ShakaErrorCodes2["WEBM_CUE_TIME_ELEMENT_MISSING"] = 3013] = "WEBM_CUE_TIME_ELEMENT_MISSING";
  ShakaErrorCodes2[ShakaErrorCodes2["MEDIA_SOURCE_OPERATION_FAILED"] = 3014] = "MEDIA_SOURCE_OPERATION_FAILED";
  ShakaErrorCodes2[ShakaErrorCodes2["MEDIA_SOURCE_OPERATION_THREW"] = 3015] = "MEDIA_SOURCE_OPERATION_THREW";
  ShakaErrorCodes2[ShakaErrorCodes2["VIDEO_ERROR"] = 3016] = "VIDEO_ERROR";
  ShakaErrorCodes2[ShakaErrorCodes2["QUOTA_EXCEEDED_ERROR"] = 3017] = "QUOTA_EXCEEDED_ERROR";
  ShakaErrorCodes2[ShakaErrorCodes2["TRANSMUXING_FAILED"] = 3018] = "TRANSMUXING_FAILED";
  ShakaErrorCodes2[ShakaErrorCodes2["UNABLE_TO_GUESS_MANIFEST_TYPE"] = 4e3] = "UNABLE_TO_GUESS_MANIFEST_TYPE";
  ShakaErrorCodes2[ShakaErrorCodes2["DASH_INVALID_XML"] = 4001] = "DASH_INVALID_XML";
  ShakaErrorCodes2[ShakaErrorCodes2["DASH_NO_SEGMENT_INFO"] = 4002] = "DASH_NO_SEGMENT_INFO";
  ShakaErrorCodes2[ShakaErrorCodes2["DASH_EMPTY_ADAPTATION_SET"] = 4003] = "DASH_EMPTY_ADAPTATION_SET";
  ShakaErrorCodes2[ShakaErrorCodes2["DASH_EMPTY_PERIOD"] = 4004] = "DASH_EMPTY_PERIOD";
  ShakaErrorCodes2[ShakaErrorCodes2["DASH_WEBM_MISSING_INIT"] = 4005] = "DASH_WEBM_MISSING_INIT";
  ShakaErrorCodes2[ShakaErrorCodes2["DASH_UNSUPPORTED_CONTAINER"] = 4006] = "DASH_UNSUPPORTED_CONTAINER";
  ShakaErrorCodes2[ShakaErrorCodes2["DASH_PSSH_BAD_ENCODING"] = 4007] = "DASH_PSSH_BAD_ENCODING";
  ShakaErrorCodes2[ShakaErrorCodes2["DASH_NO_COMMON_KEY_SYSTEM"] = 4008] = "DASH_NO_COMMON_KEY_SYSTEM";
  ShakaErrorCodes2[ShakaErrorCodes2["DASH_MULTIPLE_KEY_IDS_NOT_SUPPORTED"] = 4009] = "DASH_MULTIPLE_KEY_IDS_NOT_SUPPORTED";
  ShakaErrorCodes2[ShakaErrorCodes2["DASH_CONFLICTING_KEY_IDS"] = 4010] = "DASH_CONFLICTING_KEY_IDS";
  ShakaErrorCodes2[ShakaErrorCodes2["UNPLAYABLE_PERIOD"] = 4011] = "UNPLAYABLE_PERIOD";
  ShakaErrorCodes2[ShakaErrorCodes2["RESTRICTIONS_CANNOT_BE_MET"] = 4012] = "RESTRICTIONS_CANNOT_BE_MET";
  ShakaErrorCodes2[ShakaErrorCodes2["NO_PERIODS"] = 4014] = "NO_PERIODS";
  ShakaErrorCodes2[ShakaErrorCodes2["HLS_PLAYLIST_HEADER_MISSING"] = 4015] = "HLS_PLAYLIST_HEADER_MISSING";
  ShakaErrorCodes2[ShakaErrorCodes2["INVALID_HLS_TAG"] = 4016] = "INVALID_HLS_TAG";
  ShakaErrorCodes2[ShakaErrorCodes2["HLS_INVALID_PLAYLIST_HIERARCHY"] = 4017] = "HLS_INVALID_PLAYLIST_HIERARCHY";
  ShakaErrorCodes2[ShakaErrorCodes2["DASH_DUPLICATE_REPRESENTATION_ID"] = 4018] = "DASH_DUPLICATE_REPRESENTATION_ID";
  ShakaErrorCodes2[ShakaErrorCodes2["HLS_MULTIPLE_MEDIA_INIT_SECTIONS_FOUND"] = 4020] = "HLS_MULTIPLE_MEDIA_INIT_SECTIONS_FOUND";
  ShakaErrorCodes2[ShakaErrorCodes2["HLS_COULD_NOT_GUESS_MIME_TYPE"] = 4021] = "HLS_COULD_NOT_GUESS_MIME_TYPE";
  ShakaErrorCodes2[ShakaErrorCodes2["HLS_MASTER_PLAYLIST_NOT_PROVIDED"] = 4022] = "HLS_MASTER_PLAYLIST_NOT_PROVIDED";
  ShakaErrorCodes2[ShakaErrorCodes2["HLS_REQUIRED_ATTRIBUTE_MISSING"] = 4023] = "HLS_REQUIRED_ATTRIBUTE_MISSING";
  ShakaErrorCodes2[ShakaErrorCodes2["HLS_REQUIRED_TAG_MISSING"] = 4024] = "HLS_REQUIRED_TAG_MISSING";
  ShakaErrorCodes2[ShakaErrorCodes2["HLS_COULD_NOT_GUESS_CODECS"] = 4025] = "HLS_COULD_NOT_GUESS_CODECS";
  ShakaErrorCodes2[ShakaErrorCodes2["HLS_KEYFORMATS_NOT_SUPPORTED"] = 4026] = "HLS_KEYFORMATS_NOT_SUPPORTED";
  ShakaErrorCodes2[ShakaErrorCodes2["DASH_UNSUPPORTED_XLINK_ACTUATE"] = 4027] = "DASH_UNSUPPORTED_XLINK_ACTUATE";
  ShakaErrorCodes2[ShakaErrorCodes2["DASH_XLINK_DEPTH_LIMIT"] = 4028] = "DASH_XLINK_DEPTH_LIMIT";
  ShakaErrorCodes2[ShakaErrorCodes2["HLS_COULD_NOT_PARSE_SEGMENT_START_TIME"] = 4030] = "HLS_COULD_NOT_PARSE_SEGMENT_START_TIME";
  ShakaErrorCodes2[ShakaErrorCodes2["CONTENT_UNSUPPORTED_BY_BROWSER"] = 4032] = "CONTENT_UNSUPPORTED_BY_BROWSER";
  ShakaErrorCodes2[ShakaErrorCodes2["CANNOT_ADD_EXTERNAL_TEXT_TO_LIVE_STREAM"] = 4033] = "CANNOT_ADD_EXTERNAL_TEXT_TO_LIVE_STREAM";
  ShakaErrorCodes2[ShakaErrorCodes2["INVALID_STREAMS_CHOSEN"] = 5005] = "INVALID_STREAMS_CHOSEN";
  ShakaErrorCodes2[ShakaErrorCodes2["NO_RECOGNIZED_KEY_SYSTEMS"] = 6e3] = "NO_RECOGNIZED_KEY_SYSTEMS";
  ShakaErrorCodes2[ShakaErrorCodes2["REQUESTED_KEY_SYSTEM_CONFIG_UNAVAILABLE"] = 6001] = "REQUESTED_KEY_SYSTEM_CONFIG_UNAVAILABLE";
  ShakaErrorCodes2[ShakaErrorCodes2["FAILED_TO_CREATE_CDM"] = 6002] = "FAILED_TO_CREATE_CDM";
  ShakaErrorCodes2[ShakaErrorCodes2["FAILED_TO_ATTACH_TO_VIDEO"] = 6003] = "FAILED_TO_ATTACH_TO_VIDEO";
  ShakaErrorCodes2[ShakaErrorCodes2["INVALID_SERVER_CERTIFICATE"] = 6004] = "INVALID_SERVER_CERTIFICATE";
  ShakaErrorCodes2[ShakaErrorCodes2["FAILED_TO_CREATE_SESSION"] = 6005] = "FAILED_TO_CREATE_SESSION";
  ShakaErrorCodes2[ShakaErrorCodes2["FAILED_TO_GENERATE_LICENSE_REQUEST"] = 6006] = "FAILED_TO_GENERATE_LICENSE_REQUEST";
  ShakaErrorCodes2[ShakaErrorCodes2["LICENSE_REQUEST_FAILED"] = 6007] = "LICENSE_REQUEST_FAILED";
  ShakaErrorCodes2[ShakaErrorCodes2["LICENSE_RESPONSE_REJECTED"] = 6008] = "LICENSE_RESPONSE_REJECTED";
  ShakaErrorCodes2[ShakaErrorCodes2["ENCRYPTED_CONTENT_WITHOUT_DRM_INFO"] = 6010] = "ENCRYPTED_CONTENT_WITHOUT_DRM_INFO";
  ShakaErrorCodes2[ShakaErrorCodes2["NO_LICENSE_SERVER_GIVEN"] = 6012] = "NO_LICENSE_SERVER_GIVEN";
  ShakaErrorCodes2[ShakaErrorCodes2["OFFLINE_SESSION_REMOVED"] = 6013] = "OFFLINE_SESSION_REMOVED";
  ShakaErrorCodes2[ShakaErrorCodes2["EXPIRED"] = 6014] = "EXPIRED";
  ShakaErrorCodes2[ShakaErrorCodes2["LOAD_INTERRUPTED"] = 7e3] = "LOAD_INTERRUPTED";
  ShakaErrorCodes2[ShakaErrorCodes2["OPERATION_ABORTED"] = 7001] = "OPERATION_ABORTED";
  ShakaErrorCodes2[ShakaErrorCodes2["NO_VIDEO_ELEMENT"] = 7002] = "NO_VIDEO_ELEMENT";
  ShakaErrorCodes2[ShakaErrorCodes2["CAST_API_UNAVAILABLE"] = 8e3] = "CAST_API_UNAVAILABLE";
  ShakaErrorCodes2[ShakaErrorCodes2["NO_CAST_RECEIVERS"] = 8001] = "NO_CAST_RECEIVERS";
  ShakaErrorCodes2[ShakaErrorCodes2["ALREADY_CASTING"] = 8002] = "ALREADY_CASTING";
  ShakaErrorCodes2[ShakaErrorCodes2["UNEXPECTED_CAST_ERROR"] = 8003] = "UNEXPECTED_CAST_ERROR";
  ShakaErrorCodes2[ShakaErrorCodes2["CAST_CANCELED_BY_USER"] = 8004] = "CAST_CANCELED_BY_USER";
  ShakaErrorCodes2[ShakaErrorCodes2["CAST_CONNECTION_TIMED_OUT"] = 8005] = "CAST_CONNECTION_TIMED_OUT";
  ShakaErrorCodes2[ShakaErrorCodes2["CAST_RECEIVER_APP_UNAVAILABLE"] = 8006] = "CAST_RECEIVER_APP_UNAVAILABLE";
  ShakaErrorCodes2[ShakaErrorCodes2["STORAGE_NOT_SUPPORTED"] = 9e3] = "STORAGE_NOT_SUPPORTED";
  ShakaErrorCodes2[ShakaErrorCodes2["INDEXED_DB_ERROR"] = 9001] = "INDEXED_DB_ERROR";
  ShakaErrorCodes2[ShakaErrorCodes2["DEPRECATED_OPERATION_ABORTED"] = 9002] = "DEPRECATED_OPERATION_ABORTED";
  ShakaErrorCodes2[ShakaErrorCodes2["REQUESTED_ITEM_NOT_FOUND"] = 9003] = "REQUESTED_ITEM_NOT_FOUND";
  ShakaErrorCodes2[ShakaErrorCodes2["MALFORMED_OFFLINE_URI"] = 9004] = "MALFORMED_OFFLINE_URI";
  ShakaErrorCodes2[ShakaErrorCodes2["CANNOT_STORE_LIVE_OFFLINE"] = 9005] = "CANNOT_STORE_LIVE_OFFLINE";
  ShakaErrorCodes2[ShakaErrorCodes2["STORE_ALREADY_IN_PROGRESS"] = 9006] = "STORE_ALREADY_IN_PROGRESS";
  ShakaErrorCodes2[ShakaErrorCodes2["NO_INIT_DATA_FOR_OFFLINE"] = 9007] = "NO_INIT_DATA_FOR_OFFLINE";
  ShakaErrorCodes2[ShakaErrorCodes2["LOCAL_PLAYER_INSTANCE_REQUIRED"] = 9008] = "LOCAL_PLAYER_INSTANCE_REQUIRED";
  ShakaErrorCodes2[ShakaErrorCodes2["NEW_KEY_OPERATION_NOT_SUPPORTED"] = 9011] = "NEW_KEY_OPERATION_NOT_SUPPORTED";
  ShakaErrorCodes2[ShakaErrorCodes2["KEY_NOT_FOUND"] = 9012] = "KEY_NOT_FOUND";
  ShakaErrorCodes2[ShakaErrorCodes2["MISSING_STORAGE_CELL"] = 9013] = "MISSING_STORAGE_CELL";
  return ShakaErrorCodes2;
})(ShakaErrorCodes || {});

// src/~utils/logger/ShakaLogger/errors.ts
var destroyCircular = (from, seen) => {
  const to = Array.isArray(from) ? [] : {};
  seen.push(from);
  for (const key3 of Object.keys(from)) {
    const value = from[key3];
    if (typeof value === "function") {
      continue;
    }
    if (!value || typeof value !== "object") {
      to[key3] = value;
      continue;
    }
    if (!seen.includes(from[key3])) {
      to[key3] = destroyCircular(from[key3], seen.slice());
      continue;
    }
    to[key3] = "[Circular]";
  }
  const commonProperties = ["name", "message", "stack", "code"];
  for (const property of commonProperties) {
    if (typeof from[property] === "string") {
      to[property] = from[property];
    }
  }
  return to;
};
var serializeError = (value) => {
  if (typeof value === "object") {
    return destroyCircular(value, []);
  }
  if (typeof value === "function") {
    return `[Function: ${value.name || "anonymous"}]`;
  }
  return value;
};
var Error2 = class {
  constructor(error, ...varArgs) {
    this.severity = null;
    this.category = null;
    this.code = null;
    this.data = null;
    this.handled = false;
    this.extraInfo = null;
    this.codeName = "UNKNOWN";
    this.categoryName = "UNKNOWN";
    const { severity, category, code } = error;
    this.severity = severity;
    this.category = category;
    this.code = code;
    this.data = serializeError(error.data);
    this.extraInfo = varArgs;
    this.categoryName = ShakaErrorTypes[this.category];
    this.codeName = ShakaErrorCodes[this.code];
  }
  toString() {
    return `ShakaError ${JSON.stringify(this, null, "  ")}`;
  }
  getShakaError() {
    return {
      severity: this.severity,
      category: this.category,
      categoryName: this.categoryName,
      code: this.code,
      codeName: this.codeName,
      data: this.data
    };
  }
};
var errors_default = Error2;

// src/~utils/logger/ShakaLogger/ShakaLogger.ts
var getShakaRequestType = (type2) => type2 || "shaka-unknown" /* UNKNOWN */;
var ShakaLogger = class {
  constructor({
    player,
    video,
    onLogEvent = () => {
    }
  }) {
    this.online = window.navigator.onLine;
    this.hadError = false;
    this.boundWindowEvents = [];
    this.boundPlayerEvents = [];
    this.boundVideoEvents = [];
    this.player = player;
    this.video = video;
    this.onLogEvent = onLogEvent;
    this.onPlayStateEvent = this.onPlayStateEvent.bind(this);
    this.onErrorEvent = this.onErrorEvent.bind(this);
    this.offlineStatusEvent = this.offlineStatusEvent.bind(this);
    this.onResponseEvent = this.onResponseEvent.bind(this);
    this.onAdaptationEvent = this.onAdaptationEvent.bind(this);
    this.onBufferingEvent = this.onBufferingEvent.bind(this);
    this.onDrmSessionUpdateEvent = this.onDrmSessionUpdateEvent.bind(this);
    this.onEmsgEvent = this.onEmsgEvent.bind(this);
    this.onExpirationUpdatedEvent = this.onExpirationUpdatedEvent.bind(this);
    this.onLargeGapEvent = this.onLargeGapEvent.bind(this);
    this.onLoadingEvent = this.onLoadingEvent.bind(this);
    this.onStreamingEvent = this.onStreamingEvent.bind(this);
    this.onTextTrackVisibilityEvent = this.onTextTrackVisibilityEvent.bind(this);
    this.onTimelineRegionAddedEvent = this.onTimelineRegionAddedEvent.bind(this);
    this.onTimelineRegionEnterEvent = this.onTimelineRegionEnterEvent.bind(this);
    this.onTimelineRegionExitEvent = this.onTimelineRegionExitEvent.bind(this);
    this.onTracksChangedEvent = this.onTracksChangedEvent.bind(this);
    this.onUnloadingEvent = this.onUnloadingEvent.bind(this);
    this.bindEventListeners();
  }
  bindEventListeners() {
    if (this.boundWindowEvents.length > 0 || this.boundVideoEvents.length > 0 || this.boundPlayerEvents.length > 0) {
      console.warn("Binding events before unbound events, unbinding..");
      this.unbindEventListeners();
    }
    const windowEvents = [
      ["error", this.onErrorEvent],
      ["online", this.offlineStatusEvent],
      ["offline", this.offlineStatusEvent]
    ];
    const videoEvents = [
      ["play", this.onPlayStateEvent],
      ["pause", this.onPlayStateEvent],
      // Since videos go into a paused state at the end, Chrome and Edge both fire
      // the 'pause' event when a video ends.  IE 11 only fires the 'ended' event.
      ["ended", this.onPlayStateEvent]
    ];
    const playerEvents = [
      ["adaptation" /* ADOPTATION */, this.onAdaptationEvent],
      ["buffering" /* BUFFERING */, this.onBufferingEvent],
      ["drmsessionupdate" /* DRM_SESSION_UPDATE */, this.onDrmSessionUpdateEvent],
      ["emsg" /* ERROR_MESSAGE */, this.onEmsgEvent],
      ["error" /* ERROR */, this.onErrorEvent],
      ["expirationupdated" /* EXPIRATION_UPDATED */, this.onExpirationUpdatedEvent],
      ["largegap" /* LARGE_GAP */, this.onLargeGapEvent],
      ["loading" /* LOADING */, this.onLoadingEvent],
      ["streaming" /* STREAMING */, this.onStreamingEvent],
      ["texttrackvisibility" /* TEXTTRACK_VISIBILITY */, this.onTextTrackVisibilityEvent],
      ["timelineregionadded" /* TIMELINE_REGION_ADDED */, this.onTimelineRegionAddedEvent],
      ["timelineregionenter" /* TIMELINE_REGION_ENTER */, this.onTimelineRegionEnterEvent],
      ["timelineregionexit" /* TIMELINE_REGION_EXIT */, this.onTimelineRegionExitEvent],
      ["trackschanged" /* TRACKS_CHANGED */, this.onTracksChangedEvent],
      ["unloading" /* UNLOADING */, this.onUnloadingEvent]
    ];
    windowEvents.forEach(([evt, fn]) => {
      window.addEventListener(evt, fn);
    });
    this.boundWindowEvents = windowEvents;
    videoEvents.forEach(([evt, fn]) => {
      this.video.addEventListener(evt, fn);
    });
    this.boundVideoEvents = videoEvents;
    playerEvents.forEach(([evt, fn]) => {
      this.player.addEventListener(evt, fn);
    });
    this.boundPlayerEvents = playerEvents;
  }
  unbindEventListeners() {
    if (this.boundWindowEvents.length === 0 || this.boundVideoEvents.length === 0 || this.boundPlayerEvents.length === 0) {
      console.warn("Unbinding events where no events are bound.");
      return;
    }
    this.boundWindowEvents.forEach(([evt, fn]) => {
      window.removeEventListener(evt, fn);
    });
    this.boundWindowEvents = [];
    this.boundVideoEvents.forEach(([evt, fn]) => {
      this.video.removeEventListener(evt, fn);
    });
    this.boundVideoEvents = [];
    this.boundPlayerEvents.forEach(([evt, fn]) => {
      this.player.removeEventListener(evt, fn);
    });
    this.boundPlayerEvents = [];
  }
  logEvent(event) {
    this.onLogEvent(__spreadProps(__spreadValues({}, event), {
      hadError: this.hadError,
      online: this.online,
      manifestUri: this.player.getAssetUri(),
      buffered: this.player.getBufferedInfo(),
      drmInfo: this.player.drmInfo(),
      playheadTimeAsDate: this.player.getPlayheadTimeAsDate(),
      stats: this.player.getStats(),
      currentTime: this.video.currentTime,
      duration: this.video.duration,
      timestamp: event.timeStamp || null
    }));
  }
  onResponseEvent(type2, response) {
    const evt = getShakaRequestType(type2);
    const { timeMs, fromCache } = response;
    if (evt === "shaka-segment" /* SEGMENT */ && timeMs < 2e3 && !fromCache) {
      return;
    }
    this.logEvent(__spreadValues({
      level: "info",
      evt
    }, response));
  }
  /**
   * [onAdaptationEvent]
   */
  onAdaptationEvent(event) {
    this.logEvent({
      level: "debug",
      evt: `shaka-${event.type}`
    });
  }
  /**
   * [onBufferingEvent]
   */
  onBufferingEvent(event) {
    this.logEvent({
      level: "debug",
      evt: `shaka-${event.type}`
    });
  }
  /**
   * [onDrmSessionUpdateEvent]
   */
  onDrmSessionUpdateEvent(event) {
    this.logEvent({
      level: "info",
      evt: `shaka-${event.type}`
    });
  }
  /**
   * [onEmsgEvent]
   */
  onEmsgEvent(event) {
    this.logEvent({
      level: "debug",
      evt: `shaka-${event.type}`
    });
  }
  /**
   * [onErrorEvent]
   */
  onErrorEvent(event) {
    this.hadError = true;
    const err = event.detail || event;
    if (err.severity == null) {
      err.severity = /** @type {shakautil.Error.Severity} */
      99;
    }
    const error = new errors_default(err, event);
    this.logEvent({
      level: "error",
      evt: `shaka-${event.type}`,
      error: error.getShakaError()
    });
  }
  /**
   * [onExpirationUpdatedEvent]
   */
  onExpirationUpdatedEvent(event) {
    this.logEvent({
      level: "debug",
      evt: `shaka-${event.type}`
    });
  }
  /**
   * [onLargeGapEvent]
   */
  onLargeGapEvent(event) {
    this.logEvent({
      level: "debug",
      evt: `shaka-${event.type}`
    });
  }
  /**
   * [onLoadingEvent]
   */
  onLoadingEvent(event) {
    this.logEvent({
      level: "debug",
      evt: `shaka-${event.type}`
    });
  }
  /**
   * [onStreamingEvent]
   */
  onStreamingEvent(event) {
    this.logEvent({
      level: "debug",
      evt: `shaka-${event.type}`
    });
  }
  /**
   * [onTextTrackVisibilityEvent]
   */
  onTextTrackVisibilityEvent(event) {
    this.logEvent({
      level: "debug",
      evt: `shaka-${event.type}`
    });
  }
  /**
   * [onTimelineRegionAddedEvent]
   */
  onTimelineRegionAddedEvent(event) {
    this.logEvent({
      level: "debug",
      evt: `shaka-${event.type}`
    });
  }
  /**
   * [onTimelineRegionEnterEvent]
   */
  onTimelineRegionEnterEvent(event) {
    this.logEvent({
      level: "debug",
      evt: `shaka-${event.type}`
    });
  }
  /**
   * [onTimelineRegionExitEvent]
   */
  onTimelineRegionExitEvent(event) {
    this.logEvent({
      level: "debug",
      evt: `shaka-${event.type}`
    });
  }
  /**
   * [onTracksChangedEvent]
   */
  onTracksChangedEvent(event) {
    this.logEvent({
      level: "debug",
      evt: `shaka-${event.type}`
    });
  }
  /**
   * [onUnloadingEvent]
   */
  onUnloadingEvent(event) {
    this.logEvent({
      level: "debug",
      evt: `shaka-${event.type}`
    });
  }
  /**
   * [onPlayStateEvent]
   */
  onPlayStateEvent(event) {
    this.logEvent({
      level: "debug",
      evt: `shaka-${event.type}`
    });
  }
  /**
   * [offlineStatusEvent]
   */
  offlineStatusEvent(event) {
    this.online = window.navigator.onLine;
    this.logEvent({
      level: "debug",
      evt: `shaka-${event.type}`
    });
  }
};

// src/~utils/metrics/ClientMetrics.ts
import { Buffer as Buffer2 } from "buffer/";
var ClientMetrics = class {
  constructor({
    logFunc,
    sendIntervalTime = 6e4,
    maxBatchSize = 1024 * 25,
    maxBatchCount = 15,
    batchSizeLimit = 1024 * 1e3,
    failedQueriesLimit = 3
  }) {
    this.sendLogsIntervalId = null;
    this.logQueue = [];
    this.eventsBatchSize = 0;
    this.batchesSent = 0;
    this.requestInProgress = false;
    this.enabled = true;
    this.failedQueries = 0;
    this.extraData = null;
    if (typeof logFunc !== "function") {
      throw new Error("logFunc is not a function");
    }
    this.logFunc = logFunc;
    this.sendIntervalTime = sendIntervalTime;
    this.maxBatchSize = maxBatchSize;
    this.maxBatchCount = maxBatchCount;
    this.batchSizeLimit = batchSizeLimit;
    this.failedQueriesLimit = failedQueriesLimit;
    this.enableTimer();
  }
  setExtraData(extraData) {
    this.extraData = extraData;
  }
  enable() {
    this.enabled = true;
  }
  disable() {
    this.enabled = false;
  }
  enableTimer() {
    if (this.sendLogsIntervalId) {
      this.disableTimer();
    }
    this.sendLogsIntervalId = setInterval(() => {
      if (this.logQueue.length > 0) {
        this.flush();
      }
    }, this.sendIntervalTime);
  }
  disableTimer() {
    if (this.sendLogsIntervalId) {
      clearInterval(this.sendLogsIntervalId);
      this.sendLogsIntervalId = null;
    }
  }
  flush() {
    if (!this.enabled) {
      this.eventsBatchSize = 0;
      this.logQueue = [];
      return;
    }
    if (this.requestInProgress) {
      return;
    }
    this.requestInProgress = true;
    this.eventsBatchSize = 0;
    const logsToSend = this.logQueue;
    this.logQueue = [];
    this.logFunc(logsToSend).then(() => {
      this.requestInProgress = false;
      this.batchesSent += 1;
      this.failedQueries = 0;
    }).catch(() => {
      this.requestInProgress = false;
      this.logQueue = this.logQueue.concat(logsToSend);
      this.logQueue.map((l) => {
        this.eventsBatchSize += Buffer2.byteLength(JSON.stringify(l), "utf8");
      });
      if (this.failedQueries >= this.failedQueriesLimit || this.eventsBatchSize >= this.batchSizeLimit) {
        this.disable();
        this.logQueue = [];
        this.eventsBatchSize = 0;
      } else {
        this.failedQueries += 1;
      }
    });
  }
  log(log) {
    if (!this.enabled) {
      return;
    }
    const currentEvent = JSON.stringify(log);
    this.eventsBatchSize += Buffer2.byteLength(currentEvent, "utf8");
    if (this.eventsBatchSize >= this.batchSizeLimit) {
      this.disable();
      this.logQueue = [];
      return;
    }
    const batchOverSize = this.eventsBatchSize > this.maxBatchSize && this.maxBatchSize > 0;
    const batchOverCount = this.logQueue.length >= this.maxBatchCount && this.maxBatchCount > 0;
    this.logQueue.push({
      level: log.level,
      args: __spreadValues(__spreadValues({}, this.extraData), log)
    });
    if (batchOverSize || batchOverCount) {
      this.flush();
    }
  }
};

// src/~utils/storage/webStorage.ts
var webStorage = {
  getProvider: () => localStorage,
  get: (key3) => __async(void 0, null, function* () {
    try {
      return JSON.parse(localStorage.getItem(key3) || "");
    } catch (e) {
      return null;
    }
  }),
  set: (key3, value) => __async(void 0, null, function* () {
    return Promise.resolve(localStorage.setItem(key3, JSON.stringify(value)));
  }),
  remove: (key3) => __async(void 0, null, function* () {
    return localStorage.removeItem(key3);
  }),
  clearAll: () => __async(void 0, null, function* () {
    return localStorage.clear();
  })
};
var webStorage_default = webStorage;

// src/~utils/castUtils/castModelInfo.ts
var getModelInfo = function() {
  try {
    const { hardwareConcurrency, userAgent } = window.navigator;
    const context = cast.framework.CastReceiverContext.getInstance();
    if (context.canDisplayType('video/mp4; codecs="avc1.640033'))
      return "chromecastWithGoogleTV" /* chromecastWithGoogleTV */;
    if (userAgent.includes("Android"))
      return "chromecastAndroidBuiltIn" /* chromecastAndroid */;
    if (context.canDisplayType("video/mp4; codecs=hev1.1.6.L93.B0"))
      return "chromecastUltra" /* chromecastUltra */;
    if (context.canDisplayType("video/mp4; codecs=avc1.64002A"))
      return "chromecast3Gen" /* chromecast3Gen */;
    if (hardwareConcurrency === 2)
      return "chromecast2Gen" /* chromecast2Gen */;
    if (hardwareConcurrency === 1)
      return "chromecast1Gen" /* chromecast1Gen */;
  } catch (e) {
  }
  return "chromecastUnknown" /* chromecastUnknown */;
};
var ChromecastModel = /* @__PURE__ */ ((ChromecastModel2) => {
  ChromecastModel2["chromecast1Gen"] = "chromecast1Gen";
  ChromecastModel2["chromecast2Gen"] = "chromecast2Gen";
  ChromecastModel2["chromecast3Gen"] = "chromecast3Gen";
  ChromecastModel2["chromecastUltra"] = "chromecastUltra";
  ChromecastModel2["chromecastAndroid"] = "chromecastAndroidBuiltIn";
  ChromecastModel2["chromecastWithGoogleTV"] = "chromecastWithGoogleTV";
  ChromecastModel2["chromecastUnknown"] = "chromecastUnknown";
  return ChromecastModel2;
})(ChromecastModel || {});

// src/~utils/browserUtils/deviceDetect.ts
var DeviceDetect = class _DeviceDetect {
  static supportsMediaSource() {
    if (!(window == null ? void 0 : window.MediaSource)) {
      return false;
    }
    if (!MediaSource.isTypeSupported) {
      return false;
    }
    return true;
  }
  static isEdge() {
    if (window == null ? void 0 : window.navigator.userAgent.match(/Edge?\//)) {
      return true;
    }
    return false;
  }
  static isLegacyEdge() {
    if (window == null ? void 0 : window.navigator.userAgent.match(/Edge\//)) {
      return true;
    }
    return false;
  }
  static isIE() {
    return _DeviceDetect.userAgentContains("Trident/");
  }
  static isXboxOne() {
    return _DeviceDetect.userAgentContains("Xbox One");
  }
  static isTizen() {
    return _DeviceDetect.userAgentContains("Tizen");
  }
  static isTizen4() {
    return _DeviceDetect.userAgentContains("Tizen 4");
  }
  static isTizen3() {
    return _DeviceDetect.userAgentContains("Tizen 3");
  }
  static isTizen2() {
    return _DeviceDetect.userAgentContains("Tizen 2");
  }
  static isTizenVersions(versions) {
    return versions.some(
      (version) => _DeviceDetect.userAgentContains("Tizen " + version)
    );
  }
  static isWebOS() {
    return _DeviceDetect.userAgentContains("Web0S");
  }
  static isWebOS3() {
    return _DeviceDetect.userAgentContains("Web0S") && _DeviceDetect.userAgentContains("Chrome/38.0.2125.122 Safari/537.36");
  }
  static isChromecast() {
    return _DeviceDetect.userAgentContains("CrKey");
  }
  static isChromecastModel() {
    return getModelInfo();
  }
  static chromeVersion() {
    if (!_DeviceDetect.userAgentContains("Chrome")) {
      return null;
    }
    const match = window == null ? void 0 : window.navigator.userAgent.match(/Chrome\/(\d+)/);
    if (match) {
      return parseInt(
        match[1],
        /* base= */
        10
      );
    }
    return null;
  }
  static isChrome() {
    return _DeviceDetect.userAgentContains("Chrome") && !_DeviceDetect.isEdge();
  }
  static isApple() {
    return !!(window == null ? void 0 : window.navigator.vendor) && (window == null ? void 0 : window.navigator.vendor.includes("Apple")) && !_DeviceDetect.isTizen() && !_DeviceDetect.isEOS() && !_DeviceDetect.isPS4() && !_DeviceDetect.isAmazonFireTV();
  }
  static isPS5() {
    return _DeviceDetect.userAgentContains("PlayStation 5");
  }
  static isPS4() {
    return _DeviceDetect.userAgentContains("PlayStation 4");
  }
  static isAmazonFireTV() {
    return _DeviceDetect.userAgentContains("AFT");
  }
  static safariVersion() {
    if (!_DeviceDetect.isApple()) {
      return null;
    }
    let match = window == null ? void 0 : window.navigator.userAgent.match(/Version\/(\d+)/);
    if (match) {
      return parseInt(
        match[1],
        /* base= */
        10
      );
    }
    match = window == null ? void 0 : window.navigator.userAgent.match(/OS (\d+)(?:_\d+)?/);
    if (match) {
      return parseInt(
        match[1],
        /* base= */
        10
      );
    }
    return null;
  }
  static isSafari() {
    return !!_DeviceDetect.safariVersion();
  }
  static isEOS() {
    return _DeviceDetect.userAgentContains("PC=EOS");
  }
  static isMobile() {
    if (/(?:iPhone|iPad|iPod|Android)/.test(window == null ? void 0 : window.navigator.userAgent)) {
      return true;
    }
    return _DeviceDetect.isApple() && (window == null ? void 0 : window.navigator.maxTouchPoints) > 1;
  }
  static userAgentContains(key3) {
    var _a;
    let userAgent = "";
    try {
      userAgent = ((_a = window == null ? void 0 : window.navigator) == null ? void 0 : _a.userAgent) || "";
    } catch (error) {
      userAgent = "";
    }
    return userAgent.includes(key3);
  }
  static detectMaxHardwareResolution() {
    const maxResolution = {
      width: void 0,
      height: void 0
    };
    if (_DeviceDetect.isChromecast()) {
      const gen = _DeviceDetect.isChromecastModel();
      maxResolution.width = 1280;
      maxResolution.height = 720;
      switch (gen) {
        case "chromecast2Gen":
          maxResolution.width = 1920;
          maxResolution.height = 1080;
          break;
        case "chromecast3Gen":
          maxResolution.width = 1920;
          maxResolution.height = 1080;
          break;
        case "chromecastUltra":
          maxResolution.width = 3840;
          maxResolution.height = 2160;
          break;
        case "chromecastWithGoogleTV":
          maxResolution.width = 3840;
          maxResolution.height = 2160;
          break;
      }
    } else if (_DeviceDetect.isTizen()) {
      maxResolution.width = 1920;
      maxResolution.height = 1080;
      try {
        const tizenApi = webapis;
        if (tizenApi.systeminfo && tizenApi.systeminfo.getMaxVideoResolution) {
          const maxVideoResolution = tizenApi.systeminfo.getMaxVideoResolution();
          maxResolution.width = maxVideoResolution.width;
          maxResolution.height = maxVideoResolution.height;
        } else {
          if (tizenApi.productinfo.is8KPanelSupported && tizenApi.productinfo.is8KPanelSupported()) {
            maxResolution.width = 7680;
            maxResolution.height = 4320;
          } else if (tizenApi.productinfo.isUdPanelSupported && tizenApi.productinfo.isUdPanelSupported()) {
            maxResolution.width = 3840;
            maxResolution.height = 2160;
          }
        }
      } catch (e) {
      }
    } else if (_DeviceDetect.isWebOS()) {
      try {
        const deviceInfo2 = JSON.parse(window == null ? void 0 : window.PalmSystem.deviceInfo);
        maxResolution.width = Math.max(1920, deviceInfo2["screenWidth"]);
        maxResolution.height = Math.max(1080, deviceInfo2["screenHeight"]);
      } catch (e) {
        maxResolution.width = 1920;
        maxResolution.height = 1080;
      }
    } else if (_DeviceDetect.isPS4() || _DeviceDetect.isPS5()) {
      console.warn("NYI");
    }
    return maxResolution;
  }
};

// src/~utils/checkoutUtils/checkoutUtils.ts
var isDiscounted = (purchaseType) => purchaseType.originalPrice !== null;
var hasCampaignDiscount = (purchaseType) => purchaseType.campaignPrice !== null;
var hasVoucherDiscount = (purchaseType) => isDiscounted(purchaseType) && purchaseType.campaignPrice !== purchaseType.price;

// src/~types/types/productType.ts
var ProductType = /* @__PURE__ */ ((ProductType2) => {
  ProductType2["ticket"] = "ticket";
  ProductType2["bundle"] = "bundle";
  ProductType2["episode"] = "episode";
  ProductType2["movie"] = "movie";
  ProductType2["season"] = "season";
  ProductType2["series"] = "series";
  return ProductType2;
})(ProductType || {});

// src/~types/types/storage.ts
var STORAGE = /* @__PURE__ */ ((STORAGE2) => {
  STORAGE2["ACCOUNT_AUTH"] = "shapeshifter-core/ACCOUNT_AUTH";
  STORAGE2["UNSYNCED_BOOKMARKS"] = "shapeshifter-core/BOOKMARKS";
  STORAGE2["QUEUED_OFFLINE_EVENTS"] = "shapeshifter-core/QUEUED_OFFLINE_EVENTS";
  return STORAGE2;
})(STORAGE || {});

// src/~types/types/time.ts
var TimeUnit = /* @__PURE__ */ ((TimeUnit2) => {
  TimeUnit2["MILLISECONDS"] = "ms";
  TimeUnit2["SECONDS"] = "s";
  return TimeUnit2;
})(TimeUnit || {});

// src/~types/types/webview.ts
var ErrorCode = /* @__PURE__ */ ((ErrorCode2) => {
  ErrorCode2["E_IAP_NOT_AVAILABLE"] = "E_IAP_NOT_AVAILABLE";
  ErrorCode2["E_UNKNOWN"] = "E_UNKNOWN";
  ErrorCode2["E_USER_CANCELLED"] = "E_USER_CANCELLED";
  ErrorCode2["E_USER_ERROR"] = "E_USER_ERROR";
  ErrorCode2["E_ITEM_UNAVAILABLE"] = "E_ITEM_UNAVAILABLE";
  ErrorCode2["E_REMOTE_ERROR"] = "E_REMOTE_ERROR";
  ErrorCode2["E_NETWORK_ERROR"] = "E_NETWORK_ERROR";
  ErrorCode2["E_SERVICE_ERROR"] = "E_SERVICE_ERROR";
  ErrorCode2["E_RECEIPT_FAILED"] = "E_RECEIPT_FAILED";
  ErrorCode2["E_RECEIPT_FINISHED_FAILED"] = "E_RECEIPT_FINISHED_FAILED";
  ErrorCode2["E_NOT_PREPARED"] = "E_NOT_PREPARED";
  ErrorCode2["E_NOT_ENDED"] = "E_NOT_ENDED";
  ErrorCode2["E_ALREADY_OWNED"] = "E_ALREADY_OWNED";
  ErrorCode2["E_DEVELOPER_ERROR"] = "E_DEVELOPER_ERROR";
  ErrorCode2["E_BILLING_RESPONSE_JSON_PARSE_ERROR"] = "E_BILLING_RESPONSE_JSON_PARSE_ERROR";
  ErrorCode2["E_DEFERRED_PAYMENT"] = "E_DEFERRED_PAYMENT";
  ErrorCode2["E_INTERRUPTED"] = "E_INTERRUPTED";
  return ErrorCode2;
})(ErrorCode || {});

// src/~types/types/drm.ts
var VideoPlaybackDrmType = {
  FAIRPLAY: "fairplay",
  WIDEVINE: "widevine",
  PLAYREADY: "playready",
  NONE: "none"
};
var VideoPlaybackDrmKeySystems = {
  CLEARKEY: "org.w3.clearkey",
  FAIRPLAY: "com.apple.fps",
  FAIRPLAY_V1: "com.apple.fps.1_0",
  PLAYREADY: "com.microsoft.playready",
  WIDEVINE: "com.widevine.alpha"
};
var WidevineSecurityLevel = {
  L0: "SW_SECURE_CRYPTO",
  L1: "SW_SECURE_DECODE",
  L2: "HW_SECURE_CRYPTO",
  L3: "HW_SECURE_DECODE",
  L4: "HW_SECURE_ALL"
};

// src/~types/utils/assertUnreachable.ts
function assertUnreachableThrows(_x) {
  throw new Error("Didn't expect to get here");
}
function assertUnreachable(_x) {
}

// src/~types/utils/exists.ts
function exists(item) {
  return item != null;
}
function isTruthy(item) {
  return !!item;
}

// src/~utils/collectionUtils/collectionUtils.ts
var getDisplayableAssetImage = (displayableAsset) => {
  if (displayableAsset == null) {
    return "";
  }
  switch (displayableAsset.__typename) {
    case "DisplayableInCollectionWithCover":
      return displayableAsset.cover;
    case "DisplayableInCollectionWithPromo":
      return displayableAsset.promo;
    default:
      assertUnreachable(displayableAsset);
      return "";
  }
};

// src/~utils/commonUtils/commonUtils.ts
import flatten from "lodash/flatten";
import identity from "lodash/identity";
import pickBy from "lodash/pickBy";
var loopingArrayIndex = (activeIndex, index, length) => {
  if (index > activeIndex) {
    return index - activeIndex + 1;
  }
  if (index < activeIndex) {
    return length - (activeIndex - index) + 1;
  }
  return 1;
};
var duplicateAndFillArray = (arr, minCount) => {
  const fillTimes = Math.max(Math.ceil(minCount / arr.length), 1);
  const arrays = [];
  for (let i = 0; i < fillTimes; i++) {
    arrays[i] = arr;
  }
  return flatten(arrays);
};
var sanitizeObject = (object) => {
  return pickBy(object, identity);
};
var toQueryString = (params) => {
  const keys = Object.keys(params);
  if (!keys.length)
    return "";
  return "?" + keys.map((key3) => key3 + "=" + params[key3]).join("&");
};
function toArray(object) {
  return Object.values(object);
}
function toObject(array, keyName) {
  return array.reduce(
    (acc, cur) => {
      const id = cur[keyName];
      acc[id] = cur;
      return acc;
    },
    {}
  );
}
function onlyUnique(value, index, array) {
  return array.indexOf(value) === index;
}
var by = (prop, order2 = "asc") => (a, b) => {
  const factor = order2 === "desc" ? -1 : 1;
  if (a[prop] < b[prop])
    return -1 * factor;
  if (a[prop] > b[prop])
    return 1 * factor;
  return 0;
};

// src/~utils/commonUtils/shallowEqualsObject.ts
var shallowEqualsObject = (objA, objB) => {
  if (objA === objB) {
    return true;
  }
  if (!objA || !objB) {
    return false;
  }
  const aKeys = Object.keys(objA);
  const bKeys = Object.keys(objB);
  const len = aKeys.length;
  if (bKeys.length !== len) {
    return false;
  }
  for (let i = 0; i < len; i++) {
    const key3 = aKeys[i];
    if (objA[key3] !== objB[key3] || !Object.prototype.hasOwnProperty.call(objB, key3)) {
      return false;
    }
  }
  return true;
};

// src/~utils/commonUtils/webUtils.ts
var isSSR = typeof window === "undefined";
var isInWebview = () => {
  return isSSR ? false : !!(window == null ? void 0 : window.ReactNativeWebView);
};
var sendWebviewMessage = (action) => {
  const w = window;
  if (isSSR || !(w == null ? void 0 : w.ReactNativeWebView))
    return;
  w == null ? void 0 : w.ReactNativeWebView.postMessage(JSON.stringify(action));
};

// src/~utils/constants/Placeholders/Placeholders.ts
var TRANSPARENT1X1 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=";
var TRANSPARENT336X486 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAVAAAAHmCAQAAACPch46AAADfElEQVR42u3SMQ0AAAzDsJU/6UHo28OGECUHwyIBBgWDYlAwKBgUg4JBMSgYFAyKQcGgGBQMCgbFoGBQDAoGBYNiUDAoBgWDgkExKBgUDIpBwaAYFAwKBsWgYFAMCgYFg2JQMCgGBYOCQTEoGBSDgkHBoBgUDAoGxaBgUAwKBgWDYlAwKAYFg4JBMSgYFIOCQcGgGBQMikHBoGBQDAoGBYNiUDAoBgWDgkExKBgUg4JBwaAYFAyKQcGgYFAMCgbFoGBQMCgGBYOCQTEoGBSDgkHBoBgUDIpBwaBgUAwKBsWgYFAwKAYFg2JQMCgYFIOCQcGgGBQMikHBoGBQDAoGxaBgUDAoBgWDYlAwKBgUg4JBMSgYFAyKQcGgYFAMCgbFoGBQMCgGBYNiUDAoGBSDgkExKBgUDIpBwaAYFAwKBsWgYFAwKAYFg2JQMCgYFIOCQTEoGBQMikHBoBgUDAoGxaBgUAwKBgWDYlAwKBgUg4JBMSgYFAyKQcGgGBQMCgbFoGBQDAoGBYNiUDAoBgWDgkExKBgUDIpBwaAYFAwKBsWgYFAMCgYFg2JQMCgGBYOCQTEoGBSDgkHBoBgUDAoGxaBgUAwKBgWDYlAwKAYFg4JBMSgYFIOCQcGgGBQMikHBoGBQDAoGxaASYFAwKAYFg4JBMSgYFIOCQcGgGBQMikHBoGBQDAoGxaBgUDAoBgWDYlAwKBgUg4JBwaAYFAyKQcGgYFAMCgbFoGBQMCgGBYNiUDAoGBSDgkExKBgUDIpBwaBgUAwKBsWgYFAwKAYFg2JQMCgYFIOCQTEoGBQMikHBoBgUDAoGxaBgUDAoBgWDYlAwKBgUg4JBMSgYFAyKQcGgGBQMCgbFoGBQDAoGBYNiUDAoGBSDgkExKBgUDIpBwaAYFAwKBsWgYFAMCgYFg2JQMCgGBYOCQTEoGBQMikHBoBgUDAoGxaBgUAwKBgWDYlAwKAYFg4JBMSgYFIOCQcGgGBQMCgbFoGBQDAoGBYNiUDAoBgWDgkExKBgUg4JBwaAYFAyKQcGgYFAMCgYFg2JQMCgGBYOCQTEoGBSDgkHBoBgUDIpBwaBgUAwKBsWgYFAwKAYFg4JBMSgYFIOCQcGgGBQMikHBoGBQDAoGxaBgUDAoBgWDYlAwKBgUg4JBwaAYFAyKQcGgYFAMCgbFoGBQMCgGBYNiUDAodA+IhwHnhEuE7AAAAABJRU5ErkJggg==";
var COVER = "https://img-cdn.sfanytime.com/APP/COVERM_FALLABACK_5814b0d9a324f78d6a9bb58d82854cd1_01.png?w=375&ar=0.692&fit=crop&fm=png&s=ed943b49163cf370c6f6bf0d95c115b2";

// src/~utils/deepLinkingUtils/deepLinkingUtils.ts
var getDeepLinkUrlScheme = (brand) => {
  switch (brand) {
    case "SFAnytime" /* SFAnytime */:
      return "sfanytime://";
    case "Blockbuster" /* Blockbuster */:
      return "blockbuster://";
    default:
      assertUnreachableThrows(brand);
  }
};
var getDeepLinkHandler = (brand) => {
  const urlScheme = getDeepLinkUrlScheme(brand);
  return {
    makeDeepLink(route) {
      let routeUrl = "";
      const _a = route, { type: type2 } = _a, all = __objRest(_a, ["type"]);
      switch (type2) {
        case "LOGIN": {
          routeUrl = `login${toQueryString(all)}`;
          break;
        }
        case "REGISTER": {
          routeUrl = `register${toQueryString(all)}`;
          break;
        }
        case "FEATURE": {
          routeUrl = `feature/${route.slug}`;
          break;
        }
        case "TRAILER": {
          routeUrl = `trailer/${route.slug}`;
          break;
        }
        case "MOVIE": {
          routeUrl = `movie/${route.slug}`;
          break;
        }
        case "SERIES": {
          routeUrl = `series/${route.slug}`;
          break;
        }
        case "CHECKOUT": {
          const _b = route, { type: _type, slug: slug3 } = _b, rest = __objRest(_b, ["type", "slug"]);
          routeUrl = `checkout/${slug3}${toQueryString(rest)}`;
          break;
        }
        default: {
          assertUnreachableThrows(route);
        }
      }
      return `${urlScheme}${routeUrl}`;
    },
    parseInput(rawInput) {
      if (!rawInput.startsWith(urlScheme)) {
        return null;
      }
      const { search: search2, pathname, hostname: route } = new URL(rawInput);
      const urlParams = new URLSearchParams(search2);
      switch (route) {
        case "login":
          return { type: "LOGIN" };
        case "register":
          return { type: "REGISTER" };
      }
      const slug3 = pathname.slice(1);
      if (typeof slug3 !== "string" || slug3.length === 0) {
        return null;
      }
      switch (route) {
        case "feature":
          return { type: "FEATURE", slug: slug3 };
        case "trailer":
          return { type: "TRAILER", slug: slug3 };
        case "movie":
          return { type: "MOVIE", slug: slug3 };
        case "series":
          return { type: "SERIES", slug: slug3 };
        case "checkout":
          return {
            type: "CHECKOUT",
            slug: slug3,
            transactionId: urlParams.get("transactionId") || void 0,
            redirect: urlParams.get("redirect") || void 0
          };
      }
      return null;
    }
  };
};

// src/~utils/devicePreferences/devicePreferencesStorage.ts
var DEVICE_PREFERENCE_KEY = "DEVICE_PREFERENCES";
var SUBTITLE_KEY = `${DEVICE_PREFERENCE_KEY}/SUBTITLE_LANGUAGE`;
var AUDIO_KEY = `${DEVICE_PREFERENCE_KEY}/AUDIO_LANGUAGE`;
var FULLSCREEN_KEY = `${DEVICE_PREFERENCE_KEY}/FULLSCREEN`;
var ALLOW_CELLULAR_DOWNLOADS_KEY = `${DEVICE_PREFERENCE_KEY}/ALLOW_MOBILE_NETWORK_DOWNLOADS`;
var DevicePreferencesStorage = class {
  constructor(storage2) {
    this.storage = storage2;
    this.setSubtitleLanguagePreference = (language) => __async(this, null, function* () {
      yield this.storage.set(SUBTITLE_KEY, {
        value: language
      });
    });
    this.getSubtitleLanguagePreference = () => __async(this, null, function* () {
      var _a;
      const result = yield this.storage.get(SUBTITLE_KEY);
      return (_a = result == null ? void 0 : result.value) != null ? _a : null;
    });
    this.setAudioLanguagePreference = (language) => __async(this, null, function* () {
      yield this.storage.set(AUDIO_KEY, {
        value: language
      });
    });
    this.getAudioLanguagePreference = () => __async(this, null, function* () {
      var _a;
      const result = yield this.storage.get(AUDIO_KEY);
      return (_a = result == null ? void 0 : result.value) != null ? _a : null;
    });
    this.setFullscreenPreference = (fullscreen) => __async(this, null, function* () {
      yield this.storage.set(FULLSCREEN_KEY, {
        value: fullscreen
      });
    });
    this.getFullscreenPreference = () => __async(this, null, function* () {
      const result = yield this.storage.get(FULLSCREEN_KEY);
      return !!(result == null ? void 0 : result.value);
    });
    this.setAllowCellularDownloadsPreference = (allowCellularDownloads) => __async(this, null, function* () {
      yield this.storage.set(
        ALLOW_CELLULAR_DOWNLOADS_KEY,
        {
          value: allowCellularDownloads
        }
      );
    });
    this.getAllowCellularDownloadsPreference = () => __async(this, null, function* () {
      const result = yield this.storage.get(
        ALLOW_CELLULAR_DOWNLOADS_KEY
      );
      return !!(result == null ? void 0 : result.value);
    });
    this.storage = storage2;
  }
};

// src/~utils/errorUtils/errorUtils.ts
var getCodeFromError = (error) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  return {
    code: (_g = (_f = (_c = (_b = (_a = error == null ? void 0 : error.graphQLErrors[0]) == null ? void 0 : _a.extensions) == null ? void 0 : _b.response) == null ? void 0 : _c.status) != null ? _f : (_e = (_d = error == null ? void 0 : error.graphQLErrors[0]) == null ? void 0 : _d.extensions) == null ? void 0 : _e.code) != null ? _g : null,
    message: (_i = (_h = error == null ? void 0 : error.graphQLErrors[0]) == null ? void 0 : _h.message) != null ? _i : null
  };
};
var getLoginErrorLiterals = (error) => {
  return getErrorLiterals(error, "login");
};
var getAdyenErrorLiterals = ({ code }) => {
  return getErrorCodeLiterals({ code, scope: "adyen" });
};
var getErrorLiterals = (error, scope) => {
  const { code } = getCodeFromError(error);
  return scope && error ? getErrorCodeLiterals({ code, scope }) : getFallbackLiterals();
};
var getErrorCodeLiterals = ({
  code,
  scope
}) => {
  return {
    title: String(`error.${scope}.${code}.title`).toLowerCase(),
    text: String(`error.${scope}.${code}.text`).toLowerCase()
  };
};
var getFallbackLiterals = () => {
  return {
    title: "error.app.something_went_wrong",
    text: "error.app.please_try_again"
  };
};
var buildTextLiteral = ({
  code,
  scope
}) => {
  return String(`error.${scope}.${code}.text`).toLowerCase();
};
var buildTitleLiteral = ({
  code,
  scope
}) => {
  return String(`error.${scope}.${code}.title`).toLowerCase();
};
var buildFallbackValue = ({
  code,
  scope
}) => {
  return `Unexpected error (scope: ${scope}, code: ${code})`;
};

// src/~utils/eventEmitter/createEventEmitter.ts
function createEventEmitter() {
  let listeners = [];
  let recentEvents = {};
  let mostRecentEvent = void 0;
  const emit7 = (...args) => {
    const event = args[0];
    const payload = args[1];
    listeners.forEach((listener) => {
      if (listener.type === "allEvents") {
        listener.callback({ name: event, payload });
      } else if (event === listener.event) {
        listener.callback(payload);
      }
    });
    recentEvents[event] = payload;
    mostRecentEvent = event;
  };
  function withLatest(listener) {
    const event = listener.type === "allEvents" ? mostRecentEvent : listener.event;
    const eventHasBeenEmitted = event && event in recentEvents;
    if (eventHasBeenEmitted) {
      listener.callback({
        name: event,
        payload: recentEvents[event]
      });
    }
  }
  function onEvent8(...args) {
    var _a;
    const listener = (() => {
      if (typeof args[0] === "function") {
        const callback = args[0];
        const options = args[1];
        return { callback, type: "allEvents", options };
      }
      if (typeof args[1] === "function") {
        const event = args[0];
        const callback = args[1];
        const options = args[2];
        if (!callback)
          throw Error("Invalid arguments of onEvent function");
        return { callback, type: "singleEvent", event, options };
      }
      throw Error("Invalid arguments");
    })();
    if ((_a = listener.options) == null ? void 0 : _a.withLatest) {
      withLatest(listener);
    }
    listeners.push(listener);
    const unsubscribe = () => {
      listeners = listeners.filter((l) => l !== listener);
    };
    return unsubscribe;
  }
  const clear = () => {
    listeners = [];
    mostRecentEvent = void 0;
    recentEvents = {};
  };
  return { emit: emit7, onEvent: onEvent8, clear };
}

// src/~utils/invariant/invariant.ts
var isProduction = false;
var prefix = "Invariant failed";
function invariant(condition, message) {
  if (condition) {
    return;
  }
  if (isProduction) {
    throw new Error(prefix);
  }
  const provided = typeof message === "function" ? message() : message;
  const value = provided ? `${prefix}: ${provided}` : prefix;
  throw new Error(value);
}

// src/~utils/languageUtils/getDisplayLanguage.ts
import get from "lodash/get";

// src/~utils/languageUtils/getLocaleFromIsoCode.ts
function getLocaleFromIsoCode(isoCode) {
  const lowercaseCode = isoCode.toLowerCase().replace("_", "-");
  switch (lowercaseCode) {
    case "en-gb":
    case "en-us":
    case "en":
      return "en" /* en */;
    case "fi":
    case "fi-fi":
      return "fi" /* fi */;
    case "da":
    case "da-dk":
      return "da" /* da */;
    case "no":
    case "nb":
    case "nn":
    case "nb-no":
      return "no" /* no */;
    case "sv":
    case "sv-se":
      return "sv" /* sv */;
    default:
      if (lowercaseCode.length > 2) {
        return getLocaleFromIsoCode(isoCode.slice(0, 2));
      }
      return void 0;
  }
}

// src/~utils/languageUtils/getDisplayLanguage.ts
var getDisplayLanguage = ({
  language,
  locale,
  sound
}) => {
  if (!locale || !language) {
    return locale || language;
  }
  const data = {
    sv: {
      // Custom
      ax: "Artificiell",
      art: "Artificiell",
      xz: "Ingen dialog",
      xzz: "Ingen dialog",
      // Real
      aa: "Afar",
      ab: "Abchaziska",
      af: "Afrikaans",
      ak: "Akan",
      sq: "Albanska",
      am: "Amhariska",
      ar: "Arabiska",
      an: "Aragonesiska",
      hy: "Armeniska",
      as: "Assamesiska",
      av: "Avariska",
      ae: "Avestiska",
      ay: "Aymara",
      az: "Azerbajdzjanska",
      ba: "Basjkiriska",
      bm: "Bambara",
      eu: "Baskiska",
      be: "Vitryska",
      bn: "Bengali",
      bh: "Bh",
      bi: "Bislama",
      bs: "Bosniska",
      br: "Bretonska",
      bg: "Bulgariska",
      my: "Burmesiska",
      ca: "Katalanska",
      ch: "Chamorro",
      ce: "Tjetjenska",
      zh: "Kinesiska",
      cu: "Kyrkslaviska",
      cv: "Tjuvasjiska",
      kw: "Korniska",
      co: "Korsikanska",
      cr: "Cree",
      cs: "Tjeckiska",
      da: "Danska",
      dv: "Divehi",
      nl: "Nederl\xE4ndska",
      dz: "Dzongkha",
      en: "Engelska",
      eo: "Esperanto",
      et: "Estniska",
      ee: "Ewe",
      fo: "F\xE4r\xF6iska",
      fj: "Fijianska",
      fi: "Finska",
      fr: "Franska",
      fy: "V\xE4stfrisiska",
      ff: "Fulani",
      ka: "Georgiska",
      de: "Tyska",
      gd: "Skotsk g\xE4liska",
      ga: "Iriska",
      gl: "Galiciska",
      gv: "Manx",
      el: "Grekiska",
      gn: "Guaran\xED",
      gu: "Gujarati",
      ht: "Haitiska",
      ha: "Hausa",
      he: "Hebreiska",
      hz: "Herero",
      hi: "Hindi",
      ho: "Hirimotu",
      hr: "Kroatiska",
      hu: "Ungerska",
      ig: "Igbo",
      is: "Isl\xE4ndska",
      io: "Ido",
      ii: "Szezuan i",
      iu: "Inuktitut",
      ie: "Interlingue",
      ia: "Interlingua",
      id: "Indonesiska",
      ik: "Inupiak",
      it: "Italienska",
      jv: "Javanesiska",
      ja: "Japanska",
      kl: "Gr\xF6nl\xE4ndska",
      kn: "Kannada",
      ks: "Kashmiriska",
      kr: "Kanuri",
      kk: "Kazakiska",
      km: "Kambodjanska",
      ki: "Kikuyu",
      rw: "Kinjarwanda",
      ky: "Kirgisiska",
      kv: "Kome",
      kg: "Kikongo",
      ko: "Koreanska",
      kj: "Kuanyama",
      ku: "Kurdiska",
      lo: "Laotiska",
      la: "Latin",
      lv: "Lettiska",
      li: "Limburgiska",
      ln: "Lingala",
      lt: "Litauiska",
      lb: "Luxemburgiska",
      lu: "Luba-katanga",
      lg: "Luganda",
      mk: "Makedonska",
      mh: "Marshalliska",
      ml: "Malayalam",
      mi: "Maori",
      mr: "Marathi",
      ms: "Malajiska",
      mg: "Malagassiska",
      mt: "Maltesiska",
      mn: "Mongoliska",
      na: "Nauriska",
      nv: "Navaho",
      nr: "Sydndebele",
      nd: "Nordndebele",
      ng: "Ndonga",
      ne: "Nepalesiska",
      nn: "Nynorska",
      nb: "Norskt bokm\xE5l",
      no: "Norska",
      ny: "Nyanja",
      oc: "Occitanska",
      oj: "Odjibwa",
      or: "Oriya",
      om: "Oromo",
      os: "Ossetiska",
      pa: "Punjabi",
      fa: "Persiska",
      pi: "Pali",
      pl: "Polska",
      pt: "Portugisiska",
      ps: "Afghanska",
      qu: "Quechua",
      rm: "R\xE4toromanska",
      ro: "Rum\xE4nska",
      rn: "Rundi",
      ru: "Ryska",
      sg: "Sango",
      sa: "Sanskrit",
      si: "Singalesiska",
      sk: "Slovakiska",
      sl: "Slovenska",
      se: "Nordsamiska",
      sm: "Samoanska",
      sn: "Shona",
      sd: "Sindhi",
      so: "Somaliska",
      st: "Sydsotho",
      es: "Spanska",
      sc: "Sardinska",
      sr: "Serbiska",
      ss: "Swati",
      su: "Sundanesiska",
      sw: "Swahili",
      sv: "Svenska",
      ty: "Tahitiska",
      ta: "Tamil",
      tt: "Tatariska",
      te: "Telugu",
      tg: "Tadzjikiska",
      tl: "Tagalog",
      th: "Thail\xE4ndska",
      bo: "Tibetanska",
      ti: "Tigrinja",
      to: "Tonganska",
      tn: "Tswana",
      ts: "Tsonga",
      tk: "Turkmeniska",
      tr: "Turkiska",
      tw: "Twi",
      ug: "Uiguriska",
      uk: "Ukrainska",
      ur: "Urdu",
      uz: "Uzbekiska",
      ve: "Venda",
      vi: "Vietnamesiska",
      vo: "Volap\xFCk",
      cy: "Walesiska",
      wa: "Vallonska",
      wo: "Wolof",
      xh: "Xhosa",
      yi: "Jiddisch",
      yo: "Yoruba",
      za: "Zhuang",
      zu: "Zulu"
    },
    no: {
      // Custom
      ax: "Kunstig",
      art: "Kunstig",
      xz: "Ingen dialog",
      xzz: "Ingen dialog",
      // Real
      aa: "Afar",
      ab: "Abkhasisk",
      af: "Afrikaans",
      ak: "Akan",
      sq: "Albansk",
      am: "Amharisk",
      ar: "Arabisk",
      an: "Aragonsk",
      hy: "Armensk",
      as: "Assamesisk",
      av: "Avarisk",
      ae: "Avestisk",
      ay: "Aymara",
      az: "Aserbajdsjansk",
      ba: "Basjkirsk",
      bm: "Bambara",
      eu: "Baskisk",
      be: "Hviterussisk",
      bn: "Bengali",
      bh: "Bh",
      bi: "Bislama",
      bs: "Bosnisk",
      br: "Bretonsk",
      bg: "Bulgarsk",
      my: "Burmesisk",
      ca: "Katalansk",
      ch: "Chamorro",
      ce: "Tsjetsjensk",
      zh: "Kinesisk",
      cu: "Kirkeslavisk",
      cv: "Tsjuvasjisk",
      kw: "Kornisk",
      co: "Korsikansk",
      cr: "Cree",
      cs: "Tsjekkisk",
      da: "Dansk",
      dv: "Divehi",
      nl: "Nederlandsk",
      dz: "Dzongkha",
      en: "Engelsk",
      eo: "Esperanto",
      et: "Estisk",
      ee: "Ewe",
      fo: "F\xE6r\xF8ysk",
      fj: "Fijiansk",
      fi: "Finsk",
      fr: "Fransk",
      fy: "Vestfrisisk",
      ff: "Fulfulde",
      ka: "Georgisk",
      de: "Tysk",
      gd: "Skotsk-g\xE6lisk",
      ga: "Irsk",
      gl: "Galisisk",
      gv: "Mansk",
      el: "Gresk",
      gn: "Guarani",
      gu: "Gujarati",
      ht: "Haitisk",
      ha: "Hausa",
      he: "Hebraisk",
      hz: "Herero",
      hi: "Hindi",
      ho: "Hiri motu",
      hr: "Kroatisk",
      hu: "Ungarsk",
      ig: "Ibo",
      is: "Islandsk",
      io: "Ido",
      ii: "Sichuan-yi",
      iu: "Inuktitut",
      ie: "Interlingue",
      ia: "Interlingua",
      id: "Indonesisk",
      ik: "Inupiak",
      it: "Italiensk",
      jv: "Javanesisk",
      ja: "Japansk",
      kl: "Gr\xF8nlandsk",
      kn: "Kannada",
      ks: "Kasjmiri",
      kr: "Kanuri",
      kk: "Kasakhisk",
      km: "Khmer",
      ki: "Kikuyu",
      rw: "Kinyarwanda",
      ky: "Kirgisisk",
      kv: "Komi",
      kg: "Kikongo",
      ko: "Koreansk",
      kj: "Kuanyama",
      ku: "Kurdisk",
      lo: "Laotisk",
      la: "Latin",
      lv: "Latvisk",
      li: "Limburgsk",
      ln: "Lingala",
      lt: "Litauisk",
      lb: "Luxemburgsk",
      lu: "Luba-katanga",
      lg: "Ganda",
      mk: "Makedonsk",
      mh: "Marshallesisk",
      ml: "Malayalam",
      mi: "Maori",
      mr: "Marathi",
      ms: "Malayisk",
      mg: "Gassisk",
      mt: "Maltesisk",
      mn: "Mongolsk",
      na: "Nauru",
      nv: "Navajo",
      nr: "S\xF8r-ndebele",
      nd: "Nord-ndebele",
      ng: "Ndonga",
      ne: "Nepali",
      nn: "Norsk nynorsk",
      nb: "Norsk bokm\xE5l",
      no: "Norsk",
      ny: "Nyanja",
      oc: "Oksitansk",
      oj: "Ojibwa",
      or: "Odia",
      om: "Oromo",
      os: "Ossetisk",
      pa: "Panjabi",
      fa: "Persisk",
      pi: "Pali",
      pl: "Polsk",
      pt: "Portugisisk",
      ps: "Pashto",
      qu: "Quechua",
      rm: "Retoromansk",
      ro: "Rumensk",
      rn: "Rundi",
      ru: "Russisk",
      sg: "Sango",
      sa: "Sanskrit",
      si: "Singalesisk",
      sk: "Slovakisk",
      sl: "Slovensk",
      se: "Nordsamisk",
      sm: "Samoansk",
      sn: "Shona",
      sd: "Sindhi",
      so: "Somali",
      st: "S\xF8r-sotho",
      es: "Spansk",
      sc: "Sardisk",
      sr: "Serbisk",
      ss: "Swati",
      su: "Sundanesisk",
      sw: "Swahili",
      sv: "Svensk",
      ty: "Tahitisk",
      ta: "Tamil",
      tt: "Tatarisk",
      te: "Telugu",
      tg: "Tadsjikisk",
      tl: "Tagalog",
      th: "Thai",
      bo: "Tibetansk",
      ti: "Tigrinja",
      to: "Tongansk",
      tn: "Setswana",
      ts: "Tsonga",
      tk: "Turkmensk",
      tr: "Tyrkisk",
      tw: "Twi",
      ug: "Uigurisk",
      uk: "Ukrainsk",
      ur: "Urdu",
      uz: "Usbekisk",
      ve: "Venda",
      vi: "Vietnamesisk",
      vo: "Volapyk",
      cy: "Walisisk",
      wa: "Vallonsk",
      wo: "Wolof",
      xh: "Xhosa",
      yi: "Jiddisk",
      yo: "Joruba",
      za: "Zhuang",
      zu: "Zulu"
    },
    fi: {
      // Custom
      ax: "Keinotekoinen",
      art: "Keinotekoinen",
      xz: "	Ei dialogia",
      xzz: "Ei dialogia",
      // Real
      aa: "Afar",
      ab: "Abhaasi",
      af: "Afrikaans",
      ak: "Akan",
      sq: "Albania",
      am: "Amhara",
      ar: "Arabia",
      an: "Aragonia",
      hy: "Armenia",
      as: "Assami",
      av: "Avaari",
      ae: "Avesta",
      ay: "Aimara",
      az: "Azeri",
      ba: "Ba\u0161kiiri",
      bm: "Bambara",
      eu: "Baski",
      be: "Valkoven\xE4j\xE4",
      bn: "Bengali",
      bh: "Bh",
      bi: "Bislama",
      bs: "Bosnia",
      br: "Bretoni",
      bg: "Bulgaria",
      my: "Burma",
      ca: "Katalaani",
      ch: "T\u0161amorro",
      ce: "T\u0161et\u0161eeni",
      zh: "Kiina",
      cu: "Kirkkoslaavi",
      cv: "T\u0161uvassi",
      kw: "Korni",
      co: "Korsika",
      cr: "Cree",
      cs: "T\u0161ekki",
      da: "Tanska",
      dv: "Divehi",
      nl: "Hollanti",
      dz: "Dzongkha",
      en: "Englanti",
      eo: "Esperanto",
      et: "Viro",
      ee: "Ewe",
      fo: "F\xE4\xE4ri",
      fj: "Fid\u017Ei",
      fi: "Suomi",
      fr: "Ranska",
      fy: "L\xE4nsifriisi",
      ff: "Fulani",
      ka: "Georgia",
      de: "Saksa",
      gd: "Gaeli",
      ga: "Iiri",
      gl: "Galicia",
      gv: "Manksi",
      el: "Kreikka",
      gn: "Guarani",
      gu: "Gud\u017Earati",
      ht: "Haiti",
      ha: "Hausa",
      he: "Heprea",
      hz: "Herero",
      hi: "Hindi",
      ho: "Hiri-motu",
      hr: "Kroatia",
      hu: "Unkari",
      ig: "Igbo",
      is: "Islanti",
      io: "Ido",
      ii: "Sichuanin-yi",
      iu: "Inuktitut",
      ie: "Interlingue",
      ia: "Interlingua",
      id: "Indonesia",
      ik: "Inupiaq",
      it: "Italia",
      jv: "Jaava",
      ja: "Japani",
      kl: "Kalaallisut",
      kn: "Kannada",
      ks: "Ka\u0161miri",
      kr: "Kanuri",
      kk: "Kazakki",
      km: "Khmer",
      ki: "Kikuju",
      rw: "Ruanda",
      ky: "Kirgiisi",
      kv: "Komi",
      kg: "Kongo",
      ko: "Korea",
      kj: "Kuanjama",
      ku: "Kurdi",
      lo: "Lao",
      la: "Latina",
      lv: "Latvia",
      li: "Limburg",
      ln: "Lingala",
      lt: "Liettua",
      lb: "Luxemburg",
      lu: "Katanganluba",
      lg: "Ganda",
      mk: "Makedonia",
      mh: "Marshall",
      ml: "Malajalam",
      mi: "Maori",
      mr: "Marathi",
      ms: "Malaiji",
      mg: "Malagassi",
      mt: "Malta",
      mn: "Mongoli",
      na: "Nauru",
      nv: "Navajo",
      nr: "Etel\xE4-ndebele",
      nd: "Pohjois-ndebele",
      ng: "Ndonga",
      ne: "Nepali",
      nn: "Norjan nynorsk",
      nb: "Norjan bokm\xE5l",
      no: "Norja",
      ny: "Njand\u017Ea",
      oc: "Oksitaani",
      oj: "Od\u017Eibwa",
      or: "Orija",
      om: "Oromo",
      os: "Osseetti",
      pa: "Pand\u017Eabi",
      fa: "Persia",
      pi: "Paali",
      pl: "Puola",
      pt: "Portugali",
      ps: "Pa\u0161tu",
      qu: "Ket\u0161ua",
      rm: "Retoromaani",
      ro: "Romania",
      rn: "Rundi",
      ru: "Ven\xE4j\xE4",
      sg: "Sango",
      sa: "Sanskrit",
      si: "Sinhala",
      sk: "Slovakki",
      sl: "Sloveeni",
      se: "Pohjoissaame",
      sm: "Samoa",
      sn: "\u0161ona",
      sd: "Sindhi",
      so: "Somali",
      st: "Etel\xE4sotho",
      es: "Espanja",
      sc: "Sardi",
      sr: "Serbia",
      ss: "Swazi",
      su: "Sunda",
      sw: "Swahili",
      sv: "Ruotsi",
      ty: "Tahiti",
      ta: "Tamili",
      tt: "Tataari",
      te: "Telugu",
      tg: "Tad\u017Eikki",
      tl: "Tagalog",
      th: "Thai",
      bo: "Tiibet",
      ti: "Tigrinja",
      to: "Tonga",
      tn: "Tswana",
      ts: "Tsonga",
      tk: "Turkmeeni",
      tr: "Turkki",
      tw: "Twi",
      ug: "Uiguuri",
      uk: "Ukraina",
      ur: "Urdu",
      uz: "Uzbekki",
      ve: "Venda",
      vi: "Vietnam",
      vo: "Volap\xFCk",
      cy: "Kymri",
      wa: "Valloni",
      wo: "Wolof",
      xh: "Xhosa",
      yi: "Jiddi\u0161",
      yo: "Joruba",
      za: "Zhuang",
      zu: "Zulu"
    },
    da: {
      // Custom
      ax: "Kunstig",
      art: "Kunstig",
      xz: "Ingen dialog",
      xzz: "Ingen dialog",
      // Real
      aa: "Afar",
      ab: "Abkhasisk",
      af: "Afrikaans",
      ak: "Akan",
      sq: "Albansk",
      am: "Amharisk",
      ar: "Arabisk",
      an: "Aragonesisk",
      hy: "Armensk",
      as: "Assamesisk",
      av: "Avarisk",
      ae: "Avestan",
      ay: "Aymara",
      az: "Aserbajdsjansk",
      ba: "Bashkir",
      bm: "Bambara",
      eu: "Baskisk",
      be: "Hviderussisk",
      bn: "Bengali",
      bh: "Bh",
      bi: "Bislama",
      bs: "Bosnisk",
      br: "Bretonsk",
      bg: "Bulgarsk",
      my: "Burmesisk",
      ca: "Catalansk",
      ch: "Chamorro",
      ce: "Tjetjensk",
      zh: "Kinesisk",
      cu: "Kirkeslavisk",
      cv: "Chuvash",
      kw: "Cornisk",
      co: "Korsikansk",
      cr: "Cree",
      cs: "Tjekkisk",
      da: "Dansk",
      dv: "Divehi",
      nl: "Hollandsk",
      dz: "Dzongkha",
      en: "Engelsk",
      eo: "Esperanto",
      et: "Estisk",
      ee: "Ewe",
      fo: "F\xE6r\xF8sk",
      fj: "Fijiansk",
      fi: "Finsk",
      fr: "Fransk",
      fy: "Frisisk",
      ff: "Fulah",
      ka: "Georgisk",
      de: "Tysk",
      gd: "Skotsk g\xE6lisk",
      ga: "Irsk",
      gl: "Galicisk",
      gv: "Manx",
      el: "Gr\xE6sk",
      gn: "Guarani",
      gu: "Gujarati",
      ht: "Haitisk",
      ha: "Hausa",
      he: "Hebraisk",
      hz: "Herero",
      hi: "Hindi",
      ho: "Hirimotu",
      hr: "Kroatisk",
      hu: "Ungarsk",
      ig: "Igbo",
      is: "Islandsk",
      io: "Ido",
      ii: "Sichuan yi",
      iu: "Inuktitut",
      ie: "Interlingue",
      ia: "Interlingua",
      id: "Indonesisk",
      ik: "Inupiaq",
      it: "Italiensk",
      jv: "Javanesisk",
      ja: "Japansk",
      kl: "Gr\xF8nlandsk",
      kn: "Kannada",
      ks: "Kashmiri",
      kr: "Kanuri",
      kk: "Kasakhisk",
      km: "Khmer",
      ki: "Kikuyu",
      rw: "Kinyarwanda",
      ky: "Kirgisisk",
      kv: "Komi",
      kg: "Kongo",
      ko: "Koreansk",
      kj: "Kuanyama",
      ku: "Kurdisk",
      lo: "Lao",
      la: "Latin",
      lv: "Lettisk",
      li: "Limburgsk",
      ln: "Lingala",
      lt: "Litauisk",
      lb: "Luxembourgsk",
      lu: "Luba-Katanga",
      lg: "Ganda",
      mk: "Makedonsk",
      mh: "Marshallese",
      ml: "Malayalam",
      mi: "Maori",
      mr: "Marathisk",
      ms: "Malajisk",
      mg: "Malagassisk",
      mt: "Maltesisk",
      mn: "Mongolsk",
      na: "Nauru",
      nv: "Navajo",
      nr: "Sydndebele",
      nd: "Nordndebele",
      ng: "Ndonga",
      ne: "Nepalesisk",
      nn: "Nynorsk",
      nb: "Norsk bokm\xE5l",
      no: "Norsk",
      ny: "Nyanja",
      oc: "Occitansk",
      oj: "Ojibwa",
      or: "Oriya",
      om: "Oromo",
      os: "Ossetisk",
      pa: "Punjabisk",
      fa: "Persisk",
      pi: "Pali",
      pl: "Polsk",
      pt: "Portugisisk",
      ps: "Pashto",
      qu: "Quechua",
      rm: "R\xE6toromansk",
      ro: "Rum\xE6nsk",
      rn: "Rundi",
      ru: "Russisk",
      sg: "Sango",
      sa: "Sanskrit",
      si: "Singalesisk",
      sk: "Slovakisk",
      sl: "Slovensk",
      se: "Nordsamisk",
      sm: "Samoansk",
      sn: "Shona",
      sd: "Sindhi",
      so: "Somali",
      st: "Sydsotho",
      es: "Spansk",
      sc: "Sardinsk",
      sr: "Serbisk",
      ss: "Swati",
      su: "Sundanesisk",
      sw: "Swahili",
      sv: "Svensk",
      ty: "Tahitiansk",
      ta: "Tamil",
      tt: "Tatarisk",
      te: "Telugu",
      tg: "Tadsjikisk",
      tl: "Tagalog",
      th: "Thai",
      bo: "Tibetansk",
      ti: "Tigrinya",
      to: "Tongansk",
      tn: "Tswana",
      ts: "Tsonga",
      tk: "Turkmensk",
      tr: "Tyrkisk",
      tw: "Twi",
      ug: "Uygurisk",
      uk: "Ukrainsk",
      ur: "Urdu",
      uz: "Usbekisk",
      ve: "Venda",
      vi: "Vietnamesisk",
      vo: "Volapyk",
      cy: "Walisisk",
      wa: "Vallonsk",
      wo: "Wolof",
      xh: "IsiXhosa",
      yi: "Jiddisch",
      yo: "Yoruba",
      za: "Zhuang",
      zu: "Zulu"
    },
    en: {
      // Custom
      ax: "Artificial",
      art: "Artificial",
      xz: "No dialog",
      xzz: "No dialog",
      // Real
      aa: "Afar",
      ab: "Abkhazian",
      af: "Afrikaans",
      ak: "Akan",
      sq: "Albanian",
      am: "Amharic",
      ar: "Arabic",
      an: "Aragonese",
      hy: "Armenian",
      as: "Assamese",
      av: "Avaric",
      ae: "Avestan",
      ay: "Aymara",
      az: "Azerbaijani",
      ba: "Bashkir",
      bm: "Bambara",
      eu: "Basque",
      be: "Belarusian",
      bn: "Bangla",
      bh: "Bh",
      bi: "Bislama",
      bs: "Bosnian",
      br: "Breton",
      bg: "Bulgarian",
      my: "Burmese",
      ca: "Catalan",
      ch: "Chamorro",
      ce: "Chechen",
      zh: "Chinese",
      cu: "Church Slavic",
      cv: "Chuvash",
      kw: "Cornish",
      co: "Corsican",
      cr: "Cree",
      cs: "Czech",
      da: "Danish",
      dv: "Divehi",
      nl: "Dutch",
      dz: "Dzongkha",
      en: "English",
      eo: "Esperanto",
      et: "Estonian",
      ee: "Ewe",
      fo: "Faroese",
      fj: "Fijian",
      fi: "Finnish",
      fr: "French",
      fy: "Western Frisian",
      ff: "Fulah",
      ka: "Georgian",
      de: "German",
      gd: "Scottish Gaelic",
      ga: "Irish",
      gl: "Galician",
      gv: "Manx",
      el: "Greek",
      gn: "Guarani",
      gu: "Gujarati",
      ht: "Haitian Creole",
      ha: "Hausa",
      he: "Hebrew",
      hz: "Herero",
      hi: "Hindi",
      ho: "Hiri Motu",
      hr: "Croatian",
      hu: "Hungarian",
      ig: "Igbo",
      is: "Icelandic",
      io: "Ido",
      ii: "Sichuan Yi",
      iu: "Inuktitut",
      ie: "Interlingue",
      ia: "Interlingua",
      id: "Indonesian",
      ik: "Inupiaq",
      it: "Italian",
      jv: "Javanese",
      ja: "Japanese",
      kl: "Kalaallisut",
      kn: "Kannada",
      ks: "Kashmiri",
      kr: "Kanuri",
      kk: "Kazakh",
      km: "Khmer",
      ki: "Kikuyu",
      rw: "Kinyarwanda",
      ky: "Kyrgyz",
      kv: "Komi",
      kg: "Kongo",
      ko: "Korean",
      kj: "Kuanyama",
      ku: "Kurdish",
      lo: "Lao",
      la: "Latin",
      lv: "Latvian",
      li: "Limburgish",
      ln: "Lingala",
      lt: "Lithuanian",
      lb: "Luxembourgish",
      lu: "Luba-Katanga",
      lg: "Ganda",
      mk: "Macedonian",
      mh: "Marshallese",
      ml: "Malayalam",
      mi: "Maori",
      mr: "Marathi",
      ms: "Malay",
      mg: "Malagasy",
      mt: "Maltese",
      mn: "Mongolian",
      na: "Nauru",
      nv: "Navajo",
      nr: "South Ndebele",
      nd: "North Ndebele",
      ng: "Ndonga",
      ne: "Nepali",
      nn: "Norwegian Nynorsk",
      nb: "Norwegian Bokm\xE5l",
      no: "Norwegian",
      ny: "Nyanja",
      oc: "Occitan",
      oj: "Ojibwa",
      or: "Odia",
      om: "Oromo",
      os: "Ossetic",
      pa: "Punjabi",
      fa: "Persian",
      pi: "Pali",
      pl: "Polish",
      pt: "Portuguese",
      ps: "Pashto",
      qu: "Quechua",
      rm: "Romansh",
      ro: "Romanian",
      rn: "Rundi",
      ru: "Russian",
      sg: "Sango",
      sa: "Sanskrit",
      si: "Sinhala",
      sk: "Slovak",
      sl: "Slovenian",
      se: "Northern Sami",
      sm: "Samoan",
      sn: "Shona",
      sd: "Sindhi",
      so: "Somali",
      st: "Southern Sotho",
      es: "Spanish",
      sc: "Sardinian",
      sr: "Serbian",
      ss: "Swati",
      su: "Sundanese",
      sw: "Swahili",
      sv: "Swedish",
      ty: "Tahitian",
      ta: "Tamil",
      tt: "Tatar",
      te: "Telugu",
      tg: "Tajik",
      tl: "Tagalog",
      th: "Thai",
      bo: "Tibetan",
      ti: "Tigrinya",
      to: "Tongan",
      tn: "Tswana",
      ts: "Tsonga",
      tk: "Turkmen",
      tr: "Turkish",
      tw: "Twi",
      ug: "Uyghur",
      uk: "Ukrainian",
      ur: "Urdu",
      uz: "Uzbek",
      ve: "Venda",
      vi: "Vietnamese",
      vo: "Volap\xFCk",
      cy: "Welsh",
      wa: "Walloon",
      wo: "Wolof",
      xh: "Xhosa",
      yi: "Yiddish",
      yo: "Yoruba",
      za: "Zhuang",
      zu: "Zulu"
    }
  };
  const translatedLanguage = get(
    data,
    `[${getLocaleFromIsoCode(locale)}][${getLocaleFromIsoCode(language) || language}]`,
    `Unknown (${language})`
  );
  const has5_1sound = sound == null ? void 0 : sound.some((s) => (s == null ? void 0 : s.channels) === "5.1");
  if (has5_1sound) {
    return `${translatedLanguage} (5.1)`;
  }
  return translatedLanguage;
};

// src/~utils/languageUtils/getSupportedAppLocale.ts
var supportedAppLocals = [
  "sv" /* sv */,
  "fi" /* fi */,
  "da" /* da */,
  "no" /* no */
];
var defaultAppLocale = (brand) => brand === "Blockbuster" /* Blockbuster */ ? "da" /* da */ : "sv" /* sv */;
var getSupportedAppLocale = (locale, brand) => {
  if (!locale)
    return defaultAppLocale(brand);
  return supportedAppLocals.includes(locale) ? locale : defaultAppLocale(brand);
};

// src/~utils/languageUtils/createLanguagePrioritySort.ts
var DEFAULT_PRIORITY = ["en", "sv", "da", "no", "fi"];
var getLanguagePriority = (locale) => {
  return [locale, ...DEFAULT_PRIORITY.filter((l) => l !== locale)];
};
function createLanguagePrioritySort({
  locale,
  languageValue = (item) => String(item),
  localizeItem = ({ item, formatLanguage }) => formatLanguage(String(item)),
  transformRemaining = (items) => items.sort()
}) {
  const languagePriority = getLanguagePriority(locale);
  const formatLanguage = (language) => getDisplayLanguage({
    language,
    locale
  });
  return (items) => {
    const prioritisedLanguageMap = {};
    const remainingLanguages = [];
    for (const item of items) {
      const language = languageValue(item);
      const localizedItem = localizeItem({ item, formatLanguage });
      if (languagePriority.includes(language)) {
        prioritisedLanguageMap[language] = localizedItem;
        continue;
      }
      remainingLanguages.push(localizedItem);
    }
    const prioritisedLanguages = languagePriority.reduce(
      (acc, language) => {
        const item = prioritisedLanguageMap[language];
        if (!item)
          return acc;
        return [...acc, item];
      },
      []
    );
    return [
      ...prioritisedLanguages,
      // sort the remaining items
      ...transformRemaining(remainingLanguages)
    ];
  };
}

// src/~utils/LRUCache/LRUCacheNode.ts
var LRUCacheNode = class {
  constructor(key3, value, options) {
    const {
      entryExpirationTimeInMS = null,
      next = null,
      prev = null,
      onEntryEvicted,
      onEntryMarkedAsMostRecentlyUsed,
      clone,
      cloneFn
    } = options != null ? options : {};
    if (typeof entryExpirationTimeInMS === "number" && (entryExpirationTimeInMS <= 0 || Number.isNaN(entryExpirationTimeInMS))) {
      throw new Error(
        "entryExpirationTimeInMS must either be null (no expiry) or greater than 0"
      );
    }
    this.clone = clone != null ? clone : false;
    this.cloneFn = cloneFn != null ? cloneFn : this.defaultClone;
    this.key = key3;
    this.internalValue = this.clone ? this.cloneFn(value) : value;
    this.created = Date.now();
    this.entryExpirationTimeInMS = entryExpirationTimeInMS;
    this.next = next;
    this.prev = prev;
    this.onEntryEvicted = onEntryEvicted;
    this.onEntryMarkedAsMostRecentlyUsed = onEntryMarkedAsMostRecentlyUsed;
  }
  get value() {
    return this.clone ? this.cloneFn(this.internalValue) : this.internalValue;
  }
  get isExpired() {
    return typeof this.entryExpirationTimeInMS === "number" && Date.now() - this.created > this.entryExpirationTimeInMS;
  }
  invokeOnEvicted() {
    if (this.onEntryEvicted) {
      const { key: key3, value, isExpired } = this;
      this.onEntryEvicted({ key: key3, value, isExpired });
    }
  }
  invokeOnEntryMarkedAsMostRecentlyUsed() {
    if (this.onEntryMarkedAsMostRecentlyUsed) {
      const { key: key3, value } = this;
      this.onEntryMarkedAsMostRecentlyUsed({ key: key3, value });
    }
  }
  defaultClone(value) {
    if (typeof value === "boolean" || typeof value === "string" || typeof value === "number") {
      return value;
    }
    return JSON.parse(JSON.stringify(value));
  }
};

// src/~utils/LRUCache/LRUCache.ts
var LRUCache = class {
  /**
   * Creates a new instance of the LRUCache.
   *
   * @param options Additional configuration options for the LRUCache.
   *
   * @example
   * ```typescript
   * // No options.
   * const cache = new LRUCache();
   *
   * // With options.
   * const cache = new LRUCache({
   *  entryExpirationTimeInMS: 10000
   * });
   * ```
   */
  constructor(options) {
    this.lookupTable = /* @__PURE__ */ new Map();
    this.head = null;
    this.tail = null;
    const {
      maxSize = 25,
      entryExpirationTimeInMS = null,
      onEntryEvicted,
      onEntryMarkedAsMostRecentlyUsed,
      cloneFn,
      clone
    } = options != null ? options : {};
    if (Number.isNaN(maxSize) || maxSize <= 0) {
      throw new Error("maxSize must be greater than 0.");
    }
    if (typeof entryExpirationTimeInMS === "number" && (entryExpirationTimeInMS <= 0 || Number.isNaN(entryExpirationTimeInMS))) {
      throw new Error(
        "entryExpirationTimeInMS must either be null (no expiry) or greater than 0"
      );
    }
    this.maxSizeInternal = maxSize;
    this.entryExpirationTimeInMS = entryExpirationTimeInMS;
    this.onEntryEvicted = onEntryEvicted;
    this.onEntryMarkedAsMostRecentlyUsed = onEntryMarkedAsMostRecentlyUsed;
    this.clone = clone;
    this.cloneFn = cloneFn;
  }
  /**
   * Returns the number of entries in the LRUCache object.
   * If the cache has entryExpirationTimeInMS set, expired entries will be removed before the size is returned.
   *
   * @returns The number of entries in the cache.
   *
   * @example
   * ```typescript
   * const cache = new LRUCache();
   *
   * cache.set('testKey', 'testValue');
   *
   * const size = cache.size;
   *
   * // Will log 1
   * console.log(size);
   * ```
   */
  get size() {
    this.cleanCache();
    return this.lookupTable.size;
  }
  /**
   * Returns the number of entries that can still be added to the LRUCache without evicting existing entries.
   *
   * @returns The number of entries that can still be added without evicting existing entries.
   *
   * @example
   * ```typescript
   * const cache = new LRUCache({ maxSize: 10 });
   *
   * cache.set('testKey', 'testValue');
   *
   * const remainingSize = cache.remainingSize;
   *
   * // Will log 9 due to 9 spots remaining before reaching maxSize of 10.
   * console.log(remainingSize);
   * ```
   */
  get remainingSize() {
    return this.maxSizeInternal - this.size;
  }
  /**
   * Returns the most recently used (newest) entry in the cache.
   * This will not mark the entry as recently used.
   * If the newest node is expired, it will be removed.
   *
   * @returns The most recently used (newest) entry in the cache.
   *
   * @example
   * ```typescript
   * const cache = new LRUCache({ maxSize: 10 });
   *
   * cache.set('testKey', 'testValue');
   *
   * const newest = cache.newest;
   *
   * // Will log testValue
   * console.log(newest.value);
   *
   * // Will log testKey
   * console.log(newest.key);
   * ```
   */
  get newest() {
    if (!this.head) {
      return null;
    }
    if (this.head.isExpired) {
      this.removeNodeFromListAndLookupTable(this.head);
      return this.newest;
    }
    return this.mapNodeToEntry(this.head);
  }
  /**
   * Returns the least recently used (oldest) entry in the cache.
   * This will not mark the entry as recently used.
   * If the oldest node is expired, it will be removed.
   *
   * @returns The least recently used (oldest) entry in the cache.
   *
   * @example
   * ```typescript
   * const cache = new LRUCache({ maxSize: 10 });
   *
   * cache.set('testKey', 'testValue');
   *
   * const oldest = cache.oldest;
   *
   * // Will log testValue
   * console.log(oldest.value);
   *
   * // Will log testKey
   * console.log(oldest.key);
   * ```
   */
  get oldest() {
    if (!this.tail) {
      return null;
    }
    if (this.tail.isExpired) {
      this.removeNodeFromListAndLookupTable(this.tail);
      return this.oldest;
    }
    return this.mapNodeToEntry(this.tail);
  }
  /**
   * Gets or sets the maxSize of the cache.
   * This will evict the least recently used entries if needed to reach new maxSize.
   *
   * @param value The new value for maxSize. Must be greater than 0.
   *
   * @example
   * ```typescript
   * const cache = new LRUCache({ maxSize: 10 });
   *
   * cache.set('testKey', 'testValue');
   *
   * // Will be 10
   * const maxSize = cache.maxSize;
   *
   * // Set new maxSize to 5. If there are more than 5 items in the cache, the least recently used entries will be removed until cache size is 5.
   * cache.maxSize = 5;
   * ```
   */
  get maxSize() {
    return this.maxSizeInternal;
  }
  set maxSize(value) {
    if (Number.isNaN(value) || value <= 0) {
      throw new Error("maxSize must be greater than 0.");
    }
    this.maxSizeInternal = value;
    this.enforceSizeLimit();
  }
  /**
   * Sets the value for the key in the LRUCache object. Returns the LRUCache object.
   * This marks the newly added entry as the most recently used entry.
   * If adding the new entry makes the cache size go above maxSize,
   * this will evict the least recently used entries until size is equal to maxSize.
   *
   * @param key The key of the entry.
   * @param value The value to set for the key.
   * @param entryOptions Additional configuration options for the cache entry.
   *
   * @returns The LRUCache instance.
   *
   * @example
   * ```typescript
   * const cache = new LRUCache();
   *
   * // Set the key testKey to value testValue
   * cache.set('testKey', 'testValue');
   *
   * // Set the key key2 to value value2. Pass in optional options.
   * cache.set('key2', 'value2', { entryExpirationTimeInMS: 10 });
   * ```
   */
  set(key3, value, entryOptions) {
    const currentNodeForKey = this.lookupTable.get(key3);
    if (currentNodeForKey) {
      this.removeNodeFromListAndLookupTable(currentNodeForKey);
    }
    const node = new LRUCacheNode(key3, value, __spreadValues({
      entryExpirationTimeInMS: this.entryExpirationTimeInMS,
      onEntryEvicted: this.onEntryEvicted,
      onEntryMarkedAsMostRecentlyUsed: this.onEntryMarkedAsMostRecentlyUsed,
      clone: this.clone,
      cloneFn: this.cloneFn
    }, entryOptions));
    this.setNodeAsHead(node);
    this.lookupTable.set(key3, node);
    this.enforceSizeLimit();
    return this;
  }
  /**
   * Returns the value associated to the key, or null if there is none or if the entry is expired.
   * If an entry is returned, this marks the returned entry as the most recently used entry.
   *
   * @param key The key of the entry to get.
   *
   * @returns The cached value or null.
   *
   * @example
   * ```typescript
   * const cache = new LRUCache();
   *
   * // Set the key testKey to value testValue
   * cache.set('testKey', 'testValue');
   *
   * // Will be 'testValue'. Entry will now be most recently used.
   * const item1 = cache.get('testKey');
   *
   * // Will be null
   * const item2 = cache.get('keyNotInCache');
   * ```
   */
  get(key3) {
    const node = this.lookupTable.get(key3);
    if (!node) {
      return null;
    }
    if (node.isExpired) {
      this.removeNodeFromListAndLookupTable(node);
      return null;
    }
    this.setNodeAsHead(node);
    return node.value;
  }
  /**
   * Returns the value associated to the key, or null if there is none or if the entry is expired.
   * If an entry is returned, this will not mark the entry as most recently accessed.
   * Useful if a value is needed but the order of the cache should not be changed.
   *
   * @param key The key of the entry to get.
   *
   * @returns The cached value or null.
   *
   * @example
   * ```typescript
   * const cache = new LRUCache();
   *
   * // Set the key testKey to value testValue
   * cache.set('testKey', 'testValue');
   *
   * // Will be 'testValue'
   * const item1 = cache.peek('testKey');
   *
   * // Will be null
   * const item2 = cache.peek('keyNotInCache');
   * ```
   */
  peek(key3) {
    const node = this.lookupTable.get(key3);
    if (!node) {
      return null;
    }
    if (node.isExpired) {
      this.removeNodeFromListAndLookupTable(node);
      return null;
    }
    return node.value;
  }
  /**
   * Deletes the entry for the passed in key.
   *
   * @param key The key of the entry to delete
   *
   * @returns True if an element in the LRUCache object existed and has been removed,
   * or false if the element does not exist.
   *
   * @example
   * ```typescript
   * const cache = new LRUCache();
   *
   * // Set the key testKey to value testValue
   * cache.set('testKey', 'testValue');
   *
   * // Will be true
   * const wasDeleted = cache.delete('testKey');
   *
   * // Will be false
   * const wasDeleted2 = cache.delete('keyNotInCache');
   * ```
   */
  delete(key3) {
    const node = this.lookupTable.get(key3);
    if (!node) {
      return false;
    }
    return this.removeNodeFromListAndLookupTable(node);
  }
  /**
   * Returns a boolean asserting whether a value has been associated to the key in the LRUCache object or not.
   * This does not mark the entry as recently used.
   * If the cache has a key but the entry is expired, it will be removed and false will be returned.
   *
   * @param key The key of the entry to check if exists
   *
   * @returns true if the cache contains the supplied key. False if not.
   *
   * @example
   * ```typescript
   * const cache = new LRUCache();
   *
   * // Set the key testKey to value testValue
   * cache.set('testKey', 'testValue');
   *
   * // Will be true
   * const wasDeleted = cache.has('testKey');
   *
   * // Will be false
   * const wasDeleted2 = cache.has('keyNotInCache');
   * ```
   */
  has(key3) {
    const node = this.lookupTable.get(key3);
    if (!node) {
      return false;
    }
    if (node.isExpired) {
      this.removeNodeFromListAndLookupTable(node);
      return false;
    }
    return true;
  }
  /**
   * Removes all entries in the cache.
   *
   * @example
   * ```typescript
   * const cache = new LRUCache();
   *
   * // Set the key testKey to value testValue
   * cache.set('testKey', 'testValue');
   *
   * // Clear cache.
   * cache.clear();
   * ```
   */
  clear() {
    this.head = null;
    this.tail = null;
    this.lookupTable.clear();
  }
  /**
   * Searches the cache for an entry matching the passed in condition.
   * Expired entries will be skipped (and removed).
   * If multiply entries in the cache match the condition, the most recently used entry will be returned.
   * If an entry is returned, this marks the returned entry as the most recently used entry.
   *
   * @param condition The condition to apply to each entry in the
   *
   * @returns The first cache entry to match the condition. Null if none match.
   *
   * @example
   * ```typescript
   * const cache = new LRUCache();
   *
   * // Set the key testKey to value testValue
   * cache.set('testKey', 'testValue');
   *
   * // item will be { key: 'testKey', value: 'testValue }
   * const item = cache.find(entry => {
   *   const { key, value } = entry;
   *
   *   if (key === 'testKey' || value === 'something') {
   *     return true;
   *   }
   *
   *   return false;
   * });
   *
   * // item2 will be null
   * const item2 = cache.find(entry => entry.key === 'notInCache');
   * ```
   */
  find(condition) {
    let node = this.head;
    while (node) {
      if (node.isExpired) {
        const next = node.next;
        this.removeNodeFromListAndLookupTable(node);
        node = next;
        continue;
      }
      const entry = this.mapNodeToEntry(node);
      if (condition(entry)) {
        this.setNodeAsHead(node);
        return entry;
      }
      node = node.next;
    }
    return null;
  }
  /**
   * Iterates over and applies the callback function to each entry in the cache.
   * Iterates in order from most recently accessed entry to least recently.
   * Expired entries will be skipped (and removed).
   * No entry will be marked as recently used.
   *
   * @param callback the callback function to apply to the entry
   *
   * @example
   * ```typescript
   * const cache = new LRUCache();
   *
   * // Set the key testKey to value testValue
   * cache.set('testKey', 'testValue');
   *
   * cache.forEach((key, value, index) => {
   *   // do something with key, value, and/or index
   * });
   * ```
   */
  forEach(callback) {
    let node = this.head;
    let index = 0;
    while (node) {
      if (node.isExpired) {
        const next = node.next;
        this.removeNodeFromListAndLookupTable(node);
        node = next;
        continue;
      }
      callback(node.value, node.key, index);
      node = node.next;
      index++;
    }
  }
  /**
   * Creates a Generator which can be used with for ... of ... to iterate over the cache values.
   * Iterates in order from most recently accessed entry to least recently.
   * Expired entries will be skipped (and removed).
   * No entry will be marked as accessed.
   *
   * @returns A Generator for the cache values.
   *
   * @example
   * ```typescript
   * const cache = new LRUCache();
   *
   * // Set the key testKey to value testValue
   * cache.set('testKey', 'testValue');
   *
   * for (const value of cache.values()) {
   *   // do something with the value
   * }
   * ```
   */
  *values() {
    let node = this.head;
    while (node) {
      if (node.isExpired) {
        const next = node.next;
        this.removeNodeFromListAndLookupTable(node);
        node = next;
        continue;
      }
      yield node.value;
      node = node.next;
    }
  }
  /**
   * Creates a Generator which can be used with for ... of ... to iterate over the cache keys.
   * Iterates in order from most recently accessed entry to least recently.
   * Expired entries will be skipped (and removed).
   * No entry will be marked as accessed.
   *
   * @returns A Generator for the cache keys.
   *
   * @example
   * ```typescript
   * const cache = new LRUCache();
   *
   * // Set the key testKey to value testValue
   * cache.set('testKey', 'testValue');
   *
   * for (const key of cache.keys()) {
   *   // do something with the key
   * }
   * ```
   */
  *keys() {
    let node = this.head;
    while (node) {
      if (node.isExpired) {
        const next = node.next;
        this.removeNodeFromListAndLookupTable(node);
        node = next;
        continue;
      }
      yield node.key;
      node = node.next;
    }
  }
  /**
   * Creates a Generator which can be used with for ... of ... to iterate over the cache entries.
   * Iterates in order from most recently accessed entry to least recently.
   * Expired entries will be skipped (and removed).
   * No entry will be marked as accessed.
   *
   * @returns A Generator for the cache entries.
   *
   * @example
   * ```typescript
   * const cache = new LRUCache();
   *
   * // Set the key testKey to value testValue
   * cache.set('testKey', 'testValue');
   *
   * for (const entry of cache.entries()) {
   *   const { key, value } = entry;
   *   // do something with the entry
   * }
   * ```
   */
  *entries() {
    let node = this.head;
    while (node) {
      if (node.isExpired) {
        const next = node.next;
        this.removeNodeFromListAndLookupTable(node);
        node = next;
        continue;
      }
      yield this.mapNodeToEntry(node);
      node = node.next;
    }
  }
  /**
   * Creates a Generator which can be used with for ... of ... to iterate over the cache entries.
   * Iterates in order from most recently accessed entry to least recently.
   * Expired entries will be skipped (and removed).
   * No entry will be marked as accessed.
   *
   * @returns A Generator for the cache entries.
   *
   * @example
   * ```typescript
   * const cache = new LRUCache();
   *
   * // Set the key testKey to value testValue
   * cache.set('testKey', 'testValue');
   *
   * for (const entry of cache) {
   *   const { key, value } = entry;
   *   // do something with the entry
   * }
   * ```
   */
  *[Symbol.iterator]() {
    let node = this.head;
    while (node) {
      if (node.isExpired) {
        const next = node.next;
        this.removeNodeFromListAndLookupTable(node);
        node = next;
        continue;
      }
      yield this.mapNodeToEntry(node);
      node = node.next;
    }
  }
  enforceSizeLimit() {
    let node = this.tail;
    while (node !== null && this.size > this.maxSizeInternal) {
      const prev = node.prev;
      this.removeNodeFromListAndLookupTable(node);
      node = prev;
    }
  }
  mapNodeToEntry({
    key: key3,
    value
  }) {
    return {
      key: key3,
      value
    };
  }
  setNodeAsHead(node) {
    this.removeNodeFromList(node);
    if (!this.head) {
      this.head = node;
      this.tail = node;
    } else {
      node.next = this.head;
      this.head.prev = node;
      this.head = node;
    }
    node.invokeOnEntryMarkedAsMostRecentlyUsed();
  }
  removeNodeFromList(node) {
    if (node.prev !== null) {
      node.prev.next = node.next;
    }
    if (node.next !== null) {
      node.next.prev = node.prev;
    }
    if (this.head === node) {
      this.head = node.next;
    }
    if (this.tail === node) {
      this.tail = node.prev;
    }
    node.next = null;
    node.prev = null;
  }
  removeNodeFromListAndLookupTable(node) {
    node.invokeOnEvicted();
    this.removeNodeFromList(node);
    return this.lookupTable.delete(node.key);
  }
  cleanCache() {
    if (!this.entryExpirationTimeInMS) {
      return;
    }
    const expiredNodes = [];
    for (const node of this.lookupTable.values()) {
      if (node.isExpired) {
        expiredNodes.push(node);
      }
    }
    expiredNodes.forEach((node) => this.removeNodeFromListAndLookupTable(node));
  }
};

// src/~utils/mediaUtils/mediaUtils.ts
var isMovie = (media) => (media == null ? void 0 : media.__typename) === "Movie";
var isSeries = (media) => (media == null ? void 0 : media.__typename) === "Series";
var isSeason = (media) => (media == null ? void 0 : media.__typename) === "Season";
var isEpisode = (media) => (media == null ? void 0 : media.__typename) === "Episode";
var isPlayableMedia = (media) => (media == null ? void 0 : media.__typename) === "Episode" || (media == null ? void 0 : media.__typename) === "Movie";
var hasTrailer = (mediaItem) => {
  var _a;
  return "manifests" in mediaItem && !!((_a = mediaItem.manifests) == null ? void 0 : _a.trailers);
};
function removeAbbreviationFromSlug(slug3) {
  return slug3.replace(/-s\d{2,3}e\d{2,3}$/, "");
}

// src/~utils/muxUtils/getMuxData.ts
var getMuxData = ({
  playerVersion = "1.0.0",
  videoCdn,
  playable,
  accountId,
  initTime,
  muxKey,
  device,
  overrideDeviceCategory,
  overrideDeviceManufacturer,
  overrideDeviceName,
  subPropertyId,
  viewSessionId,
  overrideOsVersion,
  brand,
  appVersion,
  locale,
  drm,
  profileName
}) => {
  var _a;
  return {
    env_key: muxKey,
    player_name: device.type,
    sub_property_id: subPropertyId,
    view_session_id: viewSessionId,
    player_version: playerVersion,
    player_init_time: initTime,
    viewer_user_id: accountId != null ? accountId : "anonymous",
    view_drm_type: drm,
    video_id: playable.slug,
    video_type: playable.__typename,
    video_title: playable.display.originalTitle,
    video_series: playable.__typename === "Episode" ? playable.seriesSlug : void 0,
    video_content_type: drm === "none" ? "trailer" : playable.__typename === "Episode" ? "episode" : "movie",
    video_duration: ((_a = playable.duration) != null ? _a : 0) * 60 * 1e3,
    video_stream_type: drm === "none" ? "Trailer" : "Feature",
    video_cdn: videoCdn,
    // Overrides
    viewer_device_category: overrideDeviceCategory,
    viewer_device_manufacturer: overrideDeviceManufacturer,
    viewer_device_name: overrideDeviceName,
    viewer_os_version: overrideOsVersion,
    // Custom
    custom_1: brand,
    custom_2: appVersion,
    custom_3: locale,
    custom_4: profileName != null ? profileName : "UNKNOWN"
  };
};

// src/~utils/navigationUtils/types.ts
var NavigationItemId = {
  Search: "search",
  Start: "start",
  Home: "home",
  Discover: "discover",
  Movies: "movies",
  Series: "series",
  Kids: "kids",
  MyMovies: "myMovies",
  More: "more",
  New: "new",
  Coming: "coming",
  Bundles: "bundles",
  Discount: "discount",
  Settings: "settings",
  Downloads: "downloads",
  Support: "support",
  Vouchers: "vouchers",
  Login: "login"
};
var DeviceMenu = {
  Bottom: "bottom",
  Left: "left",
  More: "more",
  Top: "top",
  TopRight: "topRight",
  Hidden: "hidden"
};

// src/~utils/navigationUtils/slugs.ts
var getSlugs = (locale) => {
  const newSlugs = {};
  Object.entries(slugs).forEach(([keyString, slugItem]) => {
    const key3 = keyString;
    if ("global" in slugItem) {
      newSlugs[key3] = slugItem.global;
      return;
    }
    newSlugs[key3] = slugItem[locale];
  });
  return newSlugs;
};
var slugs = {
  home: {
    global: "home"
  },
  start: {
    global: "start"
  },
  support: {
    en: "hjalp-och-felsokning",
    sv: "hjalp-och-felsokning",
    da: "hj\xE6lp-og-fejls\xF8gning",
    no: "hjelp-og-feils\xF8king",
    fi: "tuki-ja-vianetsinta"
  },
  discover: {
    en: "teman",
    sv: "teman",
    da: "temaer",
    no: "temaer",
    fi: "katergoriat"
  },
  newSlug: {
    en: "nytt",
    sv: "nytt",
    da: "nyt",
    no: "nytt",
    fi: "uutta-kaupassa"
  },
  coming: {
    en: "kommer-snart",
    sv: "kommer-snart",
    da: "kommer-snart",
    no: "kommer-snart",
    fi: "tulossa-pian"
  },
  vouchers: {
    en: "voucher",
    sv: "voucher",
    da: "voucher",
    fi: "voucher",
    no: "voucher"
  },
  movies: {
    en: "filmer",
    sv: "filmer",
    da: "film",
    no: "filmer",
    fi: "elokuvat"
  },
  series: {
    en: "tv-serier",
    sv: "tv-serier",
    da: "tv-serier",
    no: "tv-serier",
    fi: "tv"
  },
  myMovies: {
    en: "mina-filmer",
    sv: "mina-filmer",
    da: "mine-film",
    no: "mine-filmer",
    fi: "omat-elokuvat"
  },
  kids: {
    en: "barn",
    sv: "barn",
    da: "b\xF8rn",
    no: "barn",
    fi: "lapset"
  },
  giftcards: {
    en: "presentkort",
    sv: "presentkort",
    da: "gavekort",
    no: "gavekort",
    fi: "lahjakortti"
  },
  discounts: {
    en: "prissankt",
    sv: "prissankt",
    da: "nedsat-pris",
    no: "redusert-pris",
    fi: "alennettu-hinta"
  },
  bundles: {
    en: "filmpaket",
    sv: "filmpaket",
    da: "filmsamlinger",
    no: "filmsamlinger",
    fi: "elokuvakokoelmat"
  },
  marketingConsent: {
    global: "marketing-consent-modal"
  }
};

// src/~utils/navigationUtils/utils.ts
var getNavigationItems = ({ locale }) => {
  const slugs2 = getSlugs(locale);
  return {
    home: {
      id: "home",
      type: "contentCollection",
      params: { slug: slugs2.home },
      icon: "home",
      titleKey: "navigation.home"
    },
    start: {
      id: "start",
      type: "contentCollection",
      params: { slug: slugs2.start },
      icon: "home",
      titleKey: "navigation.start"
    },
    search: {
      id: "search",
      type: "custom",
      params: {},
      icon: "search",
      titleKey: "navigation.search"
    },
    discover: {
      id: "discover",
      type: "contentCollection",
      params: { slug: slugs2.discover },
      icon: "lightbulb",
      titleKey: "navigation.discover"
    },
    movies: {
      id: "movies",
      type: "contentCollection",
      params: { slug: slugs2.movies },
      icon: "movies",
      titleKey: "navigation.movies"
    },
    series: {
      id: "series",
      type: "contentCollection",
      params: { slug: slugs2.series },
      icon: "series",
      titleKey: "navigation.series"
    },
    kids: {
      id: "kids",
      type: "contentCollection",
      params: { slug: slugs2.kids },
      icon: "kids",
      titleKey: "navigation.kids"
    },
    myMovies: {
      id: "myMovies",
      type: "contentCollection",
      params: { slug: slugs2.myMovies },
      icon: "my-movies",
      titleKey: "navigation.mymedia"
    },
    more: {
      id: "more",
      type: "custom",
      params: {},
      icon: "dots",
      titleKey: "navigation.more"
    },
    new: {
      id: "new",
      type: "contentCollection",
      params: { slug: slugs2.newSlug },
      icon: "new",
      titleKey: "navigation.new"
    },
    coming: {
      id: "coming",
      type: "contentCollection",
      params: { slug: slugs2.coming },
      icon: "coming",
      titleKey: "glossary.coming_soon"
    },
    bundles: {
      id: "bundles",
      type: "list",
      params: { slug: slugs2.bundles },
      icon: "bundles",
      titleKey: "navigation.bundles"
    },
    discount: {
      id: "discount",
      type: "list",
      params: { slug: slugs2.discounts },
      icon: "percent",
      titleKey: "navigation.discounted"
    },
    vouchers: {
      id: "vouchers",
      type: "contentCollection",
      params: { slug: slugs2.vouchers },
      icon: "gift",
      titleKey: "navigation.vouchers"
    },
    downloads: {
      id: "downloads",
      type: "custom",
      params: {},
      icon: "download",
      titleKey: "navigation.downloads"
    },
    support: {
      id: "support",
      type: "custom",
      params: { slug: slugs2.support },
      icon: "help",
      titleKey: "navigation.support"
    },
    settings: {
      id: "settings",
      type: "custom",
      params: {},
      icon: "settings",
      titleKey: "navigation.settings"
    },
    login: {
      id: "login",
      type: "custom",
      params: {},
      icon: "my-movies",
      titleKey: "navigation.login"
    }
  };
};
var getConfig = (params) => {
  return {
    tv: {
      left: [
        "search",
        "home",
        "discover",
        "movies",
        "series",
        "kids",
        "myMovies",
        "more"
      ],
      more: ["new", "coming", "bundles", "discount", "settings"],
      hidden: ["downloads", "vouchers", "support", "login", "start"]
    },
    mobile: {
      top: ["movies", "series", "kids"],
      bottom: ["home", "myMovies", "downloads", "search", "more"],
      more: [
        "new",
        "discover",
        "coming",
        "bundles",
        "discount",
        "settings",
        "support"
      ],
      hidden: ["vouchers", "login", "start"]
    },
    web: {
      top: [
        { id: "home", visible: params.isLoggedIn },
        { id: "start", visible: !params.isLoggedIn },
        "movies",
        "new",
        "kids",
        "coming",
        "vouchers",
        "discover",
        "series",
        "discount",
        "bundles",
        "support"
      ],
      topRight: [
        "search",
        { id: "login", visible: !params.isLoggedIn },
        { id: "myMovies", visible: params.isLoggedIn },
        { id: "settings", visible: params.isLoggedIn }
      ],
      hidden: ["downloads", "more"]
    }
  };
};
var deviceNavigationMap = {
  ["tvOS" /* tvOS */]: "tv",
  ["AndroidTv" /* AndroidTv */]: "tv",
  ["SmartTv" /* SmartTv */]: "tv",
  ["iOS" /* iOS */]: "mobile",
  ["Android" /* Android */]: "mobile",
  ["Web" /* Web */]: "web",
  ["ChromeCast" /* ChromeCast */]: void 0,
  ["Backend" /* Backend */]: void 0,
  ["UnknownType" /* UnknownType */]: void 0
};
var getItems = ({
  type: type2,
  device,
  locale,
  isLoggedIn
}) => {
  const navigationType = deviceNavigationMap[device.type];
  if (!navigationType) {
    console.warn(`No navigation type for ${device.type}`);
    return [];
  }
  const items = getConfig({ isLoggedIn })[navigationType][type2];
  if (!items) {
    console.warn(`No items for ${type2} on ${device.type}`);
    return [];
  }
  const navigationItems = getNavigationItems({ locale });
  return items.filter((item) => {
    if (typeof item === "string")
      return true;
    return item.visible;
  }).map((item) => {
    if (typeof item === "string") {
      return navigationItems[item];
    }
    return navigationItems[item.id];
  });
};

// src/~utils/sessionUtils/sessionEvents.ts
var { onEvent, emit } = createEventEmitter();

// src/~utils/sessionUtils/sessionUtils.ts
var STORAGE_ACCOUNT_AUTH = "shapeshifter-core/ACCOUNT_AUTH";
var subscribers = [];
var sessionData = {
  loading: true,
  auth: null,
  initialized: false
};
var getInitialSessionData = () => {
  return sessionData;
};
var getAuth = (storage2) => __async(void 0, null, function* () {
  const rawAuthData = yield storage2.get(STORAGE_ACCOUNT_AUTH);
  return extractAuthData(rawAuthData);
});
var extractAuthData = (data) => {
  var _a;
  if (typeof data !== "object" || data === null)
    return;
  if (typeof data["token"] === "string" && typeof data["refreshToken"] === "string" && (typeof data["accountId"] === "string" || typeof data["accountId"] === "number")) {
    const authObj = {
      token: data["token"],
      refreshToken: data["refreshToken"],
      expires: (_a = data["expires"]) != null ? _a : (Date.now() + 60 * 1e3).toString(),
      // Expire in 60s if we don't already have an expires
      accountId: data["accountId"].toString()
    };
    if (authObj.token.length > 10 && authObj.refreshToken.length > 10 && authObj.accountId.length > 2) {
      return authObj;
    }
  }
  return;
};
var getSessionData = (storage2) => __async(void 0, null, function* () {
  if (sessionData.initialized)
    return sessionData;
  const token = yield getAuth(storage2);
  sessionData = { auth: token != null ? token : null, loading: false, initialized: true };
  emit("sessionLoaded", { isLoggedIn: token != null });
  broadcastSessionData({});
  return sessionData;
});
var refreshToken = (client, storage2) => __async(void 0, null, function* () {
  var _a, _b;
  if (!((_a = sessionData.auth) == null ? void 0 : _a.refreshToken)) {
    return;
  }
  try {
    const res = yield client.mutate({
      mutation: GQL_ACCOUNT_AUTHORIZATION_REFRESH_default,
      variables: { refreshToken: sessionData.auth.refreshToken }
    });
    const errors = res == null ? void 0 : res.errors;
    if (errors && errors.length > 0 || !((_b = res.data) == null ? void 0 : _b.response)) {
      throw new Error("Failed to refresh token");
    }
    yield saveAuth(res.data.response, storage2);
  } catch (err) {
    yield logout({ storage: storage2, client });
    throw err;
  }
});
var subscribeToAuth = (fn) => {
  subscribers.push(fn);
};
var unsubscribeFromAuth = (fn) => {
  subscribers = subscribers.filter((f) => f !== fn);
};
var saveAuth = (auth, storage2) => __async(void 0, null, function* () {
  const validatedData = extractAuthData(auth);
  if (!validatedData) {
    throw new Error("Invalid auth data.");
  }
  yield storage2.set(STORAGE_ACCOUNT_AUTH, validatedData);
  return validatedData;
});
var logout = (_0) => __async(void 0, [_0], function* ({
  storage: storage2,
  client
}) {
  yield storage2.remove(STORAGE_ACCOUNT_AUTH);
  client.clearStore();
  broadcastSessionData({ auth: null });
});
var broadcastSessionData = (data) => __async(void 0, null, function* () {
  sessionData = __spreadValues(__spreadValues({}, sessionData), data);
  subscribers.forEach((fn) => fn(sessionData));
});

// src/~utils/shakaUtils/TextDisplayer.ts
import cloneDeep from "lodash/cloneDeep";
var createTextDisplayer = ({ shaka }) => {
  return class TextDisplayer extends shaka.text.UITextDisplayer {
    // Extending constructor for typing reasons only
    // eslint-disable-next-line @typescript-eslint/no-useless-constructor
    constructor(...args) {
      super(...args);
      this.append = (cues) => {
        cues.forEach(fixInvalidCue);
        super.append(cues);
      };
    }
  };
};
var fixInvalidCue = (cue) => {
  if (cue.region.id !== "" && cue.nestedCues.some((n) => n.region.id === cue.region.id)) {
    cue.region = cloneDeep(cue.region);
    cue.region.id = "";
  }
  cue.nestedCues.forEach(fixInvalidCue);
};

// src/~utils/storage/memStorage.ts
var store = {};
var MemStore = {
  getProvider: () => {
  },
  clearAll: () => __async(void 0, null, function* () {
    store = {};
  }),
  get: (id) => __async(void 0, null, function* () {
    return store[id];
  }),
  remove: (id) => __async(void 0, null, function* () {
    delete store[id];
  }),
  set: (id, val) => __async(void 0, null, function* () {
    store[id] = val;
  })
};
var memStorage_default = MemStore;

// src/~utils/storage/nativeStorage.ts
var createAsyncStorage = () => {
  console.error("createAsyncStorage is not implemented");
  throw new Error("createAsyncStorage is not implemented");
};

// src/~utils/storage/index.ts
var guessStorageDriver = () => {
  try {
    if (typeof document !== "undefined") {
      return "localstorage";
    } else if (
      // eslint-disable-next-line no-restricted-globals
      typeof navigator !== "undefined" && // eslint-disable-next-line no-restricted-globals
      navigator.product === "ReactNative"
    ) {
      return "asyncStorage";
    } else {
      return "memory";
    }
  } catch (error) {
  }
  return "unknown";
};
var storage = null;
var getStorage = () => {
  if (storage)
    return storage;
  const storageDriver = guessStorageDriver();
  switch (storageDriver) {
    case "localstorage": {
      storage = webStorage_default;
      break;
    }
    case "asyncStorage": {
      storage = createAsyncStorage();
      break;
    }
    case "memory": {
      storage = memStorage_default;
      break;
    }
  }
  if (!storage) {
    throw new Error("Unknown storage driver");
  }
  return storage;
};

// src/~utils/theme/brandColors.ts
var commonColors = {
  error: "#EB3338",
  warning: "#F4A133",
  success: "#73AF55",
  info: "#E6E6E6",
  white: "#FFFFFF",
  black: "#000000",
  imdb: "#E6B91E",
  facebook: "#004FF4"
};
var brandStyles = {
  ["SFAnytime" /* SFAnytime */]: __spreadProps(__spreadValues({}, commonColors), {
    cta: "#F18900",
    "cta-200": "#F9CF99",
    "cta-300": "#F7B866",
    "cta-400": "#F4A133",
    "cta-500": "#F18900",
    "cta-600": "#D87B00",
    ui: "#0D0D0D",
    "ui-100": "#E5E5E5",
    "ui-200": "#D8D8D8",
    "ui-300": "#9C9C9C",
    "ui-400": "#5A5A5A",
    "ui-500": "#2E2E2E",
    "ui-600": "#242424",
    "ui-700": "#1D1D1D",
    "ui-800": "#171717",
    "ui-900": "#0D0D0D",
    backdrop: "#171717"
  }),
  ["Blockbuster" /* Blockbuster */]: __spreadProps(__spreadValues({}, commonColors), {
    cta: "#FFE13F",
    "cta-200": "#FFF5C0",
    "cta-300": "#FFEE95",
    "cta-400": "#FFE86A",
    "cta-500": "#FFE13F",
    "cta-600": "#DDC12C",
    ui: "#0A0A27",
    "ui-100": "#F8FAFF",
    "ui-200": "#F8FAFF",
    "ui-300": "#F8FAFF",
    "ui-400": "#182A68",
    "ui-500": "#152457",
    "ui-600": "#14214D",
    "ui-700": "#0E193C",
    "ui-800": "#0C1131",
    "ui-900": "#0A0A27",
    backdrop: "#001B9F"
  })
};
var themeMap = {
  cta: "cta",
  cta600: "cta-600",
  cta400: "cta-400",
  cta300: "cta-300",
  cta200: "cta-200",
  error: "error",
  ui900: "ui-900",
  ui800: "ui-800",
  ui700: "ui-700",
  ui600: "ui-600",
  ui500: "ui-500",
  ui400: "ui-400",
  ui100: "ui-100",
  ui200: "ui-200",
  ui300: "ui-300",
  success: "success",
  white: "white",
  black: "black",
  imdb: "imdb",
  facebook: "facebook"
};

// src/~utils/theme/brands.ts
var brands = Object.values(Brand);
var isBrand = (brand) => {
  return brands.includes(brand);
};

// src/~utils/theme/utils.ts
var hex2rgb = (hex, separator = " ") => {
  var _a;
  const c = (_a = hex == null ? void 0 : hex.match(/\w\w/g)) == null ? void 0 : _a.map((x) => parseInt(x, 16));
  if (!c || c.some((x) => isNaN(x))) {
    console.warn("Invalid hex value passed to hex2rgb: ", hex);
    return [0, 1, 2].join(separator);
  }
  return [c[0], c[1], c[2]].join(separator);
};
function rgbCss(hex, alpha = 1) {
  return `rgba(${hex2rgb(hex, ", ")}, ${alpha})`;
}
var themeColor = (color, alpha = 1) => ({ theme }) => {
  return rgbCss(theme.color[color], alpha);
};

// src/~utils/thumbnailUtils/thumbnailUtils.ts
var getThumbnailImage = (thumbnailsData, time, duration) => {
  if (!thumbnailsData)
    return null;
  const thumbnailPosition = Math.floor(
    time / (duration / thumbnailsData.imageCount)
  );
  const src = thumbnailsData.thumbnails[Math.max(thumbnailPosition - 1, 1)];
  if (typeof src !== "string" || src.length < 100) {
    return null;
  }
  const hasBase64Prefix = src.startsWith("data:image/jpeg;base64,");
  const isJpeg = src.startsWith("/9j/");
  if (!hasBase64Prefix && isJpeg) {
    return `data:image/jpeg;base64,${src}`;
  }
  return src;
};
var fetchThumbnails = (thumbsUrl) => __async(void 0, null, function* () {
  if (!thumbsUrl)
    return null;
  const response = yield fetch(thumbsUrl);
  return yield response.json();
});

// src/~utils/timeUtils/timeUtils.ts
var buildTimeString = (displayTime, showHour2 = false) => {
  const h = Math.floor(displayTime / 3600);
  const m = Math.floor(displayTime / 60 % 60);
  const sec = Math.floor(displayTime % 60);
  let s = String(sec);
  if (sec < 10)
    s = `0${s}`;
  let text = `${m}:${s}`;
  if (showHour2 || h > 0) {
    if (m < 10) {
      text = `0${text}`;
    }
    text = `${h}:${text}`;
  }
  return text;
};
var humanRuntime = (runtime) => {
  if (!Number.isInteger(runtime) || runtime < 1) {
    return "-";
  }
  const hours = Math.trunc(runtime / 60);
  const displayHours = hours !== 0 ? `${hours}h ` : "";
  const minutes = `00${runtime % 60}`.slice(-2);
  return `${displayHours}${minutes}m`;
};
var currentTimeInPercentage = (currentTime, duration, options = { fractal: false }) => {
  if (duration === 0)
    return 0;
  const percentage = currentTime / duration;
  return (options.fractal ? percentage : percentage * 100) || 0;
};
var showHour = (duration) => duration >= 60 * 60;
var hasHoursPassed = (hours) => (fromDate) => {
  const enoughTimePassed = (/* @__PURE__ */ new Date()).getTime() - new Date(fromDate).getTime() > hours * 60 * 60 * 1e3;
  return enoughTimePassed;
};

// src/~utils/videoUtils/videoUtils.ts
var sampleEntryCodesISO = {
  audio: {
    a3ds: true,
    "ac-3": true,
    "ac-4": true,
    alac: true,
    alaw: true,
    dra1: true,
    "dts+": true,
    "dts-": true,
    dtsc: true,
    dtse: true,
    dtsh: true,
    "ec-3": true,
    enca: true,
    fLaC: true,
    // MP4-RA listed codec entry for FLAC
    flac: true,
    // legacy browser codec name for FLAC
    FLAC: true,
    // some manifests may list "FLAC" with Apple's tools
    g719: true,
    g726: true,
    m4ae: true,
    mha1: true,
    mha2: true,
    mhm1: true,
    mhm2: true,
    mlpa: true,
    mp4a: true,
    "raw ": true,
    Opus: true,
    opus: true,
    // browsers expect this to be lowercase despite MP4RA says 'Opus'
    samr: true,
    sawb: true,
    sawp: true,
    sevc: true,
    sqcp: true,
    ssmv: true,
    twos: true,
    ulaw: true
  },
  video: {
    avc1: true,
    avc2: true,
    avc3: true,
    avc4: true,
    avcp: true,
    av01: true,
    drac: true,
    dva1: true,
    dvav: true,
    dvh1: true,
    dvhe: true,
    encv: true,
    hev1: true,
    hvc1: true,
    mjp2: true,
    mp4v: true,
    mp4: true,
    ogg: true,
    webm: true,
    mvc1: true,
    mvc2: true,
    mvc3: true,
    mvc4: true,
    resv: true,
    rv60: true,
    s263: true,
    svc1: true,
    svc2: true,
    "vc-1": true,
    vp08: true,
    vp09: true
  },
  text: {
    stpp: true,
    wvtt: true
  }
};
function getMediaSource() {
  try {
    if (typeof window === "undefined")
      return void 0;
    if (window.WebKitMediaSource) {
      return window.WebKitMediaSource;
    }
    return window.MediaSource;
  } catch (error) {
    return void 0;
  }
}
var mediaSource = getMediaSource();
function isCodecMediaSourceSupported(codec, type2, container = "mp4") {
  var _a;
  return (_a = mediaSource == null ? void 0 : mediaSource.isTypeSupported(
    `${type2 || "video"}/${container};codecs="${codec}"`
  )) != null ? _a : false;
}
var CODEC_COMPATIBLE_NAMES = {};
function getCodecCompatibleNameLower(lowerCaseCodec) {
  if (CODEC_COMPATIBLE_NAMES[lowerCaseCodec]) {
    return CODEC_COMPATIBLE_NAMES[lowerCaseCodec];
  }
  const codecsToCheck = {
    flac: ["flac", "fLaC", "FLAC"],
    opus: ["opus", "Opus"]
  }[lowerCaseCodec];
  for (let i = 0; i < codecsToCheck.length; i++) {
    if (isCodecMediaSourceSupported(codecsToCheck[i], "audio")) {
      CODEC_COMPATIBLE_NAMES[lowerCaseCodec] = codecsToCheck[i];
      return codecsToCheck[i];
    }
  }
  return lowerCaseCodec;
}
var AUDIO_CODEC_REGEXP = /flac|opus/i;
function getCodecCompatibleName(codec) {
  return codec.replace(
    AUDIO_CODEC_REGEXP,
    (m) => getCodecCompatibleNameLower(m.toLowerCase())
  );
}
var getSupportedMediaSourceAudioCodecs = () => {
  const vidCodecs = Object.keys(sampleEntryCodesISO.video);
  const audCodecs = Object.keys(sampleEntryCodesISO.audio);
  const supported = [
    ...new Set(
      audCodecs.map((codec) => getCodecCompatibleName(codec)).filter(
        (codec) => vidCodecs.some(
          (vidCodec) => isCodecMediaSourceSupported(codec, "video", vidCodec)
        )
      )
    )
  ];
  return supported;
};

// src/~utils/videoUtils/dataTransferRate.ts
var BitsPerSecond = class {
  static toKiloBitsPerSecond(value) {
    return value / 1e3;
  }
  static toMegaBitsPerSecond(value) {
    return value / 1e6;
  }
  static toGigaBitsPerSecond(value) {
    return value / 1e9;
  }
  static toTeraBitsPerSecond(value) {
    return value / 1e12;
  }
  static toKiloBytesPerSecond(value) {
    return value / 8e3;
  }
  static toMegaBytesPerSecond(value) {
    return value / 8e6;
  }
  static toGigaBytesPerSecond(value) {
    return value / 8e9;
  }
  static toTeraBytesPerSecond(value) {
    return value / 8e12;
  }
  static toKibibitsPerSecond(value) {
    return value / 1024;
  }
  static toMebibitsPerSecond(value) {
    return value / 1048576;
  }
};
var GigaBitsPerSecond = class {
  static toBitsPerSecond(value) {
    return value * 1e9;
  }
  static toKiloBitsPerSecond(value) {
    return value * 1e6;
  }
  static toMegaBitsPerSecond(value) {
    return value * 1e3;
  }
  static toTeraBitsPerSecond(value) {
    return value / 1e3;
  }
  static toKiloBytesPerSecond(value) {
    return value * 125e3;
  }
  static toMegaBytesPerSecond(value) {
    return value * 125;
  }
  static toGigaBytesPerSecond(value) {
    return value / 8;
  }
  static toTeraBytesPerSecond(value) {
    return value / 8e3;
  }
  static toKibibitsPerSecond(value) {
    return value * 976562.5;
  }
  static toMebibitsPerSecond(value) {
    return value * 953.67431640625;
  }
};
var GigaBytesPerSecond = class {
  static toBitsPerSecond(value) {
    return value * 8e9;
  }
  static toKiloBitsPerSecond(value) {
    return value * 8e6;
  }
  static toMegaBitsPerSecond(value) {
    return value * 8e3;
  }
  static toGigaBitsPerSecond(value) {
    return value * 8;
  }
  static toTeraBitsPerSecond(value) {
    return value / 125;
  }
  static toKiloBytesPerSecond(value) {
    return value * 1e6;
  }
  static toMegaBytesPerSecond(value) {
    return value * 1e3;
  }
  static toTeraBytesPerSecond(value) {
    return value / 1e3;
  }
  static toKibibitsPerSecond(value) {
    return value * 7812500;
  }
  static toMebibitsPerSecond(value) {
    return value * 7629.39;
  }
};
var KibibitsPerSecond = class {
  static toBitsPerSecond(value) {
    return value * 1024;
  }
  static toKiloBitsPerSecond(value) {
    return value * 1.024;
  }
  static toMegaBitsPerSecond(value) {
    return value / 976.563;
  }
  static toGigaBitsPerSecond(value) {
    return value / 976562.5;
  }
  static toTeraBitsPerSecond(value) {
    return value / 976562500;
  }
  static toKiloBytesPerSecond(value) {
    return value / 7.8125;
  }
  static toMegaBytesPerSecond(value) {
    return value / 7812.5;
  }
  static toGigaBytesPerSecond(value) {
    return value / 7812500;
  }
  static toTeraBytesPerSecond(value) {
    return value / 78125e5;
  }
  static toMebibitsPerSecond(value) {
    return value / 1024;
  }
};
var KiloBitsPerSecond = class {
  static toBitsPerSecond(value) {
    return value * 1e3;
  }
  static toMegaBitsPerSecond(value) {
    return value / 1e3;
  }
  static toGigaBitsPerSecond(value) {
    return value / 1e6;
  }
  static toTeraBitsPerSecond(value) {
    return value / 1e9;
  }
  static toKiloBytesPerSecond(value) {
    return value / 8;
  }
  static toMegaBytesPerSecond(value) {
    return value / 8e3;
  }
  static toGigaBytesPerSecond(value) {
    return value / 8e6;
  }
  static toTeraBytesPerSecond(value) {
    return value / 8e9;
  }
  static toKibibitsPerSecond(value) {
    return value / 1.024;
  }
  static toMebibitsPerSecond(value) {
    return value / 1048.58;
  }
};
var KiloBytesPerSecond = class {
  static toBitsPerSecond(value) {
    return value * 8e3;
  }
  static toKiloBitsPerSecond(value) {
    return value * 8;
  }
  static toMegaBitsPerSecond(value) {
    return value / 125;
  }
  static toGigaBitsPerSecond(value) {
    return value / 125e3;
  }
  static toTeraBitsPerSecond(value) {
    return value / 125e6;
  }
  static toMegaBytesPerSecond(value) {
    return value / 1e3;
  }
  static toGigaBytesPerSecond(value) {
    return value / 1e6;
  }
  static toTeraBytesPerSecond(value) {
    return value / 1e9;
  }
  static toKibibitsPerSecond(value) {
    return value * 7.8125;
  }
  static toMebibitsPerSecond(value) {
    return value * 762939e-8;
  }
};
var MebibitsPerSecond = class {
  static toBitsPerSecond(value) {
    return value * 1048576;
  }
  static toKiloBitsPerSecond(value) {
    return value * 1048.58;
  }
  static toMegaBitsPerSecond(value) {
    return value * 1.04858;
  }
  static toGigaBitsPerSecond(value) {
    return value / 953.67431640625;
  }
  static toTeraBitsPerSecond(value) {
    return value / 953674;
  }
  static toKiloBytesPerSecond(value) {
    return value / 762939e-8;
  }
  static toMegaBytesPerSecond(value) {
    return value / 7.62939;
  }
  static toGigaBytesPerSecond(value) {
    return value / 7629.39;
  }
  static toTeraBytesPerSecond(value) {
    return value * 131072e-12;
  }
  static toKibibitsPerSecond(value) {
    return value * 1024;
  }
};
var MegaBitsPerSecond = class {
  static toBitsPerSecond(value) {
    return value * 1e6;
  }
  static toKiloBitsPerSecond(value) {
    return value * 1e3;
  }
  static toGigaBitsPerSecond(value) {
    return value / 1e3;
  }
  static toTeraBitsPerSecond(value) {
    return value / 1e6;
  }
  static toKiloBytesPerSecond(value) {
    return value * 125;
  }
  static toMegaBytesPerSecond(value) {
    return value / 8;
  }
  static toGigaBytesPerSecond(value) {
    return value / 8e3;
  }
  static toTeraBytesPerSecond(value) {
    return value / 8e6;
  }
  static toKibibitsPerSecond(value) {
    return value * 976.563;
  }
  static toMebibitsPerSecond(value) {
    return value / 1.04858;
  }
};
var MegaBytesPerSecond = class {
  static toBitsPerSecond(value) {
    return value * 8e6;
  }
  static toKiloBitsPerSecond(value) {
    return value * 8e3;
  }
  static toMegaBitsPerSecond(value) {
    return value * 8;
  }
  static toGigaBitsPerSecond(value) {
    return value / 125;
  }
  static toTeraBitsPerSecond(value) {
    return value / 125e3;
  }
  static toKiloBytesPerSecond(value) {
    return value * 1e3;
  }
  static toGigaBytesPerSecond(value) {
    return value / 1e3;
  }
  static toTeraBytesPerSecond(value) {
    return value / 1e6;
  }
  static toKibibitsPerSecond(value) {
    return value * 7812.5;
  }
  static toMebibitsPerSecond(value) {
    return value * 7.62939;
  }
};
var TeraBitsPerSecond = class {
  static toBitsPerSecond(value) {
    return value * 1e12;
  }
  static toKiloBitsPerSecond(value) {
    return value * 1e9;
  }
  static toMegaBitsPerSecond(value) {
    return value * 1e6;
  }
  static toGigaBitsPerSecond(value) {
    return value * 1e3;
  }
  static toKiloBytesPerSecond(value) {
    return value * 125e6;
  }
  static toMegaBytesPerSecond(value) {
    return value * 125e3;
  }
  static toGigaBytesPerSecond(value) {
    return value * 125;
  }
  static toTeraBytesPerSecond(value) {
    return value / 8;
  }
  static toKibibitsPerSecond(value) {
    return value * 976562500;
  }
  static toMebibitsPerSecond(value) {
    return value * 953674;
  }
};
var TeraBytesPerSecond = class {
  static toBitsPerSecond(value) {
    return value * 8e12;
  }
  static toKiloBitsPerSecond(value) {
    return value * 8e9;
  }
  static toMegaBitsPerSecond(value) {
    return value * 8e6;
  }
  static toGigaBitsPerSecond(value) {
    return value * 8e3;
  }
  static toTeraBitsPerSecond(value) {
    return value * 8;
  }
  static toKiloBytesPerSecond(value) {
    return value * 1e9;
  }
  static toMegaBytesPerSecond(value) {
    return value * 1e6;
  }
  static toGigaBytesPerSecond(value) {
    return value * 1e3;
  }
  static toKibibitsPerSecond(value) {
    return value * 78125e5;
  }
  static toMebibitsPerSecond(value) {
    return value / 131072e-12;
  }
};

// src/~client/utils/deviceCapabilities.ts
var CapabilitiesTypes = {
  video: "video",
  audio: "audio",
  pay: "pay",
  optout: "opt_out",
  color: "color"
};
var VideoCapabilities = {
  h264: "h264",
  vp8: "vp8",
  vp9: "vp9",
  av1: "av1",
  ogg: "ogg",
  hevc: "hevc",
  dv5: "dv5",
  dv8: "dv8",
  h10: "h10",
  h10p: "h10p",
  h10p_av1: "h10p_av1"
};
var AudioCapabilities = {
  eac3: "eac3",
  opus: "opus",
  aac: "aac",
  ac3: "ac3"
};
var PayCapabilities = {
  apple: "apple",
  google: "google"
};
var OptOutCapabilities = {
  track: "track",
  ads: "ads"
};
var ScreenCapabilities = {
  hdr: "hdr",
  sdr: "sdr",
  720: "720",
  1080: "1080",
  2160: "4k",
  4320: "8k"
};
var DeviceCapabilities = __spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues({}, VideoCapabilities), AudioCapabilities), PayCapabilities), OptOutCapabilities), ScreenCapabilities);
var deviceCapabilitiesErrors = {
  video: null,
  audio: null,
  context: null
};
var dvV5 = [
  'video/mp4; codecs="dvh1.05.07"',
  // 4k30fps
  // Chromecast - https://developers.google.com/cast/docs/media#mp4_video_only
  'video/mp4; codecs="dvhe.05.06"',
  // 4k24fps
  'video/mp4; codecs="dvhe.05.07"',
  // 4k30fps
  'video/mp4; codecs="dvhe.05.09"'
  // 4k60fps
];
var dvV8 = [
  'video/mp4; codecs="dvh1.08.07/db1p"',
  // 4k30fps
  'video/mp4; codecs="dvhe.08.07/db1p"',
  // 4k30fps
  // Chromecast - https://developers.google.com/cast/docs/media#mp4_video_only
  'video/mp4; codecs="dvhe.08.06"',
  // 4k24fps
  'video/mp4; codecs="dvhe.08.07"',
  // 4k30fps
  'video/mp4; codecs="dvhe.08.09"'
  // 4k60fps
];
var hdr10p = [
  'video/mp4; codecs="hvc1.2.20000000.L123.B0/cdm4"',
  'video/mp4; codecs="hev1.2.20000000.L123.B0/cdm4"'
];
var hevc = [
  'video/mp4; codecs="hev1.1.6.L120.90"',
  // HEVC main profile is supported
  'video/mp4; codecs="hev1.2.4.L120.90"',
  // HEVC main 10 profile is supported
  'video/mp4; codecs="hev1.3.E.L120.90"',
  // HEVC main still-picture profile is supported
  'video/mp4; codecs="hev1.4.10.L120.90"',
  // HEVC range extensions profile is supported
  // Chromecast - https://developers.google.com/cast/docs/media#mp4_video_only
  'video/mp4; codecs="hev1.1.6.L150.B0"',
  // HEVC main
  'video/mp4; codecs="hev1.1.6.L153.B0"',
  // HEVC main
  'video/mp4; codecs="hev1.2.6.L150.B0"',
  // HEVC main10
  'video/mp4; codecs="hev1.2.6.L153.B0"'
  // HEVC main10
];
var addDeviceCapabilitiesError = ({
  type: type2,
  err
}) => {
  deviceCapabilitiesErrors[type2] = String(err);
};
var getDefaultBrowserCapabilities = () => {
  var _a;
  const dch = new DeviceCapabilitiesHelper().merge([
    getVideoCapabilities(),
    getPaymentCapabilities(),
    getAudioCapabilities(),
    getScreenCapabilities()
  ]);
  try {
    const doNotTrack = ((_a = window == null ? void 0 : window.navigator) == null ? void 0 : _a.doNotTrack) || false;
    if (doNotTrack)
      dch.add("track");
  } catch (err) {
  }
  return dch;
};
var getPaymentCapabilities = () => {
  const dch = new DeviceCapabilitiesHelper();
  try {
    dch.set("apple", !!(window == null ? void 0 : window.ApplePaySession));
  } catch (error) {
  }
  return dch;
};
var getIsTypeSupported = () => {
  if (DeviceDetect.isChromecast()) {
    try {
      return (type2) => {
        return cast.framework.CastReceiverContext.getInstance().canDisplayType(
          type2
        );
      };
    } catch (error) {
      addDeviceCapabilitiesError({ type: "context", err: error });
    }
  }
  try {
    if (window == null ? void 0 : window.MediaSource)
      return MediaSource.isTypeSupported.bind(MediaSource);
  } catch (error) {
  }
  try {
    if (window == null ? void 0 : window.ManagedMediaSource)
      return ManagedMediaSource.isTypeSupported.bind(ManagedMediaSource);
  } catch (error) {
  }
  return () => false;
};
var getVideoCapabilities = () => {
  const dch = new DeviceCapabilitiesHelper();
  try {
    const s = getIsTypeSupported();
    dch.set("h264", s('video/mp4; codecs="avc1.42E01E"'));
    dch.set("vp8", s('video/webm; codecs="vp8"'));
    dch.set("vp9", s('video/webm; codecs="vp9"'));
    dch.set("av1", s('video/webm; codecs="av01.0.05M.08"'));
    dch.set("ogg", s('video/ogg; codecs="theora"'));
    for (const codec of hevc) {
      if (!s(codec))
        continue;
      dch.add("hevc");
      break;
    }
    for (const codec of dvV5) {
      if (!s(codec))
        continue;
      dch.add("dv5");
      break;
    }
    for (const codec of dvV8) {
      if (!s(codec))
        continue;
      dch.add("dv8");
      break;
    }
    for (const codec of hdr10p) {
      if (!s(codec))
        continue;
      dch.add("h10p");
      break;
    }
    dch.set("h10p_av1", s('video/webm; codecs="av01.0.05M.10.0.112/cdm4"'));
  } catch (err) {
    addDeviceCapabilitiesError({ type: "video", err });
  }
  if (DeviceDetect.isTizenVersions([2, 3, 4])) {
    dch.remove(["vp8", "vp9", "av1", "dv5", "dv8", "h10p", "h10p_av1"]);
  }
  return dch;
};
var getAudioCapabilities = () => {
  const dch = new DeviceCapabilitiesHelper();
  try {
    const s = getIsTypeSupported();
    dch.set("eac3", s('audio/mp4; codecs="ec-3"'));
    dch.set("opus", s('audio/webm; codecs="opus"'));
    dch.set("aac", s('audio/mp4; codecs="mp4a.40.2"'));
    dch.set("ac3", s('audio/mp4; codecs="ac-3"'));
  } catch (err) {
    addDeviceCapabilitiesError({ type: "video", err });
  }
  if (DeviceDetect.isTizenVersions([2, 3, 4])) {
    dch.remove(["opus"]);
  }
  return dch;
};
var getScreenCapabilities = () => {
  const dch = new DeviceCapabilitiesHelper();
  try {
    const doesMatch = (value) => {
      return window == null ? void 0 : window.matchMedia(`(dynamic-range: ${value})`).matches;
    };
    if (doesMatch("high")) {
      dch.add("hdr");
    }
  } catch (error) {
  }
  if (!dch.has("hdr")) {
    dch.add("sdr");
  }
  const maxHeight = DeviceDetect.detectMaxHardwareResolution().height;
  if (maxHeight !== void 0) {
    switch (maxHeight) {
      case 720:
        dch.add("720");
        break;
      case 1080:
        dch.add("1080");
        break;
      case 2160:
        dch.add("4k");
        break;
      case 4320:
        dch.add("8k");
        break;
    }
  }
  return dch;
};
var DeviceCapabilitiesHelper = class _DeviceCapabilitiesHelper {
  constructor(args = {}) {
    this.logLevel = 1;
    this.capabilities = /* @__PURE__ */ new Set();
    const initial = args.initial;
    if (initial instanceof _DeviceCapabilitiesHelper) {
      this.merge(initial);
    } else if (Array.isArray(initial)) {
      initial.forEach((c) => this.add(c));
    }
  }
  static is(c, type2) {
    switch (type2) {
      case CapabilitiesTypes.video:
        return c in VideoCapabilities;
      case CapabilitiesTypes.audio:
        return c in AudioCapabilities;
      case CapabilitiesTypes.pay:
        return c in PayCapabilities;
      case CapabilitiesTypes.optout:
        return c in OptOutCapabilities;
      case CapabilitiesTypes.color:
        return c in ScreenCapabilities;
      default:
        return c in DeviceCapabilities;
    }
  }
  static exists(c) {
    if (!c)
      return false;
    return c in DeviceCapabilities;
  }
  static type(c) {
    switch (true) {
      case c in VideoCapabilities:
        return CapabilitiesTypes.video;
      case c in AudioCapabilities:
        return CapabilitiesTypes.audio;
      case c in PayCapabilities:
        return CapabilitiesTypes.pay;
      case c in OptOutCapabilities:
        return CapabilitiesTypes.optout;
      case c in ScreenCapabilities:
        return CapabilitiesTypes.color;
      default:
        return void 0;
    }
  }
  static getDefaultBrowserCapabilities() {
    return getDefaultBrowserCapabilities();
  }
  static getDeviceCapabilitiesErrors() {
    return deviceCapabilitiesErrors;
  }
  has(c) {
    return this.capabilities.has(c);
  }
  every(c) {
    return c.every((cap) => this.capabilities.has(cap));
  }
  add(c) {
    const caps = Array.isArray(c) ? c : [c];
    caps.forEach((cap) => {
      if (!(cap in DeviceCapabilities)) {
        if (this.logLevel < 1) {
          console.warn(`Trying to add unknown capability: ${cap}`);
        }
        return;
      }
      this.capabilities.add(cap);
    });
    return this;
  }
  set(c, value) {
    if (value)
      return this.capabilities.add(c);
    return this.capabilities.delete(c);
  }
  remove(c) {
    const caps = Array.isArray(c) ? c : [c];
    caps.forEach((cap) => this.capabilities.delete(cap));
    return this;
  }
  merge(caps) {
    if (Array.isArray(caps)) {
      caps.forEach(
        (c) => c.capabilities.forEach((cap) => this.capabilities.add(cap))
      );
    } else {
      caps.capabilities.forEach((c) => this.capabilities.add(c));
    }
    return this;
  }
  toString() {
    return [...this.capabilities].sort().map((c) => {
      switch (true) {
        case c in VideoCapabilities:
          return `v_${c}`;
        case c in AudioCapabilities:
          return `a_${c}`;
        case c in PayCapabilities:
          return `pay_${c}`;
        case c in OptOutCapabilities:
          return `no_${c}`;
        case c in ScreenCapabilities:
          return `srn_${c}`;
        case typeof c === "string":
        default:
          return `ukn_${c}`;
      }
    }).join(",");
  }
  setLogLevel(level) {
    switch (level) {
      case "warn":
        this.logLevel = 1;
        break;
      case "error":
        this.logLevel = 2;
        break;
      case "info":
      default:
        this.logLevel = 0;
        break;
    }
    return this;
  }
};

// src/~client/utils/media.ts
import isEmpty from "lodash/isEmpty";
var createMediaId = (params) => {
  return createGloballyUniqueIdResolver(params.__typename, (e) => {
    var _a;
    return [
      (_a = e == null ? void 0 : e.slug) != null ? _a : ""
    ];
  })(params, params);
};
function readMedia({
  slug: slug3,
  cache,
  fragment
}) {
  const readFragment = (__typename2) => {
    const response = cache.readFragment({
      id: createMediaId({ slug: slug3, __typename: __typename2 }),
      fragment,
      returnPartialData: true
    });
    if (isEmpty(response))
      return null;
    return response;
  };
  const movie = readFragment("Movie");
  if (movie)
    return movie;
  const episode = readFragment("Episode");
  if (episode)
    return episode;
  const season = readFragment("Season");
  if (season)
    return season;
  const series = readFragment("Series");
  if (series)
    return series;
  const bundle = readFragment("MetaCollectionBundle");
  if (bundle)
    return bundle;
  return null;
}

// src/~client/utils/localizationUtils.ts
import { gql as gql81 } from "@apollo/client";
import merge from "lodash/merge";
import hash from "object-hash";
var GQL_GET_LOCALIZATIONS = gql81`
  query GetLocalizations($locale: Locale!) {
    localizations(locale: $locale) {
      items
    }
  }
`;
var mergeLocalizations = (_, next, { cache, variables }) => {
  const { locale } = variables != null ? variables : {};
  const entries = Object.values(cache.extract()).filter(
    (v) => (v == null ? void 0 : v.__typename) === "Localization"
  );
  const merged = merge(
    {},
    ...entries.filter((e) => e.locale === locale).map((l) => l.items)
  );
  cache.updateQuery(
    { query: GQL_GET_LOCALIZATIONS, variables: { locale } },
    () => ({
      localizations: { items: merged }
    })
  );
  return next;
};
var createLocalizationId = ({
  locale,
  brand,
  items
}) => {
  const encodingThatCreatesShortString = "base64";
  const itemHash = hash(items, { encoding: encodingThatCreatesShortString });
  return createGloballyUniqueId("Localization", [locale, brand, itemHash]);
};

// src/~client/utils/apolloStatus/apolloStatusEvents.ts
var { emit: emit2, onEvent: onEvent2 } = createEventEmitter();

// src/~client/utils/apolloStatus/apolloStatus.ts
var safeGlobal = (() => {
  if (typeof global !== "undefined")
    return global;
  if (typeof window !== "undefined")
    return window;
  if (typeof globalThis !== "undefined")
    return globalThis;
  throw new Error("Could not find global object");
})();
var apolloStatus = /* @__PURE__ */ (() => {
  let currentRequests = 0;
  let status = "idle";
  let timeout;
  const setStatus = (newStatus) => {
    status = newStatus;
    emit2("status", status);
    updateTimeout();
  };
  const customFetch = (...args) => __async(void 0, null, function* () {
    try {
      currentRequests++;
      updateStatus();
      return yield safeGlobal.fetch(...args);
    } finally {
      currentRequests--;
      updateStatus();
    }
  });
  const updateTimeout = () => {
    clearTimeout(timeout);
    if (status === "pending") {
      timeout = setTimeout(() => {
        setStatus("idle");
      }, 3e4);
    }
  };
  const updateStatus = () => {
    const nextStatus = currentRequests > 0 ? "pending" : "idle";
    if (nextStatus !== status) {
      setStatus(nextStatus);
    }
  };
  return {
    fetch: customFetch,
    get status() {
      return status;
    }
  };
})();

// src/~client/utils/apolloStatus/waitForStatus.ts
var onApolloStatus = onEvent2;
var waitForStatus = (status) => __async(void 0, null, function* () {
  return new Promise((resolve) => {
    if (apolloStatus.status === status) {
      resolve();
    } else {
      const unsubscribe = onApolloStatus("status", (s) => {
        if (status === s) {
          resolve();
          unsubscribe();
        }
      });
    }
  });
});

// src/~client/schema/possibleTypes.ts
var OBJECT_TYPES_WITH_ID = [
  "AccountEvent",
  "Actor",
  "Director",
  "Product",
  "DisplayableInCollectionWithCover",
  "DisplayableInCollectionWithPromo",
  "MetaCollectionBundle",
  "Ticket",
  "Series",
  "Season",
  "Episode",
  "Movie",
  "Localization",
  "List",
  "ContentList",
  "SupportTicket",
  "SupportCategory",
  "SupportArticle",
  "SupportArticleTag",
  "Tag",
  "SFAnytimeComWebApp",
  "BlockbusterWebApp",
  "SFAnytimeAndroidApp",
  "SFAnytimeAndroidTvApp",
  "SFAnytimeIosApp",
  "SFAnytimeTvosApp",
  "BlockbusterAndroidApp",
  "BlockbusterAndroidTvApp",
  "BlockbusterIosApp",
  "BlockbusterTvosApp",
  "SFAnytimeSmartTvLGApp",
  "SFAnytimeSmartTvSamsungApp",
  "SFAnytimeSmartTvVewdApp",
  "SFAnytimeSmartTvPhilipsApp",
  "BlockbusterSmartTvLGApp",
  "BlockbusterSmartTvSamsungApp",
  "BlockbusterSmartTvVewdApp",
  "BlockbusterSmartTvPhilipsApp",
  "Spotlights",
  "Promos",
  "Feature",
  "Page",
  "ContentCollectionTargetAuth",
  "ContentCollectionTargetStart",
  "ContentCollectionTargetHome",
  "ContentCollectionTargetSearch",
  "ContentCollectionTargetMedia",
  "ContentCollectionTargetContentCollection",
  "ContentCollectionTargetPage",
  "ContentCollectionTargetList",
  "ContentCollectionUserContentEntitlements",
  "ContentCollectionUserContentMyList",
  "ContentCollectionUserContentContinueWatching",
  "ContentCollectionUserContentSavedSearches",
  "ContentCollectionUserContentMyActors",
  "ContentCollectionUserContentMyDirectors",
  "ContentCollectionUserContentMyGenres",
  "ContentCollectionRecommendation",
  "ContentCollectionMyList",
  "ContentCollectionContinueWatching",
  "ContentCollectionEntitlements",
  "ContentCollectionNotificationTeaser",
  "ContentCollectionImage",
  "ContentCollectionCallToAction",
  "ContentCollectionDescription",
  "ContentCollectionTakeover",
  "ContentCollectionListPosition",
  "ListGrid",
  "ContentCollection",
  "MetaCollectionCategoryPlot",
  "MetaCollectionCategoryAudience",
  "MetaCollectionCategoryTime",
  "MetaCollectionCategoryBasedOn",
  "MetaCollectionCategoryStyle",
  "MetaCollectionCategoryPlace",
  "Favorite",
  "Account",
  "AccountSubscription",
  "AccountEntitlement",
  "AccountPlaybackToken",
  "RemoteAuthentication",
  "Bookmark",
  "TransactionAudioLanguage",
  "PurchaseTypeSelection",
  "PaymentMethodSelectionGroup",
  "Transaction",
  "Order",
  "DeviceInformation",
  "TitlesInSeriesSavedSearch",
  "SingleTitleSavedSearch",
  "GenericSavedSearch",
  "DeletedSavedSearch"
];
var OBJECT_TYPES_WITHOUT_ID = [
  "EntitlementCreatedEvent",
  "MenuItemTarget",
  "MenuItem",
  "Menu",
  "AudioTrackSound",
  "AudioTrack",
  "Audio",
  "Subtitle",
  "Display",
  "AlternativeSlug",
  "ManifestInfo",
  "Manifest",
  "ManifestUrls",
  "Review",
  "MetaCollectionBundleDiscount",
  "TicketEdge",
  "TicketConnection",
  "Ratings",
  "PromoBadge",
  "MovieManifests",
  "ListMetaData",
  "ListSortOptionArrangement",
  "ListSortOption",
  "ContentListItemEdge",
  "ContentListItemConnection",
  "TagZoneCard",
  "TagZonePrimary",
  "TagZoneDescription",
  "BasicDisplayTag",
  "PriceReducedTagDisplay",
  "PurchasableMediaDisplay",
  "MediaUnavailableDisplay",
  "MediaIsPartOfCollectionDisplay",
  "ItemIsCollectionDisplay",
  "ReleaseDateTagDisplay",
  "UnknownReleaseDateTagDisplay",
  "AnytimeExclusiveDisplay",
  "IconDisplayTag",
  "TextDisplayTag",
  "BoughtDisplayTag",
  "RentedDisplayTag",
  "BookmarkDisplayTag",
  "PageInfo",
  "NextActionProposePurchaseContent",
  "NextActionPlayContent",
  "NextActionItemResult",
  "NextActionResults",
  "RedirectAction",
  "MutationResponse",
  "SearchResults",
  "ListReference",
  "PageReference",
  "ContentCollectionReference",
  "FeatureLink",
  "FooterLink",
  "FooterItems",
  "FooterSocial",
  "Footer",
  "ContentCollectionUserContent",
  "ContentCollectionTakeoverUsp",
  "ContentCollectionUspItem",
  "ContentCollectionUsp",
  "ContentCollectionTitle",
  "ContentCollectionMetaData",
  "ContentCollectionPaginationResult",
  "ContentCollectionSliceConnection",
  "ContentCollectionSliceEdge",
  "ContentCollectionTopList",
  "MetaCollectionMetaData",
  "MetaCollectionCategoryImages",
  "MetaCollections",
  "AccountPaymentMethod",
  "AccountTicket",
  "AccountTickets",
  "AccountEntitlements",
  "WidevinePlayReponse",
  "PlayReadyPlayReponse",
  "FairplayPlayResponse",
  "AccountAuthToken",
  "AccountOAuthRequest",
  "Voucher",
  "VoucherOrderTvodBulkPrice",
  "VoucherOrder",
  "PaymentMethodSelection",
  "TransactionReceipt",
  "TransactionPayment",
  "TransactionPaymentApple",
  "TransactionPaymentGoogle",
  "TransactionPaymentAdyen",
  "TransactionAcquirerResponse",
  "AccountUpdatePaymentMethodsResponse",
  "AppFeature",
  "AppConfig",
  "GraphMetaData",
  "Device",
  "PersonalizationQuery",
  "TopGenrePersonalization",
  "TopActorPersonalization",
  "TopDirectorPersonalization",
  "TopMetaCollectionPersonalization",
  "TopYearPersonalization",
  "TopImdbRatingPersonalization"
];
var possibleTypes = {
  Media: ["Movie", "Episode", "Series", "Season"],
  BaseMedia: ["Series", "Season", "Episode", "Movie"],
  Playable: ["Episode", "Movie"],
  WithManifests: ["Manifest", "ManifestUrls"],
  Purchasable: ["MetaCollectionBundle", "Ticket", "Season", "Episode", "Movie"],
  DisplayableInCollectionAsset: [
    "DisplayableInCollectionWithCover",
    "DisplayableInCollectionWithPromo"
  ],
  DisplayableInCollection: [
    "MetaCollectionBundle",
    "Ticket",
    "Series",
    "Season",
    "Episode",
    "Movie",
    "Feature"
  ],
  BaseList: ["List", "ContentCollectionTopList"],
  TagZoneInterface: ["TagZoneCard", "TagZonePrimary", "TagZoneDescription"],
  TagZone: ["TagZoneCard", "TagZoneDescription", "TagZonePrimary"],
  MediaIsPartOfCollectionItem: ["MetaCollectionBundle"],
  TagTarget: ["ContentCollectionTargetSearch"],
  TagDisplay: [
    "BasicDisplayTag",
    "IconDisplayTag",
    "PriceReducedTagDisplay",
    "ReleaseDateTagDisplay",
    "UnknownReleaseDateTagDisplay",
    "AnytimeExclusiveDisplay",
    "PurchasableMediaDisplay",
    "MediaUnavailableDisplay",
    "MediaIsPartOfCollectionDisplay",
    "ItemIsCollectionDisplay",
    "RentedDisplayTag",
    "BoughtDisplayTag",
    "BookmarkDisplayTag",
    "TextDisplayTag"
  ],
  App: [
    "SFAnytimeComWebApp",
    "BlockbusterWebApp",
    "SFAnytimeAndroidApp",
    "SFAnytimeAndroidTvApp",
    "SFAnytimeIosApp",
    "SFAnytimeTvosApp",
    "BlockbusterAndroidApp",
    "BlockbusterAndroidTvApp",
    "BlockbusterIosApp",
    "BlockbusterTvosApp",
    "SFAnytimeSmartTvLGApp",
    "SFAnytimeSmartTvSamsungApp",
    "SFAnytimeSmartTvVewdApp",
    "SFAnytimeSmartTvPhilipsApp",
    "BlockbusterSmartTvLGApp",
    "BlockbusterSmartTvSamsungApp",
    "BlockbusterSmartTvVewdApp",
    "BlockbusterSmartTvPhilipsApp"
  ],
  WebApp: ["SFAnytimeComWebApp", "BlockbusterWebApp"],
  NativeApp: [
    "SFAnytimeAndroidApp",
    "SFAnytimeAndroidTvApp",
    "SFAnytimeIosApp",
    "SFAnytimeTvosApp",
    "BlockbusterAndroidApp",
    "BlockbusterAndroidTvApp",
    "BlockbusterIosApp",
    "BlockbusterTvosApp"
  ],
  SmartTvApp: [
    "SFAnytimeSmartTvLGApp",
    "SFAnytimeSmartTvSamsungApp",
    "SFAnytimeSmartTvVewdApp",
    "SFAnytimeSmartTvPhilipsApp",
    "BlockbusterSmartTvLGApp",
    "BlockbusterSmartTvSamsungApp",
    "BlockbusterSmartTvVewdApp",
    "BlockbusterSmartTvPhilipsApp"
  ],
  NextAction: ["NextActionProposePurchaseContent", "NextActionPlayContent"],
  Action: ["RedirectAction"],
  FeatureTarget: [
    "Movie",
    "Series",
    "MetaCollectionBundle",
    "ListReference",
    "PageReference",
    "ContentCollectionReference",
    "Ticket"
  ],
  ContentCollectionTargetBase: [
    "ContentCollectionTargetAuth",
    "ContentCollectionTargetStart",
    "ContentCollectionTargetHome",
    "ContentCollectionTargetSearch",
    "ContentCollectionTargetMedia",
    "ContentCollectionTargetContentCollection",
    "ContentCollectionTargetPage",
    "ContentCollectionTargetList"
  ],
  ContentCollectionTargetMediaItem: ["Movie", "Series", "MetaCollectionBundle"],
  ContentCollectionTarget: [
    "ContentCollectionTargetMedia",
    "ContentCollectionTargetContentCollection",
    "ContentCollectionTargetPage",
    "ContentCollectionTargetList",
    "ContentCollectionTargetAuth",
    "ContentCollectionTargetHome",
    "ContentCollectionTargetStart",
    "ContentCollectionTargetSearch"
  ],
  ContentCollectionUserContentType: [
    "ContentCollectionUserContentEntitlements",
    "ContentCollectionUserContentMyList",
    "ContentCollectionUserContentContinueWatching",
    "ContentCollectionUserContentSavedSearches",
    "ContentCollectionUserContentMyActors",
    "ContentCollectionUserContentMyDirectors",
    "ContentCollectionUserContentMyGenres"
  ],
  ContentCollectionTakeoverItem: ["Series", "Movie", "MetaCollectionBundle"],
  ContentCollectionSlice: [
    "List",
    "Promos",
    "Spotlights",
    "ListGrid",
    "ContentCollectionRecommendation",
    "ContentCollectionImage",
    "ContentCollectionDescription",
    "ContentCollectionTakeover",
    "ContentCollectionTitle",
    "ContentCollectionUsp",
    "ContentCollectionCallToAction",
    "ContentCollectionListPosition",
    "ContentCollectionMyList",
    "ContentCollectionUserContent",
    "ContentCollectionEntitlements",
    "ContentCollectionNotificationTeaser",
    "ContentCollectionContinueWatching",
    "ContentCollectionTopList"
  ],
  BaseMetaCollection: [
    "MetaCollectionBundle",
    "MetaCollectionCategoryPlot",
    "MetaCollectionCategoryAudience",
    "MetaCollectionCategoryTime",
    "MetaCollectionCategoryBasedOn",
    "MetaCollectionCategoryStyle",
    "MetaCollectionCategoryPlace"
  ],
  MetaCollectionCategory: [
    "MetaCollectionCategoryPlot",
    "MetaCollectionCategoryAudience",
    "MetaCollectionCategoryTime",
    "MetaCollectionCategoryBasedOn",
    "MetaCollectionCategoryStyle",
    "MetaCollectionCategoryPlace"
  ],
  MetaCollection: [
    "MetaCollectionCategoryAudience",
    "MetaCollectionCategoryBasedOn",
    "MetaCollectionCategoryPlot",
    "MetaCollectionCategoryStyle",
    "MetaCollectionCategoryPlace",
    "MetaCollectionCategoryTime",
    "MetaCollectionBundle"
  ],
  FavoritableItem: [
    "Movie",
    "Series",
    "Season",
    "Episode",
    "Ticket",
    "MetaCollectionBundle"
  ],
  EntitlementItem: ["Movie", "Series", "MetaCollectionBundle"],
  SavedSearch: [
    "GenericSavedSearch",
    "SingleTitleSavedSearch",
    "TitlesInSeriesSavedSearch"
  ],
  Personalization: [
    "TopGenrePersonalization",
    "TopActorPersonalization",
    "TopDirectorPersonalization",
    "TopMetaCollectionPersonalization",
    "TopYearPersonalization",
    "TopImdbRatingPersonalization"
  ],
  PersonalizationItem: [
    "TopGenrePersonalization",
    "TopActorPersonalization",
    "TopDirectorPersonalization",
    "TopMetaCollectionPersonalization",
    "TopYearPersonalization",
    "TopImdbRatingPersonalization"
  ]
};

// src/~client/cache/cacheUtils.ts
var isInvalidationPolicyCache = (cache) => {
  const maybeCache = cache;
  if (typeof maybeCache.expire !== "function")
    return null;
  if (typeof maybeCache.expiredEntities !== "function")
    return null;
  return maybeCache;
};
var mergeUnique = (curr, next) => {
  if (!curr)
    return next;
  const values = [next.map((v) => v.__ref), curr.map((v) => v.__ref)].flat().filter((u, i, all) => all.indexOf(u) === i).map((v) => ({ __ref: v }));
  return uniqBy(values, "__ref");
};
var mergeTypePolicies = (a, b) => merge2(a, b);
var pickId = (object) => object.id;
var mergeUseNext = (_, next) => next;
var mergeList = (existing = [], next = []) => [
  ...existing,
  ...next
];
var mergeResults = (existingObj, newObj) => __spreadValues(__spreadValues({}, existingObj), newObj);
var mergeByPriority = (type2) => (existing = [], incoming, { readField }) => {
  const merged = [...incoming, ...existing].filter(
    (current, _index, array) => {
      const allWithId = array.filter((v) => {
        return readField(type2, v) === readField(type2, current);
      });
      const highestPriority = allWithId.reduce((prev, current2) => {
        const prevPriority = readField("priority", prev);
        const currentPriority = readField("priority", current2);
        return prevPriority > currentPriority ? prev : current2;
      });
      return highestPriority === current;
    }
  );
  return merged;
};
var makeTypePolicies = () => {
  const typePolicies = {};
  OBJECT_TYPES_WITH_ID.forEach((t) => {
    typePolicies[t] = {
      keyFields: pickId
    };
  });
  OBJECT_TYPES_WITHOUT_ID.forEach((t) => {
    typePolicies[t] = {
      keyFields: false
    };
  });
  return typePolicies;
};
var createGloballyUniqueIdResolver = (typename, getIdentifiers) => (obj, args) => createGloballyUniqueId(typename, getIdentifiers(obj, args));
var createGloballyUniqueId = (typename, identifiers) => base64.encode(`${typename}:${identifiers.slice().sort().join(":")}`);
var mediaTypes = ["Movie", "Episode", "Season", "Series"];
var toMediaReference = ({
  toReference,
  canRead,
  args
}) => {
  for (const __typename2 of mediaTypes) {
    const ref = toReference({
      __typename: __typename2,
      id: createMediaId({ __typename: __typename2, slug: args == null ? void 0 : args.slug })
    });
    if (canRead(ref))
      return ref;
  }
};

// src/~client/StaticQueryHelper/fetchers/getDeviceInformation.ts
var createDeviceInfoId = ({
  deviceType
}) => createGloballyUniqueId("DeviceInformation", [deviceType]);
var getDeviceInformation = (_a) => __async(void 0, null, function* () {
  var _b = _a, {
    client
  } = _b, rest = __objRest(_b, [
    "client"
  ]);
  var _a2;
  const res = yield client.query({
    query: GQL_GET_DEVICE_INFORMATION_default,
    variables: getVariables(rest)
  });
  return (_a2 = res.data) == null ? void 0 : _a2.response;
});
var getVariables = (variables) => {
  return variables ? sanitizeObject(variables) : void 0;
};

// src/~client/cache/RetainingCache.ts
import { InvalidationPolicyCache } from "@nerdwallet/apollo-cache-policies";
var RetainingCache = class extends InvalidationPolicyCache {
  constructor() {
    super(...arguments);
    this.retainedIds = [];
  }
  retain(rootId, optimistic) {
    this.retainedIds.push(rootId);
    return super.retain(rootId, optimistic);
  }
  release(rootId, optimistic) {
    this.retainedIds = this.retainedIds.filter((id) => id !== rootId);
    return super.release(rootId, optimistic);
  }
  extract(...params) {
    const extracted = super.extract(...params);
    for (const id of this.retainedIds) {
      if (!extracted.invalidation.entitiesById[id]) {
        continue;
      }
      extracted.invalidation.entitiesById[id] = __spreadProps(__spreadValues({}, extracted.invalidation.entitiesById[id]), {
        cacheTime: (/* @__PURE__ */ new Date("3000-01-01")).getTime()
      });
    }
    return extracted;
  }
};

// src/~client/utils/toBrandedUrl.ts
var toBrandedUrl = ({ url, brand }) => {
  if (!url)
    return url;
  const newUrl = new URL(url);
  switch (brand) {
    case "Blockbuster" /* Blockbuster */:
    case "SFAnytime" /* SFAnytime */:
      newUrl.hostname = getProductionDomain(brand).replace("https://", "");
  }
  return newUrl.toString();
};

// src/~client/utils/toLinkTarget/toLinkTarget.ts
var extractCache = {
  data: void 0,
  lastExtracted: 0,
  extract: (cache) => {
    extractCache.data = cache.extract();
    extractCache.lastExtracted = Date.now();
  }
};
var toLinkTarget = ({
  brand,
  options: { cache, readField, isReference }
}) => {
  const target = readField("target");
  const link = readField("link");
  const id = readField("id");
  if (Date.now() - extractCache.lastExtracted > 3e4 || extractCache.data === void 0) {
    extractCache.extract(cache);
  }
  invariant(extractCache.data, "Cache must be extracted");
  const getItem = () => {
    var _a, _b;
    if (isReference(target)) {
      const object2 = (_a = extractCache.data) == null ? void 0 : _a[target.__ref];
      return object2;
    }
    if (target && typeof target === "object") {
      return target;
    }
    const object = typeof id === "string" && ((_b = extractCache.data) == null ? void 0 : _b[id]);
    if (object) {
      return object;
    }
    return void 0;
  };
  let item = getItem();
  if (!item) {
    extractCache.extract(cache);
    item = getItem();
  }
  if (item && "slug" in item) {
    return {
      target: item,
      __typename: "InternalRoute"
    };
  }
  const hasInternalLink = link && typeof link === "object" && "type" in link && (link == null ? void 0 : link.type) === "Web";
  if (hasInternalLink) {
    invariant("url" in link && typeof link.url === "string");
    const domain = getProductionDomain(brand);
    const url = link.url.replace("https:///", `${domain}/`);
    return { __typename: "InternalSite", url };
  }
  return null;
};

// src/~client/cache/cache.ts
import { InMemoryCache } from "@apollo/client";
import { relayStylePagination } from "@apollo/client/utilities";
import {
  InvalidationPolicyCache as InvalidationPolicyCache2
} from "@nerdwallet/apollo-cache-policies";
var createTypePolicies = ({ brand }) => mergeTypePolicies(makeTypePolicies(), {
  Query: {
    fields: {
      list: {
        keyArgs: ["locale", "slug", "orderBy"]
      },
      savedsearch: {
        merge: mergeUseNext
      },
      favorites: {
        merge: mergeUseNext
      },
      deviceInfo: {
        read(_, { args, toReference }) {
          return toReference({
            __typename: "DeviceInformation",
            id: createDeviceInfoId({ deviceType: args == null ? void 0 : args.device })
          });
        }
      },
      bookmark: {
        read(_, { args, toReference }) {
          return toReference({
            __typename: "Bookmark",
            id: args == null ? void 0 : args.id
          });
        }
      },
      media: {
        read: (_, opts) => toMediaReference(opts)
      },
      entitlement: {
        read(_, { args, toReference }) {
          return toReference({
            __typename: "AccountEntitlement",
            id: args == null ? void 0 : args.id
          });
        }
      },
      playbacktoken: {
        read(_, { args, toReference }) {
          return toReference({
            __typename: "AccountPlaybackToken",
            id: createPlaybackTokenId({ slug: args == null ? void 0 : args.slug })
          });
        }
      },
      tickets: relayStylePagination()
    }
  },
  ContentList: {
    fields: {
      items: relayStylePagination(["locale", "slug", "orderBy"])
    }
  },
  DeviceInformation: {
    fields: {
      features: { merge: mergeByPriority("feature") },
      configs: { merge: mergeByPriority("config") }
    }
  },
  Localization: {
    merge: mergeLocalizations
  },
  Account: {
    fields: {
      paymentMethods: {
        merge: mergeUseNext
      }
    }
  },
  Transaction: {
    fields: {
      paymentMethods: {
        merge: mergeUseNext
      }
    }
  },
  Media: {
    fields: {
      tags: {
        merge: mergeUnique
      }
    }
  },
  DisplayableInCollection: {
    fields: {
      url: {
        read: (url) => toBrandedUrl({ url, brand })
      },
      linkTarget: {
        read: (_, options) => {
          return toLinkTarget({ brand, options });
        }
      }
    }
  },
  ContentCollection: {
    fields: {
      items: {
        keyArgs: []
      },
      collection: relayStylePagination()
    }
  },
  ContentCollectionPaginationResult: {
    fields: {
      content: {
        merge: mergeList
      }
    }
  },
  Display: {
    merge: true
  }
});
var DEFAULT_GLOBAL_TTL = 1e3 * 60 * 60 * 12;
var createApolloCache = ({
  cacheInvalidation,
  brand
}) => {
  const config = {
    possibleTypes,
    typePolicies: createTypePolicies({ brand })
  };
  if (cacheInvalidation.enabled) {
    const Cache2 = cacheInvalidation.experimental_retainingCache ? RetainingCache : InvalidationPolicyCache2;
    return new Cache2(__spreadProps(__spreadValues({}, config), {
      invalidationPolicies: {
        timeToLive: cacheInvalidation.ttl || DEFAULT_GLOBAL_TTL
      }
    }));
  }
  return new InMemoryCache(config);
};

// src/~client/cache/persist.ts
import {
  CachePersistor
} from "apollo3-cache-persist";
var SCHEMA_VERSION = "3";
var SCHEMA_VERSION_KEY = "apollo-schema-version";
var attachPersistCache = (_0) => __async(void 0, [_0], function* ({
  cache,
  storageWrapper,
  storage: storage2
}) {
  const persistor = new CachePersistor({
    cache,
    storage: storageWrapper,
    maxSize: false
    // infinite
  });
  yield migrateIfNeeded({ storage: storage2, persistor });
});
function migrateIfNeeded(_0) {
  return __async(this, arguments, function* ({
    storage: storage2,
    persistor
  }) {
    const currentVersion = yield storage2.get(SCHEMA_VERSION_KEY);
    if (currentVersion === SCHEMA_VERSION) {
      yield persistor.restore();
    } else {
      yield persistor.purge();
      yield storage2.set(SCHEMA_VERSION_KEY, SCHEMA_VERSION);
    }
  });
}

// src/~client/client/client.ts
import { ApolloClient as ApolloClient2, ApolloLink as ApolloLink4 } from "@apollo/client";

// src/~client/links/links.ts
import {
  createHttpLink,
  split
} from "@apollo/client";
import { createPersistedQueryLink } from "@apollo/client/link/persisted-queries";
import { WebSocketLink } from "@apollo/client/link/ws";
import { getMainDefinition } from "@apollo/client/utilities";
import { Sha256 } from "@aws-crypto/sha256-js";
import { Buffer as Buffer3 } from "buffer/";
import { print } from "graphql/language/printer";
import { SubscriptionClient } from "subscriptions-transport-ws";

// src/~client/client/getUris.ts
var uris = {
  localhost: {
    cdn: void 0,
    noCdn: "http://localhost:4000/graphql",
    ws: "ws://localhost:4000/subscriptions",
    log: "http://localhost:4000/graphql"
  },
  alpha: {
    cdn: void 0,
    noCdn: "https://shapeshifter-graphql-alpha.herokuapp.com/graphql",
    ws: "wss://shapeshifter-graphql-alpha.herokuapp.com/subscriptions",
    log: "https://shapeshifter-graphql-alpha.herokuapp.com/graphql"
  },
  staging: {
    cdn: "https://gql.sfanytime.xyz/graphql",
    noCdn: "https://graphql.sfanytime.xyz/graphql",
    ws: "wss://graphql.sfanytime.xyz/subscriptions",
    log: "https://graphql.sfanytime.xyz/graphql"
  },
  production: {
    cdn: "https://gql.sfanytime.com/graphql",
    noCdn: "https://graphql.sfanytime.com/graphql",
    ws: "wss://ws.sfanytime.com/subscriptions",
    log: "https://log.sfanytime.com/graphql"
  }
};
var getGraphqlServerUris = ({
  env,
  ssrMode
}) => {
  if (typeof env === "object" && env.name === "custom") {
    const { uri: uri2, logUri, wsUri } = env;
    return { uri: uri2, logUri, wsUri };
  }
  const envName = typeof env === "string" ? env : env.name;
  const { cdn, log, noCdn, ws } = uris[envName];
  const uri = (() => {
    var _a;
    const useCdn = typeof env === "object" ? (_a = env.cdn) != null ? _a : true : true;
    return useCdn ? cdn != null ? cdn : noCdn : noCdn;
  })();
  return {
    wsUri: ssrMode ? void 0 : ws,
    logUri: log,
    uri
  };
};

// src/~client/links/PersistedQueryLinkSkipper.ts
import { setContext } from "@apollo/client/link/context";
var PersistedQueryLinkSkipper = () => setContext((request, context) => __async(void 0, null, function* () {
  var _a, _b;
  const currentFetchOptions = (_a = context.fetchOptions) != null ? _a : {};
  if (currentFetchOptions.method !== "GET")
    return;
  let biggerThenMaxGet = false;
  try {
    biggerThenMaxGet = encodeURIComponent(JSON.stringify(request.variables)).length > 8e3;
  } catch (e) {
  }
  if (!biggerThenMaxGet)
    return;
  return {
    fetchOptions: __spreadProps(__spreadValues({}, (_b = context.fetchOptions) != null ? _b : {}), {
      method: "POST"
    })
  };
}));
var PersistedQueryLinkSkipper_default = PersistedQueryLinkSkipper;

// src/~client/utils/promiseUtils.ts
import { Observable } from "@apollo/client";
var promiseToObservable = (promise) => new Observable((subscriber) => {
  promise.then(
    (value) => {
      if (subscriber.closed) {
        return;
      }
      subscriber.next(value);
      subscriber.complete();
    },
    (err) => {
      subscriber.error(err);
    }
  );
});

// src/~client/links/AuthLink/AuthLink.ts
import {
  ApolloLink
} from "@apollo/client";
import {
  checkDocument,
  hasDirectives,
  removeDirectivesFromDocument
} from "@apollo/client/utilities";
import get2 from "lodash/get";
var AuthLink = class extends ApolloLink {
  constructor(storage2) {
    super();
    this.sanitizedQueryCache = /* @__PURE__ */ new Map();
    this.setTokenHeader = (auth, operation) => {
      const context = operation.getContext();
      const token = typeof context.forceToken === "string" ? context.forceToken : get2(auth, "token", null);
      if (token) {
        operation.setContext({
          headers: __spreadProps(__spreadValues({}, context.headers), {
            authorization: `Bearer ${token}`
          })
        });
      }
    };
    this.sanatizeQuery = (query) => {
      let sanitizedQuery = this.sanitizedQueryCache[JSON.stringify(query)];
      if (!sanitizedQuery) {
        checkDocument(query);
        sanitizedQuery = removeDirectivesFromDocument(
          [{ name: "disableAuth" }],
          query
        );
        this.sanitizedQueryCache[JSON.stringify(query)] = sanitizedQuery;
        return this.sanitizedQueryCache[JSON.stringify(query)];
      }
      return sanitizedQuery;
    };
    this.storage = storage2;
  }
  getAuthObject() {
    return __async(this, null, function* () {
      const auth = yield getAuth(this.storage);
      return auth;
    });
  }
  request(operation, forward) {
    const disableAuth = hasDirectives(["disableAuth"], operation.query);
    operation.query = this.sanatizeQuery(operation.query);
    if (disableAuth) {
      return forward(operation);
    }
    const promise = this.getAuthObject();
    return promiseToObservable(promise).flatMap((auth) => {
      this.setTokenHeader(auth, operation);
      return forward(operation);
    });
  }
};

// src/~client/links/DeviceLink/DeviceLink.ts
import { setContext as setContext2 } from "@apollo/client/link/context";
var DeviceLink = ({
  headers: deviceHeaders,
  capabilities: deviceCapabilities,
  brand
}) => setContext2((_0, _1) => __async(void 0, [_0, _1], function* (request, { headers }) {
  const current = (request == null ? void 0 : request.headers) || headers;
  const dHeaders = typeof deviceHeaders === "function" ? deviceHeaders() : deviceHeaders;
  const newDeviceHeaders = {
    "X-Brand": brand,
    "X-Api-Token": dHeaders.token,
    "X-Device-Id": dHeaders.id,
    "X-Device-Model": dHeaders.model,
    "X-Device-Type": dHeaders.type,
    "X-Device-Version": dHeaders.version,
    "X-Device-Manufacturer": dHeaders.manufacturer,
    "X-Device-Capabilities": deviceCapabilities.toString()
  };
  const returnHeaders = {
    headers: __spreadValues(__spreadValues({}, current), newDeviceHeaders)
  };
  return returnHeaders;
}));
var DeviceLink_default = DeviceLink;

// src/~client/links/RefreshTokenLink/RefreshTokenLink.ts
import { onError } from "@apollo/client/link/error";
import {
  Observable as Observable3,
  ApolloLink as ApolloLink2
} from "@apollo/client";
import { getOperationName } from "@apollo/client/utilities";
var AuthOpName = String(getOperationName(GQL_ACCOUNT_AUTHORIZATION_default));
var AuthRefreshOpName = String(getOperationName(GQL_ACCOUNT_AUTHORIZATION_REFRESH_default));
var refreshTokenApolloLink = ({
  retryRequest,
  refreshToken: refreshToken2,
  flushQueue,
  addToQueue,
  isAlreadyFetchingToken
}) => (
  // @ts-ignore
  onError(({ graphQLErrors, operation, forward }) => {
    if (graphQLErrors) {
      const { extensions } = graphQLErrors[0];
      if (extensions && extensions.code === "UNAUTHENTICATED") {
        const opName = operation.operationName;
        if ([AuthOpName].includes(opName)) {
          return;
        }
        return new Observable3((observer) => __async(void 0, null, function* () {
          if (!isAlreadyFetchingToken()) {
            try {
              yield refreshToken2();
              flushQueue();
              return retryRequest(operation, forward, observer);
            } catch (e) {
              flushQueue(new Error("Unable to refresh access token"));
              return observer.error(e);
            }
          }
          try {
            if (opName === AuthRefreshOpName) {
              const e = new Error(
                "We cannot refresh jwt token on a AccountRefreshToken operation."
              );
              flushQueue(e);
              return observer.error(e);
            }
            const tokenSubscriber = new Promise((resolve, reject) => {
              addToQueue((errRefreshing) => {
                if (errRefreshing) {
                  return reject(errRefreshing);
                }
                return resolve(retryRequest(operation, forward, observer));
              });
            });
            return tokenSubscriber;
          } catch (e) {
            return observer.error(e);
          }
        }));
      }
    }
  })
);
var ErrorQueue = class {
  constructor() {
    this.queue = [];
  }
  enqueue(callback) {
    this.queue.push(callback);
  }
  consume(error) {
    this.queue.map((callback) => callback(error));
    this.queue = [];
  }
};
var RefreshTokenLink = class _RefreshTokenLink extends ApolloLink2 {
  constructor(storage2) {
    super();
    this.queue = new ErrorQueue();
    this.isFetchingToken = false;
    this.refreshPromise = null;
    this.storage = storage2;
    this.link = refreshTokenApolloLink({
      retryRequest: _RefreshTokenLink.retryRequest,
      refreshToken: this.refreshToken.bind(this),
      flushQueue: this.flushQueue.bind(this),
      addToQueue: this.addToQueue.bind(this),
      isAlreadyFetchingToken: this.isAlreadyFetchingToken.bind(this)
    });
  }
  static retryRequest(operation, forward, observer) {
    const subscriber = {
      next: observer.next.bind(observer),
      error: observer.error.bind(observer),
      complete: observer.complete.bind(observer)
    };
    return forward(operation).subscribe(subscriber);
  }
  injectClient(client) {
    this.client = client;
  }
  request(operation, forward) {
    return this.link.request(operation, forward);
  }
  isAlreadyFetchingToken() {
    return this.isFetchingToken;
  }
  addToQueue(callback) {
    this.queue.enqueue(callback);
  }
  flushQueue(error) {
    this.queue.consume(error);
    this.isFetchingToken = false;
  }
  refreshToken() {
    return __async(this, null, function* () {
      if (!this.client) {
        throw new Error(
          "[RefreshTokenLink] - No Apollo Client available. that means you have not injected a client. Please inject a client before you try to do any request"
        );
      }
      if (!this.isAlreadyFetchingToken()) {
        this.isFetchingToken = true;
        this.refreshPromise = refreshToken(this.client, this.storage);
        return this.refreshPromise;
      }
      return this.refreshPromise;
    });
  }
};
var RefreshTokenLink_default = RefreshTokenLink;

// src/~client/links/RetryLink/RetryLink.ts
import { RetryLink } from "@apollo/client/link/retry";
var attemptsFunction = (error) => {
  return !!error;
};
var RetryLink_default = new RetryLink({
  delay: {
    initial: 2e3,
    max: 3e4,
    jitter: true
  },
  attempts: {
    max: 2,
    retryIf: attemptsFunction
  }
});

// src/~client/links/links.ts
var sha256 = (s) => {
  const hash3 = new Sha256();
  hash3.update(s);
  const hashUint8Array = hash3.digestSync();
  return Buffer3.from(hashUint8Array).toString("hex");
};
var generateHash = (query) => {
  return sha256(print(query));
};
var isSubscription = ({ query }) => {
  const definition = getMainDefinition(query);
  return definition.kind === "OperationDefinition" && definition.operation === "subscription";
};
function createApolloLink({
  env,
  storage: storage2,
  brand,
  useGETForHashedQueries,
  deviceHeaders,
  fetch: fetch2,
  onWebsocketError = void 0,
  ssrMode,
  deviceCapabilities
}) {
  const { uri, wsUri, logUri } = getGraphqlServerUris({ env, ssrMode });
  const httpOptions = {
    credentials: "same-origin"
  };
  let websocketLink = null;
  if (wsUri) {
    const wsClient = new SubscriptionClient(wsUri, {
      lazy: true,
      reconnect: true,
      reconnectionAttempts: 4,
      inactivityTimeout: 1e3 * 60 * 15
    });
    if (onWebsocketError) {
      wsClient.onError(onWebsocketError);
    }
    websocketLink = new WebSocketLink(wsClient);
    websocketLink.subscriptionClient.use([
      {
        applyMiddleware: (operation, forward) => {
          var _a, _b, _c;
          let customBrowserHeaders = {};
          try {
            customBrowserHeaders = {
              // @ts-ignore
              "user-agent": (_a = window == null ? void 0 : window.navigator) == null ? void 0 : _a.userAgent,
              // @ts-ignore
              origin: (_b = window == null ? void 0 : window.location) == null ? void 0 : _b.origin,
              // @ts-ignore
              referer: (_c = window == null ? void 0 : window.location) == null ? void 0 : _c.href
            };
          } catch (error) {
            console.error(error);
          }
          operation.headers = __spreadValues(__spreadValues({}, customBrowserHeaders), operation.getContext().headers);
          forward();
        }
      }
    ]);
  }
  let defaultLink = createPersistedQueryLink({
    useGETForHashedQueries,
    generateHash
  });
  defaultLink = defaultLink.concat(PersistedQueryLinkSkipper_default());
  defaultLink = defaultLink.concat(
    createHttpLink(__spreadValues({
      uri,
      fetch: fetch2
    }, httpOptions))
  );
  const logLink = createHttpLink(__spreadValues({
    uri: logUri,
    fetch: fetch2
  }, httpOptions));
  const httpLink = RetryLink_default.split(
    (operation) => operation.getContext().isLog === true,
    logLink,
    defaultLink
  );
  const link = websocketLink ? split(isSubscription, websocketLink, httpLink) : httpLink;
  return [
    new RefreshTokenLink_default(storage2),
    DeviceLink_default({
      headers: deviceHeaders,
      capabilities: deviceCapabilities,
      brand
    }),
    new AuthLink(storage2),
    link
  ];
}

// src/~client/client/client.ts
function createApollo(_0) {
  return __async(this, arguments, function* ({
    brand,
    ssrMode = false,
    storage: storage2,
    env,
    useGETForHashedQueries = true,
    connectToDevTools = false,
    deviceHeaders,
    onWebsocketError = void 0,
    cacheInvalidation,
    persistance,
    defaultOptions = {},
    deviceCapabilities
  }) {
    const cache = createApolloCache({ cacheInvalidation, brand });
    if (persistance.enabled) {
      yield attachPersistCache({
        cache,
        storage: storage2,
        storageWrapper: persistance.storageWrapper
      });
    }
    const links = createApolloLink({
      storage: storage2,
      cache,
      env,
      ssrMode,
      useGETForHashedQueries,
      deviceHeaders,
      fetch: apolloStatus.fetch,
      onWebsocketError,
      brand,
      deviceCapabilities
    });
    const [refreshTokenLink] = links;
    const client = new ApolloClient2({
      link: ApolloLink4.from(links),
      cache,
      ssrMode,
      connectToDevTools,
      ssrForceFetchDelay: 100,
      typeDefs: localSchema_default,
      defaultOptions
    });
    refreshTokenLink.injectClient(client);
    return {
      client,
      cache
    };
  });
}
function createApolloSync({
  env,
  brand,
  ssrMode = false,
  storage: storage2,
  useGETForHashedQueries = true,
  connectToDevTools = false,
  deviceHeaders,
  onWebsocketError = void 0,
  cacheInvalidation,
  defaultOptions = {},
  deviceCapabilities
}) {
  const cache = createApolloCache({ cacheInvalidation, brand });
  const links = createApolloLink({
    storage: storage2,
    env,
    cache,
    useGETForHashedQueries,
    deviceHeaders,
    fetch: apolloStatus.fetch,
    onWebsocketError,
    brand,
    ssrMode,
    deviceCapabilities
  });
  const [refreshTokenLink] = links;
  const client = new ApolloClient2({
    link: ApolloLink4.from(links),
    cache,
    ssrMode,
    connectToDevTools,
    ssrForceFetchDelay: 100,
    typeDefs: localSchema_default,
    defaultOptions
  });
  refreshTokenLink.injectClient(client);
  return {
    client,
    cache
  };
}

// src/~client/StaticQueryHelper/fetchers/getAppInfo.ts
var getAppInfo = (_a) => __async(void 0, null, function* () {
  var _b = _a, {
    client,
    deviceType
  } = _b, options = __objRest(_b, [
    "client",
    "deviceType"
  ]);
  const { data } = yield client.query(__spreadValues({
    query: GQL_GET_APP_INFO_default,
    variables: { deviceType: [deviceType] }
  }, options));
  return data.response;
});

// src/~client/StaticQueryHelper/fetchers/addNotificationToken.ts
var key = "notifications/lastSentToken";
var minDaysBetweenTokenUploads = 14;
var addNotificationToken = (_0) => __async(void 0, [_0], function* ({
  storage: storage2,
  token,
  client
}) {
  var _a;
  const { token: previouslyAddedToken, timeAdded } = (_a = yield storage2.get(key)) != null ? _a : {};
  const shouldAddToken = (() => {
    if (!previouslyAddedToken)
      return true;
    if (previouslyAddedToken !== token)
      return true;
    if (!timeAdded)
      return true;
    if (hasHoursPassed(minDaysBetweenTokenUploads * 24)(timeAdded))
      return true;
    return false;
  })();
  if (shouldAddToken) {
    const response = yield client.mutate({
      mutation: GQL_ADD_NOTIFICATION_TOKEN_default,
      variables: { token }
    });
    yield storage2.set(key, {
      token,
      timeAdded: (/* @__PURE__ */ new Date()).toISOString()
    });
    return response;
  }
});
var clearLastSentNotificationToken = (storage2) => __async(void 0, null, function* () {
  yield storage2.remove(key);
});

// src/~client/StaticQueryHelper/fetchers/getBookmarks.ts
var getFilteredResponse = (response) => {
  var _a;
  return (_a = response == null ? void 0 : response.filter((r) => r !== null).filter((r) => r.item)) != null ? _a : null;
};
var getBookmarks = (_a) => __async(void 0, null, function* () {
  var _b = _a, {
    client,
    locale
  } = _b, options = __objRest(_b, [
    "client",
    "locale"
  ]);
  const { data } = yield client.query(__spreadValues({
    query: GQL_GET_BOOKMARKS_default,
    variables: { locale }
  }, options));
  return getFilteredResponse(data.response);
});

// src/~client/StaticQueryHelper/fetchers/getContentCollection.ts
var getContentCollection = (_a) => __async(void 0, null, function* () {
  var _b = _a, {
    client
  } = _b, rest = __objRest(_b, [
    "client"
  ]);
  var _a2;
  const res = yield client.query({
    query: GQL_CONTENT_COLLECTION_default,
    variables: sanitizeObject(rest)
  });
  return (_a2 = res.data) == null ? void 0 : _a2.contentcollection;
});

// src/~client/StaticQueryHelper/fetchers/getContentListPaginate.ts
var getContentListPaginate = (_0) => __async(void 0, [_0], function* ({
  client,
  orderBy,
  options,
  slug: slug3,
  locale,
  after,
  first
}) {
  var _a, _b, _c;
  const res = yield client.query({
    query: GQL_CONTENT_LIST_PAGINATE_default,
    variables: {
      locale,
      slug: slug3,
      orderBy,
      coverSize: (_a = options == null ? void 0 : options.cover) == null ? void 0 : _a.size,
      coverPreset: (_b = options == null ? void 0 : options.cover) == null ? void 0 : _b.preset,
      first,
      after
    }
  });
  return (_c = res.data) == null ? void 0 : _c.response;
});

// src/~client/StaticQueryHelper/fetchers/getCustomerSupportArticle.ts
var getCustomerSupportArticle = (_a) => __async(void 0, null, function* () {
  var _b = _a, {
    client,
    locale,
    slug: slug3
  } = _b, rest = __objRest(_b, [
    "client",
    "locale",
    "slug"
  ]);
  var _a2;
  const res = yield client.query(__spreadValues({
    query: GQL_GET_CUSTOMER_SUPPORT_ARTICLE_default,
    variables: {
      locale,
      slug: slug3 != null ? slug3 : ""
    }
  }, rest));
  return (_a2 = res.data.response) != null ? _a2 : [];
});

// src/~client/StaticQueryHelper/fetchers/getCustomerSupportCategories.ts
var getCustomerSupportCategories = (_a) => __async(void 0, null, function* () {
  var _b = _a, {
    client,
    locale
  } = _b, options = __objRest(_b, [
    "client",
    "locale"
  ]);
  var _a2;
  const { data } = yield client.query(__spreadValues({
    query: GQL_GET_CUSTOMER_SUPPORT_CATEGORIES_default,
    variables: { locale }
  }, options));
  return (_a2 = data.response) != null ? _a2 : [];
});

// src/~client/StaticQueryHelper/fetchers/getDrm.ts
var createPlaybackTokenId = ({ slug: slug3 }) => createGloballyUniqueId("AccountPlaybackToken", [slug3]);
var getDrm = (_a) => __async(void 0, null, function* () {
  var _b = _a, {
    client,
    manifestFilters = []
  } = _b, variables = __objRest(_b, [
    "client",
    "manifestFilters"
  ]);
  var _a2;
  const res = yield client.query({
    query: GQL_CREATE_PLAYBACK_TOKEN_default,
    variables: __spreadProps(__spreadValues({}, variables), {
      filters: manifestFilters
    })
  });
  return (_a2 = res.data) == null ? void 0 : _a2.response;
});

// src/~client/StaticQueryHelper/fetchers/getEntitlements.ts
var getResponseWithEmptyArrays = (response) => {
  var _a, _b;
  const items = (_a = response == null ? void 0 : response.items) != null ? _a : [];
  const entitlements2 = (_b = response == null ? void 0 : response.entitlements) != null ? _b : [];
  return {
    subscriptions: [],
    entitlements: entitlements2,
    items,
    tickets: response == null ? void 0 : response.tickets
  };
};
var getEntitlements = (_a) => __async(void 0, null, function* () {
  var _b = _a, {
    client,
    locale
  } = _b, options = __objRest(_b, [
    "client",
    "locale"
  ]);
  const { data } = yield client.query(__spreadValues({
    query: GQL_GET_ENTITLEMENTS_default,
    variables: { locale }
  }, options));
  return getResponseWithEmptyArrays(data.response);
});

// src/~client/StaticQueryHelper/fetchers/getFavorites.ts
var getFavorites = (_a) => __async(void 0, null, function* () {
  var _b = _a, {
    client,
    locale
  } = _b, options = __objRest(_b, [
    "client",
    "locale"
  ]);
  const { data } = yield client.query(__spreadProps(__spreadValues({
    query: GQL_GET_FAVORITES_default
  }, options), {
    variables: __spreadValues({ locale }, options.variables)
  }));
  return data.response;
});

// src/~client/StaticQueryHelper/fetchers/getMedia.ts
import merge3 from "lodash/merge";
var getMedia = (_a) => __async(void 0, null, function* () {
  var _b = _a, { client } = _b, rest = __objRest(_b, ["client"]);
  var _a2;
  const res = yield client.query({
    query: GQL_GET_MEDIA_default,
    variables: getVariables2(rest)
  });
  return (_a2 = res.data) == null ? void 0 : _a2.response;
});
var getVariables2 = (_a) => {
  var _b = _a, {
    hookOptions,
    options
  } = _b, rest = __objRest(_b, [
    "hookOptions",
    "options"
  ]);
  var _a2, _b2, _c, _d, _e, _f, _g, _h, _i, _j, _k;
  const mergedOptions = merge3({}, hookOptions == null ? void 0 : hookOptions.useMedia, options);
  return sanitizeObject(__spreadProps(__spreadValues({}, rest), {
    avatarPreset: (_a2 = mergedOptions == null ? void 0 : mergedOptions.cast) == null ? void 0 : _a2.preset,
    avatarSize: (_b2 = mergedOptions == null ? void 0 : mergedOptions.cast) == null ? void 0 : _b2.size,
    coverSize: (_c = mergedOptions == null ? void 0 : mergedOptions.cover) == null ? void 0 : _c.size,
    coverPreset: (_d = mergedOptions == null ? void 0 : mergedOptions.cover) == null ? void 0 : _d.preset,
    mainMediaSize: (_e = mergedOptions == null ? void 0 : mergedOptions.mainMedia) == null ? void 0 : _e.size,
    mainMediaPreset: (_f = mergedOptions == null ? void 0 : mergedOptions.mainMedia) == null ? void 0 : _f.preset,
    episodeMediaSize: (_h = (_g = mergedOptions == null ? void 0 : mergedOptions.episode) == null ? void 0 : _g.media) == null ? void 0 : _h.size,
    episodeMediaPreset: (_j = (_i = mergedOptions == null ? void 0 : mergedOptions.episode) == null ? void 0 : _i.media) == null ? void 0 : _j.preset,
    recommendationTake: (_k = mergedOptions == null ? void 0 : mergedOptions.recommendation) == null ? void 0 : _k.take,
    slug: rest.slug
  }));
};

// src/~client/StaticQueryHelper/fetchers/getMetaCollection.ts
var getMetaCollection = (_a) => __async(void 0, null, function* () {
  var _b = _a, {
    client,
    locale
  } = _b, variables = __objRest(_b, [
    "client",
    "locale"
  ]);
  var _a2;
  const res = yield client.query({
    query: GQL_GET_META_COLLECTION_default,
    variables: __spreadProps(__spreadValues({}, variables), {
      locale
    })
  });
  return (_a2 = res.data) == null ? void 0 : _a2.response;
});

// src/~client/StaticQueryHelper/fetchers/getMetaCollectionForMedia.ts
var getMetaCollectionForMedia = (_a) => __async(void 0, null, function* () {
  var _b = _a, {
    client,
    locale
  } = _b, variables = __objRest(_b, [
    "client",
    "locale"
  ]);
  const res = yield client.query({
    query: GQL_GET_META_COLLECTION_FOR_META_default,
    variables: __spreadProps(__spreadValues({}, variables), {
      locale
    })
  });
  return res.data.response;
});

// src/~client/StaticQueryHelper/fetchers/getMetaCollectionListPaginate.ts
var getMetaCollectionListPaginate = (_a) => __async(void 0, null, function* () {
  var _b = _a, {
    client
  } = _b, rest = __objRest(_b, [
    "client"
  ]);
  var _a2;
  const res = yield client.query({
    query: GQL_GET_META_COLLECTION_default,
    variables: getVariables3(rest)
  });
  return (_a2 = res.data) == null ? void 0 : _a2.response;
});
var getVariables3 = (_a) => {
  var _b = _a, {
    options
  } = _b, rest = __objRest(_b, [
    "options"
  ]);
  var _a2, _b2;
  return sanitizeObject(__spreadProps(__spreadValues({}, rest), {
    coverSize: (_a2 = options == null ? void 0 : options.cover) == null ? void 0 : _a2.size,
    coverPreset: (_b2 = options == null ? void 0 : options.cover) == null ? void 0 : _b2.preset,
    slug: rest.slug
  }));
};

// src/~client/StaticQueryHelper/fetchers/getPurchasable.ts
var getPurchasable = (_a) => __async(void 0, null, function* () {
  var _b = _a, {
    client
  } = _b, variables = __objRest(_b, [
    "client"
  ]);
  var _a2;
  const res = yield client.query({
    query: GQL_GET_PURCHASABLE_default,
    variables
  });
  return (_a2 = res.data) == null ? void 0 : _a2.purchasable;
});

// src/~client/StaticQueryHelper/fetchers/getRecommendations.ts
var getRecommendations = (_0) => __async(void 0, [_0], function* ({
  client,
  locale,
  source
}) {
  const { data } = yield client.query({
    query: GQL_GET_RECOMMENDATIONS_default,
    variables: {
      locale,
      type: toRecommendationsType(source)
    }
  });
  return data.response;
});
var toRecommendationsType = (source) => {
  return source === "vionlabs-order-history" ? "vionlabsOrderHistory" /* vionlabsOrderHistory */ : "infobaleen" /* infobaleen */;
};

// src/~client/StaticQueryHelper/fetchers/getSavedSearches.ts
var getSavedSearches = (_a) => __async(void 0, null, function* () {
  var _b = _a, {
    client
  } = _b, options = __objRest(_b, [
    "client"
  ]);
  const { data } = yield client.query(__spreadValues({
    query: GQL_GET_SAVED_SEARCHES_default
  }, options));
  return data.response;
});

// src/~client/StaticQueryHelper/fetchers/getTicket.ts
var getTicket = (_a) => __async(void 0, null, function* () {
  var _b = _a, { client } = _b, variables = __objRest(_b, ["client"]);
  var _a2;
  const res = yield client.query({
    query: GQL_GET_TICKET_default,
    variables
  });
  return (_a2 = res.data) == null ? void 0 : _a2.ticket;
});

// src/~client/StaticQueryHelper/fetchers/setBookmark.ts
var setBookmark = (_a) => {
  var _b = _a, {
    client
  } = _b, rest = __objRest(_b, [
    "client"
  ]);
  return client.mutate({
    mutation: GQL_UPDATE_BOOKMARK_default,
    variables: rest
  });
};

// src/~client/StaticQueryHelper/StaticQueryHelper.ts
var StaticQueryHelper = class {
  constructor(client, storage2, locale, device) {
    this.client = client;
    this.storage = storage2;
    this.locale = locale;
    this.device = device;
    this.setLocale = (locale) => {
      this.locale = locale;
    };
    this.client = client;
    this.storage = storage2;
    this.locale = locale;
    this.device = device;
    this.lastExecController;
  }
  hasAuth() {
    return __async(this, null, function* () {
      const authToken = yield getAuth(this.storage);
      return !!authToken;
    });
  }
  updateBookmark(variables) {
    return __async(this, null, function* () {
      const hasAuth = yield this.hasAuth();
      if (!hasAuth)
        return;
      return yield setBookmark(__spreadValues({ client: this.client }, variables));
    });
  }
  getBookmarks(options) {
    return __async(this, null, function* () {
      return getBookmarks(__spreadValues({
        client: this.client,
        locale: this.locale
      }, options));
    });
  }
  getEntitlements(options) {
    return __async(this, null, function* () {
      return getEntitlements(__spreadValues({
        client: this.client,
        locale: this.locale
      }, options));
    });
  }
  getDeviceInformation() {
    return getDeviceInformation({
      client: this.client,
      device: this.device.type
    });
  }
  getCustomerSupportCategories(variables) {
    return getCustomerSupportCategories(__spreadProps(__spreadValues({}, variables), {
      client: this.client,
      locale: this.locale
    }));
  }
  getCustomerSupportArticle(variables) {
    return getCustomerSupportArticle({
      slug: variables.slug,
      client: this.client,
      locale: this.locale
    });
  }
  getMedia(variables) {
    return getMedia(__spreadProps(__spreadValues({}, variables), { client: this.client, locale: this.locale }));
  }
  getPurchasable(variables) {
    return getPurchasable(__spreadProps(__spreadValues({}, variables), {
      client: this.client,
      locale: this.locale
    }));
  }
  getTicket(variables) {
    return getTicket(__spreadProps(__spreadValues({}, variables), {
      client: this.client,
      locale: this.locale
    }));
  }
  getContentCollection(variables) {
    return getContentCollection(__spreadValues({
      client: this.client,
      locale: this.locale
    }, variables));
  }
  getContentListPaginate(variables) {
    return getContentListPaginate(__spreadValues({
      client: this.client,
      locale: this.locale
    }, variables));
  }
  getMetaCollectionListPaginate(variables) {
    return getMetaCollectionListPaginate(__spreadValues({
      client: this.client,
      locale: this.locale
    }, variables));
  }
  getDrm(variables) {
    return getDrm(__spreadValues({ client: this.client }, variables));
  }
  getEntitlement(variables) {
    return getEntitlement(__spreadValues({ client: this.client }, variables));
  }
  // This does not have a hook as it loaded by the L10n context.
  getLocalization(variables) {
    return __async(this, null, function* () {
      var _a, _b;
      const res = yield this.client.query({
        query: GQL_GET_LOCALIZATION_default,
        variables: __spreadProps(__spreadValues({}, variables), {
          locale: (_a = variables == null ? void 0 : variables.locale) != null ? _a : this.locale,
          fallbackLocale: "en" /* en */
        })
      });
      return (_b = res.data) == null ? void 0 : _b.response;
    });
  }
  addNotificationToken(variables) {
    return addNotificationToken(__spreadValues({
      client: this.client,
      storage: this.storage
    }, variables));
  }
  getFooter(variables) {
    return __async(this, null, function* () {
      const res = yield this.client.query({
        query: GQL_GET_FOOTER_default,
        variables: __spreadProps(__spreadValues({}, variables), {
          locale: this.locale
        })
      });
      return res.data.response;
    });
  }
  getPrismicPage(variables) {
    return __async(this, null, function* () {
      const res = yield this.client.query({
        query: GQL_GET_PRISMIC_PAGE_default,
        variables: __spreadProps(__spreadValues({}, variables), {
          locale: this.locale
        })
      });
      return res.data.response;
    });
  }
  getMetaCollectionForMedia(variables) {
    return getMetaCollectionForMedia(__spreadValues({
      client: this.client,
      locale: this.locale
    }, variables));
  }
  getMetaCollection(variables) {
    return getMetaCollection(__spreadValues({
      client: this.client,
      locale: this.locale
    }, variables));
  }
  getPublicFeed(options) {
    return __async(this, null, function* () {
      const res = yield this.client.query(__spreadProps(__spreadValues({
        query: GQL_PUBLIC_FEED_default
      }, options), {
        variables: __spreadValues({
          locale: this.locale
        }, options.variables)
      }));
      return res.data.response;
    });
  }
  getSavedSearches(variables) {
    return __async(this, null, function* () {
      return yield getSavedSearches({ client: this.client, variables });
    });
  }
  getFavorites(variables) {
    return __async(this, null, function* () {
      return yield getFavorites({
        client: this.client,
        locale: this.locale,
        variables
      });
    });
  }
  getRecommendations(variables) {
    return __async(this, null, function* () {
      return yield getRecommendations(__spreadValues({
        client: this.client,
        locale: this.locale
      }, variables));
    });
  }
  getAccountInformation() {
    return __async(this, null, function* () {
      return this.client.query({
        query: GQL_GET_ACCOUNT_INFORMATION_default
      });
    });
  }
  // This does not have a hook as it loaded by search context
  getSearch(variables) {
    return __async(this, null, function* () {
      var _a;
      const debounced = "debounced";
      if (this.lastExecController) {
        this.lastExecController.abort(debounced);
      }
      const localController = new AbortController();
      this.lastExecController = localController;
      try {
        const res = yield this.client.query({
          query: GQL_GET_SEARCH_default,
          variables,
          context: {
            fetchOptions: {
              signal: localController.signal
            }
          }
        });
        if (localController.signal.aborted)
          throw new DebounceError();
        return (_a = res.data) == null ? void 0 : _a.response;
      } catch (err) {
        if (err instanceof Error && "networkError" in err && err.networkError === debounced) {
          throw new DebounceError();
        }
        throw err;
      }
    });
  }
  getAppInfo() {
    return __async(this, null, function* () {
      return yield getAppInfo({
        client: this.client,
        deviceType: this.device.type
      });
    });
  }
};
var DebounceError = class extends Error {
  constructor() {
    super("Debounced");
  }
};

// src/~client/StaticQueryHelper/fetchers/getEntitlement.ts
import { gql as gql82 } from "@apollo/client";
var GET_ENTITLEMENT = gql82`
  query GetEntitlement($id: String!) {
    entitlement(id: $id) {
      ...EntitlementParts
    }
  }
  ${ENTITLEMENT_FRAGMENT_default}
`;
var createEntitlementId = (params) => createGloballyUniqueIdResolver("AccountEntitlement", (e) => {
  var _a;
  return [(_a = e == null ? void 0 : e.slug) != null ? _a : ""];
})(
  params,
  params
);
var getEntitlement = (_0) => __async(void 0, [_0], function* ({
  client,
  slug: slug3
}) {
  var _a;
  const res = yield client.query({
    query: GET_ENTITLEMENT,
    variables: {
      id: createEntitlementId({ slug: slug3 })
    }
  });
  return (_a = res.data) == null ? void 0 : _a.response;
});

// src/~react-common/theme/darkTheme.ts
var darkThemeBrand = "SFAnytime" /* SFAnytime */;
var setDarkThemeBrand = (brand) => {
  darkThemeBrand = brand;
};
var get3 = (key3) => {
  return brandStyles[darkThemeBrand][themeMap[key3]];
};
var darkTheme = {
  color: {
    get cta() {
      return get3("cta");
    },
    get cta600() {
      return get3("cta600");
    },
    get cta400() {
      return get3("cta400");
    },
    get cta300() {
      return get3("cta300");
    },
    get cta200() {
      return get3("cta200");
    },
    get error() {
      return get3("error");
    },
    get ui900() {
      return get3("ui900");
    },
    get ui800() {
      return get3("ui800");
    },
    get ui700() {
      return get3("ui700");
    },
    get ui600() {
      return get3("ui600");
    },
    get ui500() {
      return get3("ui500");
    },
    get ui400() {
      return get3("ui400");
    },
    get ui100() {
      return get3("ui100");
    },
    get ui200() {
      return get3("ui200");
    },
    get ui300() {
      return get3("ui300");
    },
    get success() {
      return get3("success");
    },
    get white() {
      return get3("white");
    },
    get black() {
      return get3("black");
    },
    get facebook() {
      return get3("facebook");
    },
    get imdb() {
      return get3("imdb");
    }
  },
  state: {
    disabledOpacity: "0.38"
  },
  font: {
    roboto: 'Roboto, "Open Sans", "Droid Sans", "Helvetica Neue"',
    robotoDin: 'DIN, Roboto, "Open Sans", "Droid Sans", "Helvetica Neue"'
  },
  size: {
    super: "2.5rem",
    large: "1.5rem",
    title: "1.25rem",
    text: "1rem",
    tinyTitle: "0.8125rem",
    infoText: "0.8125rem",
    tinyInfo: "0.625rem"
  },
  weight: {
    bold: "700",
    medium: "500",
    regular: "400",
    light: "300"
  },
  letterSpacing: {
    big: "1px",
    small: 0
  },
  lineHeight: {
    small: "17px"
  }
};
var darkTheme_default = darkTheme;

// src/~react-common/index.ts
import { ApolloProvider } from "@apollo/client";

// src/~react-common/contexts/EventsContext/googleAnalytics.ts
var googleAnalytics = ({
  readMedia: readMedia2,
  readTransaction,
  locale
}) => {
  let logger;
  const getEvent = (...params) => {
    const { type: type2, payload } = {
      type: params[0],
      payload: params[1]
    };
    const eventSpecificParams = (() => {
      var _a, _b, _c, _d, _e, _f, _g;
      switch (type2) {
        case "add_to_cart": {
          const media = readMedia2({ slug: payload.slug });
          const item = toItem(media);
          const params2 = {
            items: [item],
            origin: payload.origin
          };
          return params2;
        }
        case "view_trailer":
        case "video_start": {
          const media = readMedia2({ slug: payload.slug });
          const params2 = {
            video_title: media.display.originalTitle
          };
          return params2;
        }
        case "select_item": {
          const { list } = payload;
          const listId = (_c = (_b = (_a = list.slug) != null ? _a : list.__typename) != null ? _b : list.type) != null ? _c : void 0;
          const params2 = {
            items: [
              {
                item_id: payload.slug,
                item_list_id: listId,
                item_list_name: (_d = list.title) != null ? _d : void 0
              }
            ]
          };
          return params2;
        }
        case "view_item_list": {
          const { list } = payload;
          const listId = (_g = (_f = (_e = list.slug) != null ? _e : list.__typename) != null ? _f : list.type) != null ? _g : void 0;
          const params2 = {
            items: payload.items.map((i) => {
              var _a2;
              return {
                item_id: i.slug,
                item_list_id: listId,
                item_list_name: (_a2 = list.title) != null ? _a2 : void 0
              };
            })
          };
          return params2;
        }
        case "view_search_results": {
          const params2 = {
            search_term: payload.searchTerm
          };
          return params2;
        }
        case "sign_up":
        case "login": {
          const params2 = {
            method: payload.type === "credentials" ? "email" : "social"
          };
          return params2;
        }
        case "add_to_wishlist": {
          const media = readMedia2({ slug: payload.slug });
          const item = toItem(media);
          const params2 = {
            video_title: media.display.originalTitle,
            items: [item]
          };
          return params2;
        }
        case "add_to_notification_list": {
          const media = readMedia2({ slug: payload.slug });
          const params2 = {
            video_title: media.display.originalTitle
          };
          return params2;
        }
        case "purchase": {
          const transaction = readTransaction({
            transactionId: payload.transactionId
          });
          const params2 = toTransactionParams(transaction);
          return params2;
        }
        case "begin_checkout": {
          const transaction = readTransaction({
            transactionId: payload.transactionId
          });
          const params2 = toTransactionParams(transaction);
          return params2;
        }
        case "add_payment_info": {
          const params2 = {
            checkout_step: payload.stepNumber,
            checkout_option: payload.stepName
          };
          return params2;
        }
        case "cast": {
          const media = readMedia2({ slug: payload.slug });
          const params2 = {
            video_title: media.display.originalTitle
          };
          return params2;
        }
        case "view_item": {
          const media = readMedia2({ slug: payload.slug });
          const item = toItem(media);
          const params2 = {
            video_title: media.display.originalTitle,
            items: [item]
          };
          return params2;
        }
        case "page_view": {
          const params2 = {
            page_title: payload.pageTitle,
            page_path: payload.pathname
          };
          return params2;
        }
        default: {
          assertUnreachable(type2);
          throw new Error(`Unknown event type: ${type2}`);
        }
      }
    })();
    const commonParams = { region: locale };
    return {
      event: type2,
      params: __spreadValues(__spreadValues({}, commonParams), eventSpecificParams)
    };
  };
  const setLogger = (newLogger) => {
    logger = newLogger;
  };
  const sendEvent = (...params) => {
    if (!logger)
      throw Error("setLogger must be called before sendEvent");
    const event = getEvent(params[0], params[1]);
    logger(event);
  };
  return {
    setLogger,
    sendEvent,
    getEvent
  };
};
var toTransactionParams = (transaction) => {
  var _a, _b, _c, _d, _e;
  const item = toItem(transaction);
  return {
    event_label: [
      transaction.item.__typename.toLowerCase(),
      transaction.selectedPurchaseType.type.toLowerCase()
    ].join("-"),
    transaction_id: transaction.id,
    value: (_b = (_a = transaction.receipt) == null ? void 0 : _a.paidAmount) != null ? _b : void 0,
    currency: (_e = (_d = (_c = transaction.receipt) == null ? void 0 : _c.currency) == null ? void 0 : _d.toUpperCase()) != null ? _e : void 0,
    coupon: transaction.accessCode,
    items: [item]
  };
};
var toItem = (entity) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k;
  const item = entity.__typename === "Transaction" ? entity.item : entity;
  const genres = "genres" in item ? item.genres : [];
  const item_category = item.__typename === "MetaCollectionBundle" ? "Bundle" : item.__typename;
  return __spreadValues({
    quantity: 1,
    item_id: item.slug,
    item_name: (_b = (_a = item == null ? void 0 : item.display) == null ? void 0 : _a.originalTitle) != null ? _b : "",
    item_category,
    item_category2: genres[0],
    item_category3: genres[1],
    item_category4: genres[2],
    item_category5: genres[3]
  }, entity.__typename === "Transaction" ? {
    item_variant: [
      item.slug,
      entity.selectedPurchaseType.type.toLowerCase()
    ].join("-"),
    price: (_d = (_c = entity.receipt) == null ? void 0 : _c.paidAmount) != null ? _d : void 0,
    currency: (_g = (_f = (_e = entity.receipt) == null ? void 0 : _e.currency) == null ? void 0 : _f.toUpperCase()) != null ? _g : void 0,
    discount: (_i = (_h = entity.receipt) == null ? void 0 : _h.discountAmount) != null ? _i : void 0,
    tax: (_k = (_j = entity.receipt) == null ? void 0 : _j.vatAmount) != null ? _k : void 0
  } : {});
};

// src/~react-common/contexts/EventsContext/EventTrackerContext.tsx
import {
  createContext as createContext13,
  useCallback as useCallback56,
  useEffect as useEffect40,
  useMemo as useMemo40,
  useRef as useRef21,
  useState as useState21
} from "react";

// src/~react-hooks/useVisibilitySensor/index.tsx
import { useEffect, useReducer, useLayoutEffect } from "react";
var useIsomorphicEffect = typeof window === "undefined" ? useEffect : useLayoutEffect;
var noop = () => {
};
function normalizeRect(rect) {
  if (rect.width === void 0) {
    rect.width = rect.right - rect.left;
  }
  if (rect.height === void 0) {
    rect.height = rect.bottom - rect.top;
  }
  return rect;
}
var initialState = { isVisible: null, visibilityRect: {} };
function reducer(state, action) {
  switch (action.type) {
    case "set":
      if (state.isVisible === action.payload.isVisible) {
        return state;
      }
      return action.payload;
    default:
      return state;
  }
}
var DEFAULT_OPTIONS = {
  containment: null,
  intervalCheck: false,
  minTopValue: 0,
  partialVisibility: false,
  resizeCheck: false,
  resizeDebounce: 250,
  resizeThrottle: -1,
  scrollCheck: true,
  scrollDebounce: 250,
  scrollThrottle: -1,
  shouldCheckOnMount: true
};
function useVisibilitySensor(ref, options) {
  const [localState, dispatch] = useReducer(reducer, initialState);
  const {
    containment,
    intervalCheck,
    scrollCheck,
    shouldCheckOnMount,
    scrollDebounce,
    scrollThrottle,
    resizeCheck,
    resizeDebounce,
    resizeThrottle,
    partialVisibility,
    minTopValue
  } = Object.assign({}, DEFAULT_OPTIONS, options);
  function getContainer() {
    return containment || window;
  }
  function checkVisibility() {
    let containmentRect;
    if (containment) {
      const containmentDOMRect = containment.getBoundingClientRect();
      containmentRect = {
        bottom: containmentDOMRect.bottom,
        left: containmentDOMRect.left,
        right: containmentDOMRect.right,
        top: containmentDOMRect.top
      };
    } else {
      containmentRect = {
        bottom: window.innerHeight || document.documentElement.clientHeight,
        left: 0,
        right: window.innerWidth || document.documentElement.clientWidth,
        top: 0
      };
    }
    if (!ref.current)
      return { isVisible: false, visibilityRect: {} };
    const rect = normalizeRect(ref.current.getBoundingClientRect());
    const hasSize = rect.height > 0 && rect.width > 0;
    const visibilityRect = {
      bottom: rect.bottom <= containmentRect.bottom,
      left: rect.left >= containmentRect.left,
      right: rect.right <= containmentRect.right,
      top: rect.top >= containmentRect.top
    };
    let isVisible2 = hasSize && visibilityRect.top && visibilityRect.left && visibilityRect.bottom && visibilityRect.right;
    if (hasSize && partialVisibility) {
      let partialVisible = rect.top <= containmentRect.bottom && rect.bottom >= containmentRect.top && rect.left <= containmentRect.right && rect.right >= containmentRect.left;
      if (typeof partialVisibility === "string") {
        partialVisible = visibilityRect[partialVisibility];
      }
      isVisible2 = minTopValue ? partialVisible && rect.top <= containmentRect.bottom - minTopValue : partialVisible;
    }
    return { isVisible: isVisible2, visibilityRect };
  }
  function updateIsVisible() {
    if (!ref.current) {
      return;
    }
    const { isVisible: isVisible2, visibilityRect } = checkVisibility();
    dispatch({
      payload: { isVisible: isVisible2, visibilityRect },
      type: "set"
    });
  }
  useEffect(() => {
    if (shouldCheckOnMount) {
      updateIsVisible();
    }
  }, []);
  useEffect(() => {
    updateIsVisible();
  }, [updateIsVisible]);
  useEffect(() => {
    if (intervalCheck && intervalCheck > 0) {
      const intervalTimer = setInterval(() => {
        updateIsVisible();
      }, intervalCheck);
      return () => {
        clearInterval(intervalTimer);
      };
    }
    return noop;
  }, [intervalCheck]);
  function createListener(event, debounce2, throttle) {
    const container = getContainer();
    let timeout = null;
    let listener;
    const later = () => {
      timeout = null;
      updateIsVisible();
    };
    if (throttle > -1) {
      listener = () => {
        if (!timeout) {
          timeout = setTimeout(later, throttle || 0);
        }
      };
    } else {
      listener = () => {
        if (!timeout)
          return;
        clearTimeout(timeout);
        timeout = setTimeout(later, debounce2 || 0);
      };
    }
    container.addEventListener(event, listener);
    return () => {
      if (!timeout)
        return;
      clearTimeout(timeout);
      container.removeEventListener(event, listener);
    };
  }
  useIsomorphicEffect(() => {
    if (scrollCheck) {
      return createListener("scroll", scrollDebounce, scrollThrottle);
    }
    return noop;
  }, []);
  useIsomorphicEffect(() => {
    if (resizeCheck) {
      return createListener("resize", resizeDebounce, resizeThrottle);
    }
    return noop;
  }, []);
  return localState;
}

// src/~react-hooks/useDebounce/index.tsx
import { useDebounce, useDebouncedCallback } from "use-debounce";

// src/~react-hooks/useQuery/useQuery.ts
import {
  useApolloClient,
  useQuery as useApolloQuery
} from "@apollo/client";
import { useCallback, useMemo } from "react";
var useQuery = (query, options) => {
  const client = useApolloClient();
  const queryResult = useApolloQuery(query, options);
  const optionVariables = useMemo(
    () => options == null ? void 0 : options.variables,
    // Deep equal comparison since options.variables object might change where
    // all variables are the same
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(options == null ? void 0 : options.variables)]
  );
  const fetch2 = useCallback(
    (fetchArgs) => __async(void 0, null, function* () {
      const res = yield client.query({
        query,
        variables: Object.assign({}, optionVariables, fetchArgs == null ? void 0 : fetchArgs.variables),
        fetchPolicy: fetchArgs == null ? void 0 : fetchArgs.fetchPolicy
      });
      return res.data;
    }),
    [client, optionVariables, query]
  );
  return __spreadProps(__spreadValues({}, queryResult), {
    fetch: fetch2,
    refresh: fetch2
  });
};
var useQuery_default = useQuery;

// src/~react-common/contexts/AppContext/AppContext.tsx
import { createContext } from "react";
var AppContext = createContext({});

// src/~react-common/contexts/AppContext/AppContextProvider.tsx
import { useContext as useContext7, useMemo as useMemo8 } from "react";

// src/~react-hooks/useUpdateCssVariables/useUpdateCssVariables.ts
import { useEffect as useEffect2 } from "react";
var useUpdateCssVariables = () => {
  const { brand } = useApp_default();
  useEffect2(() => {
    if (typeof document === "undefined")
      return;
    setCssVariables(brand);
  }, [brand]);
};
var getCssVariables = (brand) => {
  let styles = "";
  Object.entries(brandStyles[brand]).forEach(([cssVariable, value]) => {
    styles += `--${cssVariable}: ${hex2rgb(value)};`;
  });
  return styles;
};
var setCssVariables = (brand) => {
  Object.entries(brandStyles[brand]).forEach(([cssVariable, value]) => {
    document.documentElement.style.setProperty(
      `--${cssVariable}`,
      hex2rgb(value)
    );
  });
};

// src/~react-common/contexts/BrandedThemeProvider/BrandedThemeProvider.tsx
import { ThemeProvider } from "styled-components";
import { jsx } from "react/jsx-runtime";
var BrandedThemeProvider = ({ children }) => {
  useUpdateCssVariables();
  const baseTheme = darkTheme_default;
  const { brand } = useApp_default();
  setDarkThemeBrand(brand);
  const brandColors = Object.keys(baseTheme.color).reduce((acc, key3) => {
    const colorKey = key3;
    acc[colorKey] = brandStyles[brand][themeMap[colorKey]];
    return acc;
  }, {});
  const theme = __spreadProps(__spreadValues({}, baseTheme), {
    color: brandColors
  });
  return /* @__PURE__ */ jsx(ThemeProvider, { theme, children });
};

// src/~react-hooks/useBrand/useBrand.ts
import { createContext as createContext2, useContext } from "react";

// src/~react-hooks/useBrandOverride/useBrandOverride.ts
import { useCallback as useCallback2, useEffect as useEffect3 } from "react";
import { atom, useAtom } from "jotai";
var brandOverrideState = atom(void 0);
var brandOverrideLoading = atom(true);
var key2 = "brandOverrideStorage";
var brandOverrideStorageKey = key2;
var useBrandOverride = ({ reload } = {}) => {
  const [brandOverride, setBrand] = useAtom(brandOverrideState);
  const [loading, setLoading] = useAtom(brandOverrideLoading);
  const { brand: currentBrand, storage: storage2 } = useApp_default();
  useEffect3(() => {
    (() => __async(void 0, null, function* () {
      if (!loading)
        return;
      if (!storage2)
        return;
      try {
        const data = yield storage2.get(key2);
        if (data == null ? void 0 : data.brand)
          setBrand(data.brand);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    }))();
  }, [loading, setBrand, setLoading, storage2]);
  const toggleBrand = useCallback2(() => __async(void 0, null, function* () {
    const nextBrand = brands.filter((brand) => brand !== currentBrand)[0];
    setBrand(nextBrand);
    yield storage2.set(key2, { brand: nextBrand });
    if (reload)
      reload();
  }), [currentBrand, reload, setBrand, storage2]);
  const clearOverride = useCallback2(() => __async(void 0, null, function* () {
    setBrand(void 0);
    yield storage2.remove(key2);
  }), [setBrand, storage2]);
  return { brandOverride, toggleBrand, clearOverride, loading };
};

// src/~react-hooks/useBrand/useBrand.ts
var BrandContext = createContext2({});
var useBrand = () => {
  const brand = useContext(BrandContext);
  const { brandOverride } = useBrandOverride();
  return brandOverride != null ? brandOverride : brand;
};

// src/~react-hooks/useDevice/useDevice.tsx
import { createContext as createContext3, useContext as useContext2 } from "react";
var DeviceContext = createContext3({});
var useDevice = () => useContext2(DeviceContext);

// src/~react-hooks/useDeviceInformation/useDeviceInformation.ts
import { useMemo as useMemo2 } from "react";
var useDeviceInformation = (options) => {
  var _b;
  const device = useDevice();
  const _a = useQuery_default(GQL_GET_DEVICE_INFORMATION_default, __spreadValues({
    variables: { device: device.type }
  }, options)), { data, loading, error, networkStatus } = _a, other = __objRest(_a, ["data", "loading", "error", "networkStatus"]);
  const normalizedData = useMemo2(() => normalizeDeviceInfo(data), [data]);
  return __spreadProps(__spreadValues({}, other), {
    response: (_b = data == null ? void 0 : data.response) != null ? _b : null,
    data,
    normalizedData,
    loading,
    refetching: networkStatus === 4,
    networkStatus,
    error
  });
};
var normalizeDeviceInfo = (data) => {
  var _a, _b, _c, _d, _e, _f;
  return {
    deviceInfoLoaded: !!data,
    features: (_c = (_b = (_a = data == null ? void 0 : data.response) == null ? void 0 : _a.features) == null ? void 0 : _b.reduce((f, v) => {
      f[v.feature] = v.enabled;
      return f;
    }, {})) != null ? _c : {},
    configs: (_f = (_e = (_d = data == null ? void 0 : data.response) == null ? void 0 : _d.configs) == null ? void 0 : _e.reduce((c, v) => {
      c[v.config] = v.value;
      return c;
    }, {})) != null ? _f : {}
  };
};

// src/~react-hooks/useSession/useSession.tsx
import { useApolloClient as useApolloClient3, useMutation } from "@apollo/client";
import {
  createContext as createContext5,
  useCallback as useCallback3,
  useContext as useContext5,
  useEffect as useEffect4,
  useMemo as useMemo3,
  useState as useState2
} from "react";

// src/~react-hooks/useStaticQueryHelper/useStaticQueryHelper.tsx
import { useApolloClient as useApolloClient2 } from "@apollo/client";
import { createContext as createContext4, useContext as useContext3, useState } from "react";
import { jsx as jsx2 } from "react/jsx-runtime";
var sqhContext = createContext4(null);
var useStaticQueryHelper = () => {
  const sqh = useContext3(sqhContext);
  if (sqh == null) {
    throw new Error("Missing StaticQueryHelper. This should not happen.");
  }
  return sqh;
};
var SqhProvider = ({ children }) => {
  const { locale, device, storage: storage2 } = useApp_default();
  const client = useApolloClient2();
  const [sqh] = useState(
    () => new StaticQueryHelper(client, storage2, locale, device)
  );
  return /* @__PURE__ */ jsx2(sqhContext.Provider, { value: sqh, children });
};

// src/~react-hooks/useTracker/useTracker.tsx
import { useContext as useContext4 } from "react";
var useTracker = () => useContext4(EventTrackerContext);
var useTracker_default = useTracker;

// src/~react-hooks/useSession/useSession.tsx
import { jsx as jsx3 } from "react/jsx-runtime";
var useSessionData = (storage2) => {
  const [session, setSession] = useState2(getInitialSessionData());
  useEffect4(() => {
    const sub = (auth) => setSession(auth);
    subscribeToAuth(sub);
    return () => {
      unsubscribeFromAuth(sub);
    };
  }, []);
  useEffect4(() => {
    let canceled = false;
    if (session.initialized)
      return;
    (() => __async(void 0, null, function* () {
      const data = yield getSessionData(storage2);
      if (canceled)
        return;
      setSession(data);
    }))();
    return () => {
      canceled = true;
    };
  }, [storage2, session]);
  return session;
};
var SessionContext = createContext5({});
var SessionProvider = ({
  children
}) => {
  var _a, _b;
  const { storage: storage2, locale } = useApp_default();
  const client = useApolloClient3();
  const session = useSessionData(storage2);
  const { track } = useTracker_default();
  const sqh = useStaticQueryHelper();
  const [loginMutation, { loading: loginLoading, error: loginError }] = useMutation(
    GQL_ACCOUNT_AUTHORIZATION_default
  );
  const [
    oAuthMutation,
    { loading: socialLoginLoading, error: socialLoginError }
  ] = useMutation(
    GQL_ACCOUNT_OAUTH_default
  );
  const socialLogin = useCallback3(
    (variables) => __async(void 0, null, function* () {
      const res = yield oAuthMutation({ variables });
      return res;
    }),
    [oAuthMutation]
  );
  const finalizeLogin = useCallback3(
    (_0) => __async(void 0, [_0], function* ({ auth, type: type2, onBeforeLoginSuccess, newAccountCreated }) {
      if (auth) {
        const validatedData = yield saveAuth(auth, storage2);
        const maxWaitMs = 5e3;
        const response = yield Promise.race([
          Promise.allSettled([
            onBeforeLoginSuccess(),
            sqh.getAccountInformation(),
            sqh.getEntitlements(),
            sqh.getBookmarks()
          ]),
          new Promise(
            (resolve) => setTimeout(() => resolve("timeout"), maxWaitMs)
          )
        ]);
        if (response === "timeout") {
          track("loginPrefetchTimeout", { type: type2 });
        }
        broadcastSessionData({ auth: validatedData, loading: false });
        if (newAccountCreated) {
          track("accountCreated", { type: type2 });
        }
        emit("loggedIn", { type: type2, newAccountCreated });
        track("loggedIn", { type: type2 });
      } else {
        broadcastSessionData({ loading: false });
      }
    }),
    [sqh, storage2, track]
  );
  const login = useCallback3(
    (_0) => __async(void 0, [_0], function* ({
      username,
      password,
      onBeforeLoginSuccess = () => Promise.resolve(),
      newAccountCreated = false
    }) {
      var _a2, _b2;
      const res = yield loginMutation({ variables: { username, password } });
      const auth = (_b2 = (_a2 = res == null ? void 0 : res.data) == null ? void 0 : _a2.response) != null ? _b2 : null;
      yield finalizeLogin({
        auth,
        onBeforeLoginSuccess,
        type: "credentials",
        newAccountCreated
      });
      return res;
    }),
    [finalizeLogin, loginMutation]
  );
  const createAccountAndLogin = useCallback3(
    (_0) => __async(void 0, [_0], function* ({
      email,
      password,
      remoteAuthSessionCode
    }) {
      var _a2, _b2;
      broadcastSessionData({ loading: true });
      let newAccountCreated = false;
      try {
        yield client.mutate({
          mutation: GQL_CREATE_ACCOUNT_default,
          variables: {
            input: { locale, email, password, remoteAuthSessionCode }
          }
        });
        newAccountCreated = true;
      } catch (err) {
        broadcastSessionData({ loading: false });
        throw err;
      }
      const loginResult = yield login({
        username: email,
        password,
        newAccountCreated
      });
      return (_b2 = (_a2 = loginResult == null ? void 0 : loginResult.data) == null ? void 0 : _a2.response) != null ? _b2 : null;
    }),
    [client, locale, login]
  );
  const createAccount = useCallback3(
    (_0) => __async(void 0, [_0], function* ({
      email,
      password,
      remoteAuthSessionCode
    }) {
      var _a2, _b2;
      broadcastSessionData({ loading: true });
      try {
        const createAccountResult = yield client.mutate({
          mutation: GQL_CREATE_ACCOUNT_default,
          variables: {
            input: { locale, email, password, remoteAuthSessionCode }
          }
        });
        track("accountCreated", { type: "credentials" });
        return (_b2 = (_a2 = createAccountResult.data) == null ? void 0 : _a2.response) != null ? _b2 : null;
      } catch (err) {
        broadcastSessionData({ loading: false });
        throw err;
      }
    }),
    [client, locale, track]
  );
  const [
    forgotPasswordMutation,
    { loading: forgotPasswordLoading, error: forgotPasswordError }
  ] = useMutation(
    GQL_FORGOT_PASSWORD_default
  );
  const forgotPassword = useCallback3(
    (_0) => __async(void 0, [_0], function* ({ username }) {
      return forgotPasswordMutation({
        variables: {
          username
        }
      });
    }),
    [forgotPasswordMutation]
  );
  const [
    createAdditionalTokenMutation,
    {
      loading: createAdditionalTokenLoading,
      error: createAdditionalTokenError
    }
  ] = useMutation(
    GQL_ACCOUNT_AUTHORIZATION_ADDITIONAL_default
  );
  const createAdditionalToken = useCallback3(
    ({ token } = {}) => {
      if (token != null) {
        return createAdditionalTokenMutation({
          context: {
            forceToken: token
          }
        });
      }
      return createAdditionalTokenMutation();
    },
    [createAdditionalTokenMutation]
  );
  const [
    resetPasswordMutation,
    { loading: resetPasswordLoading, error: resetPasswordError }
  ] = useMutation(GQL_RESET_PASSWORD_default);
  const resetPassword = useCallback3(
    (_0) => __async(void 0, [_0], function* ({ token, newPassword }) {
      return resetPasswordMutation({
        variables: {
          token,
          newPassword
        }
      });
    }),
    [resetPasswordMutation]
  );
  const saveAuthTokenAndMutateSession = useCallback3(
    (data) => __async(void 0, null, function* () {
      const _a2 = data, { newAccountCreated } = _a2, authData = __objRest(_a2, ["newAccountCreated"]);
      const validatedData = extractAuthData(authData);
      if (!validatedData) {
        throw new Error("Auth data invalid or corrupted.");
      }
      yield finalizeLogin({
        auth: validatedData,
        type: "social",
        onBeforeLoginSuccess: Promise.resolve,
        newAccountCreated
      });
    }),
    [finalizeLogin]
  );
  const doLogout = useCallback3(() => {
    logout({ storage: storage2, client });
    emit("loggedOut");
    track("loggedOut");
  }, [client, storage2, track]);
  const value = {
    session: useMemo3(
      () => ({
        isLoggedIn: !!session.auth,
        loading: session.loading
      }),
      [session.auth, session.loading]
    ),
    auth: (_a = session == null ? void 0 : session.auth) != null ? _a : null,
    loading: (_b = session == null ? void 0 : session.loading) != null ? _b : false,
    login,
    loginLoading,
    saveAuthTokenAndMutateSession,
    loginError,
    socialLogin,
    socialLoginLoading,
    socialLoginError,
    logout: doLogout,
    forgotPasswordError,
    forgotPasswordLoading,
    resetPasswordLoading,
    resetPasswordError,
    createAccount,
    createAccountAndLogin,
    forgotPassword,
    resetPassword,
    isLoggedIn: Boolean(session == null ? void 0 : session.auth),
    createAdditionalToken,
    createAdditionalTokenLoading,
    createAdditionalTokenError,
    onEvent,
    finalizeLogin
  };
  return /* @__PURE__ */ jsx3(SessionContext.Provider, { value, children });
};
var useSession = (options) => {
  useEffect4(() => {
    if (options == null ? void 0 : options.onEvent)
      return onEvent(options.onEvent, { withLatest: true });
  }, [options == null ? void 0 : options.onEvent]);
  const value = useContext5(SessionContext);
  return useMemo3(() => __spreadProps(__spreadValues({}, value), { onEvent }), [value]);
};
var useSession_default = useSession;

// src/~react-common/contexts/LocalizationContext/LocalizationContext.tsx
import i18next from "i18next";
import { createContext as createContext6, useContext as useContext6, useEffect as useEffect5, useMemo as useMemo4 } from "react";
import { I18nextProvider } from "react-i18next";
import { jsx as jsx4 } from "react/jsx-runtime";
var fallbackLocale = "en" /* en */;
var defaultNs = "translation";
var LocalizationContext = createContext6({
  isLoading: true,
  items: {},
  refetch: () => Promise.reject("Missing LocalizationContext.Provider")
});
var LocalizationContextProvider = ({
  locale,
  children
}) => {
  var _a;
  const device = useDevice();
  const brand = useBrand();
  const {
    data: mainLocalizationData,
    loading: fallbackLoading,
    refetch
  } = useQuery_default(
    GQL_GET_LOCALIZATION_default,
    {
      variables: {
        brand,
        locale,
        fallbackLocale,
        deviceType: device.type
      }
    }
  );
  const { data, loading } = useLocalizations({ locale });
  const translationStore = useMemo4(() => {
    const store2 = i18next.createInstance({
      compatibilityJSON: supportsIntl(device.type) ? void 0 : "v3",
      fallbackLng: [fallbackLocale],
      lng: locale,
      debug: false,
      resources: {},
      interpolation: {
        escapeValue: false
      }
    });
    store2.init();
    if (data == null ? void 0 : data.response) {
      store2.addResourceBundle(
        data.response.locale,
        defaultNs,
        data.response.items,
        true,
        false
      );
    }
    if (mainLocalizationData == null ? void 0 : mainLocalizationData.fallback) {
      store2.addResourceBundle(
        mainLocalizationData == null ? void 0 : mainLocalizationData.fallback.locale,
        defaultNs,
        mainLocalizationData.fallback.items,
        true,
        false
      );
    }
    store2.changeLanguage(locale);
    return store2;
  }, []);
  const { track } = useContext6(EventTrackerContext);
  const items = (_a = data == null ? void 0 : data.response) == null ? void 0 : _a.items;
  useEffect5(() => {
    if (items) {
      translationStore.addResourceBundle(locale, defaultNs, items, false, true);
      translationStore.changeLanguage(locale);
    }
    if (translationStore.hasResourceBundle(locale, defaultNs) && translationStore.language !== locale) {
      translationStore.changeLanguage(locale);
      track("@shapeshifter-core/LOCALE_CHANGE", { locale });
    }
  }, [locale, track, items, translationStore]);
  const value = useMemo4(
    () => ({
      refetch,
      isLoading: fallbackLoading || loading || !items,
      items: items != null ? items : {}
    }),
    [fallbackLoading, items, loading, refetch]
  );
  return /* @__PURE__ */ jsx4(I18nextProvider, { i18n: translationStore, children: /* @__PURE__ */ jsx4(LocalizationContext.Provider, { value, children }) });
};
var supportsIntl = (type2) => {
  switch (type2) {
    case "Android" /* Android */:
    case "AndroidTv" /* AndroidTv */:
    case "iOS" /* iOS */:
    case "tvOS" /* tvOS */:
      return false;
    default:
      return true;
  }
};

// src/~react-common/contexts/OfflineContext/OfflineContext.tsx
import { createContext as createContext7, useEffect as useEffect6, useMemo as useMemo5, useState as useState3 } from "react";
import { jsx as jsx5 } from "react/jsx-runtime";
var OfflineContext = createContext7({});
var offlineEvents = createEventEmitter();
var { onEvent: onEvent3 } = offlineEvents;
var OfflineContextProvider = ({
  children,
  initialStatus = "online"
}) => {
  const [status, setStatus] = useState3(initialStatus);
  useEffect6(
    () => onEvent3((event) => setStatus(event.name), { withLatest: true }),
    []
  );
  const ctx = useMemo5(() => ({ offline: status === "offline" }), [status]);
  return /* @__PURE__ */ jsx5(OfflineContext.Provider, { value: ctx, children: status === "unknown" ? null : children });
};

// src/~react-common/contexts/AppContext/Boot.tsx
import { useEffect as useEffect9, useState as useState4 } from "react";

// src/~react-hooks/useAccountEvents/useAccountEvents.ts
import { useSubscription } from "@apollo/client";
import { atom as atom2, useAtomValue, useSetAtom } from "jotai";
import { useEffect as useEffect7, useMemo as useMemo6 } from "react";
var appAccountEventsAtom = atom2([]);
var useAccountEvents = ({ onEvent: onEvent8, filter }) => {
  var _a;
  const events = useAtomValue(appAccountEventsAtom);
  const filteredEvents = useMemo6(() => {
    if (!filter)
      return events;
    return events.filter((event) => filter.includes(event.action));
  }, [events, filter]);
  const previousEvents = (_a = usePrevious(filteredEvents)) != null ? _a : [];
  useEffect7(() => {
    if (!onEvent8)
      return;
    if (previousEvents.length === events.length)
      return;
    const lastEvent = events[events.length - 1];
    onEvent8(lastEvent);
  }, [events, onEvent8, previousEvents.length]);
  return events;
};
var useAccountEventSubscription = () => {
  const { locale } = useApp_default();
  const { isLoggedIn } = useSession_default();
  const setEvents = useSetAtom(appAccountEventsAtom);
  useSubscription(
    GQL_ACCOUNT_EVENT_SUBSCRIPTION_default,
    {
      variables: { locale },
      skip: !isLoggedIn,
      onData: (data) => {
        var _a;
        const event = (_a = data.data.data) == null ? void 0 : _a.response;
        if (!event)
          return;
        setEvents((events) => [...events, event]);
      }
    }
  );
};

// src/~react-hooks/useDevicePreferences/useInitiateDevicePreferences.ts
import { useEffect as useEffect8, useRef } from "react";

// src/~react-hooks/useDevicePreferences/useUpdateDevicePreferences.ts
import { useSetAtom as useSetAtom2 } from "jotai";
import { useCallback as useCallback4 } from "react";

// src/~react-hooks/useDevicePreferences/types.ts
import { atom as atom3 } from "jotai";
var devicePreferencesAtom = atom3({
  subtitleLanguage: null,
  audioLanguage: null,
  fullscreen: null,
  allowCellularDownloads: null,
  initialized: false
});

// src/~react-hooks/useDevicePreferences/useUpdateDevicePreferences.ts
var useUpdateDevicePreferences = () => {
  const setCache = useSetAtom2(devicePreferencesAtom);
  const updateCache = useCallback4(
    (key3, value) => {
      setCache((currentPreferences) => __spreadProps(__spreadValues({}, currentPreferences), {
        [key3]: value
      }));
    },
    [setCache]
  );
  return { updateCache, replace: setCache };
};

// src/~react-hooks/useDevicePreferences/useInitiateDevicePreferences.ts
var useInitiateDevicePreferences = () => {
  const { replace } = useUpdateDevicePreferences();
  const { storage: storage2 } = useApp_default();
  const devicePreferences = useRef(new DevicePreferencesStorage(storage2));
  useEffect8(() => {
    let isCancelled = false;
    (() => __async(void 0, null, function* () {
      const [
        subtitleLanguage,
        audioLanguage,
        fullscreen,
        allowCellularDownloads
      ] = yield Promise.all([
        devicePreferences.current.getSubtitleLanguagePreference(),
        devicePreferences.current.getAudioLanguagePreference(),
        devicePreferences.current.getFullscreenPreference(),
        devicePreferences.current.getAllowCellularDownloadsPreference()
      ]);
      if (isCancelled)
        return;
      replace({
        subtitleLanguage,
        audioLanguage,
        fullscreen,
        allowCellularDownloads,
        initialized: true
      });
    }))();
    return () => {
      isCancelled = true;
    };
  }, [replace]);
};

// src/~react-hooks/useEntitlements/useEntitlements.ts
import { NetworkStatus } from "@apollo/client";
import { useMemo as useMemo7 } from "react";
var useEntitlements = (_a = {}) => {
  var opts = __objRest(_a, []);
  const { locale } = useApp_default();
  const { isLoggedIn } = useSession_default();
  const _a2 = useQuery_default(GQL_GET_ENTITLEMENTS_default, __spreadValues({
    variables: { locale },
    skip: !isLoggedIn || opts.skip || false
  }, opts)), { data, loading, error, networkStatus } = _a2, other = __objRest(_a2, ["data", "loading", "error", "networkStatus"]);
  const responseWithEmptyArrays = useMemo7(
    () => getResponseWithEmptyArrays2(data == null ? void 0 : data.response),
    [data == null ? void 0 : data.response]
  );
  const refetching = networkStatus === NetworkStatus.refetch;
  return __spreadProps(__spreadValues({}, other), {
    loading: loading && responseWithEmptyArrays.items.length === 0 || refetching,
    error,
    networkStatus,
    refetching,
    response: responseWithEmptyArrays
  });
};
var getResponseWithEmptyArrays2 = (response) => {
  var _a, _b;
  const items = (_a = response == null ? void 0 : response.items) != null ? _a : [];
  const entitlements2 = (_b = response == null ? void 0 : response.entitlements) != null ? _b : [];
  return {
    subscriptions: [],
    entitlements: entitlements2,
    items,
    tickets: response == null ? void 0 : response.tickets
  };
};
var useEntitlements_default = useEntitlements;

// src/~react-hooks/useWebsocketEntitlements/useWebsocketEntitlements.ts
import { useSubscription as useSubscription2 } from "@apollo/client";
var useWebsocketEntitlements = ({ skip } = {}) => {
  const { isLoggedIn } = useSession_default();
  const { refetch } = useEntitlements_default({ skip: true });
  const shouldSkip = !isLoggedIn || false || skip === true;
  useSubscription2(GQL_ENTITLEMENT_CREATED_SUBSCRIPTION_default, {
    onData: () => {
      if (!isLoggedIn)
        return;
      refetch();
    },
    skip: shouldSkip
  });
};
var useWebsocketEntitlements_default = useWebsocketEntitlements;

// src/~react-common/contexts/AppContext/Boot.tsx
import { Fragment, jsx as jsx6 } from "react/jsx-runtime";
var Boot = (props) => {
  const { children } = props;
  const { track } = useTracker_default();
  const { sessionLoaded } = useApp_default();
  useInitiateDevicePreferences();
  useAccountEventSubscription();
  useWebsocketEntitlements_default();
  const fetchDelay = props.fetchDelay || 0;
  const [skip, setSkip] = useState4(fetchDelay > 0);
  useEffect9(() => {
    if (fetchDelay <= 0)
      return;
    const timeout = setTimeout(() => {
      requestAnimationFrame(() => setSkip(false));
    }, fetchDelay);
    return () => clearTimeout(timeout);
  });
  const [staggered, setStaggered] = useState4(0);
  const onCompleted = () => {
    setTimeout(
      () => requestAnimationFrame(() => setStaggered((s) => s + 1)),
      props.fetchStagger || 250
    );
  };
  useAccount_default({ skip: skip || staggered < 0, onCompleted });
  useEntitlements_default({ skip: skip || staggered < 1, onCompleted });
  useBookmarks_default({ skip: skip || staggered < 2, onCompleted });
  useSavedSearches({ skip: skip || staggered < 3, onCompleted });
  useFavorites_default({ skip: skip || staggered < 4, onCompleted });
  const wasSessionLoaded = usePrevious(sessionLoaded);
  useEffect9(() => {
    if (!wasSessionLoaded && sessionLoaded) {
      track("@shapeshifter-core/BOOT");
    }
  }, [sessionLoaded, track, wasSessionLoaded]);
  return /* @__PURE__ */ jsx6(Fragment, { children });
};
var Boot_default = Boot;

// src/~react-common/contexts/AppContext/AppContextProvider.tsx
import { Fragment as Fragment2, jsx as jsx7 } from "react/jsx-runtime";
var { onEvent: onEvent4, emit: emit3 } = createEventEmitter();
var DefaultWrapper = ({ children }) => {
  return /* @__PURE__ */ jsx7(Fragment2, { children });
};
var AppContextProvider = ({
  brand,
  locale,
  device,
  storage: storage2,
  children,
  trackers = [],
  initialNetworkStatus,
  bootOptions,
  wrapper
}) => {
  const ContextWrapper = wrapper || DefaultWrapper;
  return /* @__PURE__ */ jsx7(ContextWrapper, { children: /* @__PURE__ */ jsx7(DeviceContext.Provider, { value: device, children: /* @__PURE__ */ jsx7(BrandContext.Provider, { value: brand, children: /* @__PURE__ */ jsx7(LocalizationContextProvider, { locale, children: /* @__PURE__ */ jsx7(AppStateContextProvider, { locale, storage: storage2, children: /* @__PURE__ */ jsx7(EventTrackerContextProvider, { trackers, children: /* @__PURE__ */ jsx7(SqhProvider, { children: /* @__PURE__ */ jsx7(SessionProvider, { children: /* @__PURE__ */ jsx7(
    OfflineContextProvider,
    {
      initialStatus: initialNetworkStatus,
      children: /* @__PURE__ */ jsx7(BrandedThemeProvider, { children: /* @__PURE__ */ jsx7(Boot_default, __spreadProps(__spreadValues({}, bootOptions), { children })) })
    }
  ) }) }) }) }) }) }) }) });
};
var AppStateContextProvider = ({
  children,
  locale,
  storage: storage2
}) => {
  const device = useDevice();
  const brand = useBrand();
  const { isLoading: languageLoading } = useContext7(LocalizationContext);
  const { normalizedData: deviceInfo2, loading: deviceInfoLoading } = useDeviceInformation({
    onCompleted: (data) => emit3("deviceInfoLoaded", normalizeDeviceInfo(data))
  });
  const { initialized: sessionLoaded } = useSessionData(storage2);
  const { isLoading: localizationLoading } = useContext7(LocalizationContext);
  const isBooting = languageLoading || !sessionLoaded || deviceInfoLoading || localizationLoading;
  const state = useMemo8(
    () => __spreadValues({
      sessionLoaded,
      brand,
      isBooting,
      device,
      locale,
      storage: storage2
    }, deviceInfo2),
    [sessionLoaded, brand, isBooting, device, locale, storage2, deviceInfo2]
  );
  return /* @__PURE__ */ jsx7(AppContext.Provider, { value: state, children });
};

// src/~react-hooks/useApp/useApp.ts
import { useContext as useContext8, useEffect as useEffect10 } from "react";
var useApp = (options) => {
  useEffect10(() => {
    if (options == null ? void 0 : options.onEvent)
      return onEvent4(options.onEvent);
  }, [options == null ? void 0 : options.onEvent]);
  return useContext8(AppContext);
};
var useApp_default = useApp;

// src/~react-hooks/MetaCollection/useMetaCollection.ts
var useMetaCollection = (_a) => {
  var _b = _a, {
    slug: slug3,
    page,
    take,
    orderBy,
    includeItemLongSummaries
  } = _b, opts = __objRest(_b, [
    "slug",
    "page",
    "take",
    "orderBy",
    "includeItemLongSummaries"
  ]);
  var _b2;
  const { locale } = useApp_default();
  const variables = sanitizeObject({
    slug: slug3,
    locale,
    page,
    take,
    orderBy,
    includeItemLongSummaries
  });
  const _a2 = useQuery_default(GQL_GET_META_COLLECTION_default, __spreadValues({
    variables
  }, opts)), { data, loading, error, networkStatus } = _a2, other = __objRest(_a2, ["data", "loading", "error", "networkStatus"]);
  return __spreadProps(__spreadValues({}, other), {
    loading,
    error,
    networkStatus,
    refetching: networkStatus === 4,
    response: (_b2 = data == null ? void 0 : data.response) != null ? _b2 : null
  });
};
var useMetaCollection_default = useMetaCollection;

// src/~react-hooks/MetaCollection/useMetaCollectionForMedia.ts
var useMetaCollectionForMedia = (_a) => {
  var _b = _a, {
    slug: slug3,
    page,
    take,
    orderBy
  } = _b, opts = __objRest(_b, [
    "slug",
    "page",
    "take",
    "orderBy"
  ]);
  var _b2;
  const { locale } = useApp_default();
  const variables = sanitizeObject({
    slug: slug3,
    locale,
    page,
    take,
    orderBy
  });
  const _a2 = useQuery_default(GQL_GET_META_COLLECTION_FOR_META_default, __spreadValues({
    variables
  }, opts)), { data, loading, error, networkStatus } = _a2, other = __objRest(_a2, ["data", "loading", "error", "networkStatus"]);
  return __spreadProps(__spreadValues({}, other), {
    loading,
    error,
    networkStatus,
    refetching: networkStatus === 4,
    response: (_b2 = data == null ? void 0 : data.response) != null ? _b2 : null
  });
};
var useMetaCollectionForMedia_default = useMetaCollectionForMedia;

// src/~react-hooks/useAccount/useAccount.ts
var useAccount = (_a = {}) => {
  var opts = __objRest(_a, []);
  var _b;
  const { isLoggedIn } = useSession_default();
  const _a2 = useQuery_default(GQL_GET_ACCOUNT_INFORMATION_default, __spreadValues({
    skip: !isLoggedIn,
    notifyOnNetworkStatusChange: true
  }, opts)), { data, networkStatus, refetch } = _a2, other = __objRest(_a2, ["data", "networkStatus", "refetch"]);
  const accountData = (_b = data == null ? void 0 : data.response) != null ? _b : null;
  return __spreadProps(__spreadValues({}, other), {
    refetch,
    response: accountData,
    refetching: networkStatus === 4,
    networkStatus,
    isAnonymous: (accountData == null ? void 0 : accountData.id) ? false : null
    // Deprecated
  });
};
var useAccount_default = useAccount;

// src/~react-hooks/useAccountExport/useAccountExport.ts
import { useMutation as useMutation2 } from "@apollo/client";
import { useCallback as useCallback5 } from "react";
var useExportAccount = (_a = {}) => {
  var opts = __objRest(_a, []);
  const [exportAccountMutation, other] = useMutation2(GQL_EXPORT_ACCOUNT_default, opts);
  const exportAccount = useCallback5(
    (input) => {
      return exportAccountMutation({
        variables: {
          input
        }
      });
    },
    [exportAccountMutation]
  );
  return [exportAccount, other];
};
var useAccountExport_default = useExportAccount;

// src/~react-hooks/useAccountOrder/useAccountOrder.ts
var useAccountOrder = ({ take } = {}) => {
  var _b;
  const { isLoggedIn } = useSession_default();
  const { locale } = useApp_default();
  const _a = useQuery_default(GQL_GET_ACCOUNT_ORDERS_default, {
    variables: { locale, take },
    skip: !isLoggedIn
  }), { data, loading } = _a, other = __objRest(_a, ["data", "loading"]);
  return __spreadProps(__spreadValues({}, other), {
    loading,
    response: (_b = data == null ? void 0 : data.response) != null ? _b : []
  });
};
var useAccountOrder_default = useAccountOrder;

// src/~react-hooks/useAppInfo/useAppInfo.ts
var useAppInfo = (variables) => {
  const _a = useQuery_default(
    GQL_GET_APP_INFO_default,
    { variables }
  ), { data } = _a, rest = __objRest(_a, ["data"]);
  return __spreadValues({ response: data == null ? void 0 : data.response }, rest);
};
var findAppInfo = (type2) => (apps) => {
  return apps == null ? void 0 : apps.find((app) => app.__typename === type2);
};
var toDeviceType = (app) => {
  switch (app) {
    case "SFAnytimeAndroidApp":
    case "BlockbusterAndroidApp":
      return "Android" /* Android */;
    case "SFAnytimeIosApp":
    case "BlockbusterIosApp":
      return "iOS" /* iOS */;
    case "SFAnytimeAndroidTvApp":
    case "BlockbusterAndroidTvApp":
      return "AndroidTv" /* AndroidTv */;
    case "SFAnytimeTvosApp":
    case "BlockbusterTvosApp":
      return "tvOS" /* tvOS */;
    case "BlockbusterWebApp":
    case "SFAnytimeComWebApp":
      return "Web" /* Web */;
    case "SFAnytimeSmartTvLGApp":
    case "SFAnytimeSmartTvSamsungApp":
    case "SFAnytimeSmartTvVewdApp":
    case "SFAnytimeSmartTvPhilipsApp":
    case "BlockbusterSmartTvLGApp":
    case "BlockbusterSmartTvSamsungApp":
    case "BlockbusterSmartTvVewdApp":
    case "BlockbusterSmartTvPhilipsApp":
      return "SmartTv" /* SmartTv */;
    case "UnknownApp":
      return "UnknownType" /* UnknownType */;
    default:
      assertUnreachable(app);
      return null;
  }
};

// src/~react-hooks/useAskToUpdate/useAskToUpdate.ts
import { useCallback as useCallback6, useRef as useRef2 } from "react";
var import_semver_lite = __toESM(require_src());
var ASK_TO_UPDATE_STORAGE_KEY = "useAskToUpdate/LastAskDate";
var useAskToUpdate = (params) => {
  const { installedVersion, onAskToUpdate, options = {} } = params;
  const {
    minimumHoursBetweenAsks = 24,
    releaseConsideredBrandNewInHours = 48
  } = options;
  const { storage: storage2 } = useApp_default();
  const { response, loading } = useAppInfo({
    deviceType: [toDeviceType(params.app)]
  });
  const app = findAppInfo(params.app)(response);
  const latestVersion = app == null ? void 0 : app.latestVersion;
  const latestVersionReleaseDate = app == null ? void 0 : app.latestVersionReleaseDate;
  const checkInProgress = useRef2(false);
  const checkForUpdates = useCallback6(() => __async(void 0, null, function* () {
    if (!latestVersionReleaseDate || !latestVersion)
      return null;
    const hoursSinceRelease = ((/* @__PURE__ */ new Date()).getTime() - new Date(latestVersionReleaseDate).getTime()) / 36e5;
    const isBrandNewRelease = hoursSinceRelease < releaseConsideredBrandNewInHours;
    const newVersionExist = import_semver_lite.default.gt(latestVersion, installedVersion);
    return { newVersionExist, isBrandNewRelease };
  }), [
    installedVersion,
    latestVersion,
    latestVersionReleaseDate,
    releaseConsideredBrandNewInHours
  ]);
  const shouldAskToUpdate = useCallback6(() => __async(void 0, null, function* () {
    const data = yield checkForUpdates();
    if (!data)
      return false;
    const { newVersionExist, isBrandNewRelease } = data;
    if (!newVersionExist)
      return false;
    if (isBrandNewRelease)
      return false;
    const lastAsked = yield storage2.get(ASK_TO_UPDATE_STORAGE_KEY);
    if (!lastAsked)
      return true;
    if (hasHoursPassed(minimumHoursBetweenAsks)(lastAsked.date)) {
      return true;
    }
    return false;
  }), [checkForUpdates, minimumHoursBetweenAsks, storage2]);
  const askToUpdateIfNecessary = useCallback6(() => __async(void 0, null, function* () {
    if (checkInProgress.current)
      return false;
    checkInProgress.current = true;
    const shouldAsk = yield shouldAskToUpdate();
    if (shouldAsk && app) {
      yield storage2.set(ASK_TO_UPDATE_STORAGE_KEY, {
        date: (/* @__PURE__ */ new Date()).toISOString()
      });
      onAskToUpdate(app);
    }
    checkInProgress.current = false;
  }), [app, onAskToUpdate, shouldAskToUpdate, storage2]);
  return {
    askToUpdateIfNecessary,
    loading
  };
};

// src/~react-hooks/useBookmark/useBookmark.ts
import { gql as gql83 } from "@apollo/client";
import { useCallback as useCallback7, useEffect as useEffect11, useState as useState5 } from "react";
var GET_BOOKMARK = gql83`
  query GetBookmark($id: String!) {
    bookmark(id: $id) {
      ...BookmarkParts
    }
  }
  ${BOOKMARK_FRAGMENT_default}
`;
var createBookmarkId = (params) => createGloballyUniqueIdResolver("Bookmark", (e) => {
  var _a;
  return [(_a = e == null ? void 0 : e.slug) != null ? _a : ""];
})(
  params,
  params
);
var useBookmark = ({ slug: slug3 }) => {
  const cache = useApolloCache();
  const read = useCallback7(() => readBookmark({ cache, slug: slug3 }), [cache, slug3]);
  const prevSlug = usePrevious(slug3);
  useEffect11(() => {
    if (prevSlug === slug3)
      return;
    setResponse(read());
  }, [read, prevSlug, slug3]);
  const [response, setResponse] = useState5(read());
  useEffect11(() => {
    return cache.watch({
      query: GET_BOOKMARK,
      variables: { id: createBookmarkId({ slug: slug3 }) },
      optimistic: true,
      callback: (data) => {
        var _a;
        setResponse((_a = data.result) == null ? void 0 : _a.bookmark);
      }
    });
  }, [cache, slug3]);
  return {
    bookmark: response != null ? response : null,
    initializing: false
  };
};
var readBookmark = ({
  cache,
  slug: slug3
}) => {
  var _a, _b;
  try {
    return (_b = (_a = cache.read({
      query: GET_BOOKMARK,
      variables: { id: createBookmarkId({ slug: slug3 }) },
      optimistic: true
    })) == null ? void 0 : _a.bookmark) != null ? _b : null;
  } catch (e) {
    return null;
  }
};

// src/~react-hooks/useBookmarkActions/useBookmarkActions.ts
import { useMutation as useMutation3 } from "@apollo/client";
import { useCallback as useCallback10, useEffect as useEffect12 } from "react";

// src/~react-hooks/useBookmarks/useBookmarks.ts
import { useMemo as useMemo9 } from "react";
var useBookmarks = (_a = {}) => {
  var opts = __objRest(_a, []);
  const { isLoggedIn } = useSession_default();
  const { locale } = useApp_default();
  const _a2 = useQuery_default(GQL_GET_BOOKMARKS_default, __spreadValues({
    variables: { locale },
    errorPolicy: opts.errorPolicy || "ignore",
    skip: !isLoggedIn
  }, opts)), { data, loading, error, networkStatus } = _a2, other = __objRest(_a2, ["data", "loading", "error", "networkStatus"]);
  const response = useMemo9(
    () => getFilteredResponse2(data == null ? void 0 : data.response),
    [data == null ? void 0 : data.response]
  );
  return __spreadProps(__spreadValues({}, other), {
    response,
    loading,
    error,
    networkStatus,
    refetching: networkStatus === 4
  });
};
var getFilteredResponse2 = (response) => {
  var _a;
  return (_a = response == null ? void 0 : response.filter((r) => r !== null).filter((r) => r.item)) != null ? _a : null;
};
var useBookmarks_default = useBookmarks;

// src/~react-hooks/useIsOffline/useIsOffline.ts
import { useContext as useContext9 } from "react";
var useIsOffline_default = () => useContext9(OfflineContext);

// src/~react-hooks/useMedia/useMedia.ts
var useMedia = (props) => {
  const { locale } = useApp_default();
  const _a = props, { slug: slug3 } = _a, opts = __objRest(_a, ["slug"]);
  const hookOptions = useHookOptions();
  const _b = useQuery_default(GQL_GET_MEDIA_default, __spreadProps(__spreadValues({
    variables: getVariables2(__spreadProps(__spreadValues({}, props), {
      hookOptions,
      locale,
      slug: slug3 != null ? slug3 : ""
    }))
  }, opts), {
    skip: slug3 == null ? true : opts.skip
  })), { data, loading, error, networkStatus } = _b, other = __objRest(_b, ["data", "loading", "error", "networkStatus"]);
  return __spreadProps(__spreadValues({}, other), {
    response: data == null ? void 0 : data.response,
    data,
    loading,
    refetching: networkStatus === 4,
    networkStatus,
    error
  });
};
var useMedia_default = useMedia;

// src/~react-hooks/useMedia/useMediaSuspense.ts
import { useSuspenseQuery } from "@apollo/client";
var useMediaSuspense = (props) => {
  const { locale } = useApp_default();
  const _a = props, { slug: slug3 } = _a, opts = __objRest(_a, ["slug"]);
  const hookOptions = useHookOptions();
  const _b = useSuspenseQuery(GQL_GET_MEDIA_default, __spreadProps(__spreadValues({
    variables: getVariables2(__spreadProps(__spreadValues({}, props), {
      hookOptions,
      locale,
      slug: slug3 != null ? slug3 : ""
    }))
  }, opts), {
    skip: slug3 == null ? true : opts.skip,
    returnPartialData: true,
    fetchPolicy: "cache-first"
  })), { data, error, networkStatus } = _b, other = __objRest(_b, ["data", "error", "networkStatus"]);
  return __spreadProps(__spreadValues({}, other), {
    response: data == null ? void 0 : data.response,
    data,
    refetching: networkStatus === 4,
    networkStatus,
    error
  });
};

// src/~react-hooks/useBookmarkActions/helpers/bookmarkCache.ts
var getBookmarkCache = ({
  cache,
  locale
}) => {
  const read = () => {
    var _a, _b, _c;
    return (_c = (_b = (_a = cache.readQuery({
      query: GQL_GET_BOOKMARKS_default,
      variables: {
        locale
      }
    })) == null ? void 0 : _a.response) == null ? void 0 : _b.filter(exists)) != null ? _c : [];
  };
  const write = (data) => {
    const newBookmarks = Array.isArray(data) ? data : [data];
    const cachedBookmarks = read();
    const nonUpdatedBookmarks = cachedBookmarks.filter(
      (b) => !newBookmarks.some((newBookmark) => newBookmark.slug === b.slug)
    );
    const newResponse = [
      ...nonUpdatedBookmarks,
      ...newBookmarks
    ];
    cache.writeQuery({
      query: GQL_GET_BOOKMARKS_default,
      variables: {
        locale
      },
      data: __spreadProps(__spreadValues({}, cachedBookmarks), {
        response: newResponse
      })
    });
  };
  const exist = ({ slug: slug3 }) => read().some((b) => b.slug === slug3);
  const get6 = ({
    slug: slug3
  }) => read().find((b) => b.slug === slug3);
  const addIfNew = (bookmark) => {
    if (exist(bookmark))
      return;
    write(bookmark);
  };
  return {
    write,
    get: get6,
    addIfNew
  };
};

// src/~react-hooks/useBookmarkActions/helpers/makeAddNewBookmarkToListCacheUpdater.ts
var makeAddNewBookmarkToListCacheUpdater = (locale) => (cache, { data }) => {
  const newBookmark = data == null ? void 0 : data.setBookmark;
  if (!newBookmark)
    return;
  const bookmarkCache = getBookmarkCache({ cache, locale });
  bookmarkCache.addIfNew(newBookmark);
};

// src/~react-hooks/useBookmarkActions/helpers/useUnsyncedBookmarks.ts
import { useCallback as useCallback8 } from "react";
var useUnsyncedBookmarks = () => {
  const { storage: storage2 } = useApp_default();
  const addUnsyncedBookmark = useCallback8(
    (bookmark) => __async(void 0, null, function* () {
      var _a, _b, _c;
      const bookmarks = (_a = yield storage2.get("shapeshifter-core/BOOKMARKS" /* UNSYNCED_BOOKMARKS */)) != null ? _a : {};
      const previousFails = (_c = (_b = bookmarks[bookmark.slug]) == null ? void 0 : _b.failedUpdates) != null ? _c : 0;
      yield storage2.set("shapeshifter-core/BOOKMARKS" /* UNSYNCED_BOOKMARKS */, __spreadProps(__spreadValues({}, bookmarks), {
        [bookmark.slug]: __spreadProps(__spreadValues({}, bookmark), {
          failedUpdates: previousFails
        })
      }));
    }),
    [storage2]
  );
  const replaceUnsyncedBookmarks = useCallback8(
    (bookmarks) => storage2.set(
      "shapeshifter-core/BOOKMARKS" /* UNSYNCED_BOOKMARKS */,
      toObject(
        bookmarks.map((b) => __spreadProps(__spreadValues({}, b), { failedUpdates: b.failedUpdates + 1 })),
        "slug"
      )
    ),
    [storage2]
  );
  const getUnsyncedBookmarks = useCallback8(() => __async(void 0, null, function* () {
    const bookmarks = yield storage2.get(
      "shapeshifter-core/BOOKMARKS" /* UNSYNCED_BOOKMARKS */
    );
    return bookmarks ? toArray(bookmarks) : null;
  }), [storage2]);
  return {
    getUnsyncedBookmarks,
    addUnsyncedBookmark,
    replaceUnsyncedBookmarks
  };
};

// src/~react-hooks/useBookmarkActions/helpers/useWriteBookmarkToCache.ts
import { useApolloClient as useApolloClient4 } from "@apollo/client";
import base642 from "base-64";
import { useCallback as useCallback9 } from "react";
var COMPLETED_THRESHOLD_PERCENT = 90;
var STARTED_THRESHOLD_PERCENT = 5;
var makeBookmarkId = ({ slug: slug3 }) => base642.encode(`Bookmark:${slug3}`);
var createBookmark = ({
  item,
  bookmark: { seconds, slug: slug3, watched },
  duration
}) => {
  const time = seconds ? seconds * 1e3 : null;
  const percentCompleted = (() => {
    if (watched === true)
      return 100;
    if (watched === false)
      return 0;
    if (!duration || !time)
      return null;
    const part = time / duration * 100;
    const capped = Math.max(0, Math.min(part, 100));
    return capped;
  })();
  const started = percentCompleted != null ? percentCompleted >= STARTED_THRESHOLD_PERCENT : false;
  const completed = percentCompleted != null ? percentCompleted >= COMPLETED_THRESHOLD_PERCENT : false;
  const id = makeBookmarkId({ slug: slug3 });
  const newB = {
    slug: slug3,
    time,
    duration,
    id,
    item,
    percentage: percentCompleted,
    procentage: percentCompleted,
    started,
    completed,
    updatedAt: (/* @__PURE__ */ new Date()).toISOString(),
    __typename: "Bookmark"
  };
  return newB;
};
var useAddOrUpdateBookmarkInCache = () => {
  const client = useApolloClient4();
  const { locale } = useApp_default();
  const { fetch: fetchMedia } = useMedia_default({ slug: null });
  const createNew = useCallback9(
    (bookmark) => __async(void 0, null, function* () {
      const media = (yield fetchMedia({ variables: { slug: bookmark.slug, locale } })).response;
      if ((media == null ? void 0 : media.__typename) !== "Episode" && (media == null ? void 0 : media.__typename) !== "Movie" || media.duration == null) {
        throw new Error("Could not create bookmark");
      }
      const duration = media.duration * 60 * 1e3;
      return createBookmark({
        item: media,
        bookmark,
        duration
      });
    }),
    [fetchMedia, locale]
  );
  const updateOld = useCallback9(
    (_0) => __async(void 0, [_0], function* ({
      newBookmark,
      oldBookmark
    }) {
      const { item, duration } = oldBookmark;
      if (!item || !duration) {
        return createNew(newBookmark);
      }
      return createBookmark({
        item,
        duration,
        bookmark: newBookmark
      });
    }),
    [createNew]
  );
  const addOrUpdateBookmarkInCache = useCallback9(
    (bookmarks) => __async(void 0, null, function* () {
      const bookmarkCache = getBookmarkCache({
        cache: client.cache,
        locale
      });
      const newAndUpdatedBookmarks = yield Promise.all(
        bookmarks.map((newBookmark) => __async(void 0, null, function* () {
          const oldBookmark = bookmarkCache.get({ slug: newBookmark.slug });
          if (oldBookmark) {
            return updateOld({ oldBookmark, newBookmark });
          } else {
            return createNew(newBookmark);
          }
        }))
      );
      bookmarkCache.write(newAndUpdatedBookmarks);
    }),
    [client, createNew, locale, updateOld]
  );
  return { addOrUpdateBookmarkInCache };
};

// src/~react-hooks/useBookmarkActions/useBookmarkActions.ts
var MAX_BOOKMARKS_TO_SYNC = 20;
var MAX_SYNC_ATTEMPTS_PER_BOOKMARK = 5;
var allSettled = (promises) => Promise.all(
  promises.map(
    (promise) => promise.then((value) => ({ status: "fulfilled", value })).catch((reason) => ({ status: "rejected", reason }))
  )
);
var { emit: emit4, onEvent: onEvent5 } = createEventEmitter();
var useBookmarkActions = (options) => {
  var _a;
  const [updateBookmark] = useMutation3(GQL_UPDATE_BOOKMARK_default);
  const { refetch } = useBookmarks_default({ skip: true });
  const { offline } = useIsOffline_default();
  const { locale } = useApp_default();
  const accountId = (_a = useSession_default().auth) == null ? void 0 : _a.accountId;
  const { fetch: fetchMedia } = useMedia_default({ slug: null });
  const {
    getUnsyncedBookmarks,
    addUnsyncedBookmark,
    replaceUnsyncedBookmarks
  } = useUnsyncedBookmarks();
  const { addOrUpdateBookmarkInCache } = useAddOrUpdateBookmarkInCache();
  useEffect12(() => {
    if (options == null ? void 0 : options.onEvent)
      return onEvent5(options.onEvent);
  }, [options == null ? void 0 : options.onEvent]);
  const syncBookmarks = useCallback10(() => __async(void 0, null, function* () {
    const unsyncedBookmarks = yield getUnsyncedBookmarks();
    if (!unsyncedBookmarks || unsyncedBookmarks.length === 0) {
      return {
        successfulUpdates: 0,
        failedUpdates: 0,
        willResync: 0,
        ignoredBookmarks: 0
      };
    }
    const bookmarksToSync = unsyncedBookmarks.filter(
      (b) => b.accountId === accountId
    );
    const ignoredBookmarks = unsyncedBookmarks.length - bookmarksToSync.length;
    if (offline) {
      yield addOrUpdateBookmarkInCache(bookmarksToSync);
      return {
        successfulUpdates: 0,
        failedUpdates: 0,
        willResync: bookmarksToSync.length,
        ignoredBookmarks
      };
    }
    const syncResults = yield allSettled(
      bookmarksToSync.slice(0, MAX_BOOKMARKS_TO_SYNC).map((b) => {
        return updateBookmark({
          variables: { slug: b.slug, seconds: b.seconds, watched: b.watched },
          update: makeAddNewBookmarkToListCacheUpdater(locale)
        });
      })
    );
    const bookmarkSyncs = syncResults.map((result, index) => ({
      status: result.status,
      index,
      bookmark: bookmarksToSync[index]
    }));
    const failedBookmarks = bookmarkSyncs.filter(({ status }) => status === "rejected").map(({ bookmark }) => bookmark);
    const bookmarksToResync = failedBookmarks.filter(
      (b) => b.failedUpdates + 1 < MAX_SYNC_ATTEMPTS_PER_BOOKMARK
    );
    yield replaceUnsyncedBookmarks(bookmarksToResync);
    return {
      successfulUpdates: syncResults.length - failedBookmarks.length,
      failedUpdates: failedBookmarks.length,
      willResync: bookmarksToResync.length,
      ignoredBookmarks
    };
  }), [
    accountId,
    addOrUpdateBookmarkInCache,
    getUnsyncedBookmarks,
    locale,
    offline,
    replaceUnsyncedBookmarks,
    updateBookmark
  ]);
  const setBookmark2 = useCallback10(
    (bookmark) => __async(void 0, null, function* () {
      if (accountId == null)
        return;
      yield addUnsyncedBookmark(__spreadProps(__spreadValues({}, bookmark), { accountId }));
    }),
    [accountId, addUnsyncedBookmark]
  );
  const markAsWatched = useCallback10(
    (_0) => __async(void 0, [_0], function* ({ slug: slug3 }) {
      const media = (yield fetchMedia({ variables: { slug: slug3, locale } })).response;
      const duration = media && "duration" in media ? media.duration : null;
      if (!duration) {
        throw new Error(
          `markAsWatched error: Duration or media missing for ${slug3}`
        );
      }
      yield setBookmark2({
        slug: slug3,
        watched: true
      });
      yield syncBookmarks();
      emit4("markedAsWatched", { slug: slug3 });
    }),
    [fetchMedia, setBookmark2, syncBookmarks, locale]
  );
  const markAsNotWatched = useCallback10(
    (_0) => __async(void 0, [_0], function* ({ slug: slug3 }) {
      yield setBookmark2({
        slug: slug3,
        watched: false
      });
      yield syncBookmarks();
      emit4("markedAsNotWatched", { slug: slug3 });
    }),
    [setBookmark2, syncBookmarks]
  );
  return {
    syncBookmarks,
    setBookmark: setBookmark2,
    refetch,
    markAsWatched,
    markAsNotWatched
  };
};
var useBookmarkActions_default = useBookmarkActions;

// src/~react-hooks/useCastData/useCastData.ts
import { useCallback as useCallback13 } from "react";

// src/~react-hooks/useDevicePreferences/useDevicePreferences.ts
import { useCallback as useCallback11, useRef as useRef3 } from "react";
import { useAtomValue as useAtomValue2 } from "jotai";
var useDevicePreferences = () => {
  const { storage: storage2 } = useApp_default();
  const devicePreferencesStorage = useRef3(
    new DevicePreferencesStorage(storage2)
  );
  const { updateCache } = useUpdateDevicePreferences();
  const cache = useAtomValue2(devicePreferencesAtom);
  const setSubtitleLanguage = useCallback11(
    (value) => __async(void 0, null, function* () {
      updateCache("subtitleLanguage", value);
      devicePreferencesStorage.current.setSubtitleLanguagePreference(value);
    }),
    [updateCache]
  );
  const setAudioLanguage = useCallback11(
    (value) => __async(void 0, null, function* () {
      updateCache("audioLanguage", value);
      devicePreferencesStorage.current.setAudioLanguagePreference(value);
    }),
    [updateCache]
  );
  const setFullscreen = useCallback11(
    (value) => __async(void 0, null, function* () {
      updateCache("fullscreen", value);
      devicePreferencesStorage.current.setFullscreenPreference(value);
    }),
    [updateCache]
  );
  const setAllowCellularDownloads = useCallback11(
    (value) => __async(void 0, null, function* () {
      updateCache("allowCellularDownloads", value);
      devicePreferencesStorage.current.setAllowCellularDownloadsPreference(
        value
      );
    }),
    [updateCache]
  );
  return __spreadProps(__spreadValues({}, cache), {
    setSubtitleLanguage,
    setAudioLanguage,
    setFullscreen,
    setAllowCellularDownloads
  });
};

// src/~react-hooks/useL10n/useL10n.tsx
import { useCallback as useCallback12, useContext as useContext11 } from "react";
import { I18nContext as I18nContext2 } from "react-i18next";

// src/~react-hooks/useL10n/ReactiveText.tsx
import { useContext as useContext10, useEffect as useEffect13, useState as useState6 } from "react";
import { I18nContext } from "react-i18next";
import { Fragment as Fragment3, jsx as jsx8 } from "react/jsx-runtime";
var ReactiveText = ({
  exists: exists2,
  getText
}) => {
  const { i18n } = useContext10(I18nContext);
  const [text, setText] = useState6(getText());
  useEffect13(() => {
    const onChange = () => {
      if (!exists2())
        return;
      setText(getText());
    };
    i18n.on("languageChanged", onChange);
    return () => i18n.off("languageChanged", onChange);
  }, [exists2, getText, i18n]);
  return /* @__PURE__ */ jsx8(Fragment3, { children: text });
};

// src/~react-hooks/useL10n/transforms.ts
import capitalize from "lodash/capitalize";
var transforms = {
  uppercase: (t) => t.toUpperCase(),
  lowercase: (t) => t.toLowerCase(),
  capitalize: (t) => capitalize(t),
  trim: (t) => t.trim()
};
var noTransform = (text) => text;
var getTransform = ({
  transform,
  translated
}) => {
  const transformFn = transform ? transforms[transform] : noTransform;
  return transformFn(translated);
};

// src/~react-hooks/useL10n/useL10n.tsx
import { jsx as jsx9 } from "react/jsx-runtime";
var useL10n = () => {
  const { i18n } = useContext11(I18nContext2);
  const getString = useCallback12(
    (key3, options) => {
      const _a = options != null ? options : {}, { transform } = _a, restOptions = __objRest(_a, ["transform"]);
      const hasTranslationOptions = Object.keys(restOptions).length > 0;
      const translated = hasTranslationOptions ? i18n.t(key3, restOptions) : i18n.t(key3);
      return getTransform({ transform, translated });
    },
    [i18n]
  );
  const t = useCallback12(
    (key3, options) => {
      const getText = () => getString(key3, options);
      const exists2 = () => i18n.exists(key3);
      if (!exists2())
        return /* @__PURE__ */ jsx9(ReactiveText, { getText, exists: exists2 });
      return getText();
    },
    [getString, i18n]
  );
  return {
    /**
     * Use getString to get the current translation of the key.
     * Use it when you must have a string translation and you
     * are sure that the translation exists.
     **/
    getString,
    /**
     * Use t() to get the current translation or a reactive JSX
     * element if the translation is currently missing.*
     **/
    t
  };
};
var useL10n_default = useL10n;

// src/~react-hooks/useCastData/useCastData.ts
var useCastData = () => {
  const { createAdditionalToken, isLoggedIn } = useSession_default();
  const { locale, device } = useApp_default();
  const { getString } = useL10n_default();
  const { subtitleLanguage, audioLanguage } = useDevicePreferences();
  const { fetch: fetchMedia } = useMedia_default({ slug: null });
  const getCastData = useCallback13(
    (_0) => __async(void 0, [_0], function* ({
      isTrailer,
      slug: slug3
    }) {
      var _a;
      const res = yield fetchMedia({
        variables: {
          slug: slug3,
          locale
        }
      });
      const media = res.response;
      if (!media) {
        throw new Error("Media is null");
      }
      if (!isPlayableMedia(media)) {
        throw new Error(`Cannot cast a ${media.__typename}`);
      }
      const additionalToken2 = yield (() => __async(void 0, null, function* () {
        var _a2, _b, _c;
        if (!isLoggedIn) {
          if (isTrailer)
            return null;
          throw new Error("Cannot cast feature when not logged in");
        }
        return (_c = (_b = (_a2 = yield createAdditionalToken()) == null ? void 0 : _a2.data) == null ? void 0 : _b.response) != null ? _c : null;
      }))();
      const subtitle = isTrailer ? getString("glossary.trailer") : (_a = media.display.caption) != null ? _a : "";
      const canCast = (() => {
        if (isTrailer && !hasTrailer(media))
          return false;
        return true;
      })();
      const customData = {
        platform: device.type,
        duration: media.duration ? media.duration * 60 * 1e3 : null,
        slug: slug3,
        userToken: additionalToken2,
        textLanguage: subtitleLanguage,
        audioLanguage: audioLanguage || locale,
        isTrailer,
        locale
      };
      return {
        canCast,
        mediaUrl: "_",
        // url is set on receiver but needs to be a string to prevent crash when initializing
        title: media.display.title,
        subtitle,
        imageUrl: media.displayableAsset.__typename === "DisplayableInCollectionWithCover" ? media.displayableAsset.cover : void 0,
        customData
      };
    }),
    [
      audioLanguage,
      createAdditionalToken,
      device.type,
      fetchMedia,
      isLoggedIn,
      locale,
      subtitleLanguage,
      getString
    ]
  );
  return { getCastData };
};

// src/~react-hooks/useCheckout/useCheckout.tsx
import { useSubscription as useSubscription3 } from "@apollo/client";
import {
  createContext as createContext8,
  useCallback as useCallback23,
  useContext as useContext12,
  useEffect as useEffect17
} from "react";

// src/~react-hooks/useCheckout/utils/useBack.tsx
import { useMemo as useMemo10 } from "react";

// src/~react-hooks/useCheckout/types.ts
var Step = /* @__PURE__ */ ((Step2) => {
  Step2["OptionsStep"] = "OptionsStep";
  Step2["ProcessingPayment"] = "ProcessingPayment";
  Step2["Receipt"] = "Receipt";
  Step2["Error"] = "Error";
  Step2["Loading"] = "Loading";
  return Step2;
})(Step || {});

// src/~react-hooks/useCheckout/utils/useBack.tsx
var useBack = ({
  state,
  setState
}) => {
  var _a;
  const { currentStep } = state;
  const back = useMemo10(() => {
    var _a2;
    switch (currentStep) {
      case "Error" /* Error */:
        return {
          showBackButton: true,
          onBack: () => setState({ confirmedOptions: false, error: void 0 })
        };
      case "ProcessingPayment" /* ProcessingPayment */: {
        if (((_a2 = state.selectedPaymentMethod) == null ? void 0 : _a2.method) === "inApp") {
          return { showBackButton: false, onBack: void 0 };
        }
        return {
          showBackButton: true,
          onBack: () => setState({ confirmedOptions: false })
        };
      }
      default:
        return { showBackButton: false, onBack: void 0 };
    }
  }, [currentStep, setState, (_a = state.selectedPaymentMethod) == null ? void 0 : _a.method]);
  return back;
};

// src/~react-hooks/useCheckout/utils/useCheckoutError.tsx
import { useMemo as useMemo11 } from "react";

// src/~react-hooks/useCheckout/utils/utils.ts
var isPaymentInProgressStatus = (status) => {
  switch (status) {
    case "abandoned" /* abandoned */:
    case "initialized" /* initialized */:
    case "error" /* error */:
    case "paid" /* paid */:
    case "rejected" /* rejected */:
    case "refunded" /* refunded */:
      return false;
    default:
      return true;
  }
};
var isFailedStatus = (status) => {
  switch (status) {
    case "abandoned" /* abandoned */:
    case "error" /* error */:
    case "rejected" /* rejected */:
    case "refunded" /* refunded */:
      return true;
    default:
      return false;
  }
};
var toProductType = (__typename2) => {
  if (!__typename2)
    return void 0;
  return {
    Episode: "episode" /* episode */,
    Movie: "movie" /* movie */,
    Season: "season" /* season */,
    Series: "series" /* series */,
    MetaCollectionBundle: "bundle" /* bundle */,
    Ticket: "ticket" /* ticket */
  }[__typename2];
};
var getTrackingPayload = (transaction) => {
  var _a, _b, _c, _d;
  if (!transaction)
    return null;
  return {
    purchaseId: transaction.id,
    originalTitle: transaction.item.originalTitle,
    slug: transaction.item.slug,
    type: transaction.item.__typename,
    audioLanguage: (_a = transaction.selectedAudioLanguage) == null ? void 0 : _a.language,
    purchaseMethod: transaction.selectedPaymentMethod.method,
    purchaseType: transaction.selectedPurchaseType.type,
    price: (_b = transaction.receipt) == null ? void 0 : _b.paidAmount,
    discount: (_c = transaction.receipt) == null ? void 0 : _c.discountAmount,
    currency: (_d = transaction.receipt) == null ? void 0 : _d.currency
  };
};

// src/~react-hooks/useCheckout/utils/useCheckoutError.tsx
var useCheckoutError = ({
  reducerState,
  transaction,
  queryErrorCode
}) => {
  var _a, _b, _c, _d;
  const { t } = useL10n_default();
  const { device } = useApp_default();
  return useMemo11(() => {
    var _a2, _b2, _c2, _d2, _e, _f, _g;
    const error = reducerState.error;
    const transactionError = isFailedStatus(transaction == null ? void 0 : transaction.status);
    if (!error && !transactionError) {
      return { errorTitle: null, errorText: null };
    }
    const mutationErrorCode = error && "graphQLErrors" in error && ((_c2 = (_b2 = (_a2 = error == null ? void 0 : error.graphQLErrors[0]) == null ? void 0 : _a2.extensions) == null ? void 0 : _b2.response) == null ? void 0 : _c2.status);
    const acquirerErrorCode = (_d2 = transaction == null ? void 0 : transaction.acquirerResponse) == null ? void 0 : _d2.code;
    const refusalErrorCode = (_g = (_f = (_e = transaction == null ? void 0 : transaction.payment) == null ? void 0 : _e.adyen) == null ? void 0 : _f.paymentsResponse) == null ? void 0 : _g.refusalReasonCode;
    let scope = "checkout";
    let code = queryErrorCode != null ? queryErrorCode : "500";
    if (mutationErrorCode) {
      code = mutationErrorCode;
      scope = "checkout";
    }
    if (acquirerErrorCode) {
      code = acquirerErrorCode != null ? acquirerErrorCode : "500";
      scope = "adyen";
    }
    if (refusalErrorCode) {
      code = refusalErrorCode != null ? refusalErrorCode : "500";
      scope = "adyen";
    }
    const iapErrorCode = error && "errorType" in error && error.errorType === "inAppPurchase" && error.payload.errorCode;
    if (iapErrorCode) {
      scope = `iap-${device.type.toLocaleLowerCase()}`;
      code = iapErrorCode != null ? iapErrorCode : "500";
    }
    const titleKey = buildTitleLiteral({ code, scope });
    const textKey = buildTextLiteral({ code, scope });
    const errorTitle = t(titleKey != null ? titleKey : "An error has occured");
    const errorText = t(textKey != null ? textKey : buildFallbackValue({ code, scope }));
    return { errorTitle, errorText };
  }, [
    reducerState.error,
    transaction == null ? void 0 : transaction.status,
    (_a = transaction == null ? void 0 : transaction.acquirerResponse) == null ? void 0 : _a.code,
    (_d = (_c = (_b = transaction == null ? void 0 : transaction.payment) == null ? void 0 : _b.adyen) == null ? void 0 : _c.paymentsResponse) == null ? void 0 : _d.refusalReasonCode,
    queryErrorCode,
    t,
    device.type
  ]);
};

// src/~react-hooks/useCheckout/utils/useCheckoutEvents.ts
import { useCallback as useCallback14, useEffect as useEffect14, useRef as useRef4 } from "react";
var useCheckoutEvents = ({ state }) => {
  var _a, _b, _c, _d, _e, _f;
  const listeners = useRef4([]);
  const { transactionId, currentStep, trackingPayload, status, voucherCode } = state;
  const addListener = useCallback14(
    (name, onEvent8) => {
      const listener = { name, onEvent: onEvent8 };
      listeners.current.push(listener);
      const unsubscribe = () => {
        listeners.current = listeners.current.filter((l) => l !== listener);
      };
      return unsubscribe;
    },
    []
  );
  const emit7 = useCallback14(
    (name, payload) => {
      listeners.current.filter((l) => l.name === name).forEach((l) => l.onEvent(__spreadValues({ state }, payload)));
    },
    [state]
  );
  const previousPurchaseType = usePrevious((_a = state.selectedPurchaseType) == null ? void 0 : _a.type);
  useEffect14(() => {
    var _a2;
    if (!((_a2 = state.selectedPurchaseType) == null ? void 0 : _a2.type))
      return;
    if (state.selectedPurchaseType.type === previousPurchaseType)
      return;
    emit7("purchaseTypeChanged", {
      previousPurchaseType,
      purchaseType: state.selectedPurchaseType.type
    });
  }, [emit7, previousPurchaseType, state.selectedPurchaseType]);
  const previousPaymentMethod = usePrevious(
    (_b = state.selectedPaymentMethod) == null ? void 0 : _b.method
  );
  useEffect14(() => {
    var _a2;
    if (!((_a2 = state.selectedPaymentMethod) == null ? void 0 : _a2.method))
      return;
    if (state.selectedPaymentMethod.method === previousPaymentMethod)
      return;
    emit7("paymentMethodChanged", {
      previousPaymentMethod,
      paymentMethod: state.selectedPaymentMethod.method
    });
  }, [emit7, previousPaymentMethod, state.selectedPaymentMethod]);
  useEffect14(() => {
    var _a2, _b2;
    if (!((_a2 = state.selectedPaymentMethod) == null ? void 0 : _a2.method))
      return;
    if (!((_b2 = state.selectedPurchaseType) == null ? void 0 : _b2.type))
      return;
    if (state.selectedPaymentMethod.method === previousPaymentMethod && state.selectedPurchaseType.type === previousPurchaseType) {
      return;
    }
    emit7("userOptionsChanged", {});
  }, [
    emit7,
    previousPaymentMethod,
    previousPurchaseType,
    (_c = state.selectedPaymentMethod) == null ? void 0 : _c.method,
    (_d = state.selectedPurchaseType) == null ? void 0 : _d.type
  ]);
  const lastTransactionId = usePrevious((_e = state.transaction) == null ? void 0 : _e.id);
  useEffect14(() => {
    var _a2;
    if (((_a2 = state.transaction) == null ? void 0 : _a2.id) && state.transaction.id !== lastTransactionId) {
      emit7("transactionIdChanged", {});
    }
  }, [emit7, lastTransactionId, (_f = state.transaction) == null ? void 0 : _f.id]);
  const previousStep = usePrevious(state.currentStep);
  useEffect14(() => {
    if (!currentStep)
      return;
    if (!previousStep)
      return;
    if (currentStep === previousStep)
      return;
    emit7("stepChanged", { previousStep, currentStep });
  }, [emit7, lastTransactionId, currentStep, transactionId, previousStep]);
  const isPaid = status === "paid" /* paid */;
  const wasPaid = usePrevious(isPaid);
  const price = trackingPayload == null ? void 0 : trackingPayload.price;
  const hasEmittedTransactionPaidEvent = useRef4(false);
  const isReadyToEmitTransactionPaidEvent = useRef4(!wasPaid && isPaid);
  useEffect14(() => {
    if (!isReadyToEmitTransactionPaidEvent.current) {
      isReadyToEmitTransactionPaidEvent.current = !wasPaid && isPaid;
    }
  }, [wasPaid, isPaid]);
  const { storage: storage2 } = useApp_default();
  useEffect14(() => {
    (() => __async(void 0, null, function* () {
      if (!isReadyToEmitTransactionPaidEvent.current)
        return;
      if (!trackingPayload || price == null)
        return;
      const storageKey = `checkout_${transactionId}`;
      const paidBefore = !!(yield storage2.get(storageKey));
      if (paidBefore)
        return;
      yield storage2.set(storageKey, { paid: "true" });
      if (!hasEmittedTransactionPaidEvent.current) {
        hasEmittedTransactionPaidEvent.current = true;
        emit7("transactionPaidForFirstTime", {});
      }
    }))();
  }, [emit7, isPaid, storage2, trackingPayload, price, transactionId, wasPaid]);
  const previousStatus = usePrevious(status);
  useEffect14(() => {
    if (!status)
      return;
    if (!previousStatus)
      return;
    if (previousStatus === status)
      return;
    emit7("orderStatusChanged", { previousStatus, status });
  }, [emit7, previousStatus, status]);
  const previousVoucherCode = usePrevious(voucherCode);
  useEffect14(() => {
    if (!voucherCode)
      return;
    if (voucherCode === previousVoucherCode)
      return;
    emit7("validVoucherCodeChanged", { voucherCode });
  }, [emit7, previousVoucherCode, voucherCode]);
  return { addListener };
};

// src/~react-hooks/useCheckout/utils/useCheckoutReducer.ts
import { useReducer as useReducer2 } from "react";
var initialReducerState = {
  creatingTransaction: false,
  confirmingOptions: false,
  confirmedOptions: false,
  loading: false,
  error: void 0,
  transactionId: void 0,
  pollInterval: 7500,
  blockContinue: false,
  voucherLoading: false
};
var useCheckoutReducer = () => {
  return useReducer2(
    (prevState, nextState) => {
      return __spreadValues(__spreadValues({}, prevState), nextState);
    },
    initialReducerState
  );
};

// src/~react-hooks/useCheckout/utils/useConfirmOptions.ts
import { useCallback as useCallback15 } from "react";

// src/~react-hooks/useCheckout/utils/useTransactionMutations.ts
import { useMutation as useMutation4 } from "@apollo/client";
var useTransactionMutations = () => {
  const [updateTransaction] = useMutation4(GQL_UPDATE_TRANSACTION_default);
  const [createTransaction] = useMutation4(GQL_CREATE_TRANSACTION_default);
  return { updateTransaction, createTransaction };
};

// src/~react-hooks/useCheckout/utils/useConfirmOptions.ts
var useConfirmOptions = ({
  state,
  setState
}) => {
  const { selectedPaymentMethod, transactionId, returnUrl } = state;
  const { locale, device } = useApp_default();
  const { updateTransaction } = useTransactionMutations();
  return useCallback15(() => __async(void 0, null, function* () {
    try {
      setState({ confirmingOptions: true });
      yield updateTransaction({
        variables: {
          id: transactionId != null ? transactionId : "",
          locale,
          device: { type: device.type, manufacturer: device.manufacturer },
          input: {
            proceedToNext: true,
            returnUrl,
            paymentProcessor: selectedPaymentMethod == null ? void 0 : selectedPaymentMethod.processor,
            paymentMethod: selectedPaymentMethod == null ? void 0 : selectedPaymentMethod.method,
            paymentMethodId: selectedPaymentMethod == null ? void 0 : selectedPaymentMethod.methodId
          }
        }
      });
      setState({ confirmingOptions: false, confirmedOptions: true });
    } catch (e) {
      setState({ error: e, confirmingOptions: false });
    }
  }), [
    locale,
    device,
    selectedPaymentMethod == null ? void 0 : selectedPaymentMethod.methodId,
    selectedPaymentMethod == null ? void 0 : selectedPaymentMethod.method,
    selectedPaymentMethod == null ? void 0 : selectedPaymentMethod.processor,
    setState,
    returnUrl,
    transactionId,
    updateTransaction
  ]);
};

// src/~react-hooks/useCheckout/utils/useCurrentStep.tsx
var useCurrentStep = ({
  slug: slug3,
  state,
  status
}) => {
  const { canPlay } = useEntitlement_default({ slug: slug3 });
  if (state.creatingTransaction) {
    return "Loading" /* Loading */;
  }
  if (canPlay || status === "paid" /* paid */) {
    return "Receipt" /* Receipt */;
  }
  if (state.error) {
    if (isHasAccessError(state.error)) {
      return "Receipt" /* Receipt */;
    }
    return "Error" /* Error */;
  }
  if (!status)
    return "Loading" /* Loading */;
  if (!state.confirmedOptions || state.confirmingOptions) {
    return "OptionsStep" /* OptionsStep */;
  }
  if (isFailedStatus(status)) {
    return "Error" /* Error */;
  }
  if (isPaymentInProgressStatus(status)) {
    return "ProcessingPayment" /* ProcessingPayment */;
  }
  console.error("Unknown state", {
    state,
    status
  });
  return "Loading" /* Loading */;
};
var isHasAccessError = (error) => {
  var _a, _b, _c, _d;
  return !!error && "graphQLErrors" in error && ((_d = (_c = (_b = (_a = error == null ? void 0 : error.graphQLErrors) == null ? void 0 : _a[0]) == null ? void 0 : _b.extensions) == null ? void 0 : _c.response) == null ? void 0 : _d.status) == 409;
};

// src/~react-hooks/useCheckout/utils/useInAppPurchaseTransactionId.ts
import { useMemo as useMemo12 } from "react";
var useInAppPurchaseTransactionId = ({
  transaction
}) => {
  return useMemo12(() => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if ((_a = transaction == null ? void 0 : transaction.payment) == null ? void 0 : _a.apple) {
      const inAppTransactions = (_e = (_d = (_c = (_b = transaction == null ? void 0 : transaction.payment) == null ? void 0 : _b.apple) == null ? void 0 : _c.paymentData) == null ? void 0 : _d.receipt) == null ? void 0 : _e.in_app;
      if (!inAppTransactions)
        return void 0;
      if (inAppTransactions.length !== 1) {
        console.error(
          "Multiple in-app transactions in same receipt. When can this happen? How should we handle this?"
        );
      }
      return (_f = inAppTransactions[0]) == null ? void 0 : _f.transaction_id;
    }
    if ((_g = transaction == null ? void 0 : transaction.payment) == null ? void 0 : _g.google) {
      return (_h = transaction.payment.google.paymentData) == null ? void 0 : _h.purchaseToken;
    }
    return void 0;
  }, [transaction]);
};

// src/~react-hooks/useCheckout/utils/useInitTransaction.ts
import { useCallback as useCallback16, useEffect as useEffect15 } from "react";
var useInitTransaction = ({
  state,
  initialValues,
  setState
}) => {
  const { locale, device } = useApp_default();
  const { createTransaction } = useTransactionMutations();
  const { readyToCreateTransaction, slug: slug3 } = state;
  const createNew = useCallback16(() => __async(void 0, null, function* () {
    var _a;
    if (initialValues == null ? void 0 : initialValues.id) {
      setState(__spreadProps(__spreadValues({}, initialReducerState), { transactionId: initialValues.id }));
      return;
    }
    setState({ creatingTransaction: true });
    try {
      const { data } = yield createTransaction({
        variables: {
          locale,
          device: { type: device.type, manufacturer: device.manufacturer },
          input: {
            slug: slug3,
            voucherCode: initialValues == null ? void 0 : initialValues.voucherCode,
            purchaseType: initialValues == null ? void 0 : initialValues.purchaseType
          }
        }
      });
      setState(__spreadProps(__spreadValues({}, initialReducerState), {
        creatingTransaction: false,
        transactionId: (_a = data == null ? void 0 : data.response) == null ? void 0 : _a.id
      }));
    } catch (error) {
      setState({ error, creatingTransaction: false });
    }
  }), [
    createTransaction,
    device,
    initialValues == null ? void 0 : initialValues.id,
    initialValues == null ? void 0 : initialValues.purchaseType,
    initialValues == null ? void 0 : initialValues.voucherCode,
    locale,
    setState,
    slug3
  ]);
  useEffect15(() => {
    if (state.transactionId)
      return;
    if (!readyToCreateTransaction)
      return;
    createNew();
  }, [createNew, state.transactionId, readyToCreateTransaction]);
  const previousSlug = usePrevious(slug3);
  useEffect15(() => {
    const slugChanged = slug3 && previousSlug && slug3 !== previousSlug;
    if (slugChanged) {
      createNew();
    }
  }, [createNew, previousSlug, slug3]);
  const previousTransactionId = usePrevious(initialValues == null ? void 0 : initialValues.id);
  useEffect15(() => {
    if (previousTransactionId && (initialValues == null ? void 0 : initialValues.id) && previousTransactionId !== (initialValues == null ? void 0 : initialValues.id)) {
      createNew();
    }
  }, [createNew, initialValues == null ? void 0 : initialValues.id, previousTransactionId, setState]);
};

// src/~react-hooks/useCheckout/utils/useLanguageStrings.tsx
import { useMemo as useMemo13 } from "react";
var useLanguageStrings = ({ slug: slug3 }) => {
  const { purchasable } = usePurchasable({ slug: slug3 });
  const { t } = useL10n_default();
  const { locale } = useApp_default();
  return useMemo13(() => {
    var _a, _b;
    const sortLanguages = createLanguagePrioritySort({ locale });
    const subtitleLanguagesString = (_a = (() => {
      if (!purchasable)
        return;
      switch (purchasable.__typename) {
        case "Season":
        case "Ticket":
          return;
      }
      const { subtitles } = purchasable;
      if (!subtitles || subtitles.length === 0) {
        return t("checkout.subtitles.no_subtitles");
      }
      return sortLanguages(subtitles.map((s) => s.language)).join(", ");
    })()) != null ? _a : null;
    const audioLanguagesString = (_b = (() => {
      var _a2, _b2;
      if (!purchasable)
        return;
      if (purchasable.__typename === "Ticket")
        return;
      const { audio } = purchasable;
      return (audio == null ? void 0 : audio.tracks) && (audio == null ? void 0 : audio.tracks.length) > 0 ? sortLanguages(
        (_b2 = (_a2 = audio == null ? void 0 : audio.tracks) == null ? void 0 : _a2.map((track) => track.language)) != null ? _b2 : []
      ).join(", ") : null;
    })()) != null ? _b : null;
    return { audioLanguagesString, subtitleLanguagesString };
  }, [locale, purchasable, t]);
};

// src/~react-hooks/useCheckout/utils/usePurchaseTypeTitle.ts
var usePurchaseTypeTitle = ({
  transaction
}) => {
  const { purchaseTypes } = transaction != null ? transaction : {};
  if ((purchaseTypes == null ? void 0 : purchaseTypes.length) === 1) {
    const { type: type2 } = purchaseTypes[0];
    switch (type2) {
      case "est" /* est */:
        return "checkout.entitlement_type.buy";
      case "tvod" /* tvod */:
        return "checkout.entitlement_type.rent";
      default:
        assertUnreachable(type2);
        break;
    }
  }
  return "checkout.entitlement_type.title";
};

// src/~react-hooks/useCheckout/utils/useReturnUrl.ts
import { useMemo as useMemo14 } from "react";
var useReturnUrl = ({
  slug: slug3,
  isRemote,
  transaction
}) => {
  const { brand } = useApp_default();
  return useMemo14(() => {
    var _a, _b, _c, _d, _e;
    if (isSSR)
      return void 0;
    const defaultUrl = (_b = (_a = window == null ? void 0 : window.location) == null ? void 0 : _a.href) != null ? _b : "";
    if (!slug3 || !transaction)
      return defaultUrl;
    const deepLink = getDeepLinkHandler(brand).makeDeepLink;
    const url = ((_e = (_d = (_c = window == null ? void 0 : window.location) == null ? void 0 : _c.href) == null ? void 0 : _d.split("?")) != null ? _e : [])[0];
    const id = isRemote ? transaction.accessCode : transaction.id;
    const returnUrl = isInWebview() ? deepLink({
      type: "CHECKOUT",
      slug: slug3,
      transactionId: id,
      redirect: "1"
    }) : `${url}?transactionId=${id}&redirect=1`;
    return returnUrl;
  }, [brand, slug3, transaction, isRemote]);
};

// src/~react-hooks/useCheckout/utils/useSetAdyenData.tsx
import { useCallback as useCallback17 } from "react";
var useSetAdyenData = ({
  state,
  setState
}) => {
  const { updateTransaction } = useTransactionMutations();
  const { selectedPaymentMethod, transactionId, returnUrl } = state;
  const { locale, device } = useApp_default();
  return useCallback17(
    (adyenState) => __async(void 0, null, function* () {
      if (!transactionId)
        return;
      try {
        setState({ loading: true });
        yield updateTransaction({
          variables: {
            id: transactionId,
            device: { type: device.type, manufacturer: device.manufacturer },
            locale,
            input: {
              returnUrl,
              proceedToNext: true,
              payment: { adyen: { payload: adyenState.data } },
              paymentProcessor: selectedPaymentMethod == null ? void 0 : selectedPaymentMethod.processor,
              paymentMethod: selectedPaymentMethod == null ? void 0 : selectedPaymentMethod.method,
              paymentMethodId: selectedPaymentMethod == null ? void 0 : selectedPaymentMethod.methodId
            }
          }
        });
        setState({ loading: false });
      } catch (error) {
        setState({ error });
      }
    }),
    [
      transactionId,
      device,
      setState,
      updateTransaction,
      locale,
      returnUrl,
      selectedPaymentMethod == null ? void 0 : selectedPaymentMethod.processor,
      selectedPaymentMethod == null ? void 0 : selectedPaymentMethod.method,
      selectedPaymentMethod == null ? void 0 : selectedPaymentMethod.methodId
    ]
  );
};

// src/~react-hooks/useCheckout/utils/useSetPaymentMethod.ts
import { useCallback as useCallback18 } from "react";
var useSetPaymentMethod = ({
  state,
  setState
}) => {
  const { updateTransaction } = useTransactionMutations();
  const { transaction, transactionId, paymentMethods } = state;
  const { locale, device } = useApp_default();
  return useCallback18(
    (paymentMethodId) => __async(void 0, null, function* () {
      var _a;
      if (!transaction)
        return;
      if (!transactionId)
        return;
      if (!paymentMethods)
        return;
      if (((_a = transaction.selectedPaymentMethod) == null ? void 0 : _a.methodId) === paymentMethodId)
        return;
      const selectedPaymentMethod = paymentMethods.find(
        (p) => p.methodId === paymentMethodId
      );
      if (!selectedPaymentMethod)
        return;
      try {
        setState({ blockContinue: true });
        yield updateTransaction({
          variables: {
            id: transactionId,
            locale,
            device: { type: device.type, manufacturer: device.manufacturer },
            input: {
              paymentProcessor: selectedPaymentMethod.processor,
              paymentMethod: selectedPaymentMethod.method,
              paymentMethodId: selectedPaymentMethod.methodId
            }
          },
          optimisticResponse: {
            response: __spreadProps(__spreadValues({}, transaction), {
              selectedPaymentMethod,
              paymentMethods: paymentMethods.map((paymentMethod) => __spreadProps(__spreadValues({}, paymentMethod), {
                selected: paymentMethod.methodId === selectedPaymentMethod.methodId
              }))
            })
          }
        });
        setState({ blockContinue: false });
      } catch (error) {
        setState({ error, blockContinue: false });
      }
    }),
    [
      locale,
      device,
      paymentMethods,
      setState,
      transaction,
      transactionId,
      updateTransaction
    ]
  );
};

// src/~react-hooks/useCheckout/utils/useSetPurchaseType.ts
import { useCallback as useCallback19 } from "react";
var useSetPurchaseType = ({
  state,
  setState
}) => {
  const { updateTransaction } = useTransactionMutations();
  const { transaction, transactionId, purchaseTypes } = state;
  const { locale, device } = useApp_default();
  return useCallback19(
    (purchaseTypeId) => __async(void 0, null, function* () {
      var _a;
      if (!transaction || !purchaseTypes)
        return;
      if (!transactionId)
        return;
      if (((_a = transaction.selectedPurchaseType) == null ? void 0 : _a.id) === purchaseTypeId)
        return;
      const selectedPurchaseType = purchaseTypes.find(
        (t) => t.id === purchaseTypeId
      );
      if (!selectedPurchaseType)
        return;
      try {
        setState({ blockContinue: true });
        yield updateTransaction({
          variables: {
            id: transactionId,
            device: { type: device.type, manufacturer: device.manufacturer },
            locale,
            input: { purchaseType: selectedPurchaseType.type }
          },
          optimisticResponse: {
            response: __spreadProps(__spreadValues({}, transaction), {
              selectedPurchaseType,
              purchaseTypes: purchaseTypes.map((purchaseType) => __spreadProps(__spreadValues({}, purchaseType), {
                selected: purchaseType.id === selectedPurchaseType.id
              })),
              price: selectedPurchaseType.price,
              priceString: selectedPurchaseType.priceString,
              originalPrice: selectedPurchaseType.originalPrice,
              originalPriceString: selectedPurchaseType.originalPriceString
            })
          }
        });
        setState({ blockContinue: false });
      } catch (error) {
        console.error(error);
        setState({ error, blockContinue: false });
      }
    }),
    [
      locale,
      device,
      setState,
      purchaseTypes,
      transaction,
      transactionId,
      updateTransaction
    ]
  );
};

// src/~react-hooks/useCheckout/utils/useTransactionQuery.ts
import { useCallback as useCallback20, useEffect as useEffect16, useRef as useRef5 } from "react";
var NO_CONTUNE_ERROR_CODES = [
  "400",
  "401",
  "402",
  "403",
  "404",
  "422",
  "500",
  "502",
  "503",
  "504"
];
var useTransactionQuery = ({
  transactionId,
  pollInterval
}) => {
  var _a;
  const { locale, device } = useApp_default();
  const targetPollInterval = pollInterval > 1e3 ? pollInterval : 0;
  const {
    error,
    data,
    refetch,
    startPolling: _internalStartPolling,
    stopPolling
  } = useQuery_default(
    GQL_GET_TRANSACTION_default,
    {
      variables: {
        id: transactionId != null ? transactionId : "",
        locale,
        device: { type: device.type, manufacturer: device.manufacturer }
      },
      skip: !transactionId || transactionId.length < 3,
      pollInterval: targetPollInterval
    }
  );
  const aborted = useRef5(false);
  const startPolling = useCallback20(() => {
    if (aborted.current) {
      stopPolling();
      return;
    }
    _internalStartPolling(targetPollInterval);
  }, [stopPolling, _internalStartPolling, targetPollInterval]);
  useEffect16(() => {
    const time = 5 * 60 * 1e3;
    const timeout = setTimeout(() => {
      aborted.current = true;
      stopPolling();
    }, time);
    return () => clearTimeout(timeout);
  }, [stopPolling]);
  useEffect16(() => {
    var _a2;
    if (!((_a2 = data == null ? void 0 : data.response) == null ? void 0 : _a2.status))
      return;
    if ([
      "awaitingConfirmation" /* awaitingConfirmation */,
      "initialized" /* initialized */,
      "pending" /* pending */
    ].includes(data.response.status)) {
      return;
    }
    aborted.current = true;
    stopPolling();
  }, [(_a = data == null ? void 0 : data.response) == null ? void 0 : _a.status, stopPolling]);
  useEffect16(() => {
    var _a2, _b;
    const firstError = (_a2 = error == null ? void 0 : error.graphQLErrors[0]) == null ? void 0 : _a2.extensions;
    if (NO_CONTUNE_ERROR_CODES.includes((_b = firstError == null ? void 0 : firstError.code) != null ? _b : "")) {
      aborted.current = true;
      stopPolling();
    } else if (firstError == null) {
      aborted.current = false;
      startPolling();
    }
  }, [error == null ? void 0 : error.graphQLErrors, stopPolling, startPolling]);
  return { queryError: error, transaction: data == null ? void 0 : data.response, refetch };
};

// src/~react-hooks/useCheckout/utils/useVerifyReceipt.ts
import { useCallback as useCallback21 } from "react";
var useVerifyReceipt = ({
  state,
  setState
}) => {
  const { updateTransaction } = useTransactionMutations();
  const { selectedPaymentMethod, transactionId, returnUrl } = state;
  const { locale, device } = useApp_default();
  return useCallback21(
    (_0) => __async(void 0, [_0], function* ({
      receipt,
      provider
    }) {
      if (!transactionId)
        return;
      try {
        setState({ loading: true });
        yield updateTransaction({
          variables: {
            id: transactionId,
            locale,
            device: { type: device.type, manufacturer: device.manufacturer },
            input: {
              proceedToNext: true,
              payment: {
                [provider]: { payload: receipt }
              },
              returnUrl,
              paymentProcessor: selectedPaymentMethod == null ? void 0 : selectedPaymentMethod.processor,
              paymentMethod: selectedPaymentMethod == null ? void 0 : selectedPaymentMethod.method,
              paymentMethodId: selectedPaymentMethod == null ? void 0 : selectedPaymentMethod.methodId
            }
          }
        });
        setState({ loading: false });
      } catch (error) {
        setState({ error });
      }
    }),
    [
      locale,
      device,
      returnUrl,
      selectedPaymentMethod,
      setState,
      transactionId,
      updateTransaction
    ]
  );
};

// src/~react-hooks/useCheckout/utils/useVoucherCodeActions.ts
import { useCallback as useCallback22 } from "react";
var useVoucherCodeActions = ({
  state,
  setState
}) => {
  const { updateTransaction } = useTransactionMutations();
  const { transaction, transactionId, voucherLoading } = state;
  const { locale, device } = useApp_default();
  const { voucherCode, selectedPaymentMethod } = transaction != null ? transaction : {};
  const setVoucherCode = useCallback22(
    (voucher) => __async(void 0, null, function* () {
      if (typeof voucher !== "string") {
        return;
      }
      voucher = voucher.toUpperCase();
      if (!transactionId || voucher === voucherCode || voucherLoading) {
        return;
      }
      try {
        setState({ voucherLoading: true });
        yield updateTransaction({
          variables: {
            id: transactionId,
            locale,
            device: { type: device.type, manufacturer: device.manufacturer },
            input: {
              voucherCode: voucher,
              paymentProcessor: selectedPaymentMethod == null ? void 0 : selectedPaymentMethod.processor,
              paymentMethod: selectedPaymentMethod == null ? void 0 : selectedPaymentMethod.method,
              paymentMethodId: selectedPaymentMethod == null ? void 0 : selectedPaymentMethod.methodId
            }
          }
        });
      } finally {
        setState({ voucherLoading: false });
      }
    }),
    [
      locale,
      device,
      setState,
      selectedPaymentMethod,
      transactionId,
      voucherCode,
      voucherLoading,
      updateTransaction
    ]
  );
  const clearVoucherCode = useCallback22(() => {
    setVoucherCode("");
  }, [setVoucherCode]);
  return { setVoucherCode, clearVoucherCode };
};

// src/~react-hooks/useCheckout/useCheckout.tsx
import { jsx as jsx10 } from "react/jsx-runtime";
var CheckoutContext = createContext8({});
var CheckoutContextProvider = ({ children, initialValues, readyToCreateTransaction = true, slug: slug3 }) => {
  var _a, _b, _c, _d, _e, _f;
  const { locale, device } = useApp_default();
  const [reducerState, setState] = useCheckoutReducer();
  const { transactionId } = reducerState;
  const { transaction, queryError, refetch } = useTransactionQuery(reducerState);
  useSubscription3(GQL_UPDATED_TRANSACTION_SUBSCRIPTION_default, {
    skip: !(transaction == null ? void 0 : transaction.accessCode),
    variables: {
      accessCode: (_a = transaction == null ? void 0 : transaction.accessCode) != null ? _a : "",
      locale,
      device: { type: device.type, manufacturer: device.manufacturer }
    }
  });
  const isRemote = !!(transaction == null ? void 0 : transaction.accessCode) && (transaction == null ? void 0 : transaction.accessCode) === transactionId;
  const returnUrl = useReturnUrl({ slug: slug3, isRemote, transaction });
  const { errorText, errorTitle } = useCheckoutError({
    reducerState,
    transaction,
    queryErrorCode: (_c = (_b = queryError == null ? void 0 : queryError.graphQLErrors[0]) == null ? void 0 : _b.extensions) == null ? void 0 : _c.code
  });
  const currentStep = useCurrentStep({
    slug: slug3,
    status: transaction == null ? void 0 : transaction.status,
    state: reducerState
  });
  const { audioLanguagesString, subtitleLanguagesString } = useLanguageStrings({
    slug: slug3
  });
  const trackingPayload = getTrackingPayload(transaction);
  const inAppPurchaseTransactionId = useInAppPurchaseTransactionId({
    transaction
  });
  const productType = toProductType(transaction == null ? void 0 : transaction.item.__typename);
  const canApplyVoucher = productType !== "ticket";
  const purchaseTypeTitleKey = usePurchaseTypeTitle({ transaction });
  const isWebView = isInWebview();
  const state = __spreadValues({
    transaction,
    errorTitle,
    errorText,
    slug: slug3,
    readyToCreateTransaction,
    currentStep,
    returnUrl,
    productType,
    isRemote,
    audioLanguagesString,
    subtitleLanguagesString,
    trackingPayload,
    isWebView,
    canApplyVoucher,
    purchaseTypeTitleKey,
    selectedPaymentMethod: transaction == null ? void 0 : transaction.selectedPaymentMethod,
    selectedPurchaseType: transaction == null ? void 0 : transaction.selectedPurchaseType,
    purchaseTypes: transaction == null ? void 0 : transaction.purchaseTypes,
    paymentMethods: transaction == null ? void 0 : transaction.paymentMethods,
    price: transaction == null ? void 0 : transaction.price,
    priceString: transaction == null ? void 0 : transaction.priceString,
    accessCode: transaction == null ? void 0 : transaction.accessCode,
    originalPrice: transaction == null ? void 0 : transaction.originalPrice,
    originalPriceString: transaction == null ? void 0 : transaction.originalPriceString,
    receipt: transaction == null ? void 0 : transaction.receipt,
    voucherCode: transaction == null ? void 0 : transaction.voucherCode,
    status: transaction == null ? void 0 : transaction.status,
    adyen: (_d = transaction == null ? void 0 : transaction.payment) == null ? void 0 : _d.adyen,
    apple: (_e = transaction == null ? void 0 : transaction.payment) == null ? void 0 : _e.apple,
    google: (_f = transaction == null ? void 0 : transaction.payment) == null ? void 0 : _f.google,
    inAppPurchaseTransactionId,
    payQrUrl: transaction == null ? void 0 : transaction.payQrUrl,
    payUrl: transaction == null ? void 0 : transaction.payUrl,
    suggestedTicketsToBuy: transaction == null ? void 0 : transaction.suggestedTicketsToBuy
  }, reducerState);
  const { addListener } = useCheckoutEvents({ state });
  const back = useBack({ state, setState });
  const confirmOptions = useConfirmOptions({ state, setState });
  const setPaymentMethod = useSetPaymentMethod({ state, setState });
  const setPurchaseType = useSetPurchaseType({ state, setState });
  const setAdyenData = useSetAdyenData({ state, setState });
  const verifyReceipt = useVerifyReceipt({ state, setState });
  const { clearVoucherCode, setVoucherCode } = useVoucherCodeActions({
    state,
    setState
  });
  useInitTransaction({
    state,
    initialValues,
    setState
  });
  useEffect17(() => {
    if (queryError)
      setState({ error: queryError });
  }, [queryError, setState]);
  const setInAppPurchaseError = useCallback23(
    (payload) => {
      if (payload)
        setState({
          error: {
            errorType: "inAppPurchase",
            payload
          }
        });
    },
    [setState]
  );
  const _g = state, { transaction: _ } = _g, exposedState = __objRest(_g, ["transaction"]);
  return /* @__PURE__ */ jsx10(
    CheckoutContext.Provider,
    {
      value: __spreadProps(__spreadValues(__spreadValues({}, exposedState), back), {
        addListener,
        setPaymentMethod,
        setPurchaseType,
        setVoucherCode,
        setAdyenData,
        setInAppPurchaseError,
        clearVoucherCode,
        confirmOptions,
        verifyReceipt,
        refetch
      }),
      children
    }
  );
};
var useCheckout = () => useContext12(CheckoutContext);

// src/~react-hooks/useCheckout/utils.ts
var isPaymentInProgressStatus2 = (status) => {
  switch (status) {
    case "abandoned" /* abandoned */:
    case "initialized" /* initialized */:
    case "error" /* error */:
    case "paid" /* paid */:
    case "rejected" /* rejected */:
    case "refunded" /* refunded */:
      return false;
    default:
      return true;
  }
};
var isFailedStatus2 = (status) => {
  switch (status) {
    case "abandoned" /* abandoned */:
    case "error" /* error */:
    case "rejected" /* rejected */:
    case "refunded" /* refunded */:
      return true;
    default:
      return false;
  }
};
var toProductType2 = (__typename2) => {
  if (!__typename2)
    return void 0;
  return {
    Episode: "episode" /* episode */,
    Movie: "movie" /* movie */,
    Season: "season" /* season */,
    Series: "series" /* series */,
    MetaCollectionBundle: "bundle" /* bundle */,
    Ticket: "ticket" /* ticket */
  }[__typename2];
};
var usePrintDiff = (object, label) => {
  const lastObject = usePrevious(object);
  if (!lastObject)
    return;
  for (const [key3, value] of Object.entries(object)) {
    const lastValue = lastObject[key3];
    if (lastValue !== value) {
      console.log(`DIFF, ${label}, key: ${key3}`, { lastValue }, { value });
    }
  }
};
var getTrackingPayload2 = (transaction) => {
  var _a, _b, _c, _d;
  if (!transaction)
    return null;
  return {
    purchaseId: transaction.id,
    originalTitle: transaction.item.originalTitle,
    slug: transaction.item.slug,
    type: transaction.item.__typename,
    audioLanguage: (_a = transaction.selectedAudioLanguage) == null ? void 0 : _a.language,
    purchaseMethod: transaction.selectedPaymentMethod.method,
    purchaseType: transaction.selectedPurchaseType.type,
    price: (_b = transaction.receipt) == null ? void 0 : _b.paidAmount,
    discount: (_c = transaction.receipt) == null ? void 0 : _c.discountAmount,
    currency: (_d = transaction.receipt) == null ? void 0 : _d.currency
  };
};

// src/~react-hooks/useConnectionPagination/useConnectionPagination.ts
import { useCallback as useCallback24, useMemo as useMemo15, useState as useState7 } from "react";
var useConnectionPagination = (props, options) => {
  const [isLoadingNext, setIsLoadingNext] = useState7(false);
  const { data, fetchMore, loading, error, refetch, refresh, networkStatus } = useQuery_default(props.query, __spreadValues({
    variables: props.variables
  }, options));
  const connection = data != null ? props.connectionAccessor(data) : null;
  const endCursor = connection == null ? void 0 : connection.pageInfo.endCursor;
  const hasNextPage = connection == null ? void 0 : connection.pageInfo.hasNextPage;
  return {
    loading,
    error: error != null ? error : null,
    hasNextPage: hasNextPage != null ? hasNextPage : null,
    loadNext: useCallback24(
      (count) => __async(void 0, null, function* () {
        try {
          if (isLoadingNext || hasNextPage !== true) {
            return;
          }
          setIsLoadingNext(true);
          yield fetchMore({
            variables: {
              first: count != null ? count : props.variables.first,
              after: endCursor
            }
          });
        } catch (e) {
          console.warn(e);
        } finally {
          setIsLoadingNext(false);
        }
      }),
      [isLoadingNext, hasNextPage, fetchMore, props.variables.first, endCursor]
    ),
    refetch: useCallback24(
      (partialVariables) => __async(void 0, null, function* () {
        yield refetch(__spreadValues({
          after: null,
          first: props.variables.first
        }, partialVariables));
      }),
      [refetch, props.variables.first]
    ),
    refetching: networkStatus === 4,
    refresh,
    isLoadingNext,
    nodes: useMemo15(
      () => {
        var _a;
        return (_a = connection == null ? void 0 : connection.edges.map((edge) => edge.node).filter(exists)) != null ? _a : [];
      },
      [connection == null ? void 0 : connection.edges]
    ),
    rawResponse: data
  };
};

// src/~react-hooks/useContentCollection/useContentCollection.ts
var useContentCollection = (props) => {
  var _a;
  const { locale } = useApp_default();
  const { slug: slug3, variables, initialTake } = props;
  const cc = useConnectionPagination({
    query: GQL_CONTENT_COLLECTION_default,
    variables: __spreadProps(__spreadValues({}, variables), {
      slug: slug3,
      locale,
      first: initialTake
    }),
    connectionAccessor: (data) => {
      var _a2;
      return (_a2 = data.contentcollection) == null ? void 0 : _a2.collection;
    }
  });
  return __spreadProps(__spreadValues({}, cc), {
    response: (_a = cc.rawResponse) == null ? void 0 : _a.contentcollection
  });
};

// src/~react-hooks/useCustomerSupport/useCustomerSupportCategories.ts
var useCustomerSupportCategories = (props) => {
  var _b;
  const { locale } = useApp_default();
  const _a = useQuery_default(GQL_GET_CUSTOMER_SUPPORT_CATEGORIES_default, __spreadValues({
    variables: {
      locale
    }
  }, props)), { data, loading } = _a, other = __objRest(_a, ["data", "loading"]);
  return __spreadProps(__spreadValues({}, other), {
    loading,
    response: (_b = data == null ? void 0 : data.response) != null ? _b : []
  });
};

// src/~react-hooks/useCustomerSupport/useCustomerSupportArticle.ts
var useCustomerSupportArticle = (_a) => {
  var _b = _a, { slug: slug3 } = _b, config = __objRest(_b, ["slug"]);
  const { locale } = useApp_default();
  const _a2 = useQuery_default(GQL_GET_CUSTOMER_SUPPORT_ARTICLE_default, __spreadValues({
    variables: {
      locale,
      slug: slug3 != null ? slug3 : ""
    },
    skip: !slug3
  }, config)), { data, loading } = _a2, other = __objRest(_a2, ["data", "loading"]);
  return __spreadProps(__spreadValues({}, other), {
    loading,
    response: data == null ? void 0 : data.response
  });
};

// src/~graphql/mutations/GQL_CREATE_CUSTOMER_SUPPORT_TICKET.ts
import { gql as gql84 } from "@apollo/client";
var GQL_CREATE_CUSTOMER_SUPPORT_TICKET_default = gql84`
  mutation CreateCustomerSupportTicketMutation(
    $email: String!
    $type: String!
    $message: String!
    $subject: String!
    $metaData: JSON
  ) {
    response: createSupportTicket(
      email: $email
      type: $type
      message: $message
      subject: $subject
      metaData: $metaData
    ) {
      __typename
      id
    }
  }
`;

// src/~react-hooks/useCustomerSupport/useCustomerSupportTicket.ts
import { useMutation as useMutation5 } from "@apollo/client";
import { useCallback as useCallback25 } from "react";

// src/~react-hooks/useCustomerSupport/types.ts
var PROBLEM_TYPE = {
  Playback: "playback",
  Tickets: "tickets",
  Account: "account",
  Payment: "payment",
  Vouchers: "vouchers",
  Feedback: "feedback"
};
var PAYMENT_OPTIONS = {
  Card: "card",
  Tickets: "tickets",
  Swish: "swish",
  Klarna: "klarna",
  Vipps: "vipps",
  MobilePay: "mobilepay",
  Other: "other"
};

// src/~react-hooks/useCustomerSupport/useCustomerSupportTicket.ts
var getMessagePrefix = (object) => {
  return Object.keys(object).reduce(
    (str, key3) => `${str}${key3}: ${object[key3]}<br><br>`,
    ""
  );
};
var useCustomerSupportTicket = (opts) => {
  var _a;
  const { getString } = useL10n_default();
  const { isLoggedIn } = useSession_default();
  const account2 = useAccount_default();
  const orders = useAccountOrder_default({ take: 15 });
  const playableOrders = orders == null ? void 0 : orders.response.filter(exists).filter((o) => o == null ? void 0 : o.item).filter(
    (o) => {
      var _a2, _b;
      return ((_a2 = o == null ? void 0 : o.item) == null ? void 0 : _a2.__typename) === "Episode" || ((_b = o == null ? void 0 : o.item) == null ? void 0 : _b.__typename) === "Movie";
    }
  );
  const [createCustomerSupportTicketMutation, _other] = useMutation5(GQL_CREATE_CUSTOMER_SUPPORT_TICKET_default, opts);
  const email = (_a = account2 == null ? void 0 : account2.response) == null ? void 0 : _a.email;
  const createCustomerSupportTicket = useCallback25(
    (_b) => __async(void 0, null, function* () {
      var _c = _b, {
        username,
        problemType,
        message
      } = _c, rest = __objRest(_c, [
        "username",
        "problemType",
        "message"
      ]);
      if (!isLoggedIn && !username) {
        throw new Error("No contact email was supplied.");
      }
      const variables = {
        type: problemType,
        email: isLoggedIn && email ? email : String(username),
        message: `${getMessagePrefix(rest)} ${message}`,
        subject: `${getString(
          `supportforum.contact_form.email.subject_problem_type.${problemType}`
        )} | ${message}`,
        metaData: {
          problemType,
          platform: rest.platform,
          playbackTitle: rest.playbackTitle,
          playbackTitleFreeText: rest.playbackTitleFreeText,
          paymentMethod: rest.paymentMethod,
          paymentFreeText: rest.paymentFreeText,
          voucher: rest.voucher
        }
      };
      return createCustomerSupportTicketMutation({ variables });
    }),
    [createCustomerSupportTicketMutation, email, getString, isLoggedIn]
  );
  const paymentOptions = Object.values(PAYMENT_OPTIONS).map((o) => ({
    // Evaluate this expression
    value: o,
    text: getString(`supportforum.contact_form.payment_${o}`)
  }));
  const problemTypes = Object.values(PROBLEM_TYPE).map((p) => ({
    // Evaluate this expression
    value: p,
    text: getString(`supportforum.contact_form.problem_options.${p}_option`)
  }));
  return {
    createCustomerSupportTicket,
    problemTypes,
    orders,
    playableOrders,
    email,
    paymentOptions
  };
};

// src/~react-hooks/useContentListPaginate/useContentListPaginate.ts
var useContentListPaginate = (props, options) => {
  var _a, _b;
  const { locale } = useApp_default();
  const { slug: slug3, initialTake, orderBy, options: opts } = props;
  const {
    error,
    hasNextPage,
    loading,
    nodes,
    refetch,
    refresh,
    isLoadingNext,
    loadNext,
    refetching,
    rawResponse
  } = useConnectionPagination(
    {
      query: GQL_CONTENT_LIST_PAGINATE_default,
      variables: {
        locale,
        slug: slug3,
        first: initialTake,
        coverPreset: (_a = opts == null ? void 0 : opts.cover) == null ? void 0 : _a.preset,
        coverSize: (_b = opts == null ? void 0 : opts.cover) == null ? void 0 : _b.size,
        orderBy
      },
      connectionAccessor: (res) => {
        var _a2;
        return (_a2 = res.response) == null ? void 0 : _a2.items;
      }
    },
    options
  );
  return {
    error,
    hasNextPage,
    loading,
    nodes,
    refetch,
    refresh,
    isLoadingNext,
    loadNext,
    refetching,
    response: rawResponse == null ? void 0 : rawResponse.response
  };
};
var useContentListPaginate_default = useContentListPaginate;

// src/~react-hooks/useContinueWatching/continueWatchingUtils.ts
var canContinueFromBookmark = (bookmark) => bookmark != null && bookmark.completed !== true && bookmark.started === true;
var getEpisodeToContinueWatching = (entitlement, bookmarks) => {
  let episodeToContinueWatching = null;
  for (let i = 0; i <= bookmarks.length - 1; i += 1) {
    const thisBookmark = bookmarks[i];
    const thisBookmarkItem = thisBookmark.item;
    if (thisBookmarkItem != null && thisBookmarkItem.__typename === "Episode" && thisBookmarkItem.seriesSlug === entitlement.seriesSlug && canContinueFromBookmark(thisBookmark)) {
      if (episodeToContinueWatching != null) {
        if (thisBookmarkItem.seasonNo > episodeToContinueWatching.episode.seasonNo || thisBookmarkItem.seasonNo === episodeToContinueWatching.episode.seasonNo && thisBookmarkItem.episodeNo > episodeToContinueWatching.episode.episodeNo) {
          episodeToContinueWatching = {
            episode: thisBookmarkItem,
            bookmark: thisBookmark
          };
        }
      } else {
        episodeToContinueWatching = {
          episode: thisBookmarkItem,
          bookmark: thisBookmark
        };
      }
    }
  }
  return episodeToContinueWatching;
};
var getContinueWatchingItems = ({
  entitlements: entitlements2,
  bookmarks,
  limit
}) => {
  var _a, _b, _c;
  const now = /* @__PURE__ */ new Date();
  const isExpired = (entitlement) => {
    return new Date(entitlement.endDate) < now;
  };
  const nonExpiredEntitlements = entitlements2.filter(
    (item) => !isExpired(item)
  );
  const items = [];
  const alreadyInList = (slug3) => !!items.find((item) => item.slug === slug3);
  const entitlementsLookup = nonExpiredEntitlements.reduce(
    (lookupTable, entitlement) => {
      lookupTable[entitlement.slug] = entitlement;
      return lookupTable;
    },
    {}
  );
  const isEntitled = (slug3) => !!entitlementsLookup[slug3];
  const seriesChecked = {};
  const seriesAlreadyRepresentedInList = (slug3) => !!seriesChecked[slug3];
  const setSeriesAlreadyRepresentedInList = (slug3) => {
    seriesChecked[slug3] = true;
  };
  for (const thisBookmark of bookmarks) {
    if (items.length >= limit) {
      break;
    }
    if (thisBookmark.updatedAt == null) {
      break;
    }
    if (alreadyInList(thisBookmark.slug) || !isEntitled(thisBookmark.slug) || !canContinueFromBookmark(thisBookmark)) {
      continue;
    }
    if (((_a = thisBookmark.item) == null ? void 0 : _a.__typename) === "Episode" && !seriesAlreadyRepresentedInList(thisBookmark.item.seriesSlug)) {
      setSeriesAlreadyRepresentedInList(thisBookmark.item.seriesSlug);
      items.push({
        slug: thisBookmark.slug,
        bookmark: thisBookmark
      });
    } else if (((_b = thisBookmark.item) == null ? void 0 : _b.__typename) === "Movie") {
      items.push({ slug: thisBookmark.slug, bookmark: thisBookmark });
    }
  }
  if (items.length === limit) {
    return items;
  }
  const sortedEntitlements = nonExpiredEntitlements.slice().sort((a, b) => new Date(a.startDate) > new Date(b.startDate) ? -1 : 1);
  const bookmarksLookup = bookmarks.reduce(
    (lookupTable, bookmark) => {
      lookupTable[bookmark.slug] = bookmark;
      return lookupTable;
    },
    {}
  );
  for (const entitlement of sortedEntitlements) {
    if (items.length >= limit) {
      break;
    }
    if (alreadyInList(entitlement.slug)) {
      continue;
    }
    if (entitlement.seriesSlug != null && !seriesAlreadyRepresentedInList(entitlement.seriesSlug)) {
      const episodeFromSeriesToContinueWatching = getEpisodeToContinueWatching(
        entitlement,
        bookmarks
      );
      setSeriesAlreadyRepresentedInList(entitlement.seriesSlug);
      if (episodeFromSeriesToContinueWatching) {
        items.push({
          slug: episodeFromSeriesToContinueWatching.episode.slug,
          bookmark: episodeFromSeriesToContinueWatching.bookmark
        });
      }
    } else {
      const bookmark = bookmarksLookup[entitlement.slug];
      if (((_c = bookmark == null ? void 0 : bookmark.item) == null ? void 0 : _c.__typename) === "Movie" && canContinueFromBookmark(bookmark)) {
        items.push({ slug: entitlement.slug, bookmark });
      }
    }
  }
  return items;
};

// src/~react-hooks/useContinueWatching/useContinueWatching.ts
import { useMemo as useMemo16 } from "react";
var DEFAULT_CONFIG = {
  limit: 5
};
var useContinueWatching = ({
  limit = 5
} = DEFAULT_CONFIG) => {
  const { isLoggedIn } = useSession_default();
  const { response: bookmarks, loading: loadingBookmarks } = useBookmarks_default({
    fetchPolicy: "cache-first"
  });
  const {
    response: { entitlements: entitlements2 },
    loading: loadingEntitlements
  } = useEntitlements_default({ fetchPolicy: "cache-first" });
  return useMemo16(() => {
    if (!isLoggedIn)
      return {
        loading: false,
        items: []
      };
    if (bookmarks == null || entitlements2 == null || loadingEntitlements || loadingBookmarks) {
      return {
        loading: true,
        items: []
      };
    }
    const items = getContinueWatchingItems({
      entitlements: entitlements2,
      bookmarks,
      limit
    });
    return {
      loading: false,
      items
    };
  }, [
    bookmarks,
    entitlements2,
    loadingEntitlements,
    loadingBookmarks,
    limit,
    isLoggedIn
  ]);
};
var useContinueWatching_default = useContinueWatching;

// src/~react-hooks/useContinueWatching/useContinueWatchingSeries.ts
import { useMemo as useMemo17 } from "react";
var useContinueWatchingSeries = ({
  seriesSlug
}) => {
  const { response: bookmarks, loading: loadingBookmarks } = useBookmarks_default({
    fetchPolicy: "cache-first"
  });
  const {
    response: { entitlements: rawEntitlements },
    loading: loadingEntitlements
  } = useEntitlements_default({ fetchPolicy: "cache-first" });
  return useMemo17(() => {
    var _a;
    if (bookmarks == null || rawEntitlements == null || loadingEntitlements || loadingBookmarks) {
      return {
        loading: true,
        episode: null
      };
    }
    const now = /* @__PURE__ */ new Date();
    const isExpired = (entitlement) => {
      return new Date(entitlement.endDate) < now;
    };
    const entitlements2 = rawEntitlements.filter((item) => !isExpired(item));
    const entitlementsLookup = entitlements2.reduce(
      (lookupTable, entitlement) => {
        lookupTable[entitlement.slug] = entitlement;
        return lookupTable;
      },
      {}
    );
    const isEntitled = (slug3) => !!entitlementsLookup[slug3];
    for (const thisBookmark of bookmarks) {
      if (thisBookmark.updatedAt == null) {
        break;
      }
      if (!isEntitled(thisBookmark.slug) || !canContinueFromBookmark(thisBookmark)) {
        continue;
      }
      if (((_a = thisBookmark.item) == null ? void 0 : _a.__typename) === "Episode" && thisBookmark.item.seriesSlug === seriesSlug) {
        return {
          loading: false,
          episode: {
            slug: thisBookmark.slug,
            bookmark: thisBookmark
          }
        };
      }
    }
    const sortedEntitlements = entitlements2.slice().sort((a, b) => new Date(a.startDate) > new Date(b.startDate) ? -1 : 1);
    for (const entitlement of sortedEntitlements) {
      if (entitlement.seriesSlug === seriesSlug) {
        const episodeFromSeriesToContinueWatching = getEpisodeToContinueWatching(entitlement, bookmarks);
        if (episodeFromSeriesToContinueWatching) {
          return {
            loading: false,
            episode: {
              slug: episodeFromSeriesToContinueWatching.episode.slug,
              bookmark: episodeFromSeriesToContinueWatching.bookmark
            }
          };
        }
      }
    }
    return {
      loading: false,
      episode: null
    };
  }, [
    bookmarks,
    loadingBookmarks,
    loadingEntitlements,
    rawEntitlements,
    seriesSlug
  ]);
};
var useContinueWatchingSeries_default = useContinueWatchingSeries;

// src/~react-hooks/useDeleteAccount/useDeleteAccount.ts
import { useMutation as useMutation6 } from "@apollo/client";
import { useCallback as useCallback26 } from "react";
var useDeleteAccount = (_a = {}) => {
  var opts = __objRest(_a, []);
  const { logout: logout2 } = useSession_default();
  const [deleteAccountMutation, other] = useMutation6(GQL_DELETE_ACCOUNT_default, opts);
  const deleteAccount = useCallback26(
    (input) => {
      return deleteAccountMutation({
        variables: {
          input
        },
        update: () => __async(void 0, null, function* () {
          yield logout2();
        })
      });
    },
    [deleteAccountMutation, logout2]
  );
  return [deleteAccount, other];
};
var useDeleteAccount_default = useDeleteAccount;

// src/~react-hooks/useDeletePaymentMethod/useDeletePaymentMethod.ts
import { useMutation as useMutation7 } from "@apollo/client";
import { useCallback as useCallback27 } from "react";
var useDeletePaymentMethod = (_a = {}) => {
  var opts = __objRest(_a, []);
  const [deletePaymentMethodMutation, other] = useMutation7(GQL_DELETE_PAYMENT_METHOD_default, opts);
  const deletePaymentMethod = useCallback27(
    (id) => deletePaymentMethodMutation({ variables: { id } }),
    [deletePaymentMethodMutation]
  );
  return [deletePaymentMethod, other];
};
var useDeletePaymentMethod_default = useDeletePaymentMethod;

// src/~react-hooks/useDrm/useDrm.ts
import { useMemo as useMemo18 } from "react";
var useDrm = (_a = {}) => {
  var _b = _a, { slug: slug3, manifestFilters = [] } = _b, opts = __objRest(_b, ["slug", "manifestFilters"]);
  const { isLoggedIn } = useSession_default();
  const _a2 = useQuery_default(GQL_CREATE_PLAYBACK_TOKEN_default, __spreadValues({
    variables: { slug: slug3 || "", filters: manifestFilters },
    skip: !isLoggedIn || opts.skip || !slug3
  }, opts)), { data, loading, error, networkStatus, refetch } = _a2, other = __objRest(_a2, ["data", "loading", "error", "networkStatus", "refetch"]);
  const errorInfo = useMemo18(() => {
    if (!error)
      return void 0;
    const { code, message } = getCodeFromError(error);
    const errorLiterals = getErrorCodeLiterals({
      code,
      scope: "player"
    });
    return {
      title: errorLiterals.title,
      text: errorLiterals.text,
      code,
      technicalInfo: message
    };
  }, [error]);
  return __spreadProps(__spreadValues({}, other), {
    loading,
    error: errorInfo,
    refetch,
    networkStatus,
    refetching: networkStatus === 4,
    response: data == null ? void 0 : data.response
  });
};
var useDrm_default = useDrm;

// src/~react-hooks/useEntitlement/useEntitlement.ts
import { useApolloClient as useApolloClient5 } from "@apollo/client";
import { useCallback as useCallback28, useEffect as useEffect18, useMemo as useMemo19, useState as useState8 } from "react";

// src/~react-hooks/useEntitlement/createEntitlementId.ts
var createEntitlementId2 = (params) => createGloballyUniqueIdResolver("AccountEntitlement", (e) => {
  var _a;
  return [(_a = e == null ? void 0 : e.slug) != null ? _a : ""];
})(
  params,
  params
);

// src/~react-hooks/useEntitlement/useEntitlement.ts
var useEntitlement = ({ slug: slug3 }) => {
  const client = useApolloClient5();
  const params = useMemo19(
    () => ({
      query: GET_ENTITLEMENT,
      variables: { id: createEntitlementId2({ slug: slug3 }) },
      optimistic: true
    }),
    [slug3]
  );
  const read = useCallback28(() => {
    var _a, _b;
    try {
      return (_b = (_a = client.cache.read(params)) == null ? void 0 : _a.entitlement) != null ? _b : null;
    } catch (e) {
      return null;
    }
  }, [client.cache, params]);
  const [entitlement, setResponse] = useState8(read());
  useEffect18(() => {
    return client.cache.watch(__spreadProps(__spreadValues({}, params), {
      callback: (data) => {
        var _a;
        if (!data.complete)
          return;
        setResponse((_a = data.result) == null ? void 0 : _a.entitlement);
      }
    }));
  }, [client.cache, params, slug3]);
  const prevSlug = usePrevious(slug3);
  useEffect18(() => {
    if (!prevSlug)
      return;
    if (prevSlug === slug3)
      return;
    setResponse(read());
  }, [read, prevSlug, slug3]);
  const isRented2 = Boolean(entitlement && !entitlement.isEst);
  const isBought2 = Boolean(entitlement && entitlement.isEst);
  const canPlay = isRented2 || isBought2;
  return {
    isBought: isBought2,
    isRented: isRented2,
    canPlay,
    entitlement: entitlement != null ? entitlement : null,
    initializing: false
  };
};
var useEntitlement_default = useEntitlement;

// src/~react-hooks/useFavorites/useFavorites.ts
import { NetworkStatus as NetworkStatus2 } from "@apollo/client";
import { useEffect as useEffect19, useMemo as useMemo20 } from "react";
var { onEvent: onEvent6, emit: emit5 } = createEventEmitter();
var useFavorites = (opts = {}) => {
  const { locale } = useApp_default();
  const { isLoggedIn } = useSession_default();
  const _a = useQuery_default(GQL_GET_FAVORITES_default, __spreadValues({
    variables: { locale },
    skip: !isLoggedIn || opts.skip || false
  }, opts)), { data, loading, error, networkStatus } = _a, other = __objRest(_a, ["data", "loading", "error", "networkStatus"]);
  useEffect19(() => {
    if (opts == null ? void 0 : opts.onEvent)
      return onEvent6(opts.onEvent);
  }, [opts == null ? void 0 : opts.onEvent]);
  const response = useMemo20(
    () => {
      var _a2, _b;
      return (_b = (_a2 = data == null ? void 0 : data.response) == null ? void 0 : _a2.filter(exists)) != null ? _b : [];
    },
    [data == null ? void 0 : data.response]
  );
  const refetching = networkStatus === NetworkStatus2.refetch;
  return __spreadProps(__spreadValues({}, other), {
    response,
    loading: loading && response.length === 0 || refetching,
    refetching,
    networkStatus,
    error
  });
};
var useFavorites_default = useFavorites;

// src/~react-hooks/useFavorite/useFavorite.ts
import { useMemo as useMemo21 } from "react";

// src/~react-hooks/useFavoriteMutation/useFavoriteMutation.ts
import { useApolloClient as useApolloClient6, useMutation as useMutation8 } from "@apollo/client";
import { useCallback as useCallback29 } from "react";
function useFavoriteMutation({
  idOfMedia,
  slug: slug3,
  isFavorited
}) {
  const { locale } = useApp_default();
  const client = useApolloClient6();
  const [addMutation, addTuple] = useMutation8(GQL_ADD_FAVORITE_default, {
    optimisticResponse: () => {
      let cachedMediaItem = null;
      try {
        cachedMediaItem = client.cache.readFragment({
          fragment: FAVORITES_FRAGMENT_default,
          id: idOfMedia
        });
      } catch (e) {
      }
      return {
        response: {
          id: "Favorite:slug:tempId",
          slug: slug3,
          item: cachedMediaItem,
          __typename: "Favorite"
        }
      };
    },
    update: (cache, { data }) => {
      var _a;
      try {
        const response = (_a = data == null ? void 0 : data.response) != null ? _a : null;
        let cacheData = cache.readQuery({
          query: GQL_GET_FAVORITES_default,
          variables: {
            locale
          }
        });
        if (response && cacheData) {
          cacheData = __spreadProps(__spreadValues({}, cacheData), {
            response: [
              response,
              ...(cacheData.response || []).filter(
                (f) => f && f.item && f.item.id !== response.id
              )
            ]
          });
        }
        cache.writeQuery({
          query: GQL_GET_FAVORITES_default,
          variables: {
            locale
          },
          data: cacheData
        });
      } catch (err) {
        console.warn("GetFavoritesQuery not found in cache.");
      }
    }
  });
  const [removeMutation, removeTuple] = useMutation8(GQL_REMOVE_FAVORITE_default, {
    optimisticResponse: () => {
      var _a, _b;
      const cacheData = client.readQuery({
        query: GQL_GET_FAVORITES_default,
        variables: {
          locale
        }
      });
      const favoriteItem = (_a = cacheData == null ? void 0 : cacheData.response) == null ? void 0 : _a.find(
        (fav) => (fav == null ? void 0 : fav.slug) === slug3
      );
      return {
        response: {
          id: (_b = favoriteItem == null ? void 0 : favoriteItem.id) != null ? _b : "Favorite:slug:tempId",
          slug: slug3,
          item: null,
          __typename: "Favorite"
        }
      };
    },
    update: (proxy) => {
      try {
        let cacheData = proxy.readQuery({
          query: GQL_GET_FAVORITES_default,
          variables: {
            locale
          }
        });
        if (cacheData && cacheData.response) {
          cacheData = __spreadProps(__spreadValues({}, cacheData), {
            response: cacheData.response.filter(
              (f) => f && f.item && f.item.slug !== slug3
            )
          });
        }
        proxy.writeQuery({
          query: GQL_GET_FAVORITES_default,
          variables: {
            locale
          },
          data: cacheData
        });
      } catch (err) {
        console.warn("GetFavoritesQuery not found in cache.");
      }
    }
  });
  const toggleFavorite = useCallback29(() => __async(this, null, function* () {
    const mutationFn = isFavorited ? removeMutation : addMutation;
    const eventName = isFavorited ? "removed" : "added";
    const response = yield mutationFn({
      variables: { locale, slug: slug3 }
    });
    emit5(eventName, { slug: slug3 });
    return response;
  }), [addMutation, isFavorited, locale, removeMutation, slug3]);
  return [
    toggleFavorite,
    isFavorited ? addTuple : removeTuple
  ];
}
var useFavoriteMutation_default = useFavoriteMutation;

// src/~react-hooks/useFavorite/useFavorite.ts
var useFavorite = (_a) => {
  var _b = _a, { slug: slug3, idOfMedia } = _b, opts = __objRest(_b, ["slug", "idOfMedia"]);
  const _a2 = useFavorites_default(opts), { response } = _a2, other = __objRest(_a2, ["response"]);
  const favorite = useMemo21(() => {
    return response && response.length > 0 ? response.find((f) => f.slug === slug3) : null;
  }, [response, slug3]);
  const isFavorited = favorite ? !!favorite : false;
  const toggleMutation = useFavoriteMutation_default({
    slug: slug3,
    isFavorited,
    idOfMedia
  });
  return __spreadProps(__spreadValues({}, other), {
    toggleMutation,
    response: {
      isFavorited
    }
  });
};
var useFavorite_default = useFavorite;

// src/~react-hooks/useFeatureToggle/useFeatureToggle.ts
import { atom as atom4, useAtom as useAtom2, useSetAtom as useSetAtom3 } from "jotai";
import { useCallback as useCallback30, useMemo as useMemo22 } from "react";
var featureToggleOverrideAtom = atom4(/* @__PURE__ */ new Map());
var updateFeatureToggleAtom = atom4(
  null,
  (get6, set, { featureToggle, value }) => {
    const currentMap = get6(featureToggleOverrideAtom);
    const newMap = new Map(currentMap);
    newMap.set(featureToggle, value);
    set(featureToggleOverrideAtom, newMap);
  }
);
var useFeatureToggle = (feature) => {
  const { response } = useDeviceInformation();
  const [featureToggleMap] = useAtom2(featureToggleOverrideAtom);
  const updateFeatureToggle = useSetAtom3(updateFeatureToggleAtom);
  const value = useMemo22(() => {
    var _a, _b;
    const f = ((_a = response == null ? void 0 : response.features) != null ? _a : []).find((f2) => f2.feature === feature);
    const localOverride = (_b = featureToggleMap.get(feature)) != null ? _b : void 0;
    if (!f) {
      return {
        feature,
        enabled: localOverride,
        variant: null,
        data: null,
        ready: false
      };
    }
    return {
      feature: f.feature,
      enabled: localOverride != null ? localOverride : f.enabled,
      variant: f.variant,
      data: f.data,
      ready: true
    };
  }, [feature, featureToggleMap, response == null ? void 0 : response.features]);
  const toggle = useCallback30(
    () => updateFeatureToggle({
      featureToggle: feature,
      value: !value.enabled
    }),
    [feature, updateFeatureToggle, value.enabled]
  );
  return __spreadProps(__spreadValues({}, value), { toggle });
};
var useFeatureToggle_default = useFeatureToggle;

// src/~react-hooks/useFooter/useFooter.ts
var useFooter = () => {
  const { locale, brand } = useApp_default();
  const res = useQuery_default(GQL_GET_FOOTER_default, {
    variables: {
      locale,
      brand
    }
  });
  return res;
};

// src/~react-hooks/useInterval/useInterval.ts
import { useEffect as useEffect20, useRef as useRef6 } from "react";
var useInterval = (callback, delay, immediate) => {
  const savedCallback = useRef6(() => {
  });
  useEffect20(() => {
    savedCallback.current = callback;
  });
  useEffect20(() => {
    if (!immediate)
      return;
    if (delay === null || delay === false)
      return;
    savedCallback.current();
  }, [delay, immediate]);
  useEffect20(() => {
    if (delay === null || delay === false)
      return void 0;
    const tick = () => savedCallback.current();
    const id = setInterval(tick, delay);
    return () => clearInterval(id);
  }, [delay]);
};
var useInterval_default = useInterval;

// src/~react-hooks/useKeyboard/useKeyboard.ts
import { useEffect as useEffect21 } from "react";

// src/~react-hooks/useKeyboard/keyUtils.ts
var codeLowerCaseA = 65;
var codeUpperCaseZ = 122;
var isKeyFromGivenList = (keyCode, allowedKeys = []) => {
  if (allowedKeys === null || allowedKeys.includes(keyCode) || allowedKeys.length === 0) {
    return true;
  }
  return false;
};
var onKeyPress = (currentKeyCode, callback, allowedKeys, event) => {
  if (isKeyFromGivenList(currentKeyCode, allowedKeys)) {
    callback(currentKeyCode, event);
  }
};
function getAsciiCode(event) {
  let keyCode = event.which;
  if (keyCode >= codeLowerCaseA && keyCode <= codeUpperCaseZ) {
    keyCode = event.key.charCodeAt(0);
  }
  return keyCode;
}
function convertToAsciiEquivalent(inputArray) {
  return inputArray.map((item) => {
    let finalVal = item;
    if (typeof item === "string") {
      finalVal = finalVal.charCodeAt(0);
    }
    return finalVal;
  });
}

// src/~react-hooks/useKeyboard/useKeyboard.ts
var useKeyboard = (callback, { detectKeys = [], keyevent = "keydown" } = {}, { dependencies = [] } = {}) => {
  let allowedKeys = detectKeys;
  if (!Array.isArray(detectKeys)) {
    allowedKeys = [];
    console.warn("Keys should be array!");
  }
  allowedKeys = convertToAsciiEquivalent(allowedKeys);
  useEffect21(() => {
    var _a;
    const canUseDOM = !!(typeof window !== "undefined" && ((_a = window == null ? void 0 : window.document) == null ? void 0 : _a.createElement));
    if (!canUseDOM) {
      console.error("Window is not defined");
      return;
    }
    const handleEvent = (event) => {
      const asciiCode = getAsciiCode(event);
      return onKeyPress(asciiCode, callback, allowedKeys, event);
    };
    document.addEventListener(keyevent, handleEvent);
    return () => {
      document.removeEventListener(keyevent, handleEvent);
    };
  }, [allowedKeys, callback, dependencies, keyevent]);
};
var useKeyboard_default = useKeyboard;

// src/~react-hooks/useLogoutAll/useLogoutAll.ts
import { useMutation as useMutation9 } from "@apollo/client";
import { useCallback as useCallback31 } from "react";
var useLogoutAll = () => {
  const { logout: logout2 } = useSession_default();
  const mutation = useMutation9(GQL_ACCOUNT_AUTHORIZATION_LOGOUT_ALL_default);
  const [logoutAllMutation, other] = mutation;
  const logoutAll = useCallback31(() => {
    return logoutAllMutation({
      update: () => __async(void 0, null, function* () {
        yield logout2();
      })
    });
  }, [logoutAllMutation, logout2]);
  return [logoutAll, other];
};
var useLogoutAll_default = useLogoutAll;

// src/~react-hooks/useMenu/useMenu.ts
import { useMemo as useMemo23 } from "react";
var useMenu = ({ type: type2 }) => {
  const { device, locale } = useApp_default();
  const { isLoggedIn } = useSession_default();
  const menu = useMemo23(() => {
    const items = getItems({ type: type2, locale, device, isLoggedIn });
    return items;
  }, [device, type2, locale, isLoggedIn]);
  return { items: menu };
};

// src/~react-hooks/useMetaCollectionListPaginate/useMetaCollectionListPaginate.ts
import merge4 from "lodash/merge";
import { useCallback as useCallback32, useEffect as useEffect22, useRef as useRef7, useState as useState9 } from "react";
var useMetaCollectionListPaginate = (props) => {
  var _c, _d;
  const { locale } = useApp_default();
  const _a = props, { slug: slug3, page, take = 20, orderBy } = _a, opts = __objRest(_a, ["slug", "page", "take", "orderBy"]);
  const [loadingMore, setLoadingMore] = useState9(false);
  const previousResponseRef = useRef7(
    null
  );
  const variables = sanitizeObject({
    slug: slug3,
    locale,
    page,
    take,
    orderBy
  });
  const _b = useQuery_default(
    GQL_GET_META_COLLECTION_default,
    __spreadProps(__spreadValues({
      variables
    }, opts), {
      skip: false
    })
  ), {
    data,
    loading,
    error,
    networkStatus,
    fetchMore: fetchMoreQuery
  } = _b, other = __objRest(_b, [
    "data",
    "loading",
    "error",
    "networkStatus",
    "fetchMore"
  ]);
  const response = (_c = data == null ? void 0 : data.response) != null ? _c : null;
  const currentPage = (_d = response == null ? void 0 : response.page) != null ? _d : 0;
  const [forceReachedEnd, setForceReachedEnd] = useState9(false);
  const reachedEnd = forceReachedEnd || ((response == null ? void 0 : response.items) ? response.items.length >= response.totalCount : null);
  const fetchMore = useCallback32(() => __async(void 0, null, function* () {
    if (reachedEnd || loadingMore)
      return;
    setLoadingMore(true);
    try {
      yield fetchMoreQuery({
        variables: {
          page: currentPage + 1
        },
        updateQuery: (prevResult, { fetchMoreResult }) => {
          var _a2, _b2, _c2, _d2, _e;
          if (!fetchMoreResult || !fetchMoreResult.response)
            return prevResult;
          const fetchedItems = (_b2 = (_a2 = fetchMoreResult == null ? void 0 : fetchMoreResult.response) == null ? void 0 : _a2.items) != null ? _b2 : [];
          if (fetchedItems.length === 0) {
            setForceReachedEnd(true);
          }
          const prevResItems = (_d2 = (_c2 = prevResult.response) == null ? void 0 : _c2.items) != null ? _d2 : [];
          return merge4({}, prevResult, __spreadProps(__spreadValues({}, fetchMoreResult), {
            response: __spreadProps(__spreadValues({}, fetchMoreResult.response), {
              items: [
                ...prevResItems,
                ...(_e = fetchMoreResult.response.items) != null ? _e : []
              ].filter(exists)
            })
          }));
        }
      });
    } catch (error2) {
      console.error(error2);
      setForceReachedEnd(true);
    } finally {
      setLoadingMore(false);
    }
  }), [reachedEnd, loadingMore, fetchMoreQuery, currentPage]);
  useEffect22(() => {
    if (!response)
      return;
    previousResponseRef.current = response;
  }, [response]);
  const responseData = response != null ? response : previousResponseRef.current;
  return __spreadProps(__spreadValues({}, other), {
    loading,
    loadingMore,
    reachedEnd,
    page: currentPage,
    error,
    fetchMore,
    networkStatus,
    refetching: networkStatus === 4,
    response: responseData
  });
};
var useMetaCollectionListPaginate_default = useMetaCollectionListPaginate;

// src/~react-hooks/useMountEffect/useMountEffect.ts
import { useEffect as useEffect23, useRef as useRef8 } from "react";
function useMountEffect(effectFunction) {
  const hasRun = useRef8(false);
  useEffect23(() => {
    if (hasRun.current)
      return;
    hasRun.current = true;
    effectFunction();
  }, [effectFunction]);
}

// src/~react-hooks/useMux/useMux.ts
import { useEffect as useEffect24, useMemo as useMemo24, useRef as useRef9, useState as useState10 } from "react";
var isValidKey = (key3) => {
  if (!key3)
    return false;
  if (key3 === "false")
    return false;
  if (key3.length < 10)
    return false;
  return true;
};
var useMux = ({
  timeoutAfterMs = 4e3,
  slug: slug3,
  overrideDeviceCategory,
  overrideDeviceManufacturer,
  overrideDeviceName,
  overrideOsVersion,
  playerVersion,
  viewSessionId,
  videoCdn,
  appVersion,
  drm,
  profileName,
  disableMux = false
}) => {
  var _a;
  const accountId = (_a = useSession_default().auth) == null ? void 0 : _a.accountId;
  const { response: media, error: mediaError } = useMedia_default({ slug: slug3 });
  const {
    configs: { MUX_KEY },
    device,
    brand,
    locale
  } = useApp_default();
  const [hasTimedOut, setHasTimedOut] = useState10(false);
  const timeoutRef = useRef9(null);
  const isMuxEnabled = !disableMux;
  useEffect24(() => {
    if (!isMuxEnabled)
      return;
    timeoutRef.current = setTimeout(() => setHasTimedOut(true), timeoutAfterMs);
    return () => {
      if (timeoutRef.current !== null) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [isMuxEnabled, timeoutAfterMs]);
  const subPropertyId = `${device.type} ${appVersion}`;
  const muxData = useMemo24(() => {
    if (!isMuxEnabled)
      return null;
    if (isPlayableMedia(media) && MUX_KEY && isValidKey(MUX_KEY)) {
      return getMuxData({
        overrideDeviceCategory,
        overrideDeviceManufacturer,
        overrideDeviceName,
        overrideOsVersion,
        playerVersion,
        subPropertyId,
        viewSessionId,
        videoCdn,
        initTime: Date.now(),
        accountId,
        playable: media,
        muxKey: MUX_KEY,
        device,
        brand,
        appVersion,
        locale,
        drm,
        profileName
      });
    }
    return null;
  }, [
    isMuxEnabled,
    media,
    MUX_KEY,
    overrideDeviceCategory,
    overrideDeviceManufacturer,
    overrideDeviceName,
    overrideOsVersion,
    playerVersion,
    subPropertyId,
    viewSessionId,
    videoCdn,
    accountId,
    device,
    brand,
    appVersion,
    locale,
    drm,
    profileName
  ]);
  useEffect24(() => {
    if (muxData && timeoutRef.current !== null) {
      clearTimeout(timeoutRef.current);
    }
  }, [muxData]);
  if (!isMuxEnabled) {
    return {
      loading: false,
      error: false,
      data: void 0
    };
  }
  const error = !!mediaError || hasTimedOut;
  const loading = !error && muxData === null;
  const data = muxData != null ? muxData : void 0;
  return { loading, error, data };
};

// src/~react-hooks/useNextActions/useNextActions.ts
import { useMemo as useMemo25 } from "react";
var useNextActions = (props, options) => {
  var _a;
  const { locale } = useApp_default();
  const { context, slug: slug3, take } = props;
  const { data, loading, refetch } = useQuery_default(GQL_NEXT_ACTIONS_default, __spreadValues({
    variables: { context, take, slug: slug3, locale }
  }, options));
  const nextActionItems = (_a = data == null ? void 0 : data.nextActions) == null ? void 0 : _a.items;
  const nextActions = useMemo25(() => nextActionItems != null ? nextActionItems : [], [nextActionItems]);
  return {
    loading,
    nextActions,
    refetch
  };
};

// src/~react-hooks/useNextEpisode/useNextEpisode.ts
var useNextEpisode = ({ seriesSlug }) => {
  const { isLoggedIn } = useSession_default();
  const { locale } = useApp_default();
  const _a = useQuery_default(GQL_GET_NEXT_EPISODE_default, {
    skip: !isLoggedIn,
    variables: {
      seriesSlug,
      locale
    }
  }), { data } = _a, other = __objRest(_a, ["data"]);
  return __spreadProps(__spreadValues({}, other), {
    response: data == null ? void 0 : data.response
  });
};
var useNextEpisode_default = useNextEpisode;

// src/~react-hooks/useNotificationActions/useNotificationActions.ts
import { useApolloClient as useApolloClient7 } from "@apollo/client";
import { useCallback as useCallback33 } from "react";
var useNotificationActions = () => {
  const { storage: storage2 } = useApp_default();
  const client = useApolloClient7();
  const addToken = useCallback33(
    (variables) => __async(void 0, null, function* () {
      return yield addNotificationToken(__spreadProps(__spreadValues({}, variables), { storage: storage2, client }));
    }),
    [client, storage2]
  );
  const clearLastSentToken = useCallback33(() => {
    return clearLastSentNotificationToken(storage2);
  }, [storage2]);
  return {
    addToken,
    clearLastSentToken
  };
};

// src/~react-hooks/useOfflineQueue/useOfflineQueue.ts
import { useContext as useContext13 } from "react";

// src/~react-common/contexts/OfflineContext/OfflineQueueContext.tsx
import {
  useRef as useRef10,
  useCallback as useCallback34,
  useEffect as useEffect25,
  useMemo as useMemo26,
  createContext as createContext9
} from "react";
import { jsx as jsx11 } from "react/jsx-runtime";
var OfflineQueueContext = createContext9({
  pushEvent: () => {
    console.warn(
      "[OfflineQueueContext] Warning, tried to use offline queue without OfflineQueueContext setup properly."
    );
  }
});
var OfflineQueueContextProvider = ({
  children,
  handleItem,
  storage: storage2,
  flushQueueScheduler
}) => {
  const queue = useRef10([]);
  const { offline } = useIsOffline_default();
  const offlineRef = useRef10(offline);
  const persistQueue = useCallback34(() => {
    storage2.set(
      "shapeshifter-core/QUEUED_OFFLINE_EVENTS" /* QUEUED_OFFLINE_EVENTS */,
      queue.current
    );
  }, [storage2]);
  const flushQueue = useCallback34(() => {
    if (queue.current.length > 0) {
      queue.current.forEach((event) => {
        handleItem(event);
      });
      queue.current = [];
      persistQueue();
    }
  }, [handleItem, persistQueue]);
  useEffect25(() => {
    offlineRef.current = offline;
    if (!offlineRef.current) {
      if (flushQueueScheduler) {
        flushQueueScheduler(flushQueue);
      } else {
        flushQueue();
      }
    }
  }, [offline, flushQueue, flushQueueScheduler]);
  useEffect25(() => {
    (() => __async(void 0, null, function* () {
      const savedEvents = yield storage2.get(
        "shapeshifter-core/QUEUED_OFFLINE_EVENTS" /* QUEUED_OFFLINE_EVENTS */
      );
      if (savedEvents) {
        queue.current = [...savedEvents, ...queue.current];
        if (!offlineRef.current && queue.current.length > 0) {
          flushQueue();
        }
      }
    }))();
  }, [flushQueue, storage2]);
  const pushEvent = useCallback34(
    (item) => {
      if (offlineRef.current) {
        queue.current.push(item);
        persistQueue();
      } else {
        handleItem(item);
      }
    },
    [handleItem, persistQueue]
  );
  const ctx = useMemo26(
    () => ({
      pushEvent
    }),
    [pushEvent]
  );
  return /* @__PURE__ */ jsx11(OfflineQueueContext.Provider, { value: ctx, children });
};

// src/~react-hooks/useOfflineQueue/useOfflineQueue.ts
var useOfflineQueue_default = () => useContext13(OfflineQueueContext);

// src/~react-hooks/usePlayableMetadata/usePlayableMetadata.ts
var usePlayableMetadata = (_a) => {
  var _b = _a, {
    slug: slug3
  } = _b, opts = __objRest(_b, [
    "slug"
  ]);
  const { locale } = useApp_default();
  const _a2 = useQuery_default(GQL_PLAYABLE_METADATA_default, __spreadValues({
    variables: { slug: slug3, locale }
  }, opts)), { data } = _a2, other = __objRest(_a2, ["data"]);
  return __spreadProps(__spreadValues({}, other), {
    response: data == null ? void 0 : data.response
  });
};

// src/~react-hooks/usePrevious/usePrevious.ts
import { useRef as useRef11, useEffect as useEffect26 } from "react";
function usePrevious(value) {
  const ref = useRef11();
  useEffect26(() => {
    ref.current = value;
  });
  return ref.current;
}

// src/~react-hooks/usePrismicPage/usePrismicPage.ts
var usePrismicPage = ({ slug: slug3 }) => {
  const { locale } = useApp_default();
  const { data, loading } = useQuery_default(GQL_GET_PRISMIC_PAGE_default, {
    variables: { slug: slug3, locale }
  });
  return {
    response: data == null ? void 0 : data.response,
    loading
  };
};
var usePrismicPage_default = usePrismicPage;

// src/~react-hooks/useRecommendations/useRecommendations.ts
var useRecommendations = ({ source, skip }) => {
  var _b;
  const { isLoggedIn } = useSession_default();
  const { locale } = useApp_default();
  const _a = useQuery_default(
    GQL_GET_RECOMMENDATIONS_default,
    {
      skip: !isLoggedIn || skip,
      variables: {
        locale,
        type: toRecommendationsType(source)
      }
    }
  ), { data } = _a, other = __objRest(_a, ["data"]);
  const recommendations = (_b = data == null ? void 0 : data.response) != null ? _b : [];
  return __spreadProps(__spreadValues({}, other), {
    response: recommendations
  });
};
var useRecommendations_default = useRecommendations;

// src/~react-hooks/useRemoteAuthentication/useRemoteAuthentication.ts
import { useMutation as useMutation10, useSubscription as useSubscription4 } from "@apollo/client";
import { useCallback as useCallback35, useEffect as useEffect27, useState as useState11 } from "react";
var defaultPollInterval = 5e3;
var useRemoteAuthentication = () => {
  var _a;
  const { locale } = useApp_default();
  const [error, setError] = useState11(null);
  const [loading, setLoading] = useState11(false);
  const [response, setResponse] = useState11();
  const { createAdditionalToken, finalizeLogin } = useSession_default();
  const [createMutation] = useMutation10(GQL_CREATE_REMOTE_AUTHENTICATION_default);
  const [updateMutation] = useMutation10(GQL_UPDATE_REMOTE_AUTHENTICATION_default);
  const { fetch: fetch2 } = useQuery_default(GQL_GET_REMOTE_AUTHENTICATION_default, {
    skip: true
  });
  const accessCode = (_a = response == null ? void 0 : response.accessCode) != null ? _a : ``;
  useSubscription4(GQL_UPDATED_REMOTE_AUTHENTICATION_SUBSCRIPTION_default, {
    variables: { locale, accessCode },
    skip: accessCode.length < 4,
    onData: (d) => {
      var _a2, _b;
      if ((_a2 = d.data.data) == null ? void 0 : _a2.response) {
        setResponse((_b = d.data.data) == null ? void 0 : _b.response);
      }
      if (d.data.error) {
        setError(unknownError);
      }
    }
  });
  useEffect27(() => {
    if (!response)
      return;
    if (response.expiresAt) {
      const isExpired = /* @__PURE__ */ new Date() > new Date(response.expiresAt);
      if (isExpired) {
        setError({
          titleKey: "auth.access_code_expired_title",
          textKey: "auth.access_code_expired_text"
        });
        return;
      }
    }
    if (response.status === "ERROR" /* ERROR */) {
      setError(unknownError);
    }
  }, [response]);
  const create = useCallback35(
    (input) => __async(void 0, null, function* () {
      setError(null);
      setResponse(void 0);
      try {
        const { data } = yield createMutation({
          variables: { locale, input }
        });
        setResponse(data == null ? void 0 : data.response);
      } catch (e) {
        setError(unknownError);
      }
    }),
    [createMutation, locale]
  );
  const update = useCallback35(() => __async(void 0, null, function* () {
    setError(null);
    try {
      yield updateMutation({ variables: { input: { accessCode }, locale } });
    } catch (e) {
      setError(unknownError);
    }
  }), [accessCode, locale, updateMutation]);
  const fetchAccessCode = useCallback35(
    (accessCode2) => __async(void 0, null, function* () {
      try {
        const response2 = yield fetch2({
          variables: { locale, accessCode: accessCode2 },
          fetchPolicy: "network-only"
        });
        setResponse(response2.response);
      } catch (e) {
        setError(unknownError);
      } finally {
        setLoading(false);
      }
    }),
    [fetch2, locale]
  );
  const updateAccessCode = useCallback35(
    (accessCode2) => __async(void 0, null, function* () {
      setResponse(void 0);
      setError(null);
      setLoading(true);
      yield fetchAccessCode(accessCode2);
    }),
    [fetchAccessCode]
  );
  const loginWithToken = useCallback35(
    (..._0) => __async(void 0, [..._0], function* ({
      onBeforeLoginSuccess = () => Promise.resolve()
    } = {}) {
      var _a2;
      try {
        setError(null);
        const token = response == null ? void 0 : response.token;
        if (!token)
          return;
        const auth = yield createAdditionalToken({ token });
        if (!((_a2 = auth.data) == null ? void 0 : _a2.response))
          return;
        yield finalizeLogin({
          auth: auth.data.response,
          onBeforeLoginSuccess,
          type: "remote",
          newAccountCreated: false
        });
      } catch (e) {
        setError(unknownError);
      }
    }),
    [createAdditionalToken, finalizeLogin, response == null ? void 0 : response.token]
  );
  const startPolling = useCallback35(() => {
    let timeout;
    let canceled = false;
    function fetchAfterDelay() {
      if (timeout) {
        clearTimeout(timeout);
      }
      timeout = setTimeout(() => __async(this, null, function* () {
        yield fetchAccessCode(accessCode);
        if (!canceled)
          fetchAfterDelay();
      }), defaultPollInterval);
    }
    fetchAfterDelay();
    return () => {
      canceled = true;
      clearTimeout(timeout);
    };
  }, [accessCode, fetchAccessCode]);
  useEffect27(() => {
    const shouldPoll = (() => {
      if (!accessCode)
        return false;
      if (error)
        return false;
      if ((response == null ? void 0 : response.status) === "COMPLETED" /* COMPLETED */) {
        return false;
      }
      if ((response == null ? void 0 : response.status) === "ERROR" /* ERROR */) {
        return false;
      }
      return true;
    })();
    if (!shouldPoll)
      return;
    const stopPolling = startPolling();
    return () => stopPolling();
  }, [accessCode, error, response == null ? void 0 : response.status, startPolling]);
  return {
    response,
    loading,
    create,
    update,
    updateAccessCode,
    loginWithToken,
    error
  };
};
var unknownError = {
  titleKey: "error.app.500.title",
  textKey: "error.app.something_went_wrong"
};
var useRemoteAuthentication_default = useRemoteAuthentication;

// src/~react-hooks/useRemoteCheckout/useRemoteCheckout.tsx
import {
  createContext as createContext10,
  useCallback as useCallback36,
  useContext as useContext14,
  useEffect as useEffect28,
  useMemo as useMemo27,
  useState as useState12
} from "react";

// src/~react-hooks/useRemoteCheckout/types.ts
var RemoteCheckoutStep = /* @__PURE__ */ ((RemoteCheckoutStep2) => {
  RemoteCheckoutStep2["initializing"] = "initializing";
  RemoteCheckoutStep2["settingsStep"] = "settingsStep";
  RemoteCheckoutStep2["remotePayStep"] = "remotePayStep";
  RemoteCheckoutStep2["errorStep"] = "errorStep";
  RemoteCheckoutStep2["remoteConfirmStep"] = "remoteConfirmStep";
  RemoteCheckoutStep2["receiptStep"] = "receiptStep";
  return RemoteCheckoutStep2;
})(RemoteCheckoutStep || {});

// src/~react-hooks/useRemoteCheckout/useRemoteCheckout.tsx
import { jsx as jsx12 } from "react/jsx-runtime";
var RemoteCheckoutContext = createContext10({});
var RemoteCheckoutContextProvider = ({ children, onDismiss, slug: slug3 }) => {
  return /* @__PURE__ */ jsx12(CheckoutContextProvider, { slug: slug3, children: /* @__PURE__ */ jsx12(RemoteCheckoutProvider, { onDismiss, children }) });
};
var RemoteCheckoutProvider = ({ children, onDismiss = () => {
} }) => {
  const {
    error,
    price,
    purchaseTypes,
    paymentMethods,
    status,
    setPaymentMethod,
    setPurchaseType,
    confirmOptions,
    payQrUrl,
    payUrl,
    accessCode,
    creatingTransaction,
    selectedPaymentMethod,
    confirmingOptions,
    trackingPayload,
    transactionId,
    errorText,
    errorTitle,
    audioLanguagesString,
    subtitleLanguagesString
  } = useCheckout();
  const [step, setStep] = useState12(
    "initializing" /* initializing */
  );
  const { nextCard, savedCards, selectedCard } = useSavedCardCycler(paymentMethods);
  const hasSavedCard = savedCards.length > 0;
  const directRentType = useMemo27(
    () => {
      var _a;
      return (_a = purchaseTypes == null ? void 0 : purchaseTypes.find((t) => t.type === "tvod" /* tvod */)) != null ? _a : void 0;
    },
    [purchaseTypes]
  );
  const directBuyType = useMemo27(
    () => {
      var _a;
      return (_a = purchaseTypes == null ? void 0 : purchaseTypes.find((t) => t.type === "est" /* est */)) != null ? _a : void 0;
    },
    [purchaseTypes]
  );
  const directPurchaseTypes = useMemo27(
    () => ({
      est: directBuyType,
      tvod: directRentType,
      svod: void 0
    }),
    [directBuyType, directRentType]
  );
  useEffect28(() => {
    if (error) {
      setStep("errorStep" /* errorStep */);
      return;
    }
    if (!status)
      return;
    switch (status) {
      case "paid" /* paid */: {
        setStep("receiptStep" /* receiptStep */);
        return;
      }
      case "initialized" /* initialized */: {
        setStep("settingsStep" /* settingsStep */);
        return;
      }
      case "awaitingConfirmation" /* awaitingConfirmation */:
      case "pending" /* pending */: {
        setStep(
          hasSavedCard ? "remoteConfirmStep" /* remoteConfirmStep */ : "remotePayStep" /* remotePayStep */
        );
        return;
      }
      default: {
        setStep("errorStep" /* errorStep */);
        return;
      }
    }
  }, [error, hasSavedCard, status]);
  const handleDirectPurchase = useCallback36(
    (purchaseType) => {
      function doDirectPurchase() {
        return __async(this, null, function* () {
          if (!selectedCard)
            return;
          const directPurchaseType = directPurchaseTypes[purchaseType];
          if (!directPurchaseType)
            return;
          if (price !== 0) {
            yield setPaymentMethod(selectedCard.methodId);
            yield setPurchaseType(directPurchaseType.id);
          }
          confirmOptions();
        });
      }
      return doDirectPurchase();
    },
    [
      confirmOptions,
      directPurchaseTypes,
      price,
      selectedCard,
      setPaymentMethod,
      setPurchaseType
    ]
  );
  const handleRemotePurchase = useCallback36(() => {
    setStep("remotePayStep" /* remotePayStep */);
  }, []);
  const handleBack = useCallback36(() => {
    if (step === "remotePayStep" /* remotePayStep */) {
      setStep("settingsStep" /* settingsStep */);
      return;
    }
    onDismiss({ step });
  }, [onDismiss, step]);
  return /* @__PURE__ */ jsx12(
    RemoteCheckoutContext.Provider,
    {
      value: {
        error,
        purchaseTypes,
        status,
        step,
        directPurchase: handleDirectPurchase,
        remotePurchase: handleRemotePurchase,
        directRentType,
        directBuyType,
        goBack: handleBack,
        nextCard,
        savedCards,
        selectedCard,
        payQrUrl,
        payUrl,
        accessCode,
        creatingTransaction,
        selectedPaymentMethod,
        confirmingOptions,
        trackingPayload,
        transactionId,
        errorTitle,
        errorText,
        audioLanguagesString,
        subtitleLanguagesString
      },
      children
    }
  );
};
var useSavedCardCycler = (paymentMethods) => {
  var _a;
  const savedCards = useMemo27(
    () => {
      var _a2;
      return (_a2 = paymentMethods == null ? void 0 : paymentMethods.filter((m) => m.method === "savedCreditCard")) != null ? _a2 : [];
    },
    [paymentMethods]
  );
  const [selectedCardIndex, setSelectedCardIndex] = useState12(0);
  const selectedCard = (_a = savedCards[selectedCardIndex]) != null ? _a : null;
  const nextCard = useCallback36(() => {
    if (savedCards.length < 2)
      return;
    setSelectedCardIndex((i) => (i + 1) % savedCards.length);
  }, [savedCards]);
  return { savedCards, selectedCard, nextCard };
};
var useRemoteCheckout = () => {
  return useContext14(RemoteCheckoutContext);
};

// src/~react-hooks/useSavedSearchTitle/useSavedSearchTitle.ts
import { useMutation as useMutation11 } from "@apollo/client";
import { useCallback as useCallback37, useRef as useRef12 } from "react";
var type = "singletitle" /* singletitle */;
var useSavedSearchTitle = (_a) => {
  var _b = _a, { slug: slug3 } = _b, opts = __objRest(_b, ["slug"]);
  var _b2, _c, _d, _e;
  const { isLoggedIn } = useSession_default();
  const { locale } = useApp_default();
  const isChanging = useRef12(false);
  const _a2 = useQuery_default(GQL_GET_SAVED_SEARCH_default, __spreadValues({
    variables: { type },
    skip: !isLoggedIn || opts.skip
  }, opts)), { data, loading, error, networkStatus } = _a2, other = __objRest(_a2, ["data", "loading", "error", "networkStatus"]);
  const isSaved = (_c = (_b2 = data == null ? void 0 : data.response) == null ? void 0 : _b2.some((s) => s.slug == slug3)) != null ? _c : false;
  const id = (_e = (_d = data == null ? void 0 : data.response) == null ? void 0 : _d.find((s) => s.slug == slug3)) == null ? void 0 : _e.id;
  const [createMutation, createTuple] = useMutation11(GQL_CREATE_SAVED_SEARCH_default, {
    optimisticResponse: {
      response: {
        __typename: "SingleTitleSavedSearch",
        id: slug3 != null ? slug3 : String((/* @__PURE__ */ new Date()).getTime()),
        locale,
        slug: slug3 != null ? slug3 : "",
        item: null
      }
    },
    update: (cache, { data: data2 }) => {
      const cacheData = cache.readQuery({
        query: GQL_GET_SAVED_SEARCH_default,
        variables: { type }
      });
      if (!(data2 == null ? void 0 : data2.response) || !cacheData) {
        return;
      }
      cache.writeQuery({
        query: GQL_GET_SAVED_SEARCH_default,
        variables: { type },
        data: { response: [...cacheData.response || [], data2 == null ? void 0 : data2.response] }
      });
    }
  });
  const [removeMutation, removeTuple] = useMutation11(GQL_DELETE_SAVED_SEARCH_default, {
    optimisticResponse: {
      response: {
        id: id != null ? id : "",
        locale,
        __typename: "DeletedSavedSearch"
      }
    },
    update: (cache) => {
      const cacheData = cache.readQuery({
        query: GQL_GET_SAVED_SEARCH_default,
        variables: { type }
      });
      if (!(cacheData == null ? void 0 : cacheData.response)) {
        return;
      }
      cache.writeQuery({
        query: GQL_GET_SAVED_SEARCH_default,
        variables: { type },
        data: { response: cacheData.response.filter((s) => s && s.id !== id) }
      });
    }
  });
  const toggle = useCallback37(() => __async(void 0, null, function* () {
    if (!slug3)
      return;
    if (isChanging.current)
      return;
    isChanging.current = true;
    try {
      if (!isSaved) {
        yield createMutation({
          variables: {
            locale,
            type: "singletitle" /* singletitle */,
            input: {
              slug: slug3
            }
          }
        });
      } else {
        if (id) {
          yield removeMutation({
            variables: { locale, id: String(id) }
          });
        }
      }
    } finally {
      isChanging.current = false;
    }
  }), [createMutation, id, isSaved, locale, removeMutation, slug3]);
  return __spreadValues({
    isSaved,
    toggle,
    response: data == null ? void 0 : data.response,
    data,
    loading,
    refetching: networkStatus === 4,
    networkStatus,
    error,
    remove: [removeMutation, removeTuple],
    create: [createMutation, createTuple]
  }, other);
};
var useSavedSearchTitle_default = useSavedSearchTitle;

// src/~react-hooks/useTags/useTags.ts
import { useCallback as useCallback38, useMemo as useMemo28 } from "react";

// src/~react-hooks/useTags/tagUtils.ts
var createBookmarkTag = (params) => {
  var _a;
  if (!((_a = params.bookmark) == null ? void 0 : _a.time))
    return null;
  const { bookmark } = params;
  return {
    __typename: "Tag",
    id: bookmark.id,
    priority: 0,
    name: "BookmarkDisplayTag",
    zones: [
      {
        __typename: "TagZoneCard",
        groupCard: "BOTTOM" /* BOTTOM */,
        context: "CARD" /* CARD */
      }
    ],
    display: {
      __typename: "BookmarkDisplayTag",
      appearance: "CUSTOM" /* CUSTOM */,
      time: bookmark.time,
      duration: bookmark.duration,
      percentage: bookmark.percentage,
      started: bookmark.started,
      completed: bookmark.completed
    }
  };
};

// src/~react-hooks/useTags/useTags.ts
var getDisplayTags = (params) => {
  if (!(params == null ? void 0 : params.tags))
    return [];
  const { tags } = params;
  const displayTags = tags.map((tag) => tag.display);
  const hasEntitlement = tags.some(
    (tag) => tag.display.__typename === "RentedDisplayTag" || tag.display.__typename === "BoughtDisplayTag"
  );
  return displayTags.filter((tag) => {
    if (hasEntitlement) {
      return ![
        "PriceReducedTagDisplay",
        "ReleaseDateTagDisplay",
        "PurchasableMediaDisplay",
        "MediaUnavailableDisplay"
      ].includes(tag.__typename);
    }
    return true;
  });
};
var useTags = (props) => {
  const { extra: extraTags, slug: slug3 } = props;
  const { response } = useMedia_default({
    slug: slug3,
    fetchPolicy: "cache-only",
    returnPartialData: true
  });
  const { bookmark } = useBookmark({ slug: slug3 });
  const tags = useMemo28(() => {
    var _a;
    const allTags = [...(_a = response == null ? void 0 : response.tags) != null ? _a : [], ...extraTags != null ? extraTags : []].reduce(
      (acc, tag) => {
        if (!acc.some((t) => t.id === tag.id)) {
          return [...acc, tag];
        }
        return acc;
      },
      []
    );
    if (!allTags)
      return [];
    const bookmarkTag = createBookmarkTag({ bookmark });
    if (!bookmarkTag) {
      return allTags;
    }
    return [...allTags, bookmarkTag].filter(Boolean);
  }, [response, extraTags, bookmark]);
  const hasTag = useCallback38(
    (type2) => tags.some((tag) => tag.display.__typename === type2),
    [tags]
  );
  const hasAnyOfTags = useCallback38(
    (types) => tags.some((tag) => types.includes(tag.display.__typename)),
    [tags]
  );
  const getTags = useCallback38(
    (params) => {
      var _a;
      const exclude = (_a = params == null ? void 0 : params.exclude) != null ? _a : [];
      const context = params == null ? void 0 : params.context;
      const limit = params == null ? void 0 : params.limit;
      const filteredTags = getDisplayTags({
        tags: tags.filter((tag) => {
          if ((tag == null ? void 0 : tag.zones) && context) {
            return tag.zones.some((zone) => zone.context === context);
          }
          return true;
        }).filter((tag) => {
          if (exclude.length > 0) {
            return !exclude.includes(tag.display.__typename);
          }
          return true;
        })
      });
      if (limit) {
        return filteredTags.slice(0, limit);
      }
      return filteredTags;
    },
    [tags]
  );
  return {
    hasTag,
    hasAnyOfTags,
    getTags
  };
};

// src/~react-hooks/useTheme/useTheme.ts
import { useTheme as useScTheme } from "styled-components";
var useTheme = () => {
  const theme = useScTheme();
  return { theme };
};
var useTheme_default = useTheme;

// src/~react-hooks/useTimeout/useTimeout.ts
import { useState as useState13, useRef as useRef13, useEffect as useEffect29 } from "react";
function useTimeout(cb, timeoutDelayMs = 0) {
  const [isTimeoutActive, setIsTimeoutActive] = useState13(false);
  const savedRefCallback = useRef13();
  useEffect29(() => {
    savedRefCallback.current = cb;
  }, [cb]);
  function clear() {
    setIsTimeoutActive(false);
  }
  function start() {
    setIsTimeoutActive(true);
  }
  useEffect29(() => {
    const callback = () => {
      savedRefCallback.current && savedRefCallback.current();
      clear();
    };
    if (isTimeoutActive) {
      const timeout = setTimeout(callback, timeoutDelayMs);
      return () => {
        clearTimeout(timeout);
      };
    }
    return () => {
    };
  }, [isTimeoutActive, timeoutDelayMs]);
  return {
    clear,
    start,
    stop: clear,
    isActive: isTimeoutActive
  };
}
var useTimeout_default = useTimeout;

// src/~react-hooks/useUpdateAccount/useUpdateAccount.ts
import { useMutation as useMutation12 } from "@apollo/client";
import { useCallback as useCallback39 } from "react";
function useUpdateAccount(_a = {}) {
  var opts = __objRest(_a, []);
  const [updateEmailMutation, other] = useMutation12(GQL_UPDATE_ACCOUNT_INFORMATION_default, opts);
  const updatePassword = useCallback39(
    (input) => {
      return updateEmailMutation({
        variables: {
          input
        }
      });
    },
    [updateEmailMutation]
  );
  return [updatePassword, other];
}

// src/~react-hooks/useUpdateAccountPaymentMethods/useUpdateAccountPaymentMethods.ts
import { useMutation as useMutation13 } from "@apollo/client";
import { useCallback as useCallback40 } from "react";
var useUpdateAccountPaymentMethods = () => {
  const [initUpdate, { loading: isInitializing, error: initError }] = useMutation13(
    GQL_INIT_UPDATE_ACCOUNT_PAYMENT_METHODS_default
  );
  const [updatePaymentMethods, { loading: isUpdating, error: updateError }] = useMutation13(GQL_UPDATE_PAYMENT_METHODS_default);
  const init = useCallback40(() => __async(void 0, null, function* () {
    var _a;
    const res = yield initUpdate();
    return (_a = res.data) == null ? void 0 : _a.response;
  }), [initUpdate]);
  const update = useCallback40(
    (input) => __async(void 0, null, function* () {
      var _a;
      const res = yield updatePaymentMethods({
        variables: { input }
      });
      return (_a = res.data) == null ? void 0 : _a.response;
    }),
    [updatePaymentMethods]
  );
  return { init, update, isUpdating, isInitializing, initError, updateError };
};

// src/~react-hooks/useUpdateEmail/useUpdateEmail.ts
import { useMutation as useMutation14 } from "@apollo/client";
import get4 from "lodash/get";
import { useCallback as useCallback41 } from "react";
function useUpdateEmail(_a = {}) {
  var opts = __objRest(_a, []);
  const { response } = useAccount_default();
  const [updateEmailMutation, other] = useMutation14(GQL_UPDATE_ACCOUNT_EMAIL_default, opts);
  const updatePassword = useCallback41(
    ({ newEmail, password }) => {
      return updateEmailMutation({
        variables: {
          input: {
            newEmail,
            password,
            username: get4(response, "email", "")
          }
        }
      });
    },
    [updateEmailMutation, response]
  );
  return [updatePassword, other];
}

// src/~react-hooks/useUpdatePassword/useUpdatePassword.ts
import { useMutation as useMutation15 } from "@apollo/client";
import get5 from "lodash/get";
import { useCallback as useCallback42 } from "react";
function useUpdatePassword(_a = {}) {
  var opts = __objRest(_a, []);
  const { response } = useAccount_default();
  const [updatePasswordMutation, other] = useMutation15(GQL_UPDATE_ACCOUNT_PASSWORD_default, opts);
  const updatePassword = useCallback42(
    ({ oldPassword, newPassword }) => {
      return updatePasswordMutation({
        variables: {
          input: {
            newPassword,
            password: oldPassword,
            username: get5(response, "email", "")
          }
        }
      });
    },
    [updatePasswordMutation, response]
  );
  return [updatePassword, other];
}

// src/~react-hooks/useVoucher/useVoucher.ts
import { useApolloClient as useApolloClient8 } from "@apollo/client";
import { useCallback as useCallback43, useEffect as useEffect30, useMemo as useMemo29, useRef as useRef14 } from "react";
import { atom as atom5, useAtom as useAtom3 } from "jotai";
var voucherStateAtom = atom5({
  loading: false,
  error: null,
  validCode: null,
  inputText: ""
});
var useVoucher = () => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const { t } = useL10n_default();
  const {
    slug: slug3,
    voucherCode: checkoutVoucherCode,
    isRemote,
    accessCode,
    selectedPurchaseType,
    productType,
    originalPrice,
    voucherLoading,
    setVoucherCode,
    clearVoucherCode,
    selectedPaymentMethod,
    addListener
  } = useCheckout();
  const { locale } = useApp_default();
  const client = useApolloClient8();
  const { canPlay } = useEntitlement_default({
    slug: slug3
  });
  const [state, setState] = useAtom3(voucherStateAtom);
  const codeRef = useRef14(state.inputText);
  const errorCode = (_e = (_d = (_c = (_b = (_a = state == null ? void 0 : state.error) == null ? void 0 : _a.graphQLErrors) == null ? void 0 : _b[0]) == null ? void 0 : _c.extensions) == null ? void 0 : _d.error) == null ? void 0 : _e.code;
  const detailedError = errorCode ? getErrorCodeLiterals({
    code: errorCode,
    scope: "voucher"
  }) : void 0;
  const percent = (_f = state.validCode) == null ? void 0 : _f.percentageDiscount;
  const description = (_g = state.validCode) == null ? void 0 : _g.description;
  const message = useMemo29(() => {
    if (detailedError) {
      return {
        text: t(detailedError.text),
        presentAs: "error"
      };
    }
    if (state.validCode) {
      return {
        text: t("checkout.value_code_applied_value", {
          percent,
          description
        }),
        presentAs: "success"
      };
    }
    return void 0;
  }, [description, detailedError, percent, state.validCode, t]);
  const loading = state.loading || voucherLoading;
  const canSubmit = canPlay || loading;
  const submit = useCallback43(
    (code) => __async(void 0, null, function* () {
      var _a2;
      try {
        const codeToSubmit = code != null ? code : codeRef.current;
        setState((s) => __spreadProps(__spreadValues({}, s), { inputText: codeToSubmit, loading: true }));
        codeRef.current = codeToSubmit;
        const res = yield client.query({
          query: GQL_GET_VOUCHER_default,
          variables: {
            locale,
            productType,
            code: codeToSubmit,
            purchaseType: selectedPurchaseType == null ? void 0 : selectedPurchaseType.type,
            accessCode: isRemote ? accessCode : void 0,
            slug: slug3,
            paymentMethod: selectedPaymentMethod == null ? void 0 : selectedPaymentMethod.method
          },
          fetchPolicy: "network-only"
        });
        setState((s) => {
          var _a3;
          return __spreadProps(__spreadValues({}, s), {
            loading: false,
            error: null,
            validCode: (_a3 = res.data.response) != null ? _a3 : null
          });
        });
        setVoucherCode((_a2 = res.data.response) == null ? void 0 : _a2.code);
      } catch (error) {
        setState((s) => __spreadProps(__spreadValues({}, s), {
          loading: false,
          error,
          validCode: null
        }));
        clearVoucherCode();
      }
    }),
    [
      accessCode,
      clearVoucherCode,
      client,
      isRemote,
      locale,
      productType,
      selectedPurchaseType == null ? void 0 : selectedPurchaseType.type,
      selectedPaymentMethod == null ? void 0 : selectedPaymentMethod.method,
      setVoucherCode,
      slug3,
      setState
    ]
  );
  const proceedable = useMemo29(() => {
    var _a2;
    const isVoucherValidForPurchase = checkoutVoucherCode || !!originalPrice;
    if (!state.inputText)
      return true;
    if (state.error)
      return false;
    if (!isVoucherValidForPurchase)
      return false;
    if (isSameCode(checkoutVoucherCode, (_a2 = state.validCode) == null ? void 0 : _a2.code))
      return true;
    return false;
  }, [
    checkoutVoucherCode,
    originalPrice,
    state.error,
    state.inputText,
    (_h = state.validCode) == null ? void 0 : _h.code
  ]);
  useEffect30(() => {
    if (!state.inputText)
      return;
    if (state.validCode)
      return;
    submit();
  }, []);
  useEffect30(
    () => (
      // Run a submit when user options change as we need to revalidate the voucher
      addListener("userOptionsChanged", () => {
        if (!state.inputText)
          return;
        submit();
      })
    ),
    [addListener, state.inputText, submit]
  );
  useEffect30(
    () => addListener("validVoucherCodeChanged", ({ voucherCode }) => {
      if (state.inputText === voucherCode)
        return;
      submit(voucherCode);
    }),
    [addListener, state.inputText, submit]
  );
  const setText = (text) => {
    const newCode = text.toUpperCase().replace(/\s*/g, "");
    codeRef.current = newCode;
    setState((s) => __spreadProps(__spreadValues({}, s), {
      inputText: newCode,
      error: null,
      validCode: null
    }));
  };
  return {
    inputText: state.inputText,
    loading,
    proceedable,
    canSubmit,
    message,
    setText,
    submit
  };
};
var isSameCode = (code1, code2) => {
  return (code1 == null ? void 0 : code1.toLowerCase().trim()) == (code2 == null ? void 0 : code2.toLowerCase().trim());
};

// src/~react-hooks/useVoucherOrder/useVoucherOrder.ts
import { useMutation as useMutation16 } from "@apollo/client";
import { useCallback as useCallback44, useEffect as useEffect31, useRef as useRef15, useState as useState14 } from "react";
var getVoucherOrderMetaData = ({
  title
}) => ({
  __typename: "Ticket",
  linkTarget: null,
  slug: "voucher-store",
  id: "voucher-store",
  display: {
    __typename: "Display",
    title,
    originalTitle: title,
    caption: null
  },
  tags: [],
  displayableAsset: {
    id: "DisplayableInCollectionWithCover:id",
    __typename: "DisplayableInCollectionWithCover",
    cover: "https://img-cdn.sfanytime.com/APP/VOUCHER-STORE_COVER_f689ea54a87327536d64b4febb9d32c72bdcc01f20f5f447a3c96aeb1e1d1635.jpg?w=375&ar=0.692&fit=crop&fm=pjpg&s=dff900e4c29d99fff7c216edcea03588"
  },
  mediaImages: [
    "https://img-cdn.sfanytime.com/APP/VOUCHER-STORE_MEDIAM_6bd1ce22928f7d0ac77e3edb05e8da196deeab52021f482da275d692936b723d.jpg?w=1125&fm=pjpg&s=9c21fe1075bddeba8d5c7663c1a75568"
  ]
});
var useVoucherOrder = (_a = {}) => {
  var _b = _a, {
    defaultEstValue,
    defaultTvodValue
  } = _b, rest = __objRest(_b, [
    "defaultEstValue",
    "defaultTvodValue"
  ]);
  const { isLoggedIn } = useSession_default();
  const { getString } = useL10n_default();
  const { locale } = useApp_default();
  const purchasable = getVoucherOrderMetaData({
    title: getString("checkout.voucher.title")
  });
  const [updateVoucher] = useMutation16(GQL_CREATE_VOUCHER_ORDER_default, rest);
  const submitted = useRef15(true);
  const [loading, setLoading] = useState14(true);
  const [est, setEst] = useState14(defaultEstValue != null ? defaultEstValue : 0);
  const [tvod, setTvod] = useState14(defaultTvodValue != null ? defaultTvodValue : 0);
  const [proceedToNext, setProceedToNext] = useState14(false);
  const [response, setResponse] = useState14(void 0);
  const submit = useCallback44(
    (input) => __async(void 0, null, function* () {
      var _a2;
      if (!isLoggedIn)
        return;
      try {
        if (submitted.current && input.proceedToNext)
          return;
        submitted.current = input.proceedToNext;
        setLoading(true);
        const request = yield updateVoucher({
          variables: {
            locale,
            input: {
              proceedToNext: input.proceedToNext,
              est,
              tvod
            }
          }
        });
        setResponse((_a2 = request.data) == null ? void 0 : _a2.response);
        return request;
      } catch (error) {
        submitted.current = false;
        throw error;
      } finally {
        setLoading(false);
      }
    }),
    [isLoggedIn, updateVoucher, est, tvod, locale]
  );
  useEffect31(() => {
    if (!isLoggedIn) {
      console.warn("User is not logged in");
      return;
    }
    const timeoutId = setTimeout(() => {
      submit({ proceedToNext: false });
    }, 50);
    return () => clearTimeout(timeoutId);
  }, [isLoggedIn, submit, est, tvod]);
  return {
    response,
    purchasable,
    submit,
    loading,
    est,
    setEst,
    tvod,
    setTvod,
    setProceedToNext,
    proceedToNext
  };
};

// src/~react-hooks/usePurchasable/usePurchasable.ts
var usePurchasable = (_a) => {
  var _b = _a, { slug: slug3 } = _b, opts = __objRest(_b, ["slug"]);
  var _a2;
  const { locale } = useApp_default();
  const { data, loading, error, refetch } = useQuery_default(GQL_GET_PURCHASABLE_default, __spreadProps(__spreadValues({
    skip: !slug3
  }, opts), {
    variables: { slug: slug3 != null ? slug3 : "", locale }
  }));
  return {
    error,
    loading,
    purchasable: (_a2 = data == null ? void 0 : data.purchasable) != null ? _a2 : null,
    refetch
  };
};

// src/~react-hooks/useTicket/useTicket.ts
var useTicket = (config) => {
  var _b;
  const _a = config, { skip, fetchPolicy, nextFetchPolicy } = _a, rest = __objRest(_a, ["skip", "fetchPolicy", "nextFetchPolicy"]);
  const { locale, device } = useApp_default();
  const hookOptions = useHookOptions();
  const variables = __spreadValues(__spreadValues({
    locale,
    device: { type: device.type, manufacturer: device.manufacturer }
  }, hookOptions == null ? void 0 : hookOptions.useTicket), rest);
  const { data, loading, error, refetch } = useQuery_default(GQL_GET_TICKET_default, {
    skip,
    fetchPolicy,
    nextFetchPolicy,
    variables
  });
  return {
    error,
    loading,
    ticket: (_b = data == null ? void 0 : data.ticket) != null ? _b : null,
    refetch
  };
};

// src/~react-hooks/useTickets/useTickets.ts
var useTickets = ({ variables, initialTake }) => {
  const { locale, device } = useApp_default();
  return useConnectionPagination({
    query: GQL_GET_TICKETS_default,
    variables: __spreadProps(__spreadValues({}, variables), {
      locale,
      device: { type: device.type, manufacturer: device.manufacturer },
      first: initialTake
    }),
    connectionAccessor: (data) => data.tickets
  });
};

// src/~react-hooks/useSearch/useSaved.ts
import capitalize2 from "lodash/capitalize";
import { useCallback as useCallback45, useEffect as useEffect32, useMemo as useMemo30, useState as useState15 } from "react";
var STORAGE_KEY = "savedSearches";
var MAX_STORED_SAVE_SEARCHES = 10;
var includePage = false;
var useSaved = ({
  urlState,
  state
}) => {
  const { storage: storage2 } = useApp_default();
  const { t } = useL10n_default();
  const [savedSearches, setSavedSearches] = useState15([]);
  const [loading, setLoading] = useState15(true);
  const { track } = useTracker_default();
  const getActiveFilters = useActiveFilters();
  useMountEffect(() => __async(void 0, null, function* () {
    const persisted = yield storage2.get(STORAGE_KEY);
    setSavedSearches(persisted != null ? persisted : []);
    setLoading(false);
  }));
  const urlString = useMemo30(
    () => urlState.toString({ includePage }),
    [urlState]
  );
  const urlVariables = useMemo30(
    () => urlState.getVariables({ includePage }),
    [urlState]
  );
  useEffect32(() => {
    storage2.set(STORAGE_KEY, savedSearches);
  }, [savedSearches, storage2]);
  const save = useCallback45(() => {
    setSavedSearches(
      (prev) => [...prev, urlString].slice(-MAX_STORED_SAVE_SEARCHES)
    );
    track("search/saveSearch", {
      search: urlVariables
    });
  }, [urlString, urlVariables, track]);
  const remove = useCallback45((search2) => {
    setSavedSearches((prev) => prev.filter((s) => s !== search2));
  }, []);
  const removeCurrent = useCallback45(
    () => remove(urlString),
    [remove, urlString]
  );
  const isSaved = savedSearches.includes(urlString);
  const button = useMemo30(() => {
    if (urlString === "")
      return;
    if (isSaved) {
      return {
        title: t("search.remove"),
        apply: removeCurrent,
        icon: "unpin"
      };
    }
    return {
      title: t("search.save"),
      apply: save,
      icon: "pin"
    };
  }, [isSaved, removeCurrent, save, t, urlString]);
  const getLabel = useCallback45(
    (search2) => {
      const params = toSearchQueryParams(search2);
      const { myContent, query, userFilters } = getFilters(params);
      const titles = [];
      if (query) {
        titles.push(capitalize2(query));
      }
      titles.push(
        ...getActiveFilters({ myContent, userFilters, state }).map(
          (t2) => t2.label
        )
      );
      return titles.reduce(
        (acc, title, index, array) => `${acc}${index === array.length - 1 ? " &" : ","} ${title}`
      );
    },
    [getActiveFilters, state]
  );
  const items = useMemo30(
    () => savedSearches.map((search2) => ({
      label: getLabel(search2),
      data: search2
    })),
    [getLabel, savedSearches]
  );
  return {
    remove,
    items,
    button,
    loading
  };
};

// src/~react-hooks/useSearch/useSearchHistory.tsx
import { useCallback as useCallback46, useEffect as useEffect33, useMemo as useMemo31, useRef as useRef16, useState as useState16 } from "react";
var MAX_STORED_COUNT = 5;
var MIN_LENGTH = 5;
var STORAGE_KEY2 = "searchHistory";
var useSearchHistory = ({ state }) => {
  const { storage: storage2 } = useApp_default();
  const history = useRef16([]);
  const [hiddenQueries, setHiddenQueries] = useState16([]);
  useEffect33(
    () => onEvent7("query", ({ queryString, response }) => {
      const query = queryString.trim();
      const shouldAddSearch = (() => {
        var _a;
        if (!((_a = response == null ? void 0 : response.search) == null ? void 0 : _a.hits.length))
          return false;
        if (query.length < MIN_LENGTH)
          return false;
        return true;
      })();
      if (!shouldAddSearch)
        return;
      const overlap = (() => {
        const historyIncludesCurrent = history.current.find(
          (s) => s.includes(query)
        );
        const currentInHistory = history.current.find(
          (s) => query.includes(s)
        );
        const isOverlapping = historyIncludesCurrent || currentInHistory;
        return {
          isOverlapping,
          oldQuery: historyIncludesCurrent || currentInHistory
        };
      })();
      history.current = history.current.filter((p) => p !== overlap.oldQuery);
      history.current.unshift(query);
      if (history.current.length > MAX_STORED_COUNT) {
        history.current.pop();
      }
      history.current = history.current.filter(
        (p) => !hiddenQueries.includes(p)
      );
    }),
    [hiddenQueries]
  );
  const historyToShow = useMemo31(() => {
    const historyWithoutCurrent = history.current.filter(
      (s) => s !== state.queryString.trim()
    );
    return historyWithoutCurrent;
  }, [state.queryString]);
  const remove = useCallback46((query) => {
    setHiddenQueries((prev) => [...prev, query]);
  }, []);
  useMountEffect(() => __async(void 0, null, function* () {
    const persisted = yield storage2.get(STORAGE_KEY2);
    history.current = persisted != null ? persisted : [];
  }));
  useEffect33(() => {
    storage2.set(STORAGE_KEY2, historyToShow);
  }, [historyToShow, storage2]);
  return {
    items: historyToShow,
    remove
  };
};

// src/~react-hooks/useSearch/searchContext.tsx
import debounce from "lodash/debounce";
import {
  createContext as createContext11,
  useCallback as useCallback50,
  useEffect as useEffect35,
  useMemo as useMemo35,
  useReducer as useReducer3,
  useRef as useRef19
} from "react";

// src/~react-hooks/useSearch/useUrlState.ts
import { useMemo as useMemo33 } from "react";

// src/~react-hooks/useSearch/utils.ts
import omit from "lodash/omit";
import uniq from "lodash/uniq";
import upperFirst from "lodash/upperFirst";

// src/~react-hooks/useSearch/myContentFilters/getMyContentTitleKey.ts
var getMyContentTitleKey = (name) => {
  switch (name) {
    case "entitlements":
      return "mymedia.entitlements_title";
    case "favorites":
      return "mymedia.favorites_title";
    case "searches":
      return "mymedia.saved_searches_title";
    case "continue":
      return "media.continue_watching.title";
    case "watched":
      return "media.watched.title";
    default:
      assertUnreachable(name);
      return name;
  }
};

// src/~react-hooks/useSearch/filterGroups.ts
var filterGroups = [
  {
    id: "myContent",
    urlKey: "my",
    type: "tag",
    titleKey: "mymedia.my_content_title",
    algoliaFacetId: () => null,
    itemTitleKey: ({ name }) => getMyContentTitleKey(name),
    visible: true
  },
  {
    id: "productType",
    urlKey: "type",
    algoliaFacetId: () => "productType",
    type: "tag",
    titleKey: "search.facet.productType",
    itemTitleKey: ({ name }) => `glossary.${name}`.toLowerCase(),
    visible: true
  },
  {
    id: "genres",
    urlKey: "genres",
    type: "tag",
    titleKey: "search.facet.genres",
    algoliaFacetId: () => "genres",
    itemTitleKey: ({ name }) => `genre.${name}`.toLowerCase(),
    visible: true
  },
  {
    id: "imdb",
    urlKey: "imdb",
    algoliaFacetId: () => "ratings.imdb",
    type: "range",
    titleKey: "search.facet.ratings.imdb",
    step: () => 0.1,
    visible: true
  },
  {
    id: "releaseYear",
    urlKey: "year",
    type: "range",
    titleKey: "search.facet.releaseYear",
    algoliaFacetId: () => "releaseYear",
    step: () => 1,
    visible: true
  },
  {
    id: "price",
    urlKey: "price",
    type: "range",
    titleKey: "search.facet.lowestPrice",
    algoliaFacetId: ({ locale }) => `lowestPrice.${locale}`,
    step: ({ locale }) => {
      const hasEuro = locale === "fi" /* fi */;
      return hasEuro ? 0.1 : 1;
    },
    visible: true
  },
  {
    id: "audio",
    urlKey: "audio",
    type: "tag",
    titleKey: "search.facet.manifest.audio.tracks.language",
    algoliaFacetId: () => "manifest.audio.tracks.language",
    itemTitleKey: ({ name, locale }) => getDisplayLanguage({
      language: name,
      locale
    }),
    visible: true
  },
  {
    id: "subtitles",
    urlKey: "subtitles",
    type: "tag",
    titleKey: "search.facet.manifest.subtitles.language",
    algoliaFacetId: () => "manifest.subtitles.language",
    itemTitleKey: ({ name, locale }) => getDisplayLanguage({
      language: name,
      locale
    }),
    visible: true
  },
  {
    id: "metaCollections",
    urlKey: "mc",
    type: "tag",
    titleKey: "search.facet.metaCollections",
    algoliaFacetId: () => "metaCollections",
    itemTitleKey: ({ name }) => `metacollection.${name}`.toLowerCase(),
    visible: true
  },
  {
    id: "productionCountries",
    urlKey: "countries",
    type: "tag",
    titleKey: "search.facet.productionCountries",
    algoliaFacetId: () => "productionCountries",
    itemTitleKey: ({ name }) => `country.${name}`.toLowerCase(),
    visible: true
  },
  {
    id: "duration",
    urlKey: "time",
    type: "range",
    titleKey: "search.facet.duration",
    algoliaFacetId: () => "duration",
    step: () => 15,
    visible: true
  },
  {
    id: "tags",
    urlKey: "tags",
    type: "tag",
    titleKey: "search.facet.tags",
    algoliaFacetId: ({ locale }) => `mediaTags.${locale}.name`,
    itemTitleKey: ({ name }) => name,
    visible: false
  },
  {
    id: "ageLimit",
    urlKey: "age",
    type: "range",
    titleKey: "search.facet.ageLimit",
    algoliaFacetId: ({ locale }) => `ageLimit.${locale}`,
    step: () => 1,
    visible: false
  }
];

// src/~react-hooks/useSearch/utils.ts
import { produce as produce2 } from "immer";
import { useCallback as useCallback48 } from "react";

// src/~react-hooks/useSearch/facets/utils.ts
import { produce } from "immer";
var isVisible = (group) => group.visible;
var byImportance = (a, b) => {
  const algoliaKeys = filterGroups.map((f) => f.algoliaFacetId);
  return algoliaKeys.indexOf(a.algoliaFacetId) - algoliaKeys.indexOf(b.algoliaFacetId);
};
var getDefaultFacets = (locale) => {
  return filterGroups.filter(isVisible).map((f) => f.algoliaFacetId({ locale })).filter(exists);
};
var getFacetRangeStats = (filterGroupId, locale, stats) => {
  if (!stats)
    return { min: 0, max: 0, avg: 0, sum: 0, step: 1 };
  const filterGroup = filterGroups.find((g) => g.id === filterGroupId);
  if (!filterGroup) {
    throw Error("Filter group not found: " + filterGroupId);
  }
  const step = filterGroup.step({ locale });
  return __spreadProps(__spreadValues({}, stats), { step });
};
var sortActiveFacets = (facets) => {
  const customOrder = ["exclude", "include", false];
  return produce(
    facets,
    (draft) => draft.forEach((f) => {
      if (f.type === "range")
        return;
      f.items.sort(
        // indexOf is the perfect way to sort by custom order
        (a, b) => customOrder.indexOf(a.value) - customOrder.indexOf(b.value)
      );
    })
  );
};
var getFacetsFromAlgoliaResponse = ({
  response,
  userFilters,
  locale
}) => {
  var _a, _b;
  if (!response)
    return [];
  const { search: search2, globalSearch } = response;
  const facets = (_b = (_a = search2 == null ? void 0 : search2.facets) != null ? _a : globalSearch == null ? void 0 : globalSearch.facets) != null ? _b : [];
  const newFacets = Object.entries(facets).map(([fId, items]) => {
    var _a2, _b2, _c, _d, _e;
    const facetId = fId;
    const filterGroup = filterGroups.find(
      (g) => g.algoliaFacetId({ locale }) === facetId
    );
    if (!filterGroup) {
      throw Error("Filter group not found: " + facetId);
    }
    const { type: type2, id } = filterGroup;
    const globalStats = (_a2 = globalSearch == null ? void 0 : globalSearch.facets_stats) == null ? void 0 : _a2[facetId];
    switch (type2) {
      case "range": {
        const stats = getFacetRangeStats(id, locale, globalStats);
        const min = (_c = (_b2 = userFilters[id]) == null ? void 0 : _b2.filters.min) != null ? _c : stats.min;
        const max = (_e = (_d = userFilters[id]) == null ? void 0 : _d.filters.max) != null ? _e : stats.max;
        const r = __spreadProps(__spreadValues({}, filterGroup), {
          max,
          min,
          stats
        });
        return r;
      }
      default:
      case "tag": {
        const newItems = Object.entries(items).map(
          ([name, count]) => {
            var _a3, _b3;
            const value = (_b3 = (_a3 = userFilters[id]) == null ? void 0 : _a3.filters[name]) != null ? _b3 : false;
            const active = value === "include" || value === "exclude";
            return {
              count: active ? void 0 : count,
              name,
              value,
              active,
              titleKey: filterGroup.itemTitleKey({ name, locale })
            };
          }
        );
        return __spreadProps(__spreadValues({}, filterGroup), {
          items: newItems
        });
      }
    }
  });
  Object.entries(userFilters).forEach(([filterGroupId, filterGroupData]) => {
    let facet = newFacets.find((f) => f.id === filterGroupId);
    const filterGroup = filterGroups.find(
      (g) => g.id == filterGroupId
    );
    if (!filterGroup)
      return;
    const algoliaFacetId = filterGroup.algoliaFacetId({ locale });
    if (!facet) {
      const filterGroupToBeAdded = (() => {
        if (filterGroupData.type === "tag") {
          return __spreadProps(__spreadValues({}, filterGroup), {
            items: []
          });
        }
        return __spreadProps(__spreadValues({}, filterGroup), {
          max: filterGroupData.filters.max,
          min: filterGroupData.filters.min,
          stats: getFacetRangeStats(
            filterGroupId,
            locale
          )
        });
      })();
      newFacets.push(filterGroupToBeAdded);
      facet = filterGroupToBeAdded;
    }
    const activeFilters = Object.entries(filterGroupData.filters);
    if (activeFilters.length && facet.type === "tag") {
      const activeItems = activeFilters.map(([name, value]) => {
        var _a2, _b2, _c;
        const active = value === "include" || value === "exclude";
        const count = (_c = algoliaFacetId ? (_b2 = (_a2 = globalSearch == null ? void 0 : globalSearch.facets) == null ? void 0 : _a2[algoliaFacetId]) == null ? void 0 : _b2[name] : 0) != null ? _c : 0;
        return {
          count: active ? void 0 : count,
          name,
          value,
          active,
          titleKey: (facet == null ? void 0 : facet.type) === "tag" && facet.itemTitleKey({ name, locale })
        };
      });
      facet.items = [...activeItems, ...facet.items].filter(
        // removal of duplicates is needed since active filters might exists in algolia
        // response until the next fetch is completed
        removeDuplicatedFilters
      );
    }
  });
  return sortActiveFacets(newFacets).map(toFilterGroup);
};
var removeDuplicatedFilters = (item, index, arr) => {
  return arr.findIndex((i) => i.name === item.name) === index;
};
var searchStateToAlgoliaFacets = (userFilters, locale, opts) => {
  const filters = Object.entries(userFilters);
  if (filters.length === 0) {
    return { facetFilters: [], numericFilters: [] };
  }
  let facetFilters = filters.filter(
    (f) => f[1].type === "tag"
  ).map(([id, f]) => {
    return Object.entries(f.filters).filter(([, value]) => value !== false).map(([name, value]) => {
      const algoliaFacetId = getFilterGroup(id).algoliaFacetId({ locale });
      const prefix2 = value === "exclude" ? "-" : "";
      return `${algoliaFacetId}:${prefix2}${name}`;
    });
  });
  if ((opts == null ? void 0 : opts.useAnd) !== false) {
    facetFilters = facetFilters.flat();
  }
  const numericFilters = filters.filter(
    (f) => f[1].type === "range"
  ).filter(
    ([, f]) => f.filters.min !== void 0 && f.filters.max !== void 0
  ).map(([id, f]) => {
    const algoliaFacetId = getFilterGroup(id).algoliaFacetId({ locale });
    return `${algoliaFacetId}: ${f.filters.min} TO ${f.filters.max}`;
  }).sort();
  facetFilters.sort();
  numericFilters.sort();
  return { facetFilters, numericFilters };
};
var mapFacetFilter = (key3, value) => {
  const filters = [];
  if (Array.isArray(value)) {
    filters.push(...value);
  } else {
    filters.push(value);
  }
  return filters.map((productType) => `${key3}:${productType}`);
};
var toggleFacetFilterValue = (newValue, currentValue) => {
  if (newValue === "toggleIncludeExclude") {
    return currentValue === "exclude" ? "include" : "exclude";
  }
  if (newValue === "toggleIncludeOff") {
    return currentValue === "include" ? false : "include";
  }
  if (newValue !== "toggle") {
    if (newValue === true)
      return "include";
    return newValue;
  }
  switch (currentValue) {
    case "include":
      return "exclude";
    case "exclude":
      return false;
    case false:
    default:
      return "include";
  }
};
var getCleanTitleKeyId = ({
  facetId,
  locale
}) => {
  const bannedSuffixes = `.${locale}`;
  const bannedString = `${bannedSuffixes}.`;
  const titleName = facetId.endsWith(bannedSuffixes) ? facetId.replace(bannedString, ".").slice(0, -3) : facetId.replace(bannedString, ".");
  return titleName;
};
var isRangeFilterGroup = (group) => group.type === "range";
var isTagFilterGroup = (group) => group.type === "tag";

// src/~react-hooks/useSearch/myContentFilters/useMyContentFilters.ts
import { useCallback as useCallback47, useMemo as useMemo32 } from "react";

// src/~react-hooks/useSavedSearches/useSavedSearches.ts
var useSavedSearches = (_a = {}) => {
  var _b = _a, {
    coverSize,
    coverPreset
  } = _b, opts = __objRest(_b, [
    "coverSize",
    "coverPreset"
  ]);
  const { isLoggedIn } = useSession_default();
  const _a2 = useQuery_default(GQL_GET_SAVED_SEARCHES_default, __spreadValues({
    variables: { coverSize, coverPreset },
    skip: !isLoggedIn || opts.skip
  }, opts)), { data, loading, error, networkStatus } = _a2, other = __objRest(_a2, ["data", "loading", "error", "networkStatus"]);
  return __spreadValues({
    response: data == null ? void 0 : data.response,
    data,
    loading,
    refetching: networkStatus === 4,
    networkStatus,
    error
  }, other);
};

// src/~react-hooks/useSearch/myContentFilters/useMyContentFilters.ts
var contentTypenameFilter = ["Movie", "Series", "MetaCollectionBundle"];
var getSlugs2 = (items) => {
  var _a;
  if (!Array.isArray(items))
    return [];
  return (_a = items.filter(
    (m) => {
      var _a2, _b, _c;
      return contentTypenameFilter.includes(
        (_c = (_b = (_a2 = m == null ? void 0 : m.item) == null ? void 0 : _a2.__typename) != null ? _b : m == null ? void 0 : m.__typename) != null ? _c : ""
      );
    }
  ).map((f) => f.slug)) != null ? _a : [];
};
var slugsToFilters = ({
  include,
  exclude,
  locale
}) => {
  let filter = "";
  if (include.length > 0) {
    const includeFilter = `AND (${include.map((slug3) => `objectID:${slug3}`).join(" OR ")})`;
    filter = includeFilter;
  }
  if (exclude.length > 0) {
    const excludeFilter = `AND (${exclude.map((slug3) => `NOT objectID:${slug3}`).join(" AND ")} AND (isDisplayable.${locale.toLowerCase()} = 1))`;
    filter = `${filter} ${excludeFilter}`;
  }
  return filter;
};
var toMyContentState = (initialValues) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
  const defaultState = {
    entitlements: {
      value: (_b = (_a = initialValues == null ? void 0 : initialValues.find((i) => i.name === "entitlements")) == null ? void 0 : _a.value) != null ? _b : false
    },
    favorites: {
      value: (_d = (_c = initialValues == null ? void 0 : initialValues.find((i) => i.name === "favorites")) == null ? void 0 : _c.value) != null ? _d : false
    },
    searches: {
      value: (_f = (_e = initialValues == null ? void 0 : initialValues.find((i) => i.name === "searches")) == null ? void 0 : _e.value) != null ? _f : false
    },
    continue: {
      value: (_h = (_g = initialValues == null ? void 0 : initialValues.find((i) => i.name === "continue")) == null ? void 0 : _g.value) != null ? _h : false
    },
    watched: {
      value: (_j = (_i = initialValues == null ? void 0 : initialValues.find((i) => i.name === "watched")) == null ? void 0 : _i.value) != null ? _j : false
    }
  };
  return defaultState;
};
var useMyContentData = () => {
  const { isBooting } = useApp_default();
  const { loading: sessionLoading } = useSession_default();
  const {
    response: { items: entitlementsRes },
    loading: entitlementsLoading
  } = useEntitlements_default();
  const { response: favoritesRes, loading: favoritesLoading } = useFavorites_default();
  const { response: searchesRes, loading: searchesLoading } = useSavedSearches();
  const { response: bookmarksRes, loading: bookmarksLoading } = useBookmarks_default();
  const { items: continueWatchingRes, loading: continueWatchingLoading } = useContinueWatching_default({ limit: 250 });
  const loading = sessionLoading || isBooting || entitlementsLoading || favoritesLoading || searchesLoading || bookmarksLoading || continueWatchingLoading;
  const items = useMemo32(() => {
    const watched = bookmarksRes == null ? void 0 : bookmarksRes.filter((b) => b.completed);
    if (loading) {
      return {
        entitlements: [],
        favorites: [],
        searches: [],
        continue: [],
        watched: []
      };
    }
    return {
      entitlements: getSlugs2(entitlementsRes),
      favorites: getSlugs2(favoritesRes),
      searches: getSlugs2(searchesRes),
      continue: continueWatchingRes.map((c) => c.slug).map(removeAbbreviationFromSlug),
      watched: getSlugs2(watched)
    };
  }, [
    bookmarksRes,
    continueWatchingRes,
    entitlementsRes,
    favoritesRes,
    loading,
    searchesRes
  ]);
  return {
    items,
    loading
  };
};
var useMyContentFilters = (state) => {
  const { locale } = useApp_default();
  const { items, loading } = useMyContentData();
  const getFilters2 = useCallback47(
    (state2) => {
      const include = [];
      const exclude = [];
      Object.entries(state2).forEach(([k, { value: v }]) => {
        if (v === "include")
          include.push(...items[k]);
        if (v === "exclude")
          exclude.push(...items[k]);
      });
      return slugsToFilters({ include, exclude, locale });
    },
    [items, locale]
  );
  const filterGroup = getFilterGroup("myContent");
  const filters = useMemo32(
    () => Object.entries(state).map(([name, data]) => ({
      name,
      active: data.value !== false,
      value: data.value,
      titleKey: filterGroup.itemTitleKey({ name, locale }),
      count: items[name].length
    })).filter((f) => f.count > 0),
    [filterGroup, items, locale, state]
  );
  const activeCount = Object.values(state).filter(
    (v) => v.value !== false
  ).length;
  const filterGroupData = useMemo32(
    () => __spreadProps(__spreadValues({}, filterGroup), {
      items: filters,
      activeCount
    }),
    [activeCount, filterGroup, filters]
  );
  return useMemo32(
    () => ({
      filterGroup: filterGroupData,
      myContentFilters: getFilters2(state),
      loading,
      getFilters: getFilters2
    }),
    [filterGroupData, getFilters2, loading, state]
  );
};

// src/~react-hooks/useSearch/myContentFilters/types.ts
var MyContentNameVales = [
  "entitlements",
  "favorites",
  "searches",
  "continue",
  "watched"
];
var MyContentNameValesObj = MyContentNameVales.reduce(
  (acc, next) => __spreadProps(__spreadValues({}, acc), { [next]: null }),
  {}
);
function isMyContentName(value) {
  return value in MyContentNameValesObj;
}

// src/~react-hooks/useSearch/types.ts
var FilterGroupId = filterGroups.reduce(
  (acc, group) => __spreadProps(__spreadValues({}, acc), { [group.id]: group.id }),
  {}
);

// src/~react-hooks/useSearch/utils.ts
var getDefaultAlgoliaReqOpts = (locale) => ({
  hitsPerPage: 10,
  query: "",
  filters: getProductTypeFilterString({ locale }),
  page: 0,
  facetFilters: [],
  numericFilters: []
});
var getProductTypeFilterString = ({
  products,
  locale,
  ignoreDisplayable
}) => {
  if (!products) {
    products = ["movie" /* movie */, "series" /* series */, "bundle" /* bundle */];
  }
  const filter = products.map((p) => upperFirst(p)).reduce(
    (prev, curr) => prev.length === 0 ? `${FilterGroupId.productType}:${curr}` : `${prev} OR ${FilterGroupId.productType}:${curr}`,
    ""
  );
  if (ignoreDisplayable === true) {
    return `(${filter})`;
  }
  if (locale === void 0) {
    console.error("Locale is undefined", locale);
  }
  return `(${filter}) AND (isDisplayable.${locale.toLowerCase()} = 1)`;
};
var getAlgoliaRequestOptions = ({
  opts = { query: "" },
  locale,
  page = 0,
  hitsPerPage = getDefaultAlgoliaReqOpts("sv" /* sv */).hitsPerPage,
  clickAnalytics = false,
  accountId = "",
  maxValuesPerFacet = 25,
  facets,
  initialRequest
}) => {
  var _a, _b, _c, _d;
  const baseTypes = ["movie" /* movie */, "series" /* series */, "bundle" /* bundle */];
  const ignoreDisplayable = (_b = (_a = opts.filters) == null ? void 0 : _a.includes("objectID:")) != null ? _b : false;
  const searchableFilters = getProductTypeFilterString({
    products: baseTypes,
    locale,
    ignoreDisplayable
  });
  const requestFilters = [
    searchableFilters,
    // Here we basically remove a hydrated filter.
    (_d = (_c = opts.filters) == null ? void 0 : _c.replace(searchableFilters, "")) == null ? void 0 : _d.replace(/\s{2,}/g, " ")
  ].filter((f) => {
    var _a2;
    return (_a2 = f == null ? void 0 : f.length) != null ? _a2 : 0 > 1;
  }).join(" ").trim();
  if (facets === void 0) {
    facets = getDefaultFacets(locale);
  }
  const shouldFetchUnusuallyManyHits = initialRequest && page > 0;
  const requestOptions = __spreadProps(__spreadValues({}, opts), {
    page: (() => {
      var _a2;
      if (shouldFetchUnusuallyManyHits)
        return 0;
      return (_a2 = page != null ? page : opts.page) != null ? _a2 : 0;
    })(),
    hitsPerPage: (() => {
      var _a2;
      if (shouldFetchUnusuallyManyHits) {
        return (page + 1) * hitsPerPage;
      }
      return (_a2 = opts.hitsPerPage) != null ? _a2 : hitsPerPage;
    })(),
    maxValuesPerFacet,
    filters: requestFilters,
    attributesToRetrieve: getAttributesToRetrieve(locale),
    clickAnalytics,
    userToken: clickAnalytics ? accountId : void 0,
    facets
  });
  return requestOptions;
};
var getAttributesToRetrieve = (locale) => {
  const bannedSuffixes = Object.keys(Locale).filter((l) => l !== locale).map((l) => `.${l}`);
  const attributes = [
    getFilterGroup(FilterGroupId.releaseYear).algoliaFacetId(),
    getFilterGroup(FilterGroupId.imdb).algoliaFacetId(),
    getFilterGroup(FilterGroupId.productType).algoliaFacetId(),
    "actors.name",
    "ageLimit.da",
    "ageLimit.fi",
    "ageLimit.no",
    "ageLimit.sv",
    "bundleTitles.da",
    "bundleTitles.fi",
    "bundleTitles.no",
    "bundleTitles.sv",
    "directors.name",
    "duration",
    "episodeDuration",
    "imdbId",
    "longSummary.da",
    "longSummary.fi",
    "longSummary.no",
    "longSummary.sv",
    "lowestCampaignPrice.da",
    "lowestCampaignPrice.fi",
    "lowestCampaignPrice.no",
    "lowestCampaignPrice.sv",
    "lowestPriceString.da",
    "lowestPriceString.fi",
    "lowestPriceString.no",
    "lowestPriceString.sv",
    "originalTitle",
    "firstReleaseYear",
    "lastReleaseYear",
    "searchCover.da",
    "searchCover.fi",
    "searchCover.no",
    "searchCover.sv",
    "isPurchasableSeasonCount.da",
    "isPurchasableSeasonCount.fi",
    "isPurchasableSeasonCount.no",
    "isPurchasableSeasonCount.sv",
    "slug",
    "title.da",
    "title.fi",
    "title.no",
    "title.sv",
    "mediaTags.da",
    "mediaTags.fi",
    "mediaTags.no",
    "mediaTags.sv"
  ].filter((a) => !bannedSuffixes.includes(a.substr(-3)));
  return uniq(attributes).sort();
};
var createHighlightObject = (text) => {
  if (typeof text !== "string")
    return [];
  const titleNative = [];
  text.replace(
    /([^<>]*?)(<\/?[-:\w]+(?:>|\s[^<>]*?>)|$)/g,
    (a, text2, c) => {
      if (text2.length === 0)
        return "";
      if (c === "</em>") {
        titleNative.push({ type: "EMPHASIZED", text: text2 });
      } else {
        titleNative.push({ type: "NORMAL", text: text2 });
      }
      return "";
    }
  );
  return titleNative;
};
var applyHitHelperProps = ({
  hit,
  locale
}) => {
  var _a, _b, _c, _d, _e;
  const { _highlightResult: hl } = hit;
  hit.__typename = hit.productType;
  const coverSrc = (_a = hit.searchCover) != null ? _a : COVER;
  hit.displayableAsset = {
    id: "DisplayableInCollectionWithCover:id",
    __typename: "DisplayableInCollectionWithCover",
    cover: coverSrc
  };
  hit.imdbScore = Number((_b = hit == null ? void 0 : hit.ratings) == null ? void 0 : _b.imdb) || null;
  hit.imdbLink = (hit == null ? void 0 : hit.imdbId) ? `https://www.imdb.com/title/${hit.imdbId}/` : null;
  hit.ageText = hit.ageLimit !== null && hit.ageLimit > 0 ? { key: "search.agelimit_years", data: { age: hit.ageLimit } } : null;
  const titleMatch = __spreadValues({ originalTitle: hl.originalTitle }, hl.title);
  const titles = titleMatch ? Object.keys(titleMatch).filter(exists).map((loc) => __spreadProps(__spreadValues({}, titleMatch[loc]), {
    locale: loc
  })) : [];
  const matchTitles = titles.filter((t) => t.matchLevel !== "none").sort((a, b) => {
    const compare = a.matchLevel.localeCompare(b.matchLevel);
    if (compare !== 0)
      return compare;
    if (a.locale === locale)
      return -1;
    if (b.locale === locale)
      return 1;
    return 0;
  });
  const matchTitle = matchTitles == null ? void 0 : matchTitles[0];
  hit.display = {
    __typename: "Display",
    title: (_c = matchTitle == null ? void 0 : matchTitle.value) != null ? _c : hit.title,
    originalTitle: hit.originalTitle,
    caption: hit.longSummary,
    titleNative: createHighlightObject(
      (_e = (_d = matchTitle == null ? void 0 : matchTitle.value) != null ? _d : hit.title) != null ? _e : hit.originalTitle
    )
  };
  const secondaryTitle = Object.values(
    omit(hl, ["title", "originalTitle", "bundleTitles"])
  ).flat().map(
    (o) => o.value ? o : Object.values(o).shift()
  ).filter(exists).filter((t) => t.matchLevel !== "none").sort((a, b) => a.matchLevel.localeCompare(b.matchLevel)).shift();
  if (secondaryTitle) {
    hit.displaySecondary = {
      __typename: "Display",
      title: secondaryTitle == null ? void 0 : secondaryTitle.value,
      originalTitle: secondaryTitle == null ? void 0 : secondaryTitle.value,
      caption: "",
      titleNative: createHighlightObject(secondaryTitle == null ? void 0 : secondaryTitle.value)
    };
  }
  switch (hit.productType) {
    case "Bundle":
      hit.releaseYear = `${hit.firstReleaseYear} - ${hit.lastReleaseYear}`;
      hit.durationString = humanRuntime(hit.duration);
      break;
    case "Series":
      hit.duration = hit.episodeDuration;
      hit.durationString = humanRuntime(hit.episodeDuration);
      hit.releaseYear = `${hit.firstReleaseYear} - ${hit.lastReleaseYear}`;
      hit.seasonText = {
        key: hit.isPurchasableSeasonCount === 1 ? "search.number_of_seasons.singular" : "search.number_of_seasons.plural",
        data: { seasonCount: Number(hit.isPurchasableSeasonCount) }
      };
      break;
    default:
      hit.durationString = humanRuntime(hit.duration);
      hit.releaseYear = String(hit == null ? void 0 : hit.releaseYear);
      break;
  }
  return hit;
};
var applyHitsUpdates = ({
  page,
  nextHits,
  prevHits,
  fallbackHits,
  queryID,
  locale
}) => {
  const mergedHits = page && page > 0 && nextHits ? [...prevHits, ...nextHits] : fallbackHits;
  const hits = mergedHits.map((hit, index) => {
    var _a, _b;
    return __spreadProps(__spreadValues({}, hit), {
      __position: index + 1,
      __queryID: (_b = queryID != null ? queryID : (_a = fallbackHits == null ? void 0 : fallbackHits[0]) == null ? void 0 : _a.__queryID) != null ? _b : null
    });
  });
  const newHits = produce2(hits, (draftHits) => {
    draftHits.forEach((hit) => {
      Object.keys(hit).forEach((key3) => {
        Object.keys(Locale).forEach((l) => {
          var _a, _b;
          if (typeof ((_a = hit == null ? void 0 : hit[key3]) == null ? void 0 : _a[l]) === "undefined")
            return;
          hit[key3] = (_b = hit == null ? void 0 : hit[key3]) == null ? void 0 : _b[l];
        });
      });
      hit = applyHitHelperProps({ hit, locale });
    });
    return draftHits;
  });
  return newHits;
};
var getFilters = (variables) => {
  const queryParams = toQueryParamsString(variables != null ? variables : {});
  const params = new URLSearchParams(queryParams);
  const myContentFilters = [];
  const userFilters = {};
  let query = "";
  let page = 0;
  params.forEach((value, key3) => {
    var _a;
    if (key3 === "query") {
      if (!Array.isArray(value)) {
        query = value;
      }
      return;
    }
    if (key3 === "page") {
      const pageInt = parseInt(value);
      if (isNaN(pageInt))
        return;
      page = pageInt - 1;
      return;
    }
    const filterGroup = filterGroups.find((f) => f.urlKey === key3);
    if (!filterGroup) {
      if (true) {
        console.warn("Unhandled query param", key3, value);
      }
      return;
    }
    if (filterGroup.id === "myContent") {
      const name = value.startsWith("-") ? value.substring(1) : value;
      myContentFilters.push({
        name,
        value: value.startsWith("-") ? "exclude" : "include"
      });
      return;
    }
    if (filterGroup.type === "tag") {
      const name = value.startsWith("-") ? value.substring(1) : value;
      userFilters[filterGroup.id] = {
        type: "tag",
        filters: __spreadProps(__spreadValues({}, (_a = userFilters[filterGroup.id]) == null ? void 0 : _a.filters), {
          [name]: value.startsWith("-") ? "exclude" : "include"
        })
      };
      return;
    }
    if (filterGroup.type === "range") {
      if (typeof value === "string") {
        const [min, max] = value.split("-");
        userFilters[filterGroup.id] = {
          filters: { min: Number(min), max: Number(max) },
          type: "range"
        };
      }
    }
  });
  return {
    query,
    myContent: toMyContentState(myContentFilters),
    userFilters,
    page
  };
};
var myContentFromUrlState = (myContent) => {
  let filters = [];
  if (Array.isArray(myContent)) {
    filters = Object.values(myContent).map((v) => {
      const value = v.startsWith("-") ? "exclude" : "include";
      return {
        name: v.replace(/^-/g, ""),
        value
      };
    }).filter((i) => isMyContentName(i.name));
  }
  return filters;
};
var makeSearchUrlRangeValue = (min, max) => `${min}-${max}`;
var searchStateToUrlState = ({
  filterGroupsData,
  hitsPerPage,
  query,
  page
}) => {
  const urlParams = {};
  if (query != null && query !== "") {
    urlParams.query = query;
  }
  if (hitsPerPage && page) {
    urlParams.page = String(page + 1);
  }
  filterGroupsData.forEach((group) => {
    if (group.activeCount < 1)
      return;
    switch (group.type) {
      case "tag": {
        const urlKey = group.urlKey;
        urlParams[urlKey] = group.items.filter((item) => item.value !== false).map((item) => {
          const prefix2 = item.value === "exclude" ? "-" : "";
          return `${prefix2}${item.name}`;
        });
        break;
      }
      case "range": {
        if (group.min == null || group.max == null) {
          break;
        }
        const urlKey = group.urlKey;
        urlParams[urlKey] = makeSearchUrlRangeValue(group.min, group.max);
      }
    }
  });
  return urlParams;
};
var applyQuerySuggestionsUpdates = ({
  hits
}) => {
  if (!(hits == null ? void 0 : hits.hits))
    return void 0;
  const suggestions = hits == null ? void 0 : hits.hits.map((s) => {
    var _a, _b;
    const value = (_b = (_a = s._highlightResult) == null ? void 0 : _a.query) == null ? void 0 : _b.value;
    if (typeof value !== "string")
      return;
    const facets = Object.values(s).reduce(
      (previousValue, current) => {
        if (typeof current !== "object")
          return previousValue;
        const facets2 = current == null ? void 0 : current.facets;
        if (facets2)
          return facets2;
        return previousValue;
      },
      { analytics: {}, exact_matches: {} }
    );
    return {
      query: s.query,
      value,
      valueNative: createHighlightObject(value),
      facets
    };
  });
  return suggestions != null ? suggestions : [];
};
var getRangeSliders = (filter) => {
  var _a, _b, _c, _d;
  const min = (_a = filter.min) != null ? _a : filter.stats.min;
  const max = (_b = filter.max) != null ? _b : filter.stats.max;
  const { step } = filter.stats;
  const numberOfStepDecimals = (_d = (_c = step.toString().split(".")[1]) == null ? void 0 : _c.length) != null ? _d : 0;
  const toLabelValue = (value) => value.toFixed(numberOfStepDecimals);
  const maxSlider = {
    type: "max",
    labelKey: "search.to",
    min,
    max: filter.stats.max,
    value: max,
    labelValue: toLabelValue(max),
    step,
    active: max !== filter.stats.max
  };
  const minSlider = {
    type: "min",
    labelKey: "search.from",
    min: filter.stats.min,
    max,
    value: min,
    labelValue: toLabelValue(min),
    step,
    active: min !== filter.stats.min
  };
  const sliders = { min: minSlider, max: maxSlider };
  return sliders;
};
var getActiveRangeCount = (facet) => {
  let active = 0;
  if (facet.min != null && facet.min !== facet.stats.min)
    active++;
  if (facet.max != null && facet.max !== facet.stats.max)
    active++;
  return active;
};
var getActiveCount = (facet) => {
  if (facet.type === "tag")
    return getActiveTagCount(facet);
  if (facet.type === "range")
    return getActiveRangeCount(facet);
  assertUnreachable(facet);
  throw Error("Unreachable");
};
var getActiveTagCount = (facet) => {
  if (facet.type !== "tag")
    return 0;
  return facet.items.filter((af) => af.value !== false).length;
};
var isActive = (facet) => {
  return getActiveCount(facet) > 0;
};
var toFilterGroup = (facet) => {
  switch (facet.type) {
    case "tag":
      return __spreadProps(__spreadValues({}, facet), {
        activeCount: getActiveTagCount(facet)
      });
    case "range": {
      return __spreadProps(__spreadValues({}, facet), {
        activeCount: getActiveRangeCount(facet),
        sliders: getRangeSliders(facet)
      });
    }
    default:
      assertUnreachable(facet);
      throw Error("Unreachable");
  }
};
var toQueryParamsString = (variables) => {
  const searchParams = new URLSearchParams("");
  Object.entries(variables).forEach(([key3, value]) => {
    if (!value)
      return;
    if (value.length < 1)
      return;
    const values = Array.isArray(value) ? value : [value];
    values.forEach((value2) => {
      searchParams.append(key3, value2);
    });
  });
  return searchParams.toString();
};
var toQueryParamKey = (name) => {
  if (name === "query")
    return "query";
  return getFilterGroup(name).urlKey;
};
var toSearchQueryParams = (input) => {
  const searchParams = (() => {
    if (!input)
      return new URLSearchParams();
    if (typeof input === "string") {
      return new URLSearchParams(input);
    }
    const params = new URLSearchParams();
    Object.entries(input).forEach((entry) => {
      const id = entry[0];
      const validParams = [...filterGroups.map((f) => f.id), "query"];
      if (!validParams.includes(id))
        return;
      const key3 = toQueryParamKey(id);
      const value = entry[1];
      if (!value)
        return;
      const isQuery = key3 === "query";
      if (isQuery) {
        params.append(key3, value);
        return;
      }
      if (typeof value !== "object")
        return;
      const isRange = "min" in value || "max" in value;
      if (isRange) {
        const urlValue2 = makeSearchUrlRangeValue(
          value.min,
          value.max
        );
        params.append(key3, urlValue2);
        return;
      }
      const urlValue = Object.entries(value).map(([key4, value2]) => {
        const isTag = value2 === "include" || value2 === "exclude";
        if (isTag) {
          const prefix2 = value2 === "exclude" ? "-" : "";
          return `${prefix2}${key4}`;
        }
      }).join(" ");
      params.append(key3, urlValue);
    });
    return params;
  })();
  const variables = {};
  searchParams.forEach((value, key3) => {
    if (!variables[key3])
      variables[key3] = value;
    else if (typeof variables[key3] === "string") {
      variables[key3] = [variables[key3], value];
    } else if (Array.isArray(variables[key3])) {
      variables[key3].push(value);
    }
  });
  return variables;
};
var getFilterGroup = (id) => {
  const group = filterGroups.find((g) => g.id === id);
  if (!group) {
    throw new Error(`Filter group ${id} not found`);
  }
  return group;
};
var useActiveFilters = () => {
  const { t, getString } = useL10n_default();
  const { locale } = useApp_default();
  return useCallback48(
    ({
      state,
      userFilters,
      myContent
    }) => {
      const actives = [];
      Object.entries(myContent).forEach(([name, { value }]) => {
        if (value === false)
          return;
        const group = getFilterGroup("myContent");
        const filter = t(group.itemTitleKey({ name, locale }));
        actives.push({
          type: "myContent",
          name,
          value,
          id: group.id,
          label: value === "exclude" ? t("search.not", { filter }) : filter
        });
      });
      Object.entries(userFilters).forEach(([key3, value]) => {
        var _a, _b, _c;
        if (value.type === "range") {
          const filterGroup = getFilterGroup(key3);
          const facetId = filterGroup.algoliaFacetId({ locale });
          const defaults = (_c = (_b = (_a = state.response) == null ? void 0 : _a.globalSearch) == null ? void 0 : _b.facets_stats) == null ? void 0 : _c[facetId];
          if (!defaults)
            return;
          let literal = "";
          const decimals = getDecimals({ locale, filterGroup });
          if (value.filters.min !== defaults.min) {
            literal += ` ${getString(
              "search.from"
            ).toLowerCase()} ${value.filters.min.toFixed(decimals)}`;
          }
          t;
          if (value.filters.max !== defaults.max) {
            literal += ` ${getString(
              "search.to"
            ).toLowerCase()} ${value.filters.max.toFixed(decimals)}`;
          }
          actives.push({
            type: "range",
            id: filterGroup.id,
            defaults,
            value: "include",
            label: `${getString(filterGroup.titleKey)} ${literal}`
          });
        } else if (value.type === "tag") {
          try {
            const filterGroup = getFilterGroup(key3);
            Object.entries(value.filters).forEach(([name, value2]) => {
              if (value2 === false)
                return;
              const filter = t(filterGroup.itemTitleKey({ name, locale }));
              actives.push({
                type: "tag",
                id: filterGroup.id,
                name,
                value: value2,
                label: value2 === "exclude" ? t("search.not", { filter }) : filter
              });
            });
          } catch (e) {
          }
        }
      });
      return actives;
    },
    [getString, locale, t]
  );
};
function getDecimals({
  locale,
  filterGroup
}) {
  var _a, _b;
  const step = filterGroup.step({ locale });
  return (_b = (_a = step.toString().split(".")[1]) == null ? void 0 : _a.length) != null ? _b : 0;
}

// src/~react-hooks/useSearch/useUrlState.ts
var useUrlState = ({
  filterGroups: filterGroups2,
  hitsPerPage,
  query,
  page
}) => {
  return useMemo33(() => {
    const getVariables4 = ({
      includePage: includePage2 = true
    } = {}) => {
      return searchStateToUrlState({
        filterGroupsData: filterGroups2,
        query,
        hitsPerPage,
        page: includePage2 ? page : void 0
      });
    };
    const toString = (params) => {
      const variables = getVariables4(params);
      return toQueryParamsString(variables);
    };
    return { getVariables: getVariables4, toString };
  }, [filterGroups2, hitsPerPage, page, query]);
};

// src/~react-hooks/useSearch/myContentFilters/useRefetchWhenNeeded.ts
var useRefetchWhenNeeded = ({
  refetch,
  myContent
}) => {
  useFavorites_default({
    skip: true,
    onEvent: ({ name }) => {
      if (myContent.favorites.value === false)
        return;
      if (name === "added")
        refetch();
      if (name === "removed")
        refetch();
    }
  });
  useBookmarkActions_default({
    onEvent: ({ name }) => {
      const bookmarkRelatedFilters = [
        "continue",
        "watched"
      ];
      if (bookmarkRelatedFilters.every((key3) => myContent[key3].value === false)) {
        return;
      }
      if (name === "markedAsNotWatched")
        refetch();
      if (name === "markedAsWatched")
        refetch();
    }
  });
};

// src/~react-hooks/useSearch/fetching/fetchSearchResults.ts
import algoliasearch from "algoliasearch";

// src/~react-hooks/useSearch/fetching/searchQueries.ts
import hash2 from "object-hash";
var suggestionCache = new LRUCache({
  maxSize: 100
});
var searchCache = new LRUCache({
  maxSize: 100
});
var getValidClient = ({
  client,
  fallback
}) => {
  if (client === "primary" || client === "cached") {
    return client;
  }
  return fallback;
};
var getSearchQueries = (args) => {
  var _a;
  const {
    enableQuerySuggestions,
    indexName,
    params,
    locale,
    preferredClients
  } = args;
  const query = ((_a = params == null ? void 0 : params.query) != null ? _a : "").trim();
  const defaults = getDefaultAlgoliaReqOpts(locale);
  const searchQueries = {
    search: {
      client: getValidClient({
        client: preferredClients == null ? void 0 : preferredClients.search,
        fallback: "primary"
      }),
      get exec() {
        return !this.cache;
      },
      get cache() {
        return searchCache.get(this.hash);
      },
      get hash() {
        return hash2(this.query);
      },
      query: {
        indexName,
        params
      }
    },
    globalSearch: {
      client: getValidClient({
        client: preferredClients == null ? void 0 : preferredClients.globalSearch,
        fallback: "cached"
      }),
      get exec() {
        return !this.cache;
      },
      get cache() {
        return searchCache.get(this.hash);
      },
      get hash() {
        return hash2(this.query);
      },
      query: {
        indexName,
        params: __spreadProps(__spreadValues(__spreadValues({}, params), defaults), { hitsPerPage: params.hitsPerPage })
      }
    },
    suggestions: {
      client: getValidClient({
        client: preferredClients == null ? void 0 : preferredClients.suggestions,
        fallback: "cached"
      }),
      get exec() {
        if (!enableQuerySuggestions)
          return false;
        return !this.cache;
      },
      get cache() {
        return suggestionCache.get(this.hash);
      },
      get hash() {
        return hash2(this.query);
      },
      query: {
        indexName: `${indexName}_query_suggestions`,
        params: { query, hitsPerPage: 3 }
      }
    }
  };
  return searchQueries;
};
var execSearch = (params) => __async(void 0, null, function* () {
  var _a, _b, _c;
  const { queries, clients } = params;
  const response = {
    search: (_a = queries.search.cache) != null ? _a : null,
    globalSearch: (_b = queries.globalSearch.cache) != null ? _b : null,
    suggestions: (_c = queries.suggestions.cache) != null ? _c : null
  };
  const queriesByClient = Object.entries(queries).reduce(
    (acc, [key3, value]) => {
      if (!value.exec)
        return acc;
      acc[value.client].push({
        key: key3,
        query: value.query,
        hash: value.hash
      });
      return acc;
    },
    { primary: [], cached: [] }
  );
  const algoliaResponsePromise = queriesByClient.primary.length > 0 ? clients.primary.search(
    queriesByClient.primary.map((q) => q.query)
  ) : Promise.resolve({ results: [] });
  const cachedAlgoliaResponsePromise = queriesByClient.cached.length > 0 ? clients.cached.search(
    queriesByClient.cached.map((q) => q.query),
    {
      queryParameters: {
        hash: queriesByClient.cached.map((q) => q.hash).join(",")
      }
    }
  ) : Promise.resolve({ results: [] });
  const [algoliaResponse, cachedAlgoliaResponse] = yield Promise.all([
    algoliaResponsePromise,
    cachedAlgoliaResponsePromise
  ]);
  queriesByClient.primary.map(({ key: key3 }, i) => {
    var _a2, _b2;
    response[key3] = (_b2 = (_a2 = algoliaResponse.results) == null ? void 0 : _a2[i]) != null ? _b2 : null;
  });
  queriesByClient.cached.map(({ key: key3 }, i) => {
    var _a2, _b2;
    response[key3] = (_b2 = (_a2 = cachedAlgoliaResponse.results) == null ? void 0 : _a2[i]) != null ? _b2 : null;
  });
  response.search && searchCache.set(queries.search.hash, response.search);
  response.globalSearch && searchCache.set(queries.globalSearch.hash, response.globalSearch);
  response.suggestions && suggestionCache.set(queries.suggestions.hash, response.suggestions);
  return response;
});

// src/~react-hooks/useSearch/fetching/fetchSearchResults.ts
var primaryClient;
var cachedClient;
var fetchSearchResults = (_0) => __async(void 0, [_0], function* ({
  appId,
  searchKey,
  locale,
  userFilters,
  query,
  myContentFilters,
  accountId,
  page,
  indexName,
  enableQuerySuggestions,
  hitsPerPage,
  initialRequest,
  sqh,
  preferredClients
}) {
  const { facetFilters, numericFilters } = searchStateToAlgoliaFacets(
    userFilters != null ? userFilters : {},
    locale
  );
  const opts = {
    query,
    facetFilters,
    numericFilters,
    filters: myContentFilters
  };
  const params = getAlgoliaRequestOptions({
    opts,
    page,
    locale,
    accountId,
    initialRequest,
    hitsPerPage
  });
  if (!primaryClient || !cachedClient) {
    primaryClient = algoliasearch(appId, searchKey);
    cachedClient = sqh ? sqhToAlgoliaSearchClient(sqh) : primaryClient;
  }
  const response = yield execSearch({
    queries: getSearchQueries({
      locale,
      indexName,
      params,
      enableQuerySuggestions,
      preferredClients
    }),
    clients: { primary: primaryClient, cached: cachedClient }
  });
  return response;
});
var sqhToAlgoliaSearchClient = (sqh) => {
  return {
    search: (requests) => sqh.getSearch({ requests })
  };
};

// src/~react-hooks/useSearch/useCheckMetaCollectionTranslations.ts
import { useEffect as useEffect34, useRef as useRef17 } from "react";
var useCheckMetaCollectionTranslations = (filterGroups2) => {
  const { locale, brand, device } = useApp_default();
  const fetchTitles = useRef17(/* @__PURE__ */ new Set());
  const sqh = useStaticQueryHelper();
  useEffect34(() => {
    const check = () => __async(void 0, null, function* () {
      var _a;
      const metaTitles = (_a = filterGroups2.filter(isTagFilterGroup).find((f) => f.id === FilterGroupId.metaCollections)) == null ? void 0 : _a.items.map((i) => i.titleKey);
      const missing = metaTitles == null ? void 0 : metaTitles.filter((t) => !fetchTitles.current.has(t));
      if (!missing || missing.length === 0)
        return;
      missing.forEach((m) => fetchTitles.current.add(m));
      try {
        yield sqh.getLocalization({
          pick: missing,
          locale,
          brand,
          deviceType: device.type,
          excludeNamespace: ["language"]
        });
      } catch (error) {
      }
    });
    check();
  }, [brand, device.type, filterGroups2, locale, sqh]);
};

// src/~react-hooks/useSearch/useIdeas.ts
import capitalize3 from "lodash/capitalize";
import { useCallback as useCallback49, useMemo as useMemo34, useRef as useRef18, useState as useState17 } from "react";
var useIdeas = ({
  state,
  querySuggestions
}) => {
  var _a, _b;
  const { t, getString } = useL10n_default();
  const [hiddenIdeas, setHiddenIdeas] = useState17([]);
  const emptyQuerySuggestions = useRef18([]);
  const personalization2 = usePersonalization();
  const suggestions = useMemo34(() => {
    var _a2, _b2, _c;
    if (emptyQuerySuggestions.current.length) {
      return emptyQuerySuggestions.current;
    }
    const isSuggestionsForEmptyQuery = ((_b2 = (_a2 = state.response) == null ? void 0 : _a2.suggestions) == null ? void 0 : _b2.query) === "";
    if (!isSuggestionsForEmptyQuery)
      return [];
    if (!(querySuggestions == null ? void 0 : querySuggestions.length))
      return [];
    const newEmptyQuerySuggestions = (_c = querySuggestions == null ? void 0 : querySuggestions.map((s) => s == null ? void 0 : s.query).filter(exists)) != null ? _c : [];
    if (newEmptyQuerySuggestions.length) {
      emptyQuerySuggestions.current = newEmptyQuerySuggestions;
    }
    return emptyQuerySuggestions.current;
  }, [querySuggestions, state]);
  const remove = useCallback49((idea) => {
    setHiddenIdeas((prev) => [...prev, idea]);
  }, []);
  const items = useMemo34(
    () => {
      var _a2, _b2, _c, _d, _e, _f, _g, _h;
      return [
        // user's favorite genre
        ...(_b2 = (_a2 = personalization2.items) == null ? void 0 : _a2.filter((i) => i.__typename === "TopGenrePersonalization").slice(0, 1).map((i) => ({
          data: toData({ genres: { [i.slug]: "include" } }),
          label: t(`genre.${i.slug}`),
          personalized: true,
          type: i.__typename
        }))) != null ? _b2 : [],
        // user's favorite actor
        ...(_d = (_c = personalization2.items) == null ? void 0 : _c.filter((i) => i.__typename === "TopActorPersonalization").slice(0, 1).map(({ actor, __typename: __typename2 }) => ({
          data: toData({ query: actor.name }),
          label: actor.name,
          personalized: true,
          type: __typename2
        }))) != null ? _d : [],
        // user's most popular imdb rating
        ...(_f = (_e = personalization2.items) == null ? void 0 : _e.filter((i) => i.__typename === "TopImdbRatingPersonalization").slice(0, 1).map(({ rating, __typename: __typename2 }) => {
          var _a3, _b3, _c2, _d2;
          const filterGroup = getFilterGroup(FilterGroupId.imdb);
          const defaultMax = (_d2 = (_c2 = (_b3 = (_a3 = state.response) == null ? void 0 : _a3.globalSearch) == null ? void 0 : _b3.facets_stats) == null ? void 0 : _c2[filterGroup.algoliaFacetId()]) == null ? void 0 : _d2.max;
          if (!defaultMax)
            return;
          return {
            data: toData({ imdb: { min: rating, max: defaultMax } }),
            label: `${getString(filterGroup.titleKey)} ${getString(
              "search.from"
            ).toLowerCase()} ${rating.toPrecision(2)}`,
            personalized: true,
            type: __typename2
          };
        }).filter(exists)) != null ? _f : [],
        // popular queries
        ...suggestions.map((s) => ({
          data: toData({ query: s }),
          label: capitalize3(s),
          personalized: false,
          type: "suggested_query"
        })),
        // user's favorite director
        ...(_h = (_g = personalization2.items) == null ? void 0 : _g.filter((i) => i.__typename === "TopDirectorPersonalization").slice(0, 1).map(({ director, __typename: __typename2 }) => ({
          data: toData({ query: director.name }),
          label: director.name,
          personalized: true,
          type: __typename2
        }))) != null ? _h : []
      ].filter((s) => !hiddenIdeas.includes(s.data));
    },
    [
      personalization2.items,
      suggestions,
      t,
      (_b = (_a = state.response) == null ? void 0 : _a.globalSearch) == null ? void 0 : _b.facets_stats,
      getString,
      hiddenIdeas
    ]
  );
  return { items, remove };
};
var toData = (obj) => {
  return toQueryParamsString(toSearchQueryParams(obj));
};

// src/~react-hooks/useSearch/searchContext.tsx
import { jsx as jsx13 } from "react/jsx-runtime";
var { onEvent: onEvent7, emit: emit6 } = createEventEmitter();
var searchReducer = (state, updates) => {
  return __spreadValues(__spreadValues({}, state), updates);
};
var SearchContext = createContext11({});
var SearchProvider = ({
  children,
  hitsPerPage = getDefaultAlgoliaReqOpts("sv" /* sv */).hitsPerPage,
  hydratedResponse,
  queryParams,
  enableQuerySuggestions = true
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r;
  const { configs, locale, isBooting } = useApp_default();
  const { t } = useL10n_default();
  const { track } = useTracker_default();
  const { auth, isLoggedIn } = useSession_default();
  const sqh = useStaticQueryHelper();
  const { data: featureData, ready: featureReady } = useFeatureToggle_default(
    "SEARCH" /* SEARCH */
  );
  const {
    userFilters: initialUserFilters,
    myContent: initialMyContent,
    query: initialQueryString,
    page: initialPage
  } = getFilters(queryParams);
  const appId = (_a = configs == null ? void 0 : configs.ALGOLIASEARCH_APPLICATION_ID) != null ? _a : null;
  const searchKey = (_b = configs == null ? void 0 : configs.ALGOLIASEARCH_API_KEY_SEARCH) != null ? _b : null;
  const indexName = (_c = configs == null ? void 0 : configs.ALGOLIASEARCH_INDEX) != null ? _c : null;
  const [state, setSearchState] = useReducer3(searchReducer, {
    response: hydratedResponse != null ? hydratedResponse : null,
    page: initialPage,
    queryString: initialQueryString,
    userFilters: initialUserFilters,
    loading: false,
    myContent: initialMyContent
  });
  const { response, userFilters, error, loading, queryString } = state;
  const { search: search2, globalSearch, suggestions } = response != null ? response : {};
  const querySuggestions = applyQuerySuggestionsUpdates({
    hits: suggestions
  });
  const previousHits = useRef19(
    void 0
  );
  const hits = applyHitsUpdates({
    page: search2 == null ? void 0 : search2.page,
    nextHits: search2 == null ? void 0 : search2.hits,
    prevHits: (_e = (_d = previousHits.current) == null ? void 0 : _d.hits) != null ? _e : [],
    fallbackHits: (_g = (_f = search2 == null ? void 0 : search2.hits) != null ? _f : globalSearch == null ? void 0 : globalSearch.hits) != null ? _g : [],
    queryID: search2 == null ? void 0 : search2.queryID,
    locale
  });
  const showWhenNoResults = applyHitsUpdates({
    fallbackHits: (_h = globalSearch == null ? void 0 : globalSearch.hits) != null ? _h : [],
    nextHits: globalSearch == null ? void 0 : globalSearch.hits,
    prevHits: (_j = (_i = previousHits.current) == null ? void 0 : _i.hits) != null ? _j : [],
    queryID: globalSearch == null ? void 0 : globalSearch.queryID,
    page: globalSearch == null ? void 0 : globalSearch.page,
    locale
  });
  const myContent = useMyContentFilters(state.myContent);
  const filterGroups2 = useMemo35(() => {
    const groups = getFacetsFromAlgoliaResponse({
      userFilters,
      response,
      locale
    });
    if (isLoggedIn && myContent.filterGroup.items.length > 0) {
      groups.push(myContent.filterGroup);
    }
    return groups.filter(isVisible).sort(byImportance);
  }, [isLoggedIn, locale, myContent.filterGroup, response, userFilters]);
  const page = (_k = search2 == null ? void 0 : search2.page) != null ? _k : 0;
  const nbPages = (_l = search2 == null ? void 0 : search2.nbPages) != null ? _l : 0;
  const hasMore = page < nbPages - 1;
  const nbHits = (_m = search2 == null ? void 0 : search2.nbHits) != null ? _m : 0;
  const maxHits = (_n = globalSearch == null ? void 0 : globalSearch.nbHits) != null ? _n : 0;
  const doAlgoliaRequest = useCallback50(
    (params) => __async(void 0, null, function* () {
      var _a2, _b2, _c2, _d2;
      if (!indexName || !appId || !searchKey) {
        console.warn("Algolia credentials missing", {
          indexName,
          appId,
          searchKey
        });
        return;
      }
      if (params.page === 0) {
        previousHits.current = void 0;
      }
      const userFilters2 = (_a2 = params.userFilters) != null ? _a2 : state.userFilters;
      const query2 = (_b2 = params.queryString) != null ? _b2 : state.queryString;
      const myContentState = (_c2 = params.myContent) != null ? _c2 : state.myContent;
      const myContentFilters = myContent.getFilters(myContentState);
      const page2 = (_d2 = params.page) != null ? _d2 : 0;
      setSearchState({
        error: void 0,
        loading: true,
        userFilters: userFilters2,
        queryString: query2,
        myContent: myContentState,
        page: page2
      });
      try {
        const response2 = yield fetchSearchResults({
          indexName,
          appId,
          searchKey,
          enableQuerySuggestions,
          accountId: auth == null ? void 0 : auth.accountId,
          query: query2,
          page: page2,
          locale,
          userFilters: userFilters2,
          myContentFilters,
          hitsPerPage,
          initialRequest: params.initialRequest,
          sqh,
          preferredClients: featureData == null ? void 0 : featureData.preferredClients
        });
        previousHits.current = { hits, page: page2 };
        setSearchState({
          response: response2,
          loading: false,
          error: void 0
        });
        return response2;
      } catch (error2) {
        if (error2 instanceof DebounceError) {
          return;
        }
        setSearchState({ loading: false, error: error2 });
      }
    }),
    [
      appId,
      auth == null ? void 0 : auth.accountId,
      enableQuerySuggestions,
      featureData == null ? void 0 : featureData.preferredClients,
      hits,
      hitsPerPage,
      indexName,
      locale,
      myContent,
      searchKey,
      sqh,
      state.myContent,
      state.queryString,
      state.userFilters
    ]
  );
  const query = useMemo35(
    () => debounce(
      (_0) => __async(void 0, [_0], function* ({ page: page2, query: query2 }) {
        const response2 = yield doAlgoliaRequest({ queryString: query2, page: page2 });
        if (query2) {
          emit6("query", { queryString: query2, response: response2 });
        }
      }),
      250,
      { maxWait: 750, leading: true }
    ),
    [doAlgoliaRequest]
  );
  useCheckMetaCollectionTranslations(filterGroups2);
  const setTagFacet = useCallback50(
    (userFilter) => __async(void 0, null, function* () {
      var _a2;
      const { value, id, name } = userFilter;
      const nextFilters = __spreadProps(__spreadValues({}, state.userFilters), {
        [id]: {
          type: "tag",
          filters: __spreadProps(__spreadValues({}, (_a2 = state.userFilters[id]) == null ? void 0 : _a2.filters), {
            [name]: value
          })
        }
      });
      yield doAlgoliaRequest({ userFilters: nextFilters });
      emit6("filtersChanged", { id, name, value });
    }),
    [doAlgoliaRequest, state.userFilters]
  );
  const setRangeFilter = useCallback50(
    (userFilter) => __async(void 0, null, function* () {
      var _a2, _b2, _c2;
      const nextFilters = __spreadProps(__spreadValues({}, state.userFilters), {
        [userFilter.id]: {
          type: "range",
          filters: {
            max: userFilter.value.max,
            min: userFilter.value.min
          }
        }
      });
      const filterGroup = getFilterGroup(userFilter.id);
      const algoliaFacetId = filterGroup.algoliaFacetId({ locale });
      const stats = (_c2 = (_b2 = (_a2 = state.response) == null ? void 0 : _a2.globalSearch) == null ? void 0 : _b2.facets_stats) == null ? void 0 : _c2[algoliaFacetId];
      const hasDefaultValue = stats && userFilter.value.max === stats.max && userFilter.value.min === stats.min;
      if (hasDefaultValue) {
        delete nextFilters[userFilter.id];
      }
      yield doAlgoliaRequest({ userFilters: nextFilters });
      emit6("filtersChanged", {
        id: userFilter.id,
        name: void 0,
        value: void 0
      });
    }),
    [
      doAlgoliaRequest,
      locale,
      (_p = (_o = state.response) == null ? void 0 : _o.globalSearch) == null ? void 0 : _p.facets_stats,
      state.userFilters
    ]
  );
  const setMyContentFilter = useCallback50(
    (_0) => __async(void 0, [_0], function* ({
      name,
      value: newValue
    }) {
      const value = toggleFacetFilterValue(
        newValue,
        state.myContent[name].value
      );
      const myContent2 = __spreadProps(__spreadValues({}, state.myContent), {
        [name]: { value }
      });
      yield doAlgoliaRequest({ myContent: myContent2 });
      emit6("filtersChanged", { id: FilterGroupId.myContent, name, value });
    }),
    [doAlgoliaRequest, state.myContent]
  );
  const resetFilters = useCallback50(() => __async(void 0, null, function* () {
    previousHits.current = void 0;
    const myContent2 = toMyContentState();
    if (state.queryString) {
      yield doAlgoliaRequest({
        queryString: state.queryString,
        myContent: myContent2,
        userFilters: {},
        page: 0
      });
    } else {
      setSearchState({
        userFilters: {},
        page: 0,
        myContent: myContent2,
        response: state.response ? __spreadProps(__spreadValues({}, state.response), {
          search: state.response.globalSearch
        }) : void 0
      });
    }
    emit6("reset");
  }), [doAlgoliaRequest, state.queryString, state.response]);
  const reset = useCallback50(() => {
    previousHits.current = void 0;
    const myContent2 = toMyContentState();
    setSearchState({
      userFilters: {},
      page: 0,
      myContent: myContent2,
      response: state.response ? __spreadProps(__spreadValues({}, state.response), {
        search: state.response.globalSearch
      }) : void 0,
      queryString: ""
    });
    emit6("reset");
  }, [state]);
  const getMore = useCallback50(() => __async(void 0, null, function* () {
    if (!state.loading && hasMore) {
      yield doAlgoliaRequest({ page: state.page + 1 });
      emit6("moreResultsLoaded");
    }
  }), [doAlgoliaRequest, hasMore, state.loading, state.page]);
  const applyQueryParams = useCallback50(
    (variables) => __async(void 0, null, function* () {
      const { userFilters: userFilters2, myContent: myContent2, query: query2, page: page2 } = getFilters(variables);
      yield doAlgoliaRequest({
        myContent: myContent2,
        queryString: query2,
        userFilters: userFilters2,
        page: page2
      });
    }),
    [doAlgoliaRequest]
  );
  const activeFilterGroupsCount = filterGroups2.reduce(
    (a, f) => a + f.activeCount,
    0
  );
  const urlState = useUrlState({
    filterGroups: filterGroups2,
    hitsPerPage,
    query: state.queryString,
    page: state.page
  });
  useRefetchWhenNeeded({
    refetch: () => doAlgoliaRequest({}),
    myContent: state.myContent
  });
  const history = useSearchHistory({ state });
  const saved = useSaved({
    urlState,
    state
  });
  const activeFilters = useActiveFilters()({
    myContent: state.myContent,
    state,
    userFilters
  });
  const ideas = useIdeas({ state, querySuggestions });
  const shortcuts = useMemo35(
    () => [
      {
        id: "active-filters",
        title: t("search.filters_title"),
        icon: "filter",
        visible: !!activeFilters.length,
        data: activeFilters.map((f) => {
          const onRemove = () => {
            switch (f.type) {
              case "tag":
                return setTagFacet({
                  id: f.id,
                  name: f.name,
                  value: false
                });
              case "range":
                return setRangeFilter({ id: f.id, value: f.defaults });
              case "myContent":
                return setMyContentFilter({ name: f.name, value: false });
            }
          };
          return {
            id: f.id,
            title: f.label,
            renderAs: { type: "tag", value: f.value },
            onRemove,
            onPress: onRemove
            // active filters are removed on press
          };
        })
      },
      {
        id: "history",
        title: t("search.history"),
        icon: "reset",
        visible: history.items.length > 0 && state.queryString.length === 0 && activeFilterGroupsCount === 0,
        data: history.items.map((h) => ({
          id: h,
          title: h,
          renderAs: { type: "text", active: state.queryString === h },
          onPress: () => query({ query: h }),
          onRemove: () => history.remove(h)
        }))
      },
      {
        id: "saved",
        title: t("search.saved"),
        icon: "pin",
        visible: saved.items.length > 0,
        data: saved.items.map((s) => ({
          id: s.data,
          renderAs: {
            type: "text",
            active: urlState.toString() === s.data
          },
          title: s.label,
          onPress: () => applyQueryParams(toSearchQueryParams(s.data)),
          onRemove: () => saved.remove(s.data)
        }))
      },
      {
        id: "ideas",
        title: t("search.suggestions"),
        icon: "lightbulb",
        visible: ideas.items.length > 0,
        data: ideas.items.map(({ data, label, personalized, type: type2 }) => ({
          id: data,
          title: label,
          renderAs: {
            type: "text",
            active: urlState.toString() === data
          },
          extraTrackingParams: { personalized, type: type2 },
          onPress: () => applyQueryParams(toSearchQueryParams(data)),
          onRemove: () => ideas.remove(data)
        }))
      }
    ].filter((s) => s.visible).map((_a2) => {
      var _b2 = _a2, { visible: _visible } = _b2, rest = __objRest(_b2, ["visible"]);
      return rest;
    }).map((shortcut) => __spreadProps(__spreadValues({}, shortcut), {
      data: shortcut.data.map((d, index) => {
        const trackingParams = __spreadValues({
          shortcut: shortcut.id,
          position: index,
          id: d.id
        }, "extraTrackingParams" in d ? d.extraTrackingParams : {});
        return __spreadProps(__spreadValues({}, d), {
          onPress: () => {
            d.onPress();
            track("search/usedShortcut", trackingParams);
          },
          onRemove: () => {
            d.onRemove();
            track("search/removedShortcut", trackingParams);
          }
        });
      })
    })),
    [
      activeFilterGroupsCount,
      activeFilters,
      applyQueryParams,
      history,
      ideas,
      query,
      saved,
      setMyContentFilter,
      setRangeFilter,
      setTagFacet,
      state.queryString,
      t,
      track,
      urlState
    ]
  );
  const setTagFilter = useCallback50(
    ({
      id,
      name,
      value
    }) => {
      var _a2, _b2;
      if (id === FilterGroupId.myContent) {
        setMyContentFilter({ name, value });
        return;
      }
      const group = filterGroups2.find((f) => f.id === id);
      const current = (_b2 = (_a2 = group == null ? void 0 : group.items.find((i) => i.name === name)) == null ? void 0 : _a2.value) != null ? _b2 : false;
      const newValue = toggleFacetFilterValue(value, current);
      setTagFacet({ id, name, value: newValue });
    },
    [filterGroups2, setMyContentFilter, setTagFacet]
  );
  const getCurrentFilterGroup = useCallback50(
    (filterId) => {
      return filterGroups2.find(
        (group) => group.id === filterId
      );
    },
    [filterGroups2]
  );
  const readyForInitialRequest = !!(!myContent.loading && indexName && appId && searchKey && featureReady);
  const ready = readyForInitialRequest && !isBooting && !!response && !saved.loading;
  const initiated = useRef19(false);
  useEffect35(() => {
    if (initiated.current)
      return;
    if (!readyForInitialRequest)
      return;
    if (hydratedResponse)
      return;
    doAlgoliaRequest({ page: initialPage, initialRequest: true });
    initiated.current = true;
  }, [doAlgoliaRequest, hydratedResponse, initialPage, readyForInitialRequest]);
  useEffect35(() => {
    return onEvent7(({ name, payload }) => {
      if (name === "filtersChanged")
        track("searchFilterChanged", payload);
      if (name === "reset")
        track("searchReset");
    });
  }, [track]);
  const hasActiveShortcut = shortcuts.some(
    (s) => s.data.some((d) => d.renderAs.type === "text" && d.renderAs.active)
  );
  return /* @__PURE__ */ jsx13(
    SearchContext.Provider,
    {
      value: {
        setRangeFilter,
        resetFilters,
        reset,
        querySuggestions: hasActiveShortcut ? void 0 : querySuggestions,
        query: useCallback50((q) => query({ query: q }), [query]),
        hits,
        showWhenNoResults,
        page: ((_q = state.page) != null ? _q : 0) + 1,
        nbPages,
        hasMore,
        nbHits,
        maxHits,
        getMore,
        ready,
        urlState,
        activeFilterGroupsCount,
        filterGroups: filterGroups2,
        applyQueryParams,
        hitsPerPage,
        shortcuts,
        setTagFilter,
        getFilterGroup: getCurrentFilterGroup,
        activeSearchQuery: queryString,
        algoliaSearchIndex: (_r = response == null ? void 0 : response.search) == null ? void 0 : _r.index,
        response,
        error,
        loading,
        saveButton: saved.button
      },
      children
    }
  );
};

// src/~react-hooks/useSearch/useSearch.tsx
import { useContext as useContext15, useEffect as useEffect36 } from "react";
var useSearch = (options) => {
  useEffect36(() => {
    if (options == null ? void 0 : options.onEvent)
      return onEvent7(options.onEvent);
  }, [options == null ? void 0 : options.onEvent]);
  return useContext15(SearchContext);
};

// src/~react-hooks/useServiceAvailability/useServiceAvailability.ts
import { useCallback as useCallback51, useEffect as useEffect37, useMemo as useMemo36, useState as useState18 } from "react";
var ServiceAvailabilityType = /* @__PURE__ */ ((ServiceAvailabilityType2) => {
  ServiceAvailabilityType2["General"] = "General";
  ServiceAvailabilityType2["Checkout"] = "Checkout";
  return ServiceAvailabilityType2;
})(ServiceAvailabilityType || {});
var fetchServiceAvailabilityMessages = (uri) => __async(void 0, null, function* () {
  var _a;
  try {
    const res = yield fetch(uri);
    if (res.ok) {
      const result = yield res.json();
      return (_a = result.serviceAvailabilityEntries) != null ? _a : [];
    }
  } catch (e) {
  }
  return [];
});
var getServiceUri = (environment) => {
  switch (environment) {
    case "alpha" /* alpha */:
      return "https://serviceavailability-staging.sfanytime.com";
    default:
    case "production" /* production */:
      return "https://serviceavailability.sfanytime.com";
  }
};
var titleKeys = {
  ["Checkout" /* Checkout */]: "service_availability.checkout.title",
  ["General" /* General */]: "service_availability.generic.title"
};
var defaultReshowAfterHours = 1;
var defaultReShowAfterSeconds = defaultReshowAfterHours * 60 * 60;
var useServiceAvailability = ({
  type: type2,
  environment,
  polling,
  reShowAfterSeconds = defaultReShowAfterSeconds
}) => {
  const uri = getServiceUri(environment);
  const { device, locale } = useApp_default();
  const { t } = useL10n_default();
  const [dismissed, setIsDismissed] = useState18([]);
  const [allMessages, setAllMessages] = useState18([]);
  const dismiss = useCallback51((message) => {
    if (!message)
      return;
    const dismissedAt = (/* @__PURE__ */ new Date()).toISOString();
    const dismiss2 = { id: message.id, dismissedAt };
    setIsDismissed((dismisses) => [...dismisses, dismiss2]);
  }, []);
  const isValidDismiss = useCallback51(
    (dismiss2) => {
      const dismissExpiresAt = new Date(
        new Date(dismiss2.dismissedAt).getTime() + reShowAfterSeconds * 1e3
      );
      const hasExpired = dismissExpiresAt.getTime() < (/* @__PURE__ */ new Date()).getTime();
      return !hasExpired;
    },
    [reShowAfterSeconds]
  );
  const isDismissed = useCallback51(
    ({ id }) => dismissed.filter((d) => d.id === id).some(isValidDismiss),
    [dismissed, isValidDismiss]
  );
  const checkForNewMessages = useCallback51(() => __async(void 0, null, function* () {
    const messages = yield fetchServiceAvailabilityMessages(uri);
    setAllMessages(messages);
  }), [uri]);
  useEffect37(() => {
    checkForNewMessages();
  }, [checkForNewMessages]);
  useEffect37(() => {
    if (!(polling == null ? void 0 : polling.enabled))
      return;
    const interval = setInterval(() => {
      checkForNewMessages();
    }, polling.intervalSeconds * 1e3);
    return () => clearInterval(interval);
  }, [checkForNewMessages, polling]);
  const messagesToShow = useMemo36(
    () => allMessages.filter(
      (message) => {
        var _a;
        return ((_a = message.targets) == null ? void 0 : _a.includes(device.type)) && message.type === type2;
      }
    ).map((message) => {
      const { type: type3, publishedAt, text: texts } = message;
      const text = texts == null ? void 0 : texts[locale];
      const titleKey = titleKeys[type3 != null ? type3 : "General" /* General */];
      if (text == null) {
        return null;
      }
      return {
        id: publishedAt != null ? publishedAt : text,
        text,
        title: t(titleKey)
      };
    }).filter(exists).filter((m) => !isDismissed(m)),
    [allMessages, device.type, isDismissed, locale, t, type2]
  );
  return {
    checkForNewMessages,
    messagesToShow,
    dismiss
  };
};

// src/~react-hooks/useVerifyUnknownReceipt/useVerifyUnknownReceipt.ts
import { useMutation as useMutation17 } from "@apollo/client";
import { useCallback as useCallback52 } from "react";
var useVerifyUnknownReceipt = () => {
  const [mutate, { error, loading, data }] = useMutation17(GQL_VERIFY_UNKNOWN_RECEIPT_default);
  const verifyUnknownReceipt = useCallback52(
    (_0) => __async(void 0, [_0], function* ({ receipt, store: store2 }) {
      const response = yield mutate({
        variables: {
          input: {
            paymentProcessor: store2,
            payment: { [store2]: receipt }
          }
        }
      });
      return response.data.verifyUnknownInAppPurchaseReceipt;
    }),
    [mutate]
  );
  return { verifyUnknownReceipt, error, loading, data };
};

// src/~react-hooks/useTicketBoughtReturnUrl/useTicketBoughtReturnUrl.ts
import { atom as atom6 } from "jotai";
import { useAtomValue as useAtomValue3, useSetAtom as useSetAtom4 } from "jotai";
import { useMemo as useMemo37 } from "react";
var returnUrlAtom = atom6(null);
var useTicketBoughtReturnUrl = () => {
  const url = useAtomValue3(returnUrlAtom);
  const set = useSetAtom4(returnUrlAtom);
  return useMemo37(
    () => ({ get: () => url, set, remove: () => set(null) }),
    [url, set]
  );
};

// src/~react-hooks/useAsset/useAsset.ts
var useAsset = (props) => {
  const { name } = props;
  const { brand } = useApp_default();
  const url = getCdnAsset(__spreadValues({ brand }, props));
  if (isSvgKey(name)) {
    const svg = svgAssets[brand][name];
    const svgReturn = { svg, url };
    return svgReturn;
  }
  const nonSvgReturn = { url };
  return nonSvgReturn;
};
var isSvgKey = (key3) => key3 in svgAssets[Object.values(Brand)[0]];

// src/~react-hooks/useContextMenu/useContextMenu.tsx
import { useCallback as useCallback53, useMemo as useMemo38, useState as useState19 } from "react";
var useContextMenu = ({
  slug: slug3,
  origin,
  onPlayPressed,
  type: type2
}) => {
  const { bookmark } = useBookmark({ slug: slug3 });
  const { entitlement, canPlay } = useEntitlement_default({ slug: slug3 });
  const { track } = useTracker_default();
  const [isOpen, setOpen] = useState19(false);
  const {
    response: favorite,
    toggleMutation: [toggleFavorite]
  } = useFavorite_default({ slug: slug3 });
  const { markAsNotWatched, markAsWatched } = useBookmarkActions_default();
  const open = useCallback53(() => {
    setOpen(true);
    track("contextMenu/opened", { origin });
  }, [origin, track]);
  const close = useCallback53(() => {
    setOpen(false);
  }, []);
  const options = useMemo38(() => {
    const options2 = [];
    const addOption = (option) => {
      options2.push(__spreadProps(__spreadValues({}, option), {
        onPress: () => {
          track("contextMenu/itemSelected", { type: option.textKey });
          option.onPress();
        }
      }));
    };
    const canMarkAsWatched = type2 === "Episode" || type2 === "Movie";
    if (entitlement && canPlay) {
      addOption({
        textKey: "glossary.play_button",
        onPress: () => onPlayPressed({ slug: slug3 })
      });
    }
    if ((bookmark == null ? void 0 : bookmark.started) && canMarkAsWatched) {
      addOption({
        textKey: "glossary.mark_as_not_watched",
        onPress: () => markAsNotWatched({ slug: slug3 })
      });
    }
    if (!(bookmark == null ? void 0 : bookmark.completed) && canMarkAsWatched) {
      addOption({
        textKey: "glossary.mark_as_watched",
        onPress: () => markAsWatched({ slug: slug3 })
      });
    }
    if (favorite.isFavorited) {
      addOption({
        textKey: "glossary.remove_from_my_list",
        onPress: () => toggleFavorite()
      });
    }
    if (!favorite.isFavorited) {
      addOption({
        textKey: "glossary.add_to_my_list",
        onPress: () => toggleFavorite()
      });
    }
    return options2;
  }, [
    bookmark == null ? void 0 : bookmark.completed,
    bookmark == null ? void 0 : bookmark.started,
    canPlay,
    entitlement,
    favorite.isFavorited,
    markAsNotWatched,
    markAsWatched,
    onPlayPressed,
    slug3,
    toggleFavorite,
    track,
    type2
  ]);
  return { isOpen, options, open, close };
};

// src/~react-hooks/useProfiler/useProfiler.tsx
import { performance } from "isomorphic-performance";
import {
  createContext as createContext12,
  Profiler as ReactProfiler,
  useCallback as useCallback54,
  useContext as useContext16,
  useEffect as useEffect38,
  useRef as useRef20
} from "react";

// src/~react-hooks/useProfiler/measurement.ts
var readyToInteractAfterIdleMs = 500;
var createMeasurement = ({
  onRenderComplete,
  onRenderInterfered,
  now
}) => {
  let startTime;
  let accumulatedRenderDuration = 0;
  let lastRenderTime;
  let timeout;
  let currentRoute;
  let numberOfRenders = 0;
  const renderedRoutes = {};
  const reset = () => {
    startTime = now();
    accumulatedRenderDuration = 0;
    lastRenderTime = startTime;
    numberOfRenders = 0;
  };
  const getRouteKey = (route) => route ? `${route.name}-${JSON.stringify(route.params)}` : "unknown";
  return {
    didRender: (params) => {
      clearTimeout(timeout);
      const isNewRoute = getRouteKey(currentRoute) !== getRouteKey(params.route);
      if (isNewRoute) {
        reset();
      }
      currentRoute = params.route;
      accumulatedRenderDuration += params.renderDuration;
      if (!startTime)
        startTime = now();
      lastRenderTime = now();
      numberOfRenders++;
      timeout = setTimeout(() => {
        const routeKey = getRouteKey(currentRoute);
        const timeToInteractive = lastRenderTime - startTime;
        const firstRender = !renderedRoutes[routeKey];
        const type2 = firstRender ? "mount" : "update";
        renderedRoutes[routeKey] = true;
        onRenderComplete({
          route: params.route,
          timeToInteractive: getRoundMs(timeToInteractive),
          accumulatedRenderDuration: getRoundMs(accumulatedRenderDuration),
          rating: getTimeToInteractiveRating({ ttiMs: timeToInteractive }),
          type: type2,
          numberOfRenders
        });
        reset();
      }, readyToInteractAfterIdleMs);
    },
    cleanup: () => clearTimeout(timeout),
    invalidate: () => {
      if (!currentRoute)
        return;
      const routeKey = getRouteKey(currentRoute);
      const firstRender = !renderedRoutes[routeKey];
      const type2 = firstRender ? "mount" : "update";
      renderedRoutes[routeKey] = true;
      onRenderInterfered({ route: currentRoute, type: type2 });
      clearTimeout(timeout);
      reset();
    }
  };
};
var getRoundMs = (ms) => {
  const up = Math.ceil(ms);
  if (up < 100) {
    return up;
  }
  if (up < 300) {
    return Math.ceil(Math.round(up / 8.333333) * 8.333333);
  }
  if (up < 1e3) {
    return Math.ceil(Math.round(up / 16.66666) * 16.66666);
  }
  return Math.ceil(Math.round(up / 33.33333) * 33.33333);
};
var getTimeToInteractiveRating = ({
  ttiMs
}) => {
  if (ttiMs < 2468)
    return "Good";
  if (ttiMs < 3280)
    return "Ok";
  if (ttiMs < 4500)
    return "Bad";
  return "VeryBad";
};

// src/~react-hooks/useProfiler/useProfiler.tsx
import { jsx as jsx14 } from "react/jsx-runtime";
var typesToTrack = ["mount"];
var ProfilerContext = createContext12({});
var ProfilerProvider = ({
  children,
  getCurrentRoute,
  debug = false,
  performanceEngine = "isomorphic-performance"
}) => {
  const tracker2 = useTracker_default();
  const measurement = useRef20(
    createMeasurement({
      now: performanceEngine === "isomorphic-performance" ? performance.now : Date.now,
      onRenderInterfered: (data) => {
        if (!typesToTrack.includes(data.type))
          return;
        if (debug)
          console.log("renderInterfered", data);
        tracker2.track("profiling/renderInterfered", data);
      },
      onRenderComplete: (data) => {
        if (!typesToTrack.includes(data.type))
          return;
        if (debug)
          console.log("renderCompleted", data);
        tracker2.track("profiling/renderCompleted", data);
      }
    })
  );
  useEffect38(() => {
    var _a;
    return (_a = measurement.current) == null ? void 0 : _a.cleanup;
  }, [measurement]);
  const traceRender = useCallback54(
    (id, phase, duration, baseDuration, startTime, _commitTime, _interactions) => {
      var _a;
      const performanceMeasure = performanceEngine === "isomorphic-performance" ? performance.measure(id, { start: startTime, duration }) : { duration, startTime };
      const route = getCurrentRoute();
      measurement.current.didRender({
        route: { name: (_a = route == null ? void 0 : route.name) != null ? _a : "unknown", params: route == null ? void 0 : route.params },
        renderDuration: performanceMeasure.duration
      });
      return performanceMeasure;
    },
    [getCurrentRoute, performanceEngine]
  );
  return /* @__PURE__ */ jsx14(
    ProfilerContext.Provider,
    {
      value: { invalidate: measurement.current.invalidate },
      children: /* @__PURE__ */ jsx14(ReactProfiler, { id: getCurrentRoute().name, onRender: traceRender, children })
    }
  );
};
var useProfiler = () => useContext16(ProfilerContext);

// src/~react-hooks/useApolloCache/useApolloCache.ts
import { useApolloClient as useApolloClient9 } from "@apollo/client";
var useApolloCache = () => useApolloClient9().cache;

// src/~react-hooks/useLocalizations/useLocalizations.ts
var useLocalizations = ({ locale }) => {
  const { data, loading } = useQuery_default(
    GQL_GET_LOCALIZATIONS,
    {
      fetchPolicy: "cache-only",
      // long shot: should not be needed but potentially fixes a bug where network
      // requests occasionally are made to get localizations
      nextFetchPolicy: "cache-only",
      variables: { locale }
    }
  );
  return {
    loading,
    data: {
      response: { locale, items: data == null ? void 0 : data.localizations.items }
    }
  };
};

// src/~react-hooks/useQrUrl/useQrUrl.ts
var useQrUrl = (url) => {
  const { brand } = useApp_default();
  const domain = getProductionDomain(brand);
  return `${domain}/api/qr/${encodeURIComponent(url)}`;
};

// src/~react-hooks/usePersonalization/usePersonalization.ts
import { useMemo as useMemo39 } from "react";

// src/~graphql/queries/GQL_GET_PERSONALIZATION.ts
import { gql as gql85 } from "@apollo/client";
var GQL_GET_PERSONALIZATION_default = gql85`
  query GetPersonalizationQuery($avatarPreset: AvatarPreset) {
    response: personalization {
      items {
        __typename
        ... on Personalization {
          count
        }
        ... on TopActorPersonalization {
          actor {
            id
            name
            avatar(preset: $avatarPreset)
          }
        }
        ... on TopDirectorPersonalization {
          director {
            id
            name
            avatar(preset: $avatarPreset)
          }
        }
        ... on TopGenrePersonalization {
          slug
        }
        ... on TopMetaCollectionPersonalization {
          slug
        }
        ... on TopYearPersonalization {
          year
        }
        ... on TopImdbRatingPersonalization {
          rating
        }
      }
    }
  }
`;

// src/~react-hooks/usePersonalization/usePersonalization.ts
var usePersonalization = () => {
  const { isLoggedIn } = useSession_default();
  const _a = useQuery_default(GQL_GET_PERSONALIZATION_default, {
    skip: !isLoggedIn,
    variables: { avatarPreset: "circle" /* circle */ }
  }), { data } = _a, rest = __objRest(_a, ["data"]);
  return useMemo39(() => {
    var _a2, _b, _c, _d, _e;
    const items = (_b = (_a2 = data == null ? void 0 : data.response) == null ? void 0 : _a2.items) != null ? _b : [];
    return __spreadProps(__spreadValues({}, rest), {
      response: data == null ? void 0 : data.response,
      items,
      actors: (_c = items == null ? void 0 : items.filter((i) => i.__typename === "TopActorPersonalization").map((a) => a.actor)) != null ? _c : [],
      directors: (_d = items == null ? void 0 : items.filter((i) => i.__typename === "TopDirectorPersonalization").map((a) => a.director)) != null ? _d : [],
      genres: (_e = items == null ? void 0 : items.filter((i) => i.__typename === "TopGenrePersonalization").map((a) => a.slug)) != null ? _e : []
    });
  }, [data == null ? void 0 : data.response, rest]);
};

// src/~react-hooks/useThumbnail/useThumbnail.tsx
import { atom as atom7, useAtomValue as useAtomValue4, useSetAtom as useSetAtom5 } from "jotai";
import { useCallback as useCallback55 } from "react";
var currentSlugAtom = atom7(null);
var useThumbnail = (props = {}) => {
  const { configs } = useApp_default();
  const currentSlug = useAtomValue4(currentSlugAtom);
  const setCurrentSlug = useSetAtom5(currentSlugAtom);
  const slug3 = (props == null ? void 0 : props.slug) || currentSlug;
  const getThumbnail = useCallback55(
    (percentage, cfg = {}) => {
      const thumbnailSlug = (cfg == null ? void 0 : cfg.slug) || slug3;
      const FRMX_URL = configs.FRMX_URL;
      if (!thumbnailSlug || !FRMX_URL)
        return null;
      const srcUrl = `${FRMX_URL}`.replace("{slug}", thumbnailSlug).replace("{time}", percentage.toFixed(1).toString()).replace("{src}", "json").replace("{type}", "f").replace("{hash}", "p16").replace("{unit}", "p");
      const src = new URL(srcUrl);
      return {
        src: src.toString()
      };
    },
    [slug3, configs]
  );
  return { getThumbnail, setCurrentSlug };
};

// src/~react-hooks/useLanguages/useLanguages.ts
import { useEffect as useEffect39, useState as useState20 } from "react";
var useLanguages = () => {
  var _a;
  const [data, setData] = useState20(
    void 0
  );
  const [loading, setLoading] = useState20(true);
  const [error, setError] = useState20(void 0);
  useEffect39(() => {
    const timer = setTimeout(() => {
      try {
        setData({ languages: mockList });
        setLoading(false);
      } catch (e) {
        setError(e);
        setLoading(false);
      }
    }, 500);
    return () => clearTimeout(timer);
  }, []);
  return { languages: (_a = data == null ? void 0 : data.languages) != null ? _a : [], loading, error };
};
var mockList = [
  {
    id: "sv",
    "iso-639-1": "sv",
    "iso-639-2": "swe",
    name: "Swedish",
    nativeName: "Svenska",
    localizedNames: {
      en: "Swedish",
      sv: "Svenska",
      no: "Svensk",
      da: "Svensk",
      fi: "Ruotsi"
    }
  },
  {
    id: "no",
    "iso-639-1": "no",
    "iso-639-2": "nor",
    name: "Norwegian",
    nativeName: "Norsk",
    localizedNames: {
      en: "Norwegian",
      sv: "Norska",
      no: "Norsk",
      da: "Norsk",
      fi: "Norja"
    }
  },
  {
    id: "da",
    "iso-639-1": "da",
    "iso-639-2": "dan",
    name: "Danish",
    nativeName: "Dansk",
    localizedNames: {
      en: "Danish",
      sv: "Danska",
      no: "Dansk",
      da: "Dansk",
      fi: "Tanska"
    }
  },
  {
    id: "fi",
    "iso-639-1": "fi",
    "iso-639-2": "fin",
    name: "Finnish",
    nativeName: "Suomi",
    localizedNames: {
      en: "Finnish",
      sv: "Finska",
      no: "Finsk",
      da: "Finsk",
      fi: "Suomi"
    }
  },
  {
    id: "en",
    "iso-639-1": "en",
    "iso-639-2": "eng",
    name: "English",
    nativeName: "English",
    localizedNames: {
      en: "English",
      sv: "Engelska",
      no: "Engelsk",
      da: "Engelsk",
      fi: "Englanti"
    }
  },
  {
    id: "de",
    "iso-639-1": "de",
    "iso-639-2": "ger",
    name: "German",
    nativeName: "Deutsch",
    localizedNames: {
      en: "German",
      sv: "Tyska",
      no: "Tysk",
      da: "Tysk",
      fi: "Saksaksi"
    }
  },
  {
    id: "fr",
    "iso-639-1": "fr",
    "iso-639-2": "fre",
    name: "French",
    nativeName: "Fran\xE7ais",
    localizedNames: {
      en: "French",
      sv: "Franska",
      no: "Fransk",
      da: "Fransk",
      fi: "Ranskalainen"
    }
  }
];

// src/~react-common/events/types.ts
var TrackerCategory = /* @__PURE__ */ ((TrackerCategory2) => {
  TrackerCategory2["Required"] = "required";
  TrackerCategory2["Performance"] = "performance";
  TrackerCategory2["Statistics"] = "statistics";
  TrackerCategory2["Marketing"] = "marketing";
  return TrackerCategory2;
})(TrackerCategory || {});

// src/~react-common/contexts/EventsContext/EventTracker.ts
import uniq2 from "lodash/uniq";
var STORAGE_NAME = "cookieConsent";
var EventTracker = class {
  constructor() {
    this.trackers = [];
  }
  userHasConsented() {
    return __async(this, null, function* () {
      try {
        return Array.isArray(yield this.getStoredConsents());
      } catch (error) {
        return false;
      }
    });
  }
  getStoredConsents() {
    return __async(this, null, function* () {
      if (!this.context) {
        throw new Error("Context not ready");
      }
      return this.context.storage.get(STORAGE_NAME);
    });
  }
  getConsents() {
    return __async(this, null, function* () {
      var _a;
      let consents = ["required" /* Required */];
      if (!((_a = this.context) == null ? void 0 : _a.storage)) {
        return consents;
      }
      try {
        const stored = yield this.getStoredConsents();
        if (stored) {
          consents = consents.concat(stored);
        }
      } catch (error) {
      }
      return uniq2(consents).sort();
    });
  }
  setConsents(c) {
    var _a;
    if (!((_a = this.context) == null ? void 0 : _a.storage)) {
      return ["required" /* Required */];
    }
    try {
      if (!c.includes("required" /* Required */)) {
        c.push("required" /* Required */);
      }
      this.context.storage.set(STORAGE_NAME, c);
    } catch (error) {
      return ["required" /* Required */];
    }
    return uniq2(c).sort();
  }
  registerTrackers(trackers, newContext) {
    return __async(this, null, function* () {
      if (newContext)
        this.context = newContext;
      trackers.forEach((tracker2) => {
        if (tracker2.__loaded) {
          return;
        }
        if (this.trackers.filter((t) => t.id === tracker2.id).length > 0)
          return;
        tracker2.__loaded = true;
        tracker2.__initialized = false;
        this.trackers.push(tracker2);
      });
      yield this.loadTrackers();
    });
  }
  loadTrackers() {
    return __async(this, null, function* () {
      return Promise.all(
        this.trackers.map((tracker2) => __async(this, null, function* () {
          if (!(yield this.getConsents()).includes(tracker2.category))
            return;
          if (tracker2.__initialized || !this.context)
            return;
          tracker2.__initialized = true;
          tracker2.onLoad(this.context);
        }))
      );
    });
  }
  unregisterTrackers() {
    this.trackers.forEach((tracker2) => {
      if (!tracker2.__loaded) {
        return;
      }
      tracker2.__loaded = false;
      tracker2.__initialized = false;
    });
    this.trackers = [];
  }
  callEvent(event, newContext) {
    return __async(this, null, function* () {
      if (newContext)
        this.context = newContext;
      let consents;
      try {
        consents = yield this.getConsents();
      } catch (err) {
        console.warn("Failed to fetch consents", err);
        return;
      }
      this.trackers.forEach((tracker2) => {
        if (!consents.includes(tracker2.category)) {
          return;
        }
        if (!this.context) {
          console.warn("No context available for tracker", tracker2.category);
          return;
        }
        try {
          tracker2.listener(event, this.context);
        } catch (err) {
          console.warn(`Tracker "${tracker2.id}" threw an error`, err);
        }
      });
    });
  }
  getTrackers() {
    return this.trackers;
  }
};

// src/~react-common/contexts/EventsContext/EventTrackerContext.tsx
import { jsx as jsx15 } from "react/jsx-runtime";
var tracker = new EventTracker();
var EventTrackerContext = createContext13(
  {}
);
var formatConsents = (accepted) => {
  return Object.fromEntries(
    new Map(
      Object.values(TrackerCategory).map((t) => [t, accepted.includes(t)])
    )
  );
};
var EventTrackerContextProvider = ({
  children,
  trackers
}) => {
  const app = useApp_default();
  const { deviceInfoLoaded } = app;
  const [ready, setReady] = useState21(false);
  const [userHasConsented, setUserHasConsented] = useState21(
    void 0
  );
  const cache = useApolloCache();
  const readMedia2 = useCallback56(
    ({ slug: slug3 }) => {
      const media = readMedia({
        slug: slug3,
        cache,
        fragment: TRACKING_FRAGMENT_default
      });
      if (!media)
        throw new Error(`Media not found: ${slug3}`);
      return media;
    },
    [cache]
  );
  const readTransaction = useCallback56(
    ({ transactionId }) => {
      const transaction = cache.readFragment({
        id: transactionId,
        fragment: TRANSACTION_FRAGMENT_default,
        fragmentName: "TransactionParts",
        returnPartialData: true
      });
      if (!transaction)
        throw new Error(`Transaction not found: ${transactionId}`);
      return transaction;
    },
    [cache]
  );
  const ga = useRef21(
    googleAnalytics({ readMedia: readMedia2, locale: app.locale, readTransaction })
  ).current;
  const [consents, setConsents] = useState21(void 0);
  const context = useRef21(__spreadProps(__spreadValues({}, app), {
    ready,
    ga,
    readMedia: readMedia2,
    readTransaction,
    consents
  }));
  context.current = __spreadProps(__spreadValues({}, app), { ready, ga, readMedia: readMedia2, readTransaction, consents });
  useEffect40(() => {
    if (deviceInfoLoaded !== true)
      return;
    tracker.context = context.current;
    (() => __async(void 0, null, function* () {
      setConsents(formatConsents(yield tracker.getConsents()));
      setUserHasConsented(yield tracker.userHasConsented());
    }))();
  }, [context, trackers, deviceInfoLoaded]);
  useEffect40(() => {
    if (deviceInfoLoaded !== true)
      return;
    if (!consents)
      return;
    (() => __async(void 0, null, function* () {
      yield tracker.registerTrackers(trackers, context.current);
      setReady(true);
    }))();
  }, [consents, context, trackers, deviceInfoLoaded]);
  useEffect40(() => {
    return () => {
      tracker.unregisterTrackers();
    };
  }, []);
  const toggleConsent = useCallback56(
    (c) => __async(void 0, null, function* () {
      if (!tracker || !consents)
        return;
      const updated = __spreadValues({}, consents);
      updated[c] = !updated[c];
      const updatedActiveConsent = Object.fromEntries(
        Object.entries(updated).filter(([_key, value2]) => value2 === true)
      );
      setConsents(
        formatConsents(
          tracker.setConsents(
            Object.keys(updatedActiveConsent)
          )
        )
      );
      setUserHasConsented(yield tracker.userHasConsented());
    }),
    [consents]
  );
  const consentAll = useCallback56(() => __async(void 0, null, function* () {
    if (!tracker || !consents)
      return;
    setConsents(
      formatConsents(
        tracker.setConsents(
          Object.values(TrackerCategory)
        )
      )
    );
    setUserHasConsented(yield tracker.userHasConsented());
  }), [consents]);
  const track_deprecated = useCallback56(
    (event) => {
      if (!tracker || !context) {
        return;
      }
      tracker.callEvent(event, context.current);
    },
    [context]
  );
  const track = useCallback56(
    (...params) => __async(void 0, null, function* () {
      if (!tracker || !context) {
        return;
      }
      const event = { type: params[0], payload: params[1] };
      tracker.callEvent(event, context.current);
    }),
    []
  );
  const value = useMemo40(() => {
    return {
      ready,
      tracker,
      track_deprecated,
      track,
      context,
      consents,
      toggleConsent,
      consentAll,
      userHasConsented
    };
  }, [
    ready,
    track_deprecated,
    track,
    consents,
    toggleConsent,
    consentAll,
    userHasConsented
  ]);
  return /* @__PURE__ */ jsx15(EventTrackerContext.Provider, { value, children });
};

// src/~react-common/contexts/HookOptionsContext/HookOptionsContext.tsx
import { createContext as createContext14, useContext as useContext17, useMemo as useMemo41 } from "react";
import { jsx as jsx16 } from "react/jsx-runtime";
var HookOptionsContext = createContext14(null);
var HookOptionsProvider = ({ children, useMedia: useMedia2, useTicket: useTicket2 }) => {
  const value = useMemo41(() => ({ useMedia: useMedia2, useTicket: useTicket2 }), [useMedia2, useTicket2]);
  return /* @__PURE__ */ jsx16(HookOptionsContext.Provider, { value, children });
};
var useHookOptions = () => useContext17(HookOptionsContext);

// src/~react-common/theme/ThemeProvider/ThemeProvider.tsx
import merge5 from "lodash/merge";
import { ThemeProvider as SCThemeProvider } from "styled-components";
import { jsx as jsx17 } from "react/jsx-runtime";
var ThemeProvider2 = ({
  children,
  theme
}) => {
  const mainTheme = darkTheme_default;
  const customTheme = typeof theme === "function" ? theme(mainTheme) : theme;
  const mergedTheme = merge5(mainTheme, customTheme);
  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    /* @__PURE__ */ jsx17(SCThemeProvider, { theme: mergedTheme, children })
  );
};
var ThemeProvider_default = ThemeProvider2;

// src/~react-testing/storage/storageMock.ts
var mockStorage = (override) => {
  return __spreadValues({
    getProvider: () => localStorage,
    get: (key3) => __async(void 0, null, function* () {
      try {
        return JSON.parse(localStorage.getItem(key3) || "");
      } catch (e) {
        return null;
      }
    }),
    set: (key3, value) => __async(void 0, null, function* () {
      return Promise.resolve(localStorage.setItem(key3, JSON.stringify(value)));
    }),
    remove: (key3) => __async(void 0, null, function* () {
      return localStorage.removeItem(key3);
    }),
    clearAll: () => __async(void 0, null, function* () {
      return localStorage.clear();
    })
  }, override);
};

// src/~react-testing/router/routerMock.ts
var historyMock = (override) => {
  return __spreadValues({
    location: "/",
    listen: () => {
    },
    createHref: () => {
    }
  }, override);
};

// src/~react-testing/device/deviceMock.ts
var mockDevice = (override) => {
  return __spreadValues({
    token: "MockToken",
    id: "MockID1",
    model: "MockModel",
    type: "UnknownType" /* UnknownType */,
    version: "MockedVersion1",
    manufacturer: "MockManufacturer"
  }, override);
};

// src/~react-testing/MockedThemeProvider/MockedThemeProvider.tsx
import { jsx as jsx18 } from "react/jsx-runtime";
var MockedThemeProvider = ({
  children
}) => {
  return /* @__PURE__ */ jsx18(ThemeProvider_default, { theme: darkTheme_default, children });
};
var MockedThemeProvider_default = MockedThemeProvider;

// src/~react-testing/fakeTime.ts
var fakeTime = (date) => {
  const currentDate = new Date(date);
  global.Date = class extends Date {
    constructor(date2) {
      return date2 ? super(date2) : currentDate;
    }
  };
};

// src/~react-testing/mocks/accountEventSubscription.ts
var accountEventSubscription = {
  __typename: "AccountEvent",
  action: "TRANSACTION_STARTED" /* TRANSACTION_STARTED */,
  id: "123",
  payload: null,
  type: "EVENT" /* EVENT */
};

// src/~react-testing/mocks/contentcollection/contentcollection.ts
var contentCollection = {
  name: "Home",
  slug: "home",
  id: "ContentCollection:home",
  totalCount: 17,
  meta: {
    __typename: "ContentCollectionMetaData",
    title: "Home meta title",
    description: "Home meta description"
  },
  __typename: "ContentCollection",
  collection: {
    __typename: "ContentCollectionSliceConnection",
    pageInfo: {
      __typename: "PageInfo",
      hasNextPage: false,
      hasPreviousPage: false,
      startCursor: null,
      endCursor: null
    },
    edges: [
      {
        __typename: "ContentCollectionSliceEdge",
        node: {
          __typename: "Spotlights",
          promos: [
            {
              slug: "",
              tags: [],
              display: {
                __typename: "Display",
                caption: null,
                title: "lastletter",
                originalTitle: "lastletter"
              },
              displayableAsset: {
                __typename: "DisplayableInCollectionWithPromo",
                promo: "https://images.prismic.io/sfanytime/8eeeb636-7017-468f-be32-f1d8de105891_lastletterfromyourlover_1200x600_se.jpg?auto=compress,format"
              },
              link: {
                type: "Web",
                url: "https://www.sfanytime.com/sv/movie/35125/long-shot",
                __typename: "FeatureLink"
              },
              linkTarget: null,
              animation: null,
              target: null,
              __typename: "Feature"
            },
            {
              slug: "",
              tags: [],
              display: {
                __typename: "Display",
                caption: null,
                title: "lastletter2",
                originalTitle: "lastletter2"
              },
              displayableAsset: {
                __typename: "DisplayableInCollectionWithPromo",
                promo: "https://images.prismic.io/sfanytime/8eeeb636-7017-468f-be32-f1d8de105891_lastletterfromyourlover_1200x600_se.jpg?auto=compress,format"
              },
              link: {
                type: "Web",
                url: "https://www.sfanytime.com/sv/movie/34839/greta",
                __typename: "FeatureLink"
              },
              linkTarget: null,
              animation: null,
              target: null,
              __typename: "Feature"
            }
          ]
        }
      },
      {
        __typename: "ContentCollectionSliceEdge",
        node: {
          promoSize: "base" /* base */,
          __typename: "Promos",
          promos: [
            {
              slug: "",
              tags: [],
              display: {
                __typename: "Display",
                caption: null,
                title: "lastletter",
                originalTitle: "lastletter"
              },
              displayableAsset: {
                __typename: "DisplayableInCollectionWithPromo",
                promo: "https://images.prismic.io/sfanytime/8eeeb636-7017-468f-be32-f1d8de105891_lastletterfromyourlover_1200x600_se.jpg?auto=compress,format"
              },
              link: {
                type: "Web",
                url: "https://www.sfanytime.com/sv/movie/34438/uglydolls",
                __typename: "FeatureLink"
              },
              animation: null,
              target: null,
              linkTarget: null,
              __typename: "Feature"
            },
            {
              slug: "",
              tags: [],
              display: {
                __typename: "Display",
                caption: null,
                title: "lastletter2",
                originalTitle: "lastletter2"
              },
              displayableAsset: {
                __typename: "DisplayableInCollectionWithPromo",
                promo: "https://images.prismic.io/sfanytime/8eeeb636-7017-468f-be32-f1d8de105891_lastletterfromyourlover_1200x600_se.jpg?auto=compress,format"
              },
              link: {
                type: "Web",
                url: "https://www.sfanytime.com/sv/list/sf-studios-100-ar-80",
                __typename: "FeatureLink"
              },
              animation: null,
              target: null,
              linkTarget: null,
              __typename: "Feature"
            }
          ]
        }
      },
      {
        __typename: "ContentCollectionSliceEdge",
        node: {
          orderBy: "DEFAULT" /* DEFAULT */,
          __typename: "List",
          title: "Topplistan",
          slug: "filmer",
          items: [
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "avengers-endgame"
            },
            {
              __typename: "Series",
              linkTarget: null,
              tags: [],
              slug: "series-suits",
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "Suits",
                originalTitle: "Suits"
              }
            },
            {
              __typename: "Movie",
              linkTarget: null,
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              tags: [],
              slug: "dumbo"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              tags: [],
              slug: "a-star-is-born"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              tags: [],
              slug: "shazam"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              tags: [],
              slug: "alita-battle-angel"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              tags: [],
              slug: "bohemian-rhapsody"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              tags: [],
              slug: "pet-semetary-2019"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              tags: [],
              slug: "it-2017"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              tags: [],
              slug: "arctic"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              tags: [],
              slug: "after-"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              tags: [],
              slug: "pokemon-detective-pikachu"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              tags: [],
              slug: "captain-marvel"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              tags: [],
              slug: "hellboy-2019"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              tags: [],
              slug: "how-to-train-your-dragon-the-hidden-world"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              tags: [],
              slug: "long-shot"
            },
            {
              __typename: "Series",
              linkTarget: null,
              tags: [],
              slug: "series-downton-abbey",
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "Downton Abbey",
                originalTitle: "Downton Abbey"
              }
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "us"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "harry-potter-and-the-philosophers-stone"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "asterix-le-secret-de-la-potion-magique"
            }
          ].map((item) => __spreadProps(__spreadValues({}, item), {
            id: createMediaId({
              slug: item.slug,
              __typename: item.__typename
            })
          }))
        }
      },
      {
        __typename: "ContentCollectionSliceEdge",
        node: {
          orderBy: "DEFAULT" /* DEFAULT */,
          __typename: "List",
          title: "K\xF6ptoppen",
          slug: "filmer",
          items: [
            {
              __typename: "Series",
              linkTarget: null,
              tags: [],
              slug: "series-suits",
              id: "Media:series-suits",
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "Suits",
                originalTitle: "Suits"
              }
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "avengers-endgame",
              id: "Media:avengers-endgame"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "pokemon-detective-pikachu",
              id: "Media:pokemon-detective-pikachu"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "long-shot",
              id: "Media:long-shot"
            },
            {
              __typename: "Series",
              linkTarget: null,
              tags: [],
              slug: "series-downton-abbey",
              id: "Media:series-downton-abbey",
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "Downton Abbey",
                originalTitle: "Downton Abbey"
              }
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "amundsen",
              id: "Media:amundsen"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "dronningen",
              id: "Media:dronningen"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "uglydolls",
              id: "Media:uglydolls"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "mary-queen-of-scots",
              id: "Media:mary-queen-of-scots"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "ralph-breaks-the-internet",
              id: "Media:ralph-breaks-the-internet"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "the-lion-king",
              id: "Media:the-lion-king"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "moana",
              id: "Media:moana"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "greta",
              id: "Media:greta"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "bamse-och-tjuvstaden",
              id: "Media:bamse-och-tjuvstaden"
            },
            {
              __typename: "Series",
              linkTarget: null,
              tags: [],
              slug: "series-the-big-bang-theory",
              id: "Media:series-the-big-bang-theory",
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "The Big Bang Theory",
                originalTitle: "The Big Bang Theory"
              }
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "frozen-2013",
              id: "Media:frozen-2013"
            },
            {
              __typename: "Series",
              linkTarget: null,
              tags: [],
              slug: "series-badehotellet",
              id: "Media:series-badehotellet",
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "Badhotellet",
                originalTitle: "Badhotellet"
              }
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "the-little-mermaid",
              id: "Media:the-little-mermaid"
            },
            {
              __typename: "Series",
              linkTarget: null,
              tags: [],
              slug: "series-morden-i-sandhamn",
              id: "Media:series-morden-i-sandhamn",
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "Morden i Sandhamn",
                originalTitle: "Morden i Sandhamn"
              }
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "pippi-langstrump-pa-de-sju-haven",
              id: "Media:pippi-langstrump-pa-de-sju-haven"
            }
          ]
        }
      },
      {
        __typename: "ContentCollectionSliceEdge",
        node: {
          __typename: "ContentCollectionRecommendation",
          source: "vionlabs-order-history",
          args: null,
          title: ""
        }
      },
      {
        __typename: "ContentCollectionSliceEdge",
        node: {
          orderBy: "DEFAULT" /* DEFAULT */,
          __typename: "List",
          title: "To infinity and beyond",
          slug: "rymden",
          items: [
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "first-man",
              id: "Media:first-man"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "the-martian",
              id: "Media:the-martian"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "interstellar",
              id: "Media:interstellar"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "europa-report",
              id: "Media:europa-report"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "apollo-13",
              id: "Media:apollo-13"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "sunshine",
              id: "Media:sunshine"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "gravity",
              id: "Media:gravity"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "2001-a-space-odyssey",
              id: "Media:2001-a-space-odyssey"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "mission-to-mars",
              id: "Media:mission-to-mars"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "solaris-1972",
              id: "Media:solaris-1972"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "red-planet",
              id: "Media:red-planet"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "moon",
              id: "Media:moon"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "solaris",
              id: "Media:solaris"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "the-last-days-on-mars",
              id: "Media:the-last-days-on-mars"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "approaching-the-unknown",
              id: "Media:approaching-the-unknown"
            }
          ]
        }
      },
      {
        __typename: "ContentCollectionSliceEdge",
        node: {
          orderBy: "DEFAULT" /* DEFAULT */,
          __typename: "List",
          title: "Filmklippet - 9 kr f\xF6r alla titlar",
          slug: "9-kr-for-alla-titlar",
          items: [
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "the-foreigner",
              id: "Media:the-foreigner"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "love-rosie",
              id: "Media:love-rosie"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "the-man-with-the-iron-heart",
              id: "Media:the-man-with-the-iron-heart"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "the-mortal-instruments-city-of-bones",
              id: "Media:the-mortal-instruments-city-of-bones"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "the-commuter",
              id: "Media:the-commuter"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "something-borrowed",
              id: "Media:something-borrowed"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "all-eyez-on-me",
              id: "Media:all-eyez-on-me"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "eastern-promises",
              id: "Media:eastern-promises"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "the-happytime-murders",
              id: "Media:the-happytime-murders"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "bastille-day",
              id: "Media:bastille-day"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "a-monster-calls",
              id: "Media:a-monster-calls"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "the-autopsy-of-jane-doe",
              id: "Media:the-autopsy-of-jane-doe"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "how-i-spent-my-summer-vacation",
              id: "Media:how-i-spent-my-summer-vacation"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "alpha-omega",
              id: "Media:alpha-omega"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "milk",
              id: "Media:milk"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "criminal-activities",
              id: "Media:criminal-activities"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "animals-united",
              id: "Media:animals-united"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "the-next-three-days",
              id: "Media:the-next-three-days"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "sammy-2",
              id: "Media:sammy-2"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "gringo",
              id: "Media:gringo"
            }
          ]
        }
      },
      {
        __typename: "ContentCollectionSliceEdge",
        node: {
          orderBy: "DEFAULT" /* DEFAULT */,
          __typename: "List",
          title: "Pixar",
          slug: "pixar",
          items: [
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "toy-story",
              id: "Media:toy-story"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "ratatouille-textad",
              id: "Media:ratatouille-textad"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "toy-story-3-2010",
              id: "Media:toy-story-3-2010"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "inside-out",
              id: "Media:inside-out"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "toy-story-2__-1999",
              id: "Media:toy-story-2__-1999"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "the-good-dinosaur",
              id: "Media:the-good-dinosaur"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "up-2009",
              id: "Media:up-2009"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "wall-e___-2008",
              id: "Media:wall-e___-2008"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "monsters-university",
              id: "Media:monsters-university"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "monsters-inc",
              id: "Media:monsters-inc"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "brave_-2012",
              id: "Media:brave_-2012"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "finding-nemo",
              id: "Media:finding-nemo"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "cars-2-2011",
              id: "Media:cars-2-2011"
            }
          ]
        }
      },
      {
        __typename: "ContentCollectionSliceEdge",
        node: {
          orderBy: "DEFAULT" /* DEFAULT */,
          __typename: "List",
          title: "Kritikerhyllade filmer",
          slug: "kritikerhyllade",
          items: [
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "grans",
              id: "Media:grans"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "sameblod",
              id: "Media:sameblod"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "get-out",
              id: "Media:get-out"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "shoplifters",
              id: "Media:shoplifters"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "the-square",
              id: "Media:the-square"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "moonlight",
              id: "Media:moonlight"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "manchester-by-the-sea",
              id: "Media:manchester-by-the-sea"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "mad-max-fury-road",
              id: "Media:mad-max-fury-road"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "amateurs",
              id: "Media:amateurs"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "120-beats-per-minute",
              id: "Media:120-beats-per-minute"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "the-killing-of-a-sacred-deer",
              id: "Media:the-killing-of-a-sacred-deer"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "frantz",
              id: "Media:frantz"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "bond-spectre",
              id: "Media:bond-spectre"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "shaun-the-sheep-movie",
              id: "Media:shaun-the-sheep-movie"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "im-not-your-negro",
              id: "Media:im-not-your-negro"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "rams",
              id: "Media:rams"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "mr-gaga",
              id: "Media:mr-gaga"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "son-of-saul",
              id: "Media:son-of-saul"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "neon-bull",
              id: "Media:neon-bull"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "a-bigger-splash",
              id: "Media:a-bigger-splash"
            }
          ]
        }
      },
      {
        __typename: "ContentCollectionSliceEdge",
        node: {
          __typename: "List",
          orderBy: "DEFAULT" /* DEFAULT */,
          title: "Hasse & Tage - En k\xE4rlekshistoria",
          slug: "hasse--tage",
          items: [
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "appelkriget",
              id: "Media:appelkriget"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "att-angora-en-brygga",
              id: "Media:att-angora-en-brygga"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "picassos-aventyr",
              id: "Media:picassos-aventyr"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "mannen-som-slutade-roka",
              id: "Media:mannen-som-slutade-roka"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "slapp-fangarne-loss-det-ar-var",
              id: "Media:slapp-fangarne-loss-det-ar-var"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "jim-och-piraterna-blom",
              id: "Media:jim-och-piraterna-blom"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "den-enfaldige-mordaren",
              id: "Media:den-enfaldige-mordaren"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "agget-ar-lost",
              id: "Media:agget-ar-lost"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "sopor",
              id: "Media:sopor"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "vargens-tid",
              id: "Media:vargens-tid"
            }
          ]
        }
      },
      {
        __typename: "ContentCollectionSliceEdge",
        node: {
          __typename: "List",
          orderBy: "DEFAULT" /* DEFAULT */,
          title: "Stephen King",
          slug: "stephen-king",
          items: [
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "a-good-marriage",
              id: "Media:a-good-marriage"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "the-shining",
              id: "Media:the-shining"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "the-shawshank-redemption",
              id: "Media:the-shawshank-redemption"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "stephen-kings-it",
              id: "Media:stephen-kings-it"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "the-green-mile",
              id: "Media:the-green-mile"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "1408",
              id: "Media:1408"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "the-mist",
              id: "Media:the-mist"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "mercy",
              id: "Media:mercy"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "misery",
              id: "Media:misery"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "the-dark-tower",
              id: "Media:the-dark-tower"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "cell",
              id: "Media:cell"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "hearts-in-atlantis",
              id: "Media:hearts-in-atlantis"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "koplust",
              id: "Media:koplust"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "carrie",
              id: "Media:carrie"
            },
            {
              __typename: "Series",
              linkTarget: null,
              tags: [],
              slug: "series-castle-rock",
              id: "Media:series-castle-rock",
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "Castle Rock",
                originalTitle: "Castle Rock"
              }
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "secret-window",
              id: "Media:secret-window"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "dreamcatcher",
              id: "Media:dreamcatcher"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "dolans-cadillac",
              id: "Media:dolans-cadillac"
            }
          ]
        }
      },
      {
        __typename: "ContentCollectionSliceEdge",
        node: {
          orderBy: "DEFAULT" /* DEFAULT */,
          __typename: "List",
          title: "Best of Jonah Hill",
          slug: "best-of-jonah-hill",
          items: [
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "the-wolf-of-wall-street",
              id: "Media:the-wolf-of-wall-street"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "21-jump-street",
              id: "Media:21-jump-street"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "22-jump-street",
              id: "Media:22-jump-street"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "dont-worry-he-wont-get-far-on-foot",
              id: "Media:dont-worry-he-wont-get-far-on-foot"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "war-dogs",
              id: "Media:war-dogs"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "moneyball",
              id: "Media:moneyball"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "the-invention-of-lying",
              id: "Media:the-invention-of-lying"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "get-him-to-the-greek",
              id: "Media:get-him-to-the-greek"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "this-is-the-end",
              id: "Media:this-is-the-end"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "funny-people-2009",
              id: "Media:funny-people-2009"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "the-watch",
              id: "Media:the-watch"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "superbad",
              id: "Media:superbad"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "true-story",
              id: "Media:true-story"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "the-sitter",
              id: "Media:the-sitter"
            }
          ]
        }
      },
      {
        __typename: "ContentCollectionSliceEdge",
        node: {
          orderBy: "DEFAULT" /* DEFAULT */,
          __typename: "List",
          title: "Nyinkommet",
          slug: "nyinkommet",
          items: [
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "avengers-endgame",
              id: "Media:avengers-endgame"
            },
            {
              __typename: "Series",
              linkTarget: null,
              tags: [],
              slug: "series-suits",
              id: "Media:series-suits",
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "Suits",
                originalTitle: "Suits"
              }
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "pokemon-detective-pikachu",
              id: "Media:pokemon-detective-pikachu"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "long-shot",
              id: "Media:long-shot"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "the-bouncer",
              id: "Media:the-bouncer"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "amundsen",
              id: "Media:amundsen"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "dronningen",
              id: "Media:dronningen"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "avengers-infinity-war",
              id: "Media:avengers-infinity-war"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "teen-spirit",
              id: "Media:teen-spirit"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "uglydolls",
              id: "Media:uglydolls"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "mary-queen-of-scots",
              id: "Media:mary-queen-of-scots"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "greta",
              id: "Media:greta"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "eric-clapton-life-in-12-bars",
              id: "Media:eric-clapton-life-in-12-bars"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "harb-karmooz",
              id: "Media:harb-karmooz"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "triple-threat",
              id: "Media:triple-threat"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "torkel-i-knipa-sv",
              id: "Media:torkel-i-knipa-sv"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "hail-satan",
              id: "Media:hail-satan"
            },
            {
              __typename: "Series",
              linkTarget: null,
              tags: [],
              slug: "series-de-dagar-som-blommorna-blommar",
              id: "Media:series-de-dagar-som-blommorna-blommar",
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "De dagar som blommorna blommar",
                originalTitle: "De dagar som blommorna blommar"
              }
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "el-angel",
              id: "Media:el-angel"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "hacker-",
              id: "Media:hacker-"
            }
          ]
        }
      },
      {
        __typename: "ContentCollectionSliceEdge",
        node: {
          orderBy: "DEFAULT" /* DEFAULT */,
          __typename: "List",
          title: "Serier",
          slug: "tv-serier",
          items: [
            {
              __typename: "Series",
              linkTarget: null,
              tags: [],
              slug: "series-suits",
              id: "Media:series-suits",
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "Suits",
                originalTitle: "Suits"
              }
            },
            {
              __typename: "Series",
              linkTarget: null,
              tags: [],
              slug: "series-downton-abbey",
              id: "Media:series-downton-abbey",
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "Downton Abbey",
                originalTitle: "Downton Abbey"
              }
            },
            {
              __typename: "Series",
              linkTarget: null,
              tags: [],
              slug: "series-poldark",
              id: "Media:series-poldark",
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "Poldark",
                originalTitle: "Poldark"
              }
            },
            {
              __typename: "Series",
              linkTarget: null,
              tags: [],
              slug: "series-gasmamman",
              id: "Media:series-gasmamman",
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "G\xE5smamman",
                originalTitle: "G\xE5smamman"
              }
            },
            {
              __typename: "Series",
              linkTarget: null,
              tags: [],
              slug: "series-badehotellet",
              id: "Media:series-badehotellet",
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "Badhotellet",
                originalTitle: "Badhotellet"
              }
            },
            {
              __typename: "Series",
              linkTarget: null,
              tags: [],
              slug: "series-the-big-bang-theory",
              id: "Media:series-the-big-bang-theory",
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "The Big Bang Theory",
                originalTitle: "The Big Bang Theory"
              }
            },
            {
              __typename: "Series",
              linkTarget: null,
              tags: [],
              slug: "series-morden-i-sandhamn",
              id: "Media:series-morden-i-sandhamn",
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "Morden i Sandhamn",
                originalTitle: "Morden i Sandhamn"
              }
            },
            {
              __typename: "Series",
              linkTarget: null,
              tags: [],
              slug: "series-the-young-pope",
              id: "Media:series-the-young-pope",
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "The Young Pope",
                originalTitle: "The Young Pope"
              }
            },
            {
              __typename: "Series",
              linkTarget: null,
              tags: [],
              slug: "series-unsere-mutter-unsere-vater",
              id: "Media:series-unsere-mutter-unsere-vater",
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "Krigets unga hj\xE4rtan",
                originalTitle: "Krigets unga hj\xE4rtan"
              }
            },
            {
              __typename: "Series",
              linkTarget: null,
              tags: [],
              slug: "series-torka-aldrig-tarar-utan-handskar",
              id: "Media:series-torka-aldrig-tarar-utan-handskar",
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "Torka aldrig t\xE5rar utan handskar",
                originalTitle: "Torka aldrig t\xE5rar utan handskar"
              }
            },
            {
              __typename: "Series",
              linkTarget: null,
              tags: [],
              slug: "series-jagarna",
              id: "Media:series-jagarna",
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "J\xE4garna",
                originalTitle: "J\xE4garna"
              }
            },
            {
              __typename: "Series",
              linkTarget: null,
              tags: [],
              slug: "series-jordskott",
              id: "Media:series-jordskott",
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "Jordskott",
                originalTitle: "Jordskott"
              }
            },
            {
              __typename: "Series",
              linkTarget: null,
              tags: [],
              slug: "series-de-dagar-som-blommorna-blommar",
              id: "Media:series-de-dagar-som-blommorna-blommar",
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "De dagar som blommorna blommar",
                originalTitle: "De dagar som blommorna blommar"
              }
            },
            {
              __typename: "Series",
              linkTarget: null,
              tags: [],
              slug: "series-grotesco",
              id: "Media:series-grotesco",
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "Grotesco",
                originalTitle: "Grotesco"
              }
            },
            {
              __typename: "Series",
              linkTarget: null,
              tags: [],
              slug: "series-mad-men",
              id: "Media:series-mad-men",
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "Mad Men",
                originalTitle: "Mad Men"
              }
            },
            {
              __typename: "Series",
              linkTarget: null,
              tags: [],
              slug: "series-24-legacy",
              id: "Media:series-24-legacy",
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "24: Legacy",
                originalTitle: "24: Legacy"
              }
            },
            {
              __typename: "Series",
              linkTarget: null,
              tags: [],
              slug: "series-en-pilgrims-dod",
              id: "Media:series-en-pilgrims-dod",
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "En pilgrims d\xF6d",
                originalTitle: "En pilgrims d\xF6d"
              }
            },
            {
              __typename: "Series",
              linkTarget: null,
              tags: [],
              slug: "series-de-halvt-dolda-",
              id: "Media:series-de-halvt-dolda-",
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "De halvt dolda",
                originalTitle: "De halvt dolda"
              }
            },
            {
              __typename: "Series",
              linkTarget: null,
              tags: [],
              slug: "series-100-code",
              id: "Media:series-100-code",
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "100 Code",
                originalTitle: "100 Code"
              }
            },
            {
              __typename: "Series",
              linkTarget: null,
              tags: [],
              slug: "series-my-little-pony-friendship-is-magic",
              id: "Media:series-my-little-pony-friendship-is-magic",
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "My Little Pony: V\xE4nskap \xE4r magisk",
                originalTitle: "My Little Pony: V\xE4nskap \xE4r magisk"
              }
            }
          ]
        }
      },
      {
        __typename: "ContentCollectionSliceEdge",
        node: {
          orderBy: "DEFAULT" /* DEFAULT */,
          __typename: "List",
          title: "Barntoppen",
          slug: "barn",
          items: [
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "dumbo",
              id: "Media:dumbo"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "how-to-train-your-dragon-the-hidden-world",
              id: "Media:how-to-train-your-dragon-the-hidden-world"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "harry-potter-and-the-philosophers-stone",
              id: "Media:harry-potter-and-the-philosophers-stone"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "asterix-le-secret-de-la-potion-magique",
              id: "Media:asterix-le-secret-de-la-potion-magique"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "sune-vs-sune",
              id: "Media:sune-vs-sune"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "harry-potter-and-the-chamber-of-secret",
              id: "Media:harry-potter-and-the-chamber-of-secret"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "the-secret-life-of-pets",
              id: "Media:the-secret-life-of-pets"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "harry-potter-prisoners-of-azkaban",
              id: "Media:harry-potter-prisoners-of-azkaban"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "frozen-2013",
              id: "Media:frozen-2013"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "harry-potter-and-the-goblet-of-fire",
              id: "Media:harry-potter-and-the-goblet-of-fire"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "harry-potter-half-blood-prince",
              id: "Media:harry-potter-half-blood-prince"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "harry-potter-order-of-phoenix",
              id: "Media:harry-potter-order-of-phoenix"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "fantastic-beasts-and-where-to-find-them",
              id: "Media:fantastic-beasts-and-where-to-find-them"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "zootopia",
              id: "Media:zootopia"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "toy-story-3",
              id: "Media:toy-story-3"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "toy-story-2",
              id: "Media:toy-story-2"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "ralph-breaks-the-internet",
              id: "Media:ralph-breaks-the-internet"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "the-lego-movie-2-the-second-part",
              id: "Media:the-lego-movie-2-the-second-part"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "rum-213",
              id: "Media:rum-213"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "toy-story-1995",
              id: "Media:toy-story-1995"
            }
          ]
        }
      },
      {
        __typename: "ContentCollectionSliceEdge",
        node: {
          orderBy: "DEFAULT" /* DEFAULT */,
          __typename: "List",
          title: "Team SF Anytimes favoriter",
          slug: "team-sf-anytimes-favoriter",
          items: [
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "slap-shot",
              id: "Media:slap-shot"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "yrrol",
              id: "Media:yrrol"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "wedding-crashers",
              id: "Media:wedding-crashers"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "enemy-at-the-gates",
              id: "Media:enemy-at-the-gates"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "hachiko-a-dogs-story",
              id: "Media:hachiko-a-dogs-story"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "the-lion-king",
              id: "Media:the-lion-king"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "the-departed",
              id: "Media:the-departed"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "get-out",
              id: "Media:get-out"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "guardians-of-the-galaxy",
              id: "Media:guardians-of-the-galaxy"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "hjartat",
              id: "Media:hjartat"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "wind-river",
              id: "Media:wind-river"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "the-intouchables",
              id: "Media:the-intouchables"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "the-breakfast-club",
              id: "Media:the-breakfast-club"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "pulp-fiction",
              id: "Media:pulp-fiction"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "i-love-you-man",
              id: "Media:i-love-you-man"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "paris-texas",
              id: "Media:paris-texas"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "the-wolf-of-wall-street",
              id: "Media:the-wolf-of-wall-street"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "bridesmaids",
              id: "Media:bridesmaids"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "interstellar",
              id: "Media:interstellar"
            },
            {
              __typename: "Movie",
              linkTarget: null,
              tags: [],
              displayableAsset: {
                id: "DisplayableInCollectionWithCover:id",
                __typename: "DisplayableInCollectionWithCover",
                cover: "cover.jpg"
              },
              display: {
                __typename: "Display",
                caption: null,
                title: "mockMovie",
                originalTitle: "mockMovie"
              },
              slug: "the-godfather",
              id: "Media:the-godfather"
            }
          ]
        }
      }
    ]
  }
};

// src/~react-testing/mocks/entitlements/entitlementCreatedSubscription.ts
var entitlementCreatedSubscription = {
  __typename: "EntitlementCreatedEvent",
  mediaId: "123"
};

// src/~react-testing/mocks/favorite/favorite.ts
var favorites = [
  {
    id: "Favorite:shazam",
    slug: "shazam",
    item: {
      slug: "shazam",
      id: "Movie:shazam",
      displayableAsset: {
        id: "DisplayableInCollectionWithCover:id",
        __typename: "DisplayableInCollectionWithCover",
        cover: "cover.jpg"
      },
      display: {
        __typename: "Display",
        title: "mockTitle",
        originalTitle: "mockTitle",
        caption: null
      },
      __typename: "Movie",
      linkTarget: null,
      tags: []
    },
    __typename: "Favorite"
  },
  {
    id: "Favorite:what-men-want-",
    slug: "what-men-want-",
    item: {
      slug: "what-men-want-",
      id: "Movie:what-men-want-",
      displayableAsset: {
        id: "DisplayableInCollectionWithCover:id",
        __typename: "DisplayableInCollectionWithCover",
        cover: "cover.jpg"
      },
      display: {
        __typename: "Display",
        title: "mockTitle",
        originalTitle: "mockTitle",
        caption: null
      },
      __typename: "Movie",
      linkTarget: null,
      tags: []
    },
    __typename: "Favorite"
  },
  {
    id: "Favorite:dromkaken",
    slug: "dromkaken",
    item: {
      slug: "dromkaken",
      id: "Movie:dromkaken",
      displayableAsset: {
        id: "DisplayableInCollectionWithCover:id",
        __typename: "DisplayableInCollectionWithCover",
        cover: "cover.jpg"
      },
      display: {
        __typename: "Display",
        title: "mockTitle",
        originalTitle: "mockTitle",
        caption: null
      },
      __typename: "Movie",
      linkTarget: null,
      tags: []
    },
    __typename: "Favorite"
  },
  {
    id: "Favorite:holmes-and-watson",
    slug: "holmes-and-watson",
    item: {
      slug: "holmes-and-watson",
      id: "Movie:holmes-and-watson",
      displayableAsset: {
        id: "DisplayableInCollectionWithCover:id",
        __typename: "DisplayableInCollectionWithCover",
        cover: "cover.jpg"
      },
      display: {
        __typename: "Display",
        title: "mockTitle",
        originalTitle: "mockTitle",
        caption: null
      },
      __typename: "Movie",
      linkTarget: null,
      tags: []
    },
    __typename: "Favorite"
  },
  {
    id: "Favorite:aladdin",
    slug: "aladdin",
    item: {
      slug: "aladdin",
      id: "Movie:aladdin",
      displayableAsset: {
        id: "DisplayableInCollectionWithCover:id",
        __typename: "DisplayableInCollectionWithCover",
        cover: "cover.jpg"
      },
      display: {
        __typename: "Display",
        title: "mockTitle",
        originalTitle: "mockTitle",
        caption: null
      },
      __typename: "Movie",
      linkTarget: null,
      tags: []
    },
    __typename: "Favorite"
  }
];

// src/~react-testing/mocks/translations.ts
var translations = {
  da: {
    __typename: "Localization",
    id: "TG9jYWxpemF0aW9uOi9sT1I1NkZieEI0cmdKK1RGZm1ieVdXamUxbz06U0ZBbnl0aW1lOmRh",
    locale: "da",
    items: {
      age_recommendation: { child_friendly: "B\xF8rnevenligt" },
      auth: {
        access_code_expired_text: "Den kode, du har angivet, er ikke l\xE6ngere gyldig.",
        access_code_expired_title: "Udl\xF8bet kode",
        already_member: "Er du allerede medlem?",
        back_home: "G\xE5 til startsiden",
        complete_login_on_remote: "Afslut login p\xE5 din {{device}} enhed",
        continue_on_init_device: "Forts\xE6t p\xE5 dit {{device}} tv",
        current_password_placeholder: "Nuv\xE6rende adgangskode",
        email_changed_to: "E-mail \xE6ndres til:",
        email_placeholder: "Mailadresse",
        enter_new_email_for: "Indtast en ny e-mail for:",
        enter_new_password: {
          for: "Indtast en ny adgangskode til:",
          info_text: "Du skal logge ind igen i de apps og browsere, hvor du allerede er logget ind."
        },
        enter_new_password_for_email: "Angiv en ny adgangskode til {{email}} . Du skal logge ind igen i de apps og browsere, hvor du allerede er logget ind.",
        facebook_error_message: 'Hvis du allerede har oprettet en SF Anytime-konto med facebook, s\xE5 pr\xF8v at bruge "nulstil adgangskode" p\xE5 sfanytime.com. Skriv den e-mailadresse, der er knyttet til din Facebook-konto. Brug derefter den nye adgangskode og din facebook-e-mail til at logge ind i stedet.',
        facebook_error_title: "Facebook-login er i \xF8jeblikket ikke tilg\xE6ngeligt",
        forgot_password_description: "Indtast din mailadresse, s\xE5 sender vi dig instruktioner om, hvordan du nulstiller din adgangskode",
        forgot_password_done_button: "Tilbage til login",
        forgot_password_done_description: "Der er sendt en mail til dig med instruktioner til nulstilling af din adgangskode.",
        forgot_password_done_help: "Hvis du ikke kan se mailen inden for et par minutter, skal du kontrollere, om den er i spammappen. Hvis det stadig ikke virker, skal du",
        forgot_password_done_title: "Snart klar",
        forgot_password_link: "Glemt din adgangskode?",
        forgot_password_title: "Glemt din adgangskode?",
        logged_in: "Du er logget ind",
        login_button: "Log ind",
        login_button_apple: "Apple",
        login_button_facebook: "Facebook",
        login_button_google: "Google",
        login_button_in_progress: "Logger ind...",
        login_or_signup: "Log ind eller registrer dig",
        login_title: "Log ind",
        logout_confirmation: "Er du sikker p\xE5, du vil logge ud?",
        logout_from_all_devices_confirmation: "Er du sikker p\xE5, at du vil logge ud fra alle dine enheder? Du bliver n\xF8dt til at logge ind igen p\xE5 hver af de enheder, du \xF8nsker at bruge.",
        logout_from_all_devices_title: "Log ud fra alle enheder",
        logout_title: "Log ud",
        new_member: "Er du ny p\xE5 SF Anytime?",
        new_password_placeholder: "Ny adgangskode",
        new_password_title: "Ny adgangskode",
        now_logged_in_as: "Du er nu logget ind som",
        no_verification_email: "Har du ikke modtaget e-mailen?",
        or_login_with: "Eller forts\xE6t med",
        password_placeholder: "Adgangskode",
        password_restriction: "Adgangskoden skal v\xE6re mindst 8 tegn.",
        password_updated_for: "Adgangskode opdateret til:",
        remeber_me: "Husk mig",
        remote_login_device_text: "med din telefon, tablet eller computer, og indtast f\xF8lgende kode",
        remote_login_go_to: "G\xE5 til",
        send_verification_email_again: "Send igen",
        signedup_button: "Kom i gang",
        signedup_title: "Tak, fordi du registrerede dig hos os",
        signup_button: "Opret konto",
        signup_slogan: "Stream de nyeste film!\nDet er gratis at v\xE6re medlem.",
        signup_title: "Bliv medlem",
        signup_usp_array: [
          " Se, hvor du vil, n\xE5r du vil ",
          " Adgang til de nyeste film ",
          " Lav dine egne lister, og f\xE5 personlige tips "
        ],
        tos_confirm: "SF Anytimes Brugervilk\xE5r",
        tos_confirmation: "Accepter Brugervilk\xE5r for at forts\xE6tte",
        tos_consent: "Jeg bekr\xE6fter, at jeg er 18 \xE5r eller \xE6ldre, og jeg accepterer",
        tos_url: "https://www.sfanytime.com/da/page/brugsvilkar",
        verify_email_description: "Vi har sendt en bekr\xE6ftelses-e-mail til dig. Bekr\xE6ft din konto ved at klikke p\xE5 linket i den e-mail, der sendes til:",
        verify_email_social_login_description: "Vi har sendt en bekr\xE6ftelses-e-mail til dig. Bekr\xE6ft din konto ved at klikke p\xE5 linket i den e-mail, der sendes til din Facebook-konto:",
        "\u200Blogin_with_social_media": "eller log ind med",
        "\u200Bregister_with_social_media": "eller opret konto med"
      },
      checkout: {
        audio: { title: "Lyd" },
        buy_tickets_button_title: "K\xF8b tickets",
        campaign_title: "Kampagne",
        choose_language: "Du skal v\xE6lge sprog",
        confirm_button: { title: "Gennemf\xF8r k\xF8b" },
        continue_to_payment: { title: "Forts\xE6t med at betale" },
        done: "Betalt og klar!",
        download_our_app_ups: "Du kan ogs\xE5 se indhold via vores apps p\xE5 din telefon, tablet eller smart tv. Vi underst\xF8tter ogs\xE5 Chromecast.",
        entitlement_type: {
          buy: "K\xF8b",
          buy_description: "K\xF8befilm. Se den, n\xE5r du vil, og s\xE5 mange gange du vil.",
          rent: "Leje",
          rent_description: "Se den f\xE6rdig inden for 48 timer.",
          title: "Lej eller k\xF8b"
        },
        episode: "Afsnit",
        episode_count: "{{count}} afsnit",
        episode_count_title: "Afsnit",
        est: "K\xF8b",
        est_bundle_duration: "Se, n\xE5r du vil, og s\xE5 mange gange du vil.",
        est_episode_duration: "Se, n\xE5r du vil, og s\xE5 mange gange du vil.",
        est_movie_duration: "K\xF8befilm. Se den, n\xE5r du vil, og s\xE5 mange gange du vil.",
        est_season_duration: "Se, n\xE5r du vil, og s\xE5 mange gange du vil.",
        hide_price_details: "Skjul detaljer",
        language: {
          local: "Svensk tale",
          original: "Originalsprog",
          title: "Sprog",
          title_short: "Sprog"
        },
        leave_warning: "Er du sikker p\xE5, at du vil forlade checkout? Hvis du g\xF8r det, mens en aktiv betaling er i gang, kan betalingen mislykkes.",
        pay: "Betal",
        payment: {
          add_saved_card_tip: "Betal direkte p\xE5 dit tv n\xE6ste gang ved at tilf\xF8je et betalingskort til din konto p\xE5 SF Anytime",
          adyen_applepay: "Apple Pay",
          adyen_applepay_description: "Apple Pay giver dig mulighed for at foretage sikre k\xF8b, som du f\xF8jer til din Apple Wallet.",
          adyen_creditcard: "Betalingskort",
          adyen_creditcard_description: "Betal sikkert med Visa, Mastercard og American Express.",
          adyen_klarna: "Betal senere",
          adyen_klarnaaccount: "Betal over tid",
          adyen_klarnaaccount_description: "Betal over tid",
          adyen_klarnapaynow: "Betal nu",
          adyen_klarnapaynow_description: "Betal nu",
          adyen_klarna_description: "Betal med Klarna.",
          adyen_mobilepay: "MobilePay",
          adyen_mobilepay_description: "Indtast telefonnummeret til den mobiltelefon, du betaler med. Du skal have MobilePay-appen installeret.",
          adyen_savedcreditcard: "Gemt betalingskort",
          adyen_savedcreditcard_description: "Betal med {{name}} {{number}}.",
          adyen_swish: "Swish",
          adyen_swish_description: "Betal med Swish-appen p\xE5 din mobil.",
          adyen_vipps: "Vipps",
          adyen_vipps_description: "Betal nemt og bekvemt med Vipps.",
          amex: "Kortbetaling",
          amex_description: "Betal sikkert med American Express.",
          apple_inapp: "App Store",
          apple_inapp_description: "Betal med din gemte betalingsmetode, som du bruger til App Store, iTunes Store, iCloud og meget mere.",
          card: "Kortbetaling",
          card_description: "Betal sikkert med Visa og Mastercard.",
          freeproduct: "Gratis",
          google_inapp: "Google Play",
          google_inapp_description: "Betal med den betalingsmetode, som du bruger til Google Play.",
          group_klarna: {
            description: "Fleksible betalinger med Klarna.",
            title: "Klarna"
          },
          klarna: "Klarna",
          klarna_description: "Kort eller bankkonto.",
          more_payment_options: "Flere betalingsmuligheder",
          more_payment_options_description: "V\xE6lg en anden betalingsmetode, eller en v\xE6rdikode, hvis du har en.",
          not_available_in_app_description: "Betalingsmetoden kan ikke bruges til k\xF8b i denne app.",
          other: "Anden betalingsmetode",
          prepaid: "Tickets",
          saved_card: "Gemt betalingskort",
          save_payment_info: "Gem betalingsoplysningerne",
          sf_freeproduct: "Gratis",
          sf_loyaltypoints: "Loyalitetspoint",
          sf_loyaltypoints_description: "SF-loyalitetspoint",
          sf_ticket: "{{cost}} tickets",
          sf_ticket_buy_more_one: "K\xF8b {{count}} ticket",
          sf_ticket_buy_more_other: "K\xF8b {{count}} tickets",
          sf_ticket_description_one: "Betal med {{cost}} af dine tickets.\nDu har i alt {{count}} tickets.",
          sf_ticket_description_other: "Betal med {{cost}} af dine tickets. Du har i alt {{count}} tickets.",
          sf_ticket_description_zero: "Betal med {{cost}} tickets.\nDu har ingen tickets i \xF8jeblikket.",
          sf_ticket_description_disabled_one: "Du skal bruge {{count}} tickets mere.",
          sf_ticket_description_disabled_other: "Du skal bruge {{count}} tickets mere.",
          sf_voucher: "V\xE6rdikode",
          swish: "Swish",
          swish_description: "Betal med Swish-appen p\xE5 din mobil.",
          swish_disabled: "Swish kan ikke bruges i \xF8jeblikket p\xE5 grund af tekniske problemer.",
          to_payment: "Til betaling",
          to_payment_button: "Til betaling",
          tv_adyen_pay_with_saved_card: "Betal med gemt kort",
          use_a_voucher: "Brug en v\xE6rdikode",
          valuecode: "V\xE6rdikode"
        },
        payment_method: { title: "Betalingsmetode" },
        payment_method_group_placeholder: "Betalingsmuligheder",
        purchase_not_allowed_in_app: {
          link: "L\xE6s mere om, hvordan du lejer film",
          text: "Desv\xE6rre kan du ikke foretage k\xF8b i appen."
        },
        receipt: {
          app_description: "Med appen kan du ogs\xE5 se filmen p\xE5 dit tv via Chromecast eller Airplay samt downloade og se den offline.",
          datetime: "Dato",
          discount: "Rabat",
          fee: "Servicegebyr for k\xF8b i app",
          legal_info: "N\xE5r du p\xE5begynder streaming af en film; en film, der indg\xE5r i en pakke; en s\xE6son af en serie; et serieafsnit eller bruger en ticket, accepterer du, at SF Anytime p\xE5begynder opfyldelsen af leveringen af dit k\xF8b, s\xE5 du ikke l\xE6ngere kan fortryde dit k\xF8b.",
          open_in_app: "\xC5bn i appen",
          order_no: "Ordrenummer",
          payment_method: "Betalingsmetode",
          receipt_title: "Kvittering",
          save: "Gem kvittering (pdf)",
          smarttv_description: "Eller brug en af vores smart tv-apps p\xE5 Samsung, LG, AppleTV og Android TV.",
          sum: "Total",
          thanks: "Tak, fordi du har valgt at se film hos os!",
          ticket_valid_to: "Tickets gyldige indtil",
          valid_to: "Gyldig indtil",
          vat: "Heraf moms",
          voucher_legal_info: "Filmkoderne er gyldige i 6 m\xE5neder.",
          you_have_bought: "Du har k\xF8bt",
          you_have_rented: "Du har lejet"
        },
        rental_duration: "Lejeperiode",
        select_placeholder: "V\xE6lg",
        show_price_details: "Vis detaljer",
        subtitles: { no_subtitles: "Uden undertekster", title: "Undertekster" },
        ticket_prompt: {
          description: "K\xF8b tickets direkte i vores app eller p\xE5 vores hjemmeside.\nHerefter kan du ombytte dine tickets til en film eller serie.",
          not_enough_tickets: {
            title: "Du har brug for flere tickets for at forts\xE6tte med denne betalingsmetode"
          },
          tickets_are_required: {
            title: "Du skal bruge tickets for at foretage et k\xF8b i denne app"
          }
        },
        ticket_type: {
          description_one: "Gyldig i 3 \xE5r fra k\xF8bsdatoen og kan bruges i alle vores apps.",
          description_other: "Gyldig i 3 \xE5r fra k\xF8bsdatoen og kan bruges i alle vores apps.",
          description_valid_to: "En ticket er gyldig i 3 \xE5r fra k\xF8bsdatoen",
          title_one: "1 ticket",
          title_other: "{{count}} tickets"
        },
        total_cost: "Samlet bel\xF8b inkl. moms",
        tvod: "Leje",
        tvod_episode_duration: "Se den f\xE6rdig inden for 48 timer.",
        tvod_movie_duration: "Se den f\xE6rdig inden for 48 timer.",
        tvod_season_duration: "Se den f\xE6rdig p\xE5 30 dage.",
        update: {
          text: "Vi har en ny og forbedret version af vores app, og du skal opdatere din app for at forts\xE6tte.",
          title: "Opdater din app"
        },
        value_code_applied_value: "{{percent}}% rabat",
        value_code_apply: "Anvend",
        value_code_invalid: "V\xE6rdikoden er ikke gyldig til denne titel eller findes ikke",
        value_code_placeholder: "Indtast din kode",
        value_code_prompt: "Har du en v\xE6rdikode? Indtast koden her",
        value_code_title: "V\xE6rdikode",
        value_code_used: "V\xE6rdikoden er allerede blevet brugt.",
        voucher: {
          campaign: {
            "5_for_4": {
              description: "1 lejefilmkod mindre at betale for.",
              label: "K\xF8b 5 betal for 4"
            }
          },
          campaign_title: "Et tilbud er ans\xF8gt",
          delivery_type: {
            my_email: "Til min e-post",
            recipient_email: "Til modtager ved hj\xE6lp af e-mail",
            recipient_sms: "Til modtager ved hj\xE6lp af SMS",
            title: "Leveringsmetode"
          },
          entitlement_type: {
            buy_description: "K\xF8befilm. Se den, n\xE5r du vil, og s\xE5 mange gange du vil.",
            buy_text_price: "K\xF8b {{price}}",
            rent_text_description: "Se den f\xE6rdig inden for 48 timer.",
            rent_text_price: "Leje {{price}}"
          },
          title: "K\xF8b filmkoder"
        },
        voucher_has_issue: "Ret eller fjern v\xE6rdikoden",
        voucher_not_valid: "V\xE6rdikoden kan ikke bruges til dine valg",
        webview_timeout: "Dette tager l\xE6ngere tid end normalt...",
        you_have_bought: "Du har k\xF8bt",
        you_have_rented: "Du har lejet",
        you_selected_to_buy: "Du har valgt at k\xF8be",
        you_selected_to_rent: "Du har valgt at leje"
      },
      emails: {
        content_notification: {
          reason_for_email_one: "Du modtager denne e-mail, fordi du har aktiveret meddelelser om denne titel.",
          reason_for_email_other: "Du modtager denne e-mail, fordi du har aktiveret meddelelser om disse titler.",
          subject_one: "En titel, du holder \xF8je med, er nu tilg\xE6ngelig",
          subject_other: "De titler, du holder \xF8je med, er nu tilg\xE6ngelige"
        },
        footer: {
          cant_reply: "Denne e-mail kan ikke besvares. Hvis du har sp\xF8rgsm\xE5l,",
          copyright: "\xA9 2024 SF Anytime AB (org-nr.  556748-2616, VAT SE556748261601)",
          please_contact_us_link: "kontakt os her",
          regards: "Med v\xE4nliga h\xE4lsningar,",
          unsubscribe: "Afmeld",
          web_link: "Webversion"
        },
        gdpr_clean_up: {
          clarification: "*G\xE6lder kun for den konto, der er registreret p\xE5 den e-mailadresse, du modtog denne e-mail til. Hvis du har registreret flere konti med forskellige e-mailadresser, h\xE5ndteres disse separat.",
          cta: "Lej en film",
          delete_account_text_one: "Hvis du vil have din konto slettet, beh\xF8ver du ikke g\xF8re noget, kontoen slettes automatisk om 1 dag. Du kan altid oprette en ny gratis konto med de samme oplysninger, hvis du vil have en konto hos os igen i fremtiden.",
          delete_account_text_other: "Hvis du vil have din konto slettet, beh\xF8ver du ikke g\xF8re noget, kontoen slettes automatisk efter {{number}} dage. Du kan altid oprette en ny gratis konto med de samme oplysninger, hvis du vil have en konto hos os igen i fremtiden.",
          intro_one: "Det er et stykke tid siden, du sidst bes\xF8gte os, og p\xE5 grund af GDPR er vi n\xF8dt til at slette din konto* p\xE5 1 dag.",
          intro_other: "Det er et stykke tid siden, du sidst bes\xF8gte os, og p\xE5 grund af GDPR er vi n\xF8dt til at slette din konto* om {{number}} dage.",
          reason_for_email: "Du modtager denne e-mail, fordi du har en konto hos os.",
          save_account_text: "Vil du beholde din konto?\xA0Lej en film med {{discount}}% rabat med v\xE6rdikoden nedenfor!",
          subtitle_one: "Om 1 dag vil din gratis konto blive slettet",
          subtitle_other: "Om {{number}} dage vil din gratis konto blive slettet",
          title: "P\xE5mindelse om din SF Anytime-konto",
          voucher_info: "Rabatkoden er personlig og g\xE6lder kun p\xE5 denne konto, kan kun bruges \xE9n gang og rabatten g\xE6lder for en lejefilm op til 59 kr. G\xE6lder ikke for biograffilm eller k\xF8bsfilm og kan ikke kombineres med andre tilbud.",
          voucher_limitations: "G\xE6lder for lejefilm op til 59 kr.",
          voucher_offer: "{{discount}}% rabat p\xE5 lejefilm"
        },
        header: {
          hello: "Hej",
          hello_we_miss_you: "Hej, vi savner dig!",
          looking_weird: "Ser e-mailen m\xE6rkelig ud?",
          open_in_browser: "\xC5bn i browseren"
        },
        new_user: {
          intro: "Det er dejligt, at du er blevet medlem hos os. Vi har Nordens bredeste filmhylder, fyldt med alt fra prisvindende mesterv\xE6rker til god underholdning. Vi tror p\xE5, at der er en film til enhver lejlighed og en mulighed for enhver film.",
          intro2: "Tag en dyb ind\xE5nding og begiv dig ind i kollektionen.",
          title: "Velkommen til SF Anytime"
        },
        order_receipt: {
          find_your_playable_content: "Du kan finde kvitteringer for alle dine k\xF8b p\xE5 siden Mine k\xF8b og dit k\xF8bte indhold p\xE5 siden Mit indhold.",
          go_to_playable_content: "Afspil",
          greeting_bundle: "Vi p\xE5 SF Anytime \xF8nsker dig en behagelig filmoplevelse!",
          greeting_episode: "Vi hos SF Anytime \xF8nsker dig en hyggelig stund med serierne!",
          greeting_movie: "Vi p\xE5 SF Anytime \xF8nsker dig en behagelig filmoplevelse!",
          greeting_season: "Vi hos SF Anytime \xF8nsker dig en hyggelig stund med serierne!",
          greeting_ticketpack: "Vi hos SF Anytime h\xE5ber, at dine tickets vil blive brugt godt!",
          greeting_voucher: "Vi hos SF Anytime h\xE5ber, at filmkoderne vil blive brugt godt!",
          more_about_vouchers: "L\xE6s mere om filmkoder",
          product_type_bundle_est_description: "Du kan se filmene s\xE5 mange gange du vil.",
          product_type_episode_est_description: "Du kan se episoden s\xE5 mange gange, du vil.",
          product_type_episode_tvod_description: "Se den f\xE6rdig inden for 48 timer.",
          product_type_movie_est_description: "Du kan se filmen s\xE5 mange gange, du vil.",
          product_type_movie_tvod_description: "Se den f\xE6rdig inden for 48 timer.",
          product_type_season_est_description: "Du kan se series\xE6sonen s\xE5 mange gange du vil.",
          product_type_season_tvod_description: "Se den f\xE6rdig p\xE5 30 dage.",
          product_type_ticketpack_est_description: "Dine tickets er gyldige i tre \xE5r fra k\xF8bsdatoen og er tilg\xE6ngelige p\xE5 din konto. De kan bruges som betaling, n\xE5r du k\xF8ber indhold fra enhver af vores apps.",
          product_type_voucher__description: "Vedh\xE6ftet finder du dine koder. Gem koderne p\xE5 din computer, eller print dem ud og giv dem som gave.",
          reason_for_email: "Dette er en bekr\xE6ftelse af et k\xF8bt indhold med en konto, der bruger denne e-mailadresse.",
          subject: "Kvittering fra SF Anytime",
          thanks_bundle: "Tak fordi du valgte at k\xF8be en filmpakke hos os!",
          thanks_episode: "Tak fordi du valgte at k\xF8be en serieepisode hos os!",
          thanks_movie: "Tak fordi du valgte at k\xF8be en film hos os!",
          thanks_season: "Tak fordi du valgte at k\xF8be en series\xE6son hos os!",
          thanks_ticketpack: "Tak fordi du valgte at k\xF8be tickets hos os!",
          thanks_voucher: "Tak fordi du valgte at k\xF8be filmkoder hos os!",
          title: "Kvittering"
        },
        reset_password: {
          intro: "Dette er en anmodning om nulstilling af adgangskode for kontoen:",
          not_requested: "Hvis du ikke har anmodet om en e-mail for at nulstille din adgangskode, skal du stadig \xE6ndre din adgangskode p\xE5 siden Min konto under Indstillinger for at beskytte din konto.",
          reset_password: "Nulstil adgangskode",
          reset_password_link_text: "Klik p\xE5 knappen nedenfor for at v\xE6lge en ny adgangskode. Linket er gyldigt i 30 minutter.",
          subject: "Nulstilling af adgangskode",
          title: "Nulstilling af adgangskode"
        },
        voucher: {
          code_label: "Kode:",
          valid_to: "Gyldig til:",
          your_personal_code: "Din personlige kode"
        }
      },
      genre: {
        "3d": "3D",
        action: "Action",
        adult: "Voksen",
        adventure: "Eventyr",
        animated: "Animation\n",
        anime: "Anime",
        children: "B\xF8rn",
        "children-family": "B\xF8rn og familie",
        "children-family (Copy)": "B\xF8rn og familie",
        comedy: "Komedie",
        crime: "Krimi",
        cult: "Kult",
        danish: "Dansk",
        documentary: "Dokumentar",
        drama: "Drama",
        finnish: "Finsk",
        horror: "Gyser",
        "movie-gems": "Filmperler",
        music: "Musik",
        norwegian: "Norsk",
        romance: "Romantik",
        "sci-fi": "Sci-fi",
        "sf-kids": "SF Kids",
        swedish: "Svensk",
        thriller: "Thriller",
        "tv-series": "TV-serie",
        war: "Krigsfilm",
        western: "Western"
      },
      glossary: {
        abort: "Annuller",
        activate: "Aktiv\xE9r",
        add_to_my_list: "F\xF8j til Min liste",
        amount: "Antal",
        app_version: "App-version",
        available: "Tilg\xE6ngelig",
        back_navigation: "Tilbage",
        bought: "K\xF8bt",
        bought_badge: "K\xD8BT",
        brand: "SF Anytime",
        build_number: "Buildnummer",
        bundle: "Filmpakker",
        buy: "K\xF8b",
        buy_first_episode_from: "F\xF8rste afsnit af",
        buy_from: "Fra",
        campaign: "Kampagne",
        cancel: "Annuller",
        close_modal: "Luk",
        coming_soon: "Kommer snart",
        continue: "Forts\xE6t",
        customer_service: "Support",
        download_from_AppStore: "Hent i App Store",
        download_from_GooglePlay: "Hent i Google Play",
        error: "Fejl",
        fullscreen: "Fuld sk\xE6rm",
        hide_banner: "Skjul",
        last_chance: "Sidste chance",
        loading: "Indl\xE6ser...",
        mark_as_not_watched: "Mark\xE9r som ikke set",
        mark_as_watched: "Mark\xE9r som set",
        minutes: "minutter",
        movie: "Film",
        mute: "D\xE6mpe",
        next_episode: "N\xE6ste afsnit",
        no: "Nej",
        not_available: "Ikke tilg\xE6ngelig",
        off: "Fra",
        on: "Til",
        open: "\xC5bn",
        open_in_browser_button: "\xC5bn i browseren",
        password: "Adgangskode",
        pause_button: "Pause",
        play_button: "Afspil",
        read_more: "L\xE6s mere",
        release: "Kommer",
        release_date: "Udgivelsesdato",
        remote_control: "fjernbetjening",
        remove_from_my_list: "Fjern fra Min liste",
        rented: "Lejet",
        rented_badge: "LEJET",
        saved: "Gemt",
        search_results: "S\xF8geresultater",
        select: "V\xE6lg",
        series: "Serie",
        sf_anytime: "SF Anytime",
        show: "Vis",
        show_all: "Vis alle",
        show_all_x: "Vis alle {{count}}",
        support_forum: "support.sfanytime.com",
        support_mail: "support@sfanytime.com",
        this_device: "Denne enhed",
        tickets: "Tickets",
        trailer: "Trailer",
        unknown: "Ukendt",
        username: "Brugernavn",
        warning: "Advarsel",
        x_results: {
          plural: "{{number}} resultater",
          singular: "{{number}} resultat"
        },
        yes: "Ja",
        "\u200Brented_for": "Lejet i",
        "\u200Brented_to": "Lejet til"
      },
      media: {
        age_rating: "Aldersgr\xE6nse",
        audio: "Lyd",
        bundle: {
          discount_text: "Spar {{percentage}}% ",
          movie_count: "{{count}} film"
        },
        continue_watching: {
          empty: "Her finder du film og serier, som du ikke er f\xE6rdige med at se endnu.",
          title: "Forts\xE6t med at afspille"
        },
        crew: {
          actor: "Skuespiller",
          director: "Instrukt\xF8r",
          title: "Medvirkende"
        },
        download: {
          action_will_remove_active_download: "Denne handling afbryder din igangv\xE6rende download.",
          cancel_download: "Afbryd download",
          delete_download: "Slet download",
          deleting: "Slet",
          deleting_download_description: "Sletter download... Det kan tage et stykke tid.",
          downloaded: "Downloadet",
          downloading: "Downloader",
          download_completed: "Download er fuldf\xF8rt",
          download_error: "Fejl ved download",
          list_title: "Downloadet p\xE5 denne enhed",
          logout_warning: "Dine downloads slettes, n\xE5r du logger af.",
          no_entitled_downloads: "Der er downloads p\xE5 denne enhed, der ikke tilh\xF8rer din konto. Du kan stadig slette dem.",
          no_space_left_error: "Der er ikke mere plads p\xE5 enheden.",
          paused: "Sat p\xE5 pause",
          pause_download: "S\xE6t download p\xE5 pause",
          pause_download_error: "Download kunne ikke s\xE6ttes p\xE5 pause. Pr\xF8v igen.",
          pick_quality: "V\xE6lg den kvalitet, der skal downloades i. H\xF8jere kvalitet giver et bedre billede, men kr\xE6ver mere lagringsplads.",
          pick_quality_high: "H\xF8j",
          pick_quality_low: "Lav",
          pick_quality_max: "Maks.",
          pick_quality_medium: "Medium",
          quality: "Kvalitet",
          queued: "I k\xF8",
          removing: "Sletter",
          removing_download: "Sletter download",
          resume_download: "Genoptag download",
          resume_download_error: "Download kunne ikke s\xE6ttes p\xE5 pause. Pr\xF8v igen.",
          start_download: "Download",
          start_download_error: "Det lykkedes ikke at starte download. Pr\xF8v igen.",
          try_to_download_again: "Pr\xF8v at hente indholdet igen."
        },
        entitlement_type: "Type",
        episode_rental_left: "Leje slutter om: {{rental_time_left}}",
        extra_material: { title: "Ekstra materiale" },
        from_countries: "Produceret i",
        has_access: "Adgang",
        keep_watching: "Forts\xE6t afspilning",
        length: "L\xE6ngde",
        meta_description_movie: "Lej og k\xF8b filmen {{ title }} med {{ actor1 }} og {{ actor2 }}. Stream denne {{ genre }}-film og andre film online p\xE5 {{ brand }}.",
        meta_description_series: "Lej og k\xF8b serien {{ title }} med {{ actor1 }} og {{ actor2 }}. Stream denne {{ genre }}-serie og andre serier online p\xE5 {{ brand }}.",
        meta_title: "{{title}} \u2013 Lej eller k\xF8b, og stream p\xE5 SF Anytime",
        more_info_title: "Mere information",
        movie_bought_info: "K\xF8bt - Se den, n\xE5r du vil, s\xE5 mange gange du vil",
        movie_rental_left: "Leje slutter om: {{rental_time_left}}",
        movie_rented_and_expires_at: "Lejet - Leje slutter om {{rent_end_time}}",
        my_list: "Min liste",
        my_list_add_button: "Min liste",
        notify: "P\xE5mind mig",
        notifyme_button: "P\xE5mind mig",
        notifyme_button_active: "P\xE5mindelse aktiv",
        only_on: "Kun p\xE5",
        production_country: "Produceret i",
        purchase: { unavailable_button: "Kan ikke lejes" },
        release_date: "Kommer: {{dateString}}",
        series: {
          average_episode_length: "~{{length}}/afsnit",
          buy_this_season: "K\xF8b denne s\xE6son",
          episodes: "Afsnit",
          episode_count: "{{count}} afsnit",
          next_episode: "N\xE6ste afsnit",
          not_available: "Dette indhold er ikke tilg\xE6ngeligt i \xF8jeblikket",
          season: "S\xE6son",
          seasons: "S\xE6soner",
          season_release: "Kommer: {{dateString}}"
        },
        share_button: "Del",
        show_more: "Vis mere",
        similar_movies: "Lignende",
        similar_series: "Lignende",
        similar_tickets: "Andre tickets",
        similar_titles: "Lignende titler",
        subtitles: "Undertekster",
        trailer_button: "Trailer",
        upcoming: "Kommende",
        watched: { title: "Allerede set" }
      },
      mymedia: {
        entitlements_empty_list: [
          "Her finder du de film og serier, du har lejet eller k\xF8bt",
          "Se p\xE5 dit tv med Chromecast eller Airplay",
          "Download og afspil, mens du er offline - perfekt, n\xE5r du er p\xE5 farten"
        ],
        entitlements_title: "Mine film og serier",
        favorites_title: "Min liste",
        my_content_title: "Mit indhold",
        my_list_empty_array: [
          "Du har endnu ikke gemt nogen film eller serier p\xE5 Min liste",
          "Smart, s\xE5 du kan huske dem senere",
          "Se efter dette symbol"
        ],
        my_list_title: "Min liste",
        saved_searches_title: "Mine p\xE5mindelser"
      },
      offer_redeemed: "Det ser ud til, at denne v\xE6rdikode allerede er blevet brugt",
      push: {
        discountedtitle: {
          text: "En titel, som du m\xE5ske kan lide, er nu sat ned i pris.",
          title: '"{{localtitle}}" har nu en lavere pris'
        },
        multipletitlesmatchingsavedsearch: {
          text: '"{{localtitles}}" er nu tilg\xE6ngelige.',
          title: "De titler, du holder \xF8je med, er nu tilg\xE6ngelige"
        },
        newtitle: {
          text: "En titel, som du m\xE5ske er interesseret i, er nu tilg\xE6ngelig.",
          title: '"{{localtitle}}" er nu tilg\xE6ngelig'
        },
        singletitlematchingsavedsearch: {
          text: "En titel, du holder \xF8je med, er nu tilg\xE6ngelig.",
          title: '"{{localtitle}}" er nu tilg\xE6ngelig'
        },
        title_matching_saved_search: {
          "text _one": "En titel, du holder \xF8je med, er nu tilg\xE6ngelig.",
          "text _other": "De titler, du holder \xF8je med, er nu tilg\xE6ngelige"
        }
      },
      search: {
        active_filters: "Aktive filtre",
        agelimit_years: "{{age}} \xE5r",
        did_you_mean: "Mente du?",
        empty_results: "Ups, det ser ud, som om din s\xF8gning ikke gav nogen resultater.",
        empty_results_message: "Pr\xF8v at rydde din s\xF8gning, \xE6ndre dine filtre eller v\xE6lge noget fra vores popul\xE6re s\xF8geresultater nedenfor.",
        facet: {
          actors: "Skuespiller",
          ageLimit: "Aldersgr\xE6nse",
          directors: "Instrukt\xF8r",
          duration: "L\xE6ngde",
          genres: "Genrer",
          lowestPrice: "Pris",
          manifest: {
            audio: { tracks: { language: "Lyd" } },
            subtitles: { language: "Undertekster" }
          },
          mediaTags: { name: "Medier Tags" },
          metaCollections: "Emner",
          productType: "Type",
          ratings: { imdb: "IMDB-bed\xF8mmelse" },
          releaseYear: "Udgivelses\xE5r"
        },
        filters_hits: "Resultater",
        filters_reset_button: "Nulstil filtre",
        filters_title: "Filtre",
        from: "Fra",
        history: "Seneste s\xF8gninger",
        input_placeholder: "S\xF8g efter film, serier eller medvirkende",
        input_press_ok: "Tryk p\xE5 OK for at \xE5bne tastaturet",
        "list-view": "Listevisning",
        "list-view-as-grid": "Gitter",
        "list-view-as-list": "Liste",
        "load-more-button": "Indl\xE6se mere",
        not: "Ikke {{ filter }}",
        number_of_seasons: {
          plural: "{{seasonCount}} s\xE6soner",
          singular: "{{seasonCount}} s\xE6son"
        },
        placeholder: "S\xF8g...",
        popular_search_terms: "Popul\xE6re s\xF8geord:",
        recent_searches: "Seneste s\xF8gninger",
        remove: "Fjerne",
        reset_button: "Nulstille",
        reset_refinements: "Slet",
        reset_search: "Start forfra",
        save: "Gemme",
        saved: "Gemte",
        saved_searches: "Gemt",
        show_less: "Vis mindre",
        show_more: "Vis mere",
        show_previous: "Vis forrige",
        suggestions: "Forslag",
        to: "Til"
      },
      service_availability: {
        checkout: { title: "Driftsforstyrrelser" },
        generic: { title: "Driftsforstyrrelser" }
      },
      settings: {
        abort: "Annuller",
        add_card: "Tilf\xF8j betalingskort",
        add_card_success: "Dit betalingskort er blevet gemt!",
        allow_mobile_download: {
          hint_active: "Download med mobildata er tilladt",
          hint_inactive: "Tillader kun download via Wi-Fi",
          title: "Tillad downloads med mobildata"
        },
        app_info_title: "Om appen",
        bonus: "Min bonus",
        buy_tickets_service_fee: {
          description: "Der till\xE6gges ikke servicegebyr."
        },
        change_email: "Skift mail",
        change_info_web_only_description: "G\xE5 til {{url}} med din mobil, tablet eller computer for at redigere dine oplysninger.",
        change_info_web_only_description_url: "www.sfanytime.com",
        change_info_web_only_title: "\xC6ndring af din konto er kun mulig p\xE5 hjemmesiden",
        change_password: "Skift adgangskode",
        change_payment_method: "Skift betalingsmetode",
        change_payment_web_only_title: "\xC6ndring af betalingsmetode er kun mulig p\xE5 nettet",
        cookies_title: "Cookies",
        downloads_remove_all_confirm: "Slet alle downloads",
        downloads_remove_all_confirm_title: "Slet alle downloads",
        downloads_remove_confirm: "Fjern download",
        downloads_title: "Downloads",
        download_delete_all: "Slet alle",
        download_delete_all_downloads: "Slet alle downloads",
        download_no_downloads_text: "Du har ikke downloadet nogle film p\xE5 denne enhed.",
        download_receipt: "Download kvittering",
        download_total_size: "I alt {{st\xF8rrelse}}",
        empty_purchases: {
          message: "Her kan du se dine tidligere samt aktive k\xF8b. I \xF8jeblikket har du ingen k\xF8b registreret.",
          title: "Du har ingen registrerede k\xF8b"
        },
        help: "Hj\xE6lp",
        link: { to_device_settings: "G\xE5 til indstillinger" },
        manage_personal_information: "Personlige oplysninger",
        marketing: { title: "Opdater dine indstillinger for mail:" },
        my_account: {
          change_account_details: "Skift kontooplysninger",
          change_dibs_payment: "Skift betalingsmetode for smart tv",
          change_email_title: " Skift mail",
          change_payment_title: "Anden betalingsmetode",
          change_pw_title: "Skift adgangskode",
          customer_id: "Kundenummer:",
          portability_update_button: "Opdater betalingsmetode",
          username: "Brugernavn:"
        },
        my_account_title: "Min konto",
        my_profile: {
          address: "Adresse",
          change_country: "Skift land",
          choose_country: "V\xE6lg land",
          city: "By",
          country: "Land",
          delete_account: "Slet konto",
          delete_account_confirmed: "Din konto er nu slettet.",
          delete_account_description: "\xD8nsker du, at din konto, historik og alle oplysninger om dig slettes? En slettet konto kan ikke gendannes, hvilket betyder, at k\xF8bte film, serier og ubenyttede tickets g\xE5r tabt. Bekr\xE6ft dit valg ved at indtaste adgangskoden i n\xE6ste trin.",
          download: "Download",
          email: "Mailadresse",
          export_information: "Anmod om min information",
          export_information_description: "Vil du vide mere om, hvilke oplysninger vi har gemt om dig? Anmod om dine oplysninger let og sikkert her. Du kan med fordel bruge (File Viewer Plus, Altova XMLSpy, Microsoft Notepad, Microsoft WordPad eller Mozilla Firefox) for at l\xE6se .json.filen.",
          export_information_loading_message: "Dette kan tage et stykke tid afh\xE6ngigt af m\xE6ngden af data, der findes.",
          export_information_loading_title: "Vent venligst, vi henter dine oplysninger fra vores system",
          export_information_preview_title: "Forh\xE5ndsvisning af din dataeksport",
          first_name: "Fornavn",
          last_name: "Efternavn",
          myinfo_title: "Registerudtr\xE6k af personlige oplysninger",
          password: "Adgangskode",
          phone: "Mobilnummer",
          short_username: "Brugernavn",
          short_username_description: "Du kan v\xE6lge et kortere brugernavn, der forenkler login p\xE5 vores apps p\xE5 smart tv.",
          zipcode: "Postnummer"
        },
        newsletter_consent: {
          agree: "Ja tak",
          disagree: "Nej tak",
          title: "Vi vil gerne bevare kontakten med dig"
        },
        notifications: {
          allow_notifications: "Tillad notifikationer",
          controlled_from_settings_phone: "Styres fra telefonindstillingerne",
          description: "Med notifikationer f\xE5r du oplysninger om nye udgivelser, anbefalinger, kampagner eller app-funktioner.",
          dont_miss_new_releases: "G\xE5 ikke glip af nye udgivelser",
          enable_notifications: "Aktiver notifikationer",
          new_content: "Nyt indhold er tilg\xE6ngeligt",
          notification_settings_in_phone: "Dine notifikationer for SF anytime er",
          permission_description: "Hvis du aktiverer notifikationer, kan vi sende dig informationer om produktudgivelser, anbefalinger og kampagner.",
          title: "Notifikationer",
          to_device_settings: "G\xE5 til indstillinger"
        },
        notification_title: "Notifikationer",
        no_saved_payment_methods: "Du har ingen gemte betalingskort.\nHvis du tidligere har haft et gemt kort til vores gamle tv-apps, skal du tilf\xF8je et igen.",
        overview: "Oversigt",
        payment_card_tempcharge_disclaimer: "N\xE5r du registrerer et betalingskort, bliver et mindre bel\xF8b reserveret p\xE5 dit kort. Dette g\xF8res for at se, om kortet er gyldigt. Bel\xF8bet bliver aldrig debiteret, men kan ligge som et reserveret bel\xF8b i nogle dage afh\xE6ngigt af bank.",
        payment_method_remove_confirm: "Er du sikker p\xE5, at du vil fjerne betalingsmetoden?",
        payment_method_remove_failed: "Betalingsmetoden kunne ikke fjernes",
        payment_method_remove_successful: "Betalingsmetoden er nu fjernet",
        portability_title: "Se inden for EU",
        portability_unverified: "Ikke bekr\xE6ftet",
        portability_unverified_text: "Du kan se SF Anytime inden for EU/ E\xD8S, hvis du bekr\xE6fter dit hjemland. Ved at opdatere din betalingsmetode modtager vi disse oplysninger, s\xE5 kan du se film, n\xE5r du rejser inden for EU.",
        portability_verified: "Bekr\xE6ftet",
        portability_verified_disclaimer: "Da du opdaterede dine betalingsoplysninger, blev disse oplysninger stillet til r\xE5dighed for os.",
        portability_verified_text: "Vi har verificeret dit hjemland, s\xE5 nu kan du se film, n\xE5r du rejser inden for EU.",
        purchases: "Mine k\xF8b",
        recent_purchases: "Seneste k\xF8b",
        recent_rentals: "Lejede titler",
        remove_card: "Fjern kort",
        remove_payment_method: "Fjern",
        review_question: "Kan du lide appen?",
        save: "Gem",
        saved_card: "Gemt betalingskort",
        saved_payment_methods: "Gemte betalingsmetoder",
        show_more: "Vis mere",
        tickets: {
          bought_tickets: "K\xF8bte tickets",
          buy_tickets: "K\xF8b tickets",
          disclaimer: "Du kan k\xF8be eller modtage tickets, der fungerer som betaling, n\xE5r du k\xF8ber indhold p\xE5 en af SF Anytimes apps. Brug dem som betaling i vores mobilapps til iOS og Android. Gyldige tickets vil derefter v\xE6re synlige og kan bruges som betalingsmuligheder ved kassen.\n\nEn ticket svarer til et serieafsnit, og omkring 20 tickets d\xE6kker de fleste k\xF8b af vores film.",
          total_title: "{{ count }} x Tickets",
          valid: "Gyldig"
        },
        tickets_and_vouchers: "Mine tickets og v\xE6rdikoder",
        tickets_title: "Mine tickets",
        update: {
          confirm: "Opdater",
          text: "Der er en bedre version af appen!"
        },
        user_offline_goto_downloads: "G\xE5 til Mine downloads",
        user_offline_navigation: "Du ser ud til at v\xE6re offline. Tjek din internetforbindelse",
        "\u200Bnew_\u200Bemail": "Ny e-mailadresse"
      },
      store: {
        feature_1_heading: "Stream de nyeste film",
        feature_1_text: "De nyeste blockbustere, klassikere og alt derimellem",
        feature_2_heading: "Lej eller k\xF8b",
        feature_2_text: "Alle film og serier kan downloades og ses, hvor du vil ",
        feature_3_heading: "Sjov for hele familien",
        feature_3_text: "M\xF8d en masse venner fra Astrid Lindgrens verden",
        take_over: {
          price: "169 kr.",
          text: "Oscar\xAE-vinderne George Clooney og Julia Roberts genforenes p\xE5 sk\xE6rmen som et fraskilt par, der uventet ender p\xE5 en f\xE6lles mission: at afholde deres forelskede datter fra at beg\xE5 de samme fejl, som de engang begik. Ticket to Paradise er en romantisk komedie om pludselig at f\xE5 en ny chance."
        },
        take_over_child: { price: "149 kr." },
        toplist: {
          buy: "De mest popul\xE6re k\xF8betitler",
          rent: "De mest popul\xE6re lejetitler",
          series: "De mest popul\xE6re serier"
        },
        usp_1: "De nyeste film uden abonnement",
        usp_2: "Betal kun for det, du ser",
        usp_3: "Stream direkte, eller se offline",
        usp_4: "Et af Nordens bredeste udvalg"
      },
      tag: {
        collection: "Filmpakker",
        in_collection: "Del af filmpakke",
        is_collection: "Filmpakker"
      },
      test: { test: "Test for at oprette en n\xF8gle i S\xE6tning" },
      value_prop: {
        call_to_action: "Kom i gang",
        title: "Ny, gammel eller klassiker. V\xE6lg din favorit blandt tusindvis af titler."
      },
      voucher_not_valid_for_producttype_bundle: "Denne v\xE6rdikode kan ikke bruges til pakketilbud.",
      voucher_not_valid_for_producttype_episode: "Denne v\xE6rdikode kan ikke bruges til afsnit.",
      voucher_not_valid_for_producttype_movie: "Denne v\xE6rdikode kan ikke bruges til film.",
      voucher_not_valid_for_producttype_season: "Denne v\xE6rdikode kan ikke bruges til serier."
    }
  },
  en: {
    __typename: "Localization",
    id: "TG9jYWxpemF0aW9uOlNGQW55dGltZTpkUHlwTVpOMFBlbWRiTUE3eDljTnNkVytBWmM9OmVu",
    locale: "en",
    items: {
      age_recommendation: { child_friendly: "Child friendly" },
      auth: {
        access_code_expired_text: "The code you have entered is no longer valid.",
        access_code_expired_title: "Expired code",
        already_member: "Already a member?",
        back_home: "Back to home",
        complete_login_on_remote: "Complete login on your {{device}} device",
        continue_on_init_device: "Continue on your {{device}} tv",
        current_password_placeholder: "Current password",
        email_changed_to: "Email is changed to:",
        email_placeholder: "Email address",
        enter_new_email_for: "Please enter a new email for:",
        enter_new_password: {
          for: "Please enter a new password for:",
          info_text: "You will need to login again in the apps and browsers where you are already logged in before."
        },
        enter_new_password_for_email: "Please enter a new password for {{email}} . You will need to login again in the apps and browsers where you are already logged in before.",
        facebook_error_message: 'If you already have created a SF Anytime account with facebook, try to use "reset password" on sfanytime.com. Type the email adress connected to your facebook account. Then use the new password and your facebook email to login instead.',
        facebook_error_title: "Facebook login is currently unavailable",
        forgot_password_description: "Enter your email and we'll send you instructions on how to reset your password.",
        forgot_password_done_button: "Back to login",
        forgot_password_done_description: "An email has been sent to you with password reset instructions.",
        forgot_password_done_help: "If you don see the mail check your spam folder. If it still does not work please",
        forgot_password_done_title: "Almost done",
        forgot_password_link: "Forgot your password?",
        forgot_password_title: "Forgot your password?",
        logged_in: "You are logged in",
        login_button: "Log in",
        login_button_apple: "Apple",
        login_button_facebook: "Facebook",
        login_button_google: "Google",
        login_button_in_progress: "Logging in...",
        login_or_signup: "Login or sign up",
        login_title: "Login",
        logout_confirmation: "Are you sure you want to log out?",
        logout_from_all_devices_confirmation: "Are you sure you want to log out from all your devices? You will have to login again on each of the device you want to use.",
        logout_from_all_devices_title: "Logout from all devices",
        logout_title: "Logout",
        new_member: "New to SF Anytime?",
        new_password_placeholder: "New password",
        new_password_title: "New password",
        now_logged_in_as: "You are now logged in as",
        no_verification_email: "Didn\u2019t receive the email?",
        or_login_with: "Or continue with",
        password_placeholder: "Password",
        password_restriction: "The password must be at least 8 characters long.",
        password_updated_for: "Password updated for:",
        remeber_me: "Remember me",
        remote_login_device_text: "with your phone, tablet or computer and enter the following code",
        remote_login_go_to: "Go to",
        send_verification_email_again: "Send again",
        signedup_button: "Lets get started",
        signedup_title: "Thank you for signing up with us",
        signup_button: "Create account",
        signup_slogan: "Stream the lastest movies!\nTo become a member is free.",
        signup_title: "Signup",
        signup_usp_array: [
          "Watch anywhere you like",
          "Access to the newest films",
          "Save lists and get personal tips"
        ],
        tos_confirm: "SF Anytimes anv\xE4ndarvillkor",
        tos_confirmation: "Accept the terms of use to proceed",
        tos_consent: "I confirm that I am at least 18 years of age and accept",
        tos_url: "https://www.sfanytime.com/sv/page/anvandarvillkor",
        verify_email_description: "We have sent a verification email to you.\u2028Please verify your account by clicking on\u2028the link in the email sent to:",
        verify_email_social_login_description: "We have sent a verification email to you.\u2028Please verify your account by clicking on\u2028the link in the email sent to\u2028your Facebook account:",
        "\u200Blogin_with_social_media": "or login with",
        "\u200Bregister_with_social_media": "or create account with"
      },
      checkout: {
        audio: { title: "Audio track" },
        buy_tickets_button_title: "Buy tickets",
        campaign_title: "Sale",
        choose_language: "You need to choose the language",
        confirm_button: { title: "Complete purchase" },
        continue_to_payment: { title: "Continue to payment" },
        done: "Paid and done!",
        download_our_app_ups: "\nYou can also watch our apps on your mobile, tablet or SmartTV. We also support Chromecast.",
        entitlement_type: {
          buy: "Buy",
          buy_description: "Watch when you want, for as many times as you want",
          rent: "Rent",
          rent_description: "48 hours rental time",
          title: "Rent or buy"
        },
        episode: "Episode",
        episode_count: "{{count}} episodes",
        episode_count_title: "Episodes",
        est: "Buy",
        est_bundle_duration: "Watch whenever you want, as many times as you want.",
        est_episode_duration: "Watch whenever you want, as many times as you want.",
        est_movie_duration: "Buy movie, watch it whenever you want, as many times as you want.",
        est_season_duration: "Watch whenever you want, as many times as you want.",
        hide_price_details: "Hide details",
        language: {
          local: "Local language",
          original: "Original language",
          title: "Language",
          title_short: "Language"
        },
        leave_warning: "Are you should you want to leave the checkout? Leavening while active payment is in progress may cause loss of order.",
        pay: "Pay",
        payment: {
          add_saved_card_tip: "Pay directly in your TV next time by saving your card information to your account on SF Anytime",
          adyen_applepay: "Apple Pay",
          adyen_applepay_description: "Apple Pay enables you to make secure purchases using Apple Cash, Apple Card, and any other credit and debit cards that you add to Wallet.",
          adyen_creditcard: "Creditcard",
          adyen_creditcard_description: "Secure payments using Visa or Mastercard.",
          adyen_klarna: "Pay later",
          adyen_klarnaaccount: "Pay over time",
          adyen_klarnaaccount_description: "Pay over time",
          adyen_klarnapaynow: "Pay now",
          adyen_klarnapaynow_description: "Pay now",
          adyen_klarna_description: "Pay with Klarna.",
          adyen_mobilepay: "MobilePay",
          adyen_mobilepay_description: "Enter the phone number of the mobile phone you are paying with. You must have the MobilePay app installed.",
          adyen_savedcreditcard: "Saved Creditcard",
          adyen_savedcreditcard_description: "Pay with {{name}} {{number}}.",
          adyen_swish: "Swish",
          adyen_swish_description: "Pay with the Swish app on your mobile.",
          adyen_vipps: "Vipps",
          adyen_vipps_description: "Pay easily and conveniently with Vipps.",
          amex: "Card",
          amex_description: "Secure payments using American Express.",
          apple_inapp: "App Store",
          apple_inapp_description: "Pay with your saved payment method that you use for the App Store, iTunes Store, iCloud, and more.",
          card: "Card",
          card_description: "Secure payments using Visa and Mastercard",
          freeproduct: "Free",
          google_inapp: "Google Play",
          google_inapp_description: "Pay with your saved payment method that you use for Google Play.",
          group_klarna: {
            description: "Flexible payments with Klarna.",
            title: "Klarna"
          },
          klarna: "Klarna",
          klarna_description: "Pay via Klarna using a card or bank account",
          more_payment_options: "More payment options",
          more_payment_options_description: "Choose another payment method or if you have a voucher.",
          not_available_in_app_description: "The payment option is not available for purchase in this app.",
          other: "Other payment option",
          prepaid: "Home movie ticket",
          saved_card: "Saved card",
          save_payment_info: "Save payment info",
          sf_freeproduct: "Free",
          sf_loyaltypoints: "Loyalty points",
          sf_loyaltypoints_description: "SF loyalty points ",
          sf_ticket: "{{cost}} tickets",
          sf_ticket_buy_more_one: "Buy {{count}} ticket",
          sf_ticket_buy_more_other: "Buy {{count}} tickets",
          sf_ticket_description_one: "Pay with {{cost}} of your tickets.\nYou have a total {{count}} ticket.",
          sf_ticket_description_other: "Pay with {{cost}} of your tickets.\nYou have total {{count}} tickets.",
          sf_ticket_description_zero: "Pay with {{cost}} tickets.\nYou have no tickets at the moment.",
          sf_ticket_description_disabled_one: "You need {{count}} more ticket.",
          sf_ticket_description_disabled_other: "You need {{count}} more tickets.",
          sf_voucher: "Voucher",
          swish: "Swish",
          swish_description: "Pay with the Swish app on your mobile.",
          swish_disabled: "Swish is currently turned off due to technical problems.",
          to_payment: "To payment",
          to_payment_button: "To payment",
          tv_adyen_pay_with_saved_card: "Pay with saved card",
          use_a_voucher: "Use a voucher",
          valuecode: "Valuecode"
        },
        payment_method: { title: "Payment method" },
        payment_method_group_placeholder: "Payment options",
        purchase_not_allowed_in_app: {
          link: "Read more on how to rent movies",
          text: "Unfortunately, you cannot make purchases in the app."
        },
        receipt: {
          app_description: "Using our app you are able to stream our movies to your TV via Chromecast or Airplay, as well as download movies for offline viewing",
          datetime: "Date",
          discount: "Discount",
          fee: "Service fee for in app purchase",
          legal_info: "When you start streaming the movie or use our tickets you consent to SF Anytime completing the delivery of the product, and you are no longer able to recall the purchase",
          open_in_app: "Open in app",
          order_no: "Order reference",
          payment_method: "Payment method",
          receipt_title: "Receipt",
          save: "Save receipt (pdf)",
          smarttv_description: "Or use one of our Smart TV apps on Samsung, LG, AppleTV and Android TV.",
          sum: "Total",
          thanks: "Thank you for streaming with us!",
          ticket_valid_to: "Tickets valid until",
          valid_to: "Valid until",
          vat: "VAT",
          voucher_legal_info: "The movie codes are valid for 6 months.",
          you_have_bought: "You have purchased",
          you_have_rented: "You have rented"
        },
        rental_duration: "Rental Period",
        select_placeholder: "Select",
        show_price_details: "Show details",
        subtitles: { no_subtitles: "No subtitles", title: "Subtitles" },
        ticket_prompt: {
          description: "Buy tickets directly in our app or from our webpage.\nThen use your tickets to exchange for a movie or series.",
          not_enough_tickets: {
            title: "You need more tickets to continue with this payment method"
          },
          tickets_are_required: {
            title: "You need tickets to make a purchase in this app"
          }
        },
        ticket_type: {
          description_one: "Valid for 3 years from the date of purchase and can be used in all our apps.",
          description_other: "Valid for 3 years from the date of purchase and can be used in all our apps.",
          description_valid_to: "A ticket is valid for 3 years from the date of purchase",
          title_one: "1 Ticket",
          title_other: "{{count}} Ticket",
          title_zero: "No ticket"
        },
        total_cost: "Total cost incl. VAT",
        tvod: "Rent",
        tvod_episode_duration: "Watch anytime for 48 hours.",
        tvod_movie_duration: "Watch anytime in 48 hours.",
        tvod_season_duration: "Watch anytime in 30 days.",
        update: {
          text: "We have released an improved version of our app and you need to update your app to continue.",
          title: "Update your app"
        },
        value_code_applied_value: "{{percent}}% discount",
        value_code_apply: "Apply",
        value_code_invalid: "Value code is not valid for this title or does not exist",
        value_code_placeholder: "Enter your value code",
        value_code_prompt: "Do you have a voucher? Enter it here",
        value_code_title: "Voucher",
        value_code_used: "The value code is already used",
        voucher: {
          campaign: {
            "5_for_4": {
              description: "1 rental voucher code less to pay for.",
              label: "Buy 5 pay for 4"
            }
          },
          campaign_title: "An offer is applied",
          delivery_type: {
            my_email: "To my E-mail",
            recipient_email: "To recipient by using E-mail",
            recipient_sms: "To recipient by using SMS",
            title: "Choose delivery method"
          },
          entitlement_type: {
            buy_description: "Watch when you want, for as many times as you want",
            buy_text_price: "Buy {{price}}",
            rent_text_description: "48 hours rental time",
            rent_text_price: "Rent {{price}}"
          },
          title: "Buy movie vouchers"
        },
        voucher_has_issue: "Please correct or remove the voucher code",
        voucher_not_valid: "The voucher code is not valid with your choices",
        webview_timeout: "This is taking longer than usual...",
        you_have_bought: "You have bought",
        you_have_rented: "You have rented",
        you_selected_to_buy: "You have selected to buy",
        you_selected_to_rent: "You selected to rent"
      },
      emails: {
        content_notification: {
          reason_for_email_one: "You are receiving this email because you have enabled notifications on this title.",
          reason_for_email_other: "You are receiving this email because you have enabled notifications on this titles.",
          subject_one: "A title you have watched is now available",
          subject_other: "Your watched titles are now available"
        },
        footer: {
          cant_reply: "This email cannot be replied to. If you have any questions, ",
          copyright: "\xA9 2024 SF Anytime AB (org no.  556748-2616, VAT SE556748261601)",
          please_contact_us_link: "please contact us here",
          regards: "Med v\xE4nliga h\xE4lsningar,",
          unsubscribe: "Unsubscribe",
          web_link: "Web version"
        },
        gdpr_clean_up: {
          clarification: "*Only applies to the account registered to the email address you received this email to. If you have registered several accounts with different email addresses, these are handled separately.",
          cta: "Rent a movie",
          delete_account_text_one: "If you want your account deleted, you do not need to do anything, the account will be automatically deleted in 1 day. You can always create a new free account with the same details if you want to have an account with us again in the future.",
          delete_account_text_other: "If you want your account deleted, you do not need to do anything, the account will be automatically deleted in {{number}} days. You can always create a new free account with the same details if you want to have an account with us again in the future.",
          intro_one: "It's been a while since you last visited us and due to GDPR, we have to delete your account* in 1 day.",
          intro_other: "It's been a while since you last visited us and due to GDPR, we have to delete your account* in {{number}} days.",
          reason_for_email: "You are receiving this email because you have an account at our service.",
          save_account_text: "Do you want to keep your account?\xA0Rent a movie with {{discount}}% off with the value code below!",
          subtitle_one: "In 1 day, your free account will be deleted",
          subtitle_other: "In {{number}} days, your free account will be deleted",
          title: "Reminder of your SF Anytime account",
          voucher_info: "The voucher code is personal and only valid on this account, can only be used once and the discount applies to a rental movie up to 59 kr. Not valid for theatrical or purchase movies and cannot be combined with other offers.",
          voucher_limitations: "Applies to rental movie up to 59 kr.\n",
          voucher_offer: "{{discount}}% discount on rental movies"
        },
        header: {
          hello: "Hello",
          hello_we_miss_you: "Hello we miss you!",
          looking_weird: "Does the email look strange?",
          open_in_browser: "Open in web browser"
        },
        new_user: {
          intro: "It's great that you have become a member with us. We have the widest movie shelves in the Nordic region, filled with everything from award-winning masterpieces to great entertainment. We believe that there is a film for every occasion and an opportunity for every film.",
          intro2: "Take a deep breath and venture into the collection.",
          title: "Welcome to SF Anytime"
        },
        order_receipt: {
          find_your_playable_content: "You can find receipts for all your purchases on the My Purchases page and your purchased content on the My Content page.",
          go_to_playable_content: "Play",
          greeting_bundle: "We at SF Anytime wish you a pleasant movie time!",
          greeting_episode: "We at SF Anytime wish you happy series viewing!",
          greeting_movie: "We at SF Anytime wish you a pleasant movie time!",
          greeting_season: "We at SF Anytime wish you happy series viewing!",
          greeting_ticketpack: "We at SF Anytime hope your tickets will be put to good use!",
          greeting_voucher: "We at SF Anytime hope the movie vouchers will be put to good use!",
          more_about_vouchers: "Read more about movie vouchers",
          product_type_bundle_est_description: "You can watch the movies as many times as you like.",
          product_type_episode_est_description: "You can watch the episode as many times as you like.",
          product_type_episode_tvod_description: "48 hours rental time",
          product_type_movie_est_description: "You can watch the movie as many times as you like.",
          product_type_movie_tvod_description: "48 hours rental time",
          product_type_season_est_description: "You can watch the serie season as many times as you like.",
          product_type_season_tvod_description: "Watch anytime in 30 days.",
          product_type_ticketpack_est_description: "Your tickets are valid for three years from the purchase date and are available in your account. They can be used as payment when you purchase content from any of our apps.",
          product_type_voucher__description: "Attached you will find your codes. Save the codes on your computer or print them out and give them as a gift.",
          reason_for_email: "This is a confirmation of a purchased content with an account that is using this email address.",
          subject: "Receipt from SF Anytime",
          thanks_bundle: "Thank you for choosing to purchase a movie bundle with us!",
          thanks_episode: "Thank you for choosing to purchase a serie episode with us!",
          thanks_movie: "Thank you for choosing to purchase a movie with us!",
          thanks_season: "Thank you for choosing to purchase a serie season with us!",
          thanks_ticketpack: "Thank you for choosing to purchase tickets with us!",
          thanks_voucher: "Thank you for choosing to purchase movie vouchers with us!",
          title: "Receipt"
        },
        reset_password: {
          intro: "This is a request for password reset for the account:",
          not_requested: "If you did not request an email to reset your password, you should still change your password on the My Account page under Settings to protect your account.",
          reset_password: "Reset password",
          reset_password_link_text: "Click the button below to choose a new password. The link is valid for 30 minutes.",
          subject: "Reset of password",
          title: "Reset of password"
        },
        voucher: {
          code_label: "Code:",
          valid_to: "Valid to:",
          your_personal_code: "Your personal code"
        }
      },
      genre: {
        "3d": "3D",
        action: "Action",
        adult: "Adult",
        adventure: "Adventure",
        animated: "Animated",
        anime: "Anime",
        children: "Children",
        "children-family": "Children-Family",
        "children-family (Copy)": "Children-Family",
        comedy: "Comedy",
        crime: "Crime",
        cult: "Cult",
        danish: "Danish",
        documentary: "Documentary",
        drama: "Drama",
        finnish: "Finnish",
        horror: "Horror",
        "movie-gems": "Gems",
        music: "Music",
        norwegian: "Norwegian",
        romance: "Romance",
        "sci-fi": "Sci-fi",
        "sf-kids": "SF-kids",
        swedish: "Swedish",
        thriller: "Thriller",
        "tv-series": "TV-series",
        war: "War",
        western: "Western"
      },
      glossary: {
        abort: "Abort",
        activate: "Activate",
        add_to_my_list: "Add to My list",
        amount: "Amount",
        app_version: "App version",
        available: "Available",
        back_navigation: "Tillbaka",
        bought: "Bought",
        bought_badge: "OWNED",
        brand: "SF Anytime",
        build_number: "Build number",
        bundle: "Movie collections",
        buy: "Buy",
        buy_first_episode_from: "First episode from",
        buy_from: "From",
        campaign: "Sale",
        cancel: "Cancel",
        close_modal: "Close",
        coming_soon: "Coming soon",
        continue: "Continue",
        customer_service: "Support",
        download_from_AppStore: "Download on the App Store ",
        download_from_GooglePlay: "Get it on Google Play",
        error: "Error",
        fullscreen: "Full screen",
        hide_banner: "Hide",
        last_chance: "Last chance",
        loading: "Loading...",
        mark_as_not_watched: "Mark as not watched",
        mark_as_watched: "Mark as watched",
        minutes: "minutes",
        movie: "Movie",
        mute: "Mute",
        next_episode: "Next episode",
        no: "No",
        not_available: "Not available",
        off: "Off",
        on: "On",
        open: "Open",
        open_in_browser_button: "Open in web browser",
        password: "Password",
        pause_button: "Pause",
        play_button: "Play",
        read_more: "Read more",
        release: "Release",
        release_date: "Release date",
        remote_control: "remote control",
        remove_from_my_list: "Remove from My list",
        rented: "Rented",
        rented_badge: "RENTED",
        saved: "Saved",
        search_results: "Search results",
        select: "Select",
        series: "Series",
        sf_anytime: "SF Anytime",
        show: "Show",
        show_all: "Show all",
        show_all_x: "Show all {{count}}",
        support_forum: "support.sfanytime.com",
        support_mail: "support@sfanytime.com",
        this_device: "This device",
        tickets: "Tickets",
        trailer: "Trailer",
        unknown: "Unknown",
        username: "Username",
        warning: "Warning",
        x_results: {
          plural: { tes: "29 results" },
          singular: "{{number}} result"
        },
        yes: "Yes",
        "\u200Brented_for": "Rented for",
        "\u200Brented_to": "Rented to"
      },
      media: {
        age_rating: "Rating",
        audio: "Audio track",
        bundle: {
          discount_text: "Save {{percentage}}%",
          movie_count: "{{count}} movies"
        },
        continue_watching: {
          empty: "Movies and series you haven't finished watching yet will appear here",
          title: "Continue Watching"
        },
        crew: { actor: "Actor", director: "Director", title: "Featured Crew" },
        download: {
          action_will_remove_active_download: "This action will cancel your active download.",
          cancel_download: "Cancel download",
          delete_download: "Delete download",
          deleting: "Deleting",
          deleting_download_description: "Deleting download... This can take a while.",
          downloaded: "Downloaded",
          downloading: "Downloading",
          download_completed: "Download completed",
          download_error: "Download error",
          list_title: "Downloaded on this device",
          logout_warning: "Your downloads will be deleted when logging out. ",
          no_entitled_downloads: "There are downloads on this device but none that belong to your account. You can still delete them. ",
          no_space_left_error: "No space left on device.",
          paused: "Paused",
          pause_download: "Pause",
          pause_download_error: "Failed to pause the download, please try again.",
          pick_quality: "Choose quality to download",
          pick_quality_high: "High",
          pick_quality_low: "Low",
          pick_quality_max: "Max",
          pick_quality_medium: "Medium",
          quality: "Quality",
          queued: "Queued",
          removing: "Removing",
          removing_download: "Removing download",
          resume_download: "Resume download",
          resume_download_error: "Failed to resume the download, please try again. ",
          start_download: "Download",
          start_download_error: "Failed to start the download, please try again.",
          try_to_download_again: "Please try to download the content again."
        },
        entitlement_type: "Purchase type",
        episode_rental_left: "Rental ends in: {{rental_time_left}}",
        extra_material: { title: "Extra material" },
        from_countries: "Produced in",
        has_access: "Access",
        keep_watching: "Keep watching",
        length: "Length",
        meta_description_movie: "Rent and buy the movie {{ title }} with {{ actor1 }} and {{ actor2 }}. Stream this {{ genre }} movie och other movies online at {{ brand }}.",
        meta_description_series: "Rent or buy the series {{ title }} starring {{ actor1 }} and {{ actor2 }}. Stream this {{ genre }} series and other series online on {{ brand }}.",
        meta_title: "{{title}} \u2013 Buy or rent and stream on SF Anytime",
        more_info_title: "More information",
        movie_bought_info: "Bought \u2013 Watch when you want, as many times as you want",
        movie_rental_left: "Rental ends in: {{rental_time_left}}",
        movie_rented_and_expires_at: "Rented \u2013 Rental ends {{rent_end_time}}",
        my_list: "My list",
        my_list_add_button: "My list",
        notify: "Notify",
        notifyme_button: "Notify me",
        notifyme_button_active: "Followed",
        only_on: "Only on",
        production_country: "Produced in",
        purchase: { unavailable_button: "Unavailable for rent" },
        release_date: "Release: {{dateString}}",
        series: {
          average_episode_length: "~{{length}}/episode",
          buy_this_season: "Buy this season",
          episodes: "Episodes",
          episode_count: "{{count}} episodes",
          next_episode: "Next episode",
          not_available: "This content is not available at this time",
          season: "Season",
          seasons: "Seasons",
          season_release: "Release: {{dateString}}"
        },
        share_button: "Share",
        show_more: "Show more",
        similar_movies: "Similar",
        similar_series: "Similar",
        similar_tickets: "Other tickets",
        similar_titles: "Similar titles",
        subtitles: "Subtitles",
        trailer_button: "Trailer",
        upcoming: "Upcoming",
        watched: { title: "Watched movies" }
      },
      mymedia: {
        entitlements_empty_list: [
          "Here you'll find the movies and shows you have rented or bought",
          "Watch on your TV with Chromecast or Airplay",
          "Download and watch while you're offline \u2013 perfect when traveling"
        ],
        entitlements_title: "My Movies & Series",
        favorites_title: "My List",
        my_content_title: "My content",
        my_list_empty_array: [
          "You have not saved any movies or shows to My list yet",
          "Smart if you want to save it for later",
          "Look for this symbol"
        ],
        my_list_title: "My list",
        saved_searches_title: "My notifications"
      },
      offer_redeemed: "Looks like this already have been redeemed",
      push: {
        discountedtitle: {
          text: "A title that you might like is now discounted.",
          title: '"{{localtitle}}" is now discounted'
        },
        multipletitlesmatchingsavedsearch: {
          text: '"{{localtitles}}" are now available.',
          title: "Your watched titles are now available"
        },
        newtitle: {
          text: "A title that you might like is now available.",
          title: '"{{localtitle}}" is now available'
        },
        singletitlematchingsavedsearch: {
          text: "A title you have watched is now available.",
          title: '"{{localtitle}}" is now available.'
        },
        title_matching_saved_search: {
          "text _one": "A title you have watched is now available.",
          "text _other": "Your watched titles are now available"
        }
      },
      search: {
        active_filters: "Active filters",
        agelimit_years: "{{age}} years",
        did_you_mean: "Did you mean?",
        empty_results: "Oops, it looks like your search returned no results.",
        empty_results_message: "Try to clear your search, change your filters or choose something from our popular search results below.",
        facet: {
          actors: "actors",
          ageLimit: "Age limit",
          directors: "Directors",
          duration: "Duration",
          genres: "Genres",
          lowestPrice: "Lowest price",
          manifest: {
            audio: { tracks: { language: "Audio track" } },
            subtitles: { language: "Subtitles" }
          },
          mediaTags: { name: "Media Tags" },
          metaCollections: "Topics",
          productType: "Type",
          ratings: { imdb: "IMDB Rating" },
          releaseYear: "Release Year"
        },
        filters_hits: "Hits",
        filters_reset_button: "Reset filters",
        filters_title: "Filters",
        from: "From",
        history: "Recent searches",
        input_placeholder: "S\xF6k",
        input_press_ok: "Press OK to open keyboard ",
        "list-view": "List view",
        "list-view-as-grid": "Grid",
        "list-view-as-list": "List",
        "load-more-button": "Load more",
        not: "Not {{ filter }}",
        number_of_seasons: {
          plural: "{{seasonCount}} seasons",
          singular: "{{seasonCount}} season"
        },
        placeholder: "Search...",
        popular_search_terms: "Popular search terms:",
        recent_searches: "Recent searches",
        remove: "Remove",
        reset_button: "Reset",
        reset_refinements: "Clear",
        reset_search: "Start over",
        save: "Save",
        saved: "Saved",
        saved_searches: "Saved",
        show_less: "Show less",
        show_more: "Show more",
        show_previous: "Show previous",
        suggestions: "Suggestions",
        to: "To"
      },
      service_availability: {
        checkout: { title: "Operational disturbances" },
        generic: { title: "Operational disturbances" }
      },
      settings: {
        abort: "Cancel",
        add_card: "Add card",
        add_card_success: "Your credit card has been saved! ",
        allow_mobile_download: {
          hint_active: "Download with mobile data is allowed",
          hint_inactive: "Is only allowing download over Wi-Fi",
          title: "Allow downloads with mobile data"
        },
        app_info_title: "About the app",
        bonus: "My bonus",
        buy_tickets_service_fee: { description: "There is no service fee." },
        change_email: "Change e-mail",
        change_info_web_only_description: "Go to {{url}} with your mobile, tablet or computer to edit your info.",
        change_info_web_only_description_url: "www.sfanytime.com",
        change_info_web_only_title: "Editing your account is only possible on the web",
        change_password: "Change password",
        change_payment_method: "Change payment method",
        change_payment_web_only_title: "Changing payment method is only possible on the web",
        cookies_title: "Cookies",
        downloads_remove_all_confirm: "Remove all",
        downloads_remove_all_confirm_title: "Delete all downloads",
        downloads_remove_confirm: "Remove download",
        downloads_title: "Downloads",
        download_delete_all: "Delete all",
        download_delete_all_downloads: "Delete all downloads",
        download_no_downloads_text: "You have yet to download any movies.",
        download_receipt: "Download receipt ",
        download_total_size: "Total {{size}}",
        empty_purchases: {
          message: "Here you will be able to review your previous and active purchases. At the moment you have no purchases registered.",
          title: "You have no purchases registered"
        },
        help: "Help",
        link: { to_device_settings: "Go to settings" },
        manage_personal_information: "Manage your personal information",
        marketing: { title: "Update your preferences for email: " },
        my_account: {
          change_account_details: "Change account details",
          change_dibs_payment: "Change payment method for Smart TV",
          change_email_title: "\xC4ndra e-post",
          change_payment_title: "Change payment method",
          change_pw_title: "\xC4ndra l\xF6senord",
          customer_id: "Account number:",
          portability_update_button: "Update payment method ",
          username: "Username:"
        },
        my_account_title: "My account",
        my_profile: {
          address: "Address",
          change_country: "Change country",
          choose_country: "Choose country",
          city: "City",
          country: "Country",
          delete_account: "Delete account",
          delete_account_confirmed: "Your account is now removed.",
          delete_account_description: "Do you want your account, history, and all information about you to be deleted? An deleted account cannot be recreated, which means that purchased movies and series will be lost. Confirm your choice by entering the password in the next step.",
          download: "Download",
          email: "E-mail",
          export_information: "\nRequest my information",
          export_information_description: "Do you want to know more about what information we have saved about you? Request your information easy and secure here. To read the .json file use any of this\n#1) File Viewer Plus.\n#2) Altova XMLSpy.\n#3) Microsoft Notepad.\n#4) Microsoft WordPad.\n#5) Notepad++\n#6) Mozilla Firefox.",
          export_information_loading_message: "This may take a while depending on the amount of data that exists.",
          export_information_loading_title: "Please hold, we are fetching your data from our system",
          export_information_preview_title: "Preview of your data export",
          first_name: "First name",
          last_name: "Last name",
          myinfo_title: "Registry extract personal data",
          password: "Password",
          phone: "Mobile",
          short_username: "Username",
          short_username_description: "You can choose a shorter username that simplifies logging into our SmartTV apps.\n\n",
          zipcode: "Zipcode"
        },
        newsletter_consent: {
          agree: "I agree",
          disagree: "No thank you",
          title: "We'd love to keep in touch with you"
        },
        notifications: {
          allow_notifications: "Allow notifications",
          controlled_from_settings_phone: "Controlled from the settings of the phone",
          description: "With notifications on you will be able to get information of new releases, recommendations, campaigns or app features.",
          dont_miss_new_releases: "Don't miss any new releases",
          enable_notifications: "Enable notifications",
          new_content: "New content is available",
          notification_settings_in_phone: "Your notifications for SF anytime is",
          permission_description: "With notifications on you will be able to get information of product releases, recommendations and campaigns.",
          title: "Notifications",
          to_device_settings: "Go to settings"
        },
        notification_title: "Notifications",
        no_saved_payment_methods: "You have no saved payment cards.\\n\nIf you have previously had a saved card for our old TV apps, you need to add one again.",
        overview: "Overview",
        payment_card_tempcharge_disclaimer: "When you register a payment card 2 [[local currency]] will be reserved to check that the card is valid. The amount will never be debited to your account, but may be reserved up to a few days depending on your bank.",
        payment_method_remove_confirm: "Are you sure you want to remove the payment method?",
        payment_method_remove_failed: "The payment method could not be removed",
        payment_method_remove_successful: "The payment method is now removed",
        portability_title: "Watch within the EU",
        portability_unverified: "Unverified",
        portability_unverified_text: "You can use SF Anytime within EU/EES if you verify your country of residence. All you have to do is update your payment method and we will receive the information needed. After that you can continue enjoying movies and series while traveling within the EU. ",
        portability_verified: "Verified",
        portability_verified_disclaimer: "When you update your payment method that information is made available to us.",
        portability_verified_text: "We have verified your country of residence, you are free to enjoy movies while travelling in the EU.",
        purchases: "My purchases",
        recent_purchases: "Recent purchases",
        recent_rentals: "Recent rentals",
        remove_card: "Remove card",
        remove_payment_method: "Remove",
        review_question: "Do you like the app?",
        save: "Save",
        saved_card: "Saved card",
        saved_payment_methods: "Saved payment methods",
        show_more: "Show more",
        tickets: {
          bought_tickets: "Bought tickets",
          buy_tickets: "Buy tickets",
          disclaimer: "You can buy or receive tickets that serve as payment when you purchase content on any of SF Anytime's apps. Use them as payment in our mobile apps for iOS and Android. Valid tickets will then be visible and can be used as payment options at checkout.\n\nOne ticket is equivalent to one series episode and up to twenty tickets cover most purchases of our film selection.",
          total_title: "{{ count }} x Tickets",
          valid: "Valid"
        },
        tickets_and_vouchers: "My tickets & vouchers",
        tickets_title: "My tickets",
        update: {
          confirm: "Update",
          text: "There is a better version of the app!"
        },
        user_offline_goto_downloads: "Go to My Downloads",
        user_offline_navigation: "You appear to be offline",
        "\u200Bnew_\u200Bemail": "New email address"
      },
      store: {
        feature_1_heading: "Stream the latest movies",
        feature_1_text: "The latest blockbusters, the classics and everything between",
        feature_2_heading: "Rent or buy",
        feature_2_text: "Either rent for 24 hours or buy to your library",
        feature_3_heading: "Fun for the whole family",
        feature_3_text: "Meet a lot of friends from Astrid Lindgren",
        take_over: {
          text: "Oscar\xAE winners George Clooney and Julia Roberts reunite on the screen as a divorced couple who unexpectedly end up on a joint mission: to keep their daughter in love from making the same mistakes they once did. Ticket to Paradise is a romantic comedy about suddenly getting an unexpected second chance."
        },
        toplist: {
          buy: "Top purchases",
          rent: "Top rentals",
          series: "Top series"
        },
        usp_1: "The latest movies without any subscription",
        usp_2: "Pay only for what you watching",
        usp_3: "Stream instant or watch offline",
        usp_4: "One of the Nordic countries' widest assortments"
      },
      tag: {
        collection: "Collection",
        in_collection: "In collection",
        is_collection: "Collection"
      },
      test: { test: { testing_for_fun: "Testing for fun" } },
      value_prop: {
        call_to_action: "Lets get started",
        title: "New, old, classic. Choose your favorite from thousands of titles."
      },
      voucher_not_valid_for_producttype_bundle: "This voucher cannot be used for package offers.",
      voucher_not_valid_for_producttype_episode: "This voucher cannot be used for episodes.",
      voucher_not_valid_for_producttype_movie: "This voucher cannot be used for movies.",
      voucher_not_valid_for_producttype_season: "This voucher cannot be used for series."
    }
  },
  fi: {
    __typename: "Localization",
    id: "TG9jYWxpemF0aW9uOlNGQW55dGltZTpmaTpoK3pGRWs0aFV5anE2c2dLUzNHUElsSjNBMms9",
    locale: "fi",
    items: {
      age_recommendation: { child_friendly: "Lapsiyst\xE4v\xE4llinen" },
      auth: {
        access_code_expired_text: "Sy\xF6ttt\xE4si koodia ei en\xE4\xE4 voi muuttaa.",
        access_code_expired_title: "Vanhentunut koodi",
        already_member: "Oletko jo j\xE4sen?",
        back_home: "Siirry kotisivulle",
        complete_login_on_remote: "T\xE4ydellinen kirjautuminen laitteeseen {{device}}",
        continue_on_init_device: "Jatka televisiossa {{device}}",
        current_password_placeholder: "Nykyinen salasana",
        email_changed_to: "S\xE4hk\xF6postiosoite muutetaan muotoon:",
        email_placeholder: "S\xE4hk\xF6postiosoite",
        enter_new_email_for: "Anna uusi s\xE4hk\xF6postiosoite:",
        enter_new_password: {
          for: "Anna uusi salasana osoitteeseen:",
          info_text: "Sinun t\xE4ytyy kirjautua sis\xE4\xE4n uudelleen sovelluksissa ja selaimissa, joissa olet jo kirjautunut."
        },
        enter_new_password_for_email: "Kirjoita uusi salasana kohteelle {{email}} . Sinun on kirjauduttava uudelleen sis\xE4\xE4n sovelluksissa ja selaimissa, joissa olet jo kirjautunut sis\xE4\xE4n aiemmin.",
        facebook_error_message: 'Jos olet jo luonut SF Anytime -tilin Facebookissa, yrit\xE4 k\xE4ytt\xE4\xE4 sfanytime.com "nollaa salasana". Kirjoita Facebook-tiliisi yhdistetty s\xE4hk\xF6postiosoite. Kirjaudu sitten sis\xE4\xE4n uudella salasanalla ja Facebook-s\xE4hk\xF6postiosoitteellasi.',
        facebook_error_title: "Facebook-kirjautuminen ei ole t\xE4ll\xE4 hetkell\xE4 k\xE4ytett\xE4viss\xE4",
        forgot_password_description: "Kirjoita s\xE4hk\xF6postiosoitteesi ja me ' l\xE4het\xE4mme sinulle ohjeet salasanasi palauttamiseen.",
        forgot_password_done_button: "Takaisin kirjautumiseen",
        forgot_password_done_description: "Sinulle on l\xE4hetetty s\xE4hk\xF6posti, jossa on salasanan vaihto-ohjeet.",
        forgot_password_done_help: "Jos et n\xE4e s\xE4hk\xF6postia muutaman minuutin kuluessa, tarkista, onko se roskapostia. Jos se ei viel\xE4k\xE4\xE4n toimi, ota meihin yhteytt\xE4 osoitteessa:",
        forgot_password_done_title: "Melkein valmis",
        forgot_password_link: "Unohditko salasanasi?",
        forgot_password_title: "Unohditko salasanasi?",
        logged_in: "Olet kirjautunut sis\xE4\xE4n",
        login_button: "Kirjaudu sis\xE4\xE4n",
        login_button_apple: "Apple",
        login_button_facebook: "Facebook",
        login_button_google: "Google",
        login_button_in_progress: "Kirjaudutaan sis\xE4\xE4n...",
        login_or_signup: "Kirjaudu sis\xE4\xE4n tai rekister\xF6idy",
        login_title: "Kirjaudu",
        logout_confirmation: "Haluatko varmasti kirjautua ulos?",
        logout_from_all_devices_confirmation: "Haluatko varmasti kirjautua ulos kaikista laitteistasi? Sinun on kirjauduttava uudelleen jokaiseen laitteeseen, jota haluat k\xE4ytt\xE4\xE4.",
        logout_from_all_devices_title: "Kirjautuminen kaikista laitteista",
        logout_title: "Kirjaudu ulos",
        new_member: "Oletko uusi SF Anytime-k\xE4ytt\xE4j\xE4?",
        new_password_placeholder: "Uusi salasana",
        new_password_title: "Uusi salasana",
        now_logged_in_as: "Olet nyt kirjautuneena sis\xE4\xE4n nimell\xE4",
        no_verification_email: "Etk\xF6 saanut s\xE4hk\xF6postia?",
        or_login_with: "Tai jatka",
        password_placeholder: "Salasana",
        password_restriction: "Salasanan on oltava v\xE4hint\xE4\xE4n 8 merkki\xE4.",
        password_updated_for: "Salasana p\xE4ivitetty:",
        remeber_me: "Muista minut",
        remote_login_device_text: "n\xE4pp\xE4ile puhelimen, tabletin tai tietokoneen kanssa ja kirjoita seuraava koodi",
        remote_login_go_to: "Siirry osoitteeseen",
        send_verification_email_again: "L\xE4het\xE4 uudelleen",
        signedup_button: "Aloittaa",
        signedup_title: "Kiitos, ett\xE4 tulit mukaan.",
        signup_button: "Luo tili",
        signup_slogan: "Suoratoista viimeisimm\xE4t elokuvat!\nJ\xE4seneksi liittyminen on ilmaista.",
        signup_title: "Ryhdy j\xE4seneksi",
        signup_usp_array: [
          " Katso miss\xE4 tahansa haluat ",
          " P\xE4\xE4sy uusimpiin elokuviin ",
          " Tallenna luettelot ja saat henkil\xF6kohtaisia vinkkej\xE4 "
        ],
        tos_confirm: "SF Anytime-yhti\xF6n k\xE4ytt\xF6ehdoista",
        tos_confirmation: "Hyv\xE4ksy k\xE4ytt\xF6ehdot jatkaaksesi",
        tos_consent: "Vahvistan, ett\xE4 olen 18-vuotias ja olen samaa mielt\xE4",
        tos_url: "https://www.sfanytime.com/fi/page/kayttoehdot",
        verify_email_description: "Olemme l\xE4hett\xE4neet sinulle vahvistuss\xE4hk\xF6postin. Vahvista tilisi napsauttamalla linkki\xE4 s\xE4hk\xF6postissa, joka on l\xE4hetetty osoitteeseen:",
        verify_email_social_login_description: "Olemme l\xE4hett\xE4neet sinulle vahvistuss\xE4hk\xF6postin. Vahvista k\xE4ytt\xE4j\xE4tilisi klikkaamalla Facebook-k\xE4ytt\xE4j\xE4tiliisi l\xE4hetetyss\xE4 s\xE4hk\xF6postissa olevaa linkki\xE4:",
        "\u200Blogin_with_social_media": "tai kirjaudu sis\xE4\xE4n",
        "\u200Bregister_with_social_media": "tai luo tili"
      },
      checkout: {
        audio: { title: "Audio" },
        buy_tickets_button_title: "Osta lippuja",
        campaign_title: "Kampanja",
        choose_language: "Sinun on valittava kieli",
        confirm_button: { title: "Viimeistele osto" },
        continue_to_payment: { title: "Jatka maksua" },
        done: "Maksettu ja tehty!",
        download_our_app_ups: "Voit k\xE4ytt\xE4\xE4 sovellustamme my\xF6s mobiililaitteella, tabletilla tai \xE4lytelevisiolla. Tuemme my\xF6s Chromecastia.",
        entitlement_type: {
          buy: "Osta",
          buy_description: "Ostoelokuva, katso milloin haluat ja niin monta kertaa kuin haluat.",
          rent: "Vuokraa",
          rent_description: "Katso 48 tunnin aikana.",
          title: "Vuokraa tai osta"
        },
        episode: "episodi",
        episode_count: "{{count}} jaksoa",
        episode_count_title: "jaksot",
        est: "Osta",
        est_bundle_duration: "Katso aina kun haluat, niin monta kertaa kuin haluat.",
        est_episode_duration: "Katso aina kun haluat, niin monta kertaa kuin haluat.",
        est_movie_duration: "Ostoelokuva, katso milloin haluat ja niin monta kertaa kuin haluat.",
        est_season_duration: "Katso aina kun haluat, niin monta kertaa kuin haluat.",
        hide_price_details: "Piilota tiedot",
        language: {
          local: "Paikallinen kieli",
          original: "Alkuper\xE4inen kieli",
          title: "Kieli",
          title_short: "Kieli"
        },
        leave_warning: "Haluatko l\xE4hte\xE4 kassalta? Poistuminen aktiivisen maksun aikana voi aiheuttaa tilauksen menett\xE4misen.",
        pay: "Maksa",
        payment: {
          add_saved_card_tip: "Seuraavan kerran maksa suoraan televisioon tallentamalla maksukortti tilillesi osoitteessa SF Anytime",
          adyen_applepay: "Apple Pay",
          adyen_applepay_description: "Apple Payn avulla voit tehd\xE4 turvallisia ostoksia Apple Cashilla, Apple Cardilla ja muilla Walletiin lis\xE4\xE4mill\xE4si luotto- ja pankkikorteilla.",
          adyen_creditcard: "Creditcard",
          adyen_creditcard_description: "Suojattu maksu Visa, Mastercard ja American Express -kortilla.",
          adyen_klarna: "Maksa my\xF6hemmin",
          adyen_klarnaaccount: "Maksa ajan my\xF6t\xE4",
          adyen_klarnaaccount_description: "Maksa ajan my\xF6t\xE4",
          adyen_klarnapaynow: "Maksa nyt",
          adyen_klarnapaynow_description: "Maksa nyt",
          adyen_klarna_description: "Maksa Klarnalla.",
          adyen_mobilepay: "MobilePay",
          adyen_mobilepay_description: "Anna sen matkapuhelimen puhelinnumero, jolla maksat. Sinulla on oltava MobilePay-sovellus asennettuna.",
          adyen_savedcreditcard: "Tallennettu luottokortti",
          adyen_savedcreditcard_description: "Maksa {{name}} {{number}}.",
          adyen_swish: "Swish",
          adyen_swish_description: "Maksa matkapuhelimellasi Swish-sovelluksen avulla.",
          adyen_vipps: "Vipps",
          adyen_vipps_description: "Maksa helposti ja k\xE4tev\xE4sti Vippsill\xE4.",
          amex: "Korttimaksu",
          amex_description: "Maksa turvallisesti Visalla tai MasterCardilla Dibs-maksuratkaisun kautta.",
          apple_inapp: "App Store",
          apple_inapp_description: "Maksa tallennetulla maksutavalla, jota k\xE4yt\xE4t App Storessa, iTunes Storessa, iCloudissa ja paljon muuta.",
          card: "Korttimaksu",
          card_description: "Maksa turvallisesti Visalla tai MasterCardilla Dibs-maksuratkaisun kautta.",
          freeproduct: "Ilmainen",
          google_inapp: "Google Play",
          google_inapp_description: "Maksa tallennetulla maksutavalla, jota k\xE4yt\xE4t Google Playssa.",
          group_klarna: {
            description: "Joustavat maksut Klarnalla",
            title: "Klarna"
          },
          klarna: "Klarna",
          klarna_description: "Maksa Klarnan kautta kortilla tai pankkitilill\xE4",
          more_payment_options: "Lis\xE4\xE4 maksutapoja",
          more_payment_options_description: "Valitse toinen maksutapa tai jos sinulla on arvokoodi.",
          not_available_in_app_description: "Maksutapa ei ole ostettavissa t\xE4ss\xE4 sovelluksessa.",
          other: "Toinen maksutapa",
          prepaid: "Kotielokuvalippu",
          saved_card: "Tallennettu maksukortti",
          save_payment_info: "Tallenna maksutiedot",
          sf_freeproduct: "Ilmainen",
          sf_loyaltypoints: "Lojaalisuuspisteet",
          sf_loyaltypoints_description: "SF-kanta-asiakaspisteet",
          sf_ticket: "{{cost}} lippua",
          sf_ticket_buy_more_one: "Osta {{count}} ticket",
          sf_ticket_buy_more_other: "Osta {{count}} tickets",
          sf_ticket_description_one: "Maksa {{cost}} lipuillasi.\nSinulla on {{count}} lippu yhteens\xE4.",
          sf_ticket_description_other: "Maksa {{cost}} lipuillasi.\nSinulla on yhteens\xE4 {{count}} lippua.",
          sf_ticket_description_zero: "Maksa {{cost}} lipuilla.\nSinulla ei ole lippuja t\xE4ll\xE4 hetkell\xE4.",
          sf_ticket_description_disabled_one: "Tarvitset {{count}} lis\xE4\xE4 lippua.",
          sf_ticket_description_disabled_other: "Tarvitset {{count}} lis\xE4\xE4 lippuja.",
          sf_voucher: "Kuponki",
          swish: "havina",
          swish_description: "Maksa matkapuhelimellasi Swish-sovelluksen avulla.",
          swish_disabled: "Swish is inactivated due to technical reasons.",
          to_payment: "Siirry maksulle",
          to_payment_button: "Siirry maksulle",
          tv_adyen_pay_with_saved_card: "Maksa tallennetulla kortilla",
          use_a_voucher: "K\xE4yt\xE4 arvokoodia",
          valuecode: "Kuponki"
        },
        payment_method: { title: "Maksutapa" },
        payment_method_group_placeholder: "Maksuvaihtoehtoja",
        purchase_not_allowed_in_app: {
          link: "Lue lis\xE4\xE4 elokuvien vuokraamisesta",
          text: "Valitettavasti et voi tehd\xE4 ostoksia sovelluksessa."
        },
        receipt: {
          app_description: "Sovelluksen avulla voit katsella elokuvasi televisiostasi Chromecastilla tai ladata sen katseltavaksi offline-tilaan.",
          datetime: "P\xE4iv\xE4m\xE4\xE4r\xE4",
          discount: "Alennus",
          fee: "Palvelumaksu sovelluksen kautta tehdyst\xE4 ostosta",
          legal_info: "Kun aloitat elokuvan, pakettiin kuuluvan elokuvan, sarjan kauden, sarjan jakson suoratoiston tai k\xE4yt\xE4t lippua, hyv\xE4ksyt, ett\xE4 SF Anytime aloittaa toimituksen t\xE4ytt\xE4misen, ja hyv\xE4ksyt, ett\xE4 et voi pidemp\xE4\xE4n kumoa ostoksesi.",
          open_in_app: "Avaa sovelluksessa",
          order_no: "Tilausnumero",
          payment_method: "Maksutapa",
          receipt_title: "Kuitti",
          save: "Tallenna kuitti (pdf)",
          smarttv_description: "Voit my\xF6s k\xE4ytt\xE4\xE4 jotakin Smart TV -sovelluksistamme Samsungissa, LG:ss\xE4, AppleTV:ss\xE4 ja Android TV:ss\xE4.",
          sum: "Yhteens\xE4",
          thanks: "Kiitos, ett\xE4 valitsit katsoa elokuvia palvelumme kautta!",
          ticket_valid_to: "Liput voimassa asti",
          valid_to: "Voimassa",
          vat: "Josta alvia",
          vat_nr_label: "Alv-numero",
          vat_nr_value: "SE5568748261601",
          voucher_legal_info: "Elokuvakoodit ovat voimassa 6 kuukautta.",
          you_have_bought: "Olet ostanut",
          you_have_rented: "Olet kuullut"
        },
        rental_duration: "Vuokra-aika",
        select_placeholder: "Valitse",
        show_price_details: "N\xE4yt\xE4 tiedot",
        subtitles: { no_subtitles: "Ei tekstityksi\xE4", title: "Tekstitykset" },
        ticket_prompt: {
          description: "Osta liput suoraan sovelluksestamme tai verkkosivuiltamme.\nK\xE4yt\xE4 sitten lippujamme vaihtaaksesi elokuvaan tai sarjaan.",
          not_enough_tickets: {
            title: "Tarvitset lis\xE4\xE4 lippuja jatkaaksesi t\xE4ll\xE4 maksutavalla"
          },
          tickets_are_required: {
            title: "Tarvitset lippuja tehd\xE4ksesi ostoksen t\xE4ss\xE4 sovelluksessa"
          }
        },
        ticket_type: {
          description_one: "Voimassa 3 vuotta ostop\xE4iv\xE4st\xE4 ja sit\xE4 voidaan k\xE4ytt\xE4\xE4 kaikissa sovelluksissamme.",
          description_other: "Voimassa 3 vuotta ostop\xE4iv\xE4st\xE4 ja sit\xE4 voidaan k\xE4ytt\xE4\xE4 kaikissa sovelluksissamme.",
          description_valid_to: "Lippu on voimassa 3 vuotta ostop\xE4iv\xE4st\xE4",
          title_one: "1 ticket",
          title_other: "{{count}} tickets"
        },
        total_cost: "Kokonaissumma sis. alv",
        tvod: "Vuokraa",
        tvod_episode_duration: "Katso 48 tunnin aikana.",
        tvod_movie_duration: "Katso 48 tunnin aikana.",
        tvod_season_duration: "Katso selke\xE4sti 30 p\xE4iv\xE4\xE4.",
        update: {
          text: "Olemme julkaisseet parannetun version sovelluksestamme, ja sinun on p\xE4ivitett\xE4v\xE4 sovelluksesi, jotta voit jatkaa.",
          title: "Sovelluksen p\xE4ivitt\xE4minen"
        },
        value_code_applied_value: "{{percent}}% alennus",
        value_code_apply: "K\xE4yt\xE4",
        value_code_invalid: "Arvokoodi ei kelpaa t\xE4h\xE4n otsikkoon tai sit\xE4 ei ole",
        value_code_placeholder: "Anna koodi",
        value_code_prompt: "Onko sinulla kuponkia? Sy\xF6t\xE4 se t\xE4h\xE4n",
        value_code_title: "Kuponki",
        value_code_used: "Alennuskoodi jo k\xE4ytetty.",
        voucher: {
          campaign: {
            "5_for_4": {
              description: "1 vuokraelokuvakoodi V\xE4hemm\xE4n maksettavaa.",
              label: "Osta 5 maksaa 4"
            }
          },
          campaign_title: "Tarjous on tehty",
          delivery_type: {
            my_email: "S\xE4hk\xF6postiini",
            recipient_email: "Vastaanottajalle s\xE4hk\xF6postin avulla",
            recipient_sms: "Vastaanottajalle tekstiviestill\xE4",
            title: "Toimitustapa"
          },
          entitlement_type: {
            buy_description: "Ostoelokuva, katso milloin haluat ja niin monta kertaa kuin haluat.",
            buy_text_price: "Osta {{price}}",
            rent_text_description: "Katso 48 tunnin aikana.",
            rent_text_price: "Vuokra {{price}}"
          },
          title: "Osta elokuvakoodeja"
        },
        voucher_has_issue: "Korjaa tai poista kuponkikoodi",
        voucher_not_valid: "Tositekoodi ei kelpaa valintojesi kanssa",
        webview_timeout: "T\xE4m\xE4 kest\xE4\xE4 tavallista kauemmin...",
        you_have_bought: "Ostit",
        you_have_rented: "Vuokrasit",
        you_selected_to_buy: "Olet ostamassa",
        you_selected_to_rent: "Olet vuokraamassa"
      },
      emails: {
        content_notification: {
          reason_for_email_one: "Saat t\xE4m\xE4n s\xE4hk\xF6postiviestin, koska olet ottanut ilmoitukset k\xE4ytt\xF6\xF6n t\xE4ss\xE4 nimikkeess\xE4.",
          reason_for_email_other: "Saat t\xE4m\xE4n s\xE4hk\xF6postiviestin, koska olet ottanut ilmoitukset k\xE4ytt\xF6\xF6n t\xE4ss\xE4 nimikkeess\xE4.",
          subject_one: "Katsottu otsikko on nyt k\xE4ytett\xE4viss\xE4",
          subject_other: "Katsotut nimikkeet ovat nyt saatavilla"
        },
        footer: {
          cant_reply: "T\xE4h\xE4n s\xE4hk\xF6postiin ei voi vastata. Jos sinulla on kysytt\xE4v\xE4\xE4,",
          copyright: "\xA9 2024 SF Anytime AB (organisaatio nro.  556748-2616, VAT SE556748261601)",
          please_contact_us_link: "ota yhteytt\xE4 t\xE4\xE4ll\xE4",
          regards: "Med v\xE4nliga h\xE4lsningar,",
          unsubscribe: "Lopettaa",
          web_link: "Web-versio"
        },
        gdpr_clean_up: {
          clarification: "*Koskee vain tili\xE4, joka on rekister\xF6ity s\xE4hk\xF6postiosoitteeseen, johon sait t\xE4m\xE4n s\xE4hk\xF6postin. Jos olet rekister\xF6inyt useita tilej\xE4 eri s\xE4hk\xF6postiosoitteilla, niit\xE4 k\xE4sitell\xE4\xE4n erikseen.",
          cta: "Vuokraa elokuva",
          delete_account_text_one: "Jos haluat, ett\xE4 tilisi poistetaan, sinun ei tarvitse tehd\xE4 mit\xE4\xE4n, tili poistetaan automaattisesti 1 p\xE4iv\xE4n kuluessa. Voit aina luoda uuden ilmaisen tilin samoilla tiedoilla, jos haluat saada tilin meille uudelleen tulevaisuudessa.",
          delete_account_text_other: "Jos haluat, ett\xE4 tilisi poistetaan, sinun ei tarvitse tehd\xE4 mit\xE4\xE4n, tili poistetaan automaattisesti {{number}} p\xE4iv\xE4n kuluessa. Voit aina luoda uuden ilmaisen tilin samoilla tiedoilla, jos haluat saada tilin meille uudelleen tulevaisuudessa.",
          intro_one: "On kulunut jonkin aikaa siit\xE4, kun viimeksi vierailit meill\xE4, ja GDPR:n vuoksi meid\xE4n on poistettava tilisi* 1 p\xE4iv\xE4n kuluessa.",
          intro_other: "On kulunut jonkin aikaa siit\xE4, kun viimeksi vierailit meill\xE4, ja GDPR:n vuoksi meid\xE4n on poistettava tilisi* {{number}} p\xE4iv\xE4n kuluessa.",
          reason_for_email: "Saat t\xE4m\xE4n s\xE4hk\xF6postin, koska sinulla on tili palvelussamme.",
          save_account_text: "Haluatko s\xE4ilytt\xE4\xE4 tilisi?\xA0Vuokraa elokuva {{discount}}% alennuksella alla olevalla arvokoodilla!",
          subtitle_one: "1 p\xE4iv\xE4n kuluttua ilmainen tilisi poistetaan",
          subtitle_other: "Ilmainen tilisi poistetaan {{number}} p\xE4iv\xE4n kuluttua",
          title: "Muistutus SF Anytime -tilist\xE4si",
          voucher_info: "Kuponkikoodi on henkil\xF6kohtainen ja voimassa vain t\xE4ll\xE4 tilill\xE4, sen voi k\xE4ytt\xE4\xE4 vain kerran ja alennus koskee enint\xE4\xE4n 6 euroa vuokraelokuvaa. Ei koske teatteri- tai ostoelokuvia, eik\xE4 sit\xE4 voi yhdist\xE4\xE4 muihin tarjouksiin.",
          voucher_limitations: "Koskee enint\xE4\xE4n 6 euron vuokraelokuvaa.",
          voucher_offer: "{{discount}}% alennus vuokraelokuvista"
        },
        header: {
          hello: "Hei",
          hello_we_miss_you: "Hei, kaipaamme sinua!",
          looking_weird: "N\xE4ytt\xE4\xE4k\xF6 s\xE4hk\xF6posti oudolta?",
          open_in_browser: "Avaa selaimessa"
        },
        new_user: {
          intro: "On hienoa, ett\xE4 olet liittynyt j\xE4seneksi kanssamme. Meill\xE4 on Pohjoismaiden laajimmat elokuvahyllyt, jotka ovat t\xE4ynn\xE4 kaikkea palkituista mestariteoksista upeaan viihteeseen. Uskomme, ett\xE4 jokaiseen tilanteeseen on olemassa elokuva ja jokaiselle elokuvalle mahdollisuus.",
          intro2: "Hengit\xE4 syv\xE4\xE4n ja uskaltaudu kokoelmaan.",
          title: "Tervetuloa SF Anytimeen"
        },
        order_receipt: {
          find_your_playable_content: "L\xF6yd\xE4t kuitit kaikista ostoksistasi Omat ostot -sivulta ja ostamasi sis\xE4ll\xF6n Oma sis\xE4lt\xF6 -sivulta.",
          go_to_playable_content: "Toista",
          greeting_bundle: "Me SF Anytimella toivotamme sinulle mukavaa elokuva-aikaa!",
          greeting_episode: "SF Anytimella toivotamme sinulle mukavaa sarjahetke\xE4!",
          greeting_movie: "Me SF Anytimella toivotamme sinulle mukavaa elokuva-aikaa!",
          greeting_season: "SF Anytimella toivotamme sinulle mukavaa sarjahetke\xE4!",
          greeting_ticketpack: "Me SF Anytimella toivomme, ett\xE4 lippusi tulevat hyv\xE4\xE4n k\xE4ytt\xF6\xF6n!",
          greeting_voucher: "T\xE4\xE4ll\xE4 SF Anytimessa toivomme, ett\xE4 elokuvakoodejasi hy\xF6dynnet\xE4\xE4n!",
          more_about_vouchers: "Lue lis\xE4\xE4 elokuvakupongeista",
          product_type_bundle_est_description: "Voit katsella elokuvia niin monta kertaa kuin haluat.",
          product_type_episode_est_description: "Voit katsoa jakson niin monta kertaa kuin haluat.",
          product_type_episode_tvod_description: "Katso 48 tunnin aikana.",
          product_type_movie_est_description: "Voit katsoa elokuvan niin monta kertaa kuin haluat.",
          product_type_movie_tvod_description: "Katso 48 tunnin aikana.",
          product_type_season_est_description: "Voit katsoa sarjakauden niin monta kertaa kuin haluat.",
          product_type_season_tvod_description: "Katso selke\xE4sti 30 p\xE4iv\xE4\xE4.",
          product_type_ticketpack_est_description: "Liput ovat voimassa kolme vuotta ostop\xE4iv\xE4st\xE4 ja ne ovat saatavilla tilill\xE4si. Niit\xE4 voidaan k\xE4ytt\xE4\xE4 maksuna, kun ostat sis\xE4lt\xF6\xE4 mist\xE4 tahansa sovelluksestamme.",
          product_type_voucher__description: "Liitteen\xE4 l\xF6yd\xE4t koodisi. Tallenna koodit tietokoneellesi tai tulosta ne ja anna ne lahjaksi.",
          reason_for_email: "T\xE4m\xE4 on vahvistus ostetusta sis\xE4ll\xF6st\xE4 tilill\xE4, joka k\xE4ytt\xE4\xE4 t\xE4t\xE4 s\xE4hk\xF6postiosoitetta.",
          subject: "Kuitti SF Anytime",
          thanks_bundle: "Kiitos, ett\xE4 p\xE4\xE4tit ostaa elokuvapaketin kanssamme!",
          thanks_episode: "Kiitos, ett\xE4 p\xE4\xE4tit ostaa sarjajakson kanssamme!",
          thanks_movie: "Kiitos, ett\xE4 p\xE4\xE4tit ostaa elokuvan kanssamme!",
          thanks_season: "Kiitos, ett\xE4 p\xE4\xE4tit ostaa sarjakauden kanssamme!",
          thanks_ticketpack: "Kiitos, ett\xE4 p\xE4\xE4tit ostaa liput meilt\xE4!",
          thanks_voucher: "Kiitos, ett\xE4 valitsit ostaa elokuvakoodit meilt\xE4!",
          title: "Kuitti"
        },
        reset_password: {
          intro: "T\xE4m\xE4 on tilin salasanan vaihtopyynt\xF6:",
          not_requested: "Jos et pyyt\xE4nyt s\xE4hk\xF6postiviesti\xE4 salasanan vaihtamiseksi, vaihda silti salasanasi Oma tili -sivun Asetukset tilisi suojaamiseksi -kohdassa.",
          reset_password: "Vaihda salasana",
          reset_password_link_text: "Napsauta alla olevaa painiketta valitaksesi uuden salasanan. Linkki on voimassa 30 minuuttia.",
          subject: "Salasanan nollaus",
          title: "Salasanan nollaus"
        },
        voucher: {
          code_label: "Koodi:",
          valid_to: "Voimassa:",
          your_personal_code: "Henkil\xF6kohtainen koodisi"
        }
      },
      genre: {
        "3d": "3D",
        action: "Toiminta",
        adult: "Aikuinen",
        adventure: "Seikkailu",
        animated: "Animaatio",
        anime: "Anime",
        children: "Lapset",
        "children-family": "Lapset ja Perhe",
        "children-family (Copy)": "Lapset ja Perhe",
        comedy: "Komedia",
        crime: "Rikos",
        cult: "Kultti",
        danish: "Tanskan",
        documentary: "Dokumentti",
        drama: "Draama",
        finnish: "Suomi",
        horror: "Kauhu",
        "movie-gems": "Elokuvahelmi\xE4",
        music: "Musiikki",
        norwegian: "Norjan",
        romance: "Romantiikka",
        "sci-fi": "Sci-fi",
        "sf-kids": "SF Kids",
        swedish: "Ruotsi",
        thriller: "J\xE4nnitys",
        "tv-series": "TV-sarja",
        war: "Sotaelokuvat",
        western: "L\xE4nnenelokuva"
      },
      glossary: {
        abort: "Keskeytt\xE4\xE4",
        activate: "Aktivoida",
        add_to_my_list: "Lis\xE4\xE4 omaan luetteloon",
        amount: "M\xE4\xE4r\xE4",
        app_version: "Sovelluksen versio",
        available: "Katseltavissa",
        back_navigation: "Takaisin",
        bought: "Ostanut",
        bought_badge: "OMISTETTU",
        brand: "SF Anytime",
        build_number: "Koontiversion numero",
        bundle: "Elokuvapaketti",
        buy: "Osta",
        buy_first_episode_from: "Ensimm\xE4inen osa",
        buy_from: "Alkaen",
        campaign: "Kampanja",
        cancel: "Peruuta",
        close_modal: "Sulkea",
        coming_soon: "Tulossa pian",
        continue: "Jatka",
        customer_service: "Support",
        download_from_AppStore: "Lataa App Storesta",
        download_from_GooglePlay: "Lataa se Google Playsta",
        error: "Virhe",
        fullscreen: "Koko n\xE4ytt\xF6",
        hide_banner: "Piilottaa",
        last_chance: "Viimeinen mahdollisuus",
        loading: "Lastaus...",
        mark_as_not_watched: "Merkitse katsomatta",
        mark_as_watched: "Merkitse katsotuksi",
        minutes: "minuuttia",
        movie: "Elokuva",
        mute: "Mykist\xE4\xE4",
        next_episode: "Seuraava jakso",
        no: "Ei",
        not_available: "Ei saatavilla",
        off: "Pois p\xE4\xE4lt\xE4",
        on: "Kartalla",
        open: "Avaa",
        open_in_browser_button: "Avaa selaimessa",
        password: "Salasana",
        pause_button: "Keskeyt\xE4",
        play_button: "Toista",
        read_more: "Lue lis\xE4\xE4",
        release: "Tulossa",
        release_date: "Julkaisup\xE4iv\xE4",
        remote_control: "kaukos\xE4\xE4dint\xE4",
        remove_from_my_list: "Poista omalta listalta",
        rented: "VUOKRATTU",
        rented_badge: "VUOKRATTU",
        saved: "Tallennettu",
        search_results: "Tulokset",
        select: "Valitse",
        series: "Sarja",
        sf_anytime: "SF Anytime",
        show: "N\xE4yt\xE4",
        show_all: "N\xE4yt\xE4 kaikki",
        show_all_x: "N\xE4yt\xE4 kaikki {{count}}",
        support_forum: "support.sfanytime.com",
        support_mail: "support@sfanytime.com",
        this_device: "T\xE4m\xE4 laite",
        tickets: "Liput",
        trailer: "Traileri",
        unknown: "Tuntematon",
        username: "K\xE4ytt\xE4j\xE4tunnus",
        warning: "Varoitus",
        x_results: {
          plural: "{{number}} tulokset",
          singular: "{{number}} tulos"
        },
        yes: "Kyll\xE4",
        "\u200Brented_for": "Vuokrattu",
        "\u200Brented_to": "Vuokrattu"
      },
      media: {
        age_rating: "Luokitus",
        audio: "Audio",
        bundle: {
          discount_text: "S\xE4\xE4st\xE4 {{percentage}}% ",
          movie_count: "{{count}} elokuvat"
        },
        continue_watching: {
          empty: "Elokuvat ja sarjat, joita et ole viel\xE4 katsonut, n\xE4kyv\xE4t t\xE4ss\xE4",
          title: "Jatka katselua"
        },
        crew: {
          actor: "Rooleissa",
          director: "Ohjaaja",
          title: "Ohjaaja & N\xE4yttelij\xE4t"
        },
        download: {
          action_will_remove_active_download: "T\xE4m\xE4 toiminto poistaa aktiivisen latauksen.",
          cancel_download: "Katkaise lataus",
          delete_download: "Poista lataus",
          deleting: "Poistaminen",
          deleting_download_description: "Poistetaan latausta... T\xE4ss\xE4 voi kest\xE4\xE4.",
          downloaded: "Ladattua",
          downloading: "Lataaminen",
          download_completed: "Lataus valmis",
          download_error: "Latausvirhe",
          list_title: "Ladattu t\xE4lle laitteelle",
          logout_warning: "Latauksesi poistetaan uloskirjaumisen yhteydess\xE4.",
          no_entitled_downloads: "T\xE4ll\xE4 laitteella on latauksia, mutta ei tiliisi kuuluvia. Voit silti poistaa ne.",
          no_space_left_error: "Laitteessa ei ole tilaa.",
          paused: "Lataus pys\xE4htyi",
          pause_download: "Haluatko keskeytt\xE4\xE4 latauksen?",
          pause_download_error: "Latauksen keskeytt\xE4minen ep\xE4onnistui, yrit\xE4 uudelleen.",
          pick_quality: "Valitse ladattava laatu",
          pick_quality_high: "Korkea",
          pick_quality_low: "Matala",
          pick_quality_max: "Max",
          pick_quality_medium: "Medium",
          quality: "Laatu",
          queued: "Jonossa oleva",
          removing: "Poistan",
          removing_download: "Poistetaan latausta",
          resume_download: "Jatka lataamista",
          resume_download_error: "Latauksen jatkaminen ep\xE4onnistui, yrit\xE4 uudelleen.",
          start_download: "Ladata",
          start_download_error: "Latauksen k\xE4ynnist\xE4minen ep\xE4onnistui, yrit\xE4 uudelleen.",
          try_to_download_again: "Yrit\xE4 ladata sis\xE4lt\xF6 uudelleen."
        },
        entitlement_type: "Ostotyyppi",
        episode_rental_left: "Vuokra p\xE4\xE4ttyy: {{rent_time_left}}",
        extra_material: { title: "Lis\xE4materiaalia" },
        from_countries: "Tuotettu",
        has_access: "Access",
        keep_watching: "Jatka katselua",
        length: "Pituus",
        meta_description_movie: "Vuokraa ja osta elokuva {{ title }} n\xE4yttelij\xF6iden {{ actor1 }} ja {{ actor2 }} kanssa. Suoratoista t\xE4m\xE4 {{ genre }}-elokuva ja muita elokuvia verkossa {{ brand }} -palvelussa.",
        meta_description_series: "Vuokraa ja osta sarja {{ title }} n\xE4yttelij\xF6iden {{ actor1 }} ja {{ actor2 }} kanssa. Suoratoista t\xE4m\xE4 {{ genre }}-sarja ja muita sarjoja verkossa {{ brand }} -palvelussa.",
        meta_title: "{{title}} Vuokraa ja suoratoista - SF Anytime",
        more_info_title: "Lis\xE4tietoja",
        movie_bought_info: "Ostettu - Katso kun haluat, niin monta kertaa kuin haluat",
        movie_rental_left: "Vuokra p\xE4\xE4ttyy: {{rent_time_left}}",
        movie_rented_and_expires_at: "Vuokrattu - vuokra p\xE4\xE4ttyy {{rent_end_time}}",
        my_list: "Minun listani",
        my_list_add_button: "Minun listani",
        notify: "Ilmoittaa",
        notifyme_button: "Ilmoita minulle",
        notifyme_button_active: "Seurannut",
        only_on: "Vain p\xE4\xE4ll\xE4",
        production_country: "Tuotettu",
        purchase: { unavailable_button: "Ei voi vuokrata" },
        release_date: "Tulossa: {{dateString}}",
        series: {
          average_episode_length: "~{{length}}/jakso",
          buy_this_season: "Osta t\xE4ll\xE4 kaudella",
          episodes: "jaksot",
          episode_count: "{{count}} jaksoa",
          next_episode: "Seuraava jakso",
          not_available: "T\xE4m\xE4 sis\xE4lt\xF6 ei ole t\xE4ll\xE4 hetkell\xE4 k\xE4ytett\xE4viss\xE4",
          season: "Kausi",
          seasons: "Kautta",
          season_release: "Tulossa: {{dateString}}"
        },
        share_button: "Jaa",
        show_more: "N\xE4yt\xE4 lis\xE4\xE4",
        similar_movies: "Samanlaisia",
        similar_series: "Samanlaisia",
        similar_tickets: "Muut liput",
        similar_titles: "Samankaltaiset nimikkeet",
        subtitles: "Tekstitykset",
        trailer_button: "Traileri",
        upcoming: "Tulevan",
        watched: { title: "Katsottu elokuvia" }
      },
      mymedia: {
        entitlements_empty_list: [
          "T\xE4\xE4lt\xE4 l\xF6yd\xE4t vuokraamiasi tai elokuvia ja esityksi\xE4",
          "Katso televisiosta Chromecastilla tai Airplaylla",
          "Lataa ja katso, kun offline-tilassa - t\xE4ydellinen matkoilla"
        ],
        entitlements_title: "Omia elokuvia ja sarjoja",
        favorites_title: "Minun listani",
        my_content_title: "Oma sis\xE4lt\xF6",
        my_list_empty_array: [
          "Et ole viel\xE4 tallentanut elokuvia tai ohjelmia luettelooni",
          "Katso televisiossasi Chromecastilla tai Airplaylla",
          "Lataa ja katso, kun offline-tilassa - t\xE4ydellinen matkoilla"
        ],
        my_list_title: "Minun listani",
        saved_searches_title: "Omat havainnot"
      },
      offer_redeemed: "N\xE4ytt\xE4\xE4 silt\xE4, ett\xE4 t\xE4m\xE4 on jo lunastettu.",
      push: {
        discountedtitle: {
          text: "Otsikko, jonka saatat pit\xE4\xE4, on nyt alennettu.",
          title: '"{{localtitle}}" on nyt alennettu'
        },
        multipletitlesmatchingsavedsearch: {
          text: '"{{localtitles}}" on nyt k\xE4ytett\xE4viss\xE4.',
          title: "Katsotut nimikkeet ovat nyt saatavilla"
        },
        newtitle: {
          text: "Otsikko, jonka saatat pit\xE4\xE4, on nyt k\xE4ytett\xE4viss\xE4.",
          title: '"{{localtitle}}" on nyt saatavilla'
        },
        singletitlematchingsavedsearch: {
          text: "Katsottu otsikko on nyt k\xE4ytett\xE4viss\xE4.",
          title: '"{{localtitle}}" on nyt k\xE4ytett\xE4viss\xE4.'
        },
        title_matching_saved_search: {
          "text _one": "Katsottu otsikko on nyt k\xE4ytett\xE4viss\xE4.",
          "text _other": "Katsotut nimikkeet ovat nyt saatavilla"
        }
      },
      search: {
        active_filters: "Aktiiviset suodattimet",
        agelimit_years: "{{age}} vuotta",
        did_you_mean: "Tarkoititko?",
        empty_results: "N\xE4ytt\xE4\xE4 silt\xE4, ett\xE4 hakusi ei palauttanut tuloksia.",
        empty_results_message: "Yrit\xE4 tyhjent\xE4\xE4 haku, muuttaa suodattimia tai valita jotain alla olevista suosituista hakutuloksistamme.",
        facet: {
          actors: "Rooleissa",
          ageLimit: "Ik\xE4raja",
          directors: "Ohjaajat",
          duration: "Pituus",
          genres: "Tyylilajit",
          lowestPrice: "Hinta",
          manifest: {
            audio: { tracks: { language: "Audio" } },
            subtitles: { language: "Tekstitykset" }
          },
          mediaTags: { name: "Median tunnisteet" },
          metaCollections: "Aiheita",
          productType: "Tyyppi",
          ratings: { imdb: "IMDB-luokitus" },
          releaseYear: "Julkaisuvuosi"
        },
        filters_hits: "Osumia",
        filters_reset_button: "Palauta suodattimet",
        filters_title: "Suodattimet",
        from: "T\xE4st\xE4",
        history: "Viimeaikaiset haut",
        input_placeholder: "S\xF6k",
        input_press_ok: "Avaa n\xE4pp\xE4imist\xF6 painamalla OK-n\xE4pp\xE4int\xE4",
        "list-view": "Kohteen n\xE4kym\xE4",
        "list-view-as-grid": "Hila",
        "list-view-as-list": "Luettelo",
        "load-more-button": "Lataa lis\xE4\xE4",
        not: "Ei {{ filter }}",
        number_of_seasons: {
          plural: "{{seasonCount}} kautta",
          singular: "{{seasonCount}} kausi"
        },
        placeholder: "Etsi...",
        popular_search_terms: "Suositut hakutermit:",
        recent_searches: "Viimeaikaiset haut",
        remove: "Poistaa",
        reset_button: "Palauttaa",
        reset_refinements: "Nollaa",
        reset_search: "Aloita alusta",
        save: "Tallenna",
        saved: "Tallennetut",
        saved_searches: "Tallennettu",
        show_less: "N\xE4yt\xE4 v\xE4hemm\xE4n",
        show_more: "N\xE4yt\xE4 lis\xE4\xE4",
        show_previous: "N\xE4yt\xE4 edellinen",
        suggestions: "Ehdotuksia",
        to: "T\xE4h\xE4n"
      },
      service_availability: {
        checkout: { title: "Toimintah\xE4iri\xF6it\xE4" },
        generic: { title: "Toimintah\xE4iri\xF6it\xE4" }
      },
      settings: {
        abort: "Peruuttaa",
        add_card: "Lis\xE4\xE4 luottokortti",
        add_card_success: "Luottokorttisi on tallennettu!",
        allow_mobile_download: {
          hint_active: "Lataa mobiililaitteella on sallittua",
          hint_inactive: "Sallii lataamisen vain Wi-Fi: n kautta",
          title: "Salli lataukset mobiilidatan avulla"
        },
        app_info_title: "Tietoja sovelluksesta",
        bonus: "Oma bonus",
        buy_tickets_service_fee: { description: "Ei palvelumaksua." },
        change_email: "Vaihda s\xE4hk\xF6posti",
        change_info_web_only_description: "Mene osoitteeseen {{url}} matkapuhelimellasi, tablet-laitteellasi tai tietokoneellasi muokataksesi tietoja.",
        change_info_web_only_description_url: "www.sfanytime.com",
        change_info_web_only_title: "Tilisi muokkaaminen on mahdollista vain verkossa",
        change_password: "Vaihda salasana",
        change_payment_method: "Vaihda maksutapaa",
        change_payment_web_only_title: "Maksutavan muuttaminen on mahdollista vain verkossa",
        cookies_title: "Ev\xE4steet",
        downloads_remove_all_confirm: "Poista kaikki",
        downloads_remove_all_confirm_title: "Poista kaikki lataukset",
        downloads_remove_confirm: "Poista lataus",
        downloads_title: "Lataukset",
        download_delete_all: "Poista kaikki",
        download_delete_all_downloads: "Poista kaikki lataukset",
        download_no_downloads_text: "Et ole ladannut elokuvia t\xE4lle laitteelle.",
        download_receipt: "Lataa kuitti",
        download_total_size: "Yhteens\xE4 {{size}}",
        empty_purchases: {
          message: "T\xE4\xE4ll\xE4 voit tarkastella aiempia ja aktiivisia ostoksiasi. T\xE4ll\xE4 hetkell\xE4 sinulla ei ole rekister\xF6ityj\xE4 ostoksia.",
          title: "Sinulla ei ole rekister\xF6ityj\xE4 ostoksia"
        },
        help: "auta",
        link: { to_device_settings: "Siirry asetuksiin" },
        manage_personal_information: "Hallitse henkil\xF6kohtaisia tietojasi",
        marketing: { title: "P\xE4ivit\xE4 s\xE4hk\xF6postiasetuksesi:" },
        my_account: {
          change_account_details: "Vaihda tilitiedot",
          change_dibs_payment: "Smart TV:n maksutavan muuttaminen",
          change_email_title: "Vaihda s\xE4hk\xF6posti",
          change_payment_title: "Toinen maksutapa",
          change_pw_title: "Vaihda salasana",
          customer_id: "Asiakasnumero:",
          portability_update_button: "P\xE4ivit\xE4 maksutapa",
          username: "K\xE4ytt\xE4j\xE4tunnus:"
        },
        my_account_title: "Omat tiedot",
        my_profile: {
          address: "Osoite",
          change_country: "Vaihda maata",
          choose_country: "Valitse maa",
          city: "Paikkakunta",
          country: "Maa",
          delete_account: "Poista tili",
          delete_account_confirmed: "Tilisi on nyt poistettu.",
          delete_account_description: "Haluatko, ett\xE4 tilisi, historiasi ja kaikki sinua koskevat tiedot poistetaan? Poistettua tili\xE4 ei voi luoda uudelleen, mik\xE4 tarkoittaa, ett\xE4 ostetut elokuvat ja sarjat menetet\xE4\xE4n. Vahvista valinta antamalla salasana seuraavassa vaiheessa.",
          download: "Ladata",
          email: "S\xE4hk\xF6posti",
          export_information: "Pyyd\xE4 tietoja",
          export_information_description: "Haluatko tiet\xE4\xE4 enemm\xE4n mit\xE4 tietoja olemme tallentaneet sinusta? Pyyd\xE4 tietojasi helposti ja turvallisesti t\xE4\xE4lt\xE4.",
          export_information_loading_message: "T\xE4m\xE4 voi kest\xE4\xE4 jonkin aikaa olemassa olevan datan m\xE4\xE4r\xE4st\xE4 riippuen.",
          export_information_loading_title: "Ole hyv\xE4 ja pid\xE4, haemme tietojasi j\xE4rjestelm\xE4st\xE4mme",
          export_information_preview_title: "Tietojen viennin esikatselu",
          first_name: "Etunimi",
          last_name: "Sukunimi",
          myinfo_title: "Rekister\xF6i henkil\xF6kohtaiset tiedot",
          password: "Salasana",
          phone: "mobile",
          short_username: "K\xE4ytt\xE4j\xE4tunnus",
          short_username_description: "Jos k\xE4yt\xE4t jotain SmartTV-sovelluksistamme, voit alla luoda lyhyemm\xE4n vaihtoehtoisen k\xE4ytt\xE4j\xE4nimen, joka helpottaa kirjautumista.",
          zipcode: "Postinumero"
        },
        newsletter_consent: {
          agree: "Kyll\xE4, kiitos",
          disagree: "Ei, kiitos ",
          title: "Haluamme olla yhteydess\xE4 kanssasi"
        },
        notifications: {
          allow_notifications: "Salli ilmoitukset",
          controlled_from_settings_phone: "Ohjataan puhelimen asetuksista",
          description: "Ilmoitusten avulla saat tietoa uusista julkaisuista, suosituksista, kampanjoista tai sovellusominaisuuksista.",
          dont_miss_new_releases: "\xC4l\xE4 missaa uusia julkaisuja",
          enable_notifications: "Ilmoitusten ottaminen k\xE4ytt\xF6\xF6n",
          new_content: "Uutta sis\xE4lt\xF6\xE4 on saatavilla",
          notification_settings_in_phone: "Ilmoituksesi SF:lle milloin tahansa",
          permission_description: "Ilmoitusten avulla saat tietoa tuotejulkaisuista, suosituksista ja kampanjoista.",
          title: "Ilmoitukset",
          to_device_settings: "Siirry asetuksiin"
        },
        notification_title: "Ilmoitukset",
        no_saved_payment_methods: "Sinulla ei ole tallennettuja maksukortteja.\nJos sinulla on aiemmin ollut tallennettu kortti vanhoille TV-sovelluksillemme, sinun on lis\xE4tt\xE4v\xE4 se uudelleen.",
        overview: "Yleiskatsaus",
        payment_card_tempcharge_disclaimer: "Tililt\xE4si varataan \u2026\u20AC rekister\xF6idess\xE4si luottokortin. T\xE4m\xE4 tehd\xE4\xE4n kortin voimassaolon varmistamiseksi. Summaa ei veloiteta, mutta voi n\xE4ky\xE4 varattuna summana muutaman p\xE4iv\xE4n pankista riippuen.",
        payment_method_remove_confirm: "Haluatko varmasti poistaa maksutavan?",
        payment_method_remove_failed: "Maksutapaa ei voitu poistaa",
        payment_method_remove_successful: "Maksutapa on nyt poistettu",
        portability_title: "Katso EU:ssa",
        portability_unverified: "Vahvistamattomia",
        portability_unverified_text: "Voit tarkistaa SF Anytime EU / EES: ssa, jos vahvistat asuinmaasi. P\xE4ivitt\xE4m\xE4ll\xE4 maksutavan saamme n\xE4m\xE4 tiedot ja sitten voit nauttia elokuvista, kun matkustat EU: n sis\xE4ll\xE4.",
        portability_verified: "Vahvistettu",
        portability_verified_disclaimer: "Kun p\xE4ivitit maksutietosi, n\xE4m\xE4 tiedot annettiin meille.",
        portability_verified_text: "Olemme vahvistaneet asuinpaikkasi, joten nyt voit nauttia elokuvista, kun matkustat EU: n sis\xE4ll\xE4.",
        purchases: "Omat ostot",
        recent_purchases: "Viimeaikaiset ostot",
        remove_card: "Poista kortti",
        remove_payment_method: "Poistaa",
        review_question: "Pid\xE4tk\xF6 sovelluksesta?",
        save: "Tallenna",
        saved_card: "Tallennettu maksukortti",
        saved_payment_methods: "Tallennetut maksutavat",
        show_more: "N\xE4yt\xE4 lis\xE4\xE4",
        tickets: {
          bought_tickets: "Ostetut liput",
          buy_tickets: "Osta lippuja",
          disclaimer: "Voit ostaa tai vastaanottaa lippuja, jotka toimivat maksuna, kun ostat sis\xE4lt\xF6\xE4 miss\xE4 tahansa SF Anytimen sovelluksessa. K\xE4yt\xE4 niit\xE4 maksuna mobiilisovelluksissamme iOS: lle ja Androidille. Voimassa olevat liput ovat sitten n\xE4kyviss\xE4, ja niit\xE4 voidaan k\xE4ytt\xE4\xE4 maksuvaihtoehtoina kassalla.\n\nYksi lippu vastaa yht\xE4 sarjan jaksoa ja jopa kaksikymment\xE4 lippua kattaa suurimman osan elokuvavalikoimamme ostoista.",
          total_title: "{{ count }} x Liput",
          valid: "Voimassa"
        },
        tickets_and_vouchers: "Omat liput & kupongit",
        tickets_title: "Omat liput",
        update: {
          confirm: "P\xE4ivitt\xE4\xE4",
          text: "Sovelluksesta on parempi versio!"
        },
        user_offline_goto_downloads: "Siirry Omat lataukset -kohtaan",
        user_offline_navigation: "N\xE4yt\xE4t olevan offline-tilassa, tarkista internetyhteytesi",
        "\u200Bnew_\u200Bemail": "Uusi s\xE4hk\xF6postiosoite"
      },
      store: {
        feature_1_heading: "Suoratoista uusimpia elokuvia",
        feature_1_text: "Uusimmat menestyselokuvat, klassikot ja kaikkea silt\xE4 v\xE4lilt\xE4",
        feature_2_heading: "Vuokraa tai osta",
        feature_2_text: "Jokainen elokuva ja sarja on ladattavissa, katsottavissa miss\xE4 haluat",
        feature_3_heading: "Hauskaa koko perheelle",
        feature_3_text: "Tapaa paljon yst\xE4vi\xE4 Astrid Lindgren",
        take_over: {
          price: "\u20AC 17",
          text: "Oscar\xAE-voittajat George Clooney ja Julia Roberts tapaavat valkokankaalla eronneena parina, joka yll\xE4tt\xE4en p\xE4\xE4tyy yhteiseen teht\xE4v\xE4\xE4n: est\xE4\xE4 rakastunutta tyt\xE4rt\xE4\xE4n tekem\xE4st\xE4 samoja virheit\xE4 kuin ennen. Ticket to Paradise on romanttinen komedia odottamattoman toisen mahdollisuuden saamisesta yht\xE4kki\xE4."
        },
        take_over_child: { price: "\u20AC 14" },
        toplist: {
          buy: "Suosituimmat ostot",
          rent: "Suosituimmat vuokrat",
          series: "Top-sarja"
        },
        usp_1: "Uusimmat elokuvat ilman tilausta",
        usp_2: "Maksa vain siit\xE4, mit\xE4 katsot",
        usp_3: "Suoratoista v\xE4litt\xF6m\xE4sti tai katso offline-tilassa",
        usp_4: "Yksi Pohjoismaiden laajimmista valikoimista"
      },
      tag: {
        collection: "Elokuvapaketti",
        in_collection: "osa elokuvapakettia",
        is_collection: "Elokuvapaketti"
      },
      test: { test: { testing_for_fun: "Testausta huvin vuoksi" } },
      value_prop: {
        call_to_action: "Aloittaa",
        title: "Uusi, vanha, klassinen. Valitse suosikkisi tuhansista nimikkeist\xE4."
      },
      voucher_not_valid_for_producttype_bundle: "T\xE4t\xE4 arvokoodia ei voi k\xE4ytt\xE4\xE4 pakettitarjouksille.",
      voucher_not_valid_for_producttype_episode: "T\xE4t\xE4 arvokoodia ei voi k\xE4ytt\xE4\xE4 jaksoissa.",
      voucher_not_valid_for_producttype_movie: "T\xE4t\xE4 arvokoodia ei voi k\xE4ytt\xE4\xE4 elokuvissa.",
      voucher_not_valid_for_producttype_season: "T\xE4t\xE4 arvokoodia ei voi k\xE4ytt\xE4\xE4 sarjoissa."
    }
  },
  no: {
    __typename: "Localization",
    id: "TG9jYWxpemF0aW9uOlNGQW55dGltZTpubzp3LzFCS3NEamxtZjZVMFdCN1pGaFZkRmZlc009",
    locale: "no",
    items: {
      age_recommendation: { child_friendly: "Barnevennlig" },
      auth: {
        access_code_expired_text: "Koden du har angitt, er ikke lenger gyldig.",
        access_code_expired_title: "Utl\xF8pt kode",
        already_member: "Er du allerede medlem?",
        back_home: "G\xE5 til hjemmesiden",
        complete_login_on_remote: "Fullstendig p\xE5logging p\xE5 {{device}}-enheten",
        continue_on_init_device: "Fortsett p\xE5 {{device}}-tv-en",
        current_password_placeholder: "N\xE5v\xE6rende passord",
        email_changed_to: "E-postadressen endres til:",
        email_placeholder: "E-postadresse",
        enter_new_email_for: "Skriv inn en ny e-postadresse for:",
        enter_new_password: {
          for: "Skriv inn et nytt passord for:",
          info_text: "Du m\xE5 logge p\xE5 igjen i appene og nettleserne der du allerede er logget inn."
        },
        enter_new_password_for_email: "Skriv inn et nytt passord for {{email}} . Du m\xE5 logge inn igjen i appene og nettleserne der du allerede er logget inn f\xF8r.",
        facebook_error_message: 'Hvis du allerede har opprettet en SF Anytime-konto med facebook, kan du pr\xF8ve \xE5 bruke "tilbakestill passord" p\xE5 sfanytime.com. Skriv inn e-postadressen som er koblet til Facebook-kontoen din. Bruk deretter det nye passordet og Facebook-e-posten din for \xE5 logge inn i stedet.',
        facebook_error_title: "Facebook-innlogging er for \xF8yeblikket utilgjengelig",
        forgot_password_description: "Skriv inn e-posten din, s\xE5 sender vi deg instruksjoner om hvordan du tilbakestiller passordet ditt.",
        forgot_password_done_button: "Tilbake til login",
        forgot_password_done_description: "En e-post er sendt til deg med instruksjoner for tilbakestilling av passord.",
        forgot_password_done_help: "Hvis du ikke ser e-posten, m\xE5 du sjekke om det er i spam-mappen. Hvis det fortsatt ikke virker vennligst",
        forgot_password_done_title: "Snart klar",
        forgot_password_link: "Glemt passordet ditt?",
        forgot_password_title: "Glemt passordet ditt?",
        logged_in: "Du er logget inn",
        login_button: "Logg inn",
        login_button_apple: "Apple",
        login_button_facebook: "Facebook",
        login_button_google: "Google",
        login_button_in_progress: "Logger p\xE5...",
        login_or_signup: "Logg inn eller registrer deg",
        login_title: "Logg inn",
        logout_confirmation: "Er du sikker p\xE5 at du vil logge ut?",
        logout_from_all_devices_confirmation: "Er du sikker p\xE5 at du vil logge ut fra alle enhetene dine? Du m\xE5 logge inn igjen p\xE5 hver av enheten du vil bruke.",
        logout_from_all_devices_title: "Logg ut fra alle enheter",
        logout_title: "Logout",
        new_member: "Er du ny p\xE5 SF Anytime?",
        new_password_placeholder: "Nytt passord",
        new_password_title: "Nytt passord",
        now_logged_in_as: "Du er n\xE5 logget inn som",
        no_verification_email: "Har du ikke mottatt e-posten?",
        or_login_with: "Eller fortsett med",
        password_placeholder: "Passord",
        password_restriction: "Passordet m\xE5 v\xE6re minst 8 tegn.",
        password_updated_for: "Passord oppdatert for:",
        remeber_me: "Husk meg",
        remote_login_device_text: "med telefonen, nettbrettet eller datamaskinen, og skriv inn f\xF8lgende kode",
        remote_login_go_to: "G\xE5 till",
        send_verification_email_again: "Send p\xE5 nytt",
        signedup_button: "Kom i gang",
        signedup_title: "Takk for at du registrerte deg hos oss",
        signup_button: "Opprett konto",
        signup_slogan: "Str\xF8m de siste filmene!\n\xC5 bli medlem er gratis.",
        signup_title: "Bli medlem",
        signup_usp_array: [
          "Se hvor som helst du vil",
          "Tilgang til de nyeste filmene",
          "Lagre lister og f\xE5 personlige tips"
        ],
        tos_confirm: "SF Anytimes brukervillk\xE5r",
        tos_confirmation: "Godta brukervilk\xE5rene for \xE5 fortsette",
        tos_consent: "Jeg bekrefter at jeg er 18 \xE5r eller eldre, og jeg godtar",
        tos_url: "https://www.sfanytime.com/no/page/brukervilkar",
        verify_email_description: "Vi har sendt deg en bekreftelses-e-post. Bekreft kontoen din ved \xE5 klikke p\xE5 lenken i e-posten som sendes til:",
        verify_email_social_login_description: "Vi har sendt deg en bekreftelses-e-post. Bekreft kontoen din ved \xE5 klikke p\xE5 lenken i e-posten som sendes til Facebook-kontoen din:",
        "\u200Blogin_with_social_media": "eller logg inn med",
        "\u200Bregister_with_social_media": "eller opprette konto med"
      },
      checkout: {
        audio: { title: "Lyd" },
        buy_tickets_button_title: "Kj\xF8p tickets",
        campaign_title: "Kampanje",
        choose_language: "Du m\xE5 velge spr\xE5k",
        confirm_button: { title: "Fullf\xF8r kj\xF8pet" },
        continue_to_payment: { title: "Fortsett til betaling" },
        done: "Betalt og ferdig!",
        download_our_app_ups: "Du kan ogs\xE5 titte i v\xE5re apper p\xE5 mobil, nettbrett eller SmartTV. Vi st\xF8tter ogs\xE5 Chromecast.",
        entitlement_type: {
          buy: "Kj\xF8p",
          buy_description: "Kj\xF8pefilm \u2013 se den n\xE5r du vil, s\xE5 ofte du vil.",
          rent: "Lei",
          rent_description: "Se ferdig p\xE5 48 timer.",
          title: "Lei eller kj\xF8p"
        },
        episode: "Episode",
        episode_count: "{{count}}-episoder",
        episode_count_title: "Episoder",
        est: "Kj\xF8p",
        est_bundle_duration: "Se n\xE5r du vil, s\xE5 ofte du vil.",
        est_episode_duration: "Se n\xE5r du vil, s\xE5 ofte du vil.",
        est_movie_duration: "Kj\xF8pefilm \u2013 se den n\xE5r du vil, s\xE5 ofte du vil.",
        est_season_duration: "Se n\xE5r du vil, s\xE5 ofte du vil.",
        hide_price_details: "Skjul detaljer",
        language: {
          local: "Lokalt spr\xE5k",
          original: "Originalt spr\xE5k",
          title: "Spr\xE5k",
          title_short: "Spr\xE5k"
        },
        leave_warning: "Skal du forlate kassen? Hvis du lar det v\xE6re aktiv betaling, kan det f\xF8re til tap av ordre.",
        pay: "Betal",
        payment: {
          add_saved_card_tip: "Betal direkte til TV-en din neste gang ved \xE5 lagre et debetkort p\xE5 kontoen din p\xE5 SF Anytime",
          adyen_applepay: "Apple Pay",
          adyen_applepay_description: "Med Apple Pay kan du foreta sikre kj\xF8p med Apple Cash, Apple Card og andre kreditt- og debetkort du legger til i Wallet.",
          adyen_creditcard: "Kredittkort",
          adyen_creditcard_description: "Betal trygt med Visa, Mastercard og American Express.",
          adyen_klarna: "Betal senere",
          adyen_klarnaaccount: "Betal over tid",
          adyen_klarnaaccount_description: "Betal over tid",
          adyen_klarnapaynow: "Betal n\xE5",
          adyen_klarnapaynow_description: "Betal n\xE5",
          adyen_klarna_description: "Betal med Klarna.",
          adyen_mobilepay: "MobilePay",
          adyen_mobilepay_description: "Skriv inn telefonnummeret til mobiltelefonen du betaler med. Du m\xE5 ha MobilePay-appen installert.",
          adyen_savedcreditcard: "Lagret kredittkort",
          adyen_savedcreditcard_description: "Betal med {{name}} {{number}}.",
          adyen_swish: "Swish",
          adyen_swish_description: "Betal med Swish-appen p\xE5 mobilen.",
          adyen_vipps: "Vipps",
          adyen_vipps_description: "Betal enkelt og praktisk med Vipps.",
          amex: "Kortbetaling",
          amex_description: "Betal trygt med American Express.",
          apple_inapp: "App Store",
          apple_inapp_description: "Betal med den lagrede betalingsm\xE5ten du bruker for App Store, iTunes Store, iCloud og mer.",
          card: "Kortbetaling",
          card_description: "Betal trygt med Visa og Mastercard.",
          freeproduct: "Gratis",
          google_inapp: "Google Play",
          google_inapp_description: "Betal med den lagrede betalingsm\xE5ten du bruker for Google Play.",
          group_klarna: {
            description: "Fleksible betalinger med Klarna.",
            title: "Klarna"
          },
          klarna: "Klarna",
          klarna_description: "Betal via Klarna med et kort eller en bankkonto",
          more_payment_options: "Flere betalingsalternativer",
          more_payment_options_description: "Velg en annen betalingsm\xE5te, eller hvis du har en verdikode.",
          not_available_in_app_description: "Betalingsalternativet er ikke tilgjengelig for kj\xF8p i denne appen.",
          other: "Annen betalingsmetode",
          prepaid: "Film billett",
          saved_card: "Lagret betalingskort",
          save_payment_info: "Lagre betalingsinformasjon",
          sf_freeproduct: "Gratis",
          sf_loyaltypoints: "Lojalitetspoeng",
          sf_loyaltypoints_description: "SF-lojalitetspoeng",
          sf_ticket: "{{cost}} tickets",
          sf_ticket_buy_more_one: "Kj\xF8p {{count}} ticket",
          sf_ticket_buy_more_other: "Kj\xF8p {{count}} tickets",
          sf_ticket_description_one: "Betal med {{cost}} av tickets dine.\nDu har en total {{count}} tickets.",
          sf_ticket_description_other: "Betal med {{cost}} av tickets dine.\nDu har totalt {{count}} tickets.",
          sf_ticket_description_zero: "Betal med {{cost}} tickets.\nDu har ingen tickets for \xF8yeblikket.",
          sf_ticket_description_disabled_one: "Du trenger {{count}} mer tickets.",
          sf_ticket_description_disabled_other: "Du trenger {{count}} flere tickets.",
          sf_voucher: "Verdikode",
          swish: "Swish",
          swish_description: "Betal med Swish-appen p\xE5 mobilen.",
          swish_disabled: "Swish is inactivated due to technical reasons.",
          to_payment: "G\xE5 til betaling",
          to_payment_button: "G\xE5 til betaling",
          tv_adyen_pay_with_saved_card: "Betal med lagret kort",
          use_a_voucher: "Bruke et verdikode",
          valuecode: "Verdikode"
        },
        payment_method: { title: "Betalingsm\xE5te" },
        payment_method_group_placeholder: "Betalingsm\xE5ter",
        purchase_not_allowed_in_app: {
          link: "Les mer om hvordan du leier filmer",
          text: "Dessverre kan du ikke foreta kj\xF8p i appen."
        },
        receipt: {
          app_description: "Med appen kan du ogs\xE5 se filmen p\xE5 TVen din med Chromecast eller laste ned og se offline.",
          datetime: "Dato",
          discount: "Rabatt",
          fee: "Servicegebyr for kj\xF8p i app",
          legal_info: "N\xE5r du begynner \xE5 streame en film, en film inkludert i en pakke, en sesong av en serie, en serieepisode eller konsumere en ticket, samtykker du i at SF Anytime begynner \xE5 fullf\xF8re leveringen av filmen, slik at du ikke lenger kan angre p\xE5 kj\xF8pet.",
          open_in_app: "\xC5pne i appen",
          order_no: "Bestillingsnummer",
          payment_method: "Betalingsm\xE5te",
          receipt_title: "Kvittering",
          save: "Lagre kvittering (pdf)",
          smarttv_description: "Eller bruk en av v\xE5re Smart TV-apper p\xE5 Samsung, LG, AppleTV og Android TV.",
          sum: "Totalt",
          thanks: "Takk for at du valgte \xE5 se film hos oss!",
          ticket_valid_to: "Tickets er gyldige til",
          valid_to: "Gyldig til",
          vat: "Hvorav moms",
          vat_nr_label: "Norsk MVA-nummer",
          vat_nr_value: "2000121",
          voucher_legal_info: "Filmkodene er gyldige i 6 m\xE5neder.",
          you_have_bought: "Du har kj\xF8pt",
          you_have_rented: "Du har leid"
        },
        rental_duration: "Lease",
        select_placeholder: "Velg",
        show_price_details: "Vis detaljer",
        subtitles: {
          no_subtitles: "Ingen undertekster",
          title: "Undertekster"
        },
        ticket_prompt: {
          description: "Kj\xF8p tickets direkte i v\xE5r app eller fra v\xE5r nettside.\nBruk deretter tickets dine til \xE5 bytte mot en film eller serie.",
          not_enough_tickets: {
            title: "Du trenger flere tickets for \xE5 fortsette med denne betalingsm\xE5ten"
          },
          tickets_are_required: {
            title: "Du trenger tickets for \xE5 kj\xF8pe i denne appen"
          }
        },
        ticket_type: {
          description_one: "Gyldig i 3 \xE5r fra kj\xF8psdato og kan brukes i alle v\xE5re apper.",
          description_other: "Gyldig i 3 \xE5r fra kj\xF8psdato og kan brukes i alle v\xE5re apper.",
          description_valid_to: "En ticket er gyldig i 3 \xE5r fra kj\xF8psdato",
          title_one: "1 ticket",
          title_other: "{{count}} tickets"
        },
        total_cost: "Totalbel\xF8p inkl. mva",
        tvod: "Lei",
        tvod_episode_duration: "Se ferdig p\xE5 48 timer.",
        tvod_movie_duration: "Se ferdig p\xE5 48 timer.",
        tvod_season_duration: "Se ferdig p\xE5 30 dager.",
        update: {
          text: "Vi har gitt ut en forbedret versjon av appen v\xE5r, og du m\xE5 oppdatere appen for \xE5 fortsette.",
          title: "Oppdatere appen"
        },
        value_code_applied_value: "{{percent}}% rabatt",
        value_code_apply: "Bruke",
        value_code_invalid: "Verdikoden er ikke gyldig for denne tittelen eller finnes ikke",
        value_code_placeholder: "Skriv inn koden din",
        value_code_prompt: "Har du en kupong? Skriv den inn her",
        value_code_title: "Verdikode",
        value_code_used: "Koden kan ikke lenger brukes ettersom gyldighetsdato er overskredet.",
        voucher: {
          campaign: {
            "5_for_4": {
              description: "1 leiefilmkode mindre \xE5 betale for.",
              label: "Kj\xF8p 5 betale for 4"
            }
          },
          campaign_title: "Et tilbud brukes",
          delivery_type: {
            my_email: "Til min e-post",
            recipient_email: "Til mottaker ved hjelp av e-post",
            recipient_sms: "Til mottaker ved hjelp av SMS",
            title: "Leveringsmetode"
          },
          entitlement_type: {
            buy_description: "Kj\xF8pefilm \u2013 se den n\xE5r du vil, s\xE5 ofte du vil.",
            buy_text_price: "Kj\xF8p {{price}}",
            rent_text_description: "Se ferdig p\xE5 48 timer.",
            rent_text_price: "Lei {{price}}"
          },
          title: "Kj\xF8p filmkoder"
        },
        voucher_has_issue: "Vennligst korriger eller fjern kupongkoden",
        voucher_not_valid: "Kupongkoden er ikke gyldig med dine valg",
        webview_timeout: "Dette tar lengre tid enn vanlig...",
        you_have_bought: "Du har kj\xF8pt",
        you_have_rented: "Du har leid",
        you_selected_to_buy: "Du har valgt \xE5 kj\xF8pe",
        you_selected_to_rent: "Du har valgt \xE5 leie"
      },
      emails: {
        content_notification: {
          reason_for_email_one: "Du mottar denne e-posten fordi du har aktivert varsler med denne tittelen.",
          reason_for_email_other: "Du mottar denne e-posten fordi du har aktivert varsler p\xE5 disse titlene.",
          subject_one: "En tittel du har sett, er n\xE5 tilgjengelig",
          subject_other: "Titlene dine er n\xE5 tilgjengelige"
        },
        footer: {
          cant_reply: "Denne e-posten kan ikke besvares. Hvis du har sp\xF8rsm\xE5l,",
          copyright: "\xA9 2024 SF Anytime AB (org nr.  556748-2616, VAT SE556748261601)",
          please_contact_us_link: "ta kontakt med oss her",
          regards: "Med v\xE4nliga h\xE4lsningar,",
          unsubscribe: "Melde deg",
          web_link: "Web-versjon"
        },
        gdpr_clean_up: {
          clarification: "*Gjelder kun kontoen som er registrert p\xE5 e-postadressen du mottok denne e-posten til. Hvis du har registrert flere kontoer med forskjellige e-postadresser, h\xE5ndteres disse separat.",
          cta: "Lei en film",
          delete_account_text_one: "Hvis du vil ha kontoen din slettet, trenger du ikke gj\xF8re noe, kontoen slettes automatisk om 1 dag. Du kan alltid opprette en ny gratis konto med de samme opplysningene hvis du vil ha en konto hos oss igjen i fremtiden.",
          delete_account_text_other: "Hvis du vil ha kontoen din slettet, trenger du ikke gj\xF8re noe, kontoen slettes automatisk om {{number}} dager. Du kan alltid opprette en ny gratis konto med de samme opplysningene hvis du vil ha en konto hos oss igjen i fremtiden.",
          intro_one: "Det er en stund siden sist du bes\xF8kte oss, og p\xE5 grunn av GDPR m\xE5 vi slette kontoen din* p\xE5 1 dag.",
          intro_other: "Det er en stund siden sist du bes\xF8kte oss, og p\xE5 grunn av GDPR m\xE5 vi slette kontoen din* om {{number}} dager.",
          reason_for_email: "Du mottar denne e-posten fordi du har en konto til v\xE5r tjeneste.",
          save_account_text: "Vil du beholde kontoen din?\xA0Lei en film med {{discount}}% rabatt med verdikoden under!",
          subtitle_one: "Om 1 dag vil gratiskontoen din bli slettet",
          subtitle_other: "Om {{number}} dager vil gratiskontoen din bli slettet",
          title: "P\xE5minnelse om SF Anytime-kontoen din",
          voucher_info: "Kupongkoden er personlig og gjelder kun p\xE5 denne kontoen, kan kun brukes \xE9n gang og rabatten gjelder for leiefilm opp til 59 kr. Ikke gyldig for kino- eller kj\xF8psfilmer og kan ikke kombineres med andre tilbud.",
          voucher_limitations: "Gjelder leiefilm inntil 59 kr.",
          voucher_offer: "{{discount}}% rabatt p\xE5 leiefilmer"
        },
        header: {
          hello: "Hei",
          hello_we_miss_you: "Hei, vi savner deg!",
          looking_weird: "Ser e-posten merkelig ut?",
          open_in_browser: "\xC5pne i nettleseren"
        },
        new_user: {
          intro: "Det er flott at du har blitt medlem hos oss. Vi har de bredeste kinohyllene i Norden, fylt med alt fra prisbel\xF8nte mesterverk til god underholdning. Vi tror at det finnes en film for enhver anledning og en mulighet for hver film.",
          intro2: "Trekk pusten dypt og begi deg inn i kolleksjonen.",
          title: "Velkommen til SF Anytime"
        },
        order_receipt: {
          find_your_playable_content: "Du finner kvitteringer for alle kj\xF8pene dine p\xE5 Mine kj\xF8p-siden og innholdet du har kj\xF8pt, p\xE5 Mitt innhold-siden.",
          go_to_playable_content: "Spille",
          greeting_bundle: "Vi p\xE5 SF Anytime \xF8nsker deg en hyggelig filmopplevelse!\n",
          greeting_episode: "Vi hos SF Anytime \xF8nsker deg en hyggelig seriestund!",
          greeting_movie: "Vi p\xE5 SF Anytime \xF8nsker deg en hyggelig filmopplevelse!\n",
          greeting_season: "Vi hos SF Anytime \xF8nsker deg en hyggelig seriestund!",
          greeting_ticketpack: "Vi hos SF Anytime h\xE5per at ticketene dine kommer til god nytte!",
          greeting_voucher: "Vi hos SF Anytime h\xE5per at filmkodene dine kommer til god nytte!",
          more_about_vouchers: "Les mer om filmkoder",
          product_type_bundle_est_description: "Du kan se filmene s\xE5 mange ganger du vil.",
          product_type_episode_est_description: "Du kan se episoden s\xE5 mange ganger du vil.",
          product_type_episode_tvod_description: "Se ferdig p\xE5 48 timer.",
          product_type_movie_est_description: "Du kan se filmen s\xE5 mange ganger du vil.",
          product_type_movie_tvod_description: "Se ferdig p\xE5 48 timer.",
          product_type_season_est_description: "Du kan se seriesesongen s\xE5 mange ganger du vil.",
          product_type_season_tvod_description: "Se ferdig p\xE5 30 dager.",
          product_type_ticketpack_est_description: "Ticketene dine er gyldige i tre \xE5r fra kj\xF8psdatoen og er tilgjengelige p\xE5 kontoen din. De kan brukes som betaling n\xE5r du kj\xF8per innhold fra en av appene v\xE5re.",
          product_type_voucher__description: "Vedlagt finner du kodene dine. Lagre kodene p\xE5 datamaskinen eller skriv dem ut og gi dem i gave.",
          reason_for_email: "Dette er en bekreftelse p\xE5 et kj\xF8pt innhold med en konto som bruker denne e-postadressen.",
          subject: "Kvittering fra SF Anytime",
          thanks_bundle: "Takk for at du valgte \xE5 kj\xF8pe en filmpakke hos oss!",
          thanks_episode: "Takk for at du valgte \xE5 kj\xF8pe en serieepisode hos oss!",
          thanks_movie: "Takk for at du valgte \xE5 kj\xF8pe en film hos oss!",
          thanks_season: "Takk for at du valgte \xE5 kj\xF8pe en seriesesong hos oss!",
          thanks_ticketpack: "Takk for at du valgte \xE5 kj\xF8pe tickets hos oss!",
          thanks_voucher: "Takk for at du valgte \xE5 kj\xF8pe filmkoder hos oss!",
          title: "Kvittering"
        },
        reset_password: {
          intro: "Dette er en foresp\xF8rsel om tilbakestilling av passord for kontoen:",
          not_requested: "Hvis du ikke har bedt om en e-post for \xE5 tilbakestille passordet, b\xF8r du likevel endre passordet p\xE5 siden Min konto under Innstillinger for \xE5 beskytte kontoen.",
          reset_password: "Tilbakestill passord",
          reset_password_link_text: "Klikk p\xE5 knappen nedenfor for \xE5 velge et nytt passord. Lenken er gyldig i 30 minutter.",
          subject: "Tilbakestilling av passord",
          title: "Tilbakestilling av passord"
        },
        voucher: {
          code_label: "Kode:",
          valid_to: "Gyldig til:",
          your_personal_code: "Din personlige kode"
        }
      },
      genre: {
        "3d": "3D",
        action: "Action",
        adult: "Voksen",
        adventure: "Eventyr",
        animated: "Animasjon",
        anime: "Anime",
        children: "Barn",
        "children-family": "Barn og familie",
        "children-family (Copy)": "Barn og familie",
        comedy: "Komedie",
        crime: "Krim",
        cult: "Kult",
        danish: "Dansk",
        documentary: "Dokumentar",
        drama: "Drama",
        finnish: "Finsk",
        horror: "Skrekk",
        "movie-gems": "Filmperler",
        music: "Musikk",
        norwegian: "Norsk",
        romance: "Romantikk",
        "sci-fi": "Sci-fi",
        "sf-kids": "SF Kids",
        swedish: "Svensk",
        thriller: "Thriller",
        "tv-series": "TV-serie",
        war: "Krigsfilmer",
        western: "Western"
      },
      glossary: {
        abort: "Avbryte",
        activate: "Aktivere",
        add_to_my_list: "Legg til i Min liste",
        amount: "Antall",
        app_version: "App-versjon",
        available: "Tilgjengelig",
        back_navigation: "Tilbake",
        bought: "Kj\xF8pt",
        bought_badge: "KOPT",
        brand: "SF Anytime",
        build_number: "Bygg nummer",
        bundle: "Filmpakker",
        buy: "Kj\xF8p",
        buy_first_episode_from: "F\xF8rste episode fra",
        buy_from: "Fra",
        campaign: "Kampanje",
        cancel: "Avbryt",
        close_modal: "Lukk",
        coming_soon: "Kommer snart",
        continue: "Fortsett",
        customer_service: "Support",
        download_from_AppStore: "Last ned p\xE5 App Store",
        download_from_GooglePlay: "Last ned p\xE5 Google Play",
        error: "Feil",
        fullscreen: "Fullskjerm",
        hide_banner: "Skjule",
        last_chance: "Siste sjanse",
        loading: "Laster...",
        mark_as_not_watched: "Merk som ikke overv\xE5ket",
        mark_as_watched: "Merk som overv\xE5ket",
        minutes: "minutter",
        movie: "Film",
        mute: "Dempe",
        next_episode: "Neste episode",
        no: "nei",
        not_available: "Ikke tilgjengelig",
        off: "Av",
        on: "P\xE5",
        open: "\xC5pne",
        open_in_browser_button: "\xC5pne i nettleseren",
        password: "Passord",
        pause_button: "Pause",
        play_button: "Spill av",
        read_more: "Les mer",
        release: "Kommer",
        release_date: "Utgivelsesdato",
        remote_control: "fjernkontrollen",
        remove_from_my_list: "Fjern fra Min liste",
        rented: "LEASET",
        rented_badge: "LEASET",
        saved: "Lagret",
        search_results: "S\xF8keresultater",
        select: "Velg",
        series: "Serie",
        sf_anytime: "SF Anytime",
        show: "Vis",
        show_all: "Vis alle",
        show_all_x: "Vis alle {{count}}",
        support_forum: "support.sfanytime.com",
        support_mail: "support@sfanytime.com",
        this_device: "Denne enheten",
        tickets: "Tickets",
        trailer: "Trailer\n",
        unknown: "Ukjent",
        username: "Brukernavn",
        warning: "Advarsel",
        x_results: {
          plural: "{{number}} resultater",
          singular: "{{number}} resultat"
        },
        yes: "Ja",
        "\u200Brented_for": "Leid for",
        "\u200Brented_to": "Leid til"
      },
      media: {
        age_rating: "Aldersgrense",
        audio: "Lyd",
        bundle: {
          discount_text: "Spar {{percentage}}% ",
          movie_count: "{{count}} filmer"
        },
        continue_watching: {
          empty: "Filmer og serier du ikke er ferdig med \xE5 se p\xE5 enn\xE5, vises her",
          title: "Fortsett \xE5 se p\xE5"
        },
        crew: {
          actor: "Skuespillere",
          director: "Regiss\xF8r",
          title: "Rollebesetning og mannskap"
        },
        download: {
          action_will_remove_active_download: "Denne handlingen fjerner den aktive nedlastingen.",
          cancel_download: "Avbryt nedlastingen",
          delete_download: "Slett nedlasting",
          deleting: "Slette",
          deleting_download_description: "Sletter nedlasting... Dette kan ta litt tid.",
          downloaded: "Lastet ned",
          downloading: "Laste ned",
          download_completed: "Nedlasting fullf\xF8rt",
          download_error: "Nedlastingsfeil",
          list_title: "Lastet ned p\xE5 denne enheten",
          logout_warning: "Nedlastingene dine slettes n\xE5r du logger av.",
          no_entitled_downloads: "Det er nedlastinger p\xE5 denne enheten, men ingen som tilh\xF8rer kontoen din. Du kan fremdeles slette dem.",
          no_space_left_error: "Ingen plass igjen p\xE5 enheten.",
          paused: "Midlertidig stanset",
          pause_download: "Stanse nedlastingen midlertidig?",
          pause_download_error: "Kan ikke sette nedlastingen p\xE5 pause, pr\xF8v p\xE5 nytt.",
          pick_quality: "Velg kvalitet du vil laste ned",
          pick_quality_high: "H\xF8y",
          pick_quality_low: "Lav",
          pick_quality_max: "Maks",
          pick_quality_medium: "Medium",
          quality: "Kvalitet",
          queued: "K\xF8styrt",
          removing: "Fjerner",
          removing_download: "Fjerne nedlasting",
          resume_download: "Gjenoppta nedlasting",
          resume_download_error: "Kan ikke gjenoppta nedlastingen, pr\xF8v p\xE5 nytt.",
          start_download: "Last ned",
          start_download_error: "Kan ikke starte nedlastingen, pr\xF8v p\xE5 nytt.",
          try_to_download_again: "Pr\xF8v \xE5 laste ned innholdet p\xE5 nytt."
        },
        entitlement_type: "Innkj\xF8pstype",
        episode_rental_left: "Utleie slutter i: {{rental_time_left}}",
        extra_material: { title: "Ekstra materiale" },
        from_countries: "Produsert i",
        has_access: "Tilgang",
        keep_watching: "Fortsett \xE5 se p\xE5",
        length: "Lengde",
        meta_description_movie: "Lei og kj\xF8p filmen {{ title }} med {{ actor1 }} og {{ actor2 }}. Str\xF8m denne {{ genre }}-filmen og andre filmer online p\xE5 {{ brand }}.",
        meta_description_series: "Lei og kj\xF8p serien {{ title }} med {{ actor1 }} og {{ actor2 }}. Str\xF8m denne {{ genre }}-serien og andre serier online p\xE5 {{ brand }}.",
        meta_title: "{{title}} \u2013 Lei eller kj\xF8p og streame p\xE5 SF Anytime",
        more_info_title: "Mer informasjon",
        movie_bought_info: "Kj\xF8pt - Se n\xE5r du vil, s\xE5 mange ganger du vil",
        movie_rental_left: "Utleie slutter i: {{rental_time_left}}",
        movie_rented_and_expires_at: "Leid - leieperioden utl\xF8per {{rent_end_time}}",
        my_list: "Min liste",
        my_list_add_button: "Min liste",
        notify: "Varsle",
        notifyme_button: "Varsle meg",
        notifyme_button_active: "Fulgt",
        only_on: "Bare p\xE5",
        production_country: "Produsert i",
        purchase: { unavailable_button: "Kan ikke leie" },
        release_date: "Kommer: {{dateString}}",
        series: {
          average_episode_length: "~{{length}}/episode",
          buy_this_season: "Kj\xF8p denne sesongen",
          episodes: "Episoder",
          episode_count: "{{count}} episoder",
          next_episode: "Neste episode",
          not_available: "Dette innholdet er ikke tilgjengelig p\xE5 dette tidspunktet",
          season: "Sesongen",
          seasons: "Sesonger",
          season_release: "Kommer: {{dateString}}"
        },
        share_button: "Dele",
        show_more: "Vis mer",
        similar_movies: "Lignende",
        similar_series: "Lignende",
        similar_tickets: "Andre tickets",
        similar_titles: "Lignende titler",
        subtitles: "Undertekster",
        trailer_button: "Trailer",
        upcoming: "Kommende",
        watched: { title: "Allerede sett" }
      },
      mymedia: {
        entitlements_empty_list: [
          "Her finner du filmene og programmene du har leid eller kj\xF8pt",
          "Se p\xE5 TV-en med Chromecast eller Airplay",
          "Last ned og se mens du er frakoblet - perfekt n\xE5r du reiser"
        ],
        entitlements_title: "Mine filmer og serier",
        favorites_title: "Min liste",
        my_content_title: "Mitt innhold",
        my_list_empty_array: [
          "Du har ikke lagret noen filmer eller programmer til Min liste enn\xE5",
          "Se p\xE5 TV-en med Chromecast eller Airplay",
          "Last ned og se mens du er frakoblet - perfekt n\xE5r du reiser"
        ],
        my_list_title: "Min liste",
        saved_searches_title: "Mine observasjoner"
      },
      offer_redeemed: "Ser ut til at dette allerede er innl\xF8st",
      push: {
        discountedtitle: {
          text: "En tittel du kanskje liker, er n\xE5 rabattert.",
          title: '"{{localtitle}}" er n\xE5 rabattert'
        },
        multipletitlesmatchingsavedsearch: {
          text: '"{{localtitles}}" er n\xE5 tilgjengelige.',
          title: "Titlene dine er n\xE5 tilgjengelige"
        },
        newtitle: {
          text: "En tittel du kanskje liker, er n\xE5 tilgjengelig.",
          title: '"{{localtitle}}" er n\xE5 tilgjengelig'
        },
        singletitlematchingsavedsearch: {
          text: "En tittel du har sett, er n\xE5 tilgjengelig.",
          title: '"{{localtitle}}" er n\xE5 tilgjengelig.'
        },
        title_matching_saved_search: {
          "text _one": "En tittel du har sett, er n\xE5 tilgjengelig.",
          "text _other": "Titlene dine er n\xE5 tilgjengelige"
        }
      },
      search: {
        active_filters: "Aktive filtre",
        agelimit_years: "{{age}} \xE5r",
        did_you_mean: "Mente du det?",
        empty_results: "Oops, det ser ut som s\xF8ket returnerte ingen resultater.",
        empty_results_message: "Pr\xF8v \xE5 fjerne s\xF8ket, endre filtrene dine eller velg noe fra de popul\xE6re s\xF8keresultatene nedenfor.",
        facet: {
          actors: "Skuespillere",
          ageLimit: "Aldersgrense",
          directors: "Regiss\xF8rer",
          duration: "Lengde",
          genres: "Sjangere",
          lowestPrice: "Pris",
          manifest: {
            audio: { tracks: { language: "Lyd" } },
            subtitles: { language: "Undertekster" }
          },
          mediaTags: { name: "Media Tags" },
          metaCollections: "Emner",
          productType: "Type",
          ratings: { imdb: "IMDB-vurdering" },
          releaseYear: "Utgivelses\xE5r"
        },
        filters_hits: "Treff",
        filters_reset_button: "Tilbakestill filtre",
        filters_title: "Filtre",
        from: "Fra",
        history: "Nylige s\xF8k",
        input_placeholder: "S\xF8k",
        input_press_ok: "Trykk p\xE5 OK for \xE5 \xE5pne tastaturet",
        "list-view": "Listevisning",
        "list-view-as-grid": "Rutenett",
        "list-view-as-list": "Listen",
        "load-more-button": "Last inn mer",
        not: "Ikke {{ filter }}",
        number_of_seasons: {
          plural: "{{seasonCount}} sesonger",
          singular: "{{seasonCount}} sesong"
        },
        placeholder: "S\xF8k...",
        popular_search_terms: "Popul\xE6re s\xF8keord:",
        recent_searches: "Nylige s\xF8k",
        remove: "Fjerne",
        reset_button: "Tilbakestille",
        reset_refinements: "Klar",
        reset_search: "Begynn p\xE5 nytt",
        save: "Lagre",
        saved: "Lagrede",
        saved_searches: "Lagret",
        show_less: "Vis mindre",
        show_more: "Vis mer",
        show_previous: "Vis forrige",
        suggestions: "Forslag",
        to: "Inntil"
      },
      service_availability: {
        checkout: { title: "Driftsforstyrrelser" },
        generic: { title: "Driftsforstyrrelser" }
      },
      settings: {
        abort: "Avbryt",
        add_card: "Legg til kredittkort",
        add_card_success: "Kredittkortet ditt er lagret!",
        allow_mobile_download: {
          hint_active: "Nedlasting med mobildata er tillatt",
          hint_inactive: "Tillater bare nedlasting via Wi-Fi",
          title: "Tillat nedlastinger med mobildata"
        },
        app_info_title: "Om appen",
        bonus: "Min bonus",
        buy_tickets_service_fee: {
          description: "Ingen servicegebyr tilkommer."
        },
        change_email: "Endre e-post",
        change_info_web_only_description: "G\xE5 til {{url}} med mobilen, nettbrettet eller datamaskinen for \xE5 redigere informasjonen.",
        change_info_web_only_description_url: "www.sfanytime.com",
        change_info_web_only_title: "Redigering av kontoen din er bare mulig p\xE5 nettet",
        change_password: "Endre passord",
        change_payment_method: "Annen betalingsmetode",
        change_payment_web_only_title: "Endring av betalingsm\xE5te er bare mulig p\xE5 nettet",
        cookies_title: "Informasjonskapsler",
        downloads_remove_all_confirm: "Fjern alle",
        downloads_remove_all_confirm_title: "Slett alle nedlastinger",
        downloads_remove_confirm: "Fjern nedlasting",
        downloads_title: "Nedlastinger",
        download_delete_all: "Slett alle",
        download_delete_all_downloads: "Slett alle nedlastinger",
        download_no_downloads_text: "Du har ikke lastet ned noen filmer p\xE5 denne enheten.",
        download_receipt: "Last ned kvittering",
        download_total_size: "Totalt {{size}}",
        empty_purchases: {
          message: "Her vil du kunne se gjennom dine tidligere og aktive kj\xF8p. For \xF8yeblikket har du ingen kj\xF8p registrert.",
          title: "Du har ingen kj\xF8p registrert"
        },
        help: "Hjelp",
        link: { to_device_settings: "G\xE5 til innstillinger" },
        manage_personal_information: "Administrer dine personlige opplysninger",
        marketing: { title: "Oppdater preferansene dine for e-post:" },
        my_account: {
          change_account_details: "Endre kontodetaljer",
          change_dibs_payment: "Endre betalingsm\xE5te for Smart TV",
          change_email_title: "Endre e-post",
          change_payment_title: "Annen betalingsmetode",
          change_pw_title: "Endring av passord",
          customer_id: "Kundenummer:",
          portability_update_button: "Oppdatere betalingsm\xE5ten",
          username: "Brukernavn:"
        },
        my_account_title: "Mine sider",
        my_profile: {
          address: "Adresse",
          change_country: "Endre land",
          choose_country: "Velg land",
          city: "Sted",
          country: "Land",
          delete_account: "Slett konto",
          delete_account_confirmed: "Kontoen din er n\xE5 slettet.",
          delete_account_description: "Vil du at kontoen din, loggen og all informasjon om deg skal slettes? En slettet konto kan ikke opprettes p\xE5 nytt, noe som betyr at kj\xF8pte filmer og serier g\xE5r tapt. Bekreft valget ved \xE5 skrive inn passordet i neste trinn.",
          download: "Last ned",
          email: "E-",
          export_information: "Be om min informasjon",
          export_information_description: "Vil du vite mer om hvilken informasjon vi har lagret om deg? Be om informasjon enkelt og sikkert her.",
          export_information_loading_message: "Dette kan ta litt tid, avhengig av mengden data som finnes.",
          export_information_loading_title: "Vennligst vent, vi henter dataene dine fra systemet v\xE5rt",
          export_information_preview_title: "Forh\xE5ndsvisning av dataeksporten",
          first_name: "Fornavn",
          last_name: "Etternavn",
          myinfo_title: "Registrer utdrag personlige data",
          password: "Passord",
          phone: "Mobile",
          short_username: "Brukernavn",
          short_username_description: "Hvis du bruker noen av v\xE5re SmartTV-apper kan du lage et kortere, alternativt brukernavn nedenfor som gj\xF8r det letter \xE5 logge inn.",
          zipcode: "Postnummer"
        },
        newsletter_consent: {
          agree: "Ja takk",
          disagree: "Nei takk",
          title: "Vi vil gjerne holde kontakten med deg"
        },
        notifications: {
          allow_notifications: "Tillat varsler",
          controlled_from_settings_phone: "Styres fra innstillingene p\xE5 telefonen",
          description: "Med varsler om kan du f\xE5 informasjon om nye utgivelser, anbefalinger, kampanjer eller appfunksjoner.",
          dont_miss_new_releases: "Ikke g\xE5 glipp av noen nye utgivelser",
          enable_notifications: "Aktivere varsler",
          new_content: "Nytt innhold er tilgjengelig",
          notification_settings_in_phone: "Varslene dine for SF anytime er",
          permission_description: "Med varsler om vil du kunne f\xE5 informasjon om produktutgivelser, anbefalinger og kampanjer.",
          title: "Varsler",
          to_device_settings: "G\xE5 til innstillinger"
        },
        notification_title: "Varsler",
        no_saved_payment_methods: "Du har ingen lagrede betalingskort.\nHvis du tidligere har hatt et lagret kort for v\xE5re gamle TV-apper, m\xE5 du legge til et nytt.",
        overview: "Oversikt",
        payment_card_tempcharge_disclaimer: "N\xE5r du registrerer et kredittkort blir det reservert 2 SEK p\xE5 kortet. Dette gj\xF8res for \xE5 sjekke om kortet er gyldig. Bel\xF8pet vil ikke bli kredittert, men kan ligge som et reservert bel\xF8p i noen dager, avhengig av banken.",
        payment_method_remove_confirm: "Er du sikker p\xE5 at du vil fjerne betalingsm\xE5ten?",
        payment_method_remove_failed: "Betalingsm\xE5ten kan ikke fjernes",
        payment_method_remove_successful: "Betalingsm\xE5ten er n\xE5 fjernet",
        portability_title: "Str\xF8mme i EU",
        portability_unverified: "Ubekreftet",
        portability_unverified_text: "Du kan se SF Anytime innen EU / E\xD8S hvis du bekrefter ditt bosted. Ved \xE5 oppdatere betalingsm\xE5ten mottar vi denne informasjonen, og du kan da nyte filmer n\xE5r du reiser i EU.",
        portability_verified: "Bekreftet",
        portability_verified_disclaimer: "N\xE5r du oppdaterte betalingsinformasjonen din, ble denne informasjonen gjort tilgjengelig for oss.",
        portability_verified_text: "Vi har verifisert din bolig, s\xE5 n\xE5 kan du nyte filmer n\xE5r du reiser i EU.",
        purchases: "Mine kj\xF8p",
        recent_purchases: "Nylige kj\xF8p",
        recent_rentals: "Lei",
        remove_card: "Fjern kortet",
        remove_payment_method: "Fjerne",
        review_question: "Liker du appen?",
        save: "Lagre",
        saved_card: "Lagret betalingskort",
        saved_payment_methods: "Lagrede betalingsm\xE5ter",
        show_more: "Vis mer",
        tickets: {
          bought_tickets: "Kj\xF8pte tickets",
          buy_tickets: "Kj\xF8p tickets",
          disclaimer: "Du kan kj\xF8pe eller motta tickets som fungerer som betaling n\xE5r du kj\xF8per innhold p\xE5 noen av SF Anytimes apper. Bruk dem som betaling i mobilappene v\xE5re for iOS og Android. Gyldige tickets vil da v\xE6re synlige og kan brukes som betalingsalternativer i kassen.\n\nEn ticket tilsvarer en serieepisode og opptil tjue tickets dekker de fleste kj\xF8p av v\xE5rt filmutvalg.",
          total_title: "{{ count }} x Tickets",
          valid: "Gyldig"
        },
        tickets_and_vouchers: "Mine tickets og kuponger",
        tickets_title: "Mine tickets",
        update: {
          confirm: "Oppdatere",
          text: "Det er en bedre versjon av appen!"
        },
        user_offline_goto_downloads: "G\xE5 til Mine nedlastinger",
        user_offline_navigation: "Du ser ut til \xE5 v\xE6re offline, vennligst sjekk internettforbindelsen din",
        "\u200Bnew_\u200Bemail": "Ny e-postadresse"
      },
      store: {
        feature_1_heading: "Str\xF8m de nyeste filmene",
        feature_1_text: "De nyeste storfilmene, klassikerne og alt mellom",
        feature_2_heading: "Lei eller kj\xF8p",
        feature_2_text: "Hver film og serie kan lastes ned, se hvor du vil",
        feature_3_heading: "Moro for hele familien",
        feature_3_text: "M\xF8t mange venner fra Astrid Lindgren",
        take_over: {
          price: "169kr",
          text: "Oscar\xAE-vinnerne George Clooney og Julia Roberts gjenforenes p\xE5 skjermen som et skilt par som uventet ender opp p\xE5 et felles oppdrag: \xE5 holde datteren forelsket fra \xE5 gj\xF8re de samme feilene de en gang gjorde. Ticket to Paradise er en romantisk komedie om plutselig \xE5 f\xE5 en uventet ny sjanse."
        },
        take_over_child: { price: "139kr" },
        toplist: {
          buy: "Topp kj\xF8p",
          rent: "Topp utleie",
          series: "Toppserier"
        },
        usp_1: "De nyeste filmene uten abonnement",
        usp_2: "Betal bare for det du ser p\xE5",
        usp_3: "Str\xF8m \xF8yeblikkelig eller se uten nett",
        usp_4: "Et av Nordens bredeste sortiment"
      },
      tag: {
        collection: "Filmpakker",
        in_collection: "Del av filmpakke",
        is_collection: "Filmpakker"
      },
      test: { test: { testing_for_fun: "Testing for moro skyld" } },
      value_prop: {
        call_to_action: "Kom i gang",
        title: "Ny, gammel, klassisk. Velg din favoritt blant tusenvis av titler."
      },
      voucher_not_valid_for_producttype_bundle: "Denne verdikoden kan ikke brukes til pakketilbud.",
      voucher_not_valid_for_producttype_episode: "Denne verdikoden kan ikke brukes for episoder.",
      voucher_not_valid_for_producttype_movie: "Denne verdikoden kan ikke brukes for filmer.",
      voucher_not_valid_for_producttype_season: "Denne verdikoden kan ikke brukes for serier."
    }
  },
  sv: {
    __typename: "Localization",
    id: "TG9jYWxpemF0aW9uOkVsRGFlUlM4blRuTDVvTmE1YVg1TTRuc0cxTT06U0ZBbnl0aW1lOnN2",
    locale: "sv",
    items: {
      age_recommendation: { child_friendly: "Barnv\xE4nligt" },
      auth: {
        access_code_expired_text: "Koden som du har angett \xE4r inte l\xE4ngre giltig.",
        access_code_expired_title: "F\xF6rfallen kod",
        already_member: "Redan medlem?",
        back_home: "G\xE5 till startsidan",
        complete_login_on_remote: "Slutf\xF6r inloggningen p\xE5 din {{device}} enhet",
        continue_on_init_device: "Forts\xE4tt p\xE5 din {{device}} tv",
        current_password_placeholder: "Nuvarande l\xF6senord",
        email_changed_to: "E-postadressen \xE4ndras till:",
        email_placeholder: "Email",
        enter_new_email_for: "Ange en ny e-postadress f\xF6r:",
        enter_new_password: {
          for: "Ange ett nytt l\xF6senord f\xF6r:",
          info_text: "Du kommer att beh\xF6va logga in igen i de appar och webbl\xE4sare d\xE4r du redan \xE4r inloggad."
        },
        enter_new_password_for_email: "Ange ett nytt l\xF6senord f\xF6r {{email}} . Du m\xE5ste logga in igen i de appar och webbl\xE4sare d\xE4r du redan \xE4r inloggad sedan tidigare.",
        facebook_error_message: 'Om du redan har skapat ett SF Anytime-konto med Facebook, f\xF6rs\xF6k att anv\xE4nda "\xE5terst\xE4ll l\xF6senord" p\xE5 sfanytime.com. Skriv in e-postadressen som \xE4r kopplad till ditt Facebook-konto. Anv\xE4nd sedan det nya l\xF6senordet och din Facebook-e-post f\xF6r att logga in ist\xE4llet.',
        facebook_error_title: "Facebook-inloggning \xE4r f\xF6r n\xE4rvarande inte tillg\xE4nglig",
        forgot_password_description: "Ange din emailadress s\xE5 skickar vi instruktioner om hur du \xE5terst\xE4ller ditt l\xF6senord.",
        forgot_password_done_button: "Tillbaka till inloggningen",
        forgot_password_done_description: "F\xF6lj instruktionerna i mailet som vi nu skickat till dig.",
        forgot_password_done_help: "Om du inte ser mailet s\xE5 kolla din skr\xE4ppostmapp. Om det fortfarande inte fungerar",
        forgot_password_done_title: "Snart klar",
        forgot_password_link: "Gl\xF6mt ditt l\xF6senord?",
        forgot_password_title: "Gl\xF6mt ditt l\xF6senord?",
        logged_in: "Du \xE4r inloggad",
        login_button: "Logga in",
        login_button_apple: "Apple",
        login_button_facebook: "Facebook",
        login_button_google: "Google",
        login_button_in_progress: "Loggar in...",
        login_or_signup: "Logga in eller registrera dig",
        login_title: "Logga in",
        logout_confirmation: "\xC4r du s\xE4ker p\xE5 att du vill logga ut?",
        logout_from_all_devices_confirmation: "\xC4r du s\xE4ker p\xE5 att du vill logga ut fr\xE5n alla dina enheter? Du kommer att beh\xF6va logga in igen p\xE5 varje  enheten du vill anv\xE4nda.",
        logout_from_all_devices_title: "Logga ut fr\xE5n alla enheter",
        logout_title: "Logga ut",
        new_member: "Ny p\xE5 SF Anytime?",
        new_password_placeholder: "Nytt l\xF6senord",
        new_password_title: "Nytt l\xF6senord",
        now_logged_in_as: "Du \xE4r nu inloggad som",
        no_verification_email: "Fick du inte e-postmeddelandet?",
        or_login_with: "Eller forts\xE4tt med",
        password_placeholder: "L\xF6senord",
        password_restriction: "L\xF6senordet m\xE5ste vara minst fyra tecken l\xE5ngt.",
        password_updated_for: "L\xF6senordet uppdaterat f\xF6r:",
        remeber_me: "Kom ih\xE5g mig",
        remote_login_device_text: "med din telefon, surfplatta eller dator och ange f\xF6ljande kod",
        remote_login_go_to: "G\xE5 till",
        send_verification_email_again: "Skicka igen",
        signedup_button: "Kom ig\xE5ng",
        signedup_title: "Tack f\xF6r att du har registrerat dig hos oss",
        signup_button: "Skapa konto",
        signup_slogan: "Str\xF6mma de senaste filmerna!\nAtt vara medlem \xE4r gratis.",
        signup_title: "Bli medlem",
        signup_usp_array: [
          "Titta var du vill n\xE4r du vill",
          "Tillg\xE5ng till de nyaste filmerna",
          "Spara egna listor och f\xE5 personliga tips"
        ],
        tos_confirm: "SF Anytimes anv\xE4ndarvillkor",
        tos_confirmation: "Godk\xE4nn anv\xE4ndarvillkoren f\xF6r att g\xE5 vidare",
        tos_consent: "Jag bekr\xE4ftar att jag \xE4r 18 \xE5r eller \xE4ldre och jag godk\xE4nner",
        tos_url: "https://www.sfanytime.com/sv/page/anvandarvillkor",
        verify_email_description: "Vi har skickat ett verifieringsmeddelande till dig. Verifiera ditt konto genom att klicka p\xE5 l\xE4nken i e-postmeddelandet som skickas till:",
        verify_email_social_login_description: "Vi har skickat ett verifieringsmeddelande till dig. Verifiera ditt konto genom att klicka p\xE5 l\xE4nken i e-postmeddelandet som skickas till ditt Facebook-konto:",
        "\u200Blogin_with_social_media": "eller logga in med",
        "\u200Bregister_with_social_media": "eller skapa konto med"
      },
      checkout: {
        audio: { title: "Ljudsp\xE5r" },
        buy_tickets_button_title: "K\xF6p tickets",
        campaign_title: "Kampanj",
        choose_language: "Du m\xE5ste v\xE4lja spr\xE5k",
        confirm_button: { title: "Slutf\xF6r k\xF6p" },
        continue_to_payment: { title: "Forts\xE4tt till betalning" },
        done: "Betald och klar!",
        download_our_app_ups: "Du kan \xE4ven titta via v\xE5ra appar p\xE5 din mobil, surfplatta eller Smart-TV. Vi st\xF6djer \xE4ven Chromecast.",
        entitlement_type: {
          buy: "K\xF6p",
          buy_description: "K\xF6pfilm, titta p\xE5 den n\xE4r du vill, s\xE5 m\xE5nga g\xE5nger du vill.",
          rent: "Hyr",
          rent_description: "Se klart p\xE5 48 timmar.",
          title: "Hyr eller k\xF6p"
        },
        episode: "Episod",
        episode_count: "{{count}} avsnitt",
        episode_count_title: "Avsnitt",
        est: "K\xF6p",
        est_bundle_duration: "Titta n\xE4r du vill, s\xE5 m\xE5nga g\xE5nger du vill.",
        est_episode_duration: "Titta n\xE4r du vill, s\xE5 m\xE5nga g\xE5nger du vill.",
        est_movie_duration: "K\xF6pfilm, titta p\xE5 den n\xE4r du vill, s\xE5 m\xE5nga g\xE5nger du vill.",
        est_season_duration: "Titta n\xE4r du vill, s\xE5 m\xE5nga g\xE5nger du vill.",
        hide_price_details: "D\xF6lj detailjer",
        language: {
          local: "Svenskt tal",
          original: "Originalspr\xE5k",
          title: "Spr\xE5k",
          title_short: "Spr\xE5k"
        },
        leave_warning: "S\xE4ker p\xE5 att du vill l\xE4mna checkout? Om du har en aktiv betalning p\xE5g\xE5ende s\xE5 kan den g\xE5 f\xF6rlorad.",
        pay: "Betala",
        payment: {
          add_saved_card_tip: "Betala direkt i din TV n\xE4sta g\xE5ng genom att spara ett betalkort till ditt konto p\xE5 SF Anytime",
          adyen_applepay: "Apple Pay",
          adyen_applepay_description: "Med Apple Pay kan du g\xF6ra s\xE4kra k\xF6p som du l\xE4gger till i din Apple Wallet.",
          adyen_creditcard: "Betalkort",
          adyen_creditcard_description: "Betala s\xE4kert med Visa eller Mastercard.",
          adyen_klarna: "Betala senare",
          adyen_klarnaaccount: "Betala \xF6ver tid",
          adyen_klarnaaccount_description: "Betala \xF6ver tid",
          adyen_klarnapaynow: "Betala nu",
          adyen_klarnapaynow_description: "Betala nu",
          adyen_klarna_description: "Betala med Klarna.",
          adyen_mobilepay: "MobilePay",
          adyen_mobilepay_description: "Ange telefonnumret till mobiltelefonen du betalar med. Du m\xE5ste ha MobilePay-appen installerad.",
          adyen_savedcreditcard: "Sparat betalkort",
          adyen_savedcreditcard_description: "Betala med {{name}} {{number}}.",
          adyen_swish: "Swish",
          adyen_swish_description: "Betala med Swish-appen p\xE5 mobilen.",
          adyen_vipps: "Vipps",
          adyen_vipps_description: "Betala enkelt och bekv\xE4mt med Vipps.",
          amex: "Kortbetalning",
          amex_description: "Betala s\xE4kert med American Express.",
          apple_inapp: "App Store",
          apple_inapp_description: "Betala med din sparade betalningsmetod som du anv\xE4nder f\xF6r App Store, iTunes Store, iCloud med mera.",
          card: "Kortbetalning",
          card_description: "Betala s\xE4kert med Visa och Mastercard.",
          freeproduct: "Gratis",
          google_inapp: "Google Play",
          google_inapp_description: "Betala med din sparade betalningsmetod som du anv\xE4nder f\xF6r Google Play.",
          group_klarna: {
            description: "Flexibla betalningar med Klarna.",
            title: "Klarna"
          },
          klarna: "Klarna",
          klarna_description: "Kort eller bankkonto.",
          more_payment_options: "Fler betalningsalternativ",
          more_payment_options_description: "V\xE4lj en annan betalningsmetod eller om du har en v\xE4rdekod.",
          not_available_in_app_description: "Betalningsalternativet \xE4r inte tillg\xE4ngligt f\xF6r k\xF6p i den h\xE4r appen.",
          other: "Annat betals\xE4tt",
          prepaid: "Filmbiljett",
          saved_card: "Sparat betalkort",
          save_payment_info: "Spara betalningsuppgifter",
          sf_freeproduct: "Gratis",
          sf_loyaltypoints: "Lojalitetspo\xE4ng",
          sf_loyaltypoints_description: "SF-lojalitetspo\xE4ng",
          sf_ticket: "{{cost}} tickets",
          sf_ticket_buy_more_one: "K\xF6p {{count}} ticket",
          sf_ticket_buy_more_other: "K\xF6p {{count}} tickets",
          sf_ticket_description_one: "Betala med {{cost}} av dina tickets.\nDu har totalt {{count}} ticket.",
          sf_ticket_description_other: "Betala med {{cost}} av dina tickets.\nDu har totalt {{count}} tickets.",
          sf_ticket_description_zero: "Betala med {{cost}} tickets.\nDu har inga tickets just nu.",
          sf_ticket_description_disabled_one: "Du beh\xF6ver {{count}} tickets till.",
          sf_ticket_description_disabled_other: "Du beh\xF6ver {{count}} tickets till.",
          sf_ticket_description_disabled_zero: "Ticket.",
          sf_voucher: "V\xE4rdekod",
          swish: "Swish",
          swish_description: "Betala med Swish-appen p\xE5 mobilen.",
          swish_disabled: "Swish \xE4r just nu avst\xE4ngt hos oss p\xE5 grund av tekniska problem.",
          to_payment: "Till betalning",
          to_payment_button: "Till betalning",
          tv_adyen_pay_with_saved_card: "Betala med sparat kort",
          use_a_voucher: "Anv\xE4nd en v\xE4rdekod",
          valuecode: "V\xE4rdekod"
        },
        payment_method: { title: "Betalningsmetod" },
        payment_method_group_placeholder: "Alternativ f\xF6r betalning",
        purchase_not_allowed_in_app: {
          link: "L\xE4s mer om hur du g\xF6r f\xF6r att hyra",
          text: "Tyv\xE4rr kan du inte g\xF6ra k\xF6p i appen."
        },
        receipt: {
          app_description: "Med appen kan du \xE4ven se filmen p\xE5 din TV med Chromecast eller Airplay samt ladda ned och titta offline.",
          datetime: "Datum",
          discount: "Avdrag",
          fee: "Serviceavgift f\xF6r k\xF6p i app",
          legal_info: "N\xE4r du p\xE5b\xF6rjar streaming av en film, en film som ing\xE5r i ett paket, en s\xE4song av en serie, ett serieavsnitt eller f\xF6rbrukar en ticket, samtycker du till att SF Anytime p\xE5b\xF6rjar fullg\xF6rande av leverans, och du medger att du inte l\xE4ngre kan \xE5ngra ditt k\xF6p.",
          open_in_app: "\xD6ppna i appen",
          order_no: "Ordernummer",
          payment_method: "Betalningss\xE4tt",
          receipt_title: "Kvitto",
          save: "Spara kvitto (pdf)",
          smarttv_description: "Eller anv\xE4nd en av v\xE5ra Smart TV-appar p\xE5 Samsung, LG, AppleTV och Android TV.",
          sum: "Summa",
          thanks: "Tack f\xF6r att du valt att se film hos oss!",
          ticket_valid_to: "Tickets g\xE4ller t.o.m.",
          valid_to: "Giltigt till",
          vat: "Varav moms",
          voucher_legal_info: "Filmkoderna \xE4r giltiga i 6 m\xE5nader.",
          you_have_bought: "Du har k\xF6pt",
          you_have_rented: "Du har hyrt"
        },
        rental_duration: "Hyrperiod",
        select_placeholder: "V\xE4lj ",
        show_price_details: "Visa detaljer",
        subtitles: { no_subtitles: "Inga undertexter", title: "Undertexter" },
        ticket_prompt: {
          description: "K\xF6p tickets direkt i v\xE5r app eller fr\xE5n v\xE5r hemsida.\nAnv\xE4nd sedan dina tickets f\xF6r att byta mot en film eller serie.",
          not_enough_tickets: {
            title: "Du beh\xF6ver fler tickets f\xF6r att forts\xE4tta med denna betalningsmetod"
          },
          tickets_are_required: {
            title: "Du beh\xF6ver tickets f\xF6r att g\xF6ra ett k\xF6p i den h\xE4r appen"
          }
        },
        ticket_type: {
          description_one: "Giltiga i 3 \xE5r fr\xE5n ink\xF6psdatum och kan anv\xE4ndas i alla v\xE5ra appar.",
          description_other: "Giltiga i 3 \xE5r fr\xE5n ink\xF6psdatum och kan anv\xE4ndas i alla v\xE5ra appar.",
          description_valid_to: "En ticket \xE4r giltig i 3 \xE5r fr\xE5n datumet f\xF6r k\xF6p.",
          title_one: "1 ticket",
          title_other: "{{count}} tickets"
        },
        total_cost: "Totalbelopp inkl. moms",
        tvod: "Hyr",
        tvod_episode_duration: "Se klart p\xE5 48 timmar.",
        tvod_movie_duration: "Se klart p\xE5 48 timmar.",
        tvod_season_duration: "Se klart p\xE5 30 dagar.",
        update: {
          text: "Vi har sl\xE4ppt en f\xF6rb\xE4ttrad version av v\xE5r app och du m\xE5ste uppdatera din app f\xF6r att forts\xE4tta.",
          title: "Uppdatera appen"
        },
        value_code_applied_value: "{{percent}}% avdrag",
        value_code_apply: "Till\xE4mpa",
        value_code_invalid: "V\xE4rdekoden \xE4r inte giltig f\xF6r den h\xE4r titeln eller finns inte",
        value_code_placeholder: "Ange din kod",
        value_code_prompt: "Har du en v\xE4rdekod? Ange den h\xE4r",
        value_code_title: "V\xE4rdekod",
        value_code_used: "V\xE4rdekoden \xE4r redan anv\xE4nd.",
        voucher: {
          campaign: {
            "5_for_4": {
              description: "1 hyrsfilmskod mindre att betala f\xF6r.",
              label: "K\xF6p 5 betala f\xF6r 4"
            }
          },
          campaign_title: "Ett erbjudande till\xE4mpas",
          delivery_type: {
            my_email: "Till min e-post",
            recipient_email: "Till mottagare via e-post",
            recipient_sms: "Till mottagare via SMS",
            title: "Leveranss\xE4tt"
          },
          entitlement_type: {
            buy_description: "K\xF6pfilm, titta p\xE5 den n\xE4r du vill, s\xE5 m\xE5nga g\xE5nger du vill.",
            buy_text_price: "K\xF6p {{price}}",
            rent_text_description: "Se klart p\xE5 48 timmar.",
            rent_text_price: "Hyr {{price}}"
          },
          title: "K\xF6p filmkoder"
        },
        voucher_has_issue: "V\xE4nligen korrigera eller ta bort v\xE4rdekoden",
        voucher_not_valid: "V\xE4rdekoden \xE4r inte giltig med dina val",
        webview_timeout: "Det h\xE4r tar l\xE4ngre tid \xE4n vanligt...",
        you_have_bought: "Du har k\xF6pt",
        you_have_rented: "Du har hyrt",
        you_selected_to_buy: "Du har valt att k\xF6pa",
        you_selected_to_rent: "Du har valt att hyra"
      },
      emails: {
        content_notification: {
          reason_for_email_one: "Du f\xE5r det h\xE4r e-postmeddelandet eftersom du har valt att bevaka den h\xE4r titeln.",
          reason_for_email_other: "Du f\xE5r det h\xE4r e-postmeddelandet eftersom du har valt att bevaka dessa titlar.",
          subject_one: "Din bevakade titel finns nu tillg\xE4nglig hos oss",
          subject_other: "Dina bevakade titlar finns nu tillg\xE4ngliga"
        },
        footer: {
          cant_reply: "Det h\xE4r e-postmeddelandet kan inte besvaras. Om du har n\xE5gra fr\xE5gor,",
          copyright: "\xA9 2024 SF Anytime AB (org nr.  556748-2616, VAT SE556748261601)",
          please_contact_us_link: "kontakta oss h\xE4r",
          regards: "Med v\xE4nliga h\xE4lsningar",
          unsubscribe: "Avregistrera",
          web_link: "Webbversion"
        },
        gdpr_clean_up: {
          clarification: "*G\xE4ller enbart kontot som \xE4r registrerat p\xE5 mailadressen du f\xE5tt detta mail till. Har du registrerat flera konton med olika mailadresser hanteras dessa separat.",
          cta: "Hyr film",
          delete_account_text_one: "Vill du att ditt konto raderas beh\xF6ver du inte g\xF6ra n\xE5got, kontot raderas automatiskt om 1 dag. Du kan alltid skapa ett nytt kostnadsfritt konto med samma uppgifter om du vill ha ett konto hos oss igen i framtiden.",
          delete_account_text_other: "Vill du att ditt konto raderas beh\xF6ver du inte g\xF6ra n\xE5got, kontot raderas automatiskt om {{number}} dagar. Du kan alltid skapa ett nytt kostnadsfritt konto med samma uppgifter om du vill ha ett konto hos oss igen i framtiden.",
          intro_one: "Det var ett tag sedan du senast bes\xF6kte oss och p\xE5 grund av GDPR m\xE5ste vi radera ditt konto* om\xA01 dag.",
          intro_other: "Det var ett tag sedan du senast bes\xF6kte oss och p\xE5 grund av GDPR m\xE5ste vi radera ditt konto* om\xA0{{number}} dagar.",
          reason_for_email: "Du f\xE5r det h\xE4r e-postmeddelandet eftersom du har ett konto hos oss.",
          save_account_text: "Vill du beh\xE5lla ditt konto?\xA0Hyr en film med {{discount}}% rabatt med v\xE4rdekoden nedan!\xA0\xA0",
          subtitle_one: "Om 1 dag raderas ditt kostnadsfria konto\n",
          subtitle_other: "Om {{number}} dagar raderas ditt kostnadsfria konto\n",
          title: "P\xE5minnelse om ditt konto hos SF Anytime",
          voucher_info: "V\xE4rdekoden \xE4r personlig och g\xE4ller enbart p\xE5 detta kontot, kan endast anv\xE4ndas en g\xE5ng och rabatten g\xE4ller p\xE5 en hyrfilm upp till 59 kr. G\xE4ller\xA0inte\xA0f\xF6r bioaktuella filmer eller k\xF6pfilmer och kan inte kombineras med andra erbjudanden.",
          voucher_limitations: "G\xE4ller hyrfilm upp till 59 kr.",
          voucher_offer: "{{discount}}% rabatt p\xE5 hyrfilm"
        },
        header: {
          hello: "Hej",
          hello_we_miss_you: "Hejsan vi saknar dig!",
          looking_weird: "Ser mejlet konstigt ut? ",
          open_in_browser: "\xD6ppna i webbl\xE4saren"
        },
        new_user: {
          intro: "Vad roligt att du blivit medlem hos oss. Vi har de bredaste filmhyllorna i Norden fyllda\xA0 av allt fr\xE5n prisbel\xF6nta m\xE4sterverk till sk\xF6n underh\xE5llning. Vi tror att det finns en film f\xF6r varje tillf\xE4lle och ett tillf\xE4lle f\xF6r varje film. ",
          intro2: "Ta ett djupt andetag och ge dig in i samlingen.",
          title: "V\xE4lkommen till SF Anytime"
        },
        order_receipt: {
          find_your_playable_content: "Du hittar kvitton p\xE5 alla dina k\xF6p p\xE5 sidan Mina k\xF6p och ditt k\xF6pta inneh\xE5ll p\xE5 sidan Mitt inneh\xE5ll.",
          go_to_playable_content: "Spela upp",
          greeting_bundle: "Vi p\xE5 SF Anytime \xF6nskar dig en trevlig filmstund!",
          greeting_episode: "Vi p\xE5 SF Anytime \xF6nskar dig en trevligt seriestund!",
          greeting_movie: "Vi p\xE5 SF Anytime \xF6nskar dig en trevlig filmstund!",
          greeting_season: "Vi p\xE5 SF Anytime \xF6nskar dig en trevligt seriestund!",
          greeting_ticketpack: "Vi p\xE5 SF Anytime hoppas dina tickets kommer till god anv\xE4ndning!",
          greeting_voucher: "Vi p\xE5 SF Anytime hoppas filmkoderna kommer till god anv\xE4ndning!",
          more_about_vouchers: "L\xE4s mer om filmkoder",
          product_type_bundle_est_description: "Du kan se filmerna hur m\xE5nga g\xE5nger du vill.",
          product_type_episode_est_description: "Du kan se avsnittet s\xE5 m\xE5nga g\xE5nger du vill.",
          product_type_episode_tvod_description: "Se klart p\xE5 48 timmar.",
          product_type_movie_est_description: "Du kan se filmen hur m\xE5nga g\xE5nger du vill.",
          product_type_movie_tvod_description: "Se klart p\xE5 48 timmar.",
          product_type_season_est_description: "Du kan se series\xE4songen s\xE5 m\xE5nga g\xE5nger du vill.",
          product_type_season_tvod_description: "Se klart p\xE5 30 dagar.",
          product_type_ticketpack_est_description: "Dina tickets \xE4r giltiga tre \xE5r fr\xE5n ink\xF6psdatum och finns p\xE5 ditt konto. De fungerar som betalning n\xE4r du k\xF6per inneh\xE5ll ifr\xE5n n\xE5gon av v\xE5ra appar.\n",
          product_type_voucher__description: "Bifogat finner du dina koder. Spara koderna p\xE5 din dator eller skriva ut dem och ge bort som present.",
          reason_for_email: "Detta \xE4r en bekr\xE4ftelse p\xE5 ett k\xF6pt inneh\xE5ll med ett konto som anv\xE4nder den h\xE4r e-postadressen.",
          subject: "Kvitto fr\xE5n SF Anytime",
          thanks_bundle: "Tack f\xF6r att du valt att k\xF6pa ett filmpaket hos oss!",
          thanks_episode: "Tack f\xF6r att du valt att k\xF6pa ett serieavsnitt hos oss!",
          thanks_movie: "Tack f\xF6r att du valt att k\xF6pa film hos oss!",
          thanks_season: "Tack f\xF6r att du valt att k\xF6pa en series\xE4song hos oss!",
          thanks_ticketpack: "Tack f\xF6r att du valt att k\xF6pa tickets hos oss!",
          thanks_voucher: "Tack f\xF6r att du valt att k\xF6pa filmkoder hos oss!",
          title: "Kvitto"
        },
        reset_password: {
          intro: "Detta \xE4r en beg\xE4ran om \xE5terst\xE4llning av l\xF6senord f\xF6r kontot:",
          not_requested: "Om du inte bad oss att skicka email om att \xE5terst\xE4lla ditt l\xF6senord b\xF6r du \xE4ndra l\xF6senordet \xE4nd\xE5 p\xE5 sidan Mitt konto under Inst\xE4llningar f\xF6r att skydda kontot.",
          reset_password: "\xC5terst\xE4ll l\xF6senord",
          reset_password_link_text: "Klicka p\xE5 knappen nedan f\xF6r att v\xE4lja ett nytt l\xF6senord. L\xE4nken \xE4r giltig i 30 minuter.",
          subject: "\xC5terst\xE4llning av l\xF6senord",
          title: "\xC5terst\xE4llning av l\xF6senord"
        },
        voucher: {
          code_label: "Kod:",
          valid_to: "Giltig till och med:",
          your_personal_code: "Din personliga kod"
        }
      },
      genre: {
        "3d": "3D",
        action: "Action",
        adult: "Vuxen",
        adventure: "\xC4ventyr",
        animated: "Animerat",
        anime: "Anime",
        children: "Barn",
        "children-family": "Barn & Familj",
        "children-family (Copy)": "Barn & Familj",
        comedy: "Komedi",
        crime: "Deckare",
        cult: "Kult",
        danish: "Danska",
        documentary: "Dokument\xE4r",
        drama: "Drama",
        finnish: "Finska",
        horror: "Skr\xE4ck",
        "movie-gems": "Filmp\xE4rlor",
        music: "Musik",
        norwegian: "Norska",
        romance: "Romantik",
        "sci-fi": "Sci Fi",
        "sf-kids": "SF Kids",
        swedish: "Svenska",
        thriller: "Thriller",
        "tv-series": "TV-serie",
        war: "Krigsfilmer",
        western: "Western"
      },
      glossary: {
        abort: "Avbryt",
        activate: "Aktivera",
        add_to_my_list: "L\xE4gg till i Min lista",
        amount: "Antal",
        app_version: "App-version",
        available: "Tillg\xE4nglig",
        back_navigation: "Tillbaka",
        bought: "K\xF6pt",
        bought_badge: "K\xD6PT",
        brand: "SF Anytime",
        build_number: "Byggnummer",
        bundle: "Filmpaket",
        buy: "K\xF6p",
        buy_first_episode_from: "F\xF6rsta avsnittet fr\xE5n",
        buy_from: "Fr\xE5n",
        campaign: "Kampanj",
        cancel: "Avbryt",
        close_modal: "St\xE4ng",
        coming_soon: "Kommer snart",
        continue: "Forts\xE4tt",
        customer_service: "Support",
        download_from_AppStore: "H\xE4mta i App Store",
        download_from_GooglePlay: "Ladda ned p\xE5 Google Play",
        error: "Fel",
        fullscreen: "Helsk\xE4rm",
        hide_banner: "D\xF6lj",
        last_chance: "Sista chansen",
        loading: "Laddar...",
        mark_as_not_watched: "Markera som inte sedd",
        mark_as_watched: "Markera som sedd",
        minutes: "minuter",
        movie: "Film",
        mute: "Tyst",
        next_episode: "N\xE4sta avsnitt",
        no: "Nej",
        not_available: "Inte tillg\xE4nglig",
        off: "Av",
        on: "P\xE5",
        open: "\xD6ppna",
        open_in_browser_button: "\xD6ppna i webbl\xE4saren",
        password: "L\xF6senord",
        pause_button: "Pausa",
        play_button: "Spela",
        read_more: "L\xE4s mer",
        release: "Kommer",
        release_date: "Releasedatum",
        remote_control: "fj\xE4rrkontroll",
        remove_from_my_list: "Ta bort fr\xE5n Min lista",
        rented: "Hyrd",
        rented_badge: "HYRD",
        saved: "Sparat",
        search_results: "S\xF6kresultat",
        select: "V\xE4lj ",
        series: "Serie",
        sf_anytime: "SF Anytime",
        show: "Visa",
        show_all: "Visa alla",
        show_all_x: "Visa alla {{count}}",
        support_forum: "support.sfanytime.com",
        support_mail: "support@sfanytime.com",
        this_device: "Den h\xE4r enheten",
        tickets: "Tickets",
        trailer: "Trailer",
        unknown: "Ok\xE4nd",
        username: "Anv\xE4ndarnamn",
        warning: "Varning",
        x_results: {
          plural: "{{number}} resultat",
          singular: "{{number}} resultat"
        },
        yes: "Ja",
        "\u200Brented_for": "Hyrt i",
        "\u200Brented_to": "Hyrd till"
      },
      media: {
        age_rating: "\xC5ldersgr\xE4ns",
        audio: "Ljudsp\xE5r",
        bundle: {
          discount_text: "Spara {{percentage}}% ",
          movie_count: "{{count}} filmer"
        },
        continue_watching: {
          empty: "H\xE4r hittar du de filmer och serier som du inte sett klart \xE4n",
          title: "Forts\xE4tt titta"
        },
        crew: { actor: "Sk\xE5despelare", director: "Regi", title: "Medverkande" },
        download: {
          action_will_remove_active_download: "Den h\xE4r \xE5tg\xE4rden avbryter den aktiva nedladdningen.",
          cancel_download: "Avbryt nerladdning",
          delete_download: "Radera nerladdning",
          deleting: "Tar bort",
          deleting_download_description: "Tar bort nedladdning... Det kan ta ett tag.",
          downloaded: "Nerladdad",
          downloading: "Laddar ner",
          download_completed: "Nedladdningen har slutf\xF6rts",
          download_error: "Nedladdningsfel",
          list_title: "Nedladdad p\xE5 den h\xE4r enheten",
          logout_warning: "Dina nedladdningar raderas n\xE4r du loggar ut.",
          no_entitled_downloads: "Det finns nedladdningar p\xE5 den h\xE4r enheten men som inte tillh\xF6r ditt konto. Du kan fortfarande ta bort dem.",
          no_space_left_error: "Inget utrymme kvar p\xE5 enheten.",
          paused: "Pausad",
          pause_download: "Pausa nerladdning",
          pause_download_error: "Det gick inte att pausa nedladdningen, f\xF6rs\xF6k igen.",
          pick_quality: "V\xE4lj kvalitet att ladda ner. H\xF6gre kvalitet ger b\xE4ttre bild men tar upp mer lagringsutrymme.",
          pick_quality_high: "H\xF6g ",
          pick_quality_low: "L\xE5g ",
          pick_quality_max: "Max ",
          pick_quality_medium: "Medium  ",
          quality: "Kvalitet",
          queued: "K\xF6ad",
          removing: "Tar bort",
          removing_download: "Tar bort nedladdning",
          resume_download: "\xC5teruppta nerladdning",
          resume_download_error: "Det gick inte att \xE5teruppta nedladdningen, f\xF6rs\xF6k igen.",
          start_download: "Ladda ner",
          start_download_error: "Det gick inte att starta nedladdningen, f\xF6rs\xF6k igen.",
          try_to_download_again: "F\xF6rs\xF6k ladda ned inneh\xE5llet igen."
        },
        entitlement_type: "K\xF6palternativ",
        episode_rental_left: "Hyrtid kvar: {{rental_time_left}}",
        extra_material: { title: "Extramaterial" },
        from_countries: "Producerad i",
        has_access: "Tillg\xE5ng",
        keep_watching: "Forts\xE4tt titta",
        length: "L\xE4ngd",
        meta_description_movie: "Hyr och k\xF6p filmen {{ title }} med {{ actor1 }} och {{ actor2 }}. Streama denna {{ genre }}-film och andra filmer online p\xE5 {{ brand }}.",
        meta_description_series: "Hyr och k\xF6p serien {{ title }} med {{ actor1 }} och {{ actor2 }}. Streama denna {{ genre }}-serie och andra serier online p\xE5 {{ brand }}.",
        meta_title: "{{title}} \u2013 Hyr eller k\xF6p och streama hos SF Anytime",
        more_info_title: "Mer information",
        movie_bought_info: "K\xF6pt \u2013 Titta n\xE4r du vill, s\xE5 m\xE5nga g\xE5nger du vill",
        movie_rental_left: "Hyrtid kvar: {{rental_time_left}}",
        movie_rented_and_expires_at: "Hyrd \u2013 Hyrtiden g\xE5r ut {{rent_end_time}}",
        my_list: "Min lista",
        my_list_add_button: "Min lista",
        notify: "Bevaka",
        notifyme_button: "Bevaka",
        notifyme_button_active: "Bevakad",
        only_on: "Endast p\xE5",
        production_country: "Producerad i",
        purchase: { unavailable_button: "G\xE5r ej hyra" },
        release_date: "Kommer: {{dateString}}",
        series: {
          average_episode_length: "~{{length}}/avsnitt",
          buy_this_season: "K\xF6p den h\xE4r s\xE4songen",
          episodes: "Avsnitt",
          episode_count: "{{count}} avsnitt",
          next_episode: "N\xE4sta avsnitt",
          not_available: "Det h\xE4r inneh\xE5llet \xE4r inte tillg\xE4ngligt f\xF6r tillf\xE4llet",
          season: "S\xE4song",
          seasons: "S\xE4songer",
          season_release: "Kommer: {{dateString}}"
        },
        share_button: "Share",
        show_more: "Visa mer",
        similar_movies: "Liknande",
        similar_series: "Liknande",
        similar_tickets: "Andra tickets",
        similar_titles: "Liknande titlar",
        subtitles: "Undertexter",
        trailer_button: "Trailer",
        upcoming: "Kommande",
        watched: { title: "Sedda filmer" }
      },
      mymedia: {
        entitlements_empty_list: [
          "H\xE4r hittar du de filmer och serier som du hyrt eller k\xF6pt",
          "Titta p\xE5 din TV via Chromecast eller Airplay",
          "Ladda ned och titta offline - perfekt p\xE5 resan!"
        ],
        entitlements_title: "Mina filmer och serier",
        favorites_title: "Min lista",
        my_content_title: "Mitt inneh\xE5ll",
        my_list_empty_array: [
          "Du har inte sparat n\xE5gra filmer eller serier i Min lista \xE4n",
          "Smart n\xE4r du vill komma ih\xE5g dem till senare",
          "Leta efter den h\xE4r symbolen"
        ],
        my_list_title: "Min lista",
        saved_searches_title: "Mina bevakningar"
      },
      offer_redeemed: "Ser ut som att denna v\xE4rdekok redan har l\xF6sts in",
      push: {
        discountedtitle: {
          text: "En titel som du kanske gillar har nu ett l\xE4gre pris.",
          title: '"{{localtitle}}" har nu ett l\xE4gre pris'
        },
        multipletitlesmatchingsavedsearch: {
          text: '"{{localtitles}}" finns nu tillg\xE4ngliga.',
          title: "Dina bevakade titlar finns nu tillg\xE4ngliga"
        },
        newtitle: {
          text: "En titel som du kanske vill ha \xE4r nu tillg\xE4nglig.",
          title: '"{{localtitle}}" \xE4r nu tillg\xE4nglig'
        },
        singletitlematchingsavedsearch: {
          text: "Din bevakade titel finns nu tillg\xE4nglig hos oss.",
          title: '"{{localtitle}}" finns nu tillg\xE4nglig'
        },
        title_matching_saved_search: {
          "text _one": "Din bevakade titel finns nu tillg\xE4nglig hos oss.",
          "text _other": "Dina bevakade titlar finns nu tillg\xE4ngliga"
        }
      },
      search: {
        active_filters: "Aktiva filter",
        agelimit_years: "{{age}} \xE5r",
        did_you_mean: "Menade du?",
        empty_results: "Oj, det ser ut som din s\xF6kning inte returnerade n\xE5gra resultat.",
        empty_results_message: "Prova att rensa din s\xF6kning, \xE4ndra dina filter eller v\xE4lj n\xE5got fr\xE5n v\xE5ra popul\xE4ra s\xF6kresultat nedan.",
        facet: {
          actors: "Sk\xE5despelare",
          ageLimit: "\xC5ldersgr\xE4ns",
          directors: "Regiss\xF6rer",
          duration: "L\xE4ngd",
          genres: "Genrer",
          lowestPrice: "Pris",
          manifest: {
            audio: { tracks: { language: "Ljudsp\xE5r" } },
            subtitles: { language: "Undertexter" }
          },
          mediaTags: { name: "Media Taggar" },
          metaCollections: "\xC4mnen",
          productType: "Typ",
          ratings: { imdb: "IMDB-betyg" },
          releaseYear: "Utgivnings\xE5r"
        },
        filters_hits: "Tr\xE4ffar",
        filters_reset_button: "\xC5terst\xE4ll filter",
        filters_title: "Filter",
        from: "Fr\xE5n",
        history: "Senaste s\xF6kningar",
        input_placeholder: "S\xF6k efter filmer, serier eller medverkande",
        input_press_ok: "Tryck OK f\xF6r att \xF6ppna tangentbordet ",
        "list-view": "Listvy",
        "list-view-as-grid": "Rutn\xE4t",
        "list-view-as-list": "Lista",
        "load-more-button": "Ladda mer",
        not: "Ej {{ filter }}",
        number_of_seasons: {
          plural: "{{seasonCount}} s\xE4songer",
          singular: "{{seasonCount}} s\xE4song"
        },
        placeholder: "S\xF6k...",
        popular_search_terms: "Popul\xE4ra s\xF6kord:",
        recent_searches: "Senaste s\xF6kningar",
        remove: "Ta bort",
        reset_button: "\xC5terst\xE4lla",
        reset_refinements: "Rensa",
        reset_search: "B\xF6rja om",
        save: "Spara",
        saved: "Sparade",
        saved_searches: "Sparat",
        show_less: "Visa mindre",
        show_more: "Visa fler",
        show_previous: "Visa f\xF6reg\xE5ende",
        suggestions: "F\xF6rslag",
        to: "Till"
      },
      service_availability: {
        checkout: { title: "Driftst\xF6rningar" },
        generic: { title: "Driftst\xF6rningar" }
      },
      settings: {
        abort: "Avbryt",
        add_card: "L\xE4gg till betalkort",
        add_card_success: "Ditt kreditkort har sparats!",
        allow_mobile_download: {
          hint_active: "Till\xE5ter nerladdning med mobildata",
          hint_inactive: "Till\xE5ter bara nedladdning via Wi-Fi",
          title: "Till\xE5t nerladdningar med mobildata"
        },
        app_info_title: "Om appen",
        bonus: "Min bonus",
        buy_tickets_service_fee: {
          description: "Ingen serviceavgift tillkommer."
        },
        change_email: "Byt e-post",
        change_info_web_only_description: "G\xE5 till {{url}} med din mobil, surfplatta eller dator f\xF6r att redigera din information.",
        change_info_web_only_description_url: "www.sfanytime.com",
        change_info_web_only_title: "Att \xE4ndra kontouppgifter \xE4r bara m\xF6jligt p\xE5 webben",
        change_password: "\xC4ndra l\xF6senord",
        change_payment_method: "\xC4ndra betals\xE4tt",
        change_payment_web_only_title: "Att \xE4ndra betalningsmetod \xE4r endast m\xF6jligt p\xE5 webben",
        cookies_title: "Cookies",
        downloads_remove_all_confirm: "Radera alla nerladdade filer",
        downloads_remove_all_confirm_title: "Ta bort alla nerladdningar",
        downloads_remove_confirm: "Ta bort nerladdningen",
        downloads_title: "Nerladdat",
        download_delete_all: "Ta bort alla",
        download_delete_all_downloads: "Ta bort alla nerladdningar",
        download_no_downloads_text: "Du har \xE4nnu inte laddat ner n\xE5gra filmer.",
        download_receipt: "Ladda ner kvitto",
        download_total_size: "Totalt {{size}}",
        empty_purchases: {
          message: "H\xE4r kommer du kunna \xF6verblicka dina tidigare samt aktiva ink\xF6p. F\xF6r tillf\xE4llet har du dock inga ink\xF6p registrerade.",
          title: "Du har inga ink\xF6p registrerade"
        },
        help: "Hj\xE4lp",
        link: { to_device_settings: "G\xE5 till inst\xE4llningar" },
        manage_personal_information: "Mina personuppgifter",
        marketing: { title: "Uppdatera dina inst\xE4llningar f\xF6r e-post:" },
        my_account: {
          change_account_details: "\xC4ndra kontouppgifter",
          change_dibs_payment: "\xC4ndra betals\xE4tt f\xF6r Smart-TV",
          change_email_title: "\xC4ndra email",
          change_payment_title: "\xC4ndra betals\xE4tt",
          change_pw_title: "\xC4ndra l\xF6senord",
          customer_id: "Kundnummer:",
          portability_update_button: "Uppdatera betals\xE4tt",
          username: "Anv\xE4ndarnamn:"
        },
        my_account_title: "Mitt konto",
        my_profile: {
          address: "Adress",
          change_country: "\xC4ndra land",
          choose_country: "V\xE4lj land",
          city: "Stad",
          country: "Land",
          delete_account: "Ta bort konto",
          delete_account_confirmed: "Ditt konto har nu tagits bort.",
          delete_account_description: "Vill du att ditt konto, historik och all information om dig ska tas bort? Ett raderat konto kan inte \xE5terskapas, vilket inneb\xE4r att k\xF6pta filmer, serier och outnyttjade Tickets g\xE5r f\xF6rlorade. Bekr\xE4fta ditt val genom att ange l\xF6senordet i n\xE4sta steg.",
          download: "Ladda ner",
          email: "E-postadress",
          export_information: "Beg\xE4r min information",
          export_information_description: "Vill du veta mer om vilken information vi har sparad om dig? Beg\xE4r din information enkelt och s\xE4kert h\xE4r. Du kan med f\xF6rdel anv\xE4nda n\xE5got program (File Viewer Plus, Altova XMLSpy, Microsoft Notepad,  Microsoft WordPad, Anteckningar++ eller Mozilla Firefox) f\xF6r att l\xE4sa .json-filen.",
          export_information_loading_message: "Det kan ta en stund beroende p\xE5 m\xE4ngden data som finns.",
          export_information_loading_title: "V\xE4nligen v\xE4nta, vi h\xE4mtar dina uppgifter fr\xE5n v\xE5rt system",
          export_information_preview_title: "F\xF6rhandsgranskning av din dataexport",
          first_name: "F\xF6rnamn",
          last_name: "Efternamn",
          myinfo_title: "Registerutdrag personuppgifter",
          password: "L\xF6senord",
          phone: "Mobilnummer",
          short_username: "Anv\xE4ndarnamn",
          short_username_description: "Du kan v\xE4lja ett kortare anv\xE4ndarnamn som f\xF6renklar inloggningen till v\xE5ra SmartTV-appar.",
          zipcode: "Postnummer"
        },
        newsletter_consent: {
          agree: "Ja tack",
          disagree: "Nej tack",
          title: "Vi vill g\xE4rna h\xE5lla kontakten med dig"
        },
        notifications: {
          allow_notifications: "Till\xE5t aviseringar",
          controlled_from_settings_phone: "Styrs fr\xE5n inst\xE4llningarna f\xF6r telefonen",
          description: "Med notifikationer p\xE5 kommer du att kunna f\xE5 information om nya utg\xE5vor, rekommendationer, kampanjer eller appfunktioner.",
          dont_miss_new_releases: "Missa inga nya sl\xE4pp",
          enable_notifications: "Aktivera aviseringar",
          new_content: "Nytt inneh\xE5ll finns tillg\xE4ngligt",
          notification_settings_in_phone: "Dina notiser f\xF6r SF anytime \xE4r",
          permission_description: "Med notiser p\xE5 kommer du att kunna f\xE5 information om produktutgivningar, rekommendationer och kampanjer.",
          title: "Notifikationer",
          to_device_settings: "G\xE5 till inst\xE4llningar"
        },
        notification_title: "Notifikationer",
        no_saved_payment_methods: "Det finns inga sparade betalkort.\nHar du tidigare haft ett sparat kort f\xF6r v\xE5ra gamla TV-appar beh\xF6ver du l\xE4gga till ett p\xE5 nytt.",
        overview: "\xD6versikt",
        payment_card_tempcharge_disclaimer: "N\xE4r du registrerar ett kreditkort kommer 2 SEK reserveras p\xE5 ditt kort. Detta g\xF6rs f\xF6r att se om kortet \xE4r giltigt. Beloppet kommer aldrig att debiteras, men kan ligga som ett reserverat belopp i n\xE5gra dagar beroende p\xE5 bank.",
        payment_method_remove_confirm: "\xC4r du s\xE4ker p\xE5 att du vill ta bort betalningsmetoden?",
        payment_method_remove_failed: "Det gick inte att ta bort betalningsmetoden",
        payment_method_remove_successful: "Betalningsmetoden \xE4r nu borttagen",
        portability_title: "Titta inom EU",
        portability_unverified: "Overifierad",
        portability_unverified_text: "Du kan titta p\xE5 SF Anytime inom hela EU/EES om du bekr\xE4ftar din hemvist. Genom att uppdatera din betalningsinformation s\xE5 f\xE5r vi den informationen och du kan d\xE4refter njuta av film \xE4ven n\xE4r du \xE4r p\xE5 resande fot inom EU.",
        portability_verified: "Verifierad",
        portability_verified_disclaimer: "N\xE4r du uppdaterar din betalningsinformation tillg\xE4ngligg\xF6rs den informationen f\xF6r oss.",
        portability_verified_text: "Vi har verifierat din hemvist, s\xE5 nu kan du njuta av film n\xE4r du \xE4r p\xE5 resande fot inom EU.",
        purchases: "Mina ink\xF6p",
        recent_purchases: "Senaste k\xF6pen",
        recent_rentals: "Hyrda titlar",
        remove_card: "Ta bort kort",
        remove_payment_method: "Ta bort",
        review_question: "Gillar du appen?",
        save: " Spara \xE4ndringar",
        saved_card: "Sparat betalkort",
        saved_payment_methods: "Sparade betals\xE4tt",
        show_more: "Visa mer",
        tickets: {
          bought_tickets: "K\xF6pta tickets",
          buy_tickets: "K\xF6p tickets",
          disclaimer: "Du kan k\xF6pa eller f\xE5 tickets som fungerar som betalning n\xE4r du k\xF6per inneh\xE5ll p\xE5 n\xE5gon av SF Anytimes appar. Anv\xE4nd dem som betalning i v\xE5ra mobilappar f\xF6r iOS och Android. Giltiga tickets kommer sedan att synas och kan anv\xE4ndas som betalalternativ i kassan.\n \nEn ticket motsvarar ett serieavsnitt och upp mot tjugo tickets t\xE4cker de flesta k\xF6p av v\xE5rt filmutbud.",
          total_title: "{{ count }} x Tickets",
          valid: "Giltiga"
        },
        tickets_and_vouchers: "Mina tickets & kuponger",
        tickets_title: "Mina tickets",
        update: {
          confirm: "Uppdatera",
          text: "Det finns en b\xE4ttre version av appen!"
        },
        user_offline_goto_downloads: "G\xE5 till Mina nerladdningar",
        user_offline_navigation: "Du verkar vara offline",
        "\u200Bnew_\u200Bemail": "Ny e-postadress"
      },
      store: {
        feature_1_heading: "Streama de senaste filmerna",
        feature_1_text: "De senaste storfilmerna, klassikerna och allt d\xE4remellan",
        feature_2_heading: "Hyr eller k\xF6p",
        feature_2_text: "Varje film och serie \xE4r nedladdningsbar, titta var du vill",
        feature_3_heading: "Kul f\xF6r hela familjen",
        feature_3_text: "Tr\xE4ffa m\xE5nga v\xE4nner fr\xE5n Astrid Lindgren",
        take_over: {
          price: "169kr",
          text: "Oscar\xAE-vinnarna George Clooney och Julia Roberts \xE5terf\xF6renas p\xE5 vita duken som ett skilt par som ov\xE4ntat hamnar p\xE5 ett gemensamt uppdrag: att hindra sin f\xF6r\xE4lskade dotter fr\xE5n att g\xF6ra samma misstag som de en g\xE5ng gjorde. Ticket to Paradise \xE4r en romantisk komedi om att pl\xF6tsligt f\xE5 en ov\xE4ntad andra chans."
        },
        take_over_child: { price: "149kr" },
        toplist: { buy: "K\xF6ptoppen", rent: "Hyrtoppen", series: "Serietoppen" },
        usp_1: "Senaste filmerna utan n\xE5got abonnemang",
        usp_2: "Betala endast f\xF6r det du ser",
        usp_3: "Streama direkt eller se offline",
        usp_4: "Ett av nordens bredaste utbud"
      },
      tag: {
        collection: "Filmpaket",
        in_collection: "Del av filmpaket",
        is_collection: "Filmpaket"
      },
      test: {
        test: { testing_for_fun: "Testa f\xF6r skojs skull f\xF6r att det \xE4r kul." }
      },
      Text: "Fr\xE5n",
      "Text 2": "160 kr",
      value_prop: {
        call_to_action: "Kom ig\xE5ng",
        title: "Ny, gammal, klassiker. V\xE4lj din favorit bland tusentals titlar."
      },
      voucher_not_valid_for_producttype_bundle: "Den h\xE4r v\xE4rdekoden kan inte anv\xE4ndas f\xF6r paketerbjudanden.",
      voucher_not_valid_for_producttype_episode: "Den h\xE4r v\xE4rdekoden kan inte anv\xE4ndas f\xF6r avsnitt.",
      voucher_not_valid_for_producttype_movie: "Den h\xE4r v\xE4rdekoden kan inte anv\xE4ndas f\xF6r filmer.",
      voucher_not_valid_for_producttype_season: "Den h\xE4r v\xE4rdekoden kan inte anv\xE4ndas f\xF6r serier."
    }
  }
};
var translations_default = translations;

// src/~react-testing/mocks/queries/localization.ts
var localization = ({
  locale = "sv" /* sv */,
  brand = "SFAnytime" /* SFAnytime */
}) => {
  const items = {
    genre: {
      "sci-fi": "Sci Fi"
    }
  };
  return {
    __typename: "Localization",
    id: createLocalizationId({ locale, brand, items }),
    items,
    locale: "sv"
  };
};
function localizationQuery({
  deviceType = "UnknownType" /* UnknownType */,
  locale = "sv" /* sv */,
  fallbackLocale: fallbackLocale2 = "en" /* en */,
  brand = "SFAnytime" /* SFAnytime */
} = {}) {
  return {
    request: {
      query: GQL_GET_LOCALIZATION_default,
      variables: {
        locale,
        deviceType,
        fallbackLocale: fallbackLocale2,
        brand
      }
    },
    result: {
      data: {
        response: {
          __typename: "Localization",
          locale: "sv",
          id: "Localization:sv",
          deviceType,
          brand,
          fallbackLocale: fallbackLocale2,
          items: translations_default.en.items
        },
        fallback: {
          __typename: "Localization",
          id: "Localization:en",
          locale: "en",
          items: translations_default.en.items
        }
      }
    }
  };
}

// src/~react-testing/mocks/media/movie.ts
var slug = "mission-impossible-fallout";
var normalMovie = {
  id: createMediaId({ __typename: "Movie", slug }),
  slug,
  alternativeSlugs: [],
  display: {
    __typename: "Display",
    title: "Mission: Impossible - Fallout",
    originalTitle: "Mission: Impossible - Fallout",
    caption: null
  },
  displayableAsset: {
    id: "DisplayableInCollectionWithCover:id",
    __typename: "DisplayableInCollectionWithCover",
    cover: "cover.jpg"
  },
  longSummary: "Tv\xE5 \xE5r efter att Ethan Hunt f\xE5ngade Solomon Lane, har resterna av Syndikatet bildat en ny organisation, kallad Apostlarna. Under ledning av den mystiska John Lark planerar organisationen att komma \xF6ver plutonium f\xF6r att bygga k\xE4rnvapen. Nu \xE4r det upp till Ethan Hunt och hans team att stoppa dem och f\xF6rhindra en katastrof.",
  lowestPriceString: "39 kr",
  genres: ["\xC4ventyr", "Action", "Thriller"],
  localization: localization({}),
  duration: 147,
  durationStringShort: "1 t 35 m",
  durationString: "1 tim 35 min",
  durationStringLong: "1 timme 35 minuter",
  isComing: false,
  comingAt: 0,
  comingAtString: null,
  isPurchasable: true,
  releaseYear: 2018,
  ageLimit: 15,
  ageLimitString: "15+",
  ageLimitStringLong: "15 \xE5r",
  productionCountries: ["CN", "US"],
  imdbId: "tt4912910",
  url: "https://www.sfanytime.com/sv/movie/mission-impossible-fallout",
  mediaImages: [
    "https://img-cdn.sfanytime.com/MEDIAM/93f7df18-0ffb-4c44-96d3-a96c00c43b30_MEDIAM_2c20af3e-71b2-4d06-8a83-e254ecf75d06.jpg?w=1125&fm=pjpg&s=125b3bd12a23726cf3a34026e519ffde",
    "https://img-cdn.sfanytime.com/MEDIAM/93f7df18-0ffb-4c44-96d3-a96c00c43b30_MEDIAM_5cba19a2-c64d-46a0-b699-387a42f55271.jpg?w=1125&fm=pjpg&s=b2ae0756bff5caec6545d60b7e207d1a",
    "https://img-cdn.sfanytime.com/MEDIAM/93f7df18-0ffb-4c44-96d3-a96c00c43b30_MEDIAM_9c4cc4cb-f693-417a-a057-0dc0166d20d8.jpg?w=1125&fm=pjpg&s=76800b8c7e8c07db0b633065afeb158e",
    "https://img-cdn.sfanytime.com/MEDIAM/93f7df18-0ffb-4c44-96d3-a96c00c43b30_MEDIAM_a37468e4-5fd6-4f0c-9e67-a599834d5bd9.jpg?w=1125&fm=pjpg&s=172cc39963d5ba271b2f1df415736669",
    "https://img-cdn.sfanytime.com/MEDIAM/93f7df18-0ffb-4c44-96d3-a96c00c43b30_MEDIAM_9b610dc0-3b00-4112-866e-bedd3897a48a.jpg?w=1125&fm=pjpg&s=661d61dfb59edc659de2353d88a59318",
    "https://img-cdn.sfanytime.com/MEDIAM/93f7df18-0ffb-4c44-96d3-a96c00c43b30_MEDIAM_4c72f485-cc09-4c86-a63a-3186a6b16994.jpg?w=1125&fm=pjpg&s=a210ac022ef0498418d259eeaf9424a3",
    "https://img-cdn.sfanytime.com/MEDIAM/93f7df18-0ffb-4c44-96d3-a96c00c43b30_MEDIAM_769006ca-bd8e-4c99-a1fc-1fb6bb6b005f.jpg?w=1125&fm=pjpg&s=4a15d08f6de521413cb516f2d78a91a1"
  ],
  subtitles: [
    { language: "sv", __typename: "Subtitle" },
    { language: "fi", __typename: "Subtitle" },
    { language: "no", __typename: "Subtitle" }
  ],
  audio: [
    {
      __typename: "Audio",
      tracks: [
        {
          language: "en",
          sound: [
            {
              channels: "2.0",
              format: "AAC",
              __typename: "AudioTrackSound"
            }
          ],
          __typename: "AudioTrack"
        }
      ]
    }
  ],
  tags: [
    {
      name: "AnytimeExclusive",
      id: "Tag:AnytimeExclusive",
      zones: [],
      priority: 0,
      __typename: "Tag",
      display: {
        __typename: "AnytimeExclusiveDisplay",
        anytimeExclusive: true
      }
    }
  ],
  similar: [
    {
      id: "Movie:the-jackal-1997",
      slug: "the-jackal-1997",
      displayableAsset: {
        id: "DisplayableInCollectionWithCover:id",
        __typename: "DisplayableInCollectionWithCover",
        cover: "cover.jpg"
      },
      display: {
        __typename: "Display",
        title: "The Jackal",
        originalTitle: "The Jackal",
        caption: null
      },
      __typename: "Movie",
      linkTarget: null,
      tags: []
    },
    {
      id: "Movie:xxx-return-of-xander-cage",
      slug: "xxx-return-of-xander-cage",
      displayableAsset: {
        id: "DisplayableInCollectionWithCover:id",
        __typename: "DisplayableInCollectionWithCover",
        cover: "cover.jpg"
      },
      display: {
        __typename: "Display",
        title: "XXX: Return of Xander Cage",
        originalTitle: "XXX: Return of Xander Cage",
        caption: null
      },
      __typename: "Movie",
      tags: [],
      linkTarget: null
    }
  ],
  ratings: {
    imdb: 7.8,
    __typename: "Ratings"
  },
  manifests: {
    trailers: {
      default: {
        dash: "https://vod-dash.sfanytime.com/trailers/30500/30828/30828.ism/Manifest.mpd",
        hls: "https://vod-hls.sfanytime.com/trailers/30500/30828/30828.ism/Manifest.m3u8",
        smooth: "https://vod-smooth.sfanytime.com/trailers/30500/30828/30828.ism/Manifest.m3u8",
        __typename: "ManifestUrls"
      },
      dash: "https://vod-dash.sfanytime.com/trailers/30500/30828/30828.ism/Manifest.mpd",
      hls: "https://vod-hls.sfanytime.com/trailers/30500/30828/30828.ism/Manifest.m3u8",
      smooth: "https://vod-smooth.sfanytime.com/trailers/30500/30828/30828.ism/Manifest.m3u8",
      __typename: "Manifest"
    },
    __typename: "MovieManifests"
  },
  directors: [
    {
      id: "Cast:Christopher McQuarrie",
      name: "Christopher McQuarrie",
      avatar: "https://img-cdn.sfanytime.com/CAST/367b5380-2e04-4d2e-bac5-a19a00dc341b.jpg?w=128&h=128&fm=png&facepad=10&fit=facearea&mask=ellipse&ar=1&con=10&s=c78fbbbfb9790607e2456c2b3e28ad54",
      __typename: "Director"
    }
  ],
  actors: [
    {
      id: "Cast:Tom Cruise",
      name: "Tom Cruise",
      avatar: "https://img-cdn.sfanytime.com/CAST/4f89f24f-8269-4eab-adfd-a0b600aa9a91.jpg?w=128&h=128&fm=png&facepad=10&fit=facearea&mask=ellipse&ar=1&con=10&s=239b591267d5974c53de12365805570b",
      __typename: "Actor"
    },
    {
      id: "Cast:Henry Cavill",
      name: "Henry Cavill",
      avatar: "https://img-cdn.sfanytime.com/CAST/e77414f1-2625-4b46-8147-a24900ffed3b.jpg?w=128&h=128&fm=png&facepad=10&fit=facearea&mask=ellipse&ar=1&con=10&s=74ebbb285c80a15ffdf92e699c751110",
      __typename: "Actor"
    },
    {
      id: "Cast:Ving Rhames",
      name: "Ving Rhames",
      avatar: "https://img-cdn.sfanytime.com/CAST/1e23773c-7e71-437b-b1b5-a0b600aaa0df.jpg?w=128&h=128&fm=png&facepad=10&fit=facearea&mask=ellipse&ar=1&con=10&s=7ca92b69e3ddced63250daea3009b4c5",
      __typename: "Actor"
    }
  ],
  __typename: "Movie",
  linkTarget: null
};

// src/~react-testing/mocks/media/series.ts
var slug2 = "series-the-walking-dead";
var __typename = "Series";
var normalSeries = {
  __typename,
  linkTarget: null,
  comingAt: null,
  comingAtString: null,
  slug: slug2,
  alternativeSlugs: [],
  id: createMediaId({ __typename, slug: slug2 }),
  localization: localization({}),
  display: {
    __typename: "Display",
    originalTitle: "The Walking Dead",
    title: "The Walking Dead",
    caption: null
  },
  displayableAsset: {
    id: "DisplayableInCollectionWithCover:id",
    __typename: "DisplayableInCollectionWithCover",
    cover: "cover.jpg"
  },
  mediaImages: [
    "https://img-cdn.sfanytime.com/MEDIAM/3bb265a7-d036-46f6-ab2d-a39a011dcbb1_MEDIAM_77cff3ad-df0d-4a8e-a871-ecc0903238f2.jpg?w=1125&fm=pjpg&s=a8f9dcb672dd6a0384d84aed0ca7ba35"
  ],
  subtitles: [
    { language: "sv", __typename: "Subtitle" },
    { language: "fi", __typename: "Subtitle" },
    { language: "no", __typename: "Subtitle" }
  ],
  url: "https://www.sfanytime.com/sv/series/the-walking-dead",
  audio: [
    {
      tracks: [
        {
          language: "en",
          sound: [
            {
              channels: "2.0",
              format: "AAC",
              __typename: "AudioTrackSound"
            }
          ],
          __typename: "AudioTrack"
        }
      ],
      __typename: "Audio"
    }
  ],
  tags: [
    {
      id: "Tag:AnytimeExclusive",
      zones: [],
      priority: 0,
      name: "AnytimeExclusive",
      __typename: "Tag",
      display: {
        __typename: "AnytimeExclusiveDisplay",
        anytimeExclusive: true
      }
    }
  ],
  similar: [
    {
      id: "Series:series-fear-the-walking-dead",
      slug: "series-fear-the-walking-dead",
      displayableAsset: {
        id: "DisplayableInCollectionWithCover:id",
        __typename: "DisplayableInCollectionWithCover",
        cover: "cover.jpg"
      },
      display: {
        __typename: "Display",
        title: "Fear the Walking Dead",
        originalTitle: "Fear the Walking Dead",
        caption: null
      },
      __typename: "Series",
      linkTarget: null,
      tags: []
    },
    {
      id: "Series:i-am-legend",
      slug: "i-am-legend",
      displayableAsset: {
        id: "DisplayableInCollectionWithCover:id",
        __typename: "DisplayableInCollectionWithCover",
        cover: "cover.jpg"
      },
      display: {
        __typename: "Display",
        title: "I Am Legend",
        originalTitle: "I Am Legend",
        caption: null
      },
      __typename: "Series",
      linkTarget: null,
      tags: []
    },
    {
      id: "Series:28-days-later",
      slug: "28-days-later",
      displayableAsset: {
        id: "DisplayableInCollectionWithCover:id",
        __typename: "DisplayableInCollectionWithCover",
        cover: "cover.jpg"
      },
      display: {
        __typename: "Display",
        title: "28 dagar senare",
        originalTitle: "28 dagar senare",
        caption: null
      },
      __typename: "Series",
      linkTarget: null,
      tags: []
    }
  ],
  firstReleaseYear: 2010,
  lastReleaseYear: 2018,
  formattedReleaseRange: "2010 - 2018",
  imdbId: "tt1520211",
  episodeDuration: 43,
  episodeDurationStringShort: "43 m",
  episodeDurationString: "43 min",
  episodeDurationStringLong: "43 minuter",
  productionCountries: ["US"],
  ageLimit: 15,
  ageLimitString: "15+",
  ageLimitStringLong: "15 \xE5r",
  genres: ["TV-serie", "Skr\xE4ck", "Drama", "Thriller", "Sci Fi"],
  longSummary: 'En amerikansk postapokalyptisk rysare som baserats p\xE5 serietidningen \u201CThe walking dead\u201D av Robert Kirkman, Tony Moore och Charlie Adlard. Serien kretsar kring en liten grupp m\xE4nniskor som leds av sheriffen Rick Grimes, efter att en zombieepidemi har lamslagit USA.\nSerien nominerades f\xF6r "Best television series" i Golden Globe 2010, och vann en Emmy 2011 f\xF6r "Outstanding prosthetic makeup".',
  firstEpisode: {
    __typename: "Episode",
    abbreviation: "E00",
    id: "Episode:series-the-walking-dead-s01e01",
    slug: "series-the-walking-dead-s01e01",
    seasonNo: 1,
    episodeNo: 1,
    isPurchasable: true,
    comingAt: 20191111,
    lowestPriceString: "9 kr"
  },
  ratings: {
    __typename: "Ratings",
    imdb: 8.3
  },
  seasons: [
    {
      id: "Season:series-the-walking-dead-s01",
      slug: "series-the-walking-dead-s01",
      lowestPriceString: "49 kr",
      seasonNo: 1,
      isPurchasable: true,
      comingAt: null,
      __typename: "Season",
      abbreviation: "S01",
      tags: [],
      episodes: [
        {
          id: "Episode:series-the-walking-dead-s01e01",
          slug: "series-the-walking-dead-s01e01",
          display: {
            __typename: "Display",
            caption: null,
            title: "The Walking Dead S01E01",
            originalTitle: "The Walking Dead S01E01"
          },
          episodeNo: 1,
          lowestPriceString: "9 kr",
          mediaImages: [],
          isPurchasable: true,
          duration: 0,
          displayableAsset: {
            id: "DisplayableInCollectionWithCover:id",
            __typename: "DisplayableInCollectionWithCover",
            cover: "cover.jpg"
          },
          __typename: "Episode",
          abbreviation: "E00",
          tags: [],
          longSummary: null,
          subtitles: [],
          audio: null
        },
        {
          slug: "series-the-walking-dead-s01e02",
          id: "Episode:series-the-walking-dead-s01e02",
          display: {
            __typename: "Display",
            caption: null,
            title: "The Walking Dead S01E02",
            originalTitle: "The Walking Dead S01E02"
          },
          episodeNo: 2,
          lowestPriceString: "9 kr",
          mediaImages: [],
          isPurchasable: false,
          duration: 0,
          displayableAsset: {
            id: "DisplayableInCollectionWithCover:id",
            __typename: "DisplayableInCollectionWithCover",
            cover: "cover.jpg"
          },
          __typename: "Episode",
          abbreviation: "E00",
          tags: [],
          longSummary: null,
          subtitles: [],
          audio: null
        }
      ]
    },
    {
      slug: "series-the-walking-dead-s02",
      id: "Season:series-the-walking-dead-s02",
      abbreviation: "S02",
      lowestPriceString: "49 kr",
      seasonNo: 2,
      isPurchasable: true,
      comingAt: null,
      __typename: "Season",
      tags: [],
      episodes: [
        {
          slug: "series-the-walking-dead-s02e01",
          id: "Episode:series-the-walking-dead-s02e01",
          display: {
            __typename: "Display",
            title: "The Walking Dead S02E01",
            originalTitle: "The Walking Dead S02E01",
            caption: null
          },
          episodeNo: 1,
          lowestPriceString: "9 kr",
          mediaImages: [],
          isPurchasable: true,
          duration: 0,
          displayableAsset: {
            id: "DisplayableInCollectionWithCover:id",
            __typename: "DisplayableInCollectionWithCover",
            cover: "cover.jpg"
          },
          __typename: "Episode",
          abbreviation: "E00",
          tags: [],
          longSummary: null,
          subtitles: [],
          audio: null
        },
        {
          slug: "series-the-walking-dead-s02e02",
          id: "Episode:series-the-walking-dead-s02e02",
          display: {
            title: "The Walking Dead S02E02",
            originalTitle: "The Walking Dead S02E02",
            caption: null,
            __typename: "Display"
          },
          episodeNo: 2,
          lowestPriceString: "9 kr",
          mediaImages: [],
          isPurchasable: false,
          duration: 0,
          displayableAsset: {
            id: "DisplayableInCollectionWithCover:id",
            __typename: "DisplayableInCollectionWithCover",
            cover: "cover.jpg"
          },
          __typename: "Episode",
          abbreviation: "E00",
          tags: [],
          longSummary: null,
          subtitles: [],
          audio: null
        }
      ]
    }
  ],
  actors: [
    {
      id: "Cast:Jon Bernthal",
      name: "Jon Bernthal",
      avatar: "https://img-cdn.sfanytime.com/CAST/711cb5f9-7a37-414e-af04-a0b600ab080e.jpg?w=128&fm=pjpg&s=7aab199f7276ffa77306545525f9615d",
      __typename: "Actor"
    },
    {
      id: "Cast:Andrew Lincoln",
      name: "Andrew Lincoln",
      avatar: "https://img-cdn.sfanytime.com/CAST/7eb64657-f9b3-4a3c-a5c4-a0b600ab1f20.jpg?w=128&fm=pjpg&s=75473a08d85ce44dd462c86ddd8a9679",
      __typename: "Actor"
    },
    {
      id: "Cast:Laurie Holden",
      name: "Laurie Holden",
      avatar: "https://img-cdn.sfanytime.com/CAST/e7aa086c-3561-48e5-a8b0-a0b600aae98f.jpg?w=128&fm=pjpg&s=29c62a62740f981fa9391181fec643e8",
      __typename: "Actor"
    },
    {
      id: "Cast:Sarah Wayne Callies",
      name: "Sarah Wayne Callies",
      avatar: "https://img-cdn.sfanytime.com/CAST/917443ec-9e1b-4f0e-9a5e-a0da0097d04e.jpg?w=128&fm=pjpg&s=e77729a250fdfc61b5716a4ee2770ef3",
      __typename: "Actor"
    },
    {
      id: "Cast:Steven Yeun",
      name: "Steven Yeun",
      avatar: "https://img-cdn.sfanytime.com/CAST/2e6ac274-e229-4599-9274-a38900a7f053.jpg?w=128&fm=pjpg&s=bf5ad295c65ce5663bb00a7942ea0590",
      __typename: "Actor"
    },
    {
      id: "Cast:Chandler Riggs",
      name: "Chandler Riggs",
      avatar: "https://img-cdn.sfanytime.com/CAST/24e85557-4ebb-42e8-bec9-a38900a8118d.jpg?w=128&fm=pjpg&s=7688fc8202e3f28a6aa4c0ae7821df16",
      __typename: "Actor"
    },
    {
      id: "Cast:Norman Reedus",
      name: "Norman Reedus",
      avatar: "https://img-cdn.sfanytime.com/CAST/7b1fcac3-57fa-4881-af3c-a0b600aab25e.jpg?w=128&fm=pjpg&s=584f357c78e0f04a03f00bffc322bdcf",
      __typename: "Actor"
    },
    {
      id: "Cast:Tricia Brook",
      name: "Tricia Brook",
      avatar: null,
      __typename: "Actor"
    },
    {
      id: "Cast:Lauren Cohan",
      name: "Lauren Cohan",
      avatar: "https://img-cdn.sfanytime.com/CAST/f6d9ba18-db9c-4217-b34f-a0ed008a960a.jpg?w=128&fm=pjpg&s=54da67f5cb807116a7e8b461eacbb650",
      __typename: "Actor"
    },
    {
      id: "Cast:Melissa McBride",
      name: "Melissa McBride",
      avatar: "https://img-cdn.sfanytime.com/CAST/e882a21f-ba51-4c93-843f-a67b00b4a952.jpg?w=128&fm=pjpg&s=a8442eb29c91ad049addd920cc9e126d",
      __typename: "Actor"
    },
    {
      id: "Cast:Jeffrey Dean Morgan",
      name: "Jeffrey Dean Morgan",
      avatar: "https://img-cdn.sfanytime.com/CAST/88484927-a7c4-43b8-8183-a0b600aae046.jpg?w=128&fm=pjpg&s=97132417bad368dbb8c611ed818403e9",
      __typename: "Actor"
    }
  ],
  directors: [
    {
      id: "Cast:Frank Darabont",
      name: "Frank Darabont",
      avatar: "https://img-cdn.sfanytime.com/CAST/56bfd465-eee9-434e-b1dd-a0b600aaba28.jpg?w=128&fm=pjpg&s=7abd0b7b558afc517603e546047b2674",
      __typename: "Director"
    },
    {
      id: "Cast:Ernest Dickerson",
      name: "Ernest Dickerson",
      avatar: "https://img-cdn.sfanytime.com/CAST/54ad9b06-0677-4ac6-aa0a-a0b600aa9cf6.jpg?w=128&fm=pjpg&s=9b5094988cda3a7a2465b73336560143",
      __typename: "Director"
    },
    {
      id: "Cast:Guy Ferland",
      name: "Guy Ferland",
      avatar: "https://img-cdn.sfanytime.com/CAST/89681a14-99f0-448e-8bd9-a0b600aaaf06.jpg?w=128&fm=pjpg&s=38df313fc7ae3000a2bd595f22cc23eb",
      __typename: "Director"
    },
    {
      id: "Cast:Greg Nicotero",
      name: "Greg Nicotero",
      avatar: "https://img-cdn.sfanytime.com/CAST/d27972e9-5bf8-4d28-94c1-a4fd0122ff78.jpg?w=128&fm=pjpg&s=3d21d0a692dcfbe9fbe5c4eca5b2bddf",
      __typename: "Director"
    },
    {
      id: "Cast:David Boyd",
      name: "David Boyd",
      avatar: "https://img-cdn.sfanytime.com/CAST/8de9dd2f-cf3f-4441-a37e-a2c3015f42f8.jpg?w=128&fm=pjpg&s=8d039e9d15e546aef51bf9f8fe301d73",
      __typename: "Director"
    },
    {
      id: "Cast:Jennifer Lynch",
      name: "Jennifer Lynch",
      avatar: null,
      __typename: "Director"
    },
    {
      id: "Cast:Kari Skogland",
      name: "Kari Skogland",
      avatar: "https://img-cdn.sfanytime.com/CAST/b05f7ff8-e2ce-415d-be7d-a0b600aaf610.jpg?w=128&fm=pjpg&s=245757592c63fdab35bdb4c6d65ff8df",
      __typename: "Director"
    }
  ]
};

// src/~react-testing/mocks/playbacktoken.ts
var playbackToken = ({ slug: slug3 }) => ({
  __typename: "AccountPlaybackToken",
  id: createPlaybackTokenId({ slug: slug3 }),
  nextContent: null,
  media: null,
  playbackId: "test-123",
  cdn: "Lumen",
  jwt: "eyJ0eXAiOiJKV1QiLCJhbGoiOiJIUzI1NiJ9.eyJ2ZXJzaW9uIjoxLCJjb21fa2V5X2lkIjoiZjcwNmRlMzMtYzUyOS00OTI0LWI5OWUtYTkwZDAwZWI4MjhjIiwibWVzc2FnZSI6eyJ0eXBlIjoiZW50aXRsZW1lbnRfbWVzc2FnZSIsImtleXMiOlt7ImlkIjoiOUVEQkUwQzUtNUQ4OC0zMzRCLUEwRDYtMDJBMkY2QjgwOTgzIn1dLCJleHBpcmF0aW9uX2RhdGUiOiIyMDE5LTA3LTA1VDE5OjQwOjAyLjg2NTQ4NDdaIiwia2V5c19iYXNlZF9vbl9yZXF1ZXN0IjpmYWxzZSwicGVyc2lzdGVudCI6dHJ1ZX0sImJlZ2luX2RhdGUiOiIwMDAxLTAxLTAxVDAwOjAwOjAwIiwiZXhwaXJhdGlvbl9kYXRlIjoiMjAxOS0wNy0wNVQxOTo0MDowMi44NjU0ODQ3WiJ9.Bs1_SfpYkHu1XHTXmti6Esgdauly3Q64vB7XjcwonT8",
  expires: "2019-07-05T19:40:02.865Z",
  thumbsUrl: "https://thumb-cdn.sfanytime.com/sfa_prod/doctor-sleep/feature/37077_thumbs.json",
  widevine: {
    licenseServer: "https://drm-widevine-licensing.axprod.net/AcquireLicense",
    __typename: "WidevinePlayReponse"
  },
  fairplay: {
    licenseServer: "https://drm-fairplay-licensing.axprod.net/AcquireLicense",
    certificateUrl: "https://s3-eu-west-1.amazonaws.com/sf-prismic-test/fairplay.cer",
    contentId: "skd://9edbe0c5-5d88-334b-a0d6-02a2f6b80983:c5e0db9e885d4b33a0d602a2f6b80983",
    __typename: "FairplayPlayResponse"
  },
  manifest: {
    download: {
      info: {
        name: "mockManifest",
        __typename: "ManifestInfo"
      },
      dash: "https://vod-dash.sfanytime.com/features/17000/17354/17354_c.ism/Manifest.mpd",
      hls: "https://vod-hls.sfanytime.com/features/17000/17354/17354_c.ism/Manifest.m3u8",
      __typename: "ManifestUrls"
    },
    default: {
      info: {
        name: "mockManifest",
        __typename: "ManifestInfo"
      },
      dash: "https://vod-dash.sfanytime.com/features/17000/17354/17354_c.ism/Manifest.mpd",
      hls: "https://vod-hls.sfanytime.com/features/17000/17354/17354_c.ism/Manifest.m3u8",
      __typename: "ManifestUrls"
    },
    filtered: {
      dash: "https://vod-dash.sfanytime.com/features/17000/17354/17354_c.ism/Manifest.mpd",
      __typename: "ManifestUrls"
    },
    __typename: "Manifest"
  },
  playready: {
    licenseServer: "https://drm-playready-licensing.axprod.net/AcquireLicense",
    __typename: "PlayReadyPlayReponse"
  },
  extra: null
});

// src/~react-testing/mocks/savedSearch.ts
var savedSearch = {
  __typename: "SingleTitleSavedSearch",
  id: `SavedSearch/${normalMovie.slug}`,
  locale: "sv" /* sv */,
  slug: normalMovie.slug,
  item: null
};

// src/~react-testing/mocks/search.ts
var search = {
  __typename: "SearchResults",
  results: []
};

// src/~react-testing/MockedAppContext/MockedAppContext.tsx
import { MockedProvider } from "@apollo/client/testing";
import { cloneDeep as cloneDeep2 } from "@apollo/client/utilities";
import { GraphQLError } from "graphql";
import { useEffect as useEffect41, useRef as useRef22 } from "react";

// src/~react-testing/mocks/account/account.ts
var account = ({
  deviceType
}) => ({
  __typename: "Account",
  id: "test",
  mppId: "mpp123",
  email: "test@test.com",
  shortUserName: "shorttest",
  firstName: "test",
  lastName: "test",
  city: "test",
  address: "test",
  mobile: "0700777070",
  postalCode: "",
  country: "Sweden",
  locale: "sv-SE",
  countryOfResidence: "se" /* se */,
  paymentMethods: [],
  marketingConsent: false,
  isNewUser: false,
  deviceInformation: {
    __typename: "DeviceInformation",
    id: createDeviceInfoId({ deviceType }),
    brand: "SFAnytime" /* SFAnytime */,
    environment: "production" /* production */,
    features: [
      {
        __typename: "AppFeature",
        feature: "PAYMENT",
        enabled: true,
        priority: 5,
        variant: null,
        data: null
      },
      {
        __typename: "AppFeature",
        feature: "SEARCH",
        enabled: false,
        priority: 5,
        variant: null,
        data: null
      },
      {
        __typename: "AppFeature",
        feature: "DISABLEEXTERNALLINKS",
        enabled: false,
        priority: 5,
        variant: null,
        data: null
      },
      {
        __typename: "AppFeature",
        feature: "TICKETS",
        enabled: true,
        priority: 5,
        variant: null,
        data: null
      }
    ],
    configs: [
      {
        __typename: "AppConfig",
        priority: 2,
        config: "APP_DEBUG",
        value: "false"
      },
      {
        __typename: "AppConfig",
        priority: 2,
        config: "APP_ENV",
        value: "production"
      },
      {
        __typename: "AppConfig",
        priority: 2,
        config: "MUX_KEY",
        value: "012345678910"
      },
      {
        __typename: "AppConfig",
        priority: 2,
        config: "CHATLIO_ID",
        value: "7fb3b6e1-2265-40c2-5d8d-0e2b4cf7da2e"
      },
      {
        __typename: "AppConfig",
        priority: 2,
        config: "AMPLITUDE_KEY",
        value: "f5722d3b3fbd7463699fd3561ba5d20a"
      },
      {
        __typename: "AppConfig",
        priority: 2,
        config: "ALGOLIASEARCH_APPLICATION_ID",
        value: "APP_ID"
      },
      {
        __typename: "AppConfig",
        priority: 2,
        config: "ALGOLIASEARCH_INDEX",
        value: "INDEX"
      },
      {
        __typename: "AppConfig",
        priority: 2,
        config: "ALGOLIASEARCH_API_KEY_SEARCH",
        value: "API_KEY_SEARCH"
      },
      {
        __typename: "AppConfig",
        priority: 2,
        config: "CHECKOUT_URL",
        value: "https://www.sfanytime.com/:locale/checkout/:slug"
      },
      {
        __typename: "AppConfig",
        priority: 2,
        config: "CHROMECAST_ID",
        value: "7317D85A"
      },
      {
        __typename: "AppConfig",
        priority: 2,
        config: "GOOGLE_TAG_MANAGER_ID",
        value: "GTM-PPLK5LF"
      },
      {
        __typename: "AppConfig",
        priority: 2,
        config: "SENTRY_AUTH_TOKEN",
        value: "160e4505c57b46298c905300abecc1a46a69c82f35244212b76cb9574e8c2399"
      },
      {
        __typename: "AppConfig",
        priority: 2,
        config: "SENTRY_PROJECT",
        value: "sfanytime-com"
      },
      {
        __typename: "AppConfig",
        priority: 2,
        config: "SENTRY_ORG",
        value: "sfanytime"
      },
      {
        __typename: "AppConfig",
        priority: 2,
        config: "GOOGLE_ANALYTICS_ID",
        value: "UA-26634968-7"
      },
      {
        __typename: "AppConfig",
        priority: 2,
        config: "FACEBOOK_PIXEL_ID",
        value: "489668811400402"
      }
    ]
  }
});

// src/~react-testing/mocks/appInfo.ts
var defaultApp = "UnknownApp";
var defaultDeviceType = toDeviceType(defaultApp);
var appInfo = (opts) => {
  var _a, _b;
  const app = {
    __typename: defaultApp,
    id: `${Math.random()}`,
    appId: "",
    deviceType: defaultDeviceType,
    latestVersion: (_a = opts.latestVersion) != null ? _a : "",
    latestVersionReleaseDate: (_b = opts.latestVersionReleaseDate) != null ? _b : "",
    storeUrl: ""
  };
  return app;
};

// src/~react-testing/mocks/auth/auth.ts
var auth_exports = {};
__export(auth_exports, {
  additionalToken: () => additionalToken,
  normalUser: () => normalUser
});
var normalUser = {
  __typename: "AccountAuthToken",
  accountId: "test-id-123",
  refreshToken: "fakerefreshtokenthatdontwork",
  token: "faketokenthatdontwork",
  expires: "12359595459"
};
var additionalToken = {
  __typename: "AccountAuthToken",
  accountId: "test-id-123",
  refreshToken: "fakerefreshtokenthatdontwork_additional",
  token: "faketokenthatdontwork_additional",
  expires: "12359595459"
};

// src/~react-testing/mocks/bookmarks/bookmarks.ts
var bookmarkList = [
  {
    id: createBookmarkId({ slug: "national-treasure" }),
    time: 120 / 5 * 60,
    duration: 120,
    completed: false,
    started: true,
    updatedAt: null,
    procentage: 20,
    percentage: 20,
    slug: "national-treasure",
    __typename: "Bookmark",
    item: {
      id: "Movie:national-treasure",
      slug: "national-treasure",
      displayableAsset: {
        id: "DisplayableInCollectionWithCover:id",
        __typename: "DisplayableInCollectionWithCover",
        cover: "cover.jpg"
      },
      display: {
        __typename: "Display",
        caption: null,
        title: "National Treasure",
        originalTitle: "National Treasure"
      },
      tags: [],
      __typename: "Movie"
    }
  },
  {
    id: createBookmarkId({ slug: "finding-dory" }),
    time: 12655,
    duration: null,
    completed: false,
    started: false,
    updatedAt: null,
    procentage: null,
    percentage: null,
    slug: "finding-dory",
    __typename: "Bookmark",
    item: {
      id: "Movie:finding-dory",
      slug: "finding-dory",
      displayableAsset: {
        id: "DisplayableInCollectionWithCover:id",
        __typename: "DisplayableInCollectionWithCover",
        cover: "cover.jpg"
      },
      display: {
        __typename: "Display",
        caption: null,
        title: "Hitta Doris - Svensk text",
        originalTitle: "Hitta Doris - Svensk text"
      },
      tags: [],
      __typename: "Movie"
    }
  }
];

// src/~react-testing/mocks/deviceInfo/deviceInfo.ts
var deviceInfo = ({
  deviceType
}) => ({
  data: {
    response: {
      __typename: "DeviceInformation",
      id: createDeviceInfoId({ deviceType }),
      brand: "SFAnytime" /* SFAnytime */,
      environment: "production" /* production */,
      features: [
        {
          __typename: "AppFeature",
          feature: "PAYMENT" /* PAYMENT */,
          enabled: false,
          priority: 0,
          variant: null,
          data: null
        },
        {
          __typename: "AppFeature",
          feature: "SEARCH" /* SEARCH */,
          enabled: true,
          priority: 0,
          variant: "A",
          data: {
            preferredClients: {
              search: "primary",
              globalSearch: "primary",
              suggestions: "primary"
            }
          }
        },
        {
          __typename: "AppFeature",
          feature: "DISABLEEXTERNALLINKS" /* DISABLEEXTERNALLINKS */,
          enabled: false,
          priority: 0,
          variant: null,
          data: null
        },
        {
          __typename: "AppFeature",
          feature: "TICKETS" /* TICKETS */,
          enabled: false,
          priority: 0,
          variant: null,
          data: null
        }
      ],
      configs: [
        {
          __typename: "AppConfig",
          priority: 0,
          config: "APP_DEBUG" /* APP_DEBUG */,
          value: "false"
        },
        {
          __typename: "AppConfig",
          priority: 0,
          config: "APP_ENV" /* APP_ENV */,
          value: "production"
        },
        {
          __typename: "AppConfig",
          priority: 0,
          config: "MUX_KEY" /* MUX_KEY */,
          value: "012345678910"
        },
        {
          __typename: "AppConfig",
          priority: 0,
          config: "CHATLIO_ID" /* CHATLIO_ID */,
          value: "7fb3b6e1-2265-40c2-5d8d-0e2b4cf7da2e"
        },
        {
          __typename: "AppConfig",
          priority: 0,
          config: "AMPLITUDE_KEY" /* AMPLITUDE_KEY */,
          value: "f5722d3b3fbd7463699fd3561ba5d20a"
        },
        {
          __typename: "AppConfig",
          priority: 0,
          config: "ALGOLIASEARCH_APPLICATION_ID" /* ALGOLIASEARCH_APPLICATION_ID */,
          value: "E38FD90MOB"
        },
        {
          __typename: "AppConfig",
          priority: 0,
          config: "ALGOLIASEARCH_INDEX" /* ALGOLIASEARCH_INDEX */,
          value: "prod_sfanytime"
        },
        {
          __typename: "AppConfig",
          priority: 0,
          config: "ALGOLIASEARCH_API_KEY_SEARCH" /* ALGOLIASEARCH_API_KEY_SEARCH */,
          value: "3f56a452156f1a76c8939af1798a2335"
        },
        {
          __typename: "AppConfig",
          priority: 0,
          config: "CHECKOUT_URL" /* CHECKOUT_URL */,
          value: "https://www.sfanytime.com/:locale/checkout/:slug"
        },
        {
          __typename: "AppConfig",
          priority: 0,
          config: "CHROMECAST_ID" /* CHROMECAST_ID */,
          value: "7317D85A"
        },
        {
          __typename: "AppConfig",
          priority: 0,
          config: "GOOGLE_TAG_MANAGER_ID" /* GOOGLE_TAG_MANAGER_ID */,
          value: "GTM-PPLK5LF"
        },
        {
          __typename: "AppConfig",
          priority: 0,
          config: "SENTRY_AUTH_TOKEN" /* SENTRY_AUTH_TOKEN */,
          value: "160e4505c57b46298c905300abecc1a46a69c82f35244212b76cb9574e8c2399"
        },
        {
          __typename: "AppConfig",
          priority: 0,
          config: "SENTRY_PROJECT" /* SENTRY_PROJECT */,
          value: "sfanytime-com"
        },
        {
          __typename: "AppConfig",
          priority: 0,
          config: "SENTRY_ORG" /* SENTRY_ORG */,
          value: "sfanytime"
        },
        {
          __typename: "AppConfig",
          priority: 0,
          config: "GOOGLE_ANALYTICS_ID" /* GOOGLE_ANALYTICS_ID */,
          value: "UA-26634968-19"
        },
        {
          __typename: "AppConfig",
          priority: 0,
          config: "FACEBOOK_PIXEL_ID" /* FACEBOOK_PIXEL_ID */,
          value: "489668811400402"
        }
      ]
    }
  }
});

// src/~react-testing/mocks/tickets.ts
var tickets = {
  __typename: "AccountTickets",
  totalCount: 3,
  balance: 2,
  used: 1,
  displayableAsset: {
    id: "DisplayableInCollectionWithCover:id",
    __typename: "DisplayableInCollectionWithCover",
    cover: "cover.jpg"
  }
};

// src/~react-testing/mocks/entitlements/entitlements.ts
var entitlements = {
  __typename: "AccountEntitlements",
  items: [
    __spreadProps(__spreadValues({}, normalMovie), { linkTarget: null }),
    {
      slug: "series-american-gods",
      display: {
        __typename: "Display",
        title: "mockTitle",
        originalTitle: "mockTitle",
        caption: null
      },
      tags: [],
      displayableAsset: {
        id: "DisplayableInCollectionWithCover:id",
        __typename: "DisplayableInCollectionWithCover",
        cover: "cover.jpg"
      },
      __typename: "Series",
      linkTarget: null
    },
    {
      slug: "sniper-ultimate-kill",
      display: {
        __typename: "Display",
        title: "mockTitle",
        originalTitle: "mockTitle",
        caption: null
      },
      tags: [],
      displayableAsset: {
        id: "DisplayableInCollectionWithCover:id",
        __typename: "DisplayableInCollectionWithCover",
        cover: "cover.jpg"
      },
      __typename: "Movie",
      linkTarget: null
    },
    {
      slug: "first-kill",
      display: {
        __typename: "Display",
        title: "mockTitle",
        originalTitle: "mockTitle",
        caption: null
      },
      tags: [],
      displayableAsset: {
        id: "DisplayableInCollectionWithCover:id",
        __typename: "DisplayableInCollectionWithCover",
        cover: "cover.jpg"
      },
      __typename: "Movie",
      linkTarget: null
    },
    {
      slug: "americons",
      display: {
        __typename: "Display",
        title: "mockTitle",
        originalTitle: "mockTitle",
        caption: null
      },
      tags: [],
      displayableAsset: {
        id: "DisplayableInCollectionWithCover:id",
        __typename: "DisplayableInCollectionWithCover",
        cover: "cover.jpg"
      },
      __typename: "Movie",
      linkTarget: null
    },
    {
      slug: "en-underbar-javla-jul",
      display: {
        __typename: "Display",
        title: "mockTitle",
        originalTitle: "mockTitle",
        caption: null
      },
      tags: [],
      displayableAsset: {
        id: "DisplayableInCollectionWithCover:id",
        __typename: "DisplayableInCollectionWithCover",
        cover: "cover.jpg"
      },
      __typename: "Movie",
      linkTarget: null
    }
  ].map((media) => __spreadProps(__spreadValues({}, media), {
    id: createMediaId({ __typename: media.__typename, slug: media.slug })
  })),
  entitlements: [
    {
      mediaId: "00001",
      slug: normalMovie.slug,
      seriesSlug: null,
      startDate: "2016-09-15T14:59:00Z",
      endDate: "9999-12-31T00:00:00Z",
      endIn: "7981 \xE5r",
      isEst: true,
      __typename: "AccountEntitlement"
    },
    {
      mediaId: "17354",
      slug: "en-underbar-javla-jul",
      seriesSlug: null,
      startDate: "2016-09-15T14:59:00Z",
      endDate: "9999-12-31T00:00:00Z",
      endIn: "7981 \xE5r",
      isEst: true,
      __typename: "AccountEntitlement"
    },
    {
      mediaId: "23794",
      slug: "americons",
      seriesSlug: null,
      startDate: "2017-09-19T07:39:40.2Z",
      endDate: "9999-12-31T00:00:00Z",
      endIn: "7981 \xE5r",
      isEst: true,
      __typename: "AccountEntitlement"
    },
    {
      mediaId: "24414",
      slug: "first-kill",
      seriesSlug: null,
      startDate: "2017-09-20T09:25:38.98Z",
      endDate: "9999-12-31T00:00:00Z",
      endIn: "7981 \xE5r",
      isEst: true,
      __typename: "AccountEntitlement"
    },
    {
      mediaId: "24363",
      slug: "sniper-ultimate-kill",
      seriesSlug: null,
      startDate: "2017-10-19T13:16:49.417Z",
      endDate: "9999-12-31T00:00:00Z",
      endIn: "7981 \xE5r",
      isEst: true,
      __typename: "AccountEntitlement"
    },
    {
      mediaId: "23631",
      slug: "series-american-gods-s01",
      seriesSlug: "series-american-gods",
      startDate: "2018-01-12T09:57:06.357Z",
      endDate: "9999-12-31T00:00:00Z",
      endIn: "7981 \xE5r",
      isEst: true,
      __typename: "AccountEntitlement"
    },
    {
      mediaId: "23631",
      slug: "series-american-gods-s01e01",
      seriesSlug: "series-american-gods",
      startDate: "2018-01-12T09:57:06.357Z",
      endDate: "9999-12-31T00:00:00Z",
      endIn: "7981 \xE5r",
      isEst: true,
      __typename: "AccountEntitlement"
    },
    {
      mediaId: "23631",
      slug: "series-american-gods-s01e05",
      seriesSlug: "series-american-gods",
      startDate: "2018-01-12T09:57:06.357Z",
      endDate: "9999-12-31T00:00:00Z",
      endIn: "7981 \xE5r",
      isEst: true,
      __typename: "AccountEntitlement"
    },
    {
      mediaId: "23631",
      slug: "series-american-gods-s01e04",
      seriesSlug: "series-american-gods",
      startDate: "2018-01-12T09:57:06.357Z",
      endDate: "9999-12-31T00:00:00Z",
      endIn: "7981 \xE5r",
      isEst: true,
      __typename: "AccountEntitlement"
    },
    {
      mediaId: "23631",
      slug: "series-american-gods-s01e02",
      seriesSlug: "series-american-gods",
      startDate: "2018-01-12T09:57:06.357Z",
      endDate: "9999-12-31T00:00:00Z",
      endIn: "7981 \xE5r",
      isEst: true,
      __typename: "AccountEntitlement"
    },
    {
      mediaId: "23631",
      slug: "series-american-gods-s01e03",
      seriesSlug: "series-american-gods",
      startDate: "2018-01-12T09:57:06.357Z",
      endDate: "9999-12-31T00:00:00Z",
      endIn: "7981 \xE5r",
      isEst: true,
      __typename: "AccountEntitlement"
    },
    {
      mediaId: "23631",
      slug: "series-american-gods-s01e08",
      seriesSlug: "series-american-gods",
      startDate: "2018-01-12T09:57:06.357Z",
      endDate: "9999-12-31T00:00:00Z",
      endIn: "7981 \xE5r",
      isEst: true,
      __typename: "AccountEntitlement"
    },
    {
      mediaId: "23631",
      slug: "series-american-gods-s01e07",
      seriesSlug: "series-american-gods",
      startDate: "2018-01-12T09:57:06.357Z",
      endDate: "9999-12-31T00:00:00Z",
      endIn: "7981 \xE5r",
      isEst: true,
      __typename: "AccountEntitlement"
    },
    {
      mediaId: "23631",
      slug: "series-american-gods-s01e06",
      seriesSlug: "series-american-gods",
      startDate: "2018-01-12T09:57:06.357Z",
      endDate: "9999-12-31T00:00:00Z",
      endIn: "7981 \xE5r",
      isEst: true,
      __typename: "AccountEntitlement"
    }
  ].map((entitlement) => __spreadProps(__spreadValues({}, entitlement), {
    id: createEntitlementId2({ slug: entitlement.slug })
  })),
  tickets
};

// src/~react-testing/mocks/personalization.ts
var personalization = {
  __typename: "PersonalizationQuery",
  items: [
    {
      __typename: "TopGenrePersonalization",
      count: 3,
      slug: "children-family"
    },
    {
      __typename: "TopGenrePersonalization",
      count: 2,
      slug: "comedy"
    },
    {
      __typename: "TopGenrePersonalization",
      count: 2,
      slug: "action"
    },
    {
      __typename: "TopGenrePersonalization",
      count: 2,
      slug: "adventure"
    },
    {
      __typename: "TopGenrePersonalization",
      count: 2,
      slug: "thriller"
    },
    {
      __typename: "TopActorPersonalization",
      count: 1,
      actor: {
        __typename: "Actor",
        id: "1",
        avatar: "https://www.gravatar.com/avatar/",
        name: "Chris Pratt"
      }
    },
    {
      __typename: "TopActorPersonalization",
      count: 1,
      actor: {
        __typename: "Actor",
        id: "2",
        avatar: "https://www.gravatar.com/avatar/",
        name: "Anya Taylor-Joy"
      }
    },
    {
      __typename: "TopActorPersonalization",
      count: 1,
      actor: {
        __typename: "Actor",
        id: "3",
        avatar: "https://www.gravatar.com/avatar/",
        name: "Charlie Day"
      }
    },
    {
      __typename: "TopActorPersonalization",
      count: 1,
      actor: {
        __typename: "Actor",
        id: "4",
        avatar: "https://www.gravatar.com/avatar/",
        name: "Jack Black"
      }
    },
    {
      __typename: "TopActorPersonalization",
      count: 1,
      actor: {
        __typename: "Actor",
        id: "5",
        avatar: "https://www.gravatar.com/avatar/",
        name: "Keegan-Michael Key"
      }
    },
    {
      __typename: "TopDirectorPersonalization",
      count: 2,
      director: {
        __typename: "Director",
        id: "1",
        avatar: "https://www.gravatar.com/avatar/",
        name: "Chris Columbus"
      }
    },
    {
      __typename: "TopDirectorPersonalization",
      count: 1,
      director: {
        __typename: "Director",
        id: "2",
        avatar: "https://www.gravatar.com/avatar/",
        name: "Aaron Horvath"
      }
    },
    {
      __typename: "TopDirectorPersonalization",
      count: 1,
      director: {
        __typename: "Director",
        id: "3",
        avatar: "https://www.gravatar.com/avatar/",
        name: "J.K. Rowling"
      }
    },
    {
      __typename: "TopDirectorPersonalization",
      count: 1,
      director: {
        __typename: "Director",
        id: "4",
        avatar: "https://www.gravatar.com/avatar/",
        name: "James Mangold"
      }
    },
    {
      __typename: "TopDirectorPersonalization",
      count: 1,
      director: {
        __typename: "Director",
        id: "5",
        avatar: "https://www.gravatar.com/avatar/",
        name: "James Cameron"
      }
    },
    {
      __typename: "TopYearPersonalization",
      count: 3,
      year: 2023
    },
    {
      __typename: "TopYearPersonalization",
      count: 1,
      year: 1990
    },
    {
      __typename: "TopYearPersonalization",
      count: 1,
      year: 1997
    },
    {
      __typename: "TopYearPersonalization",
      count: 1,
      year: 2001
    },
    {
      __typename: "TopYearPersonalization",
      count: 1,
      year: 2011
    },
    {
      __typename: "TopImdbRatingPersonalization",
      count: 4,
      rating: 7
    },
    {
      __typename: "TopImdbRatingPersonalization",
      count: 1,
      rating: 4
    },
    {
      __typename: "TopImdbRatingPersonalization",
      count: 1,
      rating: 5
    },
    {
      __typename: "TopImdbRatingPersonalization",
      count: 1,
      rating: 6
    },
    {
      __typename: "TopMetaCollectionPersonalization",
      count: 6,
      slug: "category-basedon-remake"
    },
    {
      __typename: "TopMetaCollectionPersonalization",
      count: 6,
      slug: "category-plot-rescue"
    },
    {
      __typename: "TopMetaCollectionPersonalization",
      count: 6,
      slug: "category-plot-danger"
    },
    {
      __typename: "TopMetaCollectionPersonalization",
      count: 6,
      slug: "category-style-reboot"
    },
    {
      __typename: "TopMetaCollectionPersonalization",
      count: 5,
      slug: "category-plot-heroes"
    }
  ]
};

// src/~react-testing/MockedAppContext/MockedAppContext.tsx
import { jsx as jsx19 } from "react/jsx-runtime";
var deviceInfoMock = (variables) => ({
  request: {
    query: GQL_GET_DEVICE_INFORMATION_default,
    variables
  },
  result: {
    data: {
      response: deviceInfo({ deviceType: variables.device }).data.response
    }
  }
});
var entitlementsMock = {
  request: {
    query: GQL_GET_ENTITLEMENTS_default,
    variables: {
      locale: "sv"
    }
  },
  result: {
    data: {
      response: entitlements
    }
  }
};
var bookmarksMock = {
  request: {
    query: GQL_GET_BOOKMARKS_default,
    variables: {
      locale: "sv"
    }
  },
  result: {
    data: {
      response: bookmarkList
    }
  }
};
var accountInfoMock = {
  request: {
    query: GQL_GET_ACCOUNT_INFORMATION_default
  },
  result: {
    data: {
      response: account({ deviceType: "UnknownType" /* UnknownType */ })
    }
  }
};
var appInfoMock = (variables) => ({
  request: {
    query: GQL_GET_APP_INFO_default,
    variables: { deviceType: [variables.deviceType] }
  },
  result: {
    data: {
      response: [appInfo({})]
    }
  }
});
var contentCollectionMock = {
  request: {
    query: GQL_CONTENT_COLLECTION_default,
    variables: {
      slug: "home",
      locale: "sv",
      first: 5
    }
  },
  result: {
    data: {
      contentcollection: contentCollection
    }
  }
};
var playbackTokenMock = {
  request: {
    query: GQL_CREATE_PLAYBACK_TOKEN_default,
    variables: {
      slug: normalMovie.slug,
      filters: []
    }
  },
  result: {
    data: {
      response: playbackToken({ slug: normalMovie.slug })
    }
  }
};
var searchMock = {
  request: { query: GQL_GET_SEARCH_default },
  maxUsageCount: 10,
  variableMatcher: () => true,
  result: { data: { response: search } }
};
var favoritesMock = {
  request: { query: GQL_GET_FAVORITES_default },
  variableMatcher: () => true,
  result: { data: { response: favorites } }
};
var savedSearchMock = {
  request: { query: GQL_GET_SAVED_SEARCH_default },
  variableMatcher: () => true,
  result: { data: { response: [savedSearch] } }
};
var savedSearchesMock = {
  request: { query: GQL_GET_SAVED_SEARCHES_default },
  variableMatcher: () => true,
  result: { data: { response: [savedSearch] } }
};
var personalizationMock = {
  request: { query: GQL_GET_PERSONALIZATION_default },
  variableMatcher: () => true,
  result: { data: { response: [personalization] } }
};
var entitlementCreatedSubscriptionMock = {
  request: { query: GQL_ENTITLEMENT_CREATED_SUBSCRIPTION_default },
  variableMatcher: () => true,
  result: { data: { response: entitlementCreatedSubscription } }
};
var accountCreatedSubscriptionMock = {
  request: { query: GQL_ACCOUNT_EVENT_SUBSCRIPTION_default },
  variableMatcher: () => true,
  result: { data: { response: accountEventSubscription } }
};
var mediaMock = ({
  media,
  hookOptions
}) => ({
  request: {
    query: GQL_GET_MEDIA_default,
    variables: getVariables2({
      slug: media.slug,
      locale: "sv" /* sv */,
      hookOptions
    })
  },
  result: {
    data: {
      response: media
    }
  }
});
var createMocks = (additionalMocks, hookOptions, { isLoggedIn, device }, disableMocks) => [
  (disableMocks == null ? void 0 : disableMocks.localization) ? null : {
    name: "localization",
    requiresLogin: false,
    mock: localizationQuery({ deviceType: device.type })
  },
  (disableMocks == null ? void 0 : disableMocks.deviceInfo) ? null : {
    name: "deviceInfo",
    requiresLogin: false,
    mock: deviceInfoMock({ device: device.type })
  },
  (disableMocks == null ? void 0 : disableMocks.entitlements) ? null : {
    name: "entitlements",
    requiresLogin: true,
    mock: entitlementsMock
  },
  (disableMocks == null ? void 0 : disableMocks.accountInfo) ? null : {
    name: "accountInfo",
    requiresLogin: true,
    mock: accountInfoMock
  },
  (disableMocks == null ? void 0 : disableMocks.appInfo) ? null : {
    name: "appInfo",
    requiresLogin: false,
    mock: appInfoMock({ deviceType: device.type })
  },
  (disableMocks == null ? void 0 : disableMocks.contentCollection) ? null : {
    name: "contentCollection",
    requiresLogin: false,
    mock: contentCollectionMock
  },
  (disableMocks == null ? void 0 : disableMocks.movie) ? null : {
    name: "movie",
    requiresLogin: false,
    mock: mediaMock({ media: normalMovie, hookOptions })
  },
  (disableMocks == null ? void 0 : disableMocks.series) ? null : {
    name: "series",
    requiresLogin: false,
    mock: mediaMock({ media: normalSeries, hookOptions })
  },
  (disableMocks == null ? void 0 : disableMocks.bookmarks) ? null : { name: "bookmarks", requiresLogin: true, mock: bookmarksMock },
  (disableMocks == null ? void 0 : disableMocks.playbackToken) ? null : { name: "playbackToken", requiresLogin: true, mock: playbackTokenMock },
  (disableMocks == null ? void 0 : disableMocks.search) ? null : { name: "search", requireLogin: false, mock: searchMock },
  (disableMocks == null ? void 0 : disableMocks.favorites) ? null : { name: "favorites", requireLogin: true, mock: favoritesMock },
  (disableMocks == null ? void 0 : disableMocks.savedSearch) ? null : { name: "savedSearch", requireLogin: true, mock: savedSearchMock },
  (disableMocks == null ? void 0 : disableMocks.savedSearches) ? null : {
    name: "savedSearchesMock",
    requireLogin: true,
    mock: savedSearchesMock
  },
  (disableMocks == null ? void 0 : disableMocks.entitlementCreatedSubscription) ? null : {
    name: "entitlementCreatedSubscription",
    requireLogin: true,
    mock: entitlementCreatedSubscriptionMock
  },
  (disableMocks == null ? void 0 : disableMocks.accountEventSubscription) ? null : {
    name: "accountEventSubscription",
    requireLogin: true,
    mock: accountCreatedSubscriptionMock
  },
  {
    name: "personalization",
    requireLogin: true,
    mock: personalizationMock
  },
  ...additionalMocks
].reduce(
  (acc, curr) => {
    if (curr) {
      if (curr.requiresLogin && isLoggedIn || !curr.requiresLogin) {
        acc.push(__spreadValues({ name: curr.name }, curr.mock));
      }
    }
    return acc;
  },
  []
);
var MockedAppContext = ({
  children,
  storage: storage2,
  device,
  locale = "sv" /* sv */,
  mocks = [],
  disableBuiltInMocks,
  isLoggedIn = false,
  brand = "SFAnytime" /* SFAnytime */,
  trackers = [],
  cacheInvalidation = { enabled: false },
  mocksTransformer
}) => {
  const mockedDeviceHeaders = mockDevice(device);
  const hookOptions = useHookOptions();
  const offline = useRef22(false);
  useEffect41(() => {
    return offlineEvents.onEvent(({ name }) => {
      offline.current = name === "offline";
    });
  }, []);
  let allMocks = createMocks(
    mocks,
    hookOptions != null ? hookOptions : {},
    {
      isLoggedIn,
      device: mockedDeviceHeaders
    },
    disableBuiltInMocks
  );
  if (mocksTransformer) {
    try {
      allMocks = mocksTransformer(cloneDeep2(allMocks));
    } catch (e) {
      console.warn("mocksTransformer Failed", e);
    }
  }
  const mockedStorage = mockStorage(storage2);
  const mockedCache = createApolloCache({ cacheInvalidation, brand });
  if (isLoggedIn) {
    getInitialSessionData().auth = normalUser;
    getInitialSessionData().initialized = true;
  } else {
    getInitialSessionData().auth = null;
    getInitialSessionData().initialized = true;
  }
  getInitialSessionData().loading = false;
  const mocksWithOffline = allMocks.map((mock) => {
    return __spreadProps(__spreadValues({}, mock), {
      result: (params) => {
        if (offline.current) {
          return {
            errors: [new GraphQLError("Offline!")]
          };
        }
        return mock.result instanceof Function ? mock.result(params) : mock.result;
      }
    });
  });
  return /* @__PURE__ */ jsx19(
    MockedProvider,
    {
      mocks: mocksWithOffline,
      addTypename: true,
      cache: mockedCache,
      children: /* @__PURE__ */ jsx19(
        AppContextProvider,
        {
          brand,
          device: mockedDeviceHeaders,
          storage: mockedStorage,
          locale,
          trackers,
          initialNetworkStatus: "online",
          children
        }
      )
    }
  );
};
var MockedAppContext_default = MockedAppContext;

// src/~react-testing/mocks/mux/muxTracking.ts
var muxTrackingMovie = {
  id: createMediaId({
    __typename: "Movie",
    slug: "mission-impossible-fallout"
  }),
  slug: "mission-impossible-fallout",
  display: {
    __typename: "Display",
    originalTitle: "Mission: Impossible - Fallout"
  },
  __typename: "Movie",
  duration: 882e4
};
var muxTrackingEpisode = {
  id: createMediaId({ __typename: "Episode", slug: "the-walking-dead" }),
  slug: "the-walking-dead",
  display: {
    __typename: "Display",
    originalTitle: "The Walking Dead"
  },
  seriesSlug: "the-walking-dead",
  duration: 36e5,
  __typename: "Episode"
};

// src/~react-testing/mocks/order.ts
var order = {
  purchaseType: "Tvod",
  purchaseTypeTitleKey: "Hyr",
  purchaseTypeTitleData: {},
  paidAmountString: "0.00 kr",
  vatAmountString: "0.00 kr",
  purchaseMethod: "Voucher",
  purchaseMethodTitleKey: "Voucher",
  purchaseMethodTitleData: {},
  currency: "SEK",
  pdfReceipt: "https://gql.sfanytime.com/download/receipt/0010O4TFE0KDE0E4U2?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoic2Z1c2VyIiwidW5pcXVlX25hbWUiOiIzOTg1MTczZi1hODViLTRkYzUtYjUxOS0xYmY1MTY1YzM2ZDAiLCJBY2NvdW50VHlwZSI6Ik5vcm1hbEFjY291bnQiLCJTZXNzaW9uSWQiOiIwYmY2MmRiNS1jYzYwLTQ2ZjQtODEwOC02NTQ0ZDNjZjhmZWMiLCJCcmFuZCI6IkFueXRpbWUiLCJuYmYiOjE2MTg1NzU3NDksImV4cCI6MTYxODU4Mjk0OSwiaWF0IjoxNjE4NTc1NzQ5LCJpc3MiOiJ3d3cuc2Zhbnl0aW1lLnNlIiwiYXVkIjoid3d3LnNmYW55dGltZS5zZSJ9.qj-HkiZ61E3HZvuytIqnkuQawAHjc8PjJP8WKE-zJi8",
  description: "The King of Staten Island (Your subscription cost has been discounted by 100%)",
  __typename: "Order",
  orderId: "0010OPNPIOEI2AWMI3",
  orderDate: "2021-04-12T10:49:19.400Z",
  originalPrice: 49,
  originalPriceString: "49.00 kr",
  discountAmountString: "-49.00 kr",
  discountAmount: 4900,
  feeAmount: 0,
  feeAmountString: "0.00 kr",
  item: {
    __typename: "Movie",
    id: "123",
    slug: "the-king-of-staten-island",
    tags: [],
    displayableAsset: {
      id: "DisplayableInCollectionWithCover:id",
      __typename: "DisplayableInCollectionWithCover",
      cover: "cover.jpg"
    },
    display: {
      __typename: "Display",
      title: "The King of Staten Island",
      originalTitle: "The King of Staten Island",
      caption: null
    }
  }
};

// src/~react-testing/mocks/prismicpage/prismicpage.ts
var prismicPage = {
  slug: "om-oss",
  firstPublicationDate: "2018-06-12T12:35:39.000Z",
  lastPublicationDate: "2018-06-12T12:35:39.000Z",
  content: {
    page: [
      {
        type: "heading6",
        text: "Om oss",
        spans: []
      }
    ],
    header: [
      {
        type: "heading1",
        text: "Om oss",
        spans: []
      }
    ],
    body: [
      {
        type: "paragraph",
        text: "P\xE5 en konkurrensutsatt marknad med konsumenter som har vant sig vid globala prenumerationsj\xE4ttar med m\xE4ngder av inneh\xE5ll och d\xE4r vi st\xE4ndigt sl\xE5ss om m\xE4nniskors tid, vill vi att SF Anytime ska vara ett sj\xE4lvklart val.\xA0",
        spans: []
      },
      {
        type: "paragraph",
        text: "SF Anytime grundades 2002 och \xE4r idag den ledande video on demand-tj\xE4nsten i Norden och Baltikum. Tj\xE4nsten \xE4r tillg\xE4ngligt via ledande TV-operat\xF6rer och OTT-partners och erbjuder allt fr\xE5n de senaste storfilmerna fr\xE5n Hollywood till smalare kvalitetsfilm och tv-serier. SF Anytime \xE4r en del av SF Studios som i sin tur \xE4r en del av Bonnier AB.",
        spans: []
      },
      {
        type: "paragraph",
        text: "Hos SF Anytime finns det ett sj\xE4lvklart val i ett hav av m\xF6jligheter. SF Anytime \xE4r en portal till en magisk v\xE4rld fr\xE5n en mysig hemmamilj\xF6. Ta med dig en medresen\xE4r eller tv\xE5 och kliv i en annan tidzon, bort fr\xE5n bruset. Med SF Anytime v\xE4ljer du att stanna upp f\xF6r en stund och hitta n\xE4rvaro, oavsett film.",
        spans: []
      },
      {
        type: "paragraph",
        text: "VAR FINNS VI? \nMed SF Anytime kan du se p\xE5 film online n\xE4r och var du vill. Vi \xE4r tillg\xE4ngliga p\xE5 tv\xE5 olika huvudsakliga s\xE4tt: via operat\xF6rer och som OTT-tj\xE4nst i norden, Sverige, Danmark, Finland och Norge.",
        spans: [
          {
            start: 0,
            end: 14,
            type: "strong"
          }
        ]
      },
      {
        type: "paragraph",
        text: "OPERAT\xD6RER\xA0\xE4r leverant\xF6rer av tv, telefoni och bredband, som Telia, ComHem, Canal Digital, Bredbandsbolaget och Boxer. Hela SF Anytimes utbud finns i operat\xF6rernas filmbutiker. F\xF6r att titta p\xE5 en film fr\xE5n SF Anytime hos en operat\xF6r m\xE5ste du vara kund hos dem och ha eventuell n\xF6dv\xE4ndig teknisk utrustning. D\xE4refter v\xE4ljer du film i deras filmbutik och kostnaden f\xF6r filmhyran l\xE4ggs till din r\xE4kning hos operat\xF6ren.",
        spans: [
          {
            start: 0,
            end: 10,
            type: "strong"
          }
        ]
      },
      {
        type: "paragraph",
        text: "OTT\xA0st\xE5r f\xF6r \u201COver The Top\u201D och \xE4r ett samlingsbegrepp f\xF6r tj\xE4nster som via Internet levererar film, musik och annan media till konsumenten, utan att blanda in en tredje part som de ovan beskrivna operat\xF6rerna i distributionen. F\xF6r att titta p\xE5 en film betalar du med ditt konto/kreditkort eller med en v\xE4rdekod.",
        spans: [
          {
            start: 0,
            end: 3,
            type: "strong"
          }
        ]
      },
      {
        type: "paragraph",
        text: "Det finns flera s\xE4tt att anv\xE4nda SF Anytime som OTT-tj\xE4nst:",
        spans: []
      },
      {
        type: "list-item",
        text: "Via en vanlig dator (hemsidan sfanytime.com som du just nu befinner dig p\xE5)",
        spans: []
      },
      {
        type: "list-item",
        text: "Som app i Smart TV-apparater fr\xE5n de stora TV-tillverkarna: Samsung, LG, Panasonic, Sony och Philips.",
        spans: []
      },
      {
        type: "list-item",
        text: "Som app i telefoner och surfplattor med operativsystemen Android.",
        spans: []
      },
      {
        type: "list-item",
        text: "Som app i telefoner och surfplattor med operativsystemen iOS (Dvs iPhone och iPad).",
        spans: []
      },
      {
        type: "paragraph",
        text: "ANSVARIG UTGIVARE\nF\xF6r filmer som inte tidigare har distribuerats i Norden, och som d\xE4rmed inte har n\xE5gon annan ansvarig utgivare, \xE4r Michael Porseryd ansvarig utgivare.",
        spans: [
          {
            start: 0,
            end: 17,
            type: "strong"
          }
        ]
      },
      {
        type: "paragraph",
        text: "Organisationsnummer: 556748-2616\nMomsnummer: S556748261601\nF\xF6retaget innehar F-skattesedel",
        spans: []
      },
      {
        type: "paragraph",
        text: "KONTAKTA OSS ",
        spans: [
          {
            start: 0,
            end: 13,
            type: "strong"
          }
        ]
      },
      {
        type: "paragraph",
        text: "G\xE5 in p\xE5 v\xE5r supportsida f\xF6r att l\xE4sa mer om de vanligaste problemen samt kontaktuppgifter till kundtj\xE4nst. ",
        spans: [
          {
            start: 13,
            end: 24,
            type: "hyperlink",
            data: {
              link_type: "Web",
              url: "https://support.sfanytime.com/"
            }
          }
        ]
      }
    ]
  },
  __typename: "Page"
};

// src/~react-testing/mocks/search/movie.ts
var searchMovie = {
  activeCampaign: null,
  actors: [
    {
      slug: "leonardo-dicaprio",
      name: "Leonardo DiCaprio",
      profileImage: "PERSON/leonardo-dicaprio_d6136cdfaa8c9709d051d49e7cba1a10.jpg",
      imdbId: "nm0000138"
    },
    {
      slug: "katy-bates",
      name: "Kathy Bates",
      profileImage: "PERSON/katy-bates_1f290af86a1c0a771734595e17c76257.jpg",
      imdbId: "nm0000870"
    },
    {
      slug: "frances-fisher",
      name: "Frances Fisher",
      profileImage: "PERSON/frances-fisher_10adc3fe7e84550fc447f55ee4c841ee.jpg",
      imdbId: "nm0004920"
    },
    {
      slug: "billy-zane",
      name: "Billy Zane",
      profileImage: "PERSON/billy-zane_d960722fe425d5b9e4f115590bb46a47.jpg",
      imdbId: "nm0000708"
    },
    {
      slug: "kate-winslet",
      name: "Kate Winslet",
      profileImage: "PERSON/kate-winslet_076757933c8af7e6c54ac465d3283a3a.jpg",
      imdbId: "nm0000701"
    },
    {
      slug: "gloria-stuart",
      name: "Gloria Stuart",
      profileImage: "PERSON/gloria-stuart_f13c13bf024ab5c4296bc7364e6bc12c.jpg",
      imdbId: "nm0001784"
    }
  ],
  ageGroups: [],
  ageLimit: {
    sv: 11,
    no: 11,
    da: 11,
    fi: 11
  },
  bucket: "3",
  campaigns: ["2020 11 November DEG Mega Movie Week 49 kr"],
  comingPublishDate: {
    sv: 0,
    no: 0,
    da: 0,
    fi: 0
  },
  cover: {
    sv: "COVERM/38754820-f8f8-4d7e-9cd7-9f81010f5635_COVERM_01.jpg",
    no: "COVERM/38754820-f8f8-4d7e-9cd7-9f81010f5635_COVERM_01.jpg",
    da: "COVERM/38754820-f8f8-4d7e-9cd7-9f81010f5635_COVERM_01.jpg",
    fi: "COVERM/38754820-f8f8-4d7e-9cd7-9f81010f5635_COVERM_01.jpg"
  },
  directors: [
    {
      slug: "james-cameron",
      name: "James Cameron",
      profileImage: "PERSON/james-cameron_f456c27711ecce95ec64cebb20463c3c.jpg",
      imdbId: "nm0000116"
    }
  ],
  duration: 187,
  genres: ["romance", "drama"],
  hasActiveCampaign: false,
  hasImdbId: true,
  hasTrailer: true,
  imdbId: "tt0120338",
  isAvailable: {
    sv: true,
    no: true,
    da: true,
    fi: true
  },
  isComing: {
    sv: false,
    no: false,
    da: false,
    fi: false
  },
  isDisplayable: {
    sv: true,
    no: true,
    da: true,
    fi: true
  },
  isFocus: {
    sv: false,
    no: false,
    da: false,
    fi: false
  },
  isPurchasable: {
    sv: true,
    no: true,
    da: true,
    fi: true
  },
  latestPublishDate: {
    sv: 1518134400,
    no: 1518134400,
    da: 1518134400,
    fi: 1518134400
  },
  licenseType: "Library",
  longSummary: {
    sv: "Titanics underg\xE5ng 1912 \xE4r en av 1900-talets mest omskrivna katastrofer. F\xF6rlisningen \xE4r nu f\xF6rem\xE5l f\xF6r en av historiens dyraste filmer bel\xF6nad med 11 Oscar. Titantic imponerar b\xE5de genom den fantastiska tekniken och k\xE4rlekshistorien mellan \xF6verklasstjejen fr\xE5n f\xF6rsta klass (Winslet) och konstn\xE4ren fr\xE5n tredje klass (DiCaprio).",
    no: "Titanics undergang i 1912 er en av 1900-tallets mest omskrevne katastrofer. Forliset er n\xE5 form\xE5l for en av historiens dyreste filmer bel\xF8nnet med 11 Oscars. Titantic imponerer b\xE5de gjennom den fantastiske teknikken og kj\xE6rlighetshistorien mellom overklassepiken fra f\xF8rste klasse (Winslet) og kunstneren fra tredje klasse (DiCaprio).",
    da: "Titanics undergang i 1912 er en af 1900-tallets mest omskrevne katastrofer. Forliset er nu genstand for en af historiens dyreste film, bel\xF8nnet med 11 Oscars. Titantic imponerer b\xE5de ved den fantastiske teknik og k\xE6rlighedshistorien mellem overklassepigen fra f\xF8rste klasse (Winslet) og kunstneren fra tredje klasse (DiCaprio).",
    fi: "Titanicin uppoaminen vuonna 1912 oli yksi 1900-luvun kohutuimmista onnettomuuksista. Tapahtumasta tehtiin elokuvahistorian siihen asti kallein elokuva, joka palkittiin 11 Oscarilla. Elokuvassa kiehtovat sek\xE4 huikeat tehosteet ett\xE4 tarina luokkarajat rikkovasta rakkaudesta yl\xE4luokkaisen hienostotyt\xF6n (Winslet) ja k\xF6yh\xE4n onnenonkijan (DiCaprio) v\xE4lill\xE4."
  },
  lowestCampaignPrice: null,
  lowestPrice: {
    sv: "49.0000",
    no: "49.0000",
    da: "49.0000",
    fi: "5.0000"
  },
  lowestPriceString: {
    sv: "49 kr",
    no: "kr 49",
    da: "kr. 49",
    fi: "\u20AC 5"
  },
  lowestProductPrice: {
    sv: {
      tvod: {
        amount: "49.0000",
        amountAsString: "49 kr"
      },
      est: {
        amount: "99.0000",
        amountAsString: "99 kr"
      },
      amount: "49.0000",
      amountAsString: "49 kr"
    },
    no: {
      tvod: {
        amount: "49.0000",
        amountAsString: "kr 49"
      },
      est: {
        amount: "99.0000",
        amountAsString: "kr 99"
      },
      amount: "49.0000",
      amountAsString: "kr 49"
    },
    da: {
      tvod: {
        amount: "49.0000",
        amountAsString: "kr. 49"
      },
      est: {
        amount: "99.0000",
        amountAsString: "kr. 99"
      },
      amount: "49.0000",
      amountAsString: "kr. 49"
    },
    fi: {
      tvod: {
        amount: "5.0000",
        amountAsString: "\u20AC 5"
      },
      est: {
        amount: "10.0000",
        amountAsString: "\u20AC 10"
      },
      amount: "5.0000",
      amountAsString: "\u20AC 5"
    }
  },
  mediaImages: [
    "MEDIAM/MEDIAM_248982d5-9c98-4e67-b500-3405397f9f3f_01.jpg",
    "MEDIAM/MEDIAM_3f4a5b60-d1cc-4f95-b3f0-44cde12e1955_01.jpg"
  ],
  originalTitle: "Titanic",
  productType: "Movie",
  productionCountries: ["US"],
  promo: {
    sv: null,
    no: null,
    da: null,
    fi: null
  },
  releaseYear: 1997,
  searchCover: {
    sv: "https://img-cdn.sfanytime.com/COVERM/38754820-f8f8-4d7e-9cd7-9f81010f5635_COVERM_01.jpg?w=375&fm=pjpg&s=c5385b40ee3734bd18a18abe5a8b877f",
    no: "https://img-cdn.sfanytime.com/COVERM/38754820-f8f8-4d7e-9cd7-9f81010f5635_COVERM_01.jpg?w=375&fm=pjpg&s=c5385b40ee3734bd18a18abe5a8b877f",
    da: "https://img-cdn.sfanytime.com/COVERM/38754820-f8f8-4d7e-9cd7-9f81010f5635_COVERM_01.jpg?w=375&fm=pjpg&s=c5385b40ee3734bd18a18abe5a8b877f",
    fi: "https://img-cdn.sfanytime.com/COVERM/38754820-f8f8-4d7e-9cd7-9f81010f5635_COVERM_01.jpg?w=375&fm=pjpg&s=c5385b40ee3734bd18a18abe5a8b877f"
  },
  slug: "titanic",
  tags: [],
  title: {
    sv: "Titanic",
    no: "Titanic",
    da: "Titanic",
    fi: "Titanic"
  },
  trailerManifestUrls: {
    dash: "https://streaming2.sfanytime.com/assets/titanic/trailer/2230.ism/manifest.mpd",
    smooth: "https://streaming2.sfanytime.com/assets/titanic/trailer/2230.ism/manifest",
    hls: "https://streaming2.sfanytime.com/assets/titanic/trailer/2230.ism/manifest.m3u8",
    thumbnails: null
  },
  ratings: {
    imdb: 7.9,
    rottenTomatoes: 88,
    metacritic: 75
  },
  metaCollections: [
    "category-basedon-based-on-true-story",
    "category-plot-love",
    "category-style-romantic"
  ],
  purchases: {
    sv: {
      tvodLastDay: 26,
      tvodLastWeek: 110,
      estLastDay: 9,
      estLastWeek: 23,
      totalLastWeek: 133
    },
    no: {
      tvodLastDay: 0,
      tvodLastWeek: 4,
      estLastDay: 0,
      estLastWeek: 0,
      totalLastWeek: 4
    },
    da: {
      tvodLastDay: 11,
      tvodLastWeek: 38,
      estLastDay: 2,
      estLastWeek: 9,
      totalLastWeek: 47
    },
    fi: {
      tvodLastDay: 4,
      tvodLastWeek: 14,
      estLastDay: 0,
      estLastWeek: 0,
      totalLastWeek: 14
    }
  },
  similarTitles: [
    "romeo-juliet",
    "the-notebook",
    "a-walk-to-remember",
    "the-great-gatsby-2013",
    "ps-i-love-you",
    "romeo-juliet-2013",
    "love-story",
    "endless-love",
    "poseidon",
    "the-age-of-adaline",
    "the-best-of-me",
    "pride-and-predjudice",
    "cold-mountain",
    "me-before-you",
    "an-affair-to-remember",
    "forrest-gump",
    "everything-everything",
    "autumn-in-new-york",
    "revolutionary-road",
    "the-fault-in-our-stars",
    "after-",
    "sleeping-dictionary",
    "one-day",
    "adrift-2018",
    "midnight-sun"
  ],
  sorting: {
    hotRelease: {
      sv: 0,
      no: 0,
      da: 0,
      fi: 0
    },
    purchases: {
      totalLastDay: 52,
      totalLastWeek: 198,
      lastDay: {
        sv: 35,
        no: 0,
        da: 13,
        fi: 4
      },
      lastWeek: {
        sv: 133,
        no: 4,
        da: 47,
        fi: 14
      },
      lastWeekEst: {
        sv: 23,
        no: 0,
        da: 9,
        fi: 0
      },
      lastWeekTvod: {
        sv: 110,
        no: 4,
        da: 38,
        fi: 14
      }
    }
  },
  manifest: {
    video: {
      highestQuality: "HD",
      highestResolution: {
        width: 1280,
        height: 720
      }
    },
    audio: {
      tracks: [
        {
          language: "en",
          sound: [
            {
              channels: "2.0",
              format: "AAC"
            }
          ]
        }
      ]
    },
    subtitles: [
      {
        language: "da"
      },
      {
        language: "fi"
      },
      {
        language: "no"
      },
      {
        language: "sv"
      }
    ]
  },
  onlyOnSfa: {
    sv: false,
    no: false,
    da: false,
    fi: false
  },
  checksum: {
    hash: "25fb5895149b11c515ceebbfe1a73ce0c2362476",
    lastModifiedAt: 1690184146,
    firstSeenAt: 1637657026
  },
  licenseTypeByLocale: {
    sv: "Library",
    no: "Library",
    da: "Library",
    fi: "Library"
  },
  synopsis: {
    sv: "Titanics underg\xE5ng 1912 \xE4r en av 1900-talets mest omskrivna katastrofer. F\xF6rlisningen \xE4r nu f\xF6rem\xE5l f\xF6r en av historiens dyraste filmer bel\xF6nad med 11 Oscar. Titantic imponerar b\xE5de genom den fantastiska tekniken och k\xE4rlekshistorien mellan \xF6verklasstjejen fr\xE5n f\xF6rsta klass (Winslet) och konstn\xE4ren fr\xE5n tredje klass (DiCaprio).",
    no: "Titanics undergang i 1912 er en av 1900-tallets mest omskrevne katastrofer. Forliset er n\xE5 form\xE5l for en av historiens dyreste filmer bel\xF8nnet med 11 Oscars. Titantic imponerer b\xE5de gjennom den fantastiske teknikken og kj\xE6rlighetshistorien mellom overklassepiken fra f\xF8rste klasse (Winslet) og kunstneren fra tredje klasse (DiCaprio).",
    da: "Titanics undergang i 1912 er en af 1900-tallets mest omskrevne katastrofer. Forliset er nu genstand for en af historiens dyreste film, bel\xF8nnet med 11 Oscars. Titantic imponerer b\xE5de ved den fantastiske teknik og k\xE6rlighedshistorien mellem overklassepigen fra f\xF8rste klasse (Winslet) og kunstneren fra tredje klasse (DiCaprio).",
    fi: "Titanicin uppoaminen vuonna 1912 oli yksi 1900-luvun kohutuimmista onnettomuuksista. Tapahtumasta tehtiin elokuvahistorian siihen asti kallein elokuva, joka palkittiin 11 Oscarilla. Elokuvassa kiehtovat sek\xE4 huikeat tehosteet ett\xE4 tarina luokkarajat rikkovasta rakkaudesta yl\xE4luokkaisen hienostotyt\xF6n (Winslet) ja k\xF6yh\xE4n onnenonkijan (DiCaprio) v\xE4lill\xE4."
  },
  alternativeSlugs: [
    {
      slug: "titanic-1997",
      lang: "en"
    },
    {
      slug: "titanic-1997",
      lang: "sv"
    },
    {
      slug: "titanic-1997",
      lang: "no"
    },
    {
      slug: "titanic-1997",
      lang: "fi"
    }
  ],
  mediaTags: {
    sv: [
      {
        __typename: "Tag",
        name: "PurchasableMediaDisplay",
        display: {
          __typename: "PurchasableMediaDisplay",
          lowestPrice: 49,
          lowestPriceFormatted: "49 kr"
        }
      }
    ],
    no: [
      {
        __typename: "Tag",
        name: "PurchasableMediaDisplay",
        display: {
          __typename: "PurchasableMediaDisplay",
          lowestPrice: 49,
          lowestPriceFormatted: "kr 49"
        }
      }
    ],
    fi: [
      {
        __typename: "Tag",
        name: "PurchasableMediaDisplay",
        display: {
          __typename: "PurchasableMediaDisplay",
          lowestPrice: 5,
          lowestPriceFormatted: "\u20AC 5"
        }
      }
    ],
    da: [
      {
        __typename: "Tag",
        name: "PurchasableMediaDisplay",
        display: {
          __typename: "PurchasableMediaDisplay",
          lowestPrice: 49,
          lowestPriceFormatted: "kr. 49"
        }
      }
    ]
  },
  objectID: "titanic",
  _highlightResult: {
    actors: [
      {
        name: {
          value: "Leonardo DiCaprio",
          matchLevel: "none",
          matchedWords: []
        }
      },
      {
        name: {
          value: "Kathy Bates",
          matchLevel: "none",
          matchedWords: []
        }
      },
      {
        name: {
          value: "Frances Fisher",
          matchLevel: "none",
          matchedWords: []
        }
      },
      {
        name: {
          value: "Billy Zane",
          matchLevel: "none",
          matchedWords: []
        }
      },
      {
        name: {
          value: "Kate Winslet",
          matchLevel: "none",
          matchedWords: []
        }
      },
      {
        name: {
          value: "Gloria Stuart",
          matchLevel: "none",
          matchedWords: []
        }
      }
    ],
    directors: [
      {
        name: {
          value: "James Cameron",
          matchLevel: "none",
          matchedWords: []
        }
      }
    ],
    originalTitle: {
      value: "<em>Titani</em>c",
      matchLevel: "full",
      fullyHighlighted: false,
      matchedWords: ["titani"]
    },
    title: {
      sv: {
        value: "<em>Titani</em>c",
        matchLevel: "full",
        fullyHighlighted: false,
        matchedWords: ["titani"]
      },
      no: {
        value: "<em>Titani</em>c",
        matchLevel: "full",
        fullyHighlighted: false,
        matchedWords: ["titani"]
      },
      da: {
        value: "<em>Titani</em>c",
        matchLevel: "full",
        fullyHighlighted: false,
        matchedWords: ["titani"]
      },
      fi: {
        value: "<em>Titani</em>c",
        matchLevel: "full",
        fullyHighlighted: false,
        matchedWords: ["titani"]
      }
    }
  }
};

// src/~react-testing/mocks/bookmarks/utils.ts
var createUpdateBookmarkMock = ({
  seconds,
  slug: slug3,
  watched
}) => {
  const initialBookmark = mocks_default().bookmarkList[0];
  return {
    requiresLogin: true,
    mock: {
      request: {
        query: GQL_UPDATE_BOOKMARK_default,
        variables: {
          seconds,
          slug: slug3,
          watched
        }
      },
      result: {
        data: {
          setBookmark: __spreadProps(__spreadValues({}, initialBookmark), {
            time: seconds ? seconds * 1e3 : initialBookmark.time,
            completed: watched === true,
            procentage: watched === true ? 100 : watched === false ? 0 : initialBookmark.percentage,
            percentage: watched === true ? 100 : watched === false ? 0 : initialBookmark.percentage
          })
        }
      }
    }
  };
};

// src/~react-testing/mocks/index.ts
var getMocks = () => {
  return __spreadValues({
    deviceInfo,
    localizationQuery,
    appInfo,
    bookmarkList,
    normalMovie,
    normalSeries,
    searchMovie,
    muxTrackingMovie,
    muxTrackingEpisode,
    favorites,
    entitlements,
    contentcollection: contentCollection,
    prismicPage,
    account,
    tickets,
    order
  }, auth_exports);
};
var mocks_default = getMocks;
export {
  ACCOUNT_DETAILS_FRAGMENT_default as ACCOUNT_DETAILS_FRAGMENT,
  ASK_TO_UPDATE_STORAGE_KEY,
  AccountEventAction,
  AccountEventType,
  AdyenChannel,
  AdyenEnvironment,
  ApolloProvider,
  AppContextProvider,
  AppEnvironment,
  AudioCapabilities,
  AuthProvider,
  AvatarPreset,
  AvatarSize,
  BOOKMARK_FRAGMENT_default as BOOKMARK_FRAGMENT,
  BitsPerSecond,
  Brand,
  BrandContext,
  BrandedThemeProvider,
  COVER,
  CapabilitiesTypes,
  CheckoutContext,
  CheckoutContextProvider,
  ChromecastModel,
  ClientMetrics,
  ConfigType,
  ContentCollectionAlignment,
  ContentCollectionSize,
  ContentCollectionTargetMediaAction,
  CountryOfResidence,
  CoverPreset,
  CoverSize,
  Currency,
  DISPLAYABLE_IN_COLLECTION_FRAGMENT_default as DISPLAYABLE_IN_COLLECTION_FRAGMENT,
  DebounceError,
  DeviceCapabilities,
  DeviceCapabilitiesHelper,
  DeviceContext,
  DeviceDetect,
  DeviceMenu,
  DevicePreferencesStorage,
  DeviceType,
  DisplayTagAppearance,
  ENTITLEMENT_FRAGMENT_default as ENTITLEMENT_FRAGMENT,
  ErrorCode,
  EventTrackerContext,
  EventTrackerContextProvider,
  FAVORITES_FRAGMENT_default as FAVORITES_FRAGMENT,
  FeatureToggle,
  FilterGroupId,
  GET_ENTITLEMENT,
  GQL_ACCOUNT_AUTHORIZATION_default as GQL_ACCOUNT_AUTHORIZATION,
  GQL_ACCOUNT_AUTHORIZATION_ADDITIONAL_default as GQL_ACCOUNT_AUTHORIZATION_ADDITIONAL,
  GQL_ACCOUNT_AUTHORIZATION_LOGOUT_ALL_default as GQL_ACCOUNT_AUTHORIZATION_LOGOUT_ALL,
  GQL_ACCOUNT_AUTHORIZATION_REFRESH_default as GQL_ACCOUNT_AUTHORIZATION_REFRESH,
  GQL_ACCOUNT_EVENT_SUBSCRIPTION_default as GQL_ACCOUNT_EVENT_SUBSCRIPTION,
  GQL_ACCOUNT_OAUTH_default as GQL_ACCOUNT_OAUTH,
  GQL_ADD_FAVORITE_default as GQL_ADD_FAVORITE,
  GQL_ADD_NOTIFICATION_TOKEN_default as GQL_ADD_NOTIFICATION_TOKEN,
  GQL_CONTENT_COLLECTION_default as GQL_CONTENT_COLLECTION,
  GQL_CONTENT_LIST_PAGINATE_default as GQL_CONTENT_LIST_PAGINATE,
  GQL_CREATE_ACCOUNT_default as GQL_CREATE_ACCOUNT,
  GQL_CREATE_PLAYBACK_TOKEN_default as GQL_CREATE_PLAYBACK_TOKEN,
  GQL_CREATE_REMOTE_AUTHENTICATION_default as GQL_CREATE_REMOTE_AUTHENTICATION,
  GQL_CREATE_SAVED_SEARCH_default as GQL_CREATE_SAVED_SEARCH,
  GQL_CREATE_TRANSACTION_default as GQL_CREATE_TRANSACTION,
  GQL_CREATE_VOUCHER_ORDER_default as GQL_CREATE_VOUCHER_ORDER,
  GQL_DELETE_ACCOUNT_default as GQL_DELETE_ACCOUNT,
  GQL_DELETE_PAYMENT_METHOD_default as GQL_DELETE_PAYMENT_METHOD,
  GQL_DELETE_SAVED_SEARCH_default as GQL_DELETE_SAVED_SEARCH,
  GQL_ENTITLEMENT_CREATED_SUBSCRIPTION_default as GQL_ENTITLEMENT_CREATED_SUBSCRIPTION,
  GQL_EXPORT_ACCOUNT_default as GQL_EXPORT_ACCOUNT,
  GQL_FORGOT_PASSWORD_default as GQL_FORGOT_PASSWORD,
  GQL_GET_ACCOUNT_INFORMATION_default as GQL_GET_ACCOUNT_INFORMATION,
  GQL_GET_ACCOUNT_ORDERS_default as GQL_GET_ACCOUNT_ORDERS,
  GQL_GET_APP_INFO_default as GQL_GET_APP_INFO,
  GQL_GET_BOOKMARKS_default as GQL_GET_BOOKMARKS,
  GQL_GET_CUSTOMER_SUPPORT_ARTICLE_default as GQL_GET_CUSTOMER_SUPPORT_ARTICLE,
  GQL_GET_CUSTOMER_SUPPORT_CATEGORIES_default as GQL_GET_CUSTOMER_SUPPORT_CATEGORIES,
  GQL_GET_DEVICE_INFORMATION_default as GQL_GET_DEVICE_INFORMATION,
  GQL_GET_ENTITLEMENTS_default as GQL_GET_ENTITLEMENTS,
  GQL_GET_FAVORITES_default as GQL_GET_FAVORITES,
  GQL_GET_FOOTER_default as GQL_GET_FOOTER,
  GQL_GET_LOCALIZATION_default as GQL_GET_LOCALIZATION,
  GQL_GET_LOCALIZATIONS,
  GQL_GET_MEDIA_default as GQL_GET_MEDIA,
  GQL_GET_MENU_default as GQL_GET_MENU,
  GQL_GET_META_COLLECTION_default as GQL_GET_META_COLLECTION,
  GQL_GET_META_COLLECTION_FOR_META_default as GQL_GET_META_COLLECTION_FOR_META,
  GQL_GET_NEXT_EPISODE_default as GQL_GET_NEXT_EPISODE,
  GQL_GET_PRISMIC_PAGE_default as GQL_GET_PRISMIC_PAGE,
  GQL_GET_PURCHASABLE_default as GQL_GET_PURCHASABLE,
  GQL_GET_RECOMMENDATIONS_default as GQL_GET_RECOMMENDATIONS,
  GQL_GET_REMOTE_AUTHENTICATION_default as GQL_GET_REMOTE_AUTHENTICATION,
  GQL_GET_SAVED_SEARCH_default as GQL_GET_SAVED_SEARCH,
  GQL_GET_SAVED_SEARCHES_default as GQL_GET_SAVED_SEARCHES,
  GQL_GET_SEARCH_default as GQL_GET_SEARCH,
  GQL_GET_TICKET_default as GQL_GET_TICKET,
  GQL_GET_TICKETS_default as GQL_GET_TICKETS,
  GQL_GET_TRANSACTION_default as GQL_GET_TRANSACTION,
  GQL_GET_VOUCHER_default as GQL_GET_VOUCHER,
  GQL_INIT_UPDATE_ACCOUNT_PAYMENT_METHODS_default as GQL_INIT_UPDATE_ACCOUNT_PAYMENT_METHODS,
  GQL_NEXT_ACTIONS_default as GQL_NEXT_ACTIONS,
  GQL_PLAYABLE_METADATA_default as GQL_PLAYABLE_METADATA,
  GQL_PUBLIC_FEED_default as GQL_PUBLIC_FEED,
  GQL_REMOVE_FAVORITE_default as GQL_REMOVE_FAVORITE,
  GQL_RESET_PASSWORD_default as GQL_RESET_PASSWORD,
  GQL_SEND_LOGS_default as GQL_SEND_LOGS,
  GQL_UPDATED_REMOTE_AUTHENTICATION_SUBSCRIPTION_default as GQL_UPDATED_REMOTE_AUTHENTICATION_SUBSCRIPTION,
  GQL_UPDATED_TRANSACTION_SUBSCRIPTION_default as GQL_UPDATED_TRANSACTION_SUBSCRIPTION,
  GQL_UPDATE_ACCOUNT_EMAIL_default as GQL_UPDATE_ACCOUNT_EMAIL,
  GQL_UPDATE_ACCOUNT_INFORMATION_default as GQL_UPDATE_ACCOUNT_INFORMATION,
  GQL_UPDATE_ACCOUNT_PASSWORD_default as GQL_UPDATE_ACCOUNT_PASSWORD,
  GQL_UPDATE_BOOKMARK_default as GQL_UPDATE_BOOKMARK,
  GQL_UPDATE_PAYMENT_METHODS_default as GQL_UPDATE_PAYMENT_METHODS,
  GQL_UPDATE_REMOTE_AUTHENTICATION_default as GQL_UPDATE_REMOTE_AUTHENTICATION,
  GQL_UPDATE_TRANSACTION_default as GQL_UPDATE_TRANSACTION,
  GQL_VERIFY_UNKNOWN_RECEIPT_default as GQL_VERIFY_UNKNOWN_RECEIPT,
  GigaBitsPerSecond,
  GigaBytesPerSecond,
  HookOptionsContext,
  HookOptionsProvider,
  ICONS,
  KibibitsPerSecond,
  KiloBitsPerSecond,
  KiloBytesPerSecond,
  localSchema_default as LOCAL_SCHEMA,
  LRUCache,
  ListOrderBy,
  ListOrderByArrangement,
  Locale,
  LocalizationContext,
  LocalizationContextProvider,
  LogLevel,
  mocks_default as MOCKS,
  ManifestFilter,
  MebibitsPerSecond,
  MediaPreset,
  MediaSize,
  MegaBitsPerSecond,
  MegaBytesPerSecond,
  MenuRoute,
  MockedAppContext_default as MockedAppContext,
  MockedThemeProvider_default as MockedThemeProvider,
  NavigationItemId,
  NextActionContext,
  OfflineContext,
  OfflineContextProvider,
  OfflineQueueContext,
  OfflineQueueContextProvider,
  OptOutCapabilities,
  OrderStatus,
  PAYMENT_OPTIONS,
  PROBLEM_TYPE,
  PayCapabilities,
  PaymentProcessor,
  ProductType,
  ProfilerProvider,
  PromosSize,
  PurchaseType,
  REMOTE_AUTHENTICATION_FRAGMENT_default as REMOTE_AUTHENTICATION_FRAGMENT,
  RecommendationsType,
  RemoteAuthenticationIntent,
  RemoteAuthenticationStatus,
  RemoteCheckoutContextProvider,
  RemoteCheckoutStep,
  RentalType,
  RetainingCache,
  STORAGE,
  SavedSearchType,
  ScreenCapabilities,
  SearchProvider,
  ServiceAvailabilityType,
  Severity,
  ShakaEVENT,
  ShakaErrorCodes,
  ShakaErrorSeverity,
  ShakaErrorTypes,
  ShakaLogger,
  ShakaRequestType,
  SqhProvider,
  StaticQueryHelper,
  Step,
  TRANSACTION_FRAGMENT_default as TRANSACTION_FRAGMENT,
  TRANSPARENT1X1,
  TRANSPARENT336X486,
  TagZoneCardGroup,
  TagZoneContext,
  TagZoneDescriptionGroup,
  TagZonePrimaryGroup,
  TeraBitsPerSecond,
  TeraBytesPerSecond,
  ThemeProvider_default as ThemeProvider,
  TimeUnit,
  TrackerCategory,
  VideoCapabilities,
  VideoPlaybackDrmKeySystems,
  VideoPlaybackDrmType,
  WidevineSecurityLevel,
  aliases,
  applyHitsUpdates,
  applyQuerySuggestionsUpdates,
  aspectRatios,
  assertUnreachable,
  assertUnreachableThrows,
  assetKeys,
  assetSizes,
  assetTypes,
  assets,
  backgroundColors,
  brandOverrideStorageKey,
  brandStyles,
  brands,
  broadcastSessionData,
  buildFallbackValue,
  buildTextLiteral,
  buildTimeString,
  buildTitleLiteral,
  by,
  byImportance,
  createApollo,
  createApolloCache,
  createApolloSync,
  createBookmarkId,
  createEntitlementId,
  createEventEmitter,
  createGloballyUniqueId,
  createGloballyUniqueIdResolver,
  createHighlightObject,
  createLanguagePrioritySort,
  createLocalizationId,
  createMediaId,
  createPlaybackTokenId,
  createTextDisplayer,
  createUpdateBookmarkMock,
  currentTimeInPercentage,
  darkTheme_default as darkTheme,
  defaultAppLocale,
  duplicateAndFillArray,
  exists,
  extractAuthData,
  extractErrorMessage,
  fakeTime,
  fetchSearchResults,
  fetchThumbnails,
  findAppInfo,
  fixInvalidCue,
  getActiveCount,
  getActiveRangeCount,
  getActiveTagCount,
  getAdyenErrorLiterals,
  getAlgoliaRequestOptions,
  getAssetSrc,
  getAuth,
  getCdnAsset,
  getCdnJsonKey,
  getCleanTitleKeyId,
  getCodeFromError,
  getContinueWatchingItems,
  getCssVariables,
  getDeepLinkHandler,
  getDeepLinkUrlScheme,
  getDefaultAlgoliaReqOpts,
  getDefaultFacets,
  getDisplayLanguage,
  getDisplayableAssetImage,
  getDrm,
  getEntitlement,
  getErrorCodeLiterals,
  getErrorLiterals,
  getFacetRangeStats,
  getFacetsFromAlgoliaResponse,
  getFilterGroup,
  getFilters,
  getInitialSessionData,
  getItems,
  getLocaleFromIsoCode,
  getLoginErrorLiterals,
  getMedia,
  getModelInfo,
  getMuxData,
  getProductionDomain,
  getRangeSliders,
  getSessionData,
  getSlugs,
  getStorage,
  getSupportedAppLocale,
  getSupportedMediaSourceAudioCodecs,
  getThumbnailImage,
  getTrackingPayload2 as getTrackingPayload,
  getVariables2 as getVariables,
  hasCampaignDiscount,
  hasHoursPassed,
  hasTrailer,
  hasVoucherDiscount,
  hex2rgb,
  historyMock,
  humanRuntime,
  invariant,
  isActive,
  isBought,
  isBrand,
  isDiscounted,
  isEpisode,
  isFailedStatus2 as isFailedStatus,
  isInWebview,
  isInvalidationPolicyCache,
  isMovie,
  isMyContentName,
  isPaymentInProgressStatus2 as isPaymentInProgressStatus,
  isPlayableMedia,
  isRangeFilterGroup,
  isRented,
  isSSR,
  isSeason,
  isSeries,
  isTagFilterGroup,
  isTruthy,
  isVisible,
  keysUsedForCdnUrl,
  logout,
  loopingArrayIndex,
  makeSearchUrlRangeValue,
  makeTypePolicies,
  mapFacetFilter,
  mergeByPriority,
  mergeList,
  mergeLocalizations,
  mergeResults,
  mergeTypePolicies,
  mergeUnique,
  mergeUseNext,
  mockDevice,
  mockStorage,
  myContentFromUrlState,
  normalizeDeviceInfo,
  offlineEvents,
  onApolloStatus,
  onlyUnique,
  pickId,
  readBookmark,
  readMedia,
  refreshToken,
  removeAbbreviationFromSlug,
  returnUrlAtom,
  rgbCss,
  sanitizeObject,
  saveAuth,
  searchReducer,
  searchStateToAlgoliaFacets,
  searchStateToUrlState,
  sendWebviewMessage,
  setCssVariables,
  setDarkThemeBrand,
  shallowEqualsObject,
  showHour,
  sortActiveFacets,
  subscribeToAuth,
  svgAssets,
  themeColor,
  themeMap,
  toArray,
  toDeviceType,
  toFilterGroup,
  toMediaReference,
  toMyContentState,
  toObject,
  toProductType2 as toProductType,
  toQueryParamsString,
  toQueryString,
  toSearchQueryParams,
  toggleFacetFilterValue,
  unsubscribeFromAuth,
  useAccount_default as useAccount,
  useAccountEventSubscription,
  useAccountEvents,
  useAccountExport_default as useAccountExport,
  useAccountOrder_default as useAccountOrder,
  useActiveFilters,
  useApolloCache,
  useApp_default as useApp,
  useAppInfo,
  useAskToUpdate,
  useAsset,
  useBookmark,
  useBookmarkActions_default as useBookmarkActions,
  useBookmarks_default as useBookmarks,
  useBrand,
  useBrandOverride,
  useCastData,
  useCheckout,
  useContentCollection,
  useContentListPaginate_default as useContentListPaginate,
  useContextMenu,
  useContinueWatching_default as useContinueWatching,
  useContinueWatchingSeries_default as useContinueWatchingSeries,
  useCustomerSupportArticle,
  useCustomerSupportCategories,
  useCustomerSupportTicket,
  useDebounce,
  useDebouncedCallback,
  useDeleteAccount_default as useDeleteAccount,
  useDeletePaymentMethod_default as useDeletePaymentMethod,
  useDevice,
  useDeviceInformation,
  useDevicePreferences,
  useDrm_default as useDrm,
  useEntitlement_default as useEntitlement,
  useEntitlements_default as useEntitlements,
  useFavorite_default as useFavorite,
  useFavoriteMutation_default as useFavoriteMutation,
  useFavorites_default as useFavorites,
  useFeatureToggle_default as useFeatureToggle,
  useFooter,
  useHookOptions,
  useInterval_default as useInterval,
  useIsOffline_default as useIsOffline,
  useKeyboard_default as useKeyboard,
  useL10n_default as useL10n,
  useLanguages,
  useLocalizations,
  useLogoutAll_default as useLogoutAll,
  useMedia_default as useMedia,
  useMediaSuspense,
  useMenu,
  useMetaCollection_default as useMetaCollection,
  useMetaCollectionForMedia_default as useMetaCollectionForMedia,
  useMetaCollectionListPaginate_default as useMetaCollectionListPaginate,
  useMountEffect,
  useMux,
  useMyContentFilters,
  useNextActions,
  useNextEpisode_default as useNextEpisode,
  useNotificationActions,
  useOfflineQueue_default as useOfflineQueue,
  usePersonalization,
  usePlayableMetadata,
  usePrevious,
  usePrintDiff,
  usePrismicPage_default as usePrismicPage,
  useProfiler,
  usePurchasable,
  useQrUrl,
  useQuery_default as useQuery,
  useRecommendations_default as useRecommendations,
  useRemoteAuthentication_default as useRemoteAuthentication,
  useRemoteCheckout,
  useSavedSearchTitle_default as useSavedSearchTitle,
  useSavedSearches,
  useSearch,
  useServiceAvailability,
  useSession_default as useSession,
  useStaticQueryHelper,
  useTags,
  useTheme_default as useTheme,
  useThumbnail,
  useTicket,
  useTicketBoughtReturnUrl,
  useTickets,
  useTimeout_default as useTimeout,
  useTracker_default as useTracker,
  useTransactionQuery,
  useUpdateAccount,
  useUpdateAccountPaymentMethods,
  useUpdateCssVariables,
  useUpdateEmail,
  useUpdatePassword,
  useVerifyUnknownReceipt,
  useVisibilitySensor,
  useVoucher,
  useVoucherOrder,
  useWebsocketEntitlements_default as useWebsocketEntitlements,
  waitForStatus,
  webStorage_default as webStorage
};
